// === GENERATED BY scripts/generate_template.py — DO NOT EDIT MANUALLY ===
// Template: Python ML Pipeline
// Total files: 95

import type { FileTreeNode } from '../types/wizard';

export const pythonMlDemoFileTree: FileTreeNode[] = [
    {
      name: '.claude',
      path: '.claude',
      type: 'directory',
      children: [
        {
          name: 'rules',
          path: '.claude/rules',
          type: 'directory',
          children: [
            {
              name: 'common',
              path: '.claude/rules/common',
              type: 'directory',
              children: [
                { name: 'coding-style.md', path: '.claude/rules/common/coding-style.md', type: 'file' },
                { name: 'git-workflow.md', path: '.claude/rules/common/git-workflow.md', type: 'file' },
                { name: 'security.md', path: '.claude/rules/common/security.md', type: 'file' },
                { name: 'testing.md', path: '.claude/rules/common/testing.md', type: 'file' },
              ],
            },
            {
              name: 'python',
              path: '.claude/rules/python',
              type: 'directory',
              children: [
                { name: 'coding-style.md', path: '.claude/rules/python/coding-style.md', type: 'file' },
                { name: 'testing.md', path: '.claude/rules/python/testing.md', type: 'file' },
              ],
            },
          ],
        },
        { name: 'settings.json', path: '.claude/settings.json', type: 'file' },
      ],
    },
    { name: '.editorconfig', path: '.editorconfig', type: 'file' },
    { name: '.gitattributes', path: '.gitattributes', type: 'file' },
    {
      name: '.github',
      path: '.github',
      type: 'directory',
      children: [
        { name: 'CODEOWNERS', path: '.github/CODEOWNERS', type: 'file' },
        {
          name: 'ISSUE_TEMPLATE',
          path: '.github/ISSUE_TEMPLATE',
          type: 'directory',
          children: [
            { name: 'ai_task.md', path: '.github/ISSUE_TEMPLATE/ai_task.md', type: 'file' },
            { name: 'bug_report.md', path: '.github/ISSUE_TEMPLATE/bug_report.md', type: 'file' },
            { name: 'feature_request.md', path: '.github/ISSUE_TEMPLATE/feature_request.md', type: 'file' },
          ],
        },
        { name: 'PULL_REQUEST_TEMPLATE.md', path: '.github/PULL_REQUEST_TEMPLATE.md', type: 'file' },
        {
          name: 'workflows',
          path: '.github/workflows',
          type: 'directory',
          children: [
            { name: 'ai-code-audit.yml', path: '.github/workflows/ai-code-audit.yml', type: 'file' },
            { name: 'ci.yml', path: '.github/workflows/ci.yml', type: 'file' },
            { name: 'deploy-production.yml', path: '.github/workflows/deploy-production.yml', type: 'file' },
            { name: 'deploy-staging.yml', path: '.github/workflows/deploy-staging.yml', type: 'file' },
          ],
        },
      ],
    },
    { name: '.gitignore', path: '.gitignore', type: 'file' },
    { name: '.mcp.json', path: '.mcp.json', type: 'file' },
    { name: 'CLAUDE.md', path: 'CLAUDE.md', type: 'file' },
    { name: 'README.md', path: 'README.md', type: 'file' },
    {
      name: 'docs',
      path: 'docs',
      type: 'directory',
      children: [
        { name: 'AI-USAGE-POLICY.md', path: 'docs/AI-USAGE-POLICY.md', type: 'file' },
        { name: 'ARCHITECTURE.md', path: 'docs/ARCHITECTURE.md', type: 'file' },
        { name: 'CONTRIBUTING.md', path: 'docs/CONTRIBUTING.md', type: 'file' },
        { name: 'ONBOARDING.md', path: 'docs/ONBOARDING.md', type: 'file' },
      ],
    },
    {
      name: 'git-hooks',
      path: 'git-hooks',
      type: 'directory',
      children: [
        { name: 'commit-msg', path: 'git-hooks/commit-msg', type: 'file' },
        { name: 'pre-commit', path: 'git-hooks/pre-commit', type: 'file' },
        { name: 'pre-push', path: 'git-hooks/pre-push', type: 'file' },
      ],
    },
    { name: 'install.sh', path: 'install.sh', type: 'file' },
    {
      name: 'mock-mcp-servers',
      path: 'mock-mcp-servers',
      type: 'directory',
      children: [
        { name: 'README.md', path: 'mock-mcp-servers/README.md', type: 'file' },
        { name: 'github-server.mjs', path: 'mock-mcp-servers/github-server.mjs', type: 'file' },
        { name: 'jira-server.mjs', path: 'mock-mcp-servers/jira-server.mjs', type: 'file' },
        { name: 'package.json', path: 'mock-mcp-servers/package.json', type: 'file' },
      ],
    },
    {
      name: 'playbook',
      path: 'playbook',
      type: 'directory',
      children: [
        { name: 'PLAYBOOK.md', path: 'playbook/PLAYBOOK.md', type: 'file' },
        {
          name: 'claude-overrides',
          path: 'playbook/claude-overrides',
          type: 'directory',
          children: [
            { name: '01-discovery.claude.md', path: 'playbook/claude-overrides/01-discovery.claude.md', type: 'file' },
            { name: '02-architecture.claude.md', path: 'playbook/claude-overrides/02-architecture.claude.md', type: 'file' },
            { name: '03-foundation.claude.md', path: 'playbook/claude-overrides/03-foundation.claude.md', type: 'file' },
            { name: '04-core-implementation.claude.md', path: 'playbook/claude-overrides/04-core-implementation.claude.md', type: 'file' },
            { name: '05-integration-hardening.claude.md', path: 'playbook/claude-overrides/05-integration-hardening.claude.md', type: 'file' },
            { name: '06-testing-quality.claude.md', path: 'playbook/claude-overrides/06-testing-quality.claude.md', type: 'file' },
            { name: '07-launch.claude.md', path: 'playbook/claude-overrides/07-launch.claude.md', type: 'file' },
          ],
        },
        { name: 'codeforge-phase.sh', path: 'playbook/codeforge-phase.sh', type: 'file' },
        { name: 'current-phase.json', path: 'playbook/current-phase.json', type: 'file' },
        {
          name: 'phases',
          path: 'playbook/phases',
          type: 'directory',
          children: [
            { name: '01-discovery.md', path: 'playbook/phases/01-discovery.md', type: 'file' },
            { name: '02-architecture.md', path: 'playbook/phases/02-architecture.md', type: 'file' },
            { name: '03-foundation.md', path: 'playbook/phases/03-foundation.md', type: 'file' },
            { name: '04-core-implementation.md', path: 'playbook/phases/04-core-implementation.md', type: 'file' },
            { name: '05-integration-hardening.md', path: 'playbook/phases/05-integration-hardening.md', type: 'file' },
            { name: '06-testing-quality.md', path: 'playbook/phases/06-testing-quality.md', type: 'file' },
            { name: '07-launch.md', path: 'playbook/phases/07-launch.md', type: 'file' },
          ],
        },
        {
          name: 'prompts',
          path: 'playbook/prompts',
          type: 'directory',
          children: [
            {
              name: '01',
              path: 'playbook/prompts/01',
              type: 'directory',
              children: [
                { name: 'gather-requirements.md', path: 'playbook/prompts/01/gather-requirements.md', type: 'file' },
                { name: 'nfr-checklist.md', path: 'playbook/prompts/01/nfr-checklist.md', type: 'file' },
                { name: 'user-stories.md', path: 'playbook/prompts/01/user-stories.md', type: 'file' },
              ],
            },
            {
              name: '02',
              path: 'playbook/prompts/02',
              type: 'directory',
              children: [
                { name: 'adr-generator.md', path: 'playbook/prompts/02/adr-generator.md', type: 'file' },
                { name: 'api-design.md', path: 'playbook/prompts/02/api-design.md', type: 'file' },
                { name: 'data-model-design.md', path: 'playbook/prompts/02/data-model-design.md', type: 'file' },
              ],
            },
            {
              name: '03',
              path: 'playbook/prompts/03',
              type: 'directory',
              children: [
                { name: 'ci-pipeline.md', path: 'playbook/prompts/03/ci-pipeline.md', type: 'file' },
                { name: 'iac-setup.md', path: 'playbook/prompts/03/iac-setup.md', type: 'file' },
                { name: 'project-scaffold.md', path: 'playbook/prompts/03/project-scaffold.md', type: 'file' },
              ],
            },
            {
              name: '04',
              path: 'playbook/prompts/04',
              type: 'directory',
              children: [
                { name: 'auth-implementation.md', path: 'playbook/prompts/04/auth-implementation.md', type: 'file' },
                { name: 'crud-generator.md', path: 'playbook/prompts/04/crud-generator.md', type: 'file' },
                { name: 'feature-implementation.md', path: 'playbook/prompts/04/feature-implementation.md', type: 'file' },
              ],
            },
            {
              name: '05',
              path: 'playbook/prompts/05',
              type: 'directory',
              children: [
                { name: 'integration-adapter.md', path: 'playbook/prompts/05/integration-adapter.md', type: 'file' },
                { name: 'observability-setup.md', path: 'playbook/prompts/05/observability-setup.md', type: 'file' },
                { name: 'security-hardening.md', path: 'playbook/prompts/05/security-hardening.md', type: 'file' },
              ],
            },
            {
              name: '06',
              path: 'playbook/prompts/06',
              type: 'directory',
              children: [
                { name: 'e2e-test-generator.md', path: 'playbook/prompts/06/e2e-test-generator.md', type: 'file' },
                { name: 'load-test.md', path: 'playbook/prompts/06/load-test.md', type: 'file' },
                { name: 'test-suite-generator.md', path: 'playbook/prompts/06/test-suite-generator.md', type: 'file' },
              ],
            },
            {
              name: '07',
              path: 'playbook/prompts/07',
              type: 'directory',
              children: [
                { name: 'go-live-checklist.md', path: 'playbook/prompts/07/go-live-checklist.md', type: 'file' },
                { name: 'monitoring-setup.md', path: 'playbook/prompts/07/monitoring-setup.md', type: 'file' },
                { name: 'runbook-generator.md', path: 'playbook/prompts/07/runbook-generator.md', type: 'file' },
              ],
            },
          ],
        },
      ],
    },
    {
      name: 'plugin',
      path: 'plugin',
      type: 'directory',
      children: [
        {
          name: 'codeforge-ml-pipeline',
          path: 'plugin/codeforge-ml-pipeline',
          type: 'directory',
          children: [
            {
              name: '.claude-plugin',
              path: 'plugin/codeforge-ml-pipeline/.claude-plugin',
              type: 'directory',
              children: [
                { name: 'plugin.json', path: 'plugin/codeforge-ml-pipeline/.claude-plugin/plugin.json', type: 'file' },
              ],
            },
            { name: 'README.md', path: 'plugin/codeforge-ml-pipeline/README.md', type: 'file' },
            {
              name: 'agents',
              path: 'plugin/codeforge-ml-pipeline/agents',
              type: 'directory',
              children: [
                { name: 'architect.md', path: 'plugin/codeforge-ml-pipeline/agents/architect.md', type: 'file' },
                { name: 'build-error-resolver.md', path: 'plugin/codeforge-ml-pipeline/agents/build-error-resolver.md', type: 'file' },
                { name: 'code-reviewer.md', path: 'plugin/codeforge-ml-pipeline/agents/code-reviewer.md', type: 'file' },
                { name: 'planner.md', path: 'plugin/codeforge-ml-pipeline/agents/planner.md', type: 'file' },
                { name: 'tdd-guide.md', path: 'plugin/codeforge-ml-pipeline/agents/tdd-guide.md', type: 'file' },
              ],
            },
            {
              name: 'commands',
              path: 'plugin/codeforge-ml-pipeline/commands',
              type: 'directory',
              children: [
                { name: 'build-fix.md', path: 'plugin/codeforge-ml-pipeline/commands/build-fix.md', type: 'file' },
                { name: 'code-review.md', path: 'plugin/codeforge-ml-pipeline/commands/code-review.md', type: 'file' },
                { name: 'phase.md', path: 'plugin/codeforge-ml-pipeline/commands/phase.md', type: 'file' },
                { name: 'plan.md', path: 'plugin/codeforge-ml-pipeline/commands/plan.md', type: 'file' },
                { name: 'tdd.md', path: 'plugin/codeforge-ml-pipeline/commands/tdd.md', type: 'file' },
                { name: 'verify.md', path: 'plugin/codeforge-ml-pipeline/commands/verify.md', type: 'file' },
              ],
            },
            {
              name: 'hooks',
              path: 'plugin/codeforge-ml-pipeline/hooks',
              type: 'directory',
              children: [
                { name: 'hooks.json', path: 'plugin/codeforge-ml-pipeline/hooks/hooks.json', type: 'file' },
              ],
            },
            {
              name: 'skills',
              path: 'plugin/codeforge-ml-pipeline/skills',
              type: 'directory',
              children: [
                {
                  name: 'build-fix',
                  path: 'plugin/codeforge-ml-pipeline/skills/build-fix',
                  type: 'directory',
                  children: [
                    { name: 'SKILL.md', path: 'plugin/codeforge-ml-pipeline/skills/build-fix/SKILL.md', type: 'file' },
                  ],
                },
                {
                  name: 'code-review',
                  path: 'plugin/codeforge-ml-pipeline/skills/code-review',
                  type: 'directory',
                  children: [
                    { name: 'SKILL.md', path: 'plugin/codeforge-ml-pipeline/skills/code-review/SKILL.md', type: 'file' },
                  ],
                },
                {
                  name: 'phase',
                  path: 'plugin/codeforge-ml-pipeline/skills/phase',
                  type: 'directory',
                  children: [
                    { name: 'SKILL.md', path: 'plugin/codeforge-ml-pipeline/skills/phase/SKILL.md', type: 'file' },
                  ],
                },
                {
                  name: 'plan',
                  path: 'plugin/codeforge-ml-pipeline/skills/plan',
                  type: 'directory',
                  children: [
                    { name: 'SKILL.md', path: 'plugin/codeforge-ml-pipeline/skills/plan/SKILL.md', type: 'file' },
                  ],
                },
                {
                  name: 'tdd',
                  path: 'plugin/codeforge-ml-pipeline/skills/tdd',
                  type: 'directory',
                  children: [
                    { name: 'SKILL.md', path: 'plugin/codeforge-ml-pipeline/skills/tdd/SKILL.md', type: 'file' },
                  ],
                },
                {
                  name: 'verify',
                  path: 'plugin/codeforge-ml-pipeline/skills/verify',
                  type: 'directory',
                  children: [
                    { name: 'SKILL.md', path: 'plugin/codeforge-ml-pipeline/skills/verify/SKILL.md', type: 'file' },
                  ],
                },
              ],
            },
          ],
        },
        { name: 'marketplace.json.example', path: 'plugin/marketplace.json.example', type: 'file' },
      ],
    },
    { name: 'pyproject.toml', path: 'pyproject.toml', type: 'file' },
    { name: 'ruff.toml', path: 'ruff.toml', type: 'file' },
];

export const pythonMlDemoFileContents: Record<string, string> = {
  '.claude/rules/common/coding-style.md': `# Coding Style Rules

## Naming Conventions

- **Files and modules**: \`snake_case.py\` — e.g., \`feature_engineering.py\`, \`model_registry.py\`
- **Functions and methods**: \`snake_case\` — e.g., \`compute_embeddings()\`, \`load_training_config()\`
- **Classes**: \`PascalCase\` — e.g., \`TransformerEncoder\`, \`FeaturePipeline\`, \`TrainingConfig\`
- **Constants**: \`SCREAMING_SNAKE_CASE\` — e.g., \`DEFAULT_BATCH_SIZE\`, \`MODEL_REGISTRY_URI\`, \`MAX_SEQUENCE_LENGTH\`
- **Type variables**: \`PascalCase\` with \`T\` suffix or descriptive name — e.g., \`TensorT\`, \`BatchType\`
- **Private members**: Single leading underscore — e.g., \`_validate_input()\`, \`_cached_features\`
- **Protected/internal modules**: Single leading underscore — e.g., \`_internal_utils.py\`

### ML-Specific Naming

- Model classes end with their architecture type: \`ResNetClassifier\`, \`LSTMForecaster\`, \`TransformerEncoder\`
- Dataset classes end with \`Dataset\`: \`TabularDataset\`, \`ImageAugmentedDataset\`
- Config classes end with \`Config\`: \`TrainingConfig\`, \`ModelConfig\`, \`DataConfig\`
- Metric functions start with \`compute_\` or \`calculate_\`: \`compute_f1_score()\`, \`calculate_auc()\`
- Data transformation functions start with \`transform_\` or \`preprocess_\`: \`transform_features()\`, \`preprocess_text()\`
- Training callbacks end with \`Callback\`: \`EarlyStoppingCallback\`, \`MetricsLoggingCallback\`

## Type Hints

Type hints are **required on all public functions and methods**. Use \`from __future__ import annotations\` at the top of every module for modern annotation syntax.

\`\`\`python
from __future__ import annotations

import torch
from torch import Tensor


def train_epoch(
    model: torch.nn.Module,
    dataloader: torch.utils.data.DataLoader,
    optimizer: torch.optim.Optimizer,
    device: torch.device,
) -> dict[str, float]:
    """Train for one epoch and return metrics."""
    ...
\`\`\`

- Use \`dict\`, \`list\`, \`tuple\`, \`set\` (lowercase) — not \`Dict\`, \`List\`, \`Tuple\`, \`Set\` from \`typing\`
- Use \`X | None\` instead of \`Optional[X]\`
- Use Pydantic models for complex config types, not raw dicts
- Annotate return types — including \`-> None\` when applicable
- Use \`torch.Tensor\` or \`Tensor\` consistently (prefer the import alias)

## File Structure

Every Python module follows this section order:

\`\`\`python
"""Module docstring — one-line summary, then details if needed."""

from __future__ import annotations

# 1. Standard library imports
import logging
import os
from pathlib import Path

# 2. Third-party imports
import mlflow
import torch
import torch.nn as nn
from fastapi import APIRouter
from pydantic import BaseModel

# 3. Local/project imports
from src.utils.config import load_config
from src.utils.logging import get_logger

# 4. Constants
logger = get_logger(__name__)

DEFAULT_BATCH_SIZE = 32
MODEL_CHECKPOINT_DIR = Path("models/checkpoints")

# 5. Type aliases (if needed)
BatchOutput = dict[str, Tensor]

# 6. Classes and functions (public first, then private)
\`\`\`

## Import Ordering

Imports are organized into three groups separated by blank lines, sorted alphabetically within each group. This is enforced by \`ruff\` with isort rules.

1. **Standard library**: \`import os\`, \`from pathlib import Path\`
2. **Third-party packages**: \`import torch\`, \`import mlflow\`, \`from pydantic import BaseModel\`
3. **Local project imports**: \`from src.models.base import BaseModel\`, \`from src.utils.config import TrainingConfig\`

### Import Rules

- Use absolute imports from \`src/\`: \`from src.data.loader import TabularDataset\`
- Never use wildcard imports: \`from module import *\` is forbidden
- Prefer explicit imports over module-level imports: \`from torch.nn import Linear, ReLU\` over \`import torch.nn\`
- Group PyTorch imports together: \`torch\`, \`torch.nn\`, \`torch.optim\`, \`torch.utils.data\`
- Import Pydantic models explicitly: \`from pydantic import BaseModel, Field, validator\`

## File Length

- **Maximum 300 lines per file** — if a file exceeds this, split it into focused submodules
- Model architectures: one model class per file (plus helpers)
- Training logic: separate training loop, callbacks, and schedulers
- Data pipelines: separate loading, preprocessing, and feature engineering
- API endpoints: group by resource, one router per file

## Docstrings

Use Google-style docstrings on all public classes, functions, and modules:

\`\`\`python
def evaluate_model(
    model: torch.nn.Module,
    test_loader: torch.utils.data.DataLoader,
    metrics: list[str],
) -> dict[str, float]:
    """Evaluate a trained model on the test set.

    Runs inference on the full test set and computes the requested
    metrics. Results are logged to MLflow automatically.

    Args:
        model: Trained PyTorch model in eval mode.
        test_loader: DataLoader for the test split.
        metrics: List of metric names to compute (e.g., ["accuracy", "f1", "auc"]).

    Returns:
        Dictionary mapping metric names to their computed values.

    Raises:
        ValueError: If an unsupported metric name is provided.
    """
\`\`\`

- One-line docstrings for simple private helpers are acceptable
- Document tensor shapes in docstrings: \`Input tensor of shape (batch_size, seq_len, hidden_dim)\`
- Document units for numeric parameters: \`learning_rate: Learning rate (e.g., 1e-4)\`

## Class Structure

Order members within a class consistently:

\`\`\`python
class TransformerClassifier(nn.Module):
    """Transformer-based text classifier."""

    # 1. Class-level constants
    MAX_SEQ_LENGTH = 512

    # 2. __init__
    def __init__(self, config: ModelConfig) -> None: ...

    # 3. Public methods
    def forward(self, input_ids: Tensor, attention_mask: Tensor) -> Tensor: ...
    def predict(self, input_ids: Tensor) -> Tensor: ...

    # 4. Private/helper methods
    def _init_weights(self, module: nn.Module) -> None: ...
    def _compute_attention(self, query: Tensor, key: Tensor) -> Tensor: ...
\`\`\`

## Config Validation

All configuration must use Pydantic models — never pass raw dicts through the pipeline:

\`\`\`python
from pydantic import BaseModel, Field


class TrainingConfig(BaseModel):
    """Configuration for a training run."""

    learning_rate: float = Field(1e-4, gt=0, description="Optimizer learning rate")
    batch_size: int = Field(32, gt=0, le=1024)
    max_epochs: int = Field(100, gt=0)
    early_stopping_patience: int = Field(10, gt=0)
    device: str = Field("cuda", pattern=r"^(cuda|cpu|mps)(:\\d+)?$")
\`\`\`

## Error Handling

- Raise specific exceptions, not bare \`Exception\`
- Validate inputs at function boundaries with clear error messages
- Use \`logger.exception()\` in except blocks to preserve stack traces
- Never silently swallow exceptions in training or data pipelines — a corrupted batch must be surfaced

## Logging

- Use \`src.utils.logging.get_logger(__name__)\` — never \`print()\` for operational output
- Log at appropriate levels: \`DEBUG\` for tensor shapes, \`INFO\` for epoch results, \`WARNING\` for fallback behavior, \`ERROR\` for failures
- Include structured context: \`logger.info("Epoch complete", extra={"epoch": epoch, "loss": loss})\`

## Enforcement

These rules are enforced automatically:

- **\`ruff check\`** — linting, import sorting, style violations
- **\`ruff format\`** — consistent formatting
- **\`mypy --strict\`** — type checking
- **Pre-commit hooks** — run on every commit
- **CI pipeline** — \`uv run ruff check src/ tests/\` and \`uv run mypy src/\` in GitHub Actions`,

  '.claude/rules/common/git-workflow.md': `# Git Workflow Rules

## Branching Strategy

This project uses **GitHub Flow** with a single protected \`main\` branch.

- \`main\` is always deployable — all merges must pass CI (lint, type check, tests, train smoke test)
- All work happens on short-lived feature branches created from \`main\`
- Branches are merged back to \`main\` via pull request with required review
- Delete branches after merge

## Branch Naming Convention

Format: \`type/ticket-desc\`

| Type | Purpose | Example |
|------|---------|---------|
| \`feat\` | New feature, model, pipeline stage | \`feat/ML-42-add-transformer-model\` |
| \`fix\` | Bug fix in training, serving, data pipeline | \`fix/ML-58-nan-loss-gradient-clipping\` |
| \`experiment\` | ML experiment branch (may not merge) | \`experiment/ML-71-attention-pooling\` |
| \`chore\` | Dependency updates, CI config, tooling | \`chore/ML-80-upgrade-pytorch-2.2\` |
| \`docs\` | Documentation, runbooks, experiment logs | \`docs/ML-90-model-card-v2\` |
| \`refactor\` | Code restructuring without behavior change | \`refactor/ML-95-split-training-loop\` |
| \`data\` | Data pipeline changes, feature engineering | \`data/ML-63-add-temporal-features\` |
| \`infra\` | Terraform, Docker, Kubernetes changes | \`infra/ML-77-gpu-instance-autoscaling\` |

Rules:
- Use lowercase with hyphens for the description
- Always include the GitHub Issue number when one exists
- Keep descriptions short (3-5 words max)
- Experiment branches should be prefixed with \`experiment/\` so they are clearly identifiable

## Commit Message Convention

This project uses **Conventional Commits**. Every commit message must follow this format:

\`\`\`
type: concise description of change

[optional body with context]

[optional footer with references]
\`\`\`

### Allowed Types

| Type | When to use |
|------|-------------|
| \`feat\` | New feature, model architecture, pipeline stage, API endpoint |
| \`fix\` | Bug fix in any component |
| \`experiment\` | ML experiment iteration (hyperparams, architecture tweak, data augmentation) |
| \`chore\` | Dependency updates, CI changes, tooling, DVC remote config |
| \`docs\` | Documentation, model cards, experiment logs, runbooks |
| \`refactor\` | Code restructuring without changing behavior or model outputs |
| \`test\` | Adding or updating tests |
| \`perf\` | Performance improvement (training speed, inference latency, memory) |
| \`data\` | Data pipeline, feature engineering, DVC pipeline changes |

### Commit Message Examples

\`\`\`
feat: add multi-head attention model architecture

Implements nn.Module with configurable heads and embedding dim.
Config schema added to configs/models/attention.yaml.

Refs: #42
\`\`\`

\`\`\`
experiment: sweep learning rate with cosine annealing

Tested lr in [1e-4, 3e-4, 1e-3] with cosine schedule.
Best val_loss=0.342 at lr=3e-4. MLflow run: abc123.

Refs: #71
\`\`\`

\`\`\`
fix: handle NaN loss with gradient clipping

Added max_grad_norm=1.0 to training config and clip_grad_norm_
call in training loop. Prevents divergence on noisy batches.

Refs: #58
\`\`\`

\`\`\`
data: add temporal lag features to feature pipeline

New DVC stage in dvc.yaml for lag feature computation.
Updates configs/features/temporal.yaml with window sizes.

Refs: #63
\`\`\`

### Commit Rules

- Use imperative mood: "add feature" not "added feature" or "adds feature"
- First line must be under 72 characters
- Do not end the subject line with a period
- Separate subject from body with a blank line
- Reference GitHub Issues in the footer when applicable
- For experiment commits, include key metrics or MLflow run IDs in the body
- AI-generated code must be noted: append \`[ai-assisted]\` to the commit subject when Claude generated substantial portions of the change

## Pull Request Requirements

### Before Opening a PR

1. Rebase on latest \`main\` — no merge commits in feature branches
2. All CI checks must pass locally before pushing:
   \`\`\`bash
   uv run ruff check src/ tests/
   uv run ruff format --check src/ tests/
   uv run mypy src/
   uv run pytest tests/ --cov=src --cov-fail-under=75
   \`\`\`
3. For ML pipeline changes, verify DVC pipeline reproduces:
   \`\`\`bash
   dvc repro --dry  # Check what would run
   dvc repro         # Run if needed
   \`\`\`
4. For model changes, verify a smoke training run completes:
   \`\`\`bash
   uv run python scripts/train.py --config configs/smoke_test.yaml
   \`\`\`

### PR Title Format

PR titles must follow the same conventional commit format:
\`\`\`
feat: add transformer encoder model (#42)
fix: resolve OOM in batch inference (#58)
experiment: test label smoothing on classification head (#71)
\`\`\`

### PR Description Template

Every PR must include:

- **What**: Brief description of the change
- **Why**: Link to GitHub Issue, motivation, or experiment hypothesis
- **How**: Implementation approach, key design decisions
- **Testing**: What was tested and how (unit tests, integration tests, training runs)
- **Metrics** (for experiment/model PRs): Before/after metrics, MLflow run links
- **Config changes**: Any new or modified YAML configs
- **Data changes**: Any DVC-tracked data or pipeline changes
- **Breaking changes**: Any API, config schema, or pipeline breaking changes

### Review Requirements

- **Minimum 1 approval** required before merge
- All CI pipeline stages must pass: Lint → Type Check → Unit Tests → Integration Tests → Build Docker Image → Train Smoke Test
- CODEOWNERS rules are enforced — the designated owner for the changed paths must approve

### CODEOWNERS-Sensitive Paths

These paths require review from specific owners (defined in \`.github/CODEOWNERS\`):

| Path | Reason |
|------|--------|
| \`configs/production/**\` | Production experiment configs — changes affect live models |
| \`models/**\` | DVC-tracked model artifacts — integrity and versioning |
| \`src/serving/**\` | Model serving API — affects production inference |
| \`.env*\` | Environment variables — potential secrets exposure |
| \`data/**\` | DVC-tracked data — GDPR compliance, data lineage |
| \`Dockerfile\`, \`docker-compose.yaml\` | Container changes — security and deployment |
| \`terraform/**\` | Infrastructure changes — cost and security implications |
| \`dvc.yaml\`, \`dvc.lock\` | Pipeline definition — affects reproducibility |

### Merge Strategy

- **Squash and merge** for feature branches — keeps \`main\` history clean
- PR branch is deleted automatically after merge
- Squash commit message should follow conventional commit format

## Experiment Branch Workflow

ML experiments have a special workflow:

1. Create branch: \`experiment/ML-XX-hypothesis-name\`
2. Track all runs in MLflow with the experiment name matching the branch
3. Commit iteratively with \`experiment:\` prefix, including metrics in commit body
4. When experiment concludes:
   - **Successful**: Open PR to merge winning configuration into \`main\`, update configs/ and document results in docs/experiments/
   - **Unsuccessful**: Close branch with a summary comment documenting what was tried and learned. Do not merge.
5. Experiment branches may live longer than feature branches but should not exceed 2 weeks without a status update

## DVC and Data Workflow

- Never commit raw data or model artifacts directly to Git
- Use \`dvc push\` to sync data/model artifacts to S3 remote after changes
- Commit \`dvc.lock\` changes alongside code changes that modify the pipeline
- When modifying \`dvc.yaml\`, verify the full pipeline with \`dvc repro\` before opening a PR
- Data changes that affect GDPR-regulated fields require explicit review noting compliance (anonymization, consent verification)

## CI Pipeline Integration

The GitHub Actions pipeline runs on every push and PR:

1. **Lint**: \`uv run ruff check src/ tests/\`
2. **Type Check**: \`uv run mypy src/\`
3. **Unit Tests**: \`uv run pytest tests/unit/ --cov=src --cov-fail-under=75\`
4. **Integration Tests**: \`uv run pytest tests/integration/\`
5. **Build Docker Image**: Build and push to ECR (on main only)
6. **Train Smoke Test**: Run \`scripts/train.py\` with smoke test config to verify training pipeline
7. **Deploy Staging**: Auto-deploy to staging on merge to \`main\`
8. **Deploy Production**: Manual approval required

PRs cannot be merged until steps 1-6 pass. See \`.github/workflows/\` for pipeline definitions.`,

  '.claude/rules/common/security.md': `# Security Rules

## Data Privacy & GDPR Compliance

- Never log, print, or expose PII (personally identifiable information) in training data, model outputs, or experiment tracking
- All datasets containing user data must be anonymized or pseudonymized before entering the pipeline
- Implement data consent tracking — only train on data where user consent is verified
- Support right-to-deletion requests: maintain lineage from training data to models so affected models can be retrained when data is removed
- Store data processing records (Article 30 GDPR) alongside DVC pipeline metadata
- Tag all datasets in DVC with privacy classification: \`public\`, \`internal\`, \`confidential\`, \`restricted\`
- Never commit raw user data to git — all data flows through \`data/\` tracked by DVC with S3 remote storage
- Encrypt data at rest (S3 SSE-KMS) and in transit (TLS 1.2+)

## Model Artifact Integrity (SOC 2)

- All model artifacts stored in DVC/S3 must have SHA-256 checksums verified before deployment
- Sign model artifacts with metadata: training config hash, data version (DVC commit), code version (git SHA), MLflow run ID
- Never deploy a model that cannot be traced back to its exact training data, code, and config
- Model registry in MLflow must enforce stage transitions: \`None\` → \`Staging\` → \`Production\` with required approvals
- Maintain an audit log of all model promotions, rollbacks, and A/B test assignments
- Validate model integrity on load in the FastAPI serving layer:

\`\`\`python
def load_model(model_path: Path, expected_checksum: str) -> torch.nn.Module:
    actual_checksum = compute_sha256(model_path)
    if actual_checksum != expected_checksum:
        raise ModelIntegrityError(f"Checksum mismatch for {model_path}")
\`\`\`

## Secrets & Credentials

- Never hardcode secrets, API keys, AWS credentials, or database passwords in source code
- Use environment variables or AWS Secrets Manager for all credentials
- Files matching \`.env*\` are in \`.gitignore\` — never commit them
- MLflow tracking URI, S3 credentials, and database connection strings come from environment only
- Review any change touching \`configs/production/**\` — these are sensitive paths requiring lead approval
- Rotate credentials on a quarterly schedule; document rotation in \`docs/runbooks/credential-rotation.md\`

## Sensitive Paths

Changes to these paths require explicit review from a lead engineer:

- \`configs/production/**\` — production experiment and deployment configs
- \`models/**\` — DVC-tracked model artifacts and metadata
- \`.env*\` — environment variable files (should never be committed)
- \`data/**\` — DVC-tracked datasets
- \`src/serving/**\` — model serving endpoints exposed to external traffic
- \`.github/workflows/**\` — CI/CD pipeline definitions
- \`Dockerfile\`, \`docker-compose.yml\` — container definitions
- \`terraform/**\` — infrastructure as code

## Dependency Security

- Pin all dependency versions in \`pyproject.toml\` — no unpinned or wildcard versions
- Run \`uv pip audit\` or equivalent vulnerability scanning in CI before merging
- Review new dependencies for known CVEs before adding them
- Prefer well-maintained packages with active security response teams
- PyTorch, MLflow, FastAPI, and Pydantic versions must be explicitly pinned and reviewed on upgrade
- Do not install packages from untrusted indexes — use PyPI only unless an internal index is configured

## API & Serving Security

- All FastAPI endpoints require authentication — no anonymous access to inference endpoints
- Rate-limit inference endpoints to prevent abuse and cost overruns
- Validate all input payloads with Pydantic models — reject malformed requests before they reach model inference
- Sanitize model inputs to prevent adversarial injection or data poisoning through the API
- Log all inference requests (without PII) for audit trail and anomaly detection
- Set appropriate CORS policies — do not use \`allow_origins=["*"]\` in production

## GPU & Infrastructure Security

- GPU instances (EC2 p-series, SageMaker) must run in private subnets with no direct internet access
- Use IAM roles with least-privilege policies for SageMaker training jobs and ECS tasks
- Container images pushed to ECR must pass vulnerability scanning before deployment
- Terraform state files must be stored in encrypted S3 with versioning and access logging enabled

## Logging & Audit

- Never log model inputs/outputs that may contain PII — use request IDs for correlation
- Structure all logs as JSON for ingestion into monitoring systems
- MLflow experiment logs must include: run ID, user, timestamp, data version, config hash
- Retain audit logs for SOC 2 compliance (minimum 1 year)
- Alert on anomalous patterns: sudden accuracy drops, unusual request volumes, unauthorized model registry changes

## Code Review Security Checklist

When reviewing PRs, verify:

1. No secrets or credentials in code, configs, or comments
2. No PII in logs, metrics, or experiment tracking
3. Data privacy classification respected in pipeline changes
4. Model artifacts traceable to training data and code versions
5. New dependencies scanned for vulnerabilities
6. API input validation present on all new endpoints
7. Infrastructure changes follow least-privilege principle`,

  '.claude/rules/common/testing.md': `# Testing Standards — ml-pipeline

## Test Framework & Tooling

- **Framework**: pytest with pytest-cov, pytest-asyncio, pytest-mock
- **Runner**: \`uv run pytest\` (never bare \`pytest\`)
- **Coverage threshold**: 75% minimum, enforced in CI
- **Coverage command**: \`uv run pytest --cov=src --cov-report=term-missing --cov-fail-under=75\`
- **Type checking tests**: \`uv run mypy tests/\` (tests must also pass mypy strict mode)

## Test Directory Structure

\`\`\`
tests/
  unit/
    data/                # Data loading, preprocessing, feature engineering tests
    models/              # Model architecture tests (forward pass, shapes, dtypes)
    training/            # Training loop, callback, scheduler tests
    evaluation/          # Metrics computation, comparison logic tests
    serving/             # FastAPI endpoint tests, request/response validation
    utils/               # Utility function tests
  integration/
    test_data_pipeline.py      # End-to-end DVC pipeline stage tests
    test_training_pipeline.py  # Config → train → checkpoint round-trip
    test_serving_pipeline.py   # Model load → inference → response
    test_mlflow_tracking.py    # Experiment logging and artifact retrieval
  fixtures/
    conftest.py                # Shared fixtures (sample data, model stubs, configs)
    sample_data/               # Small deterministic datasets for tests
    sample_configs/            # Valid and invalid YAML configs for testing
\`\`\`

## Naming Conventions

- Test files: \`test_<module_name>.py\`
- Test functions: \`test_<function_name>_<scenario>_<expected_outcome>\`
- Fixtures: descriptive snake_case, scoped appropriately
- Examples:
  - \`test_forward_pass_batch_of_one_returns_correct_shape\`
  - \`test_preprocess_missing_values_raises_validation_error\`
  - \`test_predict_endpoint_valid_input_returns_200\`

## Fixture Patterns

### Use conftest.py for shared fixtures

\`\`\`python
# tests/fixtures/conftest.py
import pytest
import torch
from src.utils.config import load_config

@pytest.fixture(scope="session")
def sample_config() -> dict:
    """Load a minimal valid experiment config for testing."""
    return load_config("tests/fixtures/sample_configs/test_experiment.yaml")

@pytest.fixture
def sample_batch() -> dict[str, torch.Tensor]:
    """Deterministic batch with known shapes and values."""
    torch.manual_seed(42)
    return {
        "features": torch.randn(4, 10),
        "labels": torch.randint(0, 2, (4,)),
    }

@pytest.fixture
def trained_model_path(tmp_path: Path) -> Path:
    """Create a minimal saved model checkpoint for testing."""
    # Build, save, return path — never use production model artifacts
    ...
\`\`\`

### Fixture scope rules

- \`scope="session"\`: configs, database connections, heavy model loads
- \`scope="function"\` (default): mutable state, tensors, temp files
- Always use \`tmp_path\` or \`tmp_path_factory\` for file I/O — never write to \`data/\` or \`models/\`

## ML-Specific Test Strategies

### Model Architecture Tests (unit)

Every \`nn.Module\` in \`src/models/\` must have tests verifying:

1. **Output shape**: Forward pass returns expected tensor dimensions for known input shapes
2. **Output dtype**: Verify float32 (or expected precision) output
3. **Batch size invariance**: Works with batch_size=1 and batch_size>1
4. **Determinism**: Same input + same seed → same output
5. **Device compatibility**: Runs on CPU (GPU tests are integration-level)
6. **Gradient flow**: \`loss.backward()\` does not raise; parameters have non-None gradients

\`\`\`python
def test_classifier_forward_shape(sample_batch: dict[str, torch.Tensor]) -> None:
    model = Classifier(input_dim=10, num_classes=2)
    output = model(sample_batch["features"])
    assert output.shape == (4, 2)
    assert output.dtype == torch.float32

def test_classifier_gradient_flow(sample_batch: dict[str, torch.Tensor]) -> None:
    model = Classifier(input_dim=10, num_classes=2)
    output = model(sample_batch["features"])
    loss = torch.nn.functional.cross_entropy(output, sample_batch["labels"])
    loss.backward()
    for name, param in model.named_parameters():
        assert param.grad is not None, f"No gradient for {name}"
\`\`\`

### Data Pipeline Tests (unit + integration)

1. **Schema validation**: Verify output DataFrames/tensors match expected columns, dtypes, shapes
2. **Determinism**: Same raw input → same processed output (pin random seeds)
3. **Edge cases**: Empty datasets, single-row datasets, missing values, unexpected dtypes
4. **Feature engineering**: Known input → known output (hand-computed expected values)
5. **Data leakage checks**: Verify train/test split isolation — no information from test set in training features

\`\`\`python
def test_feature_pipeline_no_data_leakage(raw_dataset: pd.DataFrame) -> None:
    train_features, test_features = build_features(raw_dataset, split_date="2024-01-01")
    # Verify no test-period rows leaked into training statistics
    assert train_features.index.max() < pd.Timestamp("2024-01-01")
\`\`\`

### Training Loop Tests (unit + integration)

1. **Overfitting test**: Model can overfit a tiny dataset (loss decreases over N steps)
2. **Checkpoint save/load**: Save checkpoint → load → same model weights (torch.allclose)
3. **Config-driven**: Training respects all config parameters (learning rate, epochs, batch size)
4. **Early stopping**: Verify training halts when validation metric plateaus
5. **MLflow logging**: Verify metrics and params are logged (mock MLflow client in unit tests)

\`\`\`python
def test_training_loop_overfits_tiny_dataset(sample_config: dict) -> None:
    """Model should drive loss near zero on a memorizable dataset."""
    config = {**sample_config, "max_epochs": 50, "dataset_size": 16}
    result = train(config)
    assert result.final_train_loss < 0.1
\`\`\`

### Evaluation & Metrics Tests (unit)

1. **Known-answer tests**: Hand-computed metrics for small known inputs
2. **Edge cases**: All-correct predictions, all-wrong predictions, single-sample
3. **Metric consistency**: Verify custom metrics match reference implementations (sklearn, torchmetrics)
4. **Threshold behavior**: Classification thresholds produce expected precision/recall trade-offs

### Serving / FastAPI Tests (unit + integration)

Use \`httpx.AsyncClient\` with pytest-asyncio for async endpoint tests:

\`\`\`python
import pytest
from httpx import ASGITransport, AsyncClient
from src.serving.app import app

@pytest.mark.asyncio
async def test_predict_endpoint_valid_input() -> None:
    async with AsyncClient(transport=ASGITransport(app=app), base_url="http://test") as client:
        response = await client.post("/predict", json={"features": [1.0] * 10})
    assert response.status_code == 200
    assert "prediction" in response.json()
    assert "model_version" in response.json()

@pytest.mark.asyncio
async def test_predict_endpoint_invalid_input_returns_422() -> None:
    async with AsyncClient(transport=ASGITransport(app=app), base_url="http://test") as client:
        response = await client.post("/predict", json={"features": "not_a_list"})
    assert response.status_code == 422
\`\`\`

Test Pydantic request/response models independently:

\`\`\`python
def test_prediction_request_rejects_wrong_feature_count() -> None:
    with pytest.raises(ValidationError):
        PredictionRequest(features=[1.0, 2.0])  # expects 10 features
\`\`\`

### Config Validation Tests (unit)

Every Pydantic config model in \`configs/\` must have tests for:

1. **Valid configs load**: Sample YAML → Pydantic model without error
2. **Invalid configs rejected**: Missing required fields, wrong types, out-of-range values
3. **Defaults applied**: Optional fields get correct defaults
4. **Immutability**: Frozen configs cannot be mutated after creation

## Test Markers

Use pytest markers to categorize tests for selective execution:

\`\`\`python
# pyproject.toml
[tool.pytest.ini_options]
markers = [
    "unit: Fast isolated tests (no external dependencies)",
    "integration: Tests requiring database, MLflow, or file system",
    "gpu: Tests requiring CUDA-capable GPU",
    "slow: Tests taking >30 seconds (training loops, large data)",
]
\`\`\`

- **CI runs**: \`uv run pytest -m "unit"\` on every PR, \`uv run pytest -m "unit or integration"\` on merge to main
- **GPU tests**: Run only on GPU-enabled runners (\`uv run pytest -m "gpu"\`)
- **Local development**: \`uv run pytest -m "not slow and not gpu"\` for fast feedback

## Mocking & Isolation Rules

- **Mock external services**: MLflow, S3, Redis, PostgreSQL — never hit real services in unit tests
- **Use \`unittest.mock.patch\`** or \`pytest-mock\` for MLflow tracking calls
- **Use \`moto\`** for AWS S3 mocking in integration tests
- **Use \`fakeredis\`** for Redis feature store tests
- **Never mock PyTorch internals** — test real tensor operations
- **Never use production data in tests** — use synthetic fixtures in \`tests/fixtures/sample_data/\`
- **GDPR**: Test data must not contain real PII. Use faker or hand-crafted synthetic data

## What NOT to Test

- Jupyter notebooks in \`notebooks/\` — these are exploration only, not production code
- Third-party library internals (PyTorch, MLflow, DVC)
- DVC remote storage operations (test pipeline logic, not S3 connectivity)
- Terraform infrastructure (tested separately via \`terraform plan\`)

## CI Integration

Tests run in this order in GitHub Actions (see \`.github/workflows/\`):

1. \`uv run ruff check src/ tests/\` — lint
2. \`uv run ruff format --check src/ tests/\` — format check
3. \`uv run mypy src/ tests/\` — type check
4. \`uv run pytest -m "unit" --cov=src --cov-fail-under=75\` — unit tests + coverage
5. \`uv run pytest -m "integration"\` — integration tests (on merge to main)
6. Training smoke test — \`uv run python scripts/train.py --config configs/test/smoke.yaml\` (verifies end-to-end)

## Test Quality Checklist

Before submitting a PR, verify:

- [ ] All new public functions in \`src/\` have corresponding unit tests
- [ ] Tests use descriptive names following \`test_<what>_<scenario>_<expected>\` pattern
- [ ] No hardcoded file paths — use \`tmp_path\` and fixtures
- [ ] Random seeds are pinned for deterministic ML tests
- [ ] No real PII or production data in test fixtures
- [ ] Async endpoints tested with \`pytest.mark.asyncio\`
- [ ] Coverage remains ≥75% (\`uv run pytest --cov=src --cov-fail-under=75\`)
- [ ] Slow tests marked with \`@pytest.mark.slow\`
- [ ] GPU-dependent tests marked with \`@pytest.mark.gpu\`
- [ ] External service calls are mocked in unit tests`,

  '.claude/rules/python/coding-style.md': `# Python Coding Style

## Formatting & Linting

All Python code is formatted and linted with **ruff**. No exceptions.

\`\`\`bash
# Check linting
uv run ruff check src/ tests/ scripts/

# Auto-fix linting issues
uv run ruff check --fix src/ tests/ scripts/

# Format code
uv run ruff format src/ tests/ scripts/

# Check formatting without modifying
uv run ruff format --check src/ tests/ scripts/
\`\`\`

Ruff replaces flake8, isort, pycodestyle, and black. Do not add those tools. The ruff configuration lives in \`pyproject.toml\` under \`[tool.ruff]\`.

Key ruff rules enforced:
- Line length: 100 characters
- Import sorting: isort-compatible (first-party = \`src\`)
- Unused imports and variables are errors
- f-string preferred over \`.format()\` and \`%\` formatting
- No bare \`except:\` — always catch specific exceptions
- No mutable default arguments

## Type Hints

Type hints are **required on all public functions, methods, and class attributes**. This is enforced by mypy in strict mode.

\`\`\`bash
uv run mypy src/ --strict
\`\`\`

### Rules

- Every public function signature must have full type annotations (parameters and return type)
- Private/internal helpers (\`_prefixed\`) should have type hints but are not strictly enforced
- Use \`from __future__ import annotations\` at the top of every module for PEP 604 style
- Use modern syntax: \`str | None\` not \`Optional[str]\`, \`list[int]\` not \`List[int]\`
- Use \`TypeAlias\` for complex types that appear more than once
- Tensor types: annotate as \`torch.Tensor\` — add shape comments where non-obvious

\`\`\`python
from __future__ import annotations

import torch

# Good
def compute_loss(
    predictions: torch.Tensor,  # shape: (batch_size, num_classes)
    targets: torch.Tensor,      # shape: (batch_size,)
    class_weights: torch.Tensor | None = None,
) -> torch.Tensor:
    """Compute weighted cross-entropy loss."""
    ...

# Bad — missing annotations
def compute_loss(predictions, targets, class_weights=None):
    ...
\`\`\`

### Common ML Type Patterns

\`\`\`python
from pathlib import Path
from typing import Any, TypeAlias

import numpy as np
import torch
from numpy.typing import NDArray
from torch.utils.data import DataLoader

# Define type aliases for repeated complex types
BatchDict: TypeAlias = dict[str, torch.Tensor]
MetricsDict: TypeAlias = dict[str, float]
FeatureArray: TypeAlias = NDArray[np.float32]
ConfigDict: TypeAlias = dict[str, Any]

def train_epoch(
    model: torch.nn.Module,
    dataloader: DataLoader[BatchDict],
    optimizer: torch.optim.Optimizer,
    device: torch.device,
) -> MetricsDict:
    ...
\`\`\`

## Pydantic Models

Use **Pydantic v2** \`BaseModel\` for all configuration, request/response schemas, and validated data structures. Do not use raw dicts for configs.

### Experiment & Training Configs

Every experiment config YAML in \`configs/\` must have a corresponding Pydantic model in \`src/utils/config.py\` or a domain-specific config module.

\`\`\`python
from pydantic import BaseModel, Field, field_validator

class DataConfig(BaseModel):
    """Configuration for data loading and preprocessing."""

    dataset_name: str
    train_split: float = Field(default=0.8, ge=0.0, le=1.0)
    batch_size: int = Field(default=32, ge=1)
    num_workers: int = Field(default=4, ge=0)
    pin_memory: bool = True
    feature_columns: list[str]
    target_column: str
    max_sequence_length: int = Field(default=512, ge=1)

    @field_validator("feature_columns")
    @classmethod
    def validate_feature_columns(cls, v: list[str]) -> list[str]:
        if not v:
            raise ValueError("feature_columns must not be empty")
        return v


class ModelConfig(BaseModel):
    """Configuration for model architecture."""

    architecture: str  # e.g., "transformer", "mlp", "cnn"
    hidden_dim: int = Field(default=256, ge=1)
    num_layers: int = Field(default=4, ge=1)
    dropout: float = Field(default=0.1, ge=0.0, lt=1.0)
    activation: str = "gelu"
    pretrained_checkpoint: str | None = None


class TrainingConfig(BaseModel):
    """Configuration for training loop."""

    learning_rate: float = Field(default=1e-4, gt=0)
    weight_decay: float = Field(default=0.01, ge=0)
    max_epochs: int = Field(default=100, ge=1)
    early_stopping_patience: int = Field(default=10, ge=1)
    gradient_clip_norm: float = Field(default=1.0, gt=0)
    scheduler: str = "cosine"
    warmup_steps: int = Field(default=0, ge=0)
    seed: int = 42


class ExperimentConfig(BaseModel):
    """Top-level experiment configuration. Loaded from YAML."""

    experiment_name: str
    run_description: str = ""
    data: DataConfig
    model: ModelConfig
    training: TrainingConfig
    tags: dict[str, str] = Field(default_factory=dict)
\`\`\`

### FastAPI Request/Response Schemas

\`\`\`python
from pydantic import BaseModel, Field

class PredictionRequest(BaseModel):
    """Schema for single prediction requests."""

    features: dict[str, float | int | str]
    model_version: str | None = None
    return_probabilities: bool = False

class PredictionResponse(BaseModel):
    """Schema for prediction responses."""

    prediction: float | int | str
    confidence: float = Field(ge=0.0, le=1.0)
    model_version: str
    latency_ms: float
    probabilities: dict[str, float] | None = None
\`\`\`

### Pydantic Rules

- Use \`Field()\` for validation constraints (\`ge\`, \`le\`, \`gt\`, \`lt\`, \`min_length\`, \`max_length\`)
- Use \`field_validator\` for custom validation logic
- Use \`model_validator\` for cross-field validation
- Set \`model_config = ConfigDict(frozen=True)\` for immutable configs
- Use \`BaseModel.model_validate()\` to load from dicts, not direct construction from untrusted input
- Never use \`model_config = ConfigDict(extra="allow")\` in production configs — fail on unknown fields

## Docstrings

Use **Google-style docstrings** on all public modules, classes, and functions.

### Module Docstring

Every \`.py\` file in \`src/\` must start with a module docstring:

\`\`\`python
"""Feature engineering pipeline for tabular data.

Transforms raw features into model-ready tensors with normalization,
encoding, and missing value imputation. Tracked via DVC pipeline.
"""
\`\`\`

### Function Docstring

\`\`\`python
def load_and_preprocess(
    data_path: Path,
    config: DataConfig,
    *,
    cache_features: bool = True,
) -> tuple[torch.Tensor, torch.Tensor]:
    """Load raw data and apply preprocessing pipeline.

    Reads data from a DVC-tracked path, applies feature engineering
    defined in the config, and returns feature/target tensor pairs.

    Args:
        data_path: Path to the raw data file (CSV or Parquet).
        config: Data configuration with feature columns and preprocessing params.
        cache_features: Whether to cache processed features in Redis.

    Returns:
        Tuple of (features, targets) tensors ready for DataLoader.

    Raises:
        FileNotFoundError: If data_path does not exist or is not pulled via DVC.
        ValueError: If required feature columns are missing from the dataset.
    """
    ...
\`\`\`

### Class Docstring

\`\`\`python
class TransformerClassifier(torch.nn.Module):
    """Multi-head attention classifier for tabular/sequence data.

    Implements a standard Transformer encoder stack with a classification
    head. Supports variable sequence lengths and optional pretrained
    weight loading from MLflow model registry.

    Attributes:
        encoder: Transformer encoder stack.
        classifier_head: Linear projection to num_classes.
        config: Frozen model configuration.
    """

    def __init__(self, config: ModelConfig, num_classes: int) -> None:
        ...
\`\`\`

### Docstring Rules

- **Required** on: all public functions, classes, and modules in \`src/\`
- **Optional** on: private methods (\`_prefixed\`), test functions, scripts
- Include \`Args\`, \`Returns\`, \`Raises\` sections when applicable
- Keep the summary line under 80 characters
- Do not restate the type hints in the docstring — they are already in the signature
- For ML functions, mention tensor shapes in \`Args\`/\`Returns\` when non-obvious
- Reference related MLflow experiment names or DVC pipeline stages where relevant

## Naming Conventions

| Element | Convention | Example |
|---|---|---|
| Files and modules | \`snake_case\` | \`feature_engineering.py\` |
| Functions and methods | \`snake_case\` | \`compute_attention_weights()\` |
| Classes | \`PascalCase\` | \`TransformerClassifier\` |
| Constants | \`SCREAMING_SNAKE_CASE\` | \`DEFAULT_LEARNING_RATE\` |
| Config fields | \`snake_case\` | \`hidden_dim\`, \`batch_size\` |
| Type aliases | \`PascalCase\` | \`MetricsDict\`, \`BatchDict\` |
| Test functions | \`test_snake_case\` | \`test_model_forward_pass()\` |
| Fixtures | \`snake_case\` | \`sample_batch\`, \`trained_model\` |

## File Structure

Maximum file length: **300 lines**. If a file exceeds this, split it.

Every Python file in \`src/\` follows this order:

1. Module docstring
2. \`from __future__ import annotations\`
3. Standard library imports
4. Third-party imports
5. Local imports
6. Constants (\`SCREAMING_SNAKE_CASE\`)
7. Type aliases
8. Classes and functions
9. No top-level executable code (use \`if __name__ == "__main__":\` in scripts only)

\`\`\`python
"""Data loading utilities for training pipeline."""

from __future__ import annotations

import logging
from pathlib import Path

import torch
from torch.utils.data import Dataset

from src.utils.config import DataConfig

logger = logging.getLogger(__name__)

DEFAULT_CACHE_TTL: int = 3600
MAX_SEQUENCE_LENGTH: int = 512

# ... classes and functions
\`\`\`

## Error Handling

- Catch specific exceptions — never bare \`except:\`
- Use custom exception classes in \`src/utils/exceptions.py\` for domain errors
- Log exceptions with \`logger.exception()\` for stack traces
- Raise \`ValueError\` for invalid configs, \`FileNotFoundError\` for missing data/artifacts
- In FastAPI endpoints, use \`HTTPException\` with appropriate status codes
- In training loops, catch \`torch.cuda.OutOfMemoryError\` explicitly and log batch size

\`\`\`python
# Good
try:
    model = load_model_from_registry(model_name, version=config.model_version)
except mlflow.exceptions.MlflowException as e:
    logger.exception("Failed to load model '%s' v%s from registry", model_name, config.model_version)
    raise ModelLoadError(f"Model not found in registry: {model_name}") from e

# Bad
try:
    model = load_model_from_registry(model_name)
except:
    pass
\`\`\`

## Logging

Use the standard library \`logging\` module. Do not use \`print()\` in \`src/\`.

\`\`\`python
import logging

logger = logging.getLogger(__name__)

logger.info("Starting training run: %s", config.experiment_name)
logger.debug("Batch shape: %s", batch["features"].shape)
logger.warning("GPU memory usage above 90%%")
logger.error("Checkpoint save failed for epoch %d", epoch)
\`\`\`

- Use \`%s\` formatting in log calls (not f-strings) for lazy evaluation
- Log at \`INFO\` level: experiment starts, epoch completions, model saves, deployment events
- Log at \`DEBUG\` level: tensor shapes, batch details, cache hits/misses
- Log at \`WARNING\` level: fallback behavior, deprecated usage, resource pressure
- Log at \`ERROR\` level: recoverable failures (retries, fallback models)

## Imports

- Absolute imports only — no relative imports (\`from .utils import ...\` is not allowed)
- Import modules, not individual names, for large packages: \`import torch\` not \`from torch import Tensor, nn, optim\`
- Exception: Pydantic and typing imports can be individual: \`from pydantic import BaseModel, Field\`
- Group imports: stdlib → third-party → local (enforced by ruff isort rules)

## ML-Specific Patterns

### Device Handling

\`\`\`python
def get_device() -> torch.device:
    """Get the best available compute device."""
    if torch.cuda.is_available():
        return torch.device("cuda")
    return torch.device("cpu")
\`\`\`

Never hardcode \`"cuda"\` — always check availability. Pass \`device\` as a parameter to functions that create or move tensors.

### Reproducibility

Every training script must set seeds:

\`\`\`python
def set_seed(seed: int) -> None:
    """Set random seeds for reproducibility across all libraries."""
    import random

    import numpy as np

    random.seed(seed)
    np.random.seed(seed)
    torch.manual_seed(seed)
    if torch.cuda.is_available():
        torch.cuda.manual_seed_all(seed)
\`\`\`

### Model Checkpointing

Save checkpoints as dicts with metadata, not bare state_dicts:

\`\`\`python
checkpoint = {
    "epoch": epoch,
    "model_state_dict": model.state_dict(),
    "optimizer_state_dict": optimizer.state_dict(),
    "config": config.model_dump(),
    "metrics": metrics,
    "mlflow_run_id": run_id,
}
torch.save(checkpoint, checkpoint_path)
\`\`\`

## Cross-References

- General coding standards: \`.claude/rules/common/coding-style.md\`
- Security and data privacy: \`.claude/rules/common/security.md\`
- ruff and mypy configuration: \`pyproject.toml\`
- Pydantic config models: \`src/utils/config.py\`
- FastAPI schemas: \`src/serving/schemas.py\`
- Custom exceptions: \`src/utils/exceptions.py\``,

  '.claude/rules/python/testing.md': `# Python Testing Standards — ML Pipeline

## pytest Configuration

All tests run via \`uv run pytest\`. Configuration lives in \`pyproject.toml\`:

\`\`\`toml
[tool.pytest.ini_options]
testpaths = ["tests"]
python_files = ["test_*.py"]
python_classes = ["Test*"]
python_functions = ["test_*"]
addopts = "--strict-markers --tb=short -q --cov=src --cov-report=term-missing --cov-fail-under=75"
asyncio_mode = "auto"
markers = [
    "slow: marks tests as slow (deselect with '-m \\"not slow\\"')",
    "gpu: requires GPU (deselect with '-m \\"not gpu\\"')",
    "integration: integration tests requiring external services",
    "smoke: lightweight smoke tests for training pipelines",
]
\`\`\`

Run commands:
- \`uv run pytest\` — full suite
- \`uv run pytest -m "not slow and not gpu"\` — fast unit tests only
- \`uv run pytest -m smoke\` — smoke tests for CI training validation
- \`uv run pytest tests/unit/\` — unit tests only
- \`uv run pytest tests/integration/\` — integration tests (requires services)
- \`uv run pytest --co\` — collect tests without running (verify discovery)

## Test Directory Structure

\`\`\`
tests/
  conftest.py                  # Shared fixtures (sample tensors, configs, tmp paths)
  unit/
    data/
      test_preprocessing.py
      test_feature_engineering.py
      test_dataset.py
    models/
      test_architectures.py
      test_layers.py
    training/
      test_trainer.py
      test_callbacks.py
      test_hyperparams.py
    evaluation/
      test_metrics.py
      test_comparison.py
    serving/
      test_api.py
      test_inference_pipeline.py
    utils/
      test_config.py
      test_logging.py
  integration/
    test_mlflow_tracking.py
    test_dvc_pipeline.py
    test_model_registry.py
    test_api_end_to_end.py
    test_redis_feature_store.py
  smoke/
    test_training_smoke.py
    test_inference_smoke.py
  fixtures/
    sample_configs/            # YAML config fixtures
    sample_data/               # Small CSV/parquet test data (NOT DVC-tracked)
\`\`\`

Mirror \`src/\` structure under \`tests/unit/\`. Every module in \`src/\` should have a corresponding test file.

## Fixtures — Core Patterns

### conftest.py Shared Fixtures

\`\`\`python
import pytest
import torch
from pathlib import Path
from unittest.mock import MagicMock

from src.utils.config import ExperimentConfig


@pytest.fixture
def sample_batch() -> dict[str, torch.Tensor]:
    """Minimal batch tensor for model forward pass tests."""
    return {
        "features": torch.randn(8, 10),
        "labels": torch.randint(0, 2, (8,)),
    }


@pytest.fixture
def sample_image_batch() -> dict[str, torch.Tensor]:
    """Batch of image tensors for vision model tests."""
    return {
        "images": torch.randn(4, 3, 224, 224),
        "labels": torch.randint(0, 10, (4,)),
    }


@pytest.fixture
def sample_config(tmp_path: Path) -> ExperimentConfig:
    """Valid experiment config for testing."""
    return ExperimentConfig(
        experiment_name="test-experiment",
        model={"type": "mlp", "hidden_dims": [64, 32]},
        training={"epochs": 2, "learning_rate": 1e-3, "batch_size": 8},
        data={"dataset": "test", "split_ratio": 0.8},
        output_dir=str(tmp_path / "outputs"),
    )


@pytest.fixture
def mock_mlflow_client() -> MagicMock:
    """Mock MLflow client — prevents real tracking calls in unit tests."""
    client = MagicMock()
    client.create_experiment.return_value = "test-exp-id"
    client.log_metric.return_value = None
    client.log_param.return_value = None
    client.log_artifact.return_value = None
    return client


@pytest.fixture
def sample_csv_data(tmp_path: Path) -> Path:
    """Write a small CSV file for data loading tests."""
    import pandas as pd

    df = pd.DataFrame({
        "feature_a": [1.0, 2.0, 3.0, 4.0, 5.0],
        "feature_b": [0.1, 0.2, 0.3, 0.4, 0.5],
        "label": [0, 1, 0, 1, 0],
    })
    path = tmp_path / "test_data.csv"
    df.to_csv(path, index=False)
    return path


@pytest.fixture
def device() -> torch.device:
    """Return available device, preferring CPU for test determinism."""
    return torch.device("cpu")
\`\`\`

### Fixture Scoping Rules

- \`function\` scope (default): most fixtures — fresh state per test
- \`session\` scope: expensive fixtures like loading a pretrained tokenizer or compiling a model
- \`module\` scope: shared database connections in integration tests
- Never use \`session\` scope for mutable state — leads to test pollution

\`\`\`python
@pytest.fixture(scope="session")
def pretrained_tokenizer():
    """Expensive to load — share across all tests in session."""
    from transformers import AutoTokenizer
    return AutoTokenizer.from_pretrained("bert-base-uncased")
\`\`\`

### tmp_path for All File I/O

Always use \`tmp_path\` (function-scoped) or \`tmp_path_factory\` (session-scoped) for file operations. Never write to the real \`data/\` or \`models/\` directories in tests.

\`\`\`python
def test_checkpoint_save(sample_config: ExperimentConfig, tmp_path: Path) -> None:
    checkpoint_path = tmp_path / "checkpoint.pt"
    # ... save and verify
    assert checkpoint_path.exists()
\`\`\`

## Parametrize — Testing Multiple Configurations

Use \`@pytest.mark.parametrize\` extensively for ML code where behavior varies across configs.

### Model Architecture Variants

\`\`\`python
@pytest.mark.parametrize("hidden_dims", [
    [64],
    [128, 64],
    [256, 128, 64],
])
def test_mlp_forward_shape(
    hidden_dims: list[int],
    sample_batch: dict[str, torch.Tensor],
) -> None:
    from src.models.mlp import MLP

    model = MLP(input_dim=10, hidden_dims=hidden_dims, output_dim=2)
    output = model(sample_batch["features"])
    assert output.shape == (8, 2)
\`\`\`

### Activation Functions and Hyperparameters

\`\`\`python
@pytest.mark.parametrize("activation", ["relu", "gelu", "silu"])
@pytest.mark.parametrize("dropout", [0.0, 0.1, 0.5])
def test_model_with_different_activations(
    activation: str,
    dropout: float,
) -> None:
    from src.models.mlp import MLP

    model = MLP(
        input_dim=10,
        hidden_dims=[32],
        output_dim=2,
        activation=activation,
        dropout=dropout,
    )
    x = torch.randn(4, 10)
    output = model(x)
    assert not torch.isnan(output).any()
\`\`\`

### Data Preprocessing Edge Cases

\`\`\`python
@pytest.mark.parametrize("input_data,expected_shape", [
    (torch.zeros(5, 10), (5, 10)),
    (torch.ones(1, 10), (1, 10)),
    (torch.randn(100, 10), (100, 10)),
])
def test_normalize_preserves_shape(
    input_data: torch.Tensor,
    expected_shape: tuple[int, ...],
) -> None:
    from src.data.preprocessing import normalize_features

    result = normalize_features(input_data)
    assert result.shape == expected_shape
\`\`\`

### Config Validation

\`\`\`python
@pytest.mark.parametrize("invalid_field,value,error_msg", [
    ("learning_rate", -0.01, "must be positive"),
    ("epochs", 0, "must be at least 1"),
    ("batch_size", 3, "must be a power of 2"),
])
def test_training_config_validation(
    invalid_field: str,
    value: object,
    error_msg: str,
) -> None:
    from pydantic import ValidationError
    from src.utils.config import TrainingConfig

    with pytest.raises(ValidationError, match=error_msg):
        TrainingConfig(**{invalid_field: value})
\`\`\`

## Mocking ML Components

### Mock External Services — Always

Never call real MLflow, S3, Redis, or PostgreSQL in unit tests. Use mocks or fakes.

\`\`\`python
from unittest.mock import patch, MagicMock


def test_training_logs_metrics(
    sample_config: ExperimentConfig,
    sample_batch: dict[str, torch.Tensor],
) -> None:
    with patch("src.training.trainer.mlflow") as mock_mlflow:
        from src.training.trainer import Trainer

        trainer = Trainer(config=sample_config)
        trainer.train_step(sample_batch)

        mock_mlflow.log_metrics.assert_called_once()
        call_args = mock_mlflow.log_metrics.call_args[0][0]
        assert "train_loss" in call_args
\`\`\`

### Mock PyTorch DataLoaders

\`\`\`python
@pytest.fixture
def mock_dataloader(sample_batch: dict[str, torch.Tensor]):
    """Yields a single batch — fast iteration for training loop tests."""
    return [sample_batch]


def test_training_loop_completes(
    mock_dataloader: list[dict[str, torch.Tensor]],
    sample_config: ExperimentConfig,
) -> None:
    from src.training.trainer import Trainer

    with patch("src.training.trainer.mlflow"):
        trainer = Trainer(config=sample_config)
        metrics = trainer.train_epoch(mock_dataloader)

    assert "epoch_loss" in metrics
    assert isinstance(metrics["epoch_loss"], float)
\`\`\`

### Mock Model for Serving Tests

\`\`\`python
@pytest.fixture
def mock_model() -> MagicMock:
    """Mock model that returns deterministic predictions."""
    model = MagicMock()
    model.eval.return_value = model
    model.return_value = torch.tensor([[0.8, 0.2]])
    return model


def test_inference_pipeline(mock_model: MagicMock) -> None:
    from src.serving.inference_pipeline import InferencePipeline

    pipeline = InferencePipeline(model=mock_model)
    result = pipeline.predict({"features": [1.0, 2.0, 3.0]})

    assert result["prediction"] == 0
    assert 0.0 <= result["confidence"] <= 1.0
\`\`\`

### Mock Redis Feature Store

\`\`\`python
@pytest.fixture
def mock_redis():
    """In-memory dict pretending to be Redis."""
    store = {}

    class FakeRedis:
        def get(self, key: str) -> bytes | None:
            return store.get(key)

        def set(self, key: str, value: bytes, ex: int | None = None) -> None:
            store[key] = value

        def delete(self, key: str) -> None:
            store.pop(key, None)

    return FakeRedis()
\`\`\`

## Testing FastAPI Endpoints

Use \`httpx.AsyncClient\` with \`app\` directly — no real server needed.

\`\`\`python
import pytest
from httpx import ASGITransport, AsyncClient

from src.serving.app import create_app


@pytest.fixture
def app(mock_model: MagicMock):
    return create_app(model=mock_model)


@pytest.fixture
async def client(app) -> AsyncClient:
    transport = ASGITransport(app=app)
    async with AsyncClient(transport=transport, base_url="http://test") as ac:
        yield ac


async def test_predict_endpoint(client: AsyncClient) -> None:
    response = await client.post("/predict", json={"features": [1.0, 2.0, 3.0]})
    assert response.status_code == 200
    body = response.json()
    assert "prediction" in body
    assert "confidence" in body
    assert "model_version" in body


async def test_predict_invalid_input(client: AsyncClient) -> None:
    response = await client.post("/predict", json={"features": "not_a_list"})
    assert response.status_code == 422


async def test_health_endpoint(client: AsyncClient) -> None:
    response = await client.get("/health")
    assert response.status_code == 200
    assert response.json()["status"] == "healthy"
\`\`\`

## Testing PyTorch Models

### Verify Forward Pass Shape and Dtype

\`\`\`python
def test_model_output_shape(sample_batch: dict[str, torch.Tensor]) -> None:
    from src.models.mlp import MLP

    model = MLP(input_dim=10, hidden_dims=[64, 32], output_dim=2)
    output = model(sample_batch["features"])

    assert output.shape == (8, 2)
    assert output.dtype == torch.float32
\`\`\`

### Verify Gradient Flow

\`\`\`python
def test_gradients_flow_to_all_parameters(
    sample_batch: dict[str, torch.Tensor],
) -> None:
    from src.models.mlp import MLP

    model = MLP(input_dim=10, hidden_dims=[64, 32], output_dim=2)
    output = model(sample_batch["features"])
    loss = output.sum()
    loss.backward()

    for name, param in model.named_parameters():
        assert param.grad is not None, f"No gradient for {name}"
        assert not torch.all(param.grad == 0), f"Zero gradient for {name}"
\`\`\`

### Verify Model is Deterministic in Eval Mode

\`\`\`python
def test_model_deterministic_in_eval(
    sample_batch: dict[str, torch.Tensor],
) -> None:
    from src.models.mlp import MLP

    model = MLP(input_dim=10, hidden_dims=[64, 32], output_dim=2, dropout=0.5)
    model.eval()

    with torch.no_grad():
        output_1 = model(sample_batch["features"])
        output_2 = model(sample_batch["features"])

    torch.testing.assert_close(output_1, output_2)
\`\`\`

### Verify Serialization Round-Trip

\`\`\`python
def test_model_save_load_roundtrip(
    sample_batch: dict[str, torch.Tensor],
    tmp_path: Path,
) -> None:
    from src.models.mlp import MLP

    model = MLP(input_dim=10, hidden_dims=[64, 32], output_dim=2)
    model.eval()

    with torch.no_grad():
        expected = model(sample_batch["features"])

    path = tmp_path / "model.pt"
    torch.save(model.state_dict(), path)

    loaded = MLP(input_dim=10, hidden_dims=[64, 32], output_dim=2)
    loaded.load_state_dict(torch.load(path, weights_only=True))
    loaded.eval()

    with torch.no_grad():
        actual = loaded(sample_batch["features"])

    torch.testing.assert_close(actual, expected)
\`\`\`

### Test Loss Decreases (Overfitting Sanity Check)

\`\`\`python
@pytest.mark.slow
def test_model_can_overfit_single_batch(
    sample_batch: dict[str, torch.Tensor],
) -> None:
    """Model should be able to memorize a single batch — sanity check."""
    from src.models.mlp import MLP

    model = MLP(input_dim=10, hidden_dims=[64, 32], output_dim=2)
    optimizer = torch.optim.Adam(model.parameters(), lr=1e-2)
    criterion = torch.nn.CrossEntropyLoss()

    initial_loss = None
    for step in range(100):
        optimizer.zero_grad()
        output = model(sample_batch["features"])
        loss = criterion(output, sample_batch["labels"])
        loss.backward()
        optimizer.step()
        if step == 0:
            initial_loss = loss.item()

    assert loss.item() < initial_loss * 0.1, "Model failed to overfit single batch"
\`\`\`

## Testing Data Pipelines

### Test Preprocessing Transforms

\`\`\`python
def test_normalize_zero_mean_unit_var() -> None:
    from src.data.preprocessing import normalize_features

    data = torch.tensor([[1.0, 100.0], [2.0, 200.0], [3.0, 300.0]])
    result = normalize_features(data)

    assert torch.allclose(result.mean(dim=0), torch.zeros(2), atol=1e-6)
    assert torch.allclose(result.std(dim=0, correction=0), torch.ones(2), atol=1e-6)


def test_preprocessing_handles_nan() -> None:
    from src.data.preprocessing import handle_missing_values

    data = torch.tensor([[1.0, float("nan")], [2.0, 3.0]])
    result = handle_missing_values(data, strategy="mean")

    assert not torch.isnan(result).any()
\`\`\`

### Test Dataset Class

\`\`\`python
def test_custom_dataset_length(sample_csv_data: Path) -> None:
    from src.data.dataset import TabularDataset

    dataset = TabularDataset(sample_csv_data, target_column="label")
    assert len(dataset) == 5


def test_custom_dataset_getitem(sample_csv_data: Path) -> None:
    from src.data.dataset import TabularDataset

    dataset = TabularDataset(sample_csv_data, target_column="label")
    features, label = dataset[0]

    assert isinstance(features, torch.Tensor)
    assert isinstance(label, torch.Tensor)
    assert features.shape == (2,)  # feature_a, feature_b
\`\`\`

## Testing Pydantic Configs

\`\`\`python
def test_valid_config_loads_from_yaml(tmp_path: Path) -> None:
    from src.utils.config import ExperimentConfig

    yaml_content = """
    experiment_name: test-run
    model:
      type: mlp
      hidden_dims: [128, 64]
    training:
      epochs: 10
      learning_rate: 0.001
      batch_size: 32
    data:
      dataset: tabular-v1
      split_ratio: 0.8
    """
    config_path = tmp_path / "config.yaml"
    config_path.write_text(yaml_content)

    config = ExperimentConfig.from_yaml(config_path)
    assert config.experiment_name == "test-run"
    assert config.model["hidden_dims"] == [128, 64]


def test_config_rejects_missing_required_fields() -> None:
    from pydantic import ValidationError
    from src.utils.config import ExperimentConfig

    with pytest.raises(ValidationError):
        ExperimentConfig(experiment_name="test")  # missing model, training, data
\`\`\`

## Test Data Management

- Store small test fixtures in \`tests/fixtures/sample_data/\` (committed to git)
- Keep test data under 1 MB total — use synthetic data generators for larger needs
- Never use real production data in tests — GDPR compliance requires anonymized or synthetic data
- Use \`pytest.importorskip("torch.cuda")\` for GPU-dependent tests
- DVC-tracked data in \`data/\` is NOT available in CI — tests must be self-contained

\`\`\`python
@pytest.fixture
def synthetic_classification_data() -> tuple[torch.Tensor, torch.Tensor]:
    """Generate synthetic binary classification data."""
    torch.manual_seed(42)
    n_samples = 200
    features = torch.randn(n_samples, 10)
    weights = torch.randn(10)
    logits = features @ weights
    labels = (logits > 0).long()
    return features, labels
\`\`\`

## Integration Test Patterns

Integration tests live in \`tests/integration/\` and require running services. They are skipped in fast CI runs.

\`\`\`python
@pytest.mark.integration
def test_mlflow_experiment_tracking() -> None:
    """Requires MLflow server running at localhost:5000."""
    import mlflow

    mlflow.set_tracking_uri("http://localhost:5000")
    mlflow.set_experiment("integration-test")

    with mlflow.start_run():
        mlflow.log_param("test_param", "value")
        mlflow.log_metric("test_metric", 0.95)

    runs = mlflow.search_runs(experiment_names=["integration-test"])
    assert len(runs) > 0
\`\`\`

## Smoke Tests for Training Pipelines

Smoke tests verify the full training pipeline runs without errors on minimal data. Used in CI after Docker image build.

\`\`\`python
@pytest.mark.smoke
def test_training_pipeline_smoke(tmp_path: Path) -> None:
    """Full pipeline with 1 epoch, tiny data — verifies nothing crashes."""
    from src.training.trainer import Trainer
    from src.utils.config import ExperimentConfig

    config = ExperimentConfig(
        experiment_name="smoke-test",
        model={"type": "mlp", "hidden_dims": [16]},
        training={"epochs": 1, "learning_rate": 1e-3, "batch_size": 4},
        data={"dataset": "synthetic", "n_samples": 20, "split_ratio": 0.8},
        output_dir=str(tmp_path),
    )

    with patch("src.training.trainer.mlflow"):
        trainer = Trainer(config=config)
        metrics = trainer.run()

    assert "final_loss" in metrics
    assert (tmp_path / "checkpoint_epoch_1.pt").exists()
\`\`\`

## Assertions for ML Code

Use \`torch.testing.assert_close\` instead of manual tolerance checks:

\`\`\`python
# Good
torch.testing.assert_close(actual, expected, atol=1e-5, rtol=1e-5)

# Avoid
assert abs(actual - expected) < 1e-5
\`\`\`

For probability outputs:

\`\`\`python
def assert_valid_probabilities(probs: torch.Tensor) -> None:
    """Verify tensor represents valid probability distribution."""
    assert (probs >= 0).all(), "Negative probabilities"
    assert (probs <= 1).all(), "Probabilities > 1"
    torch.testing.assert_close(
        probs.sum(dim=-1),
        torch.ones(probs.shape[0]),
        atol=1e-5,
        rtol=1e-5,
    )
\`\`\`

## Coverage and CI

- Minimum coverage: 75% (enforced by \`--cov-fail-under=75\`)
- Coverage measured on \`src/\` only — not \`tests/\`, \`notebooks/\`, or \`scripts/\`
- Exclude from coverage: \`# pragma: no cover\` for CLI entry points and \`if __name__ == "__main__"\` blocks
- CI runs \`uv run pytest -m "not slow and not gpu and not integration"\` on every PR
- Integration and smoke tests run in the dedicated CI stage after Docker build
- See \`.claude/rules/common/testing.md\` for general testing philosophy`,

  '.claude/settings.json': `{
  "permissions": {
    "allow": [
      "Bash(uv run pytest*)",
      "Bash(uv run ruff check*)",
      "Bash(uv run ruff format*)",
      "Bash(uv run mypy src/*)",
      "Bash(uv run mypy tests/*)",
      "Bash(uv run python -m pytest*)",
      "Bash(uv run python -c*)",
      "Bash(uv pip list*)",
      "Bash(uv pip show*)",
      "Bash(uv sync*)",
      "Bash(uv lock*)",
      "Bash(dvc status*)",
      "Bash(dvc dag*)",
      "Bash(dvc params diff*)",
      "Bash(dvc metrics show*)",
      "Bash(dvc metrics diff*)",
      "Bash(dvc plots show*)",
      "Bash(dvc plots diff*)",
      "Bash(mlflow experiments search-experiments*)",
      "Bash(mlflow runs list*)",
      "Bash(mlflow models list*)",
      "Bash(cat *)",
      "Bash(head *)",
      "Bash(tail *)",
      "Bash(wc *)",
      "Bash(find *)",
      "Bash(grep *)",
      "Bash(ls *)",
      "Bash(tree *)",
      "Bash(pwd)",
      "Bash(git status*)",
      "Bash(git log*)",
      "Bash(git diff*)",
      "Bash(git branch*)",
      "Bash(git show*)",
      "Bash(git rev-parse*)",
      "Bash(python -c 'import torch; print(torch.cuda.is_available())')",
      "Bash(python -c 'import torch; print(torch.__version__)')",
      "Read(*)",
      "Write(src/**)",
      "Write(tests/**)",
      "Write(configs/**)",
      "Write(scripts/**)",
      "Write(docs/**)",
      "Write(notebooks/**)",
      "Write(.github/**)",
      "Write(pyproject.toml)",
      "Write(dvc.yaml)",
      "Write(dvc.lock)",
      "Write(params.yaml)",
      "Write(.dvcignore)",
      "Write(Dockerfile*)",
      "Write(docker-compose*.yml)",
      "Write(.claude/**)",
      "Write(plugin/**)",
      "Write(playbook/**)",
      "Write(README.md)",
      "Write(CLAUDE.md)",
      "Write(CODEOWNERS)",
      "Write(.gitignore)",
      "Write(.ruff.toml)",
      "Write(mypy.ini)"
    ],
    "deny": [
      "Bash(rm -rf *)",
      "Bash(rm -rf /)",
      "Bash(uv run python src/training/train*)",
      "Bash(dvc repro*)",
      "Bash(dvc push*)",
      "Bash(dvc pull*)",
      "Bash(mlflow models serve*)",
      "Bash(mlflow deployments*)",
      "Bash(docker push*)",
      "Bash(docker run*)",
      "Bash(kubectl*)",
      "Bash(terraform apply*)",
      "Bash(terraform destroy*)",
      "Bash(aws *)",
      "Bash(curl *)",
      "Bash(wget *)",
      "Bash(pip install*)",
      "Bash(sudo *)",
      "Bash(chmod 777*)",
      "Bash(export AWS_*)",
      "Bash(export MLFLOW_*)",
      "Bash(*> /dev/null*)",
      "Write(.env*)",
      "Write(configs/production/**)",
      "Write(models/**)",
      "Write(data/**)"
    ]
  },
  "env": {
    "PYTHONPATH": "src",
    "MLFLOW_TRACKING_URI": "http://localhost:5000",
    "DVC_NO_ANALYTICS": "1",
    "PYTHONDONTWRITEBYTECODE": "1",
    "UV_LINK_MODE": "copy"
  },
  "preferences": {
    "codeStyle": "Follow .claude/rules/python/coding-style.md — ruff formatting, strict mypy types, Pydantic configs",
    "testFramework": "pytest with pytest-cov and pytest-asyncio. Tests in tests/ mirroring src/ structure",
    "commitStyle": "Conventional commits: feat:, fix:, chore:, docs:, experiment:, refactor:, test:",
    "branchNaming": "type/ticket-desc (e.g., feat/ML-42-add-transformer-model)",
    "maxFileLength": 300,
    "mlWorkflow": "All experiments tracked in MLflow. Configs in YAML validated by Pydantic. DVC for data/model versioning. Notebooks for exploration only.",
    "securityPolicy": "SOC 2 and GDPR compliance. Never log PII. Never commit secrets. Validate all model inputs. Sign model artifacts.",
    "aiCodeMarking": "Add '# AI-generated' comment to AI-authored functions and modules",
    "sensitiveFiles": "configs/production/**, models/**, .env*, data/** — require explicit human review"
  }
}`,

  '.editorconfig': `root = true

[*]
charset = utf-8
end_of_line = lf
insert_final_newline = true
trim_trailing_whitespace = true

[*.py]
indent_style = space
indent_size = 4
max_line_length = 120

[*.pyi]
indent_style = space
indent_size = 4
max_line_length = 120

[*.{yml,yaml}]
indent_style = space
indent_size = 2

[*.{json,jsonc}]
indent_style = space
indent_size = 2

[*.toml]
indent_style = space
indent_size = 4

[*.md]
indent_style = space
indent_size = 2
trim_trailing_whitespace = false

[*.{html,css,js}]
indent_style = space
indent_size = 2

[Dockerfile*]
indent_style = space
indent_size = 4

[*.tf]
indent_style = space
indent_size = 2

[*.{sh,bash}]
indent_style = space
indent_size = 2

[Makefile]
indent_style = tab

[*.ipynb]
indent_style = space
indent_size = 1

[{dvc.yaml,dvc.lock,.dvc}]
indent_style = space
indent_size = 2

[{pyproject.toml,setup.cfg}]
indent_style = space
indent_size = 4`,

  '.gitattributes': `# Auto detect text files and ensure LF line endings
* text=auto eol=lf

# Python source files
*.py text diff=python eol=lf
*.pyx text diff=python eol=lf
*.pxd text diff=python eol=lf
*.pyi text diff=python eol=lf

# Configuration files
*.yml text diff eol=lf
*.yaml text diff eol=lf
*.toml text diff eol=lf
*.cfg text diff eol=lf
*.ini text diff eol=lf
*.conf text diff eol=lf

# Markdown and documentation
*.md text diff=markdown eol=lf
*.rst text eol=lf
*.txt text eol=lf

# Web and API (FastAPI templates, OpenAPI specs)
*.html text diff=html eol=lf
*.css text diff=css eol=lf
*.js text eol=lf
*.json text eol=lf

# Shell scripts
*.sh text eol=lf
*.bash text eol=lf

# Docker and infrastructure
Dockerfile text eol=lf
docker-compose*.yml text diff eol=lf
*.tf text eol=lf
*.tfvars text eol=lf

# CI/CD
*.yml text diff eol=lf linguist-detectable

# Jupyter notebooks — custom diff, treat as generated in stats
*.ipynb text diff=jupyter eol=lf linguist-generated

# DVC files
*.dvc text diff eol=lf
dvc.yaml text diff eol=lf
dvc.lock text diff eol=lf linguist-generated

# MLflow artifacts and experiment metadata
MLproject text eol=lf

# Environment and secrets (should not be committed, but enforce LF if present)
.env text eol=lf
.env.* text eol=lf

# Requirements and lock files
requirements*.txt text eol=lf
uv.lock text eol=lf linguist-generated
pyproject.toml text diff eol=lf

# Binary model artifacts — do not diff, treat as binary (DVC-tracked)
*.pt binary
*.pth binary
*.onnx binary
*.safetensors binary
*.pkl binary
*.pickle binary
*.joblib binary
*.h5 binary
*.hdf5 binary

# Binary data files (DVC-tracked)
*.parquet binary
*.feather binary
*.arrow binary
*.npy binary
*.npz binary
*.csv.gz binary
*.csv.zst binary
*.tar.gz binary
*.zip binary

# Images (model evaluation plots, architecture diagrams)
*.png binary
*.jpg binary
*.jpeg binary
*.gif binary
*.svg text eol=lf
*.ico binary

# Compiled Python
*.pyc binary
*.pyo binary
*.so binary
*.egg binary
*.whl binary

# Font files (if serving docs)
*.woff binary
*.woff2 binary
*.ttf binary
*.eot binary

# Git and GitHub
.gitattributes text eol=lf
.gitignore text eol=lf
.gitmodules text eol=lf
CODEOWNERS text eol=lf

# Claude configuration
.claude/**/*.md text diff=markdown eol=lf
.claude/**/*.json text diff eol=lf
CLAUDE.md text diff=markdown eol=lf`,

  '.github/CODEOWNERS': `# CODEOWNERS — ml-pipeline
# https://docs.github.com/en/repositories/managing-your-repositorys-settings-and-features/customizing-your-repository/about-code-owners
#
# Each line is a file pattern followed by one or more owners.
# Order matters — later rules take precedence.

# ──────────────────────────────────────────────
# Default: all ML engineers review everything
# ──────────────────────────────────────────────
*                                   @ml-pipeline/ml-engineers

# ──────────────────────────────────────────────
# Model architectures — ML leads must approve
# ──────────────────────────────────────────────
src/models/**                       @ml-pipeline/ml-leads
models/**                           @ml-pipeline/ml-leads

# ──────────────────────────────────────────────
# Training pipeline — ML leads must approve
# ──────────────────────────────────────────────
src/training/**                     @ml-pipeline/ml-leads

# ──────────────────────────────────────────────
# Production configs — ML leads + infra owner
# ──────────────────────────────────────────────
configs/production/**               @ml-pipeline/ml-leads @ml-pipeline/infra

# ──────────────────────────────────────────────
# Serving / API — ML leads + API owner
# ──────────────────────────────────────────────
src/serving/**                      @ml-pipeline/ml-leads @ml-pipeline/api-owners

# ──────────────────────────────────────────────
# Data pipelines and feature engineering
# ──────────────────────────────────────────────
src/data/**                         @ml-pipeline/data-scientists @ml-pipeline/ml-leads
data/**                             @ml-pipeline/data-scientists @ml-pipeline/ml-leads
dvc.yaml                            @ml-pipeline/ml-leads
dvc.lock                            @ml-pipeline/ml-leads

# ──────────────────────────────────────────────
# Evaluation — metrics, comparison, dashboards
# ──────────────────────────────────────────────
src/evaluation/**                   @ml-pipeline/ml-leads @ml-pipeline/data-scientists

# ──────────────────────────────────────────────
# Infrastructure and CI/CD
# ──────────────────────────────────────────────
.github/**                          @ml-pipeline/infra @ml-pipeline/ml-leads
Dockerfile                          @ml-pipeline/infra
docker-compose*.yml                 @ml-pipeline/infra
terraform/**                        @ml-pipeline/infra
k8s/**                              @ml-pipeline/infra

# ──────────────────────────────────────────────
# Sensitive files — security and compliance
# (SOC 2: changes to secrets/env require lead review)
# ──────────────────────────────────────────────
.env*                               @ml-pipeline/ml-leads @ml-pipeline/infra
configs/production/**               @ml-pipeline/ml-leads @ml-pipeline/infra

# ──────────────────────────────────────────────
# Project configuration and dependencies
# ──────────────────────────────────────────────
pyproject.toml                      @ml-pipeline/ml-leads
uv.lock                             @ml-pipeline/ml-leads
ruff.toml                           @ml-pipeline/ml-leads

# ──────────────────────────────────────────────
# Claude / AI tooling configuration
# ──────────────────────────────────────────────
CLAUDE.md                           @ml-pipeline/ml-leads
.claude/**                          @ml-pipeline/ml-leads`,

  '.github/ISSUE_TEMPLATE/ai_task.md': `---
name: AI Task (Claude Code)
about: Structured task for Claude Code to pick up and execute ML pipeline work
title: "[AI] "
labels: ai-task, claude-code
assignees: ''
---

## Task Type

<!-- Select one -->
- [ ] Feature — New model, pipeline stage, API endpoint
- [ ] Experiment — Hyperparameter sweep, architecture comparison, ablation study
- [ ] Data — Data pipeline, feature engineering, preprocessing
- [ ] Fix — Bug fix in training, serving, or data pipeline
- [ ] Refactor — Code quality, performance optimization, tech debt
- [ ] Infra — Docker, CI/CD, Terraform, deployment
- [ ] Docs — Documentation, runbooks, experiment logs

## Priority

<!-- Select one -->
- [ ] P0 — Blocking production or training pipeline
- [ ] P1 — Required for current sprint
- [ ] P2 — Important but not urgent
- [ ] P3 — Nice to have

## Objective

<!-- One sentence describing what this task accomplishes -->


## Context

<!-- Background information Claude Code needs to understand the task -->
<!-- Include links to related experiments, MLflow runs, DVC pipeline stages, or prior PRs -->

**Related MLflow Experiment**: <!-- e.g., experiment_id=12, run_id=abc123 -->
**Related DVC Pipeline Stage**: <!-- e.g., train, evaluate, featurize -->
**Related Config**: <!-- e.g., configs/experiments/transformer_v2.yaml -->
**Depends On**: <!-- Link to blocking issues or PRs -->

## Requirements

### Functional Requirements

<!-- Numbered list of what the code must do -->
1.
2.
3.

### Technical Constraints

<!-- Non-negotiable technical boundaries -->
- [ ] Must use existing Pydantic config schema in \`configs/\`
- [ ] Must track all runs in MLflow with reproducible parameters
- [ ] Must work with DVC pipeline (\`dvc repro\` succeeds)
- [ ] Must include type hints on all public functions
- [ ] Must not exceed 300 lines per file
- [ ] Other: <!-- specify -->

### Data & Privacy Constraints

<!-- GDPR / SOC 2 requirements if applicable -->
- [ ] No PII in logs, metrics, or MLflow artifacts
- [ ] Data must be loaded via DVC (not hardcoded paths)
- [ ] Anonymization required for any user-facing data
- [ ] Not applicable

## Affected Files & Directories

<!-- List the files Claude Code should create or modify -->
<!-- Mark sensitive paths that require careful review -->

### Create
- [ ] \`src/...\`
- [ ] \`configs/...\`
- [ ] \`tests/...\`

### Modify
- [ ] \`src/...\`
- [ ] \`dvc.yaml\` (if adding/changing pipeline stages)
- [ ] \`dvc.lock\` (will update via \`dvc repro\`)

### Sensitive Paths (require lead review)
<!-- These paths trigger CODEOWNERS review -->
- [ ] \`configs/production/**\`
- [ ] \`models/**\`
- [ ] \`.env*\`
- [ ] \`data/**\`

## Experiment Specification

<!-- Fill this section for experiment-type tasks -->

**Hypothesis**: <!-- What do you expect to observe? -->

**Baseline**: <!-- MLflow run ID or experiment name for comparison -->

**Metrics to Track**:
- Primary: <!-- e.g., val_loss, f1_score, accuracy -->
- Secondary: <!-- e.g., inference_latency_ms, model_size_mb, training_time_s -->

**Config Overrides**:
\`\`\`yaml
# Paste YAML config or overrides for this experiment
# model:
#   architecture: transformer
#   hidden_dim: 256
#   num_layers: 4
# training:
#   learning_rate: 0.001
#   batch_size: 64
#   epochs: 50
\`\`\`

**GPU Requirements**: <!-- e.g., 1x V100, 4x A10G, CPU-only -->

## Acceptance Criteria

<!-- Checklist that must pass before this task is considered done -->
- [ ] All new/modified code passes \`uv run ruff check src/ tests/\`
- [ ] All new/modified code passes \`uv run ruff format --check src/ tests/\`
- [ ] Type checking passes: \`uv run mypy src/\`
- [ ] Unit tests pass: \`uv run pytest tests/unit/ -v\`
- [ ] Integration tests pass (if applicable): \`uv run pytest tests/integration/ -v\`
- [ ] Test coverage ≥ 75% on changed files
- [ ] DVC pipeline reproduces cleanly: \`dvc repro\`
- [ ] MLflow run logged with all parameters, metrics, and artifacts
- [ ] No secrets, credentials, or PII in committed code
- [ ] Commit messages follow conventional format (\`feat:\`, \`fix:\`, \`experiment:\`, etc.)
- [ ] PR description references this issue
- [ ] AI-generated code flagged with \`# AI-generated\` comment on non-trivial blocks

## Implementation Hints

<!-- Optional guidance for Claude Code on approach, patterns, or pitfalls -->
<!-- Reference existing code patterns, similar implementations, or architectural decisions -->

**Suggested Approach**:
<!--
1. Start by reading the relevant config schema in configs/
2. Look at similar implementations in src/models/ or src/training/
3. Write tests first (TDD approach preferred)
4. Implement the feature
5. Run the full validation suite
-->

**Patterns to Follow**:
<!-- e.g., "Follow the same pattern as src/models/baseline.py" -->
<!-- e.g., "Use the DataLoader pattern from src/data/loaders.py" -->

**Pitfalls to Avoid**:
<!-- e.g., "Don't load full dataset into memory — use streaming" -->
<!-- e.g., "Redis feature cache TTL must be set for GDPR compliance" -->

## Branch & PR

**Branch Name**: \`feat/ML-XXX-short-description\`
**Target Branch**: \`main\`
**Reviewers**: <!-- @username or team -->

## Validation Commands

\`\`\`bash
# Run these commands to validate the implementation
uv run ruff check src/ tests/
uv run ruff format --check src/ tests/
uv run mypy src/
uv run pytest tests/unit/ -v --cov=src --cov-fail-under=75
uv run pytest tests/integration/ -v  # if applicable
dvc repro                              # if pipeline stages changed
mlflow ui                              # verify experiment tracking at http://localhost:5000
\`\`\`

## Additional Notes

<!-- Anything else Claude Code or reviewers should know -->`,

  '.github/ISSUE_TEMPLATE/bug_report.md': `---
name: Bug Report
about: Report a bug in the ML pipeline, model serving, training, or data processing
title: "[BUG] "
labels: bug
assignees: ''
---

## Bug Description

A clear and concise description of the bug.

## Environment

- **Branch/Commit**: <!-- e.g., main @ abc1234 -->
- **Python Version**: <!-- e.g., 3.11.8 -->
- **PyTorch Version**: <!-- e.g., 2.2.0 -->
- **CUDA Version**: <!-- e.g., 12.1, or N/A for CPU -->
- **Infrastructure**: <!-- e.g., local, AWS EC2 g5.xlarge, SageMaker, ECS -->
- **OS**: <!-- e.g., Ubuntu 22.04, macOS 14.3 -->
- **Docker Image Tag**: <!-- if applicable -->

## ML Context

### Model Information
- **Model Architecture**: <!-- e.g., TransformerClassifier, ResNetFeatureExtractor -->
- **Model Version / MLflow Run ID**: <!-- e.g., runs:/abc123def456 or models:/my-model/3 -->
- **Model Registry Stage**: <!-- None / Staging / Production -->
- **Checkpoint Path**: <!-- e.g., models/checkpoints/epoch_15.pt -->

### Experiment Configuration
- **Experiment Config File**: <!-- e.g., configs/experiment_v12.yaml -->
- **MLflow Experiment Name**: <!-- e.g., transformer-classification-v2 -->
- **Key Hyperparameters**: <!-- list any relevant params: lr, batch_size, epochs, etc. -->

\`\`\`yaml
# Paste relevant config snippet here (redact any secrets)
\`\`\`

### Data Information
- **Dataset**: <!-- e.g., customer_transactions_v3 -->
- **DVC Version/Hash**: <!-- output of \`dvc version\` and relevant .dvc file hash -->
- **Data Split**: <!-- train / validation / test / inference -->
- **Data Size**: <!-- e.g., 1.2M rows, 50GB -->
- **Feature Set**: <!-- e.g., feature_store_v2, engineered_features_20240115 -->
- **Preprocessing Pipeline**: <!-- e.g., dvc repro stage name or script -->

## Steps to Reproduce

1. <!-- Step 1 -->
2. <!-- Step 2 -->
3. <!-- Step 3 -->

\`\`\`bash
# Commands to reproduce (e.g., uv run python scripts/train.py --config configs/...)
\`\`\`

## Expected Behavior

What you expected to happen.

## Actual Behavior

What actually happened.

## Error Output

\`\`\`
# Paste full traceback or error log here
\`\`\`

## Pipeline Stage

Where in the pipeline does this bug occur?

- [ ] Data ingestion / download
- [ ] Data preprocessing / feature engineering
- [ ] DVC pipeline (\`dvc repro\`)
- [ ] Model training
- [ ] Hyperparameter tuning
- [ ] Model evaluation / metrics
- [ ] MLflow tracking / registry
- [ ] Model serving (FastAPI)
- [ ] Batch inference
- [ ] Docker build / deployment
- [ ] CI/CD pipeline
- [ ] Other: <!-- specify -->

## Impact

- **Severity**: <!-- Critical / High / Medium / Low -->
- **Affects Production Model**: <!-- Yes / No -->
- **Data Integrity Concern**: <!-- Yes / No — if yes, note GDPR implications -->
- **Blocks Training Pipeline**: <!-- Yes / No -->
- **Metrics Affected**: <!-- e.g., accuracy dropped from 0.92 to 0.71, latency spike to 500ms -->

## Debugging Already Attempted

- [ ] Checked MLflow UI for run comparison
- [ ] Verified data integrity with \`dvc status\` / \`dvc diff\`
- [ ] Reproduced on clean environment (\`uv sync && dvc pull\`)
- [ ] Checked GPU memory usage (\`nvidia-smi\`)
- [ ] Reviewed recent config changes
- [ ] Ran \`uv run ruff check src/\` and \`uv run mypy src/\`
- [ ] Checked model artifact integrity (checksums match)
- [ ] Reviewed FastAPI logs / Prometheus metrics

## Relevant Logs and Artifacts

<!-- Attach or link to: -->
<!-- - MLflow run URL -->
<!-- - Training logs -->
<!-- - Grafana dashboard screenshot -->
<!-- - DVC pipeline DAG (\`dvc dag\`) output -->
<!-- - GPU utilization logs -->

## Possible Root Cause

<!-- Optional: your hypothesis on what's causing this -->

## Suggested Fix

<!-- Optional: if you have an idea for the fix -->

## Security and Compliance Notes

<!-- Flag if this bug involves: -->
<!-- - Exposure of PII or training data (GDPR) -->
<!-- - Model artifact tampering concerns (SOC 2) -->
<!-- - Access control issues -->
<!-- - Data leakage between train/test splits -->`,

  '.github/ISSUE_TEMPLATE/feature_request.md': `---
name: Feature Request
about: Propose a new model, pipeline stage, feature engineering step, or infrastructure improvement
title: "[FEATURE] "
labels: enhancement
assignees: ''
---

## Feature Type

<!-- Select the category that best fits this request -->

- [ ] New model architecture
- [ ] New pipeline stage (data, training, evaluation, serving)
- [ ] Feature engineering / data transformation
- [ ] Experiment tracking / MLflow integration
- [ ] Model serving / API endpoint
- [ ] Infrastructure / cloud (AWS, Docker, Kubernetes)
- [ ] Hyperparameter tuning strategy
- [ ] Monitoring / observability
- [ ] Other

## Problem Statement

<!-- Describe the problem this feature would solve. Include context about current limitations. -->

## Proposed Solution

<!-- Describe your proposed approach. Be specific about implementation details. -->

### Model / Pipeline Details

<!-- Fill in whichever sections are relevant -->

**Model Architecture** (if applicable):
- Base framework: <!-- e.g., PyTorch nn.Module, Transformer, CNN -->
- Input shape / features:
- Output shape / task type: <!-- e.g., classification, regression, ranking -->
- Estimated parameter count:

**Data Requirements** (if applicable):
- Data source:
- Expected volume:
- Feature engineering steps:
- DVC pipeline stages needed:

**Training Configuration** (if applicable):
- Optimizer / scheduler:
- Loss function:
- Estimated training time / GPU requirements:
- Hyperparameters to tune:

**Serving Requirements** (if applicable):
- Latency target (p99):
- Throughput (requests/sec):
- Batch inference needed: yes / no
- A/B testing considerations:

## Experiment Plan

<!-- How will this feature be validated? Reference MLflow experiment tracking. -->

- [ ] Baseline metric to beat:
- [ ] Evaluation metrics: <!-- e.g., accuracy, F1, AUC, RMSE -->
- [ ] Dataset split strategy: <!-- e.g., temporal, stratified, k-fold -->
- [ ] MLflow experiment name: \`experiments/<name>\`
- [ ] Success criteria:

## Configuration

<!-- Provide a sample YAML config for \`configs/\` if applicable -->

\`\`\`yaml
# Example experiment config (configs/experiments/feature_name.yaml)
model:
  name:
  params: {}

data:
  source:
  preprocessing: []

training:
  epochs:
  batch_size:
  learning_rate:
  optimizer:
\`\`\`

## Implementation Checklist

<!-- Anticipated implementation steps -->

- [ ] Add Pydantic config schema in \`src/utils/\`
- [ ] Implement data pipeline stage in \`src/data/\`
- [ ] Implement model architecture in \`src/models/\`
- [ ] Add training logic in \`src/training/\`
- [ ] Add evaluation metrics in \`src/evaluation/\`
- [ ] Add serving endpoint in \`src/serving/\` (if applicable)
- [ ] Write unit tests (\`tests/unit/\`)
- [ ] Write integration tests (\`tests/integration/\`)
- [ ] Add DVC pipeline stage (\`dvc.yaml\`)
- [ ] Add YAML experiment config (\`configs/\`)
- [ ] Update documentation (\`docs/\`)
- [ ] Verify MLflow tracking and artifact logging
- [ ] Run \`uv run ruff check\` and \`uv run mypy src/\`
- [ ] Ensure test coverage ≥ 75%

## Compliance & Data Privacy

<!-- Required for features that touch data or model artifacts -->

- [ ] No PII in training data, or anonymization applied (GDPR)
- [ ] Data consent and lineage documented
- [ ] Model artifacts stored in DVC/S3 with integrity checks (SOC 2)
- [ ] No sensitive data logged to MLflow or stdout
- [ ] Right-to-deletion impact assessed if user data involved

## Alternatives Considered

<!-- What other approaches did you evaluate? Why is this approach preferred? -->

## Dependencies

<!-- New Python packages, infrastructure, or external services required -->

| Dependency | Version | Purpose | Risk Assessment |
|------------|---------|---------|-----------------|
|            |         |         |                 |

## Estimated Effort

- **T-shirt size**: XS / S / M / L / XL
- **GPU hours estimated**:
- **Blocked by**: <!-- Link related issues -->

## Additional Context

<!-- Relevant papers, benchmarks, notebooks, or Slack threads. Link exploration notebooks in \`notebooks/\` if applicable. -->`,

  '.github/PULL_REQUEST_TEMPLATE.md': `## Description

<!-- Provide a clear summary of what this PR does and why. Link the relevant GitHub Issue. -->

Resolves #<!-- issue number -->

### Change Type

- [ ] 🧪 Experiment (new model, hyperparameter search, architecture change)
- [ ] 🔧 Feature (new pipeline stage, API endpoint, tooling)
- [ ] 🐛 Bug Fix (training bug, data leak, inference error)
- [ ] 📊 Data Pipeline (feature engineering, preprocessing, data source change)
- [ ] 📦 Infrastructure (Docker, Terraform, CI/CD, deployment)
- [ ] 📝 Documentation (docs, runbooks, experiment logs)
- [ ] 🔨 Refactor (code quality, no behavior change)
- [ ] ⬆️ Dependency Update

---

## AI Disclosure

<!-- Required: Disclose any AI-assisted code generation per project policy. -->

- [ ] This PR contains **AI-generated code** (Claude, Copilot, etc.)
  - **Files with AI-generated content**: <!-- list files or "N/A" -->
  - **AI tool used**: <!-- e.g., Claude Code, GitHub Copilot -->
  - **Human review performed**: [ ] Yes
- [ ] This PR contains **no AI-generated code**

---

## Experiment Details

<!-- Complete this section if this PR involves model training, evaluation, or hyperparameter changes. Delete if not applicable. -->

### MLflow Tracking

- **Experiment name**: <!-- e.g., transformer-v2-ablation -->
- **Run ID(s)**: <!-- e.g., abc123def456 -->
- **MLflow UI link**: <!-- e.g., http://mlflow.internal/experiments/42 -->

### Experiment Config

- **Config file**: <!-- e.g., configs/experiments/transformer_v2.yaml -->
- **Key parameters changed**:
  | Parameter | Previous | New |
  |-----------|----------|-----|
  |           |          |     |

### Results

| Metric | Baseline | This PR | Delta |
|--------|----------|---------|-------|
|        |          |         |       |

- **Training time**: <!-- e.g., 2h 15m on p3.2xlarge -->
- **GPU utilization**: <!-- e.g., ~85% on V100 -->
- **Reproducibility**: [ ] Config committed [ ] Random seeds fixed [ ] DVC pipeline updated

---

## Data Pipeline Changes

<!-- Complete this section if data loading, preprocessing, or feature engineering changed. Delete if not applicable. -->

- [ ] DVC pipeline updated (\`dvc.yaml\` / \`dvc.lock\`)
- [ ] Data schema changes documented
- [ ] Feature store updated (Redis)
- [ ] Backward compatible with existing data versions
- **DVC remote sync**: [ ] \`dvc push\` completed for new artifacts
- **Data affected**: <!-- e.g., raw/clicks_2024.parquet, features/user_embeddings.npy -->

### GDPR / Data Privacy

- [ ] No PII introduced or exposed
- [ ] Data anonymization maintained
- [ ] Consent requirements verified for new data sources
- [ ] Right-to-deletion compatibility preserved

---

## Model Artifact Changes

<!-- Complete this section if model weights, checkpoints, or serving artifacts changed. Delete if not applicable. -->

- [ ] Model registered in MLflow Model Registry
- [ ] Model version: <!-- e.g., v3 -->
- [ ] Model stage: <!-- e.g., Staging, Production -->
- [ ] DVC-tracked model artifacts updated (\`models/\`)
- [ ] Inference latency benchmarked: <!-- e.g., p50=12ms, p99=45ms -->
- [ ] Model artifact integrity verified (checksum matches)
- [ ] Serving endpoint compatibility confirmed

---

## Checklist

### Code Quality

- [ ] Type hints on all public functions (\`mypy --strict\` passes)
- [ ] \`uv run ruff check .\` passes with no errors
- [ ] \`uv run ruff format --check .\` passes
- [ ] \`uv run mypy src/\` passes
- [ ] Files under 300 lines
- [ ] No production logic in \`notebooks/\` — exploration only
- [ ] Pydantic models used for config validation

### Testing

- [ ] \`uv run pytest\` passes
- [ ] Unit tests added/updated for changed code
- [ ] Integration tests added for new pipeline stages or API endpoints
- [ ] Coverage ≥ 75% (\`uv run pytest --cov=src --cov-fail-under=75\`)
- [ ] Training smoke test passes (\`scripts/smoke_test_train.py\`)

### Pipeline & Reproducibility

- [ ] \`dvc repro\` runs successfully end-to-end
- [ ] Experiment config committed in \`configs/\`
- [ ] Random seeds set for reproducibility
- [ ] All dependencies pinned in \`pyproject.toml\`

### Security & Compliance (SOC 2)

- [ ] No secrets, credentials, or API keys in code
- [ ] No changes to sensitive paths without required review:
  - \`configs/production/**\`, \`models/**\`, \`.env*\`, \`data/**\`
- [ ] Docker image scanned for vulnerabilities
- [ ] Model artifact provenance tracked (MLflow lineage)

### Deployment

- [ ] Docker build succeeds: \`docker build -t ml-pipeline .\`
- [ ] Staging deployment tested (if applicable)
- [ ] API contract unchanged or versioned (FastAPI schema)
- [ ] Monitoring/alerting updated (Prometheus metrics, Grafana dashboards)
- [ ] Rollback plan documented for production model changes

---

## Screenshots / Visualizations

<!-- Attach training curves, confusion matrices, feature importance plots, or API response examples if relevant. -->

---

## Reviewer Notes

<!-- Anything specific reviewers should focus on? Known limitations? Areas of uncertainty? -->`,

  '.github/workflows/ai-code-audit.yml': `name: AI Code Audit

on:
  schedule:
    # Run every Monday at 08:00 UTC (Americas morning)
    - cron: '0 8 * * 1'
  workflow_dispatch:
    inputs:
      audit_scope:
        description: 'Scope of audit'
        required: false
        default: 'full'
        type: choice
        options:
          - full
          - models
          - training
          - serving
          - data
          - configs
      focus_area:
        description: 'Specific focus area'
        required: false
        default: 'all'
        type: choice
        options:
          - all
          - reproducibility
          - performance
          - security
          - type-safety
          - test-coverage
          - ml-best-practices

permissions:
  contents: read
  issues: write
  pull-requests: read

env:
  PYTHON_VERSION: '3.11'
  AUDIT_REPORT_DIR: audit-reports

jobs:
  static-analysis:
    name: Static Analysis Collection
    runs-on: ubuntu-latest
    outputs:
      ruff_issues: \${{ steps.ruff.outputs.issue_count }}
      mypy_issues: \${{ steps.mypy.outputs.issue_count }}
      coverage_pct: \${{ steps.coverage.outputs.percentage }}
      large_files: \${{ steps.file_analysis.outputs.large_files }}
    steps:
      - name: Checkout repository
        uses: actions/checkout@v4
        with:
          fetch-depth: 0

      - name: Install uv
        uses: astral-sh/setup-uv@v4
        with:
          version: "latest"

      - name: Set up Python
        run: uv python install \${{ env.PYTHON_VERSION }}

      - name: Install dependencies
        run: uv sync --frozen --all-extras

      - name: Run ruff analysis
        id: ruff
        continue-on-error: true
        run: |
          uv run ruff check src/ --output-format=json > \${{ env.AUDIT_REPORT_DIR }}/ruff-report.json 2>&1 || true
          ISSUE_COUNT=$(python3 -c "import json; data=json.load(open('\${{ env.AUDIT_REPORT_DIR }}/ruff-report.json')); print(len(data))" 2>/dev/null || echo "0")
          echo "issue_count=$ISSUE_COUNT" >> "$GITHUB_OUTPUT"
          echo "::notice::Ruff found $ISSUE_COUNT issues"

      - name: Run mypy analysis
        id: mypy
        continue-on-error: true
        run: |
          mkdir -p \${{ env.AUDIT_REPORT_DIR }}
          uv run mypy src/ --no-error-summary 2>&1 | tee \${{ env.AUDIT_REPORT_DIR }}/mypy-report.txt || true
          ISSUE_COUNT=$(grep -c "error:" \${{ env.AUDIT_REPORT_DIR }}/mypy-report.txt 2>/dev/null || echo "0")
          echo "issue_count=$ISSUE_COUNT" >> "$GITHUB_OUTPUT"
          echo "::notice::mypy found $ISSUE_COUNT type errors"

      - name: Run test coverage
        id: coverage
        continue-on-error: true
        run: |
          uv run pytest tests/ --co -q 2>/dev/null | tail -1 > \${{ env.AUDIT_REPORT_DIR }}/test-count.txt || true
          uv run pytest tests/ --cov=src --cov-report=json:\${{ env.AUDIT_REPORT_DIR }}/coverage.json \\
            --cov-report=term -x --timeout=120 2>&1 | tee \${{ env.AUDIT_REPORT_DIR }}/coverage-report.txt || true
          COVERAGE=$(python3 -c "import json; data=json.load(open('\${{ env.AUDIT_REPORT_DIR }}/coverage.json')); print(round(data['totals']['percent_covered'], 1))" 2>/dev/null || echo "0")
          echo "percentage=$COVERAGE" >> "$GITHUB_OUTPUT"
          echo "::notice::Test coverage: $COVERAGE%"

      - name: Analyze file sizes and complexity
        id: file_analysis
        run: |
          mkdir -p \${{ env.AUDIT_REPORT_DIR }}
          echo "# Files exceeding 300-line limit" > \${{ env.AUDIT_REPORT_DIR }}/large-files.txt
          LARGE_FILES=""
          while IFS= read -r file; do
            lines=$(wc -l < "$file")
            if [ "$lines" -gt 300 ]; then
              echo "$file: $lines lines" >> \${{ env.AUDIT_REPORT_DIR }}/large-files.txt
              LARGE_FILES="\${LARGE_FILES}\${file}:\${lines},"
            fi
          done < <(find src/ -name "*.py" -type f 2>/dev/null)
          echo "large_files=$LARGE_FILES" >> "$GITHUB_OUTPUT"

      - name: Check for missing type hints on public functions
        run: |
          mkdir -p \${{ env.AUDIT_REPORT_DIR }}
          cat > /tmp/check_type_hints.py << 'PYEOF'
          import ast
          import sys
          from pathlib import Path

          issues = []
          for py_file in Path("src").rglob("*.py"):
              try:
                  tree = ast.parse(py_file.read_text())
                  for node in ast.walk(tree):
                      if isinstance(node, (ast.FunctionDef, ast.AsyncFunctionDef)):
                          if node.name.startswith("_"):
                              continue
                          if node.returns is None:
                              issues.append(f"{py_file}:{node.lineno} - {node.name}() missing return type hint")
                          for arg in node.args.args:
                              if arg.arg == "self" or arg.arg == "cls":
                                  continue
                              if arg.annotation is None:
                                  issues.append(f"{py_file}:{node.lineno} - {node.name}() param '{arg.arg}' missing type hint")
              except SyntaxError:
                  issues.append(f"{py_file}: SyntaxError - could not parse")

          with open("\${{ env.AUDIT_REPORT_DIR }}/type-hint-audit.txt", "w") as f:
              f.write(f"# Missing Type Hints: {len(issues)} issues\\n\\n")
              for issue in issues:
                  f.write(f"- {issue}\\n")
          print(f"Found {len(issues)} missing type hint issues")
          PYEOF
          python3 /tmp/check_type_hints.py

      - name: Upload analysis artifacts
        uses: actions/upload-artifact@v4
        with:
          name: static-analysis-reports
          path: \${{ env.AUDIT_REPORT_DIR }}/
          retention-days: 30

  ml-reproducibility-audit:
    name: ML Reproducibility & Best Practices Audit
    runs-on: ubuntu-latest
    steps:
      - name: Checkout repository
        uses: actions/checkout@v4
        with:
          fetch-depth: 0

      - name: Check experiment config completeness
        run: |
          mkdir -p \${{ env.AUDIT_REPORT_DIR }}
          cat > /tmp/check_configs.py << 'PYEOF'
          import yaml
          from pathlib import Path

          REQUIRED_FIELDS = {
              "model": ["name", "architecture"],
              "training": ["epochs", "learning_rate", "batch_size", "seed"],
              "data": ["dataset", "split_ratio"],
          }

          issues = []
          config_files = list(Path("configs").rglob("*.yaml")) + list(Path("configs").rglob("*.yml"))

          if not config_files:
              issues.append("WARNING: No YAML config files found in configs/")

          for config_path in config_files:
              if "production" in str(config_path):
                  continue
              try:
                  with open(config_path) as f:
                      config = yaml.safe_load(f)
                  if config is None:
                      issues.append(f"{config_path}: Empty config file")
                      continue
                  for section, fields in REQUIRED_FIELDS.items():
                      if section not in config:
                          continue
                      for field in fields:
                          if field not in config[section]:
                              issues.append(f"{config_path}: Missing {section}.{field}")
                  # Check for random seed (reproducibility)
                  has_seed = False
                  for section in config.values():
                      if isinstance(section, dict) and "seed" in section:
                          has_seed = True
                  if not has_seed:
                      issues.append(f"{config_path}: No random seed specified (reproducibility risk)")
              except Exception as e:
                  issues.append(f"{config_path}: Parse error - {e}")

          with open("\${{ env.AUDIT_REPORT_DIR }}/config-audit.txt", "w") as f:
              f.write(f"# Config Audit: {len(issues)} issues found\\n")
              f.write(f"# Configs scanned: {len(config_files)}\\n\\n")
              for issue in issues:
                  f.write(f"- {issue}\\n")
          print(f"Config audit: {len(issues)} issues across {len(config_files)} files")
          PYEOF
          pip install pyyaml -q
          python3 /tmp/check_configs.py

      - name: Check DVC pipeline integrity
        run: |
          mkdir -p \${{ env.AUDIT_REPORT_DIR }}
          echo "# DVC Pipeline Audit" > \${{ env.AUDIT_REPORT_DIR }}/dvc-audit.txt
          if [ -f "dvc.yaml" ]; then
            echo "✅ dvc.yaml found" >> \${{ env.AUDIT_REPORT_DIR }}/dvc-audit.txt
            # Check for stages without deps (non-reproducible)
            python3 -c "
          import yaml
          with open('dvc.yaml') as f:
              dvc = yaml.safe_load(f)
          stages = dvc.get('stages', {})
          for name, stage in stages.items():
              if 'deps' not in stage or not stage['deps']:
                  print(f'WARNING: Stage \\"{name}\\" has no dependencies declared')
              if 'outs' not in stage and 'metrics' not in stage:
                  print(f'WARNING: Stage \\"{name}\\" has no outputs or metrics')
          print(f'Total stages: {len(stages)}')
          " >> \${{ env.AUDIT_REPORT_DIR }}/dvc-audit.txt 2>&1 || echo "Could not parse dvc.yaml" >> \${{ env.AUDIT_REPORT_DIR }}/dvc-audit.txt
          else
            echo "⚠️ dvc.yaml not found — DVC pipeline not configured" >> \${{ env.AUDIT_REPORT_DIR }}/dvc-audit.txt
          fi
          if [ -f "dvc.lock" ]; then
            echo "✅ dvc.lock found (pipeline has been executed)" >> \${{ env.AUDIT_REPORT_DIR }}/dvc-audit.txt
          else
            echo "⚠️ dvc.lock not found — pipeline has never been fully executed" >> \${{ env.AUDIT_REPORT_DIR }}/dvc-audit.txt
          fi

      - name: Check model code patterns
        run: |
          mkdir -p \${{ env.AUDIT_REPORT_DIR }}
          cat > /tmp/check_ml_patterns.py << 'PYEOF'
          import re
          from pathlib import Path

          issues = []
          warnings = []

          # Check for hardcoded hyperparameters in model/training code
          for py_file in list(Path("src/models").rglob("*.py")) + list(Path("src/training").rglob("*.py")):
              content = py_file.read_text()
              lines = content.split("\\n")
              for i, line in enumerate(lines, 1):
                  # Hardcoded learning rates
                  if re.search(r'lr\\s*=\\s*\\d+\\.\\d+', line) and 'config' not in line.lower():
                      issues.append(f"{py_file}:{i} - Possible hardcoded learning rate: {line.strip()}")
                  # Hardcoded batch sizes
                  if re.search(r'batch_size\\s*=\\s*\\d+', line) and 'config' not in line.lower() and 'default' not in line.lower():
                      warnings.append(f"{py_file}:{i} - Possible hardcoded batch_size: {line.strip()}")
                  # Non-deterministic operations without seed
                  if 'torch.manual_seed' not in content and 'random.seed' not in content:
                      if re.search(r'torch\\.randn|torch\\.rand\\(|np\\.random\\.', line):
                          warnings.append(f"{py_file}:{i} - Random operation without visible seed setting")

          # Check for model saving without versioning
          for py_file in Path("src").rglob("*.py"):
              content = py_file.read_text()
              if "torch.save" in content and "mlflow" not in content:
                  warnings.append(f"{py_file}: Uses torch.save without MLflow logging — artifact may not be tracked")

          # Check serving code for input validation
          for py_file in Path("src/serving").rglob("*.py"):
              content = py_file.read_text()
              if "pydantic" not in content.lower() and "BaseModel" not in content:
                  if "@app.post" in content or "@router.post" in content:
                      issues.append(f"{py_file}: POST endpoint without Pydantic input validation")

          with open("\${{ env.AUDIT_REPORT_DIR }}/ml-patterns-audit.txt", "w") as f:
              f.write(f"# ML Pattern Audit\\n")
              f.write(f"# Issues: {len(issues)}, Warnings: {len(warnings)}\\n\\n")
              f.write("## Issues\\n")
              for issue in issues:
                  f.write(f"- ❌ {issue}\\n")
              f.write("\\n## Warnings\\n")
              for w in warnings:
                  f.write(f"- ⚠️ {w}\\n")
          print(f"ML patterns: {len(issues)} issues, {len(warnings)} warnings")
          PYEOF
          python3 /tmp/check_ml_patterns.py

      - name: Check for data leakage patterns
        run: |
          mkdir -p \${{ env.AUDIT_REPORT_DIR }}
          cat > /tmp/check_data_leakage.py << 'PYEOF'
          import re
          from pathlib import Path

          issues = []

          for py_file in Path("src").rglob("*.py"):
              content = py_file.read_text()
              lines = content.split("\\n")
              for i, line in enumerate(lines, 1):
                  # Fitting scaler/encoder on full dataset before split
                  if re.search(r'\\.fit_transform\\(.*(?:X|data|df)\\)', line):
                      if 'train' not in line.lower():
                          issues.append(f"{py_file}:{i} - fit_transform on possibly unsplit data: {line.strip()}")
                  # Target leakage: using target in feature engineering
                  if re.search(r'groupby.*target|target.*groupby', line, re.IGNORECASE):
                      issues.append(f"{py_file}:{i} - Possible target leakage in groupby: {line.strip()}")

          with open("\${{ env.AUDIT_REPORT_DIR }}/data-leakage-audit.txt", "w") as f:
              f.write(f"# Data Leakage Audit: {len(issues)} potential issues\\n\\n")
              for issue in issues:
                  f.write(f"- ⚠️ {issue}\\n")
              if not issues:
                  f.write("✅ No obvious data leakage patterns detected\\n")
          print(f"Data leakage check: {len(issues)} potential issues")
          PYEOF
          python3 /tmp/check_data_leakage.py

      - name: Upload ML audit artifacts
        uses: actions/upload-artifact@v4
        with:
          name: ml-audit-reports
          path: \${{ env.AUDIT_REPORT_DIR }}/
          retention-days: 30

  security-compliance-audit:
    name: Security & Compliance Audit
    runs-on: ubuntu-latest
    steps:
      - name: Checkout repository
        uses: actions/checkout@v4
        with:
          fetch-depth: 0

      - name: Check for secrets and PII patterns
        run: |
          mkdir -p \${{ env.AUDIT_REPORT_DIR }}
          echo "# Security & Compliance Audit" > \${{ env.AUDIT_REPORT_DIR }}/security-audit.txt

          # Check for potential secrets in code
          echo "## Potential Secrets" >> \${{ env.AUDIT_REPORT_DIR }}/security-audit.txt
          SECRETS_FOUND=0
          while IFS= read -r file; do
            if grep -nE '(aws_secret|password|api_key|token|secret)\\s*=\\s*["\\x27][^"\\x27]{8,}' "$file" 2>/dev/null | grep -v '#.*noqa' | grep -v 'os\\.environ' | grep -v 'config\\.' | head -5; then
              SECRETS_FOUND=$((SECRETS_FOUND + 1))
            fi
          done < <(find src/ configs/ scripts/ -name "*.py" -o -name "*.yaml" -o -name "*.yml" 2>/dev/null) >> \${{ env.AUDIT_REPORT_DIR }}/security-audit.txt
          echo "Potential secret patterns found in $SECRETS_FOUND files" >> \${{ env.AUDIT_REPORT_DIR }}/security-audit.txt

          # GDPR: Check for PII handling
          echo "" >> \${{ env.AUDIT_REPORT_DIR }}/security-audit.txt
          echo "## GDPR / PII Patterns" >> \${{ env.AUDIT_REPORT_DIR }}/security-audit.txt
          grep -rnl 'email\\|phone\\|address\\|ssn\\|social_security\\|date_of_birth\\|ip_address' src/ 2>/dev/null | while read -r file; do
            echo "⚠️ $file may handle PII — verify GDPR compliance (anonymization, consent, right to deletion)" >> \${{ env.AUDIT_REPORT_DIR }}/security-audit.txt
          done

          # Check for pickle usage (security risk in ML)
          echo "" >> \${{ env.AUDIT_REPORT_DIR }}/security-audit.txt
          echo "## Unsafe Deserialization" >> \${{ env.AUDIT_REPORT_DIR }}/security-audit.txt
          grep -rn 'pickle\\.load\\|torch\\.load.*weights_only.*False\\|joblib\\.load' src/ 2>/dev/null | while read -r match; do
            echo "⚠️ $match — unsafe deserialization (SOC 2 / model artifact integrity risk)" >> \${{ env.AUDIT_REPORT_DIR }}/security-audit.txt
          done

          # Check model artifact integrity
          echo "" >> \${{ env.AUDIT_REPORT_DIR }}/security-audit.txt
          echo "## Model Artifact Integrity" >> \${{ env.AUDIT_REPORT_DIR }}/security-audit.txt
          if grep -rq 'torch\\.load.*weights_only\\s*=\\s*True' src/ 2>/dev/null; then
            echo "✅ Found torch.load with weights_only=True (safe loading)" >> \${{ env.AUDIT_REPORT_DIR }}/security-audit.txt
          fi
          if grep -rq 'mlflow.*log_model\\|mlflow.*log_artifact' src/ 2>/dev/null; then
            echo "✅ MLflow artifact logging detected" >> \${{ env.AUDIT_REPORT_DIR }}/security-audit.txt
          else
            echo "⚠️ No MLflow artifact logging found — model provenance may not be tracked" >> \${{ env.AUDIT_REPORT_DIR }}/security-audit.txt
          fi

      - name: Check dependency vulnerabilities
        continue-on-error: true
        run: |
          pip install pip-audit -q
          pip-audit --requirement <(uv export --no-hashes 2>/dev/null || echo "") \\
            --output \${{ env.AUDIT_REPORT_DIR }}/vulnerability-report.txt 2>&1 || \\
            echo "Could not run pip-audit (dependencies may not be exported)" > \${{ env.AUDIT_REPORT_DIR }}/vulnerability-report.txt

      - name: Check production config protection
        run: |
          echo "## Production Config Protection" >> \${{ env.AUDIT_REPORT_DIR }}/security-audit.txt
          # Verify CODEOWNERS protects sensitive paths
          if [ -f ".github/CODEOWNERS" ]; then
            for path in "configs/production" "models/" ".env"; do
              if grep -q "$path" .github/CODEOWNERS; then
                echo "✅ $path protected in CODEOWNERS" >> \${{ env.AUDIT_REPORT_DIR }}/security-audit.txt
              else
                echo "❌ $path NOT protected in CODEOWNERS" >> \${{ env.AUDIT_REPORT_DIR }}/security-audit.txt
              fi
            done
          else
            echo "❌ CODEOWNERS file not found" >> \${{ env.AUDIT_REPORT_DIR }}/security-audit.txt
          fi

      - name: Upload security audit artifacts
        uses: actions/upload-artifact@v4
        with:
          name: security-audit-reports
          path: \${{ env.AUDIT_REPORT_DIR }}/
          retention-days: 30

  generate-audit-report:
    name: Generate Consolidated Audit Report
    needs: [static-analysis, ml-reproducibility-audit, security-compliance-audit]
    runs-on: ubuntu-latest
    steps:
      - name: Checkout repository
        uses: actions/checkout@v4

      - name: Download all audit artifacts
        uses: actions/download-artifact@v4
        with:
          path: all-reports/

      - name: Generate consolidated report
        id: report
        run: |
          REPORT_DATE=$(date -u +"%Y-%m-%d")
          REPORT_FILE="audit-report-\${REPORT_DATE}.md"

          cat > "$REPORT_FILE" << EOF
          # 🔍 ML Pipeline Weekly Audit Report

          **Date:** \${REPORT_DATE}
          **Repository:** \${{ github.repository }}
          **Commit:** \${{ github.sha }}
          **Triggered by:** \${{ github.event_name }}
          **Audit scope:** \${{ inputs.audit_scope || 'full' }}
          **Focus area:** \${{ inputs.focus_area || 'all' }}

          ---

          ## 📊 Summary

          | Metric | Value | Threshold | Status |
          |--------|-------|-----------|--------|
          | Ruff lint issues | \${{ needs.static-analysis.outputs.ruff_issues || 'N/A' }} | 0 | $([ "\${{ needs.static-analysis.outputs.ruff_issues }}" = "0" ] && echo "✅" || echo "⚠️") |
          | mypy type errors | \${{ needs.static-analysis.outputs.mypy_issues || 'N/A' }} | 0 | $([ "\${{ needs.static-analysis.outputs.mypy_issues }}" = "0" ] && echo "✅" || echo "⚠️") |
          | Test coverage | \${{ needs.static-analysis.outputs.coverage_pct || 'N/A' }}% | 75% | $(python3 -c "print('✅' if float('\${{ needs.static-analysis.outputs.coverage_pct || 0 }}') >= 75 else '❌')") |
          | Files > 300 lines | $(echo "\${{ needs.static-analysis.outputs.large_files }}" | tr ',' '\\n' | grep -c . || echo "0") | 0 | $([ -z "\${{ needs.static-analysis.outputs.large_files }}" ] && echo "✅" || echo "⚠️") |

          ---

          ## 📋 Detailed Reports

          EOF

          # Append all report files
          for report_dir in all-reports/*/; do
            for report_file in "$report_dir"*.txt "$report_dir"*.json; do
              if [ -f "$report_file" ]; then
                BASENAME=$(basename "$report_file")
                echo "### 📄 \${BASENAME}" >> "$REPORT_FILE"
                echo "" >> "$REPORT_FILE"
                echo '\`\`\`' >> "$REPORT_FILE"
                head -100 "$report_file" >> "$REPORT_FILE"
                TOTAL_LINES=$(wc -l < "$report_file")
                if [ "$TOTAL_LINES" -gt 100 ]; then
                  echo "... (truncated, $TOTAL_LINES total lines)" >> "$REPORT_FILE"
                fi
                echo '\`\`\`' >> "$REPORT_FILE"
                echo "" >> "$REPORT_FILE"
              fi
            done
          done

          cat >> "$REPORT_FILE" << 'EOF'

          ---

          ## 🎯 Action Items

          Review the findings above and create GitHub Issues for:
          1. **Critical:** Any security findings (secrets, unsafe deserialization, GDPR violations)
          2. **High:** Type errors, missing type hints on public APIs, test coverage below 75%
          3. **Medium:** Hardcoded hyperparameters, missing experiment configs, files exceeding 300 lines
          4. **Low:** Lint warnings, code style improvements

          ## 🏷️ Labels

          Apply these labels to created issues:
          - \`audit\` — from automated audit
          - \`ai-generated\` — AI-identified issue
          - \`security\` / \`reproducibility\` / \`code-quality\` as appropriate

          ---

          *This report was generated by the AI Code Audit workflow.*
          *Review methodology: static analysis + ML-specific pattern matching + security scanning.*
          *SOC 2 compliance: model artifact integrity and access controls verified.*
          *GDPR compliance: PII handling patterns flagged for manual review.*
          EOF

          echo "report_file=$REPORT_FILE" >> "$GITHUB_OUTPUT"

          # Determine overall health
          RUFF=\${{ needs.static-analysis.outputs.ruff_issues || 0 }}
          MYPY=\${{ needs.static-analysis.outputs.mypy_issues || 0 }}
          COV=\${{ needs.static-analysis.outputs.coverage_pct || 0 }}
          if [ "$RUFF" -eq 0 ] && [ "$MYPY" -eq 0 ] && [ "$(python3 -c "print(1 if float('$COV') >= 75 else 0)")" -eq 1 ]; then
            echo "health=healthy" >> "$GITHUB_OUTPUT"
          else
            echo "health=needs-attention" >> "$GITHUB_OUTPUT"
          fi

      - name: Create GitHub Issue with audit results
        uses: actions/github-script@v7
        with:
          script: |
            const fs = require('fs');
            const reportFile = '\${{ steps.report.outputs.report_file }}';
            const health = '\${{ steps.report.outputs.health }}';
            const reportContent = fs.readFileSync(reportFile, 'utf8');

            const title = health === 'healthy'
              ? \`✅ Weekly ML Audit — \${new Date().toISOString().split('T')[0]} — All Clear\`
              : \`⚠️ Weekly ML Audit — \${new Date().toISOString().split('T')[0]} — Needs Attention\`;

            const labels = ['audit', 'ai-generated'];
            if (health !== 'healthy') {
              labels.push('needs-attention');
            }

            // Close previous audit issues
            const previousIssues = await github.rest.issues.listForRepo({
              owner: context.repo.owner,
              repo: context.repo.repo,
              labels: 'audit',
              state: 'open',
            });

            for (const issue of previousIssues.data) {
              if (issue.title.includes('Weekly ML Audit')) {
                await github.rest.issues.update({
                  owner: context.repo.owner,
                  repo: context.repo.repo,
                  issue_number: issue.number,
                  state: 'closed',
                  state_reason: 'completed',
                });
              }
            }

            // Truncate if too long for GitHub issue body
            const maxLength = 60000;
            const body = reportContent.length > maxLength
              ? reportContent.substring(0, maxLength) + '\\n\\n... (report truncated, see workflow artifacts for full report)'
              : reportContent;

            await github.rest.issues.create({
              owner: context.repo.owner,
              repo: context.repo.repo,
              title: title,
              body: body,
              labels: labels,
            });

      - name: Upload consolidated report
        uses: actions/upload-artifact@v4
        with:
          name: consolidated-audit-report
          path: \${{ steps.report.outputs.report_file }}
          retention-days: 90

      - name: Post summary
        run: |
          echo "## 🔍 AI Code Audit Complete" >> "$GITHUB_STEP_SUMMARY"
          echo "" >> "$GITHUB_STEP_SUMMARY"
          echo "**Health:** \${{ steps.report.outputs.health }}" >> "$GITHUB_STEP_SUMMARY"
          echo "**Ruff issues:** \${{ needs.static-analysis.outputs.ruff_issues || 'N/A' }}" >> "$GITHUB_STEP_SUMMARY"
          echo "**mypy errors:** \${{ needs.static-analysis.outputs.mypy_issues || 'N/A' }}" >> "$GITHUB_STEP_SUMMARY"
          echo "**Coverage:** \${{ needs.static-analysis.outputs.coverage_pct || 'N/A' }}%" >> "$GITHUB_STEP_SUMMARY"
          echo "" >> "$GITHUB_STEP_SUMMARY"
          echo "Full report created as GitHub Issue." >> "$GITHUB_STEP_SUMMARY"`,

  '.github/workflows/ci.yml': `name: CI Pipeline

on:
  pull_request:
    branches: [main]
  push:
    branches: [main]

concurrency:
  group: ci-\${{ github.ref }}
  cancel-in-progress: true

env:
  PYTHON_VERSION: "3.11"
  UV_VERSION: "0.4"
  MLFLOW_TRACKING_URI: sqlite:///mlflow.db
  DVC_NO_ANALYTICS: "1"

jobs:
  lint:
    name: Lint (ruff)
    runs-on: ubuntu-latest
    steps:
      - uses: actions/checkout@v4

      - name: Install uv
        uses: astral-sh/setup-uv@v3
        with:
          version: \${{ env.UV_VERSION }}

      - name: Set up Python
        run: uv python install \${{ env.PYTHON_VERSION }}

      - name: Install dependencies
        run: uv sync --frozen --dev

      - name: Run ruff check
        run: uv run ruff check src/ tests/ scripts/

      - name: Run ruff format check
        run: uv run ruff format --check src/ tests/ scripts/

  type-check:
    name: Type Check (mypy)
    runs-on: ubuntu-latest
    steps:
      - uses: actions/checkout@v4

      - name: Install uv
        uses: astral-sh/setup-uv@v3
        with:
          version: \${{ env.UV_VERSION }}

      - name: Set up Python
        run: uv python install \${{ env.PYTHON_VERSION }}

      - name: Install dependencies
        run: uv sync --frozen --dev

      - name: Run mypy (strict)
        run: uv run mypy src/

  unit-tests:
    name: Unit Tests
    runs-on: ubuntu-latest
    needs: [lint, type-check]
    services:
      redis:
        image: redis:7-alpine
        ports:
          - 6379:6379
        options: >-
          --health-cmd "redis-cli ping"
          --health-interval 10s
          --health-timeout 5s
          --health-retries 5
      postgres:
        image: postgres:15-alpine
        env:
          POSTGRES_USER: mlpipeline
          POSTGRES_PASSWORD: testpassword
          POSTGRES_DB: mlpipeline_test
        ports:
          - 5432:5432
        options: >-
          --health-cmd pg_isready
          --health-interval 10s
          --health-timeout 5s
          --health-retries 5
    env:
      DATABASE_URL: postgresql://mlpipeline:testpassword@localhost:5432/mlpipeline_test
      REDIS_URL: redis://localhost:6379/0
    steps:
      - uses: actions/checkout@v4

      - name: Install uv
        uses: astral-sh/setup-uv@v3
        with:
          version: \${{ env.UV_VERSION }}

      - name: Set up Python
        run: uv python install \${{ env.PYTHON_VERSION }}

      - name: Install dependencies
        run: uv sync --frozen --dev

      - name: Run unit tests with coverage
        run: |
          uv run pytest tests/unit/ \\
            --cov=src \\
            --cov-report=xml:coverage.xml \\
            --cov-report=term-missing \\
            --cov-fail-under=75 \\
            -v \\
            --tb=short \\
            -x

      - name: Upload coverage report
        if: always()
        uses: actions/upload-artifact@v4
        with:
          name: coverage-report
          path: coverage.xml
          retention-days: 7

      - name: Post coverage to PR
        if: github.event_name == 'pull_request'
        uses: orgoro/coverage@v3.2
        with:
          coverageFile: coverage.xml
          token: \${{ secrets.GITHUB_TOKEN }}
          thresholdAll: 0.75

  integration-tests:
    name: Integration Tests
    runs-on: ubuntu-latest
    needs: [unit-tests]
    services:
      redis:
        image: redis:7-alpine
        ports:
          - 6379:6379
        options: >-
          --health-cmd "redis-cli ping"
          --health-interval 10s
          --health-timeout 5s
          --health-retries 5
      postgres:
        image: postgres:15-alpine
        env:
          POSTGRES_USER: mlpipeline
          POSTGRES_PASSWORD: testpassword
          POSTGRES_DB: mlpipeline_test
        ports:
          - 5432:5432
        options: >-
          --health-cmd pg_isready
          --health-interval 10s
          --health-timeout 5s
          --health-retries 5
    env:
      DATABASE_URL: postgresql://mlpipeline:testpassword@localhost:5432/mlpipeline_test
      REDIS_URL: redis://localhost:6379/0
    steps:
      - uses: actions/checkout@v4

      - name: Install uv
        uses: astral-sh/setup-uv@v3
        with:
          version: \${{ env.UV_VERSION }}

      - name: Set up Python
        run: uv python install \${{ env.PYTHON_VERSION }}

      - name: Install dependencies
        run: uv sync --frozen --dev

      - name: Run integration tests
        run: |
          uv run pytest tests/integration/ \\
            -v \\
            --tb=short \\
            -x \\
            --timeout=120

  dvc-repro-check:
    name: DVC Pipeline Check
    runs-on: ubuntu-latest
    needs: [lint, type-check]
    steps:
      - uses: actions/checkout@v4
        with:
          fetch-depth: 0

      - name: Install uv
        uses: astral-sh/setup-uv@v3
        with:
          version: \${{ env.UV_VERSION }}

      - name: Set up Python
        run: uv python install \${{ env.PYTHON_VERSION }}

      - name: Install dependencies
        run: uv sync --frozen --dev

      - name: Install DVC with S3 support
        run: uv pip install "dvc[s3]"

      - name: Validate DVC pipeline definition
        run: |
          if [ -f dvc.yaml ]; then
            echo "Validating dvc.yaml..."
            uv run dvc dag
            echo "DVC DAG validated successfully"
          else
            echo "No dvc.yaml found — skipping pipeline validation"
          fi

      - name: Check DVC lock file consistency
        run: |
          if [ -f dvc.lock ]; then
            echo "Checking dvc.lock consistency with dvc.yaml..."
            uv run dvc status 2>&1 | tee dvc-status.txt
            if grep -q "changed" dvc-status.txt; then
              echo "::warning::DVC pipeline has changed stages. Run 'dvc repro' locally and commit dvc.lock"
            fi
          else
            echo "No dvc.lock found — pipeline has not been run yet"
          fi

      - name: Validate experiment configs
        run: |
          uv run python -c "
          import yaml
          from pathlib import Path

          config_dir = Path('configs')
          if config_dir.exists():
              for config_file in config_dir.rglob('*.yaml'):
                  print(f'Validating {config_file}...')
                  with open(config_file) as f:
                      config = yaml.safe_load(f)
                  assert config is not None, f'{config_file} is empty or invalid'
                  print(f'  ✓ {config_file} is valid YAML')
              print('All configs validated successfully')
          else:
              print('No configs directory found')
          "

  train-smoke-test:
    name: Training Smoke Test
    runs-on: ubuntu-latest
    needs: [unit-tests, dvc-repro-check]
    env:
      MLFLOW_TRACKING_URI: sqlite:///mlflow.db
    steps:
      - uses: actions/checkout@v4

      - name: Install uv
        uses: astral-sh/setup-uv@v3
        with:
          version: \${{ env.UV_VERSION }}

      - name: Set up Python
        run: uv python install \${{ env.PYTHON_VERSION }}

      - name: Install dependencies
        run: uv sync --frozen --dev

      - name: Run training smoke test (CPU, minimal data)
        run: |
          uv run pytest tests/smoke/ \\
            -v \\
            --tb=short \\
            -x \\
            --timeout=300 \\
            -k "smoke"
        env:
          DEVICE: cpu
          SMOKE_TEST: "1"
          MAX_EPOCHS: "1"
          BATCH_SIZE: "4"
          MAX_SAMPLES: "32"

  serving-test:
    name: Serving API Test
    runs-on: ubuntu-latest
    needs: [unit-tests]
    steps:
      - uses: actions/checkout@v4

      - name: Install uv
        uses: astral-sh/setup-uv@v3
        with:
          version: \${{ env.UV_VERSION }}

      - name: Set up Python
        run: uv python install \${{ env.PYTHON_VERSION }}

      - name: Install dependencies
        run: uv sync --frozen --dev

      - name: Test FastAPI serving endpoints
        run: |
          uv run pytest tests/serving/ \\
            -v \\
            --tb=short \\
            -x \\
            --timeout=60

  docker-build:
    name: Docker Build
    runs-on: ubuntu-latest
    needs: [unit-tests, integration-tests, train-smoke-test, serving-test]
    if: github.event_name == 'push' && github.ref == 'refs/heads/main'
    steps:
      - uses: actions/checkout@v4

      - name: Set up Docker Buildx
        uses: docker/setup-buildx-action@v3

      - name: Build training image
        uses: docker/build-push-action@v5
        with:
          context: .
          file: ./Dockerfile.train
          push: false
          tags: ml-pipeline/train:\${{ github.sha }}
          cache-from: type=gha
          cache-to: type=gha,mode=max

      - name: Build serving image
        uses: docker/build-push-action@v5
        with:
          context: .
          file: ./Dockerfile.serve
          push: false
          tags: ml-pipeline/serve:\${{ github.sha }}
          cache-from: type=gha
          cache-to: type=gha,mode=max

  security-scan:
    name: Security Scan
    runs-on: ubuntu-latest
    needs: [lint]
    steps:
      - uses: actions/checkout@v4

      - name: Install uv
        uses: astral-sh/setup-uv@v3
        with:
          version: \${{ env.UV_VERSION }}

      - name: Set up Python
        run: uv python install \${{ env.PYTHON_VERSION }}

      - name: Install dependencies
        run: uv sync --frozen --dev

      - name: Run bandit security linter
        run: uv run bandit -r src/ -c pyproject.toml -f json -o bandit-report.json || true

      - name: Check for secrets in code
        run: |
          uv run pip install detect-secrets
          detect-secrets scan --all-files --exclude-files '\\.lock$' --exclude-files 'uv\\.lock$' > .secrets-baseline.json
          if [ "$(python -c "import json; d=json.load(open('.secrets-baseline.json')); print(len(d.get('results', {})))")" != "0" ]; then
            echo "::error::Potential secrets detected in codebase. Review .secrets-baseline.json"
            cat .secrets-baseline.json
            exit 1
          fi

      - name: Check for PII in configs (GDPR compliance)
        run: |
          echo "Scanning configs for potential PII patterns..."
          if grep -rn -E '(email|phone|ssn|social_security|date_of_birth|address)' configs/ --include="*.yaml" 2>/dev/null; then
            echo "::warning::Potential PII field references found in configs. Ensure GDPR-compliant anonymization is applied."
          fi

      - name: Upload security report
        if: always()
        uses: actions/upload-artifact@v4
        with:
          name: security-report
          path: bandit-report.json
          retention-days: 30

  ci-status:
    name: CI Status
    runs-on: ubuntu-latest
    needs: [lint, type-check, unit-tests, integration-tests, dvc-repro-check, train-smoke-test, serving-test, security-scan]
    if: always()
    steps:
      - name: Check CI results
        run: |
          if [ "\${{ needs.lint.result }}" != "success" ] || \\
             [ "\${{ needs.type-check.result }}" != "success" ] || \\
             [ "\${{ needs.unit-tests.result }}" != "success" ] || \\
             [ "\${{ needs.integration-tests.result }}" != "success" ] || \\
             [ "\${{ needs.dvc-repro-check.result }}" != "success" ] || \\
             [ "\${{ needs.train-smoke-test.result }}" != "success" ] || \\
             [ "\${{ needs.serving-test.result }}" != "success" ] || \\
             [ "\${{ needs.security-scan.result }}" != "success" ]; then
            echo "::error::One or more CI jobs failed"
            echo "  lint: \${{ needs.lint.result }}"
            echo "  type-check: \${{ needs.type-check.result }}"
            echo "  unit-tests: \${{ needs.unit-tests.result }}"
            echo "  integration-tests: \${{ needs.integration-tests.result }}"
            echo "  dvc-repro-check: \${{ needs.dvc-repro-check.result }}"
            echo "  train-smoke-test: \${{ needs.train-smoke-test.result }}"
            echo "  serving-test: \${{ needs.serving-test.result }}"
            echo "  security-scan: \${{ needs.security-scan.result }}"
            exit 1
          fi
          echo "All CI checks passed ✓"`,

  '.github/workflows/deploy-production.yml': `name: Deploy Production

on:
  workflow_dispatch:
    inputs:
      model_name:
        description: "MLflow registered model name"
        required: true
        type: string
      model_version:
        description: "MLflow model version to promote (e.g., 5)"
        required: true
        type: string
      canary_percentage:
        description: "Initial canary traffic percentage"
        required: true
        type: choice
        options:
          - "5"
          - "10"
          - "25"
        default: "10"
      skip_canary:
        description: "Skip canary and deploy 100% (emergency only)"
        required: false
        type: boolean
        default: false
      rollback_version:
        description: "ECS task definition revision to rollback to (leave empty for new deploy)"
        required: false
        type: string

concurrency:
  group: production-deploy
  cancel-in-progress: false

env:
  AWS_REGION: us-east-1
  ECR_REPOSITORY: ml-pipeline-serving
  ECS_CLUSTER: ml-pipeline-production
  ECS_SERVICE: ml-pipeline-serving-prod
  ECS_SERVICE_CANARY: ml-pipeline-serving-prod-canary
  MLFLOW_TRACKING_URI: \${{ secrets.MLFLOW_TRACKING_URI }}
  PRODUCTION_URL: https://api.ml-pipeline.example.com

permissions:
  id-token: write
  contents: read
  deployments: write
  issues: write

jobs:
  # -------------------------------------------------------------------
  # Gate: require manual approval via GitHub environment protection rules
  # -------------------------------------------------------------------
  approval:
    name: Production Approval Gate
    runs-on: ubuntu-latest
    environment:
      name: production
      url: \${{ env.PRODUCTION_URL }}
    steps:
      - name: Approval confirmed
        run: echo "Production deployment approved by \${{ github.actor }}"

  # -------------------------------------------------------------------
  # Validate: ensure model exists, passes quality gates, and is safe
  # -------------------------------------------------------------------
  validate-model:
    name: Validate Model for Production
    needs: [approval]
    runs-on: ubuntu-latest
    outputs:
      model_uri: \${{ steps.validate.outputs.model_uri }}
      model_run_id: \${{ steps.validate.outputs.model_run_id }}
      model_metrics: \${{ steps.validate.outputs.model_metrics }}
      image_tag: \${{ steps.image-tag.outputs.tag }}
    steps:
      - name: Checkout repository
        uses: actions/checkout@v4

      - name: Configure AWS credentials
        uses: aws-actions/configure-aws-credentials@v4
        with:
          role-to-assume: \${{ secrets.AWS_PROD_ROLE_ARN }}
          aws-region: \${{ env.AWS_REGION }}

      - name: Install uv
        uses: astral-sh/setup-uv@v4
        with:
          version: "latest"

      - name: Set up Python
        run: uv python install 3.11

      - name: Install dependencies
        run: uv sync --frozen --group mlflow

      - name: Validate model in MLflow registry
        id: validate
        env:
          MODEL_NAME: \${{ inputs.model_name }}
          MODEL_VERSION: \${{ inputs.model_version }}
        run: |
          uv run python -c "
          import mlflow
          import json
          import sys
          import os

          client = mlflow.tracking.MlflowClient()
          model_name = os.environ['MODEL_NAME']
          model_version = os.environ['MODEL_VERSION']

          # Fetch model version details
          try:
              mv = client.get_model_version(model_name, model_version)
          except Exception as e:
              print(f'::error::Model {model_name} v{model_version} not found: {e}')
              sys.exit(1)

          # Verify model was validated in staging
          run = client.get_run(mv.run_id)
          tags = run.data.tags
          metrics = run.data.metrics

          # Check staging validation tag
          if tags.get('staging_validated') != 'true':
              print('::error::Model has not been validated in staging. Deploy to staging first.')
              sys.exit(1)

          # Check minimum metric thresholds for production
          min_thresholds = {
              'test_accuracy': 0.85,
              'test_f1': 0.80,
          }
          for metric, threshold in min_thresholds.items():
              value = metrics.get(metric)
              if value is None:
                  print(f'::warning::Metric {metric} not found, skipping threshold check')
                  continue
              if value < threshold:
                  print(f'::error::Metric {metric}={value:.4f} below production threshold {threshold}')
                  sys.exit(1)
              print(f'✓ {metric}={value:.4f} >= {threshold}')

          # Check for bias/fairness audit tag (SOC 2 / GDPR)
          if tags.get('bias_audit_passed') != 'true':
              print('::warning::Bias audit tag not found. Ensure fairness review is complete.')

          # Check for data lineage (GDPR compliance)
          if not tags.get('data_lineage'):
              print('::warning::Data lineage tag missing. Required for GDPR compliance.')

          model_uri = f'models:/{model_name}/{model_version}'

          with open(os.environ['GITHUB_OUTPUT'], 'a') as f:
              f.write(f'model_uri={model_uri}\\n')
              f.write(f'model_run_id={mv.run_id}\\n')
              f.write(f'model_metrics={json.dumps(dict(metrics))}\\n')

          print(f'✓ Model {model_name} v{model_version} validated for production')
          print(f'  Run ID: {mv.run_id}')
          print(f'  Source: {mv.source}')
          print(f'  Status: {mv.status}')
          "

      - name: Verify model artifact integrity (SOC 2)
        env:
          MODEL_NAME: \${{ inputs.model_name }}
          MODEL_VERSION: \${{ inputs.model_version }}
        run: |
          uv run python -c "
          import mlflow
          import hashlib
          import os

          client = mlflow.tracking.MlflowClient()
          model_name = os.environ['MODEL_NAME']
          model_version = os.environ['MODEL_VERSION']
          mv = client.get_model_version(model_name, model_version)
          run = client.get_run(mv.run_id)

          # Verify artifact checksum if stored
          expected_checksum = run.data.tags.get('model_checksum')
          if expected_checksum:
              artifacts_path = mlflow.artifacts.download_artifacts(run_id=mv.run_id, artifact_path='model')
              # Compute checksum of model weights
              import glob
              model_files = sorted(glob.glob(f'{artifacts_path}/**/*', recursive=True))
              hasher = hashlib.sha256()
              for fp in model_files:
                  if os.path.isfile(fp):
                      with open(fp, 'rb') as f:
                          for chunk in iter(lambda: f.read(8192), b''):
                              hasher.update(chunk)
              actual_checksum = hasher.hexdigest()
              if actual_checksum != expected_checksum:
                  print(f'::error::Model artifact integrity check failed!')
                  print(f'  Expected: {expected_checksum}')
                  print(f'  Actual:   {actual_checksum}')
                  raise SystemExit(1)
              print(f'✓ Model artifact integrity verified: {actual_checksum[:16]}...')
          else:
              print('::warning::No model_checksum tag found. Skipping integrity verification.')
          "

      - name: Generate image tag
        id: image-tag
        run: |
          TAG="prod-\${{ inputs.model_name }}-v\${{ inputs.model_version }}-$(echo \${{ github.sha }} | cut -c1-7)"
          echo "tag=\${TAG}" >> "$GITHUB_OUTPUT"

  # -------------------------------------------------------------------
  # Build: production Docker image with model baked in
  # -------------------------------------------------------------------
  build-production-image:
    name: Build Production Image
    needs: [validate-model]
    runs-on: ubuntu-latest
    outputs:
      image_uri: \${{ steps.build.outputs.image_uri }}
    steps:
      - name: Checkout repository
        uses: actions/checkout@v4

      - name: Configure AWS credentials
        uses: aws-actions/configure-aws-credentials@v4
        with:
          role-to-assume: \${{ secrets.AWS_PROD_ROLE_ARN }}
          aws-region: \${{ env.AWS_REGION }}

      - name: Login to Amazon ECR
        id: ecr-login
        uses: aws-actions/amazon-ecr-login@v2

      - name: Set up Docker Buildx
        uses: docker/setup-buildx-action@v3

      - name: Build and push production image
        id: build
        env:
          ECR_REGISTRY: \${{ steps.ecr-login.outputs.registry }}
          IMAGE_TAG: \${{ needs.validate-model.outputs.image_tag }}
          MODEL_URI: \${{ needs.validate-model.outputs.model_uri }}
        run: |
          IMAGE_URI="\${ECR_REGISTRY}/\${ECR_REPOSITORY}:\${IMAGE_TAG}"

          docker buildx build \\
            --platform linux/amd64 \\
            --build-arg MODEL_URI="\${MODEL_URI}" \\
            --build-arg MLFLOW_TRACKING_URI="\${MLFLOW_TRACKING_URI}" \\
            --build-arg ENVIRONMENT=production \\
            --build-arg BUILD_SHA="\${{ github.sha }}" \\
            --build-arg MODEL_NAME="\${{ inputs.model_name }}" \\
            --build-arg MODEL_VERSION="\${{ inputs.model_version }}" \\
            --tag "\${IMAGE_URI}" \\
            --tag "\${ECR_REGISTRY}/\${ECR_REPOSITORY}:prod-latest" \\
            --file Dockerfile.serving \\
            --push \\
            .

          echo "image_uri=\${IMAGE_URI}" >> "$GITHUB_OUTPUT"
          echo "✓ Production image built: \${IMAGE_URI}"

      - name: Scan image for vulnerabilities (SOC 2)
        env:
          ECR_REGISTRY: \${{ steps.ecr-login.outputs.registry }}
          IMAGE_TAG: \${{ needs.validate-model.outputs.image_tag }}
        run: |
          aws ecr start-image-scan \\
            --repository-name "\${ECR_REPOSITORY}" \\
            --image-id imageTag="\${IMAGE_TAG}"

          echo "Waiting for scan to complete..."
          aws ecr wait image-scan-complete \\
            --repository-name "\${ECR_REPOSITORY}" \\
            --image-id imageTag="\${IMAGE_TAG}" || true

          FINDINGS=$(aws ecr describe-image-scan-findings \\
            --repository-name "\${ECR_REPOSITORY}" \\
            --image-id imageTag="\${IMAGE_TAG}" \\
            --query 'imageScanFindings.findingSeverityCounts' \\
            --output json 2>/dev/null || echo '{}')

          echo "Scan findings: \${FINDINGS}"

          CRITICAL=$(echo "\${FINDINGS}" | jq -r '.CRITICAL // 0')
          HIGH=$(echo "\${FINDINGS}" | jq -r '.HIGH // 0')

          if [ "\${CRITICAL}" -gt 0 ]; then
            echo "::error::\${CRITICAL} CRITICAL vulnerabilities found. Blocking deployment."
            exit 1
          fi

          if [ "\${HIGH}" -gt 5 ]; then
            echo "::error::\${HIGH} HIGH vulnerabilities found (threshold: 5). Blocking deployment."
            exit 1
          fi

          echo "✓ Image scan passed (Critical: \${CRITICAL}, High: \${HIGH})"

  # -------------------------------------------------------------------
  # Pre-deploy: smoke test the production image
  # -------------------------------------------------------------------
  pre-deploy-smoke-test:
    name: Pre-Deploy Smoke Test
    needs: [validate-model, build-production-image]
    runs-on: ubuntu-latest
    steps:
      - name: Checkout repository
        uses: actions/checkout@v4

      - name: Configure AWS credentials
        uses: aws-actions/configure-aws-credentials@v4
        with:
          role-to-assume: \${{ secrets.AWS_PROD_ROLE_ARN }}
          aws-region: \${{ env.AWS_REGION }}

      - name: Login to Amazon ECR
        id: ecr-login
        uses: aws-actions/amazon-ecr-login@v2

      - name: Run smoke test against production image
        env:
          IMAGE_URI: \${{ needs.build-production-image.outputs.image_uri }}
        run: |
          docker pull "\${IMAGE_URI}"

          docker run -d \\
            --name smoke-test \\
            -p 8000:8000 \\
            -e ENVIRONMENT=smoke-test \\
            -e LOG_LEVEL=warning \\
            "\${IMAGE_URI}"

          echo "Waiting for service to start..."
          for i in $(seq 1 30); do
            if curl -sf http://localhost:8000/health > /dev/null 2>&1; then
              echo "✓ Service is healthy"
              break
            fi
            if [ "$i" -eq 30 ]; then
              echo "::error::Service failed to start within 30 seconds"
              docker logs smoke-test
              exit 1
            fi
            sleep 1
          done

          # Health check
          HEALTH=$(curl -sf http://localhost:8000/health)
          echo "Health: \${HEALTH}"

          # Model info endpoint
          MODEL_INFO=$(curl -sf http://localhost:8000/model/info || echo '{}')
          echo "Model info: \${MODEL_INFO}"

          # Inference smoke test with sample payload
          RESPONSE=$(curl -sf -X POST http://localhost:8000/predict \\
            -H "Content-Type: application/json" \\
            -d '{"features": [0.1, 0.2, 0.3, 0.4, 0.5]}' || echo 'FAILED')

          if [ "\${RESPONSE}" = "FAILED" ]; then
            echo "::error::Inference smoke test failed"
            docker logs smoke-test
            exit 1
          fi

          echo "✓ Inference response: \${RESPONSE}"

          # Latency check (p99 should be under 500ms for production)
          for i in $(seq 1 10); do
            curl -sf -o /dev/null -w "%{time_total}\\n" -X POST http://localhost:8000/predict \\
              -H "Content-Type: application/json" \\
              -d '{"features": [0.1, 0.2, 0.3, 0.4, 0.5]}'
          done | awk '{sum+=$1; if($1>max)max=$1} END {
            printf "Avg latency: %.3fs, Max latency: %.3fs\\n", sum/NR, max;
            if(max > 0.5) { print "::warning::Max latency exceeds 500ms threshold" }
          }'

          docker stop smoke-test
          echo "✓ Pre-deploy smoke test passed"

  # -------------------------------------------------------------------
  # Deploy: canary rollout to production
  # -------------------------------------------------------------------
  deploy-canary:
    name: Deploy Canary (\${{ inputs.canary_percentage }}%)
    needs: [validate-model, build-production-image, pre-deploy-smoke-test]
    if: \${{ !inputs.skip_canary && inputs.rollback_version == '' }}
    runs-on: ubuntu-latest
    outputs:
      canary_task_def: \${{ steps.deploy-canary.outputs.task_definition_arn }}
    steps:
      - name: Checkout repository
        uses: actions/checkout@v4

      - name: Configure AWS credentials
        uses: aws-actions/configure-aws-credentials@v4
        with:
          role-to-assume: \${{ secrets.AWS_PROD_ROLE_ARN }}
          aws-region: \${{ env.AWS_REGION }}

      - name: Create GitHub deployment
        id: deployment
        uses: actions/github-script@v7
        with:
          script: |
            const deployment = await github.rest.repos.createDeployment({
              owner: context.repo.owner,
              repo: context.repo.repo,
              ref: context.sha,
              environment: 'production-canary',
              description: \`Canary deploy: \${{ inputs.model_name }} v\${{ inputs.model_version }} at \${{ inputs.canary_percentage }}%\`,
              auto_merge: false,
              required_contexts: [],
            });
            return deployment.data.id;

      - name: Update ECS task definition for canary
        id: deploy-canary
        env:
          IMAGE_URI: \${{ needs.build-production-image.outputs.image_uri }}
        run: |
          # Get current task definition
          CURRENT_TASK_DEF=$(aws ecs describe-services \\
            --cluster "\${ECS_CLUSTER}" \\
            --services "\${ECS_SERVICE_CANARY}" \\
            --query 'services[0].taskDefinition' \\
            --output text)

          TASK_DEF_JSON=$(aws ecs describe-task-definition \\
            --task-definition "\${CURRENT_TASK_DEF}" \\
            --query 'taskDefinition')

          # Update container image and environment variables
          NEW_TASK_DEF=$(echo "\${TASK_DEF_JSON}" | jq \\
            --arg IMAGE "\${IMAGE_URI}" \\
            --arg MODEL "\${{ inputs.model_name }}" \\
            --arg VERSION "\${{ inputs.model_version }}" \\
            --arg RUN_ID "\${{ needs.validate-model.outputs.model_run_id }}" \\
            '
            del(.taskDefinitionArn, .revision, .status, .requiresAttributes, .compatibilities, .registeredAt, .registeredBy) |
            .containerDefinitions[0].image = $IMAGE |
            .containerDefinitions[0].environment += [
              {"name": "MODEL_NAME", "value": $MODEL},
              {"name": "MODEL_VERSION", "value": $VERSION},
              {"name": "MLFLOW_RUN_ID", "value": $RUN_ID},
              {"name": "DEPLOYMENT_TYPE", "value": "canary"},
              {"name": "CANARY_WEIGHT", "value": "\${{ inputs.canary_percentage }}"}
            ]
            ')

          # Register new task definition
          NEW_TASK_DEF_ARN=$(aws ecs register-task-definition \\
            --cli-input-json "\${NEW_TASK_DEF}" \\
            --query 'taskDefinition.taskDefinitionArn' \\
            --output text)

          echo "task_definition_arn=\${NEW_TASK_DEF_ARN}" >> "$GITHUB_OUTPUT"

          # Update canary service
          aws ecs update-service \\
            --cluster "\${ECS_CLUSTER}" \\
            --service "\${ECS_SERVICE_CANARY}" \\
            --task-definition "\${NEW_TASK_DEF_ARN}" \\
            --force-new-deployment

          echo "✓ Canary service updated with task definition: \${NEW_TASK_DEF_ARN}"

      - name: Configure ALB traffic split
        run: |
          # Update target group weights for canary traffic split
          LISTENER_ARN=$(aws elbv2 describe-listeners \\
            --load-balancer-arn "\${{ secrets.PROD_ALB_ARN }}" \\
            --query 'Listeners[?Port==\`443\`].ListenerArn' \\
            --output text)

          CANARY_WEIGHT=\${{ inputs.canary_percentage }}
          STABLE_WEIGHT=$((100 - CANARY_WEIGHT))

          aws elbv2 modify-rule \\
            --rule-arn "\${{ secrets.PROD_LISTENER_RULE_ARN }}" \\
            --actions "[{
              \\"Type\\": \\"forward\\",
              \\"ForwardConfig\\": {
                \\"TargetGroups\\": [
                  {\\"TargetGroupArn\\": \\"\${{ secrets.PROD_TG_STABLE_ARN }}\\", \\"Weight\\": \${STABLE_WEIGHT}},
                  {\\"TargetGroupArn\\": \\"\${{ secrets.PROD_TG_CANARY_ARN }}\\", \\"Weight\\": \${CANARY_WEIGHT}}
                ]
              }
            }]"

          echo "✓ Traffic split configured: stable=\${STABLE_WEIGHT}%, canary=\${CANARY_WEIGHT}%"

      - name: Wait for canary service stability
        run: |
          echo "Waiting for canary service to stabilize..."
          aws ecs wait services-stable \\
            --cluster "\${ECS_CLUSTER}" \\
            --services "\${ECS_SERVICE_CANARY}"
          echo "✓ Canary service is stable"

  # -------------------------------------------------------------------
  # Monitor: watch canary metrics before promoting
  # -------------------------------------------------------------------
  monitor-canary:
    name: Monitor Canary (10 minutes)
    needs: [deploy-canary]
    if: \${{ !inputs.skip_canary && inputs.rollback_version == '' }}
    runs-on: ubuntu-latest
    steps:
      - name: Checkout repository
        uses: actions/checkout@v4

      - name: Configure AWS credentials
        uses: aws-actions/configure-aws-credentials@v4
        with:
          role-to-assume: \${{ secrets.AWS_PROD_ROLE_ARN }}
          aws-region: \${{ env.AWS_REGION }}

      - name: Install uv
        uses: astral-sh/setup-uv@v4
        with:
          version: "latest"

      - name: Set up Python
        run: uv python install 3.11

      - name: Install monitoring dependencies
        run: uv sync --frozen --group monitoring

      - name: Monitor canary health and metrics
        id: monitor
        run: |
          uv run python -c "
          import time
          import json
          import urllib.request
          import sys

          CANARY_URL = '\${{ env.PRODUCTION_URL }}'
          MONITOR_DURATION_SECONDS = 600  # 10 minutes
          CHECK_INTERVAL_SECONDS = 30
          ERROR_RATE_THRESHOLD = 0.05  # 5%
          LATENCY_P99_THRESHOLD_MS = 500

          total_checks = 0
          error_count = 0
          latencies = []
          start_time = time.time()

          print(f'Monitoring canary for {MONITOR_DURATION_SECONDS}s...')
          print(f'Error rate threshold: {ERROR_RATE_THRESHOLD*100}%')
          print(f'Latency p99 threshold: {LATENCY_P99_THRESHOLD_MS}ms')
          print()

          while time.time() - start_time < MONITOR_DURATION_SECONDS:
              elapsed = int(time.time() - start_time)
              total_checks += 1

              try:
                  req = urllib.request.Request(
                      f'{CANARY_URL}/health',
                      headers={'X-Canary-Check': 'true'}
                  )
                  t0 = time.time()
                  with urllib.request.urlopen(req, timeout=5) as resp:
                      latency_ms = (time.time() - t0) * 1000
                      latencies.append(latency_ms)
                      status = resp.status
                      if status != 200:
                          error_count += 1
              except Exception as e:
                  error_count += 1
                  print(f'  [{elapsed}s] Health check failed: {e}')

              # Calculate running metrics
              error_rate = error_count / total_checks if total_checks > 0 else 0
              sorted_lat = sorted(latencies) if latencies else [0]
              p99_idx = int(len(sorted_lat) * 0.99)
              p99_latency = sorted_lat[min(p99_idx, len(sorted_lat)-1)]

              if elapsed % 60 == 0 and elapsed > 0:
                  print(f'  [{elapsed}s] checks={total_checks} errors={error_count} '
                        f'error_rate={error_rate:.2%} p99={p99_latency:.0f}ms')

              # Early abort if error rate is too high
              if total_checks >= 10 and error_rate > ERROR_RATE_THRESHOLD:
                  print(f'::error::Canary error rate {error_rate:.2%} exceeds threshold {ERROR_RATE_THRESHOLD*100}%')
                  print('CANARY_FAILED=true')
                  sys.exit(1)

              if total_checks >= 10 and p99_latency > LATENCY_P99_THRESHOLD_MS:
                  print(f'::error::Canary p99 latency {p99_latency:.0f}ms exceeds threshold {LATENCY_P99_THRESHOLD_MS}ms')
                  sys.exit(1)

              time.sleep(CHECK_INTERVAL_SECONDS)

          # Final report
          error_rate = error_count / total_checks
          sorted_lat = sorted(latencies)
          p50 = sorted_lat[int(len(sorted_lat)*0.5)] if sorted_lat else 0
          p99 = sorted_lat[int(len(sorted_lat)*0.99)] if sorted_lat else 0

          print()
          print('=== Canary Monitoring Report ===')
          print(f'Duration: {MONITOR_DURATION_SECONDS}s')
          print(f'Total checks: {total_checks}')
          print(f'Errors: {error_count}')
          print(f'Error rate: {error_rate:.2%}')
          print(f'Latency p50: {p50:.0f}ms')
          print(f'Latency p99: {p99:.0f}ms')
          print(f'Status: PASSED ✓')
          "

      - name: Auto-rollback canary on failure
        if: failure()
        run: |
          echo "::error::Canary monitoring failed. Rolling back traffic to stable."

          # Set canary weight to 0
          LISTENER_ARN=$(aws elbv2 describe-listeners \\
            --load-balancer-arn "\${{ secrets.PROD_ALB_ARN }}" \\
            --query 'Listeners[?Port==\`443\`].ListenerArn' \\
            --output text)

          aws elbv2 modify-rule \\
            --rule-arn "\${{ secrets.PROD_LISTENER_RULE_ARN }}" \\
            --actions "[{
              \\"Type\\": \\"forward\\",
              \\"ForwardConfig\\": {
                \\"TargetGroups\\": [
                  {\\"TargetGroupArn\\": \\"\${{ secrets.PROD_TG_STABLE_ARN }}\\", \\"Weight\\": 100},
                  {\\"TargetGroupArn\\": \\"\${{ secrets.PROD_TG_CANARY_ARN }}\\", \\"Weight\\": 0}
                ]
              }
            }]"

          echo "✓ Traffic rolled back to stable (100%)"

  # -------------------------------------------------------------------
  # Promote: shift all traffic to new version
  # -------------------------------------------------------------------
  promote-to-production:
    name: Promote to Full Production
    needs: [validate-model, build-production-image, deploy-canary, monitor-canary]
    if: \${{ !inputs.skip_canary && inputs.rollback_version == '' }}
    runs-on: ubuntu-latest
    steps:
      - name: Configure AWS credentials
        uses: aws-actions/configure-aws-credentials@v4
        with:
          role-to-assume: \${{ secrets.AWS_PROD_ROLE_ARN }}
          aws-region: \${{ env.AWS_REGION }}

      - name: Update stable service with new image
        env:
          IMAGE_URI: \${{ needs.build-production-image.outputs.image_uri }}
        run: |
          # Get current stable task definition
          CURRENT_TASK_DEF=$(aws ecs describe-services \\
            --cluster "\${ECS_CLUSTER}" \\
            --services "\${ECS_SERVICE}" \\
            --query 'services[0].taskDefinition' \\
            --output text)

          TASK_DEF_JSON=$(aws ecs describe-task-definition \\
            --task-definition "\${CURRENT_TASK_DEF}" \\
            --query 'taskDefinition')

          NEW_TASK_DEF=$(echo "\${TASK_DEF_JSON}" | jq \\
            --arg IMAGE "\${IMAGE_URI}" \\
            --arg MODEL "\${{ inputs.model_name }}" \\
            --arg VERSION "\${{ inputs.model_version }}" \\
            --arg RUN_ID "\${{ needs.validate-model.outputs.model_run_id }}" \\
            '
            del(.taskDefinitionArn, .revision, .status, .requiresAttributes, .compatibilities, .registeredAt, .registeredBy) |
            .containerDefinitions[0].image = $IMAGE |
            .containerDefinitions[0].environment += [
              {"name": "MODEL_NAME", "value": $MODEL},
              {"name": "MODEL_VERSION", "value": $VERSION},
              {"name": "MLFLOW_RUN_ID", "value": $RUN_ID},
              {"name": "DEPLOYMENT_TYPE", "value": "stable"}
            ]
            ')

          NEW_TASK_DEF_ARN=$(aws ecs register-task-definition \\
            --cli-input-json "\${NEW_TASK_DEF}" \\
            --query 'taskDefinition.taskDefinitionArn' \\
            --output text)

          aws ecs update-service \\
            --cluster "\${ECS_CLUSTER}" \\
            --service "\${ECS_SERVICE}" \\
            --task-definition "\${NEW_TASK_DEF_ARN}" \\
            --force-new-deployment

          echo "✓ Stable service updated: \${NEW_TASK_DEF_ARN}"

      - name: Wait for stable service deployment
        run: |
          echo "Waiting for stable service to stabilize..."
          aws ecs wait services-stable \\
            --cluster "\${ECS_CLUSTER}" \\
            --services "\${ECS_SERVICE}"
          echo "✓ Stable service is running"

      - name: Shift all traffic to stable
        run: |
          aws elbv2 modify-rule \\
            --rule-arn "\${{ secrets.PROD_LISTENER_RULE_ARN }}" \\
            --actions "[{
              \\"Type\\": \\"forward\\",
              \\"ForwardConfig\\": {
                \\"TargetGroups\\": [
                  {\\"TargetGroupArn\\": \\"\${{ secrets.PROD_TG_STABLE_ARN }}\\", \\"Weight\\": 100},
                  {\\"TargetGroupArn\\": \\"\${{ secrets.PROD_TG_CANARY_ARN }}\\", \\"Weight\\": 0}
                ]
              }
            }]"

          echo "✓ All traffic shifted to stable (100%)"

  # -------------------------------------------------------------------
  # Direct deploy: skip canary (emergency or skip_canary flag)
  # -------------------------------------------------------------------
  direct-deploy:
    name: Direct Deploy (Skip Canary)
    needs: [validate-model, build-production-image, pre-deploy-smoke-test]
    if: \${{ inputs.skip_canary && inputs.rollback_version == '' }}
    runs-on: ubuntu-latest
    steps:
      - name: Configure AWS credentials
        uses: aws-actions/configure-aws-credentials@v4
        with:
          role-to-assume: \${{ secrets.AWS_PROD_ROLE_ARN }}
          aws-region: \${{ env.AWS_REGION }}

      - name: Deploy directly to stable service
        env:
          IMAGE_URI: \${{ needs.build-production-image.outputs.image_uri }}
        run: |
          echo "::warning::Deploying directly without canary. Ensure this is intentional."

          CURRENT_TASK_DEF=$(aws ecs describe-services \\
            --cluster "\${ECS_CLUSTER}" \\
            --services "\${ECS_SERVICE}" \\`,

  '.github/workflows/deploy-staging.yml': `name: Deploy Staging

on:
  push:
    branches: [main]
  workflow_dispatch:
    inputs:
      force_deploy:
        description: "Force deployment even if no model changes"
        required: false
        default: "false"
        type: boolean

concurrency:
  group: deploy-staging
  cancel-in-progress: false

env:
  AWS_REGION: us-east-1
  ECR_REPOSITORY: ml-pipeline/serving
  ECS_CLUSTER: ml-pipeline-staging
  ECS_SERVICE: model-serving-staging
  ECS_TASK_DEFINITION: .aws/task-definition-staging.json
  CONTAINER_NAME: model-serving
  MLFLOW_TRACKING_URI: \${{ secrets.MLFLOW_TRACKING_URI_STAGING }}
  DOCKER_BUILDKIT: 1

permissions:
  contents: read
  id-token: write
  packages: write

jobs:
  lint-and-typecheck:
    name: Lint & Type Check
    runs-on: ubuntu-latest
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Install uv
        uses: astral-sh/setup-uv@v4
        with:
          version: "latest"

      - name: Set up Python
        run: uv python install 3.11

      - name: Install dependencies
        run: uv sync --frozen

      - name: Ruff lint
        run: uv run ruff check src/ tests/ scripts/

      - name: Ruff format check
        run: uv run ruff format --check src/ tests/ scripts/

      - name: Mypy type check
        run: uv run mypy src/

  test:
    name: Unit & Integration Tests
    runs-on: ubuntu-latest
    services:
      postgres:
        image: postgres:15
        env:
          POSTGRES_USER: mlpipeline
          POSTGRES_PASSWORD: testpassword
          POSTGRES_DB: mlpipeline_test
        ports:
          - 5432:5432
        options: >-
          --health-cmd pg_isready
          --health-interval 10s
          --health-timeout 5s
          --health-retries 5
      redis:
        image: redis:7-alpine
        ports:
          - 6379:6379
        options: >-
          --health-cmd "redis-cli ping"
          --health-interval 10s
          --health-timeout 5s
          --health-retries 5
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Install uv
        uses: astral-sh/setup-uv@v4
        with:
          version: "latest"

      - name: Set up Python
        run: uv python install 3.11

      - name: Install dependencies
        run: uv sync --frozen

      - name: Run unit tests
        env:
          DATABASE_URL: postgresql://mlpipeline:testpassword@localhost:5432/mlpipeline_test
          REDIS_URL: redis://localhost:6379/0
        run: |
          uv run pytest tests/unit/ \\
            --cov=src \\
            --cov-report=xml \\
            --cov-fail-under=75 \\
            -x -q

      - name: Run integration tests
        env:
          DATABASE_URL: postgresql://mlpipeline:testpassword@localhost:5432/mlpipeline_test
          REDIS_URL: redis://localhost:6379/0
        run: |
          uv run pytest tests/integration/ \\
            -x -q \\
            --timeout=120

      - name: Run serving API tests
        env:
          DATABASE_URL: postgresql://mlpipeline:testpassword@localhost:5432/mlpipeline_test
          REDIS_URL: redis://localhost:6379/0
        run: |
          uv run pytest tests/integration/test_serving*.py \\
            -x -q \\
            --timeout=60

  train-smoke-test:
    name: Training Smoke Test
    runs-on: ubuntu-latest
    needs: [lint-and-typecheck, test]
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Install uv
        uses: astral-sh/setup-uv@v4
        with:
          version: "latest"

      - name: Set up Python
        run: uv python install 3.11

      - name: Install dependencies
        run: uv sync --frozen

      - name: Run training smoke test
        env:
          MLFLOW_TRACKING_URI: sqlite:///mlflow_smoke.db
        run: |
          uv run python scripts/train_smoke_test.py \\
            --config configs/smoke_test.yaml \\
            --max-epochs 2 \\
            --max-samples 100

      - name: Verify model artifact
        run: |
          uv run python -c "
          import torch
          import glob
          artifacts = glob.glob('artifacts/smoke_test/*.pt')
          assert len(artifacts) > 0, 'No model artifacts produced'
          model_state = torch.load(artifacts[0], map_location='cpu', weights_only=True)
          print(f'Smoke test model loaded: {len(model_state)} parameter tensors')
          "

  build-and-push:
    name: Build & Push Docker Image
    runs-on: ubuntu-latest
    needs: [lint-and-typecheck, test, train-smoke-test]
    outputs:
      image_uri: \${{ steps.build.outputs.image_uri }}
      image_tag: \${{ steps.meta.outputs.version }}
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Configure AWS credentials
        uses: aws-actions/configure-aws-credentials@v4
        with:
          role-to-assume: \${{ secrets.AWS_DEPLOY_ROLE_ARN_STAGING }}
          aws-region: \${{ env.AWS_REGION }}

      - name: Login to Amazon ECR
        id: ecr-login
        uses: aws-actions/amazon-ecr-login@v2

      - name: Generate image metadata
        id: meta
        run: |
          SHA_SHORT=$(git rev-parse --short HEAD)
          TIMESTAMP=$(date +%Y%m%d%H%M%S)
          VERSION="staging-\${SHA_SHORT}-\${TIMESTAMP}"
          echo "version=\${VERSION}" >> "$GITHUB_OUTPUT"
          echo "sha_short=\${SHA_SHORT}" >> "$GITHUB_OUTPUT"

      - name: Build and push Docker image
        id: build
        env:
          ECR_REGISTRY: \${{ steps.ecr-login.outputs.registry }}
          IMAGE_TAG: \${{ steps.meta.outputs.version }}
        run: |
          IMAGE_URI="\${ECR_REGISTRY}/\${ECR_REPOSITORY}:\${IMAGE_TAG}"
          
          docker build \\
            --file Dockerfile.serving \\
            --build-arg PYTHON_VERSION=3.11 \\
            --build-arg BUILD_DATE=$(date -u +"%Y-%m-%dT%H:%M:%SZ") \\
            --build-arg GIT_SHA=\${{ steps.meta.outputs.sha_short }} \\
            --build-arg ENVIRONMENT=staging \\
            --tag "\${IMAGE_URI}" \\
            --tag "\${ECR_REGISTRY}/\${ECR_REPOSITORY}:staging-latest" \\
            --cache-from "\${ECR_REGISTRY}/\${ECR_REPOSITORY}:staging-latest" \\
            .
          
          docker push "\${IMAGE_URI}"
          docker push "\${ECR_REGISTRY}/\${ECR_REPOSITORY}:staging-latest"
          
          echo "image_uri=\${IMAGE_URI}" >> "$GITHUB_OUTPUT"

      - name: Scan image for vulnerabilities
        uses: aquasecurity/trivy-action@master
        with:
          image-ref: \${{ steps.build.outputs.image_uri }}
          format: "sarif"
          output: "trivy-results.sarif"
          severity: "CRITICAL,HIGH"
          exit-code: "1"

      - name: Upload scan results
        if: always()
        uses: github/codeql-action/upload-sarif@v3
        with:
          sarif_file: "trivy-results.sarif"

  fetch-model:
    name: Fetch Production Model from Registry
    runs-on: ubuntu-latest
    needs: [build-and-push]
    outputs:
      model_version: \${{ steps.fetch.outputs.model_version }}
      model_name: \${{ steps.fetch.outputs.model_name }}
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Configure AWS credentials
        uses: aws-actions/configure-aws-credentials@v4
        with:
          role-to-assume: \${{ secrets.AWS_DEPLOY_ROLE_ARN_STAGING }}
          aws-region: \${{ env.AWS_REGION }}

      - name: Install uv
        uses: astral-sh/setup-uv@v4
        with:
          version: "latest"

      - name: Set up Python
        run: uv python install 3.11

      - name: Install dependencies
        run: uv sync --frozen --only-group mlflow

      - name: Fetch latest staging model
        id: fetch
        env:
          MLFLOW_TRACKING_URI: \${{ secrets.MLFLOW_TRACKING_URI_STAGING }}
          AWS_DEFAULT_REGION: \${{ env.AWS_REGION }}
        run: |
          MODEL_INFO=$(uv run python scripts/fetch_model_version.py \\
            --stage staging \\
            --output json)
          
          MODEL_NAME=$(echo "$MODEL_INFO" | jq -r '.name')
          MODEL_VERSION=$(echo "$MODEL_INFO" | jq -r '.version')
          
          echo "model_name=\${MODEL_NAME}" >> "$GITHUB_OUTPUT"
          echo "model_version=\${MODEL_VERSION}" >> "$GITHUB_OUTPUT"
          echo "::notice::Deploying model \${MODEL_NAME} version \${MODEL_VERSION} to staging"

  deploy-staging:
    name: Deploy to Staging
    runs-on: ubuntu-latest
    needs: [build-and-push, fetch-model]
    environment:
      name: staging
      url: \${{ steps.deploy.outputs.service_url }}
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Configure AWS credentials
        uses: aws-actions/configure-aws-credentials@v4
        with:
          role-to-assume: \${{ secrets.AWS_DEPLOY_ROLE_ARN_STAGING }}
          aws-region: \${{ env.AWS_REGION }}

      - name: Update ECS task definition
        id: task-def
        uses: aws-actions/amazon-ecs-render-task-definition@v1
        with:
          task-definition: \${{ env.ECS_TASK_DEFINITION }}
          container-name: \${{ env.CONTAINER_NAME }}
          image: \${{ needs.build-and-push.outputs.image_uri }}
          environment-variables: |
            ENVIRONMENT=staging
            MLFLOW_TRACKING_URI=\${{ secrets.MLFLOW_TRACKING_URI_STAGING }}
            MODEL_NAME=\${{ needs.fetch-model.outputs.model_name }}
            MODEL_VERSION=\${{ needs.fetch-model.outputs.model_version }}
            DATABASE_URL=\${{ secrets.DATABASE_URL_STAGING }}
            REDIS_URL=\${{ secrets.REDIS_URL_STAGING }}
            LOG_LEVEL=INFO
            ENABLE_METRICS=true
            METRICS_PORT=9090
            MAX_BATCH_SIZE=32
            INFERENCE_TIMEOUT_SECONDS=30
            GDPR_ANONYMIZE_LOGS=true

      - name: Deploy to ECS
        id: deploy
        uses: aws-actions/amazon-ecs-deploy-task-definition@v2
        with:
          task-definition: \${{ steps.task-def.outputs.task-definition }}
          service: \${{ env.ECS_SERVICE }}
          cluster: \${{ env.ECS_CLUSTER }}
          wait-for-service-stability: true
          wait-for-minutes: 10

      - name: Get service URL
        id: service-url
        run: |
          SERVICE_URL=$(aws ecs describe-services \\
            --cluster \${{ env.ECS_CLUSTER }} \\
            --services \${{ env.ECS_SERVICE }} \\
            --query 'services[0].loadBalancers[0].targetGroupArn' \\
            --output text)
          
          ALB_DNS=$(aws elbv2 describe-target-groups \\
            --target-group-arns "\${SERVICE_URL}" \\
            --query 'TargetGroups[0].LoadBalancerArns[0]' \\
            --output text | xargs -I {} aws elbv2 describe-load-balancers \\
            --load-balancer-arns {} \\
            --query 'LoadBalancers[0].DNSName' \\
            --output text)
          
          echo "service_url=https://\${ALB_DNS}" >> "$GITHUB_OUTPUT"

  verify-deployment:
    name: Verify Staging Deployment
    runs-on: ubuntu-latest
    needs: [deploy-staging, fetch-model]
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Configure AWS credentials
        uses: aws-actions/configure-aws-credentials@v4
        with:
          role-to-assume: \${{ secrets.AWS_DEPLOY_ROLE_ARN_STAGING }}
          aws-region: \${{ env.AWS_REGION }}

      - name: Wait for service readiness
        run: |
          STAGING_URL="\${{ secrets.STAGING_API_URL }}"
          echo "Waiting for staging service at \${STAGING_URL}..."
          
          for i in $(seq 1 30); do
            HTTP_CODE=$(curl -s -o /dev/null -w "%{http_code}" \\
              "\${STAGING_URL}/health" \\
              --max-time 10 || echo "000")
            
            if [ "$HTTP_CODE" = "200" ]; then
              echo "Service is healthy (attempt \${i})"
              break
            fi
            
            if [ "$i" = "30" ]; then
              echo "::error::Service failed to become healthy after 30 attempts"
              exit 1
            fi
            
            echo "Attempt \${i}: HTTP \${HTTP_CODE}, retrying in 10s..."
            sleep 10
          done

      - name: Verify health endpoint
        run: |
          STAGING_URL="\${{ secrets.STAGING_API_URL }}"
          
          HEALTH=$(curl -sf "\${STAGING_URL}/health" --max-time 15)
          echo "Health response: \${HEALTH}"
          
          STATUS=$(echo "$HEALTH" | jq -r '.status')
          MODEL_LOADED=$(echo "$HEALTH" | jq -r '.model_loaded')
          
          if [ "$STATUS" != "healthy" ]; then
            echo "::error::Service status is '\${STATUS}', expected 'healthy'"
            exit 1
          fi
          
          if [ "$MODEL_LOADED" != "true" ]; then
            echo "::error::Model not loaded in serving container"
            exit 1
          fi

      - name: Verify model version
        run: |
          STAGING_URL="\${{ secrets.STAGING_API_URL }}"
          EXPECTED_VERSION="\${{ needs.fetch-model.outputs.model_version }}"
          
          MODEL_INFO=$(curl -sf "\${STAGING_URL}/model/info" --max-time 15)
          DEPLOYED_VERSION=$(echo "$MODEL_INFO" | jq -r '.model_version')
          
          echo "Expected model version: \${EXPECTED_VERSION}"
          echo "Deployed model version: \${DEPLOYED_VERSION}"
          
          if [ "$DEPLOYED_VERSION" != "$EXPECTED_VERSION" ]; then
            echo "::error::Model version mismatch: expected \${EXPECTED_VERSION}, got \${DEPLOYED_VERSION}"
            exit 1
          fi

      - name: Run inference smoke test
        run: |
          STAGING_URL="\${{ secrets.STAGING_API_URL }}"
          
          # Single prediction test
          RESPONSE=$(curl -sf "\${STAGING_URL}/predict" \\
            --max-time 30 \\
            -H "Content-Type: application/json" \\
            -d '{"features": [0.1, 0.2, 0.3, 0.4, 0.5]}')
          
          echo "Prediction response: \${RESPONSE}"
          
          HAS_PREDICTION=$(echo "$RESPONSE" | jq 'has("prediction")')
          if [ "$HAS_PREDICTION" != "true" ]; then
            echo "::error::Prediction response missing 'prediction' field"
            exit 1
          fi
          
          # Batch prediction test
          BATCH_RESPONSE=$(curl -sf "\${STAGING_URL}/predict/batch" \\
            --max-time 60 \\
            -H "Content-Type: application/json" \\
            -d '{"instances": [
              {"features": [0.1, 0.2, 0.3, 0.4, 0.5]},
              {"features": [0.5, 0.4, 0.3, 0.2, 0.1]}
            ]}')
          
          echo "Batch response: \${BATCH_RESPONSE}"
          
          BATCH_COUNT=$(echo "$BATCH_RESPONSE" | jq '.predictions | length')
          if [ "$BATCH_COUNT" != "2" ]; then
            echo "::error::Batch prediction returned \${BATCH_COUNT} results, expected 2"
            exit 1
          fi

      - name: Verify Prometheus metrics endpoint
        run: |
          STAGING_URL="\${{ secrets.STAGING_API_URL }}"
          
          METRICS=$(curl -sf "\${STAGING_URL}/metrics" --max-time 15)
          
          if ! echo "$METRICS" | grep -q "model_inference_duration_seconds"; then
            echo "::error::Missing inference duration metric"
            exit 1
          fi
          
          if ! echo "$METRICS" | grep -q "model_predictions_total"; then
            echo "::error::Missing predictions counter metric"
            exit 1
          fi
          
          echo "Metrics endpoint verified"

      - name: Check GDPR compliance headers
        run: |
          STAGING_URL="\${{ secrets.STAGING_API_URL }}"
          
          HEADERS=$(curl -sI "\${STAGING_URL}/health" --max-time 15)
          
          if ! echo "$HEADERS" | grep -qi "X-Data-Processing-Purpose"; then
            echo "::warning::Missing X-Data-Processing-Purpose header (GDPR)"
          fi
          
          echo "GDPR header check complete"

  notify:
    name: Notify Deployment Status
    runs-on: ubuntu-latest
    needs: [build-and-push, fetch-model, deploy-staging, verify-deployment]
    if: always()
    steps:
      - name: Determine status
        id: status
        run: |
          if [ "\${{ needs.verify-deployment.result }}" = "success" ]; then
            echo "status=success" >> "$GITHUB_OUTPUT"
            echo "emoji=✅" >> "$GITHUB_OUTPUT"
            echo "color=good" >> "$GITHUB_OUTPUT"
          else
            echo "status=failure" >> "$GITHUB_OUTPUT"
            echo "emoji=❌" >> "$GITHUB_OUTPUT"
            echo "color=danger" >> "$GITHUB_OUTPUT"
          fi

      - name: Notify Slack
        if: always()
        uses: slackapi/slack-github-action@v1.27.0
        with:
          payload: |
            {
              "channel": "\${{ secrets.SLACK_DEPLOY_CHANNEL }}",
              "text": "\${{ steps.status.outputs.emoji }} Staging deployment \${{ steps.status.outputs.status }}",
              "attachments": [
                {
                  "color": "\${{ steps.status.outputs.color }}",
                  "fields": [
                    {
                      "title": "Environment",
                      "value": "Staging",
                      "short": true
                    },
                    {
                      "title": "Image",
                      "value": "\`\${{ needs.build-and-push.outputs.image_tag }}\`",
                      "short": true
                    },
                    {
                      "title": "Model",
                      "value": "\${{ needs.fetch-model.outputs.model_name }} v\${{ needs.fetch-model.outputs.model_version }}",
                      "short": true
                    },
                    {
                      "title": "Commit",
                      "value": "<\${{ github.server_url }}/\${{ github.repository }}/commit/\${{ github.sha }}|\${{ github.sha }}>",
                      "short": true
                    },
                    {
                      "title": "Triggered by",
                      "value": "\${{ github.actor }}",
                      "short": true
                    },
                    {
                      "title": "Workflow",
                      "value": "<\${{ github.server_url }}/\${{ github.repository }}/actions/runs/\${{ github.run_id }}|View Run>",
                      "short": true
                    }
                  ]
                }
              ]
            }
        env:
          SLACK_WEBHOOK_URL: \${{ secrets.SLACK_WEBHOOK_URL }}
          SLACK_WEBHOOK_TYPE: INCOMING_WEBHOOK`,

  '.gitignore': `# =============================================================================
# Python ML Pipeline - .gitignore
# =============================================================================

# -----------------------------------------------------------------------------
# Python
# -----------------------------------------------------------------------------
__pycache__/
*.py[cod]
*$py.class
*.so
*.egg
*.egg-info/
dist/
build/
eggs/
*.whl
pip-wheel-metadata/
*.manifest
*.spec

# -----------------------------------------------------------------------------
# Virtual Environments
# -----------------------------------------------------------------------------
.venv/
venv/
ENV/
env/
.python-version

# -----------------------------------------------------------------------------
# uv
# -----------------------------------------------------------------------------
# Lock file is committed; caches are not
.uv/

# -----------------------------------------------------------------------------
# Data (DVC-tracked — raw data never committed to git)
# -----------------------------------------------------------------------------
data/raw/
data/processed/
data/features/
data/external/
data/interim/
*.csv
*.parquet
*.arrow
*.h5
*.hdf5
*.pkl
*.pickle
*.feather
*.tfrecord
!data/.gitkeep
!data/raw/.gitkeep
!data/processed/.gitkeep
!data/features/.gitkeep

# -----------------------------------------------------------------------------
# Model Artifacts (DVC-tracked)
# -----------------------------------------------------------------------------
models/*.pt
models/*.pth
models/*.onnx
models/*.bin
models/*.safetensors
models/checkpoints/
models/exported/
!models/.gitkeep

# -----------------------------------------------------------------------------
# DVC
# -----------------------------------------------------------------------------
# DVC cache and temp files (tracked data referenced via .dvc files)
.dvc/cache/
.dvc/tmp/
.dvc/plots/
*.dvc.lock

# -----------------------------------------------------------------------------
# MLflow
# -----------------------------------------------------------------------------
mlruns/
mlartifacts/
mlflow.db

# -----------------------------------------------------------------------------
# Jupyter Notebooks
# -----------------------------------------------------------------------------
notebooks/.ipynb_checkpoints/
*.ipynb_checkpoints/
notebooks/output/
notebooks/figures/

# -----------------------------------------------------------------------------
# IDE / Editor
# -----------------------------------------------------------------------------
.vscode/
.idea/
*.swp
*.swo
*~
.project
.settings/
.classpath

# -----------------------------------------------------------------------------
# OS
# -----------------------------------------------------------------------------
.DS_Store
Thumbs.db
Desktop.ini
*.lnk

# -----------------------------------------------------------------------------
# Environment & Secrets
# -----------------------------------------------------------------------------
.env
.env.*
!.env.example
*.pem
*.key
secrets/
credentials/

# -----------------------------------------------------------------------------
# Docker
# -----------------------------------------------------------------------------
docker-compose.override.yml

# -----------------------------------------------------------------------------
# Terraform
# -----------------------------------------------------------------------------
.terraform/
*.tfstate
*.tfstate.*
*.tfvars
!*.tfvars.example
crash.log

# -----------------------------------------------------------------------------
# Testing & Coverage
# -----------------------------------------------------------------------------
.pytest_cache/
.coverage
.coverage.*
htmlcov/
coverage.xml
*.cover
.hypothesis/
.mypy_cache/
.ruff_cache/
.dmypy.json
dmypy.json

# -----------------------------------------------------------------------------
# Build & Distribution
# -----------------------------------------------------------------------------
*.log
*.tmp
*.bak
tmp/
temp/

# -----------------------------------------------------------------------------
# GPU / CUDA
# -----------------------------------------------------------------------------
*.nv/
cuda-memcheck.log

# -----------------------------------------------------------------------------
# Weights & Biases (if ever used alongside MLflow)
# -----------------------------------------------------------------------------
wandb/

# -----------------------------------------------------------------------------
# Misc
# -----------------------------------------------------------------------------
*.zip
*.tar.gz
*.tgz
*.rar
# Large files that should go through DVC
*.sqlite
*.db
!mlflow.db`,

  '.mcp.json': `{
  "mcpServers": {
    "github": {
      "command": "npx",
      "args": [
        "-y",
        "@modelcontextprotocol/server-github"
      ],
      "env": {
        "GITHUB_PERSONAL_ACCESS_TOKEN": "\${GITHUB_TOKEN}"
      },
      "description": "GitHub Issues, PRs, and repository operations for ml-pipeline"
    },
    "slack": {
      "command": "npx",
      "args": [
        "-y",
        "@modelcontextprotocol/server-slack"
      ],
      "env": {
        "SLACK_BOT_TOKEN": "\${SLACK_BOT_TOKEN}",
        "SLACK_TEAM_ID": "\${SLACK_TEAM_ID}"
      },
      "description": "Slack integration for team notifications and experiment alerts"
    },
    "postgres": {
      "command": "npx",
      "args": [
        "-y",
        "@modelcontextprotocol/server-postgres",
        "\${MLFLOW_BACKEND_STORE_URI}"
      ],
      "description": "PostgreSQL access for MLflow backend store and pipeline metadata"
    },
    "filesystem": {
      "command": "npx",
      "args": [
        "-y",
        "@modelcontextprotocol/server-filesystem",
        "./src",
        "./configs",
        "./tests",
        "./scripts",
        "./docs",
        "./notebooks"
      ],
      "description": "Filesystem access scoped to source, configs, tests, scripts, docs, and notebooks — excludes data/ and models/ (DVC-tracked) and configs/production/** (sensitive)"
    },
    "memory": {
      "command": "npx",
      "args": [
        "-y",
        "@modelcontextprotocol/server-memory"
      ],
      "description": "Persistent memory for tracking experiment context, model architecture decisions, and pipeline state across sessions"
    },
    "fetch": {
      "command": "npx",
      "args": [
        "-y",
        "@modelcontextprotocol/server-fetch"
      ],
      "description": "HTTP fetch for accessing MLflow tracking server API, Prometheus metrics, and Grafana dashboards"
    },
    "notion": {
      "command": "npx",
      "args": [
        "-y",
        "@modelcontextprotocol/server-notion"
      ],
      "env": {
        "NOTION_API_KEY": "\${NOTION_API_KEY}"
      },
      "description": "Notion integration for experiment documentation, architecture decisions, and runbooks"
    },
    "aws": {
      "command": "npx",
      "args": [
        "-y",
        "@modelcontextprotocol/server-aws"
      ],
      "env": {
        "AWS_PROFILE": "\${AWS_PROFILE:-ml-pipeline}",
        "AWS_REGION": "\${AWS_REGION:-us-east-1}"
      },
      "description": "AWS operations for S3 (DVC remote, MLflow artifacts), ECR, ECS, SageMaker, and EC2 GPU instances"
    }
  }
}`,

  'CLAUDE.md': `# CLAUDE.md — Project Intelligence

## Project Overview

ml-pipeline is an end-to-end ML pipeline: PyTorch training, MLflow experiment tracking, DVC data versioning, FastAPI model serving. Deployed on AWS with GPU-accelerated training.

## Quick Commands

\`\`\`bash
# Package management (always use uv, never pip)
uv sync                          # Install dependencies
uv add <package>                 # Add dependency (pin version in pyproject.toml)
uv run pytest                    # Run tests
uv run ruff check src/ tests/   # Lint
uv run ruff format src/ tests/  # Format
uv run mypy src/                 # Type check (strict mode)

# ML pipeline
dvc repro                        # Run full DVC pipeline (data → features → train → evaluate)
dvc push                         # Push data/model artifacts to S3
dvc pull                         # Pull data/model artifacts from S3
mlflow ui                        # Launch experiment tracking UI (localhost:5000)

# Serving
uv run uvicorn src.serving.app:app --reload  # Local API server
uv run pytest tests/ -m "not integration"    # Unit tests only
uv run pytest tests/ -m integration           # Integration tests only

# Docker
docker build -t ml-pipeline .
docker compose up                # Full stack: API + MLflow + PostgreSQL + Redis
\`\`\`

## Architecture

\`\`\`
Data (S3/DVC) → Feature Engineering → Training (PyTorch/GPU) → Evaluation → Model Registry (MLflow) → Serving (FastAPI)
\`\`\`

- **Pipeline orchestration**: DVC (\`dvc.yaml\` defines the DAG)
- **Experiment configs**: YAML files in \`configs/\` validated by Pydantic models
- **Model artifacts**: DVC-tracked in \`models/\`, registered in MLflow Model Registry
- **Feature store**: Redis-backed for low-latency serving features
- **Metadata**: PostgreSQL (MLflow backend store, pipeline metadata)

## Directory Conventions

| Directory | Purpose | Rules |
|---|---|---|
| \`src/data/\` | Data loading, preprocessing, feature engineering | Pure functions preferred, Pydantic schemas for data validation |
| \`src/models/\` | PyTorch \`nn.Module\` classes | One model architecture per file, max 300 lines |
| \`src/training/\` | Training loops, HP tuning, callbacks | All runs logged to MLflow, configs from YAML |
| \`src/evaluation/\` | Metrics, comparison, visualization | Deterministic evaluation, results logged to MLflow |
| \`src/serving/\` | FastAPI app, inference pipeline | Async endpoints, Pydantic request/response models |
| \`src/utils/\` | Shared utilities, logging, config loading | No ML-specific logic here |
| \`configs/\` | YAML experiment configs | Validated by Pydantic, never hardcode hyperparameters |
| \`notebooks/\` | Exploration only | **Never production code** — extract to \`src/\` before merging |
| \`data/\` | DVC-tracked raw/processed/features | **Never commit data to git** — \`.gitignore\`'d, DVC-tracked |
| \`models/\` | DVC-tracked model checkpoints | **Never commit model files to git** |
| \`scripts/\` | CLI scripts for training, deployment | Entry points, thin wrappers around \`src/\` |

## Coding Standards

- **Type hints required** on all public functions — mypy strict mode enforced
- **snake_case** for files and functions, **PascalCase** for classes, **SCREAMING_SNAKE_CASE** for constants
- **Max 300 lines per file** — split into modules if larger
- **Pydantic** for all config validation and API schemas — no raw dicts for configuration
- **Pin all dependency versions** in \`pyproject.toml\`
- **ruff** for linting and formatting (replaces flake8, isort, black)
- **Conventional commits**: \`feat:\`, \`fix:\`, \`chore:\`, \`docs:\`, \`experiment:\`
- **Branch naming**: \`type/ticket-desc\` (e.g., \`feat/ML-42-add-transformer-model\`)

## ML-Specific Patterns

### Experiment Tracking
- Every training run MUST log to MLflow: params, metrics, artifacts, model
- Use config YAML as the single source of truth for experiment parameters
- Tag experiments with git commit hash for reproducibility
- Never hardcode hyperparameters in training code — always load from config

### Data Pipeline
- DVC pipeline stages defined in \`dvc.yaml\` — run with \`dvc repro\`
- Raw data → processed data → features → training → evaluation
- Data schemas validated with Pydantic before pipeline stages
- Feature engineering is deterministic and versioned

### Model Management
- Models registered in MLflow Model Registry with stage transitions (Staging → Production)
- Model checkpointing during training — save best and last checkpoints
- Model signatures logged with MLflow for input/output validation
- A/B testing infrastructure in serving layer for model comparison

### Reproducibility
- Random seeds set in config and passed through entire pipeline
- Environment captured: Python version, package versions, CUDA version
- DVC ensures data version matches code version

## Sensitive Paths — Extra Caution Required

- \`configs/production/**\` — Production model and serving configs, review carefully
- \`models/**\` — Model artifacts, verify integrity and provenance
- \`.env*\` — Secrets, API keys, connection strings — **never commit**
- \`data/**\` — May contain PII, GDPR compliance required

## Compliance

- **SOC 2**: Audit trail for model deployments, access controls on model registry, signed artifacts
- **GDPR**: Data anonymization in preprocessing, consent tracking, right-to-deletion support in data pipeline, no PII in MLflow logs or model artifacts

## CI/CD Pipeline

Lint → Type Check → Unit Tests → Integration Tests → Build Docker → Train Smoke Test → Deploy Staging (auto) → Deploy Production (manual approval)

- Tests must pass with ≥75% coverage
- AI-generated code flagged with \`# AI-generated\` comment
- CODEOWNERS enforced — ML model changes require lead review

## What NOT to Do

- Don't use \`pip install\` — use \`uv add\` / \`uv sync\`
- Don't put production logic in notebooks — extract to \`src/\`
- Don't commit data or model files to git — use DVC
- Don't hardcode hyperparameters — use config YAML + Pydantic
- Don't skip MLflow logging in training code
- Don't store PII in experiment logs or model artifacts
- Don't merge without type checking passing (\`uv run mypy src/\`)

## Cross-References

- See \`.claude/settings.json\` for Claude Code tool permissions
- See \`playbook/\` for development methodology phases
- See \`plugin/codeforge-ml-pipeline/\` for custom agents and commands
- See \`docs/\` for architecture decisions and runbooks
- See \`dvc.yaml\` for pipeline DAG definition
- See \`configs/README.md\` for experiment config schema documentation`,

  'README.md': `# ml-pipeline

[![CI](https://github.com/your-org/ml-pipeline/actions/workflows/ci.yml/badge.svg)](https://github.com/your-org/ml-pipeline/actions/workflows/ci.yml)
[![Deploy Staging](https://github.com/your-org/ml-pipeline/actions/workflows/deploy-staging.yml/badge.svg)](https://github.com/your-org/ml-pipeline/actions/workflows/deploy-staging.yml)
[![Deploy Production](https://github.com/your-org/ml-pipeline/actions/workflows/deploy-production.yml/badge.svg)](https://github.com/your-org/ml-pipeline/actions/workflows/deploy-production.yml)
[![Coverage](https://img.shields.io/badge/coverage-75%25+-brightgreen)](https://github.com/your-org/ml-pipeline)
[![Python](https://img.shields.io/badge/python-3.11+-blue)](https://python.org)
[![PyTorch](https://img.shields.io/badge/pytorch-2.x-ee4c2c)](https://pytorch.org)
[![MLflow](https://img.shields.io/badge/mlflow-tracking-0194E2)](https://mlflow.org)
[![License](https://img.shields.io/badge/license-proprietary-red)]()
[![SOC 2](https://img.shields.io/badge/compliance-SOC%202-green)]()
[![GDPR](https://img.shields.io/badge/compliance-GDPR-blue)]()

End-to-end machine learning pipeline with reproducible experiment tracking, data versioning, automated training, and model serving.

---

## Table of Contents

- [Overview](#overview)
- [Architecture](#architecture)
- [Tech Stack](#tech-stack)
- [Quickstart](#quickstart)
- [Project Structure](#project-structure)
- [Data Pipeline](#data-pipeline)
- [Training](#training)
- [Experiment Tracking](#experiment-tracking)
- [Model Serving](#model-serving)
- [Testing](#testing)
- [Deployment](#deployment)
- [Configuration](#configuration)
- [Compliance](#compliance)
- [Contributing](#contributing)

---

## Overview

**ml-pipeline** is a production-grade ML system built for a small team of ML engineers and data scientists. It provides:

- **Reproducible training** — Every experiment is tracked with MLflow and versioned configs
- **Data versioning** — DVC manages datasets and model artifacts on S3
- **Pipeline orchestration** — DAG-based pipelines via DVC for data processing → feature engineering → training → evaluation
- **Model serving** — FastAPI REST API with batch inference, caching via Redis, and A/B testing infrastructure
- **GPU training** — AWS EC2 GPU instances and SageMaker integration
- **Model registry** — MLflow model registry with staging/production promotion workflow

## Architecture

\`\`\`
┌─────────────┐     ┌──────────────┐     ┌──────────────┐     ┌──────────────┐
│  Raw Data   │────▶│   Feature    │────▶│   Training   │────▶│  Evaluation  │
│  (S3/DVC)   │     │ Engineering  │     │  (PyTorch)   │     │  & Registry  │
└─────────────┘     └──────────────┘     └──────────────┘     └──────────────┘
                                                │                      │
                                                ▼                      ▼
                                         ┌──────────────┐     ┌──────────────┐
                                         │   MLflow      │     │   Model      │
                                         │   Tracking    │     │   Serving    │
                                         │   Server      │     │   (FastAPI)  │
                                         └──────────────┘     └──────────────┘
                                                                       │
                                                                       ▼
                                                               ┌──────────────┐
                                                               │   A/B Test   │
                                                               │   Router     │
                                                               └──────────────┘
\`\`\`

**Pipeline DAG** (orchestrated by DVC):

\`\`\`
data/raw → preprocess → feature_engineering → train → evaluate → register
\`\`\`

Each stage is defined in \`dvc.yaml\` with explicit dependencies, outputs, and metrics. See [docs/ARCHITECTURE.md](docs/ARCHITECTURE.md) for the full system design.

## Tech Stack

| Component | Technology |
|---|---|
| Language | Python 3.11+ (type hints required) |
| ML Framework | PyTorch 2.x |
| Experiment Tracking | MLflow (backend: PostgreSQL, artifacts: S3) |
| Data Versioning | DVC (remote: S3) |
| Model Serving | FastAPI |
| Databases | PostgreSQL (metadata), Redis (caching/feature store) |
| Config Validation | Pydantic + YAML |
| Package Manager | uv |
| Linting/Formatting | ruff |
| Type Checking | mypy (strict) |
| Testing | pytest |
| Cloud | AWS (SageMaker, S3, ECR, ECS, EC2 GPU) |
| Infrastructure | Docker, Kubernetes, Terraform |
| CI/CD | GitHub Actions |

## Quickstart

### Prerequisites

- Python 3.11+
- [uv](https://docs.astral.sh/uv/) (package manager)
- [DVC](https://dvc.org/) 3.x
- Docker & Docker Compose
- AWS CLI configured with appropriate credentials
- GPU drivers (optional, for local GPU training)

### 1. Clone and install

\`\`\`bash
git clone git@github.com:your-org/ml-pipeline.git
cd ml-pipeline

# Install dependencies with uv
uv sync

# Install git hooks
cp git-hooks/* .git/hooks/
chmod +x .git/hooks/*
\`\`\`

### 2. Start infrastructure services

\`\`\`bash
# PostgreSQL (MLflow backend), Redis (feature store/cache), MLflow server
docker compose up -d
\`\`\`

### 3. Pull data with DVC

\`\`\`bash
# Configure DVC remote (one-time)
dvc remote modify myremote access_key_id $AWS_ACCESS_KEY_ID
dvc remote modify myremote secret_access_key $AWS_SECRET_ACCESS_KEY

# Pull versioned data and model artifacts
dvc pull
\`\`\`

### 4. Run the full pipeline

\`\`\`bash
# Reproduce the entire DAG (preprocess → features → train → evaluate)
dvc repro
\`\`\`

### 5. Launch MLflow UI

\`\`\`bash
# View experiments, compare runs, inspect artifacts
mlflow ui --backend-store-uri postgresql://mlflow:mlflow@localhost:5432/mlflow
\`\`\`

Open [http://localhost:5000](http://localhost:5000) to browse experiments.

### 6. Start the serving API

\`\`\`bash
uv run uvicorn src.serving.app:app --reload --host 0.0.0.0 --port 8000
\`\`\`

Open [http://localhost:8000/docs](http://localhost:8000/docs) for the interactive API docs.

### 7. Run tests

\`\`\`bash
# Full test suite
uv run pytest

# With coverage report
uv run pytest --cov=src --cov-report=term-missing --cov-fail-under=75

# Type checking
uv run mypy src/

# Linting
uv run ruff check .

# Formatting check
uv run ruff format --check .
\`\`\`

## Project Structure

\`\`\`
ml-pipeline/
├── src/
│   ├── data/                # Data loading, preprocessing, feature engineering
│   │   ├── loaders.py       # Dataset loaders (S3, local, streaming)
│   │   ├── preprocessors.py # Cleaning, normalization, imputation
│   │   └── features.py      # Feature engineering pipelines
│   ├── models/              # PyTorch model architectures
│   │   ├── base.py          # Abstract base model class
│   │   ├── transformer.py   # Transformer-based models
│   │   └── registry.py      # Model factory and registration
│   ├── training/            # Training infrastructure
│   │   ├── trainer.py       # Training loop with checkpointing
│   │   ├── callbacks.py     # Early stopping, LR scheduling, logging
│   │   └── tuning.py        # Hyperparameter search (Optuna integration)
│   ├── evaluation/          # Model evaluation
│   │   ├── metrics.py       # Custom metrics and aggregation
│   │   ├── comparison.py    # Model comparison utilities
│   │   └── visualization.py # Plots and charts for MLflow
│   ├── serving/             # Model serving
│   │   ├── app.py           # FastAPI application
│   │   ├── inference.py     # Inference pipeline (single + batch)
│   │   ├── ab_testing.py    # A/B test routing and tracking
│   │   └── schemas.py       # Pydantic request/response models
│   └── utils/               # Shared utilities
│       ├── config.py        # Pydantic config loader (YAML → validated objects)
│       ├── logging.py       # Structured logging setup
│       └── mlflow_utils.py  # MLflow helper functions
├── configs/                 # Experiment configurations (YAML)
│   ├── base.yaml            # Default parameters
│   ├── experiments/         # Per-experiment overrides
│   │   └── transformer_v1.yaml
│   ├── staging/             # Staging environment config
│   └── production/          # Production config (SENSITIVE — CODEOWNERS protected)
├── notebooks/               # Jupyter notebooks (exploration only, NOT production)
├── tests/
│   ├── unit/                # Unit tests for individual components
│   ├── integration/         # Integration tests (DB, API, pipeline)
│   └── conftest.py          # Shared fixtures
├── data/                    # DVC-tracked data (not in git)
│   ├── raw/                 # Original datasets
│   ├── processed/           # Cleaned data
│   └── features/            # Engineered features
├── models/                  # DVC-tracked model artifacts (not in git)
├── scripts/                 # Operational scripts
│   ├── train.py             # CLI training entrypoint
│   ├── download_data.py     # Data acquisition
│   └── deploy.py            # Deployment helpers
├── docs/                    # Documentation
│   ├── ARCHITECTURE.md      # System design and decisions
│   ├── CONTRIBUTING.md      # Contribution guidelines
│   ├── ONBOARDING.md        # New team member guide
│   └── AI-USAGE-POLICY.md   # Claude Code usage policy
├── .github/                 # GitHub Actions, templates, CODEOWNERS
├── .claude/                 # Claude Code rules and settings
├── plugin/                  # CodeForge plugin (agents, commands, skills)
├── dvc.yaml                 # DVC pipeline definition
├── dvc.lock                 # DVC pipeline lock file
├── pyproject.toml           # Project metadata, dependencies (pinned versions)
├── ruff.toml                # Ruff linter/formatter configuration
├── docker-compose.yml       # Local dev services
├── Dockerfile               # Production container
└── Makefile                 # Common task shortcuts
\`\`\`

## Data Pipeline

The pipeline is defined as a DAG in \`dvc.yaml\` and executed with \`dvc repro\`:

### Stages

| Stage | Input | Output | Description |
|---|---|---|---|
| \`preprocess\` | \`data/raw/\` | \`data/processed/\` | Cleaning, normalization, train/val/test split |
| \`feature_engineering\` | \`data/processed/\` | \`data/features/\` | Feature extraction, encoding, scaling |
| \`train\` | \`data/features/\`, \`configs/\` | \`models/\` | PyTorch training with MLflow logging |
| \`evaluate\` | \`models/\`, \`data/features/\` | \`metrics.json\` | Compute metrics, generate comparison plots |

### Running individual stages

\`\`\`bash
# Run only preprocessing
dvc repro preprocess

# Force re-run training (even if inputs haven't changed)
dvc repro --force train

# Show pipeline DAG
dvc dag
\`\`\`

### Data versioning

\`\`\`bash
# Track new data
dvc add data/raw/dataset_v2.parquet
git add data/raw/dataset_v2.parquet.dvc data/raw/.gitignore
git commit -m "chore: add dataset v2"
dvc push

# Switch to a previous data version
git checkout v1.0.0 -- data/raw/dataset.parquet.dvc
dvc checkout
\`\`\`

## Training

### Run a training experiment

\`\`\`bash
# Using the default config
uv run python scripts/train.py --config configs/base.yaml

# With experiment-specific overrides
uv run python scripts/train.py --config configs/experiments/transformer_v1.yaml

# Override specific parameters via CLI
uv run python scripts/train.py --config configs/base.yaml \\
  --set training.learning_rate=0.0003 \\
  --set training.epochs=50 \\
  --set model.hidden_dim=512
\`\`\`

### Hyperparameter tuning

\`\`\`bash
# Launch Optuna-based hyperparameter search
uv run python scripts/train.py --config configs/base.yaml --tune \\
  --n-trials 100 \\
  --study-name transformer-hparam-search
\`\`\`

### GPU training on AWS

\`\`\`bash
# Launch training on SageMaker
uv run python scripts/train.py --config configs/base.yaml --sagemaker \\
  --instance-type ml.g5.xlarge
\`\`\`

### Config structure (Pydantic-validated)

\`\`\`yaml
# configs/experiments/transformer_v1.yaml
experiment:
  name: transformer-v1-baseline
  tags:
    model_type: transformer
    dataset: v2

model:
  architecture: transformer
  hidden_dim: 256
  num_layers: 4
  num_heads: 8
  dropout: 0.1

training:
  epochs: 100
  batch_size: 64
  learning_rate: 0.001
  optimizer: adamw
  weight_decay: 0.01
  scheduler: cosine_annealing
  early_stopping_patience: 10
  gradient_clip_norm: 1.0

data:
  train_path: data/features/train.parquet
  val_path: data/features/val.parquet
  test_path: data/features/test.parquet
\`\`\`

All configs are validated at load time via Pydantic models in \`src/utils/config.py\`. Invalid configs fail fast with clear error messages.

## Experiment Tracking

Every training run is automatically logged to MLflow:

- **Parameters** — Full config (model architecture, hyperparameters, data paths)
- **Metrics** — Loss, accuracy, F1, AUC (per epoch and final)
- **Artifacts** — Model checkpoints, confusion matrices, feature importance plots
- **Tags** — Git commit hash, branch, config file path, \`ai-generated\` flag
- **Model** — Registered in MLflow Model Registry with staging/production stages

### Comparing experiments

\`\`\`bash
# Launch MLflow UI
mlflow ui

# Query runs programmatically
uv run python -c "
import mlflow
runs = mlflow.search_runs(experiment_names=['transformer-v1-baseline'])
print(runs[['params.learning_rate', 'metrics.val_f1', 'metrics.val_loss']].head())
"
\`\`\`

### Promoting models

\`\`\`bash
# Register a model version
uv run python -c "
import mlflow
result = mlflow.register_model('runs:/<run_id>/model', 'transformer-v1')
"

# Transition to staging/production (requires review)
uv run python -c "
from mlflow import MlflowClient
client = MlflowClient()
client.transition_model_version_stage('transformer-v1', version=3, stage='Production')
"
\`\`\`

## Model Serving

### REST API (FastAPI)

\`\`\`bash
# Start the server
uv run uvicorn src.serving.app:app --host 0.0.0.0 --port 8000

# Single prediction
curl -X POST http://localhost:8000/predict \\
  -H "Content-Type: application/json" \\
  -d '{"features": [1.0, 2.5, 3.7, 0.8]}'

# Batch prediction
curl -X POST http://localhost:8000/predict/batch \\
  -H "Content-Type: application/json" \\
  -d '{"instances": [[1.0, 2.5, 3.7, 0.8], [0.5, 1.2, 2.1, 0.3]]}'

# Health check
curl http://localhost:8000/health

# Model metadata
curl http://localhost:8000/model/info
\`\`\`

### A/B Testing

The serving layer supports traffic splitting between model versions:

\`\`\`yaml
# configs/production/ab_test.yaml
ab_test:
  enabled: true
  variants:
    - model_name: transformer-v1
      model_version: 3
      traffic_weight: 0.8
    - model_name: transformer-v2
      model_version: 1
      traffic_weight: 0.2
  tracking:
    log_predictions: true
    metrics_endpoint: /metrics
\`\`\`

## Testing

\`\`\`bash
# Run all tests
uv run pytest

# Unit tests only
uv run pytest tests/unit/

# Integration tests only
uv run pytest tests/integration/

# With coverage
uv run pytest --cov=src --cov-report=term-missing --cov-fail-under=75

# Run specific test file
uv run pytest tests/unit/test_models.py -v

# Run tests matching a pattern
uv run pytest -k "test_transformer" -v

# Type checking
uv run mypy src/

# Lint
uv run ruff check .

# Format
uv run ruff format .
\`\`\`

### Training smoke test

CI includes a smoke test that runs a minimal training loop (1 epoch, tiny dataset) to verify the pipeline doesn't crash:

\`\`\`bash
uv run python scripts/train.py --config configs/experiments/smoke_test.yaml
\`\`\`

## Deployment

### Docker

\`\`\`bash
# Build production image
docker build -t ml-pipeline:latest .

# Run locally
docker run -p 8000:8000 ml-pipeline:latest

# Push to ECR
aws ecr get-login-password | docker login --username AWS --password-stdin <account>.dkr.ecr.<region>.amazonaws.com
docker tag ml-pipeline:latest <account>.dkr.ecr.<region>.amazonaws.com/ml-pipeline:latest
docker push <account>.dkr.ecr.<region>.amazonaws.com/ml-pipeline:latest
\`\`\`

### Deployment flow

1. **PR merged to \`main\`** → CI runs full test suite + training smoke test
2. **Staging** → Auto-deployed via GitHub Actions to ECS staging cluster
3. **Production** → Manual approval required, deployed via \`deploy-production.yml\` workflow

See [.github/workflows/](/.github/workflows/) for full CI/CD pipeline definitions.

### Infrastructure

\`\`\`bash
# Provision AWS resources
cd terraform/
terraform init
terraform plan
terraform apply
\`\`\`

## Configuration

### Environment variables

| Variable | Description | Required |
|---|---|---|
| \`AWS_ACCESS_KEY_ID\` | AWS credentials | Yes |
| \`AWS_SECRET_ACCESS_KEY\` | AWS credentials | Yes |
| \`AWS_DEFAULT_REGION\` | AWS region (default: \`us-east-1\`) | Yes |
| \`MLFLOW_TRACKING_URI\` | MLflow server URL | Yes |
| \`MLFLOW_S3_ENDPOINT_URL\` | S3 endpoint for artifacts | No |
| \`DATABASE_URL\` | PostgreSQL connection string | Yes |
| \`REDIS_URL\` | Redis connection string | Yes |
| \`MODEL_NAME\` | Model to serve (default: latest production) | No |
| \`MODEL_VERSION\` | Specific model version | No |
| \`LOG_LEVEL\` | Logging level (default: \`INFO\`) | No |

Copy \`.env.example\` to \`.env\` for local development. **Never commit \`.env\` files.**

## Compliance

### SOC 2

- All model artifacts are integrity-checked (SHA-256 hashes stored in DVC and MLflow)
- Access to production configs and model registry requires authorized roles
- Audit trail via MLflow experiment logs and git history
- See [docs/AI-USAGE-POLICY.md](docs/AI-USAGE-POLICY.md) for AI-generated code policies

### GDPR

- Training data must be anonymized before ingestion into \`data/raw/\`
- PII detection runs as a preprocessing step — flagged data is excluded
- Data deletion requests are handled via the \`scripts/gdpr_delete.py\` utility
- Data retention policies are enforced in the preprocessing pipeline
- All data lineage is tracked via DVC for auditability

## Contributing

See [docs/CONTRIBUTING.md](docs/CONTRIBUTING.md) for guidelines on:

- Branch naming (\`type/ticket-desc\`, e.g., \`feat/ML-42-add-transformer-model\`)
- Conventional commits (\`feat:\`, \`fix:\`, \`experiment:\`, \`chore:\`, \`docs:\`)
- PR requirements (tests passing, 1 approval, coverage ≥ 75%)
- Code style (ruff, mypy strict, type hints on all public functions)
- Experiment conventions (MLflow tracking, reproducible configs)

New to the project? Start with [docs/ONBOARDING.md](docs/ONBOARDING.md).

## Quick Reference

\`\`\`bash
# Common commands
uv sync                          # Install/update dependencies
dvc repro                        # Run full pipeline
dvc pull                         # Pull data from S3
dvc push                         # Push data to S3
mlflow ui                        # Launch experiment tracker
uv run pytest                    # Run tests
uv run ruff check .              # Lint
uv run ruff format .             # Format
uv run mypy src/                 # Type check
uv run uvicorn src.serving.app:app --reload  # Start API server
\`\`\`

---

Built with ❤️ by the ML Engineering team. Questions? Reach out on **#ml-pipeline** in Slack.`,

  'docs/AI-USAGE-POLICY.md': `# AI Usage Policy — ml-pipeline

> Guidelines for using Claude and other AI assistants in the ml-pipeline project.
> Last updated: 2024-01-15 | Approved by: ML Engineering Lead

## Purpose

This policy defines when and how AI coding assistants (primarily Claude via Claude Code) may be used across the ml-pipeline project. It balances productivity gains with the rigor required for reproducible ML systems, SOC 2 compliance, and GDPR data protection.

---

## 1. Permitted Uses

### 1.1 Encouraged — Use Freely

| Area | Examples |
|------|----------|
| **Boilerplate & scaffolding** | New PyTorch \`nn.Module\` skeletons, FastAPI endpoint stubs, Pydantic config models |
| **Test generation** | pytest unit tests, fixture creation, parametrized test cases |
| **Documentation** | Docstrings, README sections, experiment runbooks, architecture docs |
| **Config files** | YAML experiment configs, DVC pipeline stages, Dockerfile updates |
| **Utility functions** | Data loading helpers, logging setup, metric formatting in \`src/utils/\` |
| **Refactoring** | Extracting functions, improving type hints, applying ruff suggestions |
| **Code review assistance** | Summarizing diffs, identifying edge cases, suggesting test scenarios |
| **Debugging** | Stack trace analysis, hypothesis generation, fix suggestions |
| **DVC pipeline definitions** | \`dvc.yaml\` stages, parameter files, dependency graphs |
| **CI/CD workflows** | GitHub Actions steps, Docker build optimization |

### 1.2 Permitted with Review — Requires Human Validation

| Area | Review Requirement |
|------|-------------------|
| **Model architecture changes** (\`src/models/\`) | Senior ML engineer review + experiment validation |
| **Training loop modifications** (\`src/training/\`) | Lead review + regression test on benchmark dataset |
| **Loss functions & optimizers** | ML engineer review + mathematical correctness check |
| **Feature engineering** (\`src/data/\`) | Data scientist review + distribution analysis |
| **Hyperparameter tuning configs** | Review against prior experiment results in MLflow |
| **Evaluation metrics** (\`src/evaluation/\`) | Verify against published metric definitions |
| **Data preprocessing pipelines** | Review for data leakage, GDPR compliance |
| **Serving inference code** (\`src/serving/\`) | Load test + latency validation before merge |
| **Database migrations** | DBA or senior engineer review |
| **Infrastructure / Terraform** | DevOps lead review |

### 1.3 Prohibited — Do Not Use AI For

| Area | Reason |
|------|--------|
| **Generating or handling real PII/training data** | GDPR compliance — AI assistants must never process actual user data |
| **Writing security credentials or secrets** | SOC 2 — secrets managed via AWS Secrets Manager only |
| **Final model selection decisions** | Requires human judgment on business metrics, fairness, and bias |
| **Compliance documentation sign-off** | Legal and compliance team must author and approve |
| **Bypassing code review** | All AI-generated code follows the same PR process |
| **Production incident response** | Humans lead; AI may assist with log analysis only |

---

## 2. AI-Generated Code Labeling

All AI-generated or AI-assisted code **must** be labeled. This is enforced by our CI pipeline (\`.github/workflows/ai-code-audit.yml\`).

### 2.1 PR-Level Labeling

Every pull request containing AI-generated code must:

1. Check the "AI-assisted code" box in the PR template
2. Apply the \`ai-assisted\` GitHub label
3. Specify which files or sections were AI-generated

### 2.2 Code-Level Labeling

For substantial AI-generated blocks (>10 lines of logic), add a comment:

\`\`\`python
# AI-GENERATED: Claude — model architecture scaffold
# Human-reviewed by: @engineer-handle on 2024-01-15
class TransformerEncoder(nn.Module):
    ...
\`\`\`

For AI-assisted modifications to existing code:

\`\`\`python
# AI-ASSISTED: Claude — refactored data loading for streaming support
def load_dataset_streaming(config: DataConfig) -> IterableDataset:
    ...
\`\`\`

### 2.3 Commit Messages

Use the conventional commit format with AI attribution:

\`\`\`
feat(models): add multi-head attention layer [ai-assisted]
fix(training): resolve gradient accumulation bug [ai-assisted]
\`\`\`

---

## 3. Review Requirements by Risk Level

### 3.1 Risk Classification

| Risk Level | Scope | Reviewer Requirement | Turnaround |
|------------|-------|---------------------|------------|
| **Low** | Tests, docs, configs, utilities | 1 team member | Same day |
| **Medium** | Feature engineering, data pipelines, serving endpoints | 1 senior+ engineer | 1 business day |
| **High** | Model architecture, training loops, loss functions | 1 lead + 1 senior ML engineer | 2 business days |
| **Critical** | Production model deployment, data privacy logic, security | Lead + dedicated reviewer | 3 business days |

### 3.2 Model-Specific Review Checklist

When AI generates or modifies code in \`src/models/\` or \`src/training/\`:

- [ ] **Mathematical correctness** — Verify tensor shapes, loss formulations, gradient flow
- [ ] **Reproducibility** — Config is complete and tracked; random seeds set
- [ ] **Experiment tracking** — MLflow experiment logged with all parameters
- [ ] **Benchmark comparison** — Run against baseline; results recorded in MLflow
- [ ] **Memory profiling** — Verify GPU memory usage is within instance limits
- [ ] **Numerical stability** — Check for NaN/Inf handling, gradient clipping
- [ ] **Test coverage** — Unit tests for forward pass, loss computation, edge cases
- [ ] **No data leakage** — Verify train/val/test splits are respected
- [ ] **Type hints** — All public functions annotated; \`mypy --strict\` passes

### 3.3 Data Pipeline Review Checklist

When AI generates or modifies code in \`src/data/\`:

- [ ] **GDPR compliance** — PII anonymized or pseudonymized before processing
- [ ] **Data lineage** — DVC tracks all input/output artifacts
- [ ] **Schema validation** — Pydantic models validate data shapes
- [ ] **Distribution checks** — Feature distributions logged and compared
- [ ] **Idempotency** — Pipeline produces identical output on re-run
- [ ] **Error handling** — Graceful handling of missing/corrupt data

### 3.4 Serving Code Review Checklist

When AI generates or modifies code in \`src/serving/\`:

- [ ] **Input validation** — Pydantic request models with strict types
- [ ] **Model loading** — Correct model version from MLflow registry
- [ ] **Latency** — Response time within SLA (<100ms p95 for online inference)
- [ ] **Error responses** — Proper HTTP status codes, no stack traces in production
- [ ] **Authentication** — API key or JWT validation in place
- [ ] **Rate limiting** — Redis-backed rate limiting configured
- [ ] **No PII in logs** — Request/response logging excludes sensitive fields

---

## 4. Experiment Workflow with AI Assistance

### 4.1 Exploration Phase (Notebooks)

AI assistants **may** be used freely in \`notebooks/\` for:

- Prototyping model ideas
- Exploratory data analysis
- Visualizing experiment results
- Testing hypotheses

Notebooks are **never** deployed to production. Validated ideas must be refactored into \`src/\` modules.

### 4.2 Experiment Implementation

When using AI to implement an experiment:

1. **Start with a config**: Define the experiment in \`configs/\` using Pydantic-validated YAML
2. **Generate code**: Use Claude to scaffold the model/training changes
3. **Track everything**: Ensure MLflow logs params, metrics, and artifacts
4. **Run with DVC**: Execute via \`dvc repro\` for reproducibility
5. **Compare**: Use \`mlflow ui\` to compare against baselines
6. **Document**: Record findings in the experiment's MLflow run notes

### 4.3 Promoting to Production

AI-generated experiment code follows the standard promotion path:

\`\`\`
notebook exploration → src/ implementation → PR review → staging → A/B test → production
\`\`\`

No AI-generated model goes to production without:

- Passing all CI checks (\`uv run ruff check\`, \`uv run mypy src/\`, \`uv run pytest\`)
- Benchmark results logged in MLflow showing improvement over current production model
- Lead engineer sign-off
- Staged rollout via A/B testing infrastructure

---

## 5. Sensitive Paths — Extra Scrutiny

The following paths require heightened review for any changes, AI-generated or not:

| Path | Reason | Required Reviewer |
|------|--------|-------------------|
| \`configs/production/**\` | Production model/serving configuration | Lead engineer |
| \`models/**\` | DVC-tracked model artifacts | ML lead |
| \`.env*\` | Environment variables (should never contain secrets) | DevOps lead |
| \`data/**\` | DVC-tracked datasets (GDPR implications) | Data lead |
| \`src/serving/auth.py\` | Authentication logic | Security reviewer |
| \`terraform/**\` | Infrastructure changes | DevOps lead |
| \`.github/workflows/**\` | CI/CD pipeline changes | Lead engineer |

These paths are enforced via \`CODEOWNERS\`. See \`.github/CODEOWNERS\`.

---

## 6. Data Privacy & GDPR Compliance

### 6.1 Rules for AI Assistants

- **Never paste real user data** into Claude or any AI assistant
- **Use synthetic or anonymized data** when asking AI for help with data pipelines
- **Redact PII** from error messages, logs, and stack traces before sharing with AI
- **Do not use AI to generate** fake PII that resembles real users
- **Document data flows** — AI can help draft data flow diagrams but a human must verify GDPR compliance

### 6.2 Training Data Governance

- All training datasets must be registered in DVC with metadata about consent and anonymization
- AI-generated data augmentation code must be reviewed for potential PII reconstruction
- Feature engineering that derives from PII fields requires privacy impact assessment

---

## 7. SOC 2 Considerations

- **Audit trail**: AI-generated code is labeled and traceable via git history and PR labels
- **Access control**: Claude Code operates with the developer's permissions — no elevated access
- **Change management**: All changes go through PR review regardless of origin
- **Model artifact integrity**: Model files in \`models/\` are checksummed by DVC; any modification is tracked
- **Separation of duties**: AI generates code, humans review and approve — no self-merging

---

## 8. Quality Gates for AI-Generated Code

All AI-generated code must pass the same quality gates as human-written code:

\`\`\`bash
# Linting
uv run ruff check src/ tests/

# Formatting
uv run ruff format --check src/ tests/

# Type checking
uv run mypy src/

# Unit tests with coverage
uv run pytest --cov=src --cov-fail-under=75

# Training smoke test (for model changes)
uv run python scripts/train_smoke_test.py --config configs/smoke_test.yaml

# DVC pipeline validation
dvc status
\`\`\`

CI enforces all gates. See \`.github/workflows/ci.yml\`.

---

## 9. Accountability

| Role | Responsibility |
|------|---------------|
| **Developer using AI** | Understands, tests, and takes ownership of all AI-generated code |
| **PR Reviewer** | Validates correctness, security, and compliance — same standard as human code |
| **ML Lead** | Approves model architecture and training changes; monitors experiment quality |
| **Team** | Reports issues with AI-generated code; updates this policy as needed |

**The developer who commits AI-generated code is fully responsible for it.** AI is a tool, not an author. If a bug ships, the committer owns the fix.

---

## 10. Policy Review

This policy is reviewed quarterly or when:

- New AI tools are adopted
- Compliance requirements change
- Incidents occur involving AI-generated code
- Team composition changes significantly

**Next review date**: 2024-04-15

---

## References

- [ARCHITECTURE.md](./ARCHITECTURE.md) — System architecture and component overview
- [CODEOWNERS](../.github/CODEOWNERS) — Code ownership rules
- [PR Template](../.github/PULL_REQUEST_TEMPLATE.md) — Pull request checklist
- [CI Pipeline](../.github/workflows/ci.yml) — Automated quality gates
- [AI Code Audit](../.github/workflows/ai-code-audit.yml) — AI attribution tracking
- [CLAUDE.md](../CLAUDE.md) — Claude Code project instructions`,

  'docs/ARCHITECTURE.md': `# ML Pipeline Architecture

## Overview

ml-pipeline is an end-to-end machine learning system built on a DAG-based pipeline architecture. It handles data ingestion, feature engineering, model training, experiment tracking, and model serving with full reproducibility and auditability.

This document describes the system architecture, data flow, component interactions, and deployment topology.

---

## System Architecture Diagram

\`\`\`
┌─────────────────────────────────────────────────────────────────────────────┐
│                              AWS Cloud (VPC)                                │
│                                                                             │
│  ┌──────────┐    ┌──────────────┐    ┌──────────────┐    ┌──────────────┐  │
│  │  S3      │    │  PostgreSQL  │    │  Redis       │    │  ECR         │  │
│  │  Buckets │    │  (RDS)       │    │  (ElastiC.)  │    │  Registry    │  │
│  │          │    │              │    │              │    │              │  │
│  │ • data/  │    │ • mlflow db  │    │ • feature    │    │ • training   │  │
│  │ • models/│    │ • app meta   │    │   cache      │    │ • serving    │  │
│  │ • dvc/   │    │ • user data  │    │ • inference  │    │   images     │  │
│  │ • mlflow/│    │              │    │   cache      │    │              │  │
│  └────┬─────┘    └──────┬───────┘    └──────┬───────┘    └──────┬───────┘  │
│       │                 │                   │                   │          │
│  ─────┴─────────────────┴───────────────────┴───────────────────┴────────  │
│                              Internal Network                              │
│  ────────────────────────────────────────────────────────────────────────  │
│       │                 │                   │                   │          │
│  ┌────┴─────┐    ┌──────┴───────┐    ┌─────┴────────┐   ┌─────┴────────┐ │
│  │  DVC     │    │  MLflow      │    │  FastAPI      │   │  Training    │ │
│  │  Pipeline│    │  Tracking    │    │  Serving      │   │  Workers     │ │
│  │  (ECS)   │    │  Server      │    │  (ECS/K8s)    │   │  (EC2 GPU)  │ │
│  │          │    │  (ECS)       │    │               │   │              │ │
│  └──────────┘    └──────────────┘    └───────────────┘   └──────────────┘ │
│                                                                             │
│  ┌──────────────────────────────────────────────────────────────────────┐   │
│  │  Kubernetes Cluster (EKS)                                           │   │
│  │  ┌────────────┐  ┌────────────┐  ┌────────────┐  ┌──────────────┐  │   │
│  │  │ Serving    │  │ Serving    │  │ Prometheus  │  │ Grafana      │  │   │
│  │  │ Pod (v1)   │  │ Pod (v2)   │  │ Monitoring  │  │ Dashboards   │  │   │
│  │  │ (A/B test) │  │ (A/B test) │  │             │  │              │  │   │
│  │  └────────────┘  └────────────┘  └────────────┘  └──────────────┘  │   │
│  └──────────────────────────────────────────────────────────────────────┘   │
└─────────────────────────────────────────────────────────────────────────────┘
\`\`\`

---

## Pipeline DAG (DVC-Orchestrated)

The ML pipeline is defined as a directed acyclic graph in \`dvc.yaml\`. Each stage is reproducible, cached, and version-tracked.

\`\`\`
                    ┌──────────────┐
                    │  Raw Data    │
                    │  (S3/DVC)    │
                    └──────┬───────┘
                           │
                    ┌──────▼───────┐
                    │  Ingest      │
                    │  & Validate  │
                    └──────┬───────┘
                           │
                    ┌──────▼───────┐
                    │  Preprocess  │
                    │  & Clean     │
                    └──────┬───────┘
                           │
                    ┌──────▼───────┐
                    │  Feature     │
                    │  Engineering │
                    └──────┬───────┘
                           │
              ┌────────────┼────────────┐
              │            │            │
       ┌──────▼─────┐ ┌───▼──────┐ ┌──▼──────────┐
       │  Train/Val  │ │  Test    │ │  Feature    │
       │  Split      │ │  Split   │ │  Store      │
       └──────┬──────┘ └───┬──────┘ │  (Redis)    │
              │            │        └─────────────┘
       ┌──────▼──────┐     │
       │  Train      │     │
       │  Model      │     │
       │  (PyTorch)  │     │
       └──────┬──────┘     │
              │            │
       ┌──────▼──────┐     │
       │  Evaluate   ◄─────┘
       │  Model      │
       └──────┬──────┘
              │
       ┌──────▼──────┐
       │  Register   │
       │  Model      │
       │  (MLflow)   │
       └──────┬──────┘
              │
       ┌──────▼──────┐
       │  Deploy     │
       │  (Staging)  │
       └─────────────┘
\`\`\`

### DVC Stage Definitions

| Stage | Script | Inputs | Outputs | Metrics |
|---|---|---|---|---|
| \`ingest\` | \`scripts/ingest.py\` | S3 raw data path | \`data/raw/\` | Row counts, schema validation |
| \`preprocess\` | \`src/data/preprocess.py\` | \`data/raw/\` | \`data/processed/\` | Missing value stats |
| \`featurize\` | \`src/data/feature_engineering.py\` | \`data/processed/\`, config | \`data/features/\` | Feature distributions |
| \`split\` | \`src/data/split.py\` | \`data/features/\` | \`data/train/\`, \`data/val/\`, \`data/test/\` | Split ratios |
| \`train\` | \`src/training/train.py\` | \`data/train/\`, \`data/val/\`, config | \`models/checkpoints/\` | Loss, learning rate |
| \`evaluate\` | \`src/evaluation/evaluate.py\` | \`models/checkpoints/\`, \`data/test/\` | \`metrics/eval.json\` | Accuracy, F1, AUC, latency |
| \`register\` | \`scripts/register_model.py\` | \`models/checkpoints/\`, \`metrics/eval.json\` | MLflow model registry | Registry version |

### Running the Pipeline

\`\`\`bash
# Full pipeline reproduction
dvc repro

# Run specific stage
dvc repro train

# Run with parameter override
dvc repro --set-param train.learning_rate=0.001

# View pipeline DAG
dvc dag
\`\`\`

---

## Data Flow

### Data Lifecycle

\`\`\`
External Sources ──► S3 (raw/) ──► Preprocessing ──► S3 (processed/)
                                                          │
                                                          ▼
                                                   Feature Engineering
                                                          │
                                          ┌───────────────┼───────────────┐
                                          ▼               ▼               ▼
                                    S3 (features/)   Redis (cache)   DVC (versioned)
                                          │
                                          ▼
                                    Train / Val / Test splits
                                          │
                                          ▼
                                    PyTorch DataLoaders
\`\`\`

### Data Versioning Strategy

All data artifacts are tracked by DVC with remote storage on S3:

- **\`data/raw/\`** — Immutable raw data snapshots, never modified after ingestion
- **\`data/processed/\`** — Cleaned and validated data, regenerated from raw
- **\`data/features/\`** — Engineered features, regenerated from processed
- **\`models/\`** — Trained model checkpoints and artifacts

\`\`\`bash
# Track new data
dvc add data/raw/dataset_v3.parquet
git add data/raw/dataset_v3.parquet.dvc data/raw/.gitignore
git commit -m "chore: add dataset v3"

# Push to remote
dvc push

# Pull data on another machine
dvc pull
\`\`\`

### GDPR Compliance in Data Pipeline

The data pipeline enforces GDPR requirements at every stage:

1. **Ingestion**: PII detection scan, consent flag validation
2. **Preprocessing**: Anonymization/pseudonymization of personal data fields
3. **Feature Engineering**: No raw PII in feature vectors; only derived, non-reversible features
4. **Storage**: Encryption at rest (S3 SSE-KMS), encryption in transit (TLS 1.2+)
5. **Deletion**: Right-to-deletion pipeline (\`scripts/gdpr_delete.py\`) propagates through all stages
6. **Audit**: All data access logged to CloudWatch, queryable for compliance audits

See \`docs/GDPR_DATA_HANDLING.md\` for detailed procedures.

---

## Model Training Architecture

### Training Infrastructure

\`\`\`
┌─────────────────────────────────────────────────────┐
│  Training Worker (EC2 p3.2xlarge / g5.xlarge)       │
│                                                     │
│  ┌─────────────┐  ┌──────────────┐  ┌───────────┐  │
│  │  PyTorch    │  │  MLflow      │  │  DVC      │  │
│  │  Training   │──│  Client      │──│  Client   │  │
│  │  Loop       │  │  (tracking)  │  │  (data)   │  │
│  └──────┬──────┘  └──────┬───────┘  └─────┬─────┘  │
│         │                │                │         │
│  ┌──────▼──────┐         │                │         │
│  │  CUDA/GPU   │         │                │         │
│  │  Execution  │         │                │         │
│  └─────────────┘         │                │         │
└──────────────────────────┼────────────────┼─────────┘
                           │                │
                    ┌──────▼───────┐  ┌─────▼─────┐
                    │  MLflow      │  │  S3       │
                    │  Server      │  │  (DVC     │
                    │  (tracking)  │  │   remote) │
                    └──────────────┘  └───────────┘
\`\`\`

### Experiment Configuration

All experiments are configured via Pydantic-validated YAML files in \`configs/\`:

\`\`\`yaml
# configs/experiment/baseline_transformer.yaml
experiment:
  name: baseline-transformer-v2
  tags:
    team: ml-pipeline
    ticket: ML-42

data:
  dataset: features_v3
  train_split: 0.8
  val_split: 0.1
  test_split: 0.1
  batch_size: 64
  num_workers: 4

model:
  architecture: transformer
  params:
    d_model: 256
    n_heads: 8
    n_layers: 4
    dropout: 0.1

training:
  optimizer: adamw
  learning_rate: 0.0003
  weight_decay: 0.01
  scheduler: cosine_annealing
  max_epochs: 100
  early_stopping_patience: 10
  gradient_clip_norm: 1.0

resources:
  device: cuda
  mixed_precision: true
  num_gpus: 1
\`\`\`

### Training Loop Design

\`\`\`python
# Simplified training flow (see src/training/train.py for full implementation)

# 1. Load and validate config
config = ExperimentConfig.from_yaml("configs/experiment/baseline_transformer.yaml")

# 2. Initialize MLflow run
with mlflow.start_run(run_name=config.experiment.name):
    mlflow.log_params(config.flat_dict())

    # 3. Load data via DVC-tracked paths
    train_loader, val_loader = create_data_loaders(config.data)

    # 4. Initialize model, optimizer, scheduler
    model = ModelFactory.create(config.model)
    optimizer = OptimizerFactory.create(config.training, model)

    # 5. Training loop with callbacks
    trainer = Trainer(
        model=model,
        optimizer=optimizer,
        callbacks=[
            EarlyStopping(patience=config.training.early_stopping_patience),
            ModelCheckpoint(path="models/checkpoints/"),
            MLflowLogger(),
            GradientClipCallback(max_norm=config.training.gradient_clip_norm),
        ],
    )
    trainer.fit(train_loader, val_loader, max_epochs=config.training.max_epochs)

    # 6. Log final model to MLflow
    mlflow.pytorch.log_model(model, "model")
\`\`\`

### Hyperparameter Tuning

Hyperparameter search is orchestrated via \`src/training/tuning.py\` using Optuna with MLflow tracking:

\`\`\`
Optuna Study
    │
    ├── Trial 1 ──► MLflow Run (child) ──► metrics logged
    ├── Trial 2 ──► MLflow Run (child) ──► metrics logged
    ├── Trial 3 ──► MLflow Run (child) ──► metrics logged
    └── ...
    │
    ▼
Best trial params ──► Final training run ──► Model registry
\`\`\`

---

## Experiment Tracking (MLflow)

### MLflow Architecture

\`\`\`
┌──────────────┐     ┌──────────────────┐     ┌──────────────┐
│  Training    │────►│  MLflow Tracking │────►│  PostgreSQL  │
│  Scripts     │     │  Server          │     │  (metadata)  │
└──────────────┘     └────────┬─────────┘     └──────────────┘
                              │
┌──────────────┐              │
│  Notebooks   │──────────────┘
│  (explore)   │              │
└──────────────┘              ▼
                     ┌──────────────────┐
                     │  S3 Artifact     │
                     │  Store           │
                     │  • model files   │
                     │  • plots         │
                     │  • configs       │
                     └──────────────────┘
\`\`\`

### MLflow Hierarchy

\`\`\`
Experiment: "transformer-classification"
    │
    ├── Run: "baseline-transformer-v2" (run_id: abc123)
    │   ├── Parameters: lr=0.0003, d_model=256, ...
    │   ├── Metrics: val_loss=0.342, val_f1=0.891, ...
    │   ├── Artifacts: model/, plots/, config.yaml
    │   └── Tags: team=ml-pipeline, ticket=ML-42
    │
    ├── Run: "transformer-v2-tuning" (parent run)
    │   ├── Child Run: trial_0 (lr=0.001, val_f1=0.856)
    │   ├── Child Run: trial_1 (lr=0.0005, val_f1=0.878)
    │   └── Child Run: trial_2 (lr=0.0003, val_f1=0.891)
    │
    └── Run: "transformer-v3-larger" (run_id: def456)
        └── ...
\`\`\`

### Model Registry Workflow

\`\`\`
Training ──► MLflow Run ──► Register Model
                                │
                    ┌───────────┼───────────┐
                    ▼           ▼           ▼
                 "None"    "Staging"   "Production"
                 (new)     (testing)   (serving)
                    │           │           │
                    └───► Promote ───► Promote
                      (auto after     (manual,
                       CI passes)      requires
                                       approval)
\`\`\`

Model promotion from Staging to Production requires:
1. All evaluation metrics above threshold (defined in \`configs/production/thresholds.yaml\`)
2. Latency benchmark passes (p99 < 50ms for single inference)
3. A/B test results reviewed (if applicable)
4. Approval from ML lead via GitHub PR

---

## Model Serving Architecture

### FastAPI Service

\`\`\`
┌─────────────────────────────────────────────────────────────────┐
│  FastAPI Application (src/serving/)                             │
│                                                                 │
│  ┌──────────────┐  ┌──────────────┐  ┌───────────────────────┐ │
│  │  /predict    │  │  /predict    │  │  /health              │ │
│  │  (single)    │  │  /batch      │  │  /metrics             │ │
│  │              │  │              │  │  /model-info          │ │
│  └──────┬───────┘  └──────┬───────┘  └───────────────────────┘ │
│         │                 │                                     │
│  ┌──────▼─────────────────▼──────┐                              │
│  │  Inference Pipeline           │                              │
│  │  ┌─────────┐  ┌───────────┐   │                              │
│  │  │ Feature │  │ Model     │   │                              │
│  │  │ Transform│  │ Inference │   │                              │
│  │  └────┬────┘  └─────┬─────┘   │                              │
│  │       │             │         │                              │
│  │  ┌────▼────┐  ┌─────▼─────┐   │                              │
│  │  │ Redis   │  │ PyTorch   │   │                              │
│  │  │ Cache   │  │ Model     │   │                              │
│  │  └─────────┘  └───────────┘   │                              │
│  └───────────────────────────────┘                              │
└─────────────────────────────────────────────────────────────────┘
\`\`\`

### Request Flow

\`\`\`
Client Request
    │
    ▼
API Gateway (ALB)
    │
    ▼
FastAPI Router ──► Input Validation (Pydantic)
    │
    ▼
Feature Transform ──► Redis Cache (check)
    │                      │
    │ (cache miss)         │ (cache hit)
    ▼                      ▼
PyTorch Model.forward() ──► Response
    │
    ▼
Redis Cache (store) ──► Prediction Logging ──► Response
                              │
                              ▼
                        PostgreSQL (audit log)
\`\`\`

### A/B Testing Infrastructure

Traffic splitting is handled at the Kubernetes ingress level:

\`\`\`
Incoming Traffic
    │
    ▼
Ingress Controller (traffic split)
    │
    ├── 90% ──► Service A (Production model v5)
    │           Pod 1, Pod 2, Pod 3
    │
    └── 10% ──► Service B (Candidate model v6)
                Pod 1
    │
    ▼
Both log to ──► Prediction Log (PostgreSQL)
                    │
                    ▼
              A/B Analysis Pipeline
              (src/evaluation/ab_test.py)
                    │
                    ▼
              MLflow Metrics + Grafana Dashboard
\`\`\`

A/B test configuration in \`configs/serving/ab_test.yaml\`:

\`\`\`yaml
ab_test:
  name: transformer-v6-rollout
  control:
    model_name: transformer-classifier
    model_version: 5
    traffic_percentage: 90
  treatment:
    model_name: transformer-classifier
    model_version: 6
    traffic_percentage: 10
  metrics:
    primary: conversion_rate
    guardrail:
      - latency_p99_ms: 50
      - error_rate: 0.01
  duration_days: 7
  min_sample_size: 10000
\`\`\`

### Batch Inference

\`\`\`
S3 (input batch) ──► ECS Task ──► FastAPI /predict/batch ──► S3 (results)
                         │
                         ▼
                   MLflow (log batch metrics)
\`\`\`

Batch jobs are triggered via:
- Scheduled ECS tasks (daily/weekly)
- Manual invocation via \`scripts/batch_inference.py\`
- GitHub Actions workflow dispatch

---

## Monitoring & Observability

### Metrics Stack

\`\`\`
┌──────────────┐     ┌──────────────┐     ┌──────────────┐
│  FastAPI     │────►│  Prometheus  │────►│  Grafana     │
│  /metrics    │     │  (scrape)    │     │  Dashboards  │
└──────────────┘     └──────────────┘     └──────────────┘

┌──────────────┐     ┌──────────────┐
│  Training    │────►│  MLflow UI   │
│  Metrics     │     │  (experiments│
└──────────────┘     │   & models)  │
                     └──────────────┘
\`\`\`

### Key Metrics Tracked

| Category | Metric | Alert Threshold |
|---|---|---|
| **Serving** | Request latency (p50, p95, p99) | p99 > 100ms |
| **Serving** | Error rate | > 1% over 5 min |
| **Serving** | Requests per second | < 10 (low traffic alert) |
| **Model** | Prediction distribution drift | KL divergence > 0.1 |
| **Model** | Feature distribution drift | PSI > 0.2 |
| **Model** | Accuracy on labeled feedback | < 85% |
| **Training** | GPU utilization | < 50% (waste alert) |
| **Training** | Training loss divergence | NaN or > 10x initial |
| **Data** | Data freshness | > 24h since last ingest |
| **Infra** | Pod restarts | > 3 in 10 min |
| **Infra** | Memory usage | > 85% |

### Grafana Dashboards

1. **Model Serving** — Latency, throughput, error rates, prediction distributions
2. **Training Monitor** — GPU utilization, loss curves, epoch progress
3. **Data Pipeline** — DVC stage durations, data freshness, row counts
4. **A/B Test** — Metric comparison, statistical significance, traffic split
5. **Infrastructure** — Pod health, resource usage, S3 costs

---

## Security Architecture

### SOC 2 Controls

| Control | Implementation |
|---|---|
| Access control | IAM roles per service, least privilege |
| Data encryption at rest | S3 SSE-KMS, RDS encryption, EBS encryption |
| Data encryption in transit | TLS 1.2+ everywhere, VPC internal traffic |
| Audit logging | CloudTrail, CloudWatch, prediction audit log |
| Model integrity | SHA-256 checksums on all model artifacts in MLflow |
| Secret management | AWS Secrets Manager, never in code or configs |
| Network isolation | VPC, private subnets, security groups |
| Dependency scanning | \`uv audit\` in CI, Dependabot alerts |

### Model Artifact Integrity

Every model registered in MLflow includes:
- SHA-256 hash of model weights
- Hash of the training config used
- Git commit SHA of the training code
- DVC data version hash
- Signed metadata linking all of the above

Verification runs automatically before any model is promoted to Production.

---

## Directory Structure Reference

\`\`\`
ml-pipeline/
├── .claude/                    # Claude Code rules and settings
│   ├── rules/
│   │   ├── common/             # Language-agnostic rules
│   │   └── python/             # Python-specific rules
│   └── settings.json
├── .github/
│   ├── workflows/
│   │   ├── ci.yml              # Lint, type check, test, build
│   │   └── deploy-staging.yml  # Auto-deploy to staging
│   ├── CODEOWNERS
│   ├── ISSUE_TEMPLATE/
│   └── PULL_REQUEST_TEMPLATE.md
├── configs/
│   ├── experiment/             # Experiment YAML configs
│   ├── serving/                # Serving and A/B test configs
│   └── production/             # Production thresholds (protected)
├── data/                       # DVC-tracked (not in git)
│   ├── raw/
│   ├── processed/
│   └── features/
├── docs/
│   ├── ARCHITECTURE.md         # This file
│   ├── EXPERIMENT_LOG.md       # Experiment decisions and results
│   └── RUNBOOK.md              # Operational procedures
├── models/                     # DVC-tracked model artifacts
├── notebooks/                  # Exploration only, not production
├── scripts/
│   ├── ingest.py
│   ├── register_model.py
│   ├── batch_inference.py
│   └── gdpr_delete.py
├── src/
│   ├── data/
│   │   ├── __init__.py
│   │   ├── preprocess.py
│   │   ├── feature_engineering.py
│   │   ├── split.py
│   │   └── loaders.py
│   ├── models/
│   │   ├── __init__.py
│   │   ├── base.py             # Abstract base model
│   │   ├── transformer.py
│   │   └── factory.py          # ModelFactory
│   ├── training/
│   │   ├── __init__.py
│   │   ├── train.py
│   │   ├── tuning.py           # Optuna integration
│   │   ├── callbacks.py
│   │   └── trainer.py
│   ├── evaluation/
│   │   ├── __init__.py
│   │   ├── evaluate.py
│   │   ├── metrics.py
│   │   └── ab_test.py
│   ├── serving/
│   │   ├── __init__.py
│   │   ├── app.py              # FastAPI application
│   │   ├── routes.py
│   │   ├── inference.py
│   │   └── schemas.py          # Pydantic request/response models
│   └── utils/
│       ├── __init__.py
│       ├── config.py           # Pydantic config loading
│       ├── logging.py
│       └── reproducibility.py  # Seed setting, determinism
├── tests/
│   ├── unit/
│   ├── integration/
│   └── conftest.py
├── dvc.yaml                    # Pipeline DAG definition
├── dvc.lock                    # Locked pipeline state
├── params.yaml                 # DVC parameters
├── pyproject.toml              # Dependencies (pinned versions)
├── Dockerfile                  # Multi-stage build
├── docker-compose.yml          # Local dev environment
├── CLAUDE.md                   # Claude Code project instructions
└── ruff.toml                   # Linter/formatter config
\`\`\`

---

## Local Development

### Prerequisites

\`\`\`bash
# Install uv
curl -LsSf https://astral.sh/uv/install.sh | sh

# Clone and setup
git clone <repo-url> && cd ml-pipeline
uv sync
dvc pull

# Start local services
docker compose up -d  # PostgreSQL, Redis, MLflow server

# Verify setup
uv run pytest tests/unit/
uv run mlflow ui  # http://localhost:5000
\`\`\`

### Common Development Commands

\`\`\`bash
# Run full pipeline
dvc repro

# Run linting and type checking
uv run ruff check src/ tests/
uv run ruff format --check src/ tests/
uv run mypy src/

# Run tests
uv run pytest tests/unit/ -v
uv run pytest tests/integration/ -v --cov=src --cov-report=term-missing

# Start serving locally
uv run uvicorn src.serving.app:app --reload --port 8000

# Train with specific config
uv run python -m src.training.train --config configs/experiment/baseline_transformer.yaml
\`\`\`

---

## Decision Log

| Date | Decision | Rationale |
|---|---|---|
| 2024-01 | DVC over custom pipeline | Reproducibility, git integration, S3 remote support |
| 2024-01 | MLflow over W&B | Self-hosted (SOC 2), model registry, PyTorch integration |
| 2024-02 | FastAPI over Flask | Async support, Pydantic integration, auto OpenAPI docs |
| 2024-02 | uv over pip/poetry | 10-100x faster installs, lockfile support, drop-in replacement |
| 2024-03 | Optuna over Ray Tune | Simpler setup for small team, MLflow integration |
| 2024-03 | Redis feature cache | Sub-ms feature lookup for real-time serving |
| 2024-04 | K8s A/B testing | Native traffic splitting, no vendor lock-in |

---

## Related Documentation

- [CLAUDE.md](../CLAUDE.md) — Claude Code project instructions and conventions
- [docs/EXPERIMENT_LOG.md](EXPERIMENT_LOG.md) — Experiment decisions and results
- [docs/RUNBOOK.md](RUNBOOK.md) — Operational procedures and incident response
- [.github/PULL_REQUEST_TEMPLATE.md](../.github/PULL_REQUEST_TEMPLATE.md) — PR review checklist
- [configs/](../configs/) — All experiment and serving configurations`,

  'docs/CONTRIBUTING.md': `# Contributing to ml-pipeline

Welcome to the ml-pipeline project. This guide covers our development workflow, experiment conventions, data pipeline standards, and PR process.

## Table of Contents

- [Getting Started](#getting-started)
- [Development Environment](#development-environment)
- [Experiment Workflow](#experiment-workflow)
- [Data Pipeline Conventions](#data-pipeline-conventions)
- [Code Contribution Workflow](#code-contribution-workflow)
- [PR Process](#pr-process)
- [Testing Standards](#testing-standards)
- [Code Style](#code-style)
- [Notebooks vs Production Code](#notebooks-vs-production-code)
- [Data Privacy & Compliance](#data-privacy--compliance)

---

## Getting Started

1. Clone the repository and install dependencies:

\`\`\`bash
git clone git@github.com:<org>/ml-pipeline.git
cd ml-pipeline
uv sync
\`\`\`

2. Install git hooks:

\`\`\`bash
cp git-hooks/* .git/hooks/
chmod +x .git/hooks/*
\`\`\`

3. Pull DVC-tracked data and model artifacts:

\`\`\`bash
dvc pull
\`\`\`

4. Verify your environment:

\`\`\`bash
uv run ruff check src/
uv run mypy src/
uv run pytest
\`\`\`

5. Start MLflow UI for experiment tracking:

\`\`\`bash
mlflow ui --backend-store-uri postgresql://localhost:5432/mlflow
\`\`\`

## Development Environment

### Required Tools

| Tool | Version | Purpose |
|------|---------|---------|
| Python | 3.11+ | Runtime |
| uv | Latest | Package management |
| DVC | 3.x | Data versioning and pipelines |
| Docker | 24+ | Containerization |
| AWS CLI | 2.x | Cloud access (S3, ECR, SageMaker) |

### Environment Variables

Copy the example env file and fill in your values:

\`\`\`bash
cp .env.example .env
\`\`\`

Required variables:

- \`MLFLOW_TRACKING_URI\` — MLflow server URL
- \`AWS_PROFILE\` — AWS credentials profile for S3/DVC remote
- \`POSTGRES_URL\` — PostgreSQL connection string
- \`REDIS_URL\` — Redis connection string for feature store/caching

> **Never commit \`.env\` files or credentials.** These paths are protected in CODEOWNERS.

---

## Experiment Workflow

All experiments follow a structured, reproducible workflow. Ad-hoc training runs without tracked configs are not acceptable for anything beyond local exploration.

### 1. Create an Experiment Config

Every experiment starts with a YAML config in \`configs/\`:

\`\`\`yaml
# configs/experiments/transformer_v2.yaml
experiment:
  name: transformer-v2-classification
  tags:
    task: text-classification
    author: your-name
    ticket: ML-42

data:
  dataset: processed/reviews_v3
  split_ratio: [0.8, 0.1, 0.1]
  features: configs/features/text_features_v2.yaml

model:
  architecture: transformer
  params:
    num_layers: 6
    hidden_dim: 512
    num_heads: 8
    dropout: 0.1

training:
  epochs: 50
  batch_size: 32
  learning_rate: 0.0003
  optimizer: adamw
  scheduler: cosine_warmup
  early_stopping:
    patience: 5
    metric: val_f1

evaluation:
  metrics: [accuracy, f1, precision, recall, auc_roc]
  comparison_baseline: models/production/current
\`\`\`

Configs are validated at runtime using Pydantic models defined in \`src/utils/config.py\`.

### 2. Run the Experiment

Use DVC pipelines for reproducible runs:

\`\`\`bash
# Run the full pipeline (data → features → train → evaluate)
dvc repro

# Run a specific stage
dvc repro train

# Run with a specific experiment config
uv run python scripts/train.py --config configs/experiments/transformer_v2.yaml
\`\`\`

### 3. Track in MLflow

All training scripts must log to MLflow automatically. The training harness in \`src/training/\` handles this, but verify:

- **Parameters**: All config values logged as params
- **Metrics**: Training and validation metrics logged per epoch
- **Artifacts**: Model checkpoints, confusion matrices, learning curves
- **Tags**: Ticket number, author, git commit SHA, config file path
- **Model**: Registered in MLflow Model Registry if performance meets threshold

\`\`\`python
# Example — this is handled by src/training/trainer.py
with mlflow.start_run(run_name="transformer-v2-exp-001"):
    mlflow.log_params(config.flatten())
    mlflow.log_metric("val_f1", best_f1, step=epoch)
    mlflow.pytorch.log_model(model, "model")
\`\`\`

### 4. Compare and Promote

\`\`\`bash
# Compare experiments in MLflow UI
mlflow ui

# Promote a model to staging in the registry
uv run python scripts/promote_model.py --run-id <run_id> --stage staging
\`\`\`

### Experiment Branch Naming

Use the \`experiment:\` commit prefix and branch pattern:

\`\`\`
feat/ML-42-transformer-v2-architecture    # New model architecture
fix/ML-55-fix-data-leakage               # Bug fix in pipeline
experiment/ML-60-lr-sweep                 # Hyperparameter exploration (may not merge)
\`\`\`

---

## Data Pipeline Conventions

### DVC Pipeline Structure

The pipeline is defined in \`dvc.yaml\` at the project root:

\`\`\`
data/raw/          → [download]   → data/raw/<dataset>
data/raw/          → [preprocess] → data/processed/<dataset>
data/processed/    → [features]   → data/features/<feature_set>
data/features/     → [train]      → models/<experiment>
models/<experiment> → [evaluate]  → reports/<experiment>
\`\`\`

### Data Directory Layout

\`\`\`
data/
├── raw/                # Original, immutable data (DVC-tracked)
│   ├── reviews_v1.parquet
│   └── reviews_v1.parquet.dvc
├── processed/          # Cleaned, transformed data (DVC-tracked)
│   └── reviews_v3/
├── features/           # Engineered feature sets (DVC-tracked)
│   └── text_features_v2/
└── .gitignore          # Ensures data files aren't committed to git
\`\`\`

### Data Versioning Rules

1. **Never commit data files to git.** All data is tracked via DVC with S3 remote storage.
2. **Immutable raw data.** Never modify files in \`data/raw/\`. Create new versions instead.
3. **Version feature sets.** Each feature engineering change produces a new versioned directory.
4. **Document data lineage.** Every dataset must have a corresponding entry in \`docs/data-catalog.md\`.
5. **DVC lock files are committed.** Always commit \`dvc.lock\` after running \`dvc repro\`.

### Adding New Data

\`\`\`bash
# Add a new raw dataset
cp /path/to/new_data.parquet data/raw/
dvc add data/raw/new_data.parquet
git add data/raw/new_data.parquet.dvc data/raw/.gitignore

# Push data to remote
dvc push
git commit -m "chore: add new_data.parquet dataset"
\`\`\`

### Feature Engineering

Feature engineering code lives in \`src/data/features.py\` (or submodules under \`src/data/\`). Rules:

- Feature transforms must be deterministic and reproducible
- Use Pydantic configs for feature parameters
- Register feature sets in the feature catalog
- Cache expensive features in Redis when used in serving

---

## Code Contribution Workflow

### 1. Pick Up a Task

- Assign yourself a GitHub Issue
- Issues are labeled: \`model\`, \`data\`, \`infra\`, \`serving\`, \`experiment\`

### 2. Create a Branch

\`\`\`bash
git checkout main
git pull origin main
git checkout -b feat/ML-42-add-transformer-model
\`\`\`

Branch naming: \`type/ticket-desc\`

| Type | Use Case |
|------|----------|
| \`feat/\` | New feature, model, pipeline stage |
| \`fix/\` | Bug fix |
| \`experiment/\` | Exploratory work (may not merge to main) |
| \`chore/\` | Tooling, config, dependency updates |
| \`docs/\` | Documentation only |

### 3. Develop

- Write code in \`src/\`, never in \`notebooks/\`
- Add type hints to all public functions
- Keep files under 300 lines
- Validate configs with Pydantic
- Add tests for new functionality

### 4. Commit

Use conventional commits:

\`\`\`bash
git commit -m "feat: add transformer encoder model architecture"
git commit -m "fix: resolve data leakage in temporal split"
git commit -m "experiment: sweep learning rates for transformer v2"
git commit -m "docs: add transformer model architecture docs"
\`\`\`

The \`commit-msg\` git hook enforces this format.

### 5. Push and Open PR

\`\`\`bash
git push origin feat/ML-42-add-transformer-model
\`\`\`

Open a PR against \`main\` using the PR template.

---

## PR Process

### PR Requirements

All PRs to \`main\` must satisfy:

- [ ] At least **1 approval** from a code owner
- [ ] All CI checks passing (lint, type check, unit tests, integration tests)
- [ ] Coverage threshold met (≥75%)
- [ ] No changes to sensitive paths without explicit approval (\`configs/production/**\`, \`models/**\`, \`.env*\`, \`data/**\`)
- [ ] Conventional commit messages
- [ ] PR template filled out completely

### PR Template Checklist

The PR template at \`.github/PULL_REQUEST_TEMPLATE.md\` includes ML-specific sections:

- **Experiment link**: MLflow run URL if applicable
- **Data changes**: Whether DVC-tracked data was modified
- **Model changes**: Architecture or training changes
- **Config changes**: New or modified YAML configs
- **Performance impact**: Metrics comparison vs baseline

### Review Guidelines

**For reviewers:**

- Verify experiment reproducibility — can you re-run from the config?
- Check for data leakage in preprocessing/feature engineering
- Validate that metrics are logged correctly to MLflow
- Ensure model artifacts are DVC-tracked, not git-committed
- Review Pydantic config schemas for completeness
- Check type hints on all public functions
- Flag any hardcoded paths, credentials, or magic numbers

**For model/experiment PRs specifically:**

- Compare metrics against the current baseline (documented in PR)
- Verify the experiment config is committed alongside code changes
- Ensure training is deterministic (seeds set, documented non-determinism)
- Check GPU memory usage and training time estimates

### AI-Generated Code

Code generated with Claude or other AI tools must be:

- Marked with \`# AI-generated\` comment at the top of the file or function
- Reviewed with the same rigor as human-written code
- Flagged in the PR description under the AI assistance section
- Audited by the \`ai-code-audit.yml\` workflow

---

## Testing Standards

### Test Structure

\`\`\`
tests/
├── unit/
│   ├── test_models/          # Model architecture tests
│   ├── test_data/            # Data loading and feature tests
│   ├── test_training/        # Training loop tests
│   ├── test_evaluation/      # Metrics and evaluation tests
│   └── test_serving/         # API endpoint tests
├── integration/
│   ├── test_pipeline.py      # End-to-end DVC pipeline
│   ├── test_mlflow.py        # MLflow logging integration
│   └── test_api.py           # FastAPI integration tests
└── conftest.py               # Shared fixtures
\`\`\`

### Running Tests

\`\`\`bash
# All tests
uv run pytest

# Unit tests only
uv run pytest tests/unit/

# With coverage
uv run pytest --cov=src --cov-report=term-missing --cov-fail-under=75

# Specific test file
uv run pytest tests/unit/test_models/test_transformer.py -v
\`\`\`

### ML-Specific Testing

- **Model tests**: Verify forward pass shapes, gradient flow, serialization round-trip
- **Data tests**: Validate schema, check for nulls, verify split ratios
- **Training tests**: Use small synthetic data, verify loss decreases over a few steps
- **Serving tests**: Test API contracts, input validation, error handling
- **Determinism tests**: Same seed + config → same output

---

## Code Style

### Enforced by Tooling

\`\`\`bash
# Lint
uv run ruff check src/ tests/

# Format
uv run ruff format src/ tests/

# Type check
uv run mypy src/
\`\`\`

### Naming Conventions

| Element | Convention | Example |
|---------|-----------|---------|
| Files | snake_case | \`feature_engineering.py\` |
| Functions | snake_case | \`compute_embeddings()\` |
| Classes | PascalCase | \`TransformerEncoder\` |
| Constants | SCREAMING_SNAKE_CASE | \`MAX_SEQUENCE_LENGTH\` |
| Configs | snake_case YAML keys | \`learning_rate: 0.001\` |

### File Length

Maximum **300 lines** per file. If a file grows beyond this, refactor into submodules.

### Type Hints

Required on all public functions:

\`\`\`python
def train_model(
    config: TrainingConfig,
    dataset: torch.utils.data.Dataset,
    device: torch.device,
) -> tuple[nn.Module, dict[str, float]]:
    ...
\`\`\`

---

## Notebooks vs Production Code

| | Notebooks (\`notebooks/\`) | Production Code (\`src/\`) |
|---|---|---|
| Purpose | Exploration, visualization, prototyping | Training, serving, pipelines |
| Testing | Not tested | Fully tested |
| Type hints | Optional | Required |
| Code review | Light review | Full review |
| Deployed | Never | Yes |
| DVC pipeline | Never a stage | Pipeline stages |

**Rule**: If code from a notebook is useful, refactor it into \`src/\` with tests and type hints before using it in any pipeline or serving context.

---

## Data Privacy & Compliance

This project operates under **SOC 2** and **GDPR** requirements.

### GDPR Requirements

- **Anonymization**: PII must be anonymized or pseudonymized before entering \`data/processed/\`
- **Consent tracking**: Training data must have documented consent basis
- **Right to deletion**: Pipeline must support removing individual records and retraining
- **Data minimization**: Only collect and store features necessary for the model task
- **Audit trail**: All data transformations logged and reproducible via DVC

### SOC 2 Requirements

- **Model artifact integrity**: All model artifacts are checksummed via DVC
- **Access control**: Production configs and model files require CODEOWNERS approval
- **Audit logging**: All experiment runs tracked in MLflow with author attribution
- **Change management**: All production changes go through PR review

### Sensitive Paths

The following paths require explicit approval from designated code owners:

- \`configs/production/**\` — Production deployment configs
- \`models/**\` — Trained model artifacts
- \`.env*\` — Environment variables and secrets
- \`data/**\` — DVC tracking files

See \`.github/CODEOWNERS\` for the full ownership map.

---

## Getting Help

- **Architecture questions**: See \`docs/ARCHITECTURE.md\`
- **Experiment setup**: Check \`configs/experiments/\` for examples
- **Slack**: \`#ml-pipeline\` channel for async discussion
- **MLflow UI**: Browse past experiments and compare runs
- **GitHub Issues**: File bugs, request features, or propose experiments`,

  'docs/ONBOARDING.md': `# Onboarding Guide — ml-pipeline

Welcome to the ML Pipeline project. This guide walks you through setting up your local development environment, pulling data with DVC, running experiments, and configuring GPU access.

## Prerequisites

| Tool | Version | Install |
|------|---------|---------|
| Python | 3.11+ | [python.org](https://www.python.org/downloads/) or \`pyenv install 3.11\` |
| uv | latest | \`curl -LsSf https://astral.sh/uv/install.sh \\| sh\` |
| Docker | 24+ | [docs.docker.com](https://docs.docker.com/get-docker/) |
| AWS CLI | 2.x | \`brew install awscli\` or [AWS docs](https://docs.aws.amazon.com/cli/latest/userguide/install-cliv2.html) |
| DVC | 3.x | Installed via \`uv sync\` (project dependency) |
| Git | 2.40+ | \`brew install git\` or system package manager |

Optional for GPU training:
- NVIDIA Driver 535+
- CUDA Toolkit 12.1+
- cuDNN 8.9+

## 1. Clone the Repository

\`\`\`bash
git clone git@github.com:<org>/ml-pipeline.git
cd ml-pipeline
\`\`\`

## 2. Install Dependencies with uv

We use [uv](https://github.com/astral-sh/uv) as our Python package manager. It replaces pip, pip-tools, and virtualenv.

\`\`\`bash
# Install all dependencies (creates .venv automatically)
uv sync

# Verify the environment
uv run python --version   # Should print Python 3.11+
uv run ruff --version
uv run mypy --version
uv run pytest --version
\`\`\`

The virtual environment lives at \`.venv/\` in the project root. All commands should be run via \`uv run <command>\` to ensure the correct environment is used.

### Install Git Hooks

\`\`\`bash
# Set up pre-commit, commit-msg, and pre-push hooks
chmod +x git-hooks/*
git config core.hooksPath git-hooks
\`\`\`

## 3. Configure AWS Credentials

You need AWS access for S3 (DVC remote, MLflow artifacts) and optionally SageMaker/EC2 GPU instances.

\`\`\`bash
# Configure your AWS profile
aws configure --profile ml-pipeline

# Set the profile for this session
export AWS_PROFILE=ml-pipeline

# Verify access to the DVC remote bucket
aws s3 ls s3://ml-pipeline-dvc-remote/ --profile ml-pipeline
\`\`\`

Ask your team lead for:
- AWS IAM credentials (access key + secret key)
- The correct AWS region (check \`configs/infrastructure/aws.yaml\`)
- S3 bucket names for DVC and MLflow artifact stores

> **GDPR Note**: Never store PII or raw customer data on your local machine. All sensitive datasets remain in the encrypted S3 bucket and are accessed through DVC with appropriate access controls.

## 4. Pull Data with DVC

DVC tracks datasets and model artifacts in S3. After cloning, the \`data/\` and \`models/\` directories contain only \`.dvc\` pointer files.

\`\`\`bash
# Pull all DVC-tracked data and models
uv run dvc pull

# Or pull specific stages
uv run dvc pull data/raw.dvc
uv run dvc pull data/processed.dvc

# Verify data is present
ls -la data/raw/
ls -la data/processed/
\`\`\`

### DVC Remote Configuration

The DVC remote is pre-configured in \`.dvc/config\`. If you need to check or modify:

\`\`\`bash
uv run dvc remote list
# Should show: s3remote  s3://ml-pipeline-dvc-remote/

uv run dvc remote modify s3remote region us-east-1
\`\`\`

### Understanding the Data Pipeline

\`\`\`bash
# View the full DVC pipeline DAG
uv run dvc dag

# Reproduce the entire pipeline (data → features → train → evaluate)
uv run dvc repro

# Reproduce a specific stage
uv run dvc repro train
\`\`\`

The pipeline stages are defined in \`dvc.yaml\` at the project root. See [ARCHITECTURE.md](./ARCHITECTURE.md) for the full pipeline diagram.

## 5. Set Up Local Services

### PostgreSQL and Redis (Docker Compose)

MLflow uses PostgreSQL as its backend store. Redis is used for feature caching and serving.

\`\`\`bash
# Start local PostgreSQL and Redis
docker compose up -d postgres redis

# Verify services are running
docker compose ps
\`\`\`

The \`docker-compose.yml\` at the project root defines:
- **PostgreSQL** on \`localhost:5432\` — MLflow backend store, metadata
- **Redis** on \`localhost:6379\` — Feature cache, inference caching

### Environment Variables

Copy the example environment file and fill in your values:

\`\`\`bash
cp .env.example .env
\`\`\`

Edit \`.env\` with your local settings:

\`\`\`bash
# .env (DO NOT commit this file)
MLFLOW_TRACKING_URI=http://localhost:5000
MLFLOW_BACKEND_STORE_URI=postgresql://mlflow:mlflow@localhost:5432/mlflow
MLFLOW_ARTIFACT_ROOT=s3://ml-pipeline-artifacts/
AWS_PROFILE=ml-pipeline
REDIS_URL=redis://localhost:6379/0
DATABASE_URL=postgresql://mlflow:mlflow@localhost:5432/mlflow
ENVIRONMENT=development
\`\`\`

> **Security**: \`.env\` files are in \`.gitignore\`. Never commit secrets. See \`.claude/rules/common/security.md\` for sensitive path policies.

## 6. Start MLflow Tracking Server

\`\`\`bash
# Start the MLflow UI and tracking server
uv run mlflow server \\
  --backend-store-uri postgresql://mlflow:mlflow@localhost:5432/mlflow \\
  --default-artifact-root s3://ml-pipeline-artifacts/ \\
  --host 0.0.0.0 \\
  --port 5000

# Open in browser
open http://localhost:5000
\`\`\`

You should see the MLflow UI with existing experiments. Key experiments to explore:
- \`baseline\` — Initial model benchmarks
- \`hyperparameter-search\` — Optuna-based HP tuning runs
- \`production\` — Models promoted to the model registry

### MLflow Model Registry

Browse registered models at \`http://localhost:5000/#/models\`. Models go through stages:
1. **None** → Experimental runs
2. **Staging** → Passed evaluation thresholds, under review
3. **Production** → Deployed to serving infrastructure
4. **Archived** → Deprecated models

## 7. Run the Test Suite

Verify everything works before making changes:

\`\`\`bash
# Lint check
uv run ruff check src/ tests/

# Type checking
uv run mypy src/

# Unit tests
uv run pytest tests/unit/ -v

# Integration tests (requires Docker services running)
uv run pytest tests/integration/ -v

# Full test suite with coverage
uv run pytest --cov=src --cov-report=term-missing --cov-fail-under=75

# Training smoke test (quick model train to verify pipeline)
uv run pytest tests/smoke/ -v -m smoke
\`\`\`

## 8. Run a Training Experiment

Try running a training experiment to verify the full pipeline:

\`\`\`bash
# Run training with the default config
uv run python -m src.training.train --config configs/experiments/baseline.yaml

# Run with overrides
uv run python -m src.training.train \\
  --config configs/experiments/baseline.yaml \\
  --override model.hidden_dim=256 \\
  --override training.learning_rate=0.001 \\
  --override training.max_epochs=5

# Check results in MLflow
open http://localhost:5000
\`\`\`

### Experiment Config Structure

Configs are YAML files validated by Pydantic. Example (\`configs/experiments/baseline.yaml\`):

\`\`\`yaml
experiment_name: baseline
run_name: baseline-v1

data:
  dataset: customer_churn
  version: v2.1
  split_ratio: [0.7, 0.15, 0.15]
  feature_config: configs/features/default.yaml

model:
  architecture: transformer
  hidden_dim: 128
  num_layers: 4
  dropout: 0.1

training:
  learning_rate: 0.0003
  batch_size: 64
  max_epochs: 50
  early_stopping_patience: 5
  optimizer: adamw
  scheduler: cosine_annealing

evaluation:
  metrics: [accuracy, f1, auc_roc, precision, recall]
  threshold: 0.5
\`\`\`

## 9. Start the Serving API

\`\`\`bash
# Start the FastAPI model serving endpoint
uv run uvicorn src.serving.app:app --reload --host 0.0.0.0 --port 8000

# Health check
curl http://localhost:8000/health

# API docs
open http://localhost:8000/docs

# Test a prediction
curl -X POST http://localhost:8000/predict \\
  -H "Content-Type: application/json" \\
  -d '{"features": {"feature_1": 0.5, "feature_2": 1.2, "feature_3": -0.3}}'
\`\`\`

## 10. GPU Setup (Optional)

### Local GPU (NVIDIA)

If you have a local NVIDIA GPU:

\`\`\`bash
# Verify CUDA is available
uv run python -c "import torch; print(f'CUDA available: {torch.cuda.is_available()}, Device: {torch.cuda.get_device_name(0) if torch.cuda.is_available() else \\"N/A\\"}')"

# Run training on GPU
uv run python -m src.training.train \\
  --config configs/experiments/baseline.yaml \\
  --override training.device=cuda
\`\`\`

### AWS EC2 GPU Instances

For larger experiments, use EC2 GPU instances:

\`\`\`bash
# Launch a GPU instance via our helper script
uv run python scripts/launch_gpu_instance.py \\
  --instance-type g5.xlarge \\
  --experiment-config configs/experiments/large_model.yaml

# SSH into the instance (script outputs the command)
ssh -i ~/.ssh/ml-pipeline.pem ubuntu@<instance-ip>

# Or use the remote training script (launches, trains, syncs results, terminates)
uv run python scripts/remote_train.py \\
  --config configs/experiments/large_model.yaml \\
  --instance-type g5.2xlarge \\
  --spot  # Use spot instances for cost savings
\`\`\`

### AWS SageMaker Training Jobs

For production training:

\`\`\`bash
# Submit a SageMaker training job
uv run python scripts/sagemaker_train.py \\
  --config configs/experiments/production.yaml \\
  --instance-type ml.g5.2xlarge \\
  --instance-count 1
\`\`\`

Results are automatically logged to MLflow. Check the MLflow UI for the run.

### Docker GPU Training

\`\`\`bash
# Build the GPU training image
docker build -f Dockerfile.gpu -t ml-pipeline-gpu .

# Run training in Docker with GPU access
docker run --gpus all \\
  -v $(pwd)/configs:/app/configs \\
  -e MLFLOW_TRACKING_URI=http://host.docker.internal:5000 \\
  -e AWS_PROFILE=ml-pipeline \\
  ml-pipeline-gpu \\
  python -m src.training.train --config configs/experiments/baseline.yaml
\`\`\`

## 11. IDE Setup

### VS Code (Recommended)

Install these extensions:
- **Python** (ms-python.python)
- **Pylance** (ms-python.vscode-pylance)
- **Ruff** (charliermarsh.ruff)
- **Jupyter** (ms-toolsai.jupyter)
- **YAML** (redhat.vscode-yaml)
- **DVC** (iterative.dvc)

The project includes \`.vscode/settings.json\` with pre-configured:
- Ruff as the default formatter and linter
- mypy type checking enabled
- pytest as the test runner
- Python path pointing to \`.venv/\`

### PyCharm

1. Open the project directory
2. Set the Python interpreter to \`.venv/bin/python\`
3. Enable ruff integration under **Settings → Tools → Ruff**
4. Configure pytest as the default test runner

## 12. Using Claude Code

Claude Code is configured for this project. See [CLAUDE.md](../CLAUDE.md) for the full reference.

Key commands:

\`\`\`bash
# Claude understands the project context via .claude/ rules
# Ask Claude to help with:
# - Writing model architectures in src/models/
# - Creating experiment configs
# - Writing tests
# - Debugging training issues
# - Reviewing DVC pipeline changes
\`\`\`

Rules that Claude follows are in:
- \`.claude/rules/common/\` — Security, git workflow, testing, coding style
- \`.claude/rules/python/\` — Python-specific coding style and testing patterns
- \`.claude/settings.json\` — Permissions and tool access

> **AI Code Policy**: All AI-generated code must be marked with \`# AI-generated\` comments and flagged in PRs. See the PR template and CI audit workflow.

## 13. Daily Workflow

\`\`\`bash
# Start of day
git checkout main && git pull
uv sync                          # Update dependencies if pyproject.toml changed
uv run dvc pull                  # Pull latest data/model artifacts
docker compose up -d             # Ensure services are running

# Start working on a task
git checkout -b feat/ML-42-add-transformer-model

# Development loop
uv run ruff check src/ tests/    # Lint
uv run ruff format src/ tests/   # Format
uv run mypy src/                 # Type check
uv run pytest tests/unit/ -v     # Run tests

# Track an experiment
uv run python -m src.training.train --config configs/experiments/my_experiment.yaml

# Review results
open http://localhost:5000        # MLflow UI

# Commit and push
git add -A
git commit -m "feat(models): add transformer architecture for ML-42"
git push -u origin feat/ML-42-add-transformer-model
# Open PR on GitHub
\`\`\`

## 14. Key Documentation

| Document | Location | Description |
|----------|----------|-------------|
| Architecture | [docs/ARCHITECTURE.md](./ARCHITECTURE.md) | System design, pipeline DAG, infrastructure |
| Claude Reference | [CLAUDE.md](../CLAUDE.md) | AI assistant rules and project context |
| Security Rules | [.claude/rules/common/security.md](../.claude/rules/common/security.md) | SOC 2, GDPR, secrets management |
| Git Workflow | [.claude/rules/common/git-workflow.md](../.claude/rules/common/git-workflow.md) | Branching, commits, PR process |
| Coding Style | [.claude/rules/python/coding-style.md](../.claude/rules/python/coding-style.md) | Python conventions, ruff config |
| Testing Guide | [.claude/rules/python/testing.md](../.claude/rules/python/testing.md) | pytest patterns, coverage requirements |
| PR Template | [.github/PULL_REQUEST_TEMPLATE.md](../.github/PULL_REQUEST_TEMPLATE.md) | Required PR checklist |

## Troubleshooting

### \`uv sync\` fails

\`\`\`bash
# Clear the cache and retry
uv cache clean
uv sync --reinstall
\`\`\`

### DVC pull fails with permission error

\`\`\`bash
# Verify AWS credentials
aws sts get-caller-identity --profile ml-pipeline

# Check DVC remote config
uv run dvc remote list
uv run dvc remote modify s3remote profile ml-pipeline
\`\`\`

### MLflow server won't start

\`\`\`bash
# Check if PostgreSQL is running
docker compose ps postgres
docker compose logs postgres

# Reset the MLflow database
docker compose exec postgres psql -U mlflow -c "DROP DATABASE mlflow; CREATE DATABASE mlflow;"
\`\`\`

### CUDA out of memory

\`\`\`bash
# Reduce batch size in your config
uv run python -m src.training.train \\
  --config configs/experiments/baseline.yaml \\
  --override training.batch_size=16

# Or use gradient accumulation
uv run python -m src.training.train \\
  --config configs/experiments/baseline.yaml \\
  --override training.gradient_accumulation_steps=4
\`\`\`

### Tests fail on import errors

\`\`\`bash
# Ensure you're running via uv
uv run pytest tests/ -v

# Check the virtual environment
uv run python -c "import src; print(src.__file__)"
\`\`\`

## Getting Help

- **Slack**: \`#ml-pipeline\` channel for team questions
- **GitHub Issues**: File bugs and feature requests using the [issue templates](../.github/ISSUE_TEMPLATE/)
- **MLflow UI**: \`http://localhost:5000\` for experiment results
- **Grafana**: Check with your lead for the monitoring dashboard URL
- **Team Lead**: For AWS access, production configs, and architecture decisions`,

  'git-hooks/commit-msg': `#!/usr/bin/env bash
#
# commit-msg hook — validates conventional commit format for ml-pipeline
# Enforces: type(scope): description
# Valid types: feat, fix, chore, docs, experiment, refactor, test, ci, perf, build
# The "experiment:" type is ML-specific for tracking experiment changes.

set -euo pipefail

COMMIT_MSG_FILE="$1"
COMMIT_MSG=$(head -1 "$COMMIT_MSG_FILE")

# Skip merge commits and fixup/squash commits
if echo "$COMMIT_MSG" | grep -qE "^(Merge|Revert|fixup!|squash!)"; then
    exit 0
fi

# Valid conventional commit types (experiment is ML-specific)
VALID_TYPES="feat|fix|chore|docs|experiment|refactor|test|ci|perf|build"

# Pattern: type(optional-scope): description
# or:      type: description
# or:      type!: description (breaking change)
PATTERN="^(\${VALID_TYPES})(\\([a-z0-9_/-]+\\))?!?: .{1,}"

if ! echo "$COMMIT_MSG" | grep -qE "$PATTERN"; then
    echo ""
    echo "ERROR: Invalid commit message format."
    echo ""
    echo "  Got: $COMMIT_MSG"
    echo ""
    echo "  Expected: <type>(<scope>): <description>"
    echo ""
    echo "  Valid types:"
    echo "    feat        — New feature or model capability"
    echo "    fix         — Bug fix"
    echo "    experiment  — ML experiment change (config, hyperparams, architecture)"
    echo "    refactor    — Code refactor without behavior change"
    echo "    docs        — Documentation updates"
    echo "    test        — Adding or updating tests"
    echo "    chore       — Maintenance, dependency updates"
    echo "    ci          — CI/CD pipeline changes"
    echo "    perf        — Performance improvement"
    echo "    build       — Build system or Docker changes"
    echo ""
    echo "  Examples:"
    echo "    feat(models): add transformer encoder for sequence classification"
    echo "    experiment(training): tune learning rate schedule for ResNet"
    echo "    fix(serving): handle missing features in inference request"
    echo "    docs: update experiment tracking runbook"
    echo ""
    exit 1
fi

# Validate description is not empty after the colon
DESCRIPTION=$(echo "$COMMIT_MSG" | sed -E "s/^(\${VALID_TYPES})(\\([a-z0-9_/-]+\\))?!?: //")
if [ -z "$DESCRIPTION" ]; then
    echo "ERROR: Commit description cannot be empty."
    exit 1
fi

# Validate description starts with lowercase (conventional commit style)
if echo "$DESCRIPTION" | grep -qE "^[A-Z]"; then
    echo "ERROR: Commit description should start with lowercase."
    echo "  Got: $DESCRIPTION"
    exit 1
fi

# Warn on long subject lines (soft limit 72, hard limit 100)
MSG_LENGTH=\${#COMMIT_MSG}
if [ "$MSG_LENGTH" -gt 100 ]; then
    echo "ERROR: Subject line too long (\${MSG_LENGTH} chars, max 100)."
    exit 1
elif [ "$MSG_LENGTH" -gt 72 ]; then
    echo "WARNING: Subject line is \${MSG_LENGTH} chars (recommended max: 72)."
fi

exit 0`,

  'git-hooks/pre-commit': `#!/usr/bin/env bash
# Pre-commit hook for ml-pipeline
# Runs ruff check, ruff format, mypy, and prevents data/model files from being committed
# Install: ln -sf ../../git-hooks/pre-commit .git/hooks/pre-commit && chmod +x .git/hooks/pre-commit

set -euo pipefail

RED='\\033[0;31m'
GREEN='\\033[0;32m'
YELLOW='\\033[1;33m'
NC='\\033[0m'

FAILED=0

echo "🔍 Running pre-commit checks..."
echo ""

# Get staged Python files
STAGED_PY_FILES=$(git diff --cached --name-only --diff-filter=ACM | grep '\\.py$' || true)

# ---------------------------------------------------------------------------
# 1. Prevent data files, model artifacts, and secrets from being committed
# ---------------------------------------------------------------------------
echo "📦 Checking for prohibited files in staging area..."

PROHIBITED_PATTERNS=(
    "data/raw/"
    "data/processed/"
    "data/features/"
    "models/*.pt"
    "models/*.pth"
    "models/*.onnx"
    "models/*.pkl"
    "models/*.joblib"
    "*.parquet"
    "*.csv"
    "*.h5"
    "*.hdf5"
    "*.arrow"
    "*.feather"
    "*.tar.gz"
    "*.zip"
)

SECRET_PATTERNS=(
    ".env"
    ".env.*"
    "*.pem"
    "*.key"
    "aws_credentials"
    "credentials.json"
    "configs/production/**"
)

STAGED_FILES=$(git diff --cached --name-only --diff-filter=ACM)
BLOCKED_FILES=""

for pattern in "\${PROHIBITED_PATTERNS[@]}"; do
    matched=$(echo "$STAGED_FILES" | grep -E "^\${pattern//\\*/.*}$" 2>/dev/null || true)
    if [[ -n "$matched" ]]; then
        BLOCKED_FILES="\${BLOCKED_FILES}\${matched}\\n"
    fi
done

for pattern in "\${SECRET_PATTERNS[@]}"; do
    matched=$(echo "$STAGED_FILES" | grep -E "^\${pattern//\\*/.*}$" 2>/dev/null || true)
    if [[ -n "$matched" ]]; then
        BLOCKED_FILES="\${BLOCKED_FILES}\${matched}\\n"
    fi
done

# Check for large files (>5MB) that might be data or model artifacts
while IFS= read -r file; do
    if [[ -n "$file" && -f "$file" ]]; then
        file_size=$(wc -c < "$file" 2>/dev/null || echo "0")
        if [[ "$file_size" -gt 5242880 ]]; then
            BLOCKED_FILES="\${BLOCKED_FILES}\${file} ($(( file_size / 1048576 ))MB - exceeds 5MB limit)\\n"
        fi
    fi
done <<< "$STAGED_FILES"

if [[ -n "$BLOCKED_FILES" ]]; then
    echo -e "\${RED}✗ Prohibited files detected in staging area:\${NC}"
    echo -e "\${RED}$(echo -e "$BLOCKED_FILES" | sed '/^$/d' | sed 's/^/    /')\${NC}"
    echo ""
    echo -e "\${YELLOW}  Data and model files must be tracked with DVC, not git.\${NC}"
    echo -e "\${YELLOW}  Use: dvc add <file> && git add <file>.dvc .gitignore\${NC}"
    echo -e "\${YELLOW}  Secrets and production configs must never be committed (SOC 2).\${NC}"
    echo ""
    FAILED=1
fi

# Check for GDPR-sensitive patterns in staged content
if [[ -n "$STAGED_PY_FILES" ]]; then
    PII_PATTERNS="(social.security|ssn|date.of.birth|passport|credit.card|national.id)"
    PII_MATCHES=""
    for file in $STAGED_PY_FILES; do
        matched=$(git diff --cached "$file" | grep -iE "$PII_PATTERNS" 2>/dev/null || true)
        if [[ -n "$matched" ]]; then
            PII_MATCHES="\${PII_MATCHES}  \${file}\\n"
        fi
    done
    if [[ -n "$PII_MATCHES" ]]; then
        echo -e "\${YELLOW}⚠ Potential PII references detected (GDPR compliance review needed):\${NC}"
        echo -e "\${YELLOW}$(echo -e "$PII_MATCHES" | sed '/^$/d')\${NC}"
        echo -e "\${YELLOW}  Ensure data is anonymized/pseudonymized before processing.\${NC}"
        echo ""
    fi
fi

if [[ -z "$STAGED_PY_FILES" ]]; then
    if [[ "$FAILED" -eq 1 ]]; then
        echo -e "\${RED}Pre-commit checks failed.\${NC}"
        exit 1
    fi
    echo -e "\${GREEN}✓ No Python files staged. Skipping lint/format/type checks.\${NC}"
    exit 0
fi

STAGED_PY_LIST=$(echo "$STAGED_PY_FILES" | tr '\\n' ' ')
echo -e "\${GREEN}✓ File check passed\${NC}"
echo ""

# ---------------------------------------------------------------------------
# 2. Ruff linting
# ---------------------------------------------------------------------------
echo "🔧 Running ruff check..."

if command -v uv &>/dev/null; then
    RUNNER="uv run"
elif [[ -f ".venv/bin/ruff" ]]; then
    RUNNER=".venv/bin"
    RUNNER="" # fall through to direct command
fi

if ! uv run ruff check $STAGED_PY_LIST; then
    echo -e "\${RED}✗ Ruff linting failed\${NC}"
    echo -e "\${YELLOW}  Fix: uv run ruff check --fix src/ tests/\${NC}"
    FAILED=1
else
    echo -e "\${GREEN}✓ Ruff linting passed\${NC}"
fi
echo ""

# ---------------------------------------------------------------------------
# 3. Ruff formatting check
# ---------------------------------------------------------------------------
echo "🎨 Running ruff format check..."

if ! uv run ruff format --check $STAGED_PY_LIST; then
    echo -e "\${RED}✗ Ruff format check failed\${NC}"
    echo -e "\${YELLOW}  Fix: uv run ruff format src/ tests/\${NC}"
    FAILED=1
else
    echo -e "\${GREEN}✓ Ruff format check passed\${NC}"
fi
echo ""

# ---------------------------------------------------------------------------
# 4. Mypy type checking
# ---------------------------------------------------------------------------
echo "🔬 Running mypy type check..."

# Only run mypy on src/ and tests/ files to respect mypy config boundaries
MYPY_FILES=$(echo "$STAGED_PY_FILES" | grep -E "^(src/|tests/)" || true)

if [[ -n "$MYPY_FILES" ]]; then
    MYPY_FILE_LIST=$(echo "$MYPY_FILES" | tr '\\n' ' ')
    if ! uv run mypy $MYPY_FILE_LIST; then
        echo -e "\${RED}✗ Mypy type check failed\${NC}"
        echo -e "\${YELLOW}  Fix: uv run mypy src/\${NC}"
        echo -e "\${YELLOW}  All public functions require type hints.\${NC}"
        FAILED=1
    else
        echo -e "\${GREEN}✓ Mypy type check passed\${NC}"
    fi
else
    echo -e "\${GREEN}✓ No src/tests Python files to type check\${NC}"
fi
echo ""

# ---------------------------------------------------------------------------
# 5. Check for notebook outputs (prevent large diffs)
# ---------------------------------------------------------------------------
STAGED_NOTEBOOKS=$(git diff --cached --name-only --diff-filter=ACM | grep '\\.ipynb$' || true)

if [[ -n "$STAGED_NOTEBOOKS" ]]; then
    echo "📓 Checking notebooks for cleared outputs..."
    for notebook in $STAGED_NOTEBOOKS; do
        output_cells=$(git diff --cached "$notebook" | grep -c '"output_type"' 2>/dev/null || echo "0")
        if [[ "$output_cells" -gt 0 ]]; then
            echo -e "\${YELLOW}⚠ Notebook '$notebook' contains cell outputs.\${NC}"
            echo -e "\${YELLOW}  Clear outputs before committing: jupyter nbconvert --clear-output --inplace $notebook\${NC}"
            echo -e "\${YELLOW}  Reminder: Notebooks are for exploration only — production code belongs in src/\${NC}"
            FAILED=1
        fi
    done
    if [[ "$FAILED" -eq 0 ]]; then
        echo -e "\${GREEN}✓ Notebook outputs cleared\${NC}"
    fi
    echo ""
fi

# ---------------------------------------------------------------------------
# 6. Check for AI-generated code markers (CI/CD policy)
# ---------------------------------------------------------------------------
if [[ -n "$STAGED_PY_FILES" ]]; then
    UNMARKED_AI_FILES=""
    for file in $STAGED_PY_FILES; do
        diff_content=$(git diff --cached "$file")
        # Check if diff contains common AI patterns but lacks AI marker
        has_ai_marker=$(echo "$diff_content" | grep -c "AI-generated\\|ai-generated\\|Generated by Claude\\|Copilot" 2>/dev/null || echo "0")
        # This is informational only — not blocking
    done
fi

# ---------------------------------------------------------------------------
# Summary
# ---------------------------------------------------------------------------
echo "━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━"
if [[ "$FAILED" -eq 1 ]]; then
    echo -e "\${RED}❌ Pre-commit checks failed. Please fix the issues above.\${NC}"
    echo -e "\${YELLOW}   To bypass (not recommended): git commit --no-verify\${NC}"
    exit 1
else
    echo -e "\${GREEN}✅ All pre-commit checks passed.\${NC}"
    exit 0
fi`,

  'git-hooks/pre-push': `#!/usr/bin/env bash
# Pre-push hook for ml-pipeline
# Runs pytest suite and blocks push on test failure
# Install: cp git-hooks/pre-push .git/hooks/pre-push && chmod +x .git/hooks/pre-push

set -euo pipefail

YELLOW='\\033[0;33m'
RED='\\033[0;31m'
GREEN='\\033[0;32m'
CYAN='\\033[0;36m'
NC='\\033[0m'

info() { echo -e "\${CYAN}[pre-push]\${NC} $1"; }
warn() { echo -e "\${YELLOW}[pre-push]\${NC} $1"; }
error() { echo -e "\${RED}[pre-push]\${NC} $1"; }
success() { echo -e "\${GREEN}[pre-push]\${NC} $1"; }

# Allow skipping with SKIP_PRE_PUSH=1 git push (escape hatch for hotfixes)
if [ "\${SKIP_PRE_PUSH:-0}" = "1" ]; then
    warn "Pre-push checks skipped via SKIP_PRE_PUSH=1"
    warn "Ensure CI passes before merging."
    exit 0
fi

# Detect protected branch pushes
remote="$1"
url="$2"

while read -r local_ref local_oid remote_ref remote_oid; do
    if [ "$local_ref" = "refs/heads/main" ]; then
        error "Direct push to 'main' is blocked. Use a pull request."
        error "Branch naming: type/ticket-desc (e.g., feat/ML-42-add-transformer-model)"
        exit 1
    fi
done

# Verify uv is available
if ! command -v uv &> /dev/null; then
    error "uv not found. Install: https://docs.astral.sh/uv/getting-started/installation/"
    exit 1
fi

FAILED=0

# --------------------------------------------------------------------------
# Stage 1: Type checking with mypy
# --------------------------------------------------------------------------
info "Running mypy type checks on src/..."
if uv run mypy src/ --no-error-summary 2>/dev/null; then
    success "mypy passed"
else
    error "mypy found type errors. Fix before pushing."
    FAILED=1
fi

# --------------------------------------------------------------------------
# Stage 2: Ruff lint check (catch anything pre-commit missed)
# --------------------------------------------------------------------------
info "Running ruff lint check..."
if uv run ruff check src/ tests/ scripts/ --no-fix 2>/dev/null; then
    success "ruff check passed"
else
    error "ruff found lint issues. Run: uv run ruff check --fix src/ tests/ scripts/"
    FAILED=1
fi

# --------------------------------------------------------------------------
# Stage 3: Unit tests with pytest
# --------------------------------------------------------------------------
info "Running pytest unit tests..."
if uv run pytest tests/ \\
    -x \\
    --timeout=120 \\
    --ignore=tests/integration \\
    --ignore=tests/e2e \\
    -q \\
    --tb=short \\
    --no-header \\
    --cov=src \\
    --cov-fail-under=75 \\
    2>/dev/null; then
    success "pytest passed (coverage >= 75%)"
else
    error "Tests failed or coverage below 75%. Fix before pushing."
    error "Run locally: uv run pytest tests/ -x --cov=src --cov-fail-under=75"
    FAILED=1
fi

# --------------------------------------------------------------------------
# Stage 4: Check for sensitive data leaks
# --------------------------------------------------------------------------
info "Scanning for sensitive data in staged commits..."

SENSITIVE_PATTERNS=(
    'AWS_SECRET_ACCESS_KEY'
    'MLFLOW_TRACKING_PASSWORD'
    'DATABASE_URL.*postgresql://'
    'REDIS_PASSWORD'
    'sk-[a-zA-Z0-9]{20,}'
    'AKIA[0-9A-Z]{16}'
    'password\\s*=\\s*["\\x27][^"\\x27]+'
)

# Check diff between local and remote for the current branch
CURRENT_BRANCH=$(git rev-parse --abbrev-ref HEAD)
REMOTE_REF="refs/remotes/\${remote}/\${CURRENT_BRANCH}"

if git rev-parse --verify "$REMOTE_REF" &>/dev/null; then
    DIFF_RANGE="\${REMOTE_REF}..HEAD"
else
    # New branch — check all commits since branching from main
    MERGE_BASE=$(git merge-base HEAD origin/main 2>/dev/null || echo "")
    if [ -n "$MERGE_BASE" ]; then
        DIFF_RANGE="\${MERGE_BASE}..HEAD"
    else
        DIFF_RANGE="HEAD~5..HEAD"
    fi
fi

SECRETS_FOUND=0
for pattern in "\${SENSITIVE_PATTERNS[@]}"; do
    if git diff "$DIFF_RANGE" 2>/dev/null | grep -qEi "$pattern"; then
        error "Potential secret detected matching pattern: $pattern"
        SECRETS_FOUND=1
    fi
done

if [ "$SECRETS_FOUND" -eq 1 ]; then
    error "Sensitive data detected in commits. Remove secrets before pushing."
    error "Use environment variables or AWS Secrets Manager for credentials."
    error "GDPR/SOC 2 compliance requires no secrets in source control."
    FAILED=1
else
    success "No sensitive data patterns detected"
fi

# --------------------------------------------------------------------------
# Stage 5: Verify DVC pipeline integrity (if dvc.yaml changed)
# --------------------------------------------------------------------------
if git diff --name-only "$DIFF_RANGE" 2>/dev/null | grep -q "dvc\\.\\(yaml\\|lock\\)"; then
    info "DVC pipeline files changed — validating..."
    if command -v dvc &> /dev/null; then
        if dvc status 2>/dev/null | grep -q "changed"; then
            warn "DVC pipeline has uncommitted changes. Run: dvc repro && dvc push"
            warn "Ensure dvc.lock is committed for reproducibility."
        else
            success "DVC pipeline is up to date"
        fi
    else
        warn "DVC not installed — skipping pipeline validation"
    fi
fi

# --------------------------------------------------------------------------
# Stage 6: Check experiment config validity (Pydantic schemas)
# --------------------------------------------------------------------------
CHANGED_CONFIGS=$(git diff --name-only "$DIFF_RANGE" 2>/dev/null | grep "^configs/.*\\.ya\\?ml$" || true)
if [ -n "$CHANGED_CONFIGS" ]; then
    info "Validating changed experiment configs..."
    if [ -f "scripts/validate_configs.py" ]; then
        if echo "$CHANGED_CONFIGS" | xargs uv run python scripts/validate_configs.py 2>/dev/null; then
            success "Experiment configs are valid"
        else
            error "Invalid experiment config detected. Validate with Pydantic schemas."
            FAILED=1
        fi
    else
        warn "scripts/validate_configs.py not found — skipping config validation"
    fi
fi

# --------------------------------------------------------------------------
# Stage 7: Check model artifact references (no large files in git)
# --------------------------------------------------------------------------
info "Checking for large files that should be DVC-tracked..."
LARGE_FILES=$(git diff --name-only "$DIFF_RANGE" 2>/dev/null | while read -r file; do
    if [ -f "$file" ]; then
        size=$(wc -c < "$file" 2>/dev/null || echo 0)
        if [ "$size" -gt 10485760 ]; then  # 10MB
            echo "$file ($(( size / 1048576 ))MB)"
        fi
    fi
done)

if [ -n "$LARGE_FILES" ]; then
    error "Large files detected that should be tracked with DVC:"
    echo "$LARGE_FILES" | while read -r line; do
        error "  $line"
    done
    error "Add to DVC: dvc add <file> && git add <file>.dvc"
    FAILED=1
else
    success "No oversized files detected"
fi

# --------------------------------------------------------------------------
# Summary
# --------------------------------------------------------------------------
echo ""
if [ "$FAILED" -ne 0 ]; then
    error "========================================="
    error "  Pre-push checks FAILED. Push blocked."
    error "========================================="
    error ""
    error "Fix the issues above and try again."
    error "Emergency override: SKIP_PRE_PUSH=1 git push"
    exit 1
fi

success "========================================="
success "  All pre-push checks passed!"
success "========================================="
exit 0`,

  'install.sh': `#!/usr/bin/env bash
set -euo pipefail

# ml-pipeline installer
# Sets up the development environment for the ML pipeline project

SCRIPT_DIR="$(cd "$(dirname "\${BASH_SOURCE[0]}")" && pwd)"
cd "$SCRIPT_DIR"

# Colors for output
RED='\\033[0;31m'
GREEN='\\033[0;32m'
YELLOW='\\033[1;33m'
BLUE='\\033[0;34m'
NC='\\033[0m' # No Color

info() { echo -e "\${BLUE}[INFO]\${NC} $*"; }
success() { echo -e "\${GREEN}[OK]\${NC} $*"; }
warn() { echo -e "\${YELLOW}[WARN]\${NC} $*"; }
error() { echo -e "\${RED}[ERROR]\${NC} $*"; }

# Track failures for summary
FAILURES=()

step_failed() {
    FAILURES+=("$1")
    error "$1 — continuing with remaining steps"
}

header() {
    echo ""
    echo -e "\${BLUE}━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\${NC}"
    echo -e "\${BLUE}  ml-pipeline — Development Environment Setup\${NC}"
    echo -e "\${BLUE}━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\${NC}"
    echo ""
}

# ─────────────────────────────────────────────────────────────
# 1. Prerequisites check
# ─────────────────────────────────────────────────────────────
check_prerequisites() {
    info "Checking prerequisites..."

    # Python 3.11+
    if command -v python3 &>/dev/null; then
        PYTHON_VERSION=$(python3 -c 'import sys; print(f"{sys.version_info.major}.{sys.version_info.minor}")')
        PYTHON_MAJOR=$(echo "$PYTHON_VERSION" | cut -d. -f1)
        PYTHON_MINOR=$(echo "$PYTHON_VERSION" | cut -d. -f2)
        if [[ "$PYTHON_MAJOR" -ge 3 && "$PYTHON_MINOR" -ge 11 ]]; then
            success "Python $PYTHON_VERSION detected"
        else
            error "Python 3.11+ required, found $PYTHON_VERSION"
            echo "  Install via: brew install python@3.11  OR  pyenv install 3.11"
            exit 1
        fi
    else
        error "Python 3 not found"
        echo "  Install via: brew install python@3.11  OR  pyenv install 3.11"
        exit 1
    fi

    # Git
    if command -v git &>/dev/null; then
        success "Git $(git --version | awk '{print $3}') detected"
    else
        error "Git not found — install git first"
        exit 1
    fi

    # Docker (optional but recommended)
    if command -v docker &>/dev/null; then
        success "Docker detected"
    else
        warn "Docker not found — needed for containerized training and serving"
    fi

    # AWS CLI (optional)
    if command -v aws &>/dev/null; then
        success "AWS CLI detected"
    else
        warn "AWS CLI not found — needed for S3, SageMaker, ECR access"
        echo "  Install via: brew install awscli  OR  pip install awscli"
    fi
}

# ─────────────────────────────────────────────────────────────
# 2. Install uv (fast Python package manager)
# ─────────────────────────────────────────────────────────────
install_uv() {
    info "Checking for uv package manager..."

    if command -v uv &>/dev/null; then
        UV_VERSION=$(uv --version 2>&1 | head -1)
        success "uv already installed: $UV_VERSION"
    else
        info "Installing uv..."
        if curl -LsSf https://astral.sh/uv/install.sh | sh; then
            # Add to current PATH
            export PATH="$HOME/.local/bin:$HOME/.cargo/bin:$PATH"
            if command -v uv &>/dev/null; then
                success "uv installed: $(uv --version 2>&1 | head -1)"
            else
                step_failed "uv installed but not found in PATH — add ~/.local/bin or ~/.cargo/bin to PATH"
                return
            fi
        else
            step_failed "Failed to install uv — install manually: https://docs.astral.sh/uv/"
            return
        fi
    fi
}

# ─────────────────────────────────────────────────────────────
# 3. Install Python dependencies
# ─────────────────────────────────────────────────────────────
install_dependencies() {
    info "Installing Python dependencies with uv..."

    if ! command -v uv &>/dev/null; then
        step_failed "uv not available — skipping dependency installation"
        return
    fi

    if [[ -f "pyproject.toml" ]]; then
        # Create virtual environment if it doesn't exist
        if [[ ! -d ".venv" ]]; then
            info "Creating virtual environment..."
            uv venv --python 3.11
        fi

        # Install all dependencies including dev extras
        info "Installing project dependencies (this may take a few minutes for PyTorch)..."
        if uv sync --all-extras; then
            success "Dependencies installed"
        else
            step_failed "Dependency installation failed — check pyproject.toml"
            return
        fi

        # Verify critical packages
        info "Verifying critical packages..."
        local packages=("torch" "mlflow" "fastapi" "pydantic" "dvc")
        for pkg in "\${packages[@]}"; do
            if uv run python -c "import $pkg" 2>/dev/null; then
                success "  $pkg — OK"
            else
                warn "  $pkg — not importable (may need extra install steps)"
            fi
        done
    else
        step_failed "pyproject.toml not found — cannot install dependencies"
    fi
}

# ─────────────────────────────────────────────────────────────
# 4. Set up Git hooks
# ─────────────────────────────────────────────────────────────
setup_git_hooks() {
    info "Setting up Git hooks..."

    if [[ ! -d ".git" ]]; then
        warn "Not a git repository — initializing..."
        git init
    fi

    # Configure git hooks path
    git config core.hooksPath git-hooks

    # Ensure hooks are executable
    if [[ -d "git-hooks" ]]; then
        chmod +x git-hooks/*
        success "Git hooks configured (core.hooksPath = git-hooks)"

        # List installed hooks
        for hook in git-hooks/*; do
            if [[ -f "$hook" ]]; then
                hook_name=$(basename "$hook")
                success "  $hook_name — installed"
            fi
        done
    else
        step_failed "git-hooks/ directory not found"
    fi
}

# ─────────────────────────────────────────────────────────────
# 5. Configure .claude/ directory
# ─────────────────────────────────────────────────────────────
setup_claude() {
    info "Configuring Claude Code settings..."

    # Verify .claude directory structure
    local required_files=(
        ".claude/settings.json"
        ".claude/rules/common/git-workflow.md"
        ".claude/rules/common/testing.md"
        ".claude/rules/python/coding-style.md"
        ".claude/rules/python/testing.md"
    )

    local all_present=true
    for f in "\${required_files[@]}"; do
        if [[ -f "$f" ]]; then
            success "  $f — present"
        else
            warn "  $f — missing"
            all_present=false
        fi
    done

    # Create CLAUDE.md if it doesn't exist
    if [[ ! -f "CLAUDE.md" ]]; then
        info "Creating CLAUDE.md project instructions..."
        cat > CLAUDE.md << 'CLAUDE_EOF'
# CLAUDE.md — ml-pipeline

## Project Overview
End-to-end ML pipeline: PyTorch training, MLflow tracking, DVC data versioning, FastAPI serving.

## Quick Commands
- \`uv run pytest\` — run tests
- \`uv run ruff check src/ tests/\` — lint
- \`uv run ruff format src/ tests/\` — format
- \`uv run mypy src/\` — type check
- \`dvc repro\` — reproduce full pipeline
- \`mlflow ui\` — launch experiment tracker (http://localhost:5000)
- \`uv run uvicorn src.serving.app:app --reload\` — run API server

## Key Rules
- Type hints on ALL public functions
- Pydantic for config validation
- Experiments tracked in MLflow with reproducible YAML configs
- DVC for data and model artifacts — never commit data/ or models/ to git
- Notebooks for exploration only — production code lives in src/
- Pin all dependency versions in pyproject.toml
- Max 300 lines per file
- snake_case for files/functions, PascalCase for classes, SCREAMING_SNAKE_CASE for constants
- Conventional commits: feat:, fix:, chore:, docs:, experiment:

## Architecture
See docs/ARCHITECTURE.md for full system design.

## Compliance
- SOC 2: audit logging, access controls, model artifact integrity
- GDPR: data anonymization, consent tracking, right to deletion support
CLAUDE_EOF
        success "CLAUDE.md created"
    else
        success "CLAUDE.md already exists"
    fi

    if $all_present; then
        success "Claude Code configuration complete"
    else
        warn "Some Claude config files missing — check .claude/ directory"
    fi
}

# ─────────────────────────────────────────────────────────────
# 6. Install CodeForge plugin
# ─────────────────────────────────────────────────────────────
install_plugin() {
    info "Setting up CodeForge ML Pipeline plugin..."

    local plugin_dir="plugin/codeforge-ml-pipeline"

    if [[ -d "$plugin_dir" ]]; then
        success "Plugin directory exists: $plugin_dir"

        # Check for plugin manifest
        if [[ -f "$plugin_dir/manifest.json" ]]; then
            success "  manifest.json — present"
        else
            warn "  manifest.json — not found (plugin may not be fully configured)"
        fi

        # List plugin contents
        local count
        count=$(find "$plugin_dir" -type f | wc -l | tr -d ' ')
        info "  Plugin contains $count files"
    else
        info "Creating plugin directory structure..."
        mkdir -p "$plugin_dir/agents"
        mkdir -p "$plugin_dir/commands"
        mkdir -p "$plugin_dir/skills"
        success "Plugin directory created: $plugin_dir"
    fi
}

# ─────────────────────────────────────────────────────────────
# 7. Set up DVC
# ─────────────────────────────────────────────────────────────
setup_dvc() {
    info "Setting up DVC (Data Version Control)..."

    if ! command -v uv &>/dev/null; then
        step_failed "uv not available — skipping DVC setup"
        return
    fi

    # Check if DVC is available
    if ! uv run dvc version &>/dev/null 2>&1; then
        warn "DVC not available in environment — will be available after dependency install"
        return
    fi

    # Initialize DVC if not already done
    if [[ ! -d ".dvc" ]]; then
        info "Initializing DVC..."
        if uv run dvc init; then
            success "DVC initialized"
        else
            step_failed "DVC initialization failed"
            return
        fi
    else
        success "DVC already initialized"
    fi

    # Create DVC data directories
    local dvc_dirs=("data/raw" "data/processed" "data/features" "models/checkpoints" "models/production")
    for dir in "\${dvc_dirs[@]}"; do
        mkdir -p "$dir"
        # Add .gitkeep so directories are tracked by git
        if [[ ! -f "$dir/.gitkeep" ]]; then
            touch "$dir/.gitkeep"
        fi
    done
    success "DVC data directories created"

    # Configure S3 remote if AWS credentials are available
    if command -v aws &>/dev/null && aws sts get-caller-identity &>/dev/null 2>&1; then
        info "AWS credentials detected"
        # Check if remote is already configured
        if uv run dvc remote list 2>/dev/null | grep -q "s3remote"; then
            success "DVC S3 remote already configured"
        else
            info "To configure DVC S3 remote, run:"
            echo "  uv run dvc remote add -d s3remote s3://your-bucket/ml-pipeline/dvc-store"
            echo "  uv run dvc remote modify s3remote region us-east-1"
        fi
    else
        info "AWS credentials not configured — DVC S3 remote setup skipped"
        echo "  Configure later with:"
        echo "  uv run dvc remote add -d s3remote s3://your-bucket/ml-pipeline/dvc-store"
    fi

    # Create a basic dvc.yaml if it doesn't exist
    if [[ ! -f "dvc.yaml" ]]; then
        info "Creating dvc.yaml pipeline definition..."
        cat > dvc.yaml << 'DVC_EOF'
stages:
  prepare_data:
    cmd: uv run python -m src.data.prepare
    deps:
      - src/data/prepare.py
      - data/raw/
      - configs/data.yaml
    outs:
      - data/processed/
    params:
      - configs/data.yaml:

  feature_engineering:
    cmd: uv run python -m src.data.features
    deps:
      - src/data/features.py
      - data/processed/
      - configs/features.yaml
    outs:
      - data/features/
    params:
      - configs/features.yaml:

  train:
    cmd: uv run python -m src.training.train
    deps:
      - src/training/train.py
      - src/models/
      - data/features/
      - configs/model.yaml
      - configs/training.yaml
    outs:
      - models/checkpoints/:
          persist: true
    params:
      - configs/model.yaml:
      - configs/training.yaml:
    plots:
      - reports/metrics.json:
          cache: false

  evaluate:
    cmd: uv run python -m src.evaluation.evaluate
    deps:
      - src/evaluation/evaluate.py
      - models/checkpoints/
      - data/features/
      - configs/evaluation.yaml
    metrics:
      - reports/evaluation.json:
          cache: false
    plots:
      - reports/plots/:
          cache: false
    params:
      - configs/evaluation.yaml:
DVC_EOF
        success "dvc.yaml created with pipeline stages: prepare_data → feature_engineering → train → evaluate"
    else
        success "dvc.yaml already exists"
    fi
}

# ─────────────────────────────────────────────────────────────
# 8. Set up MLflow
# ─────────────────────────────────────────────────────────────
setup_mlflow() {
    info "Setting up MLflow experiment tracking..."

    # Create MLflow directories
    mkdir -p mlruns
    mkdir -p reports/plots

    # Create configs directory with example experiment config
    mkdir -p configs/production configs/staging configs/experiments

    if [[ ! -f "configs/experiments/example.yaml" ]]; then
        cat > configs/experiments/example.yaml << 'MLFLOW_EOF'
# Example experiment configuration
# All experiments must use Pydantic-validated YAML configs for reproducibility

experiment:
  name: "baseline-classifier"
  tags:
    project: "ml-pipeline"
    owner: "ml-team"

data:
  dataset: "data/features/train.parquet"
  val_split: 0.2
  test_split: 0.1
  random_seed: 42

model:
  architecture: "transformer"
  hidden_dim: 256
  num_layers: 4
  dropout: 0.1

training:
  epochs: 50
  batch_size: 64
  learning_rate: 0.001
  weight_decay: 0.01
  scheduler: "cosine"
  warmup_steps: 100
  early_stopping_patience: 5
  gradient_clip_norm: 1.0

evaluation:
  metrics:
    - accuracy
    - f1_macro
    - auc_roc
  threshold: 0.5
MLFLOW_EOF
        success "Example experiment config created: configs/experiments/example.yaml"
    fi

    # Create MLflow configuration
    if [[ ! -f "configs/mlflow.yaml" ]]; then
        cat > configs/mlflow.yaml << 'MLCONF_EOF'
# MLflow configuration
# Backend store: PostgreSQL (production) or SQLite (local dev)
# Artifact store: S3 (production) or local (dev)

local:
  tracking_uri: "sqlite:///mlruns/mlflow.db"
  artifact_location: "./mlruns/artifacts"

staging:
  tracking_uri: "\${MLFLOW_TRACKING_URI}"
  artifact_location: "s3://ml-pipeline-staging/mlflow-artifacts"

production:
  tracking_uri: "\${MLFLOW_TRACKING_URI}"
  artifact_location: "s3://ml-pipeline-prod/mlflow-artifacts"
  registry_uri: "\${MLFLOW_TRACKING_URI}"
MLCONF_EOF
        success "MLflow config created: configs/mlflow.yaml"
    fi

    success "MLflow setup complete — run 'mlflow ui' to launch the tracking UI"
}

# ─────────────────────────────────────────────────────────────
# 9. Create project scaffolding
# ─────────────────────────────────────────────────────────────
create_scaffolding() {
    info "Creating project scaffolding..."

    # Source directories with __init__.py
    local src_dirs=(
        "src"
        "src/data"
        "src/models"
        "src/training"
        "src/evaluation"
        "src/serving"
        "src/utils"
    )

    for dir in "\${src_dirs[@]}"; do
        mkdir -p "$dir"
        if [[ ! -f "$dir/__init__.py" ]]; then
            echo '"""'"$(basename "$dir")"' module."""' > "$dir/__init__.py"
        fi
    done
    success "Source directories created with __init__.py"

    # Test directories
    local test_dirs=(
        "tests"
        "tests/unit"
        "tests/integration"
        "tests/unit/data"
        "tests/unit/models"
        "tests/unit/training"
        "tests/unit/serving"
    )

    for dir in "\${test_dirs[@]}"; do
        mkdir -p "$dir"
        if [[ ! -f "$dir/__init__.py" ]]; then
            touch "$dir/__init__.py"
        fi
    done
    success "Test directories created"

    # Create conftest.py if missing
    if [[ ! -f "tests/conftest.py" ]]; then
        cat > tests/conftest.py << 'CONFTEST_EOF'
"""Shared pytest fixtures for ml-pipeline tests."""

import pytest
import torch


@pytest.fixture
def device() -> torch.device:
    """Return available compute device."""
    return torch.device("cuda" if torch.cuda.is_available() else "cpu")


@pytest.fixture
def sample_batch_size() -> int:
    """Standard batch size for test fixtures."""
    return 4


@pytest.fixture
def random_seed() -> int:
    """Fixed seed for reproducible tests."""
    return 42
CONFTEST_EOF
        success "tests/conftest.py created"
    fi

    # Scripts directory
    mkdir -p scripts
    success "Project scaffolding complete"
}

# ─────────────────────────────────────────────────────────────
# 10. Set up MCP mock servers (for local development)
# ─────────────────────────────────────────────────────────────
setup_mcp_servers() {
    info "Setting up MCP mock servers..."

    if [[ -d "mock-mcp-servers" && -f "mock-mcp-servers/package.json" ]]; then
        if command -v node &>/dev/null; then
            info "Installing MCP server dependencies..."
            (cd mock-mcp-servers && npm install --silent 2>/dev/null) && \\
                success "MCP mock servers ready" || \\
                warn "MCP server npm install failed — not critical for ML development"
        else
            warn "Node.js not found — MCP mock servers won't be available"
            echo "  Install via: brew install node"
        fi
    else
        warn "mock-mcp-servers/ not found — skipping"
    fi
}

# ─────────────────────────────────────────────────────────────
# 11. Create .env template
# ─────────────────────────────────────────────────────────────
setup_env() {
    info "Setting up environment configuration..."

    if [[ ! -f ".env.example" ]]; then
        cat > .env.example << 'ENV_EOF'
# ml-pipeline environment configuration
# Copy to .env and fill in values — NEVER commit .env to git

# MLflow
MLFLOW_TRACKING_URI=sqlite:///mlruns/mlflow.db
MLFLOW_EXPERIMENT_NAME=default

# AWS
AWS_REGION=us-east-1
AWS_DEFAULT_REGION=us-east-1
# AWS_ACCESS_KEY_ID=
# AWS_SECRET_ACCESS_KEY=

# DVC Remote
# DVC_REMOTE_URL=s3://your-bucket/ml-pipeline/dvc-store

# PostgreSQL (MLflow backend store — production)
# POSTGRES_HOST=localhost
# POSTGRES_PORT=5432
# POSTGRES_DB=mlflow
# POSTGRES_USER=mlflow
# POSTGRES_PASSWORD=

# Redis (feature store cache)
# REDIS_HOST=localhost
# REDIS_PORT=6379

# FastAPI serving
API_HOST=0.0.0.0
API_PORT=8000
API_WORKERS=2
MODEL_CACHE_TTL=300

# Training
CUDA_VISIBLE_DEVICES=0
TORCH_NUM_THREADS=4

# GDPR / Compliance
DATA_ANONYMIZATION_ENABLED=true
AUDIT_LOG_ENABLED=true
ENV_EOF
        success ".env.example created"
    fi

    if [[ ! -f ".env" ]]; then
        cp .env.example .env
        success ".env created from template — update with your values"
    else
        success ".env already exists"
    fi
}

# ─────────────────────────────────────────────────────────────
# 12. Verify installation
# ─────────────────────────────────────────────────────────────
verify_installation() {
    info "Verifying installation..."

    local checks_passed=0
    local checks_total=0

    # Check git hooks
    checks_total=$((checks_total + 1))
    if [[ "$(git config core.hooksPath)" == "git-hooks" ]]; then
        success "  Git hooks — configured"
        checks_passed=$((checks_passed + 1))
    else
        warn "  Git hooks — not configured"
    fi

    # Check virtual environment
    checks_total=$((checks_total + 1))
    if [[ -d ".venv" ]]; then
        success "  Virtual environment — exists"
        checks_passed=$((checks_passed + 1))
    else
        warn "  Virtual environment — missing"
    fi

    # Check DVC
    checks_total=$((checks_total + 1))
    if [[ -d ".dvc" ]]; then
        success "  DVC — initialized"
        checks_passed=$((checks_passed + 1))
    else
        warn "  DVC — not initialized"
    fi

    # Check Claude config
    checks_total=$((checks_total + 1))
    if [[ -f ".claude/settings.json" ]]; then
        success "  Claude settings — present"
        checks_passed=$((checks_passed + 1))
    else
        warn "  Claude settings — missing"
    fi

    # Check CLAUDE.md
    checks_total=$((checks_total + 1))
    if [[ -f "CLAUDE.md" ]]; then
        success "  CLAUDE.md — present"
        checks_passed=$((checks_passed + 1))
    else
        warn "  CLAUDE.md — missing"
    fi

    # Check project structure
    checks_total=$((checks_total + 1))
    if [[ -f "src/__init__.py" ]]; then
        success "  Project scaffolding — present"
        checks_passed=$((checks_passed + 1))
    else
        warn "  Project scaffolding — missing"
    fi

    # Run linter check (quick smoke test)
    checks_total=$((checks_total + 1))
    if command -v uv &>/dev/null && [[ -d ".venv" ]]; then
        if uv run ruff check src/ --quiet 2>/dev/null; then
            success "  Ruff linter — working"
            checks_passed=$((checks_passed + 1))
        else
            warn "  Ruff linter — issues found (run 'uv run ruff check src/' to see details)"
            checks_passed=$((checks_passed + 1))  # Still counts — ruff is working
        fi
    else
        warn "  Ruff linter — skipped (no venv)"
    fi

    echo ""
    echo -e "\${BLUE}━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\${NC}"
    echo -e "  Verification: \${GREEN}$checks_passed\${NC}/$checks_total checks passed"
    echo -e "\${BLUE}━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\${NC}"
}

# ─────────────────────────────────────────────────────────────
# Print summary
# ─────────────────────────────────────────────────────────────
print_summary() {
    echo ""
    echo -e "\${GREEN}━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\${NC}"
    echo -e "\${GREEN}  Setup Complete!\${NC}"
    echo -e "\${GREEN}━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\${NC}"

    if [[ \${#FAILURES[@]} -gt 0 ]]; then
        echo ""
        warn "Some steps had issues:"
        for failure in "\${FAILURES[@]}"; do
            echo -e "  \${YELLOW}•\${NC} $failure"
        done
    fi

    echo ""
    echo "  Quick start commands:"
    echo ""
    echo -e "    \${BLUE}uv run pytest\${NC}                              Run tests"
    echo -e "    \${BLUE}uv run ruff check src/ tests/\${NC}              Lint code"
    echo -e "    \${BLUE}uv run ruff format src/ tests/\${NC}             Format code"
    echo -e "    \${BLUE}uv run mypy src/\${NC}                           Type check"
    echo -e "    \${BLUE}dvc repro\${NC}                                  Run ML pipeline"
    echo -e "    \${BLUE}mlflow ui\${NC}                                  Launch experiment tracker"
    echo -e "    \${BLUE}uv run uvicorn src.serving.app:app --reload\${NC} Start API server"
    echo ""
    echo "  Documentation:"
    echo ""
    echo -e "    \${BLUE}docs/ONBOARDING.md\${NC}      Getting started guide"
    echo -e "    \${BLUE}docs/ARCHITECTURE.md\${NC}    System architecture"
    echo -e "    \${BLUE}docs/CONTRIBUTING.md\${NC}    Contribution guidelines"
    echo -e "    \${BLUE}docs/AI-USAGE-POLICY.md\${NC} AI code generation policy"
    echo ""
}

# ─────────────────────────────────────────────────────────────
# Main
# ─────────────────────────────────────────────────────────────
main() {
    header
    check_prerequisites
    install_uv
    install_dependencies
    setup_git_hooks
    setup_claude
    install_plugin
    setup_dvc
    setup_mlflow
    create_scaffolding
    setup_mcp_servers
    setup_env
    verify_installation
    print_summary
}

main "$@"`,

  'mock-mcp-servers/README.md': `# Mock MCP Servers

Local mock MCP (Model Context Protocol) servers for development and testing. These servers simulate external tool integrations so Claude Code can interact with GitHub Issues, project management, and other services without requiring live API credentials.

## Overview

| Server | File | Port | Simulates |
|--------|------|------|-----------|
| GitHub | \`github-server.mjs\` | stdio | GitHub Issues, PRs, repository metadata |
| Jira | \`jira-server.mjs\` | stdio | Jira-style ticket management (maps to GitHub Issues workflow) |

These servers are referenced in the root \`.mcp.json\` configuration and are automatically available to Claude Code sessions.

## Prerequisites

- **Node.js** >= 18.0 (for running MCP server scripts)
- **Claude Code** with MCP support enabled

Verify Node.js is installed:

\`\`\`bash
node --version
\`\`\`

## Setup

1. **Install dependencies** (if any are added later):

   \`\`\`bash
   cd mock-mcp-servers
   npm install  # Currently no external deps required
   \`\`\`

2. **Verify MCP configuration** in the project root \`.mcp.json\`:

   \`\`\`json
   {
     "mcpServers": {
       "github": {
         "command": "node",
         "args": ["mock-mcp-servers/github-server.mjs"]
       },
       "jira": {
         "command": "node",
         "args": ["mock-mcp-servers/jira-server.mjs"]
       }
     }
   }
   \`\`\`

3. **Start a Claude Code session** — MCP servers launch automatically via stdio transport.

## Available Tools

### GitHub Server (\`github-server.mjs\`)

Tools for interacting with GitHub Issues and pull requests in the \`ml-pipeline\` repository.

| Tool | Description | Parameters |
|------|-------------|------------|
| \`get_issue\` | Fetch a GitHub Issue by number | \`issue_number\` (int) |
| \`list_issues\` | List issues with optional filters | \`state\` (open/closed/all), \`labels\` (string[]), \`assignee\` (string) |
| \`create_issue\` | Create a new GitHub Issue | \`title\` (string), \`body\` (string), \`labels\` (string[]), \`assignee\` (string) |
| \`update_issue\` | Update an existing issue | \`issue_number\` (int), \`state\` (string), \`labels\` (string[]), \`body\` (string) |
| \`list_pull_requests\` | List PRs with optional filters | \`state\` (open/closed/all), \`base\` (string) |
| \`get_pull_request\` | Fetch a PR by number | \`pr_number\` (int) |
| \`get_repo_info\` | Get repository metadata | — |

**Example usage in Claude Code:**

> "Look up issue ML-42 and summarize the requirements for the transformer model feature."

### Jira Server (\`jira-server.mjs\`)

Tools for ticket/project management, modeled after Jira but mapped to our GitHub Issues workflow.

| Tool | Description | Parameters |
|------|-------------|------------|
| \`get_ticket\` | Fetch a ticket by key (e.g., ML-42) | \`ticket_key\` (string) |
| \`list_tickets\` | List tickets with filters | \`project\` (string), \`status\` (string), \`assignee\` (string), \`sprint\` (string) |
| \`create_ticket\` | Create a new ticket | \`project\` (string), \`summary\` (string), \`description\` (string), \`type\` (story/task/bug/experiment), \`assignee\` (string), \`priority\` (string) |
| \`update_ticket\` | Update ticket fields | \`ticket_key\` (string), \`status\` (string), \`assignee\` (string), \`priority\` (string) |
| \`transition_ticket\` | Move ticket through workflow | \`ticket_key\` (string), \`transition\` (to_do/in_progress/in_review/done) |
| \`log_experiment\` | Log an ML experiment against a ticket | \`ticket_key\` (string), \`mlflow_run_id\` (string), \`metrics\` (object), \`notes\` (string) |

**ML-specific ticket types:**
- \`experiment\` — For ML experiment tracking tickets that link to MLflow runs
- \`story\` — Feature work (new model architecture, data pipeline changes)
- \`task\` — Infrastructure, tooling, config changes
- \`bug\` — Model performance regressions, data quality issues

**Example usage in Claude Code:**

> "Create an experiment ticket for hyperparameter tuning on the ResNet feature extractor, priority high, assign to me."

## Mock Data

Both servers include pre-seeded mock data relevant to the ml-pipeline project:

- **Issues/Tickets**: Sample ML tasks (model training, data pipeline, feature engineering, deployment)
- **PRs**: Example pull requests following our \`type/ticket-desc\` branch naming convention
- **Labels**: ML-specific labels (\`model\`, \`data-pipeline\`, \`experiment\`, \`infrastructure\`, \`serving\`, \`p0-critical\`, \`p1-high\`)
- **Sprints**: Current and past sprint data

## Customizing Mock Data

Edit the data arrays at the top of each \`.mjs\` file to add or modify mock entries. The data structures are plain JavaScript objects — no database required.

\`\`\`javascript
// Example: Add a new mock issue in github-server.mjs
const MOCK_ISSUES = [
  {
    number: 50,
    title: "Add data drift detection to feature pipeline",
    state: "open",
    labels: ["data-pipeline", "monitoring"],
    assignee: "your-username",
    body: "Implement statistical drift detection for incoming features...",
  },
  // ... existing entries
];
\`\`\`

## Adding New Mock Servers

To add a new MCP server (e.g., for AWS, Slack, Notion):

1. Create a new \`.mjs\` file in this directory following the existing pattern
2. Implement the MCP stdio protocol (read JSON-RPC from stdin, write to stdout)
3. Register it in the root \`.mcp.json\`
4. Document available tools in this README

**Server template structure:**

\`\`\`javascript
// mock-mcp-servers/new-server.mjs
import { createInterface } from "readline";

const rl = createInterface({ input: process.stdin });

function handleRequest(request) {
  const { method, params } = request;
  switch (method) {
    case "tools/list":
      return { tools: [/* tool definitions */] };
    case "tools/call":
      return handleToolCall(params);
    default:
      return { error: { code: -32601, message: "Method not found" } };
  }
}

rl.on("line", (line) => {
  const request = JSON.parse(line);
  const response = { jsonrpc: "2.0", id: request.id, result: handleRequest(request) };
  process.stdout.write(JSON.stringify(response) + "\\n");
});
\`\`\`

## Troubleshooting

**Server not responding:**
- Check that Node.js >= 18 is installed and on your PATH
- Verify \`.mcp.json\` paths are relative to the project root
- Restart your Claude Code session after modifying \`.mcp.json\`

**Tool calls returning errors:**
- Check the server logs (stderr output) for error details
- Ensure parameter names match the tool definitions exactly
- Mock data IDs are integers for GitHub, string keys (e.g., \`ML-42\`) for Jira

**Adding real API integration:**
- These mocks are for local development only. For production integrations, configure real MCP servers with appropriate API tokens stored in environment variables (never committed — see \`.gitignore\` and \`.claude/rules/common/security.md\`)
- Ensure any real integrations comply with SOC 2 access controls and GDPR data handling requirements

## Related Files

- [\`/.mcp.json\`](../.mcp.json) — MCP server configuration
- [\`/.claude/settings.json\`](../.claude/settings.json) — Claude Code settings including MCP permissions
- [\`/.claude/rules/common/security.md\`](../.claude/rules/common/security.md) — Security rules for API keys and secrets`,

  'mock-mcp-servers/github-server.mjs': `#!/usr/bin/env node

/**
 * Mock GitHub MCP Server for ml-pipeline
 * Simulates PR, issue, repo, and code review operations
 * Used for local development and testing of Claude Code integrations
 */

import { Server } from "@modelcontextprotocol/sdk/server/index.js";
import { StdioServerTransport } from "@modelcontextprotocol/sdk/server/stdio.js";
import {
  CallToolRequestSchema,
  ListToolsRequestSchema,
} from "@modelcontextprotocol/sdk/types.js";

const REPO_OWNER = "ml-team";
const REPO_NAME = "ml-pipeline";

let issueCounter = 10;
let prCounter = 20;

const mockIssues = [
  {
    number: 1,
    title: "Add transformer model architecture",
    body: "Implement a transformer-based model in src/models/ for sequence classification tasks. Must include Pydantic config validation and MLflow experiment tracking.",
    state: "open",
    labels: ["feat", "model-architecture", "priority:high"],
    assignees: ["alice"],
    milestone: "v0.3.0",
    created_at: "2024-01-15T10:00:00Z",
    updated_at: "2024-01-15T10:00:00Z",
  },
  {
    number: 2,
    title: "Fix data pipeline OOM on large datasets",
    body: "DVC pipeline stage \`featurize\` runs out of memory when processing datasets > 10GB. Need to implement chunked processing in src/data/feature_engineering.py.",
    state: "open",
    labels: ["fix", "data-pipeline", "priority:critical"],
    assignees: ["bob"],
    milestone: "v0.2.1",
    created_at: "2024-01-14T08:30:00Z",
    updated_at: "2024-01-16T14:00:00Z",
  },
  {
    number: 3,
    title: "Add GDPR data anonymization pipeline stage",
    body: "Implement PII detection and anonymization as a DVC pipeline stage before feature engineering. Required for SOC 2 and GDPR compliance.",
    state: "open",
    labels: ["feat", "compliance", "gdpr", "priority:high"],
    assignees: ["carol"],
    milestone: "v0.3.0",
    created_at: "2024-01-13T09:00:00Z",
    updated_at: "2024-01-13T09:00:00Z",
  },
  {
    number: 4,
    title: "Implement A/B testing endpoint in FastAPI serving layer",
    body: "Add model variant routing to src/serving/ that supports traffic splitting between model versions registered in MLflow Model Registry.",
    state: "closed",
    labels: ["feat", "serving", "priority:medium"],
    assignees: ["alice"],
    milestone: "v0.2.0",
    created_at: "2024-01-10T11:00:00Z",
    updated_at: "2024-01-12T16:00:00Z",
  },
];

const mockPRs = [
  {
    number: 11,
    title: "feat(ML-1): add transformer model architecture",
    body: "## Summary\\nAdds TransformerClassifier in src/models/transformer.py with Pydantic config.\\n\\n## Checklist\\n- [x] Type hints on all public functions\\n- [x] MLflow experiment tracking\\n- [x] Unit tests (pytest)\\n- [x] ruff check passes\\n- [x] mypy strict passes\\n\\nCloses #1",
    state: "open",
    head: { ref: "feat/ML-1-add-transformer-model" },
    base: { ref: "main" },
    author: "alice",
    labels: ["feat", "model-architecture"],
    reviewers: ["bob", "carol"],
    draft: false,
    mergeable: true,
    checks_passed: true,
    created_at: "2024-01-16T10:00:00Z",
    updated_at: "2024-01-17T09:00:00Z",
    changed_files: 5,
    additions: 280,
    deletions: 10,
    files: [
      { filename: "src/models/transformer.py", status: "added", additions: 150, deletions: 0 },
      { filename: "src/models/__init__.py", status: "modified", additions: 2, deletions: 0 },
      { filename: "configs/models/transformer.yaml", status: "added", additions: 35, deletions: 0 },
      { filename: "tests/models/test_transformer.py", status: "added", additions: 88, deletions: 0 },
      { filename: "tests/models/__init__.py", status: "added", additions: 5, deletions: 10 },
    ],
  },
  {
    number: 12,
    title: "fix(ML-2): chunked processing for large datasets",
    body: "## Summary\\nFixes OOM in featurize stage by implementing chunked DataFrame processing.\\n\\n## Testing\\n- Tested with 15GB dataset on EC2 GPU instance\\n- Memory usage stays under 4GB\\n\\nCloses #2",
    state: "open",
    head: { ref: "fix/ML-2-data-pipeline-oom" },
    base: { ref: "main" },
    author: "bob",
    labels: ["fix", "data-pipeline"],
    reviewers: ["alice"],
    draft: false,
    mergeable: true,
    checks_passed: false,
    created_at: "2024-01-17T08:00:00Z",
    updated_at: "2024-01-17T12:00:00Z",
    changed_files: 3,
    additions: 95,
    deletions: 30,
    files: [
      { filename: "src/data/feature_engineering.py", status: "modified", additions: 70, deletions: 25 },
      { filename: "tests/data/test_feature_engineering.py", status: "modified", additions: 20, deletions: 5 },
      { filename: "dvc.yaml", status: "modified", additions: 5, deletions: 0 },
    ],
  },
];

const mockReviews = [
  {
    pr_number: 11,
    id: 101,
    user: "bob",
    state: "APPROVED",
    body: "Clean implementation. Pydantic config looks good. MLflow integration is solid.",
    submitted_at: "2024-01-17T08:30:00Z",
  },
  {
    pr_number: 12,
    id: 102,
    user: "alice",
    state: "CHANGES_REQUESTED",
    body: "Chunking logic works but missing type hints on \`process_chunk()\`. Also need to add DVC pipeline params for chunk_size in configs/.",
    submitted_at: "2024-01-17T11:00:00Z",
  },
];

const mockBranches = [
  { name: "main", protected: true },
  { name: "feat/ML-1-add-transformer-model", protected: false },
  { name: "fix/ML-2-data-pipeline-oom", protected: false },
  { name: "feat/ML-3-gdpr-anonymization", protected: false },
];

const mockWorkflowRuns = [
  {
    id: 5001,
    name: "CI Pipeline",
    head_branch: "feat/ML-1-add-transformer-model",
    status: "completed",
    conclusion: "success",
    jobs: [
      { name: "lint", status: "completed", conclusion: "success" },
      { name: "type-check", status: "completed", conclusion: "success" },
      { name: "unit-tests", status: "completed", conclusion: "success" },
      { name: "integration-tests", status: "completed", conclusion: "success" },
      { name: "build-docker", status: "completed", conclusion: "success" },
      { name: "train-smoke-test", status: "completed", conclusion: "success" },
    ],
    created_at: "2024-01-17T09:00:00Z",
  },
  {
    id: 5002,
    name: "CI Pipeline",
    head_branch: "fix/ML-2-data-pipeline-oom",
    status: "completed",
    conclusion: "failure",
    jobs: [
      { name: "lint", status: "completed", conclusion: "success" },
      { name: "type-check", status: "completed", conclusion: "failure" },
      { name: "unit-tests", status: "completed", conclusion: "success" },
    ],
    created_at: "2024-01-17T12:00:00Z",
  },
];

const CODEOWNERS_CONTENT = [
  "# ML Pipeline CODEOWNERS",
  "src/models/**          @ml-team/model-leads",
  "src/training/**        @ml-team/model-leads",
  "src/data/**            @ml-team/data-engineers",
  "src/serving/**         @ml-team/platform",
  "configs/production/**  @ml-team/leads",
  "models/**             @ml-team/model-leads",
  ".env*                 @ml-team/leads",
  "data/**               @ml-team/data-engineers",
  "dvc.yaml             @ml-team/data-engineers @ml-team/model-leads",
  "Dockerfile            @ml-team/platform",
  ".github/**            @ml-team/leads",
].join("\\n");

const server = new Server(
  { name: "mock-github-server", version: "1.0.0" },
  { capabilities: { tools: {} } }
);

server.setRequestHandler(ListToolsRequestSchema, async () => ({
  tools: [
    {
      name: "get_issue",
      description: "Get a GitHub issue by number from ml-pipeline repo",
      inputSchema: {
        type: "object",
        properties: {
          issue_number: { type: "number", description: "Issue number" },
        },
        required: ["issue_number"],
      },
    },
    {
      name: "list_issues",
      description: "List GitHub issues with optional filters",
      inputSchema: {
        type: "object",
        properties: {
          state: { type: "string", enum: ["open", "closed", "all"], default: "open" },
          labels: { type: "string", description: "Comma-separated label names" },
          assignee: { type: "string", description: "Filter by assignee username" },
        },
      },
    },
    {
      name: "create_issue",
      description: "Create a new GitHub issue",
      inputSchema: {
        type: "object",
        properties: {
          title: { type: "string" },
          body: { type: "string" },
          labels: { type: "array", items: { type: "string" } },
          assignees: { type: "array", items: { type: "string" } },
        },
        required: ["title"],
      },
    },
    {
      name: "get_pull_request",
      description: "Get a pull request by number",
      inputSchema: {
        type: "object",
        properties: {
          pr_number: { type: "number", description: "PR number" },
        },
        required: ["pr_number"],
      },
    },
    {
      name: "list_pull_requests",
      description: "List pull requests with optional filters",
      inputSchema: {
        type: "object",
        properties: {
          state: { type: "string", enum: ["open", "closed", "all"], default: "open" },
          author: { type: "string" },
          base: { type: "string", default: "main" },
        },
      },
    },
    {
      name: "create_pull_request",
      description: "Create a new pull request",
      inputSchema: {
        type: "object",
        properties: {
          title: { type: "string" },
          body: { type: "string" },
          head: { type: "string", description: "Source branch" },
          base: { type: "string", description: "Target branch", default: "main" },
          draft: { type: "boolean", default: false },
        },
        required: ["title", "head"],
      },
    },
    {
      name: "get_pr_files",
      description: "Get files changed in a pull request",
      inputSchema: {
        type: "object",
        properties: {
          pr_number: { type: "number" },
        },
        required: ["pr_number"],
      },
    },
    {
      name: "get_pr_reviews",
      description: "Get reviews for a pull request",
      inputSchema: {
        type: "object",
        properties: {
          pr_number: { type: "number" },
        },
        required: ["pr_number"],
      },
    },
    {
      name: "create_pr_review",
      description: "Submit a review on a pull request",
      inputSchema: {
        type: "object",
        properties: {
          pr_number: { type: "number" },
          body: { type: "string" },
          event: { type: "string", enum: ["APPROVE", "REQUEST_CHANGES", "COMMENT"] },
        },
        required: ["pr_number", "body", "event"],
      },
    },
    {
      name: "list_branches",
      description: "List repository branches",
      inputSchema: { type: "object", properties: {} },
    },
    {
      name: "get_workflow_runs",
      description: "Get CI workflow runs for a branch",
      inputSchema: {
        type: "object",
        properties: {
          branch: { type: "string", description: "Branch name" },
        },
        required: ["branch"],
      },
    },
    {
      name: "get_codeowners",
      description: "Get CODEOWNERS file content",
      inputSchema: { type: "object", properties: {} },
    },
    {
      name: "get_repo_info",
      description: "Get repository metadata and settings",
      inputSchema: { type: "object", properties: {} },
    },
    {
      name: "search_code",
      description: "Search for code patterns in the repository",
      inputSchema: {
        type: "object",
        properties: {
          query: { type: "string", description: "Search query" },
          path: { type: "string", description: "Filter by file path prefix" },
        },
        required: ["query"],
      },
    },
  ],
}));

server.setRequestHandler(CallToolRequestSchema, async (request) => {
  const { name, arguments: args } = request.params;

  switch (name) {
    case "get_issue": {
      const issue = mockIssues.find((i) => i.number === args.issue_number);
      if (!issue) {
        return { content: [{ type: "text", text: \`Issue #\${args.issue_number} not found in \${REPO_OWNER}/\${REPO_NAME}\` }] };
      }
      return { content: [{ type: "text", text: JSON.stringify({ repo: \`\${REPO_OWNER}/\${REPO_NAME}\`, ...issue }, null, 2) }] };
    }

    case "list_issues": {
      let filtered = [...mockIssues];
      const state = args.state || "open";
      if (state !== "all") {
        filtered = filtered.filter((i) => i.state === state);
      }
      if (args.labels) {
        const labelSet = args.labels.split(",").map((l) => l.trim());
        filtered = filtered.filter((i) => labelSet.some((l) => i.labels.includes(l)));
      }
      if (args.assignee) {
        filtered = filtered.filter((i) => i.assignees.includes(args.assignee));
      }
      return {
        content: [{
          type: "text",
          text: JSON.stringify({ repo: \`\${REPO_OWNER}/\${REPO_NAME}\`, total_count: filtered.length, issues: filtered }, null, 2),
        }],
      };
    }

    case "create_issue": {
      issueCounter++;
      const newIssue = {
        number: issueCounter,
        title: args.title,
        body: args.body || "",
        state: "open",
        labels: args.labels || [],
        assignees: args.assignees || [],
        milestone: null,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
      };
      mockIssues.push(newIssue);
      return { content: [{ type: "text", text: JSON.stringify({ message: "Issue created", repo: \`\${REPO_OWNER}/\${REPO_NAME}\`, ...newIssue }, null, 2) }] };
    }

    case "get_pull_request": {
      const pr = mockPRs.find((p) => p.number === args.pr_number);
      if (!pr) {
        return { content: [{ type: "text", text: \`PR #\${args.pr_number} not found in \${REPO_OWNER}/\${REPO_NAME}\` }] };
      }
      return { content: [{ type: "text", text: JSON.stringify({ repo: \`\${REPO_OWNER}/\${REPO_NAME}\`, ...pr }, null, 2) }] };
    }

    case "list_pull_requests": {
      let filtered = [...mockPRs];
      const state = args.state || "open";
      if (state !== "all") {
        filtered = filtered.filter((p) => p.state === state);
      }
      if (args.author) {
        filtered = filtered.filter((p) => p.author === args.author);
      }
      if (args.base) {
        filtered = filtered.filter((p) => p.base.ref === args.base);
      }
      return {
        content: [{
          type: "text",
          text: JSON.stringify({ repo: \`\${REPO_OWNER}/\${REPO_NAME}\`, total_count: filtered.length, pull_requests: filtered }, null, 2),
        }],
      };
    }

    case "create_pull_request": {
      prCounter++;
      const newPR = {
        number: prCounter,
        title: args.title,
        body: args.body || "",
        state: "open",
        head: { ref: args.head },
        base: { ref: args.base || "main" },
        author: "claude-code",
        labels: [],
        reviewers: [],
        draft: args.draft || false,
        mergeable: true,
        checks_passed: false,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
        changed_files: 0,
        additions: 0,
        deletions: 0,
        files: [],
      };
      mockPRs.push(newPR);
      return { content: [{ type: "text", text: JSON.stringify({ message: "Pull request created", repo: \`\${REPO_OWNER}/\${REPO_NAME}\`, ...newPR }, null, 2) }] };
    }

    case "get_pr_files": {
      const pr = mockPRs.find((p) => p.number === args.pr_number);
      if (!pr) {
        return { content: [{ type: "text", text: \`PR #\${args.pr_number} not found\` }] };
      }
      const sensitivePatterns = ["configs/production/", "models/", ".env", "data/"];
      const filesWithFlags = pr.files.map((f) => ({
        ...f,
        is_sensitive: sensitivePatterns.some((p) => f.filename.startsWith(p)),
        requires_codeowner_review: sensitivePatterns.some((p) => f.filename.startsWith(p)),
      }));
      return { content: [{ type: "text", text: JSON.stringify({ pr_number: pr.number, total_files: filesWithFlags.length, files: filesWithFlags }, null, 2) }] };
    }

    case "get_pr_reviews": {
      const reviews = mockReviews.filter((r) => r.pr_number === args.pr_number);
      return {
        content: [{
          type: "text",
          text: JSON.stringify({ pr_number: args.pr_number, total_reviews: reviews.length, reviews }, null, 2),
        }],
      };
    }

    case "create_pr_review": {
      const reviewId = 200 + Math.floor(Math.random() * 1000);
      const newReview = {
        pr_number: args.pr_number,
        id: reviewId,
        user: "claude-code",
        state: args.event,
        body: args.body,
        submitted_at: new Date().toISOString(),
      };
      mockReviews.push(newReview);
      return { content: [{ type: "text", text: JSON.stringify({ message: "Review submitted", ...newReview }, null, 2) }] };
    }

    case "list_branches": {
      return { content: [{ type: "text", text: JSON.stringify({ repo: \`\${REPO_OWNER}/\${REPO_NAME}\`, branches: mockBranches }, null, 2) }] };
    }

    case "get_workflow_runs": {
      const runs = mockWorkflowRuns.filter((r) => r.head_branch === args.branch);
      if (runs.length === 0) {
        return { content: [{ type: "text", text: JSON.stringify({ branch: args.branch, message: "No workflow runs found. CI stages: lint, type-check, unit-tests, integration-tests, build-docker, train-smoke-test, deploy-staging, deploy-production" }, null, 2) }] };
      }
      return { content: [{ type: "text", text: JSON.stringify({ branch: args.branch, workflow_runs: runs }, null, 2) }] };
    }

    case "get_codeowners": {
      return { content: [{ type: "text", text: CODEOWNERS_CONTENT }] };
    }

    case "get_repo_info": {
      const info = {
        owner: REPO_OWNER,
        name: REPO_NAME,
        full_name: \`\${REPO_OWNER}/\${REPO_NAME}\`,
        description: "End-to-end ML pipeline with PyTorch, MLflow, DVC, and FastAPI",
        default_branch: "main",
        protected_branches: ["main"],
        language: "Python",
        topics: ["machine-learning", "pytorch", "mlflow", "dvc", "fastapi", "mlops"],
        branch_protection: {
          main: {
            required_reviews: 1,
            require_status_checks: true,
            required_checks: ["lint", "type-check", "unit-tests", "train-smoke-test"],
            enforce_admins: true,
          },
        },
        compliance: ["SOC 2", "GDPR"],
        ci_platform: "GitHub Actions",
        package_manager: "uv",
      };
      return { content: [{ type: "text", text: JSON.stringify(info, null, 2) }] };
    }

    case "search_code": {
      const mockResults = [];
      const query = (args.query || "").toLowerCase();
      const pathFilter = args.path || "";

      const codeIndex = [
        { path: "src/models/transformer.py", snippets: ["class TransformerClassifier(nn.Module):", "def forward(self, x: torch.Tensor) -> torch.Tensor:", "mlflow.log_params(config.dict())"] },
        { path: "src/models/base.py", snippets: ["class BaseModel(nn.Module, ABC):", "def save_checkpoint(self, path: str) -> None:", "def load_checkpoint(cls, path: str) -> BaseModel:"] },
        { path: "src/training/trainer.py", snippets: ["class Trainer:", "def train_epoch(self, dataloader: DataLoader) -> dict[str, float]:", "mlflow.log_metrics(metrics, step=epoch)", "torch.cuda.is_available()"] },
        { path: "src/training/hyperparameter_tuning.py", snippets: ["def run_optuna_study(config: TuningConfig) -> Study:", "mlflow.log_params(trial.params)"] },
        { path: "src/data/feature_engineering.py", snippets: ["def compute_features(df: pd.DataFrame, config: FeatureConfig) -> pd.DataFrame:", "def process_chunk(chunk: pd.DataFrame) -> pd.DataFrame:"] },
        { path: "src/data/preprocessing.py", snippets: ["def anonymize_pii(df: pd.DataFrame) -> pd.DataFrame:", "def validate_gdpr_compliance(dataset_path: str) -> bool:"] },
        { path: "src/serving/app.py", snippets: ["app = FastAPI(title='ML Pipeline Serving')", "async def predict(request: PredictRequest) -> PredictResponse:", "async def health() -> dict[str, str]:"] },
        { path: "src/serving/ab_testing.py", snippets: ["class ABTestRouter:", "def route_request(self, request: PredictRequest) -> str:", "mlflow_client.get_model_version(name, stage='Production')"] },
        { path: "configs/models/transformer.yaml", snippets: ["model_type: transformer", "hidden_dim: 256", "num_heads: 8", "num_layers: 6"] },
        { path: "dvc.yaml", snippets: ["stages:", "  preprocess:", "    cmd: uv run python scripts/preprocess.py", "  featurize:", "  train:", "    cmd: uv run python scripts/train.py"] },
      ];

      for (const entry of codeIndex) {
        if (pathFilter && !entry.path.startsWith(pathFilter)) continue;
        const matchingSnippets = entry.snippets.filter((s) => s.toLowerCase().includes(query));
        if (matchingSnippets.length > 0) {
          mockResults.push({ path: entry.path, matches: matchingSnippets });
        }
      }

      return {
        content: [{
          type: "text",
          text: JSON.stringify({
            query: args.query,
            path_filter: pathFilter || null,
            total_results: mockResults.length,
            results: mockResults,
          }, null, 2),
        }],
      };
    }

    default:
      return { content: [{ type: "text", text: \`Unknown tool: \${name}\` }] };
  }
});

async function main() {
  const transport = new StdioServerTransport();
  await server.connect(transport);
  console.error(\`Mock GitHub MCP server running for \${REPO_OWNER}/\${REPO_NAME}\`);
}

main().catch((error) => {
  console.error("Failed to start mock GitHub MCP server:", error);
  process.exit(1);
});`,

  'mock-mcp-servers/jira-server.mjs': `#!/usr/bin/env node

/**
 * Mock GitHub Issues MCP Server for ml-pipeline
 *
 * Simulates ticket lookup for ML experiment tasks, training runs,
 * data pipeline work, and model serving issues.
 *
 * Note: Despite the filename (kept for plugin compatibility), this project
 * uses GitHub Issues as its ticket system, not Jira.
 *
 * Usage:
 *   node mock-mcp-servers/jira-server.mjs
 *
 * Protocol: JSON-RPC 2.0 over stdio (MCP standard)
 */

import { stdin, stdout } from "node:process";
import { createInterface } from "node:readline";

const MOCK_TICKETS = {
  "ML-1": {
    key: "ML-1",
    title: "Set up DVC pipeline for raw data ingestion",
    status: "Done",
    type: "task",
    priority: "high",
    assignee: "data-engineer-1",
    labels: ["data-pipeline", "infrastructure"],
    sprint: "Sprint 1",
    description:
      "Configure DVC remote on S3 and create initial dvc.yaml stages for raw data download, validation, and storage. Ensure GDPR-compliant data handling with anonymization for PII fields.",
    acceptance_criteria: [
      "DVC remote configured with s3://ml-pipeline-data bucket",
      "dvc.yaml has stages: download, validate, store",
      "PII fields are anonymized before storage",
      "Pipeline reproducible via \`dvc repro\`",
    ],
    experiment_config: null,
  },
  "ML-2": {
    key: "ML-2",
    title: "Implement feature engineering pipeline stage",
    status: "In Progress",
    type: "task",
    priority: "high",
    assignee: "ml-engineer-1",
    labels: ["feature-engineering", "data-pipeline"],
    sprint: "Sprint 2",
    description:
      "Build feature engineering module in src/data/feature_engineering.py. Must integrate with DVC pipeline and output to data/features/ directory. All transformations must be deterministic and logged.",
    acceptance_criteria: [
      "Feature transforms defined in configs/features.yaml",
      "Pydantic validation for feature config schema",
      "DVC stage added for feature generation",
      "Unit tests with >80% coverage on transform functions",
      "Type hints on all public functions",
    ],
    experiment_config: "configs/features.yaml",
  },
  "ML-3": {
    key: "ML-3",
    title: "Train baseline transformer model",
    status: "In Progress",
    type: "experiment",
    priority: "high",
    assignee: "ml-engineer-2",
    labels: ["training", "model", "experiment"],
    sprint: "Sprint 2",
    description:
      "Train a baseline transformer model using PyTorch. Track experiment in MLflow with full config logging. Use configs/experiments/baseline_transformer.yaml for hyperparameters. Target GPU instance (p3.2xlarge).",
    acceptance_criteria: [
      "Model architecture in src/models/transformer.py as nn.Module subclass",
      "Training loop in src/training/trainer.py with checkpoint callbacks",
      "MLflow experiment logged with all hyperparams, metrics, and artifacts",
      "Experiment config validated with Pydantic",
      "Model artifact tracked by DVC",
      "Smoke test passes: scripts/train_smoke_test.sh",
    ],
    experiment_config: "configs/experiments/baseline_transformer.yaml",
    mlflow_experiment: "baseline-transformer",
  },
  "ML-4": {
    key: "ML-4",
    title: "Add hyperparameter tuning with Optuna",
    status: "To Do",
    type: "experiment",
    priority: "medium",
    assignee: "ml-engineer-1",
    labels: ["training", "hyperparameter-tuning", "experiment"],
    sprint: "Sprint 3",
    description:
      "Integrate Optuna for hyperparameter search. Each trial should be logged as a child run in MLflow. Search space defined in YAML config. Support early stopping via pruning.",
    acceptance_criteria: [
      "Optuna integration in src/training/tuning.py",
      "Search space configurable via configs/experiments/tuning_search.yaml",
      "Each trial logged as MLflow child run",
      "Best params saved to configs/experiments/best_params.yaml",
      "Pruning enabled for unpromising trials",
      "Type hints and Pydantic validation throughout",
    ],
    experiment_config: "configs/experiments/tuning_search.yaml",
    mlflow_experiment: "hyperparam-tuning",
  },
  "ML-5": {
    key: "ML-5",
    title: "Build FastAPI model serving endpoint",
    status: "To Do",
    type: "task",
    priority: "high",
    assignee: "ml-engineer-2",
    labels: ["serving", "api", "infrastructure"],
    sprint: "Sprint 3",
    description:
      "Create FastAPI application in src/serving/ for real-time model inference. Load model from MLflow model registry. Include health check, prediction, and batch prediction endpoints. Add Redis caching for repeated predictions.",
    acceptance_criteria: [
      "FastAPI app in src/serving/app.py",
      "Endpoints: GET /health, POST /predict, POST /predict/batch",
      "Model loaded from MLflow registry (Production stage)",
      "Pydantic request/response schemas with validation",
      "Redis caching for prediction results",
      "Prometheus metrics endpoint at /metrics",
      "Docker image builds and runs successfully",
      "Integration tests with pytest-asyncio",
    ],
    experiment_config: null,
  },
  "ML-6": {
    key: "ML-6",
    title: "Implement model evaluation and comparison pipeline",
    status: "To Do",
    type: "task",
    priority: "medium",
    assignee: "data-scientist-1",
    labels: ["evaluation", "metrics", "experiment"],
    sprint: "Sprint 3",
    description:
      "Build evaluation module in src/evaluation/ that compares model versions using configurable metrics. Generate comparison reports and visualizations. Integrate with MLflow for metric logging.",
    acceptance_criteria: [
      "Evaluation metrics in src/evaluation/metrics.py",
      "Model comparison logic in src/evaluation/compare.py",
      "Visualization generation for key metrics",
      "Results logged to MLflow with artifacts",
      "DVC pipeline stage for evaluation",
      "Support for A/B test metric comparison",
    ],
    experiment_config: "configs/evaluation.yaml",
  },
  "ML-7": {
    key: "ML-7",
    title: "Set up A/B testing infrastructure for model rollout",
    status: "To Do",
    type: "task",
    priority: "medium",
    assignee: "ml-engineer-1",
    labels: ["serving", "a-b-testing", "infrastructure"],
    sprint: "Sprint 4",
    description:
      "Add A/B testing support to the FastAPI serving layer. Route traffic between model versions based on configurable split ratios. Track per-variant metrics in Prometheus and MLflow.",
    acceptance_criteria: [
      "Traffic splitting logic in src/serving/ab_testing.py",
      "Config-driven variant assignment via configs/ab_test.yaml",
      "Per-variant metrics tracked in Prometheus",
      "Results exportable to MLflow for analysis",
      "Pydantic config validation",
      "Unit and integration tests",
    ],
    experiment_config: "configs/ab_test.yaml",
  },
  "ML-8": {
    key: "ML-8",
    title: "Fix data leakage in temporal feature split",
    status: "In Progress",
    type: "bug",
    priority: "critical",
    assignee: "data-scientist-1",
    labels: ["bug", "data-pipeline", "feature-engineering"],
    sprint: "Sprint 2",
    description:
      "Temporal features are being computed using future data points in the training set. The feature engineering pipeline must enforce strict temporal ordering before computing rolling aggregations. This is causing inflated validation metrics.",
    acceptance_criteria: [
      "Temporal split enforced before feature computation",
      "Rolling features use only past data within each split",
      "Validation metrics recalculated and logged to MLflow",
      "Regression test added to prevent future leakage",
      "DVC pipeline updated to enforce ordering",
    ],
    experiment_config: "configs/features.yaml",
  },
  "ML-9": {
    key: "ML-9",
    title: "Add GDPR data deletion pipeline",
    status: "To Do",
    type: "task",
    priority: "high",
    assignee: "data-engineer-1",
    labels: ["compliance", "gdpr", "data-pipeline"],
    sprint: "Sprint 4",
    description:
      "Implement right-to-deletion pipeline that removes user data from raw, processed, and feature stores. Must handle DVC-tracked datasets and retrain affected models. Audit trail required for SOC 2 compliance.",
    acceptance_criteria: [
      "Deletion script in scripts/gdpr_delete.py",
      "Removes data from all pipeline stages (raw, processed, features)",
      "Handles DVC-tracked files with proper cache invalidation",
      "Audit log written to PostgreSQL for SOC 2",
      "Triggers model retraining if training data affected",
      "Integration test with mock user data",
    ],
    experiment_config: null,
  },
  "ML-10": {
    key: "ML-10",
    title: "Optimize model inference latency for production",
    status: "To Do",
    type: "task",
    priority: "medium",
    assignee: "ml-engineer-2",
    labels: ["serving", "performance", "optimization"],
    sprint: "Sprint 4",
    description:
      "Profile and optimize the inference pipeline. Target p99 latency < 50ms. Consider TorchScript compilation, batching strategies, and Redis feature caching. Benchmark on ECS deployment.",
    acceptance_criteria: [
      "Inference profiling report with bottleneck analysis",
      "TorchScript model export in src/serving/optimize.py",
      "Batch inference optimization for /predict/batch",
      "Redis caching for feature store lookups",
      "p99 latency < 50ms on benchmark dataset",
      "Prometheus latency histograms for monitoring",
    ],
    experiment_config: null,
  },
};

const SPRINTS = {
  "Sprint 1": {
    name: "Sprint 1 - Foundation",
    start: "2024-01-08",
    end: "2024-01-19",
    status: "closed",
    goal: "Set up data infrastructure, DVC pipelines, and MLflow tracking",
  },
  "Sprint 2": {
    name: "Sprint 2 - Baseline Model",
    start: "2024-01-22",
    end: "2024-02-02",
    status: "active",
    goal: "Feature engineering, baseline model training, experiment tracking",
  },
  "Sprint 3": {
    name: "Sprint 3 - Serving & Tuning",
    start: "2024-02-05",
    end: "2024-02-16",
    status: "planned",
    goal: "Model serving API, hyperparameter tuning, evaluation pipeline",
  },
  "Sprint 4": {
    name: "Sprint 4 - Production Hardening",
    start: "2024-02-19",
    end: "2024-03-01",
    status: "planned",
    goal: "A/B testing, GDPR compliance, latency optimization, production deploy",
  },
};

function handleGetTicket(params) {
  const ticketKey = params.ticket_key || params.key || params.issue_id;
  if (!ticketKey) {
    return { error: "Missing required parameter: ticket_key" };
  }

  const normalized = ticketKey.toUpperCase().trim();
  const ticket = MOCK_TICKETS[normalized];

  if (!ticket) {
    return {
      error: \`Ticket \${normalized} not found. Available: \${Object.keys(MOCK_TICKETS).join(", ")}\`,
    };
  }

  return { content: [{ type: "text", text: JSON.stringify(ticket, null, 2) }] };
}

function handleSearchTickets(params) {
  const { query, status, label, assignee, type, sprint } = params;
  let results = Object.values(MOCK_TICKETS);

  if (status) {
    results = results.filter(
      (t) => t.status.toLowerCase() === status.toLowerCase()
    );
  }

  if (label) {
    results = results.filter((t) =>
      t.labels.some((l) => l.toLowerCase().includes(label.toLowerCase()))
    );
  }

  if (assignee) {
    results = results.filter((t) =>
      t.assignee.toLowerCase().includes(assignee.toLowerCase())
    );
  }

  if (type) {
    results = results.filter(
      (t) => t.type.toLowerCase() === type.toLowerCase()
    );
  }

  if (sprint) {
    results = results.filter((t) =>
      t.sprint.toLowerCase().includes(sprint.toLowerCase())
    );
  }

  if (query) {
    const q = query.toLowerCase();
    results = results.filter(
      (t) =>
        t.title.toLowerCase().includes(q) ||
        t.description.toLowerCase().includes(q) ||
        t.labels.some((l) => l.includes(q))
    );
  }

  const summary = results.map((t) => ({
    key: t.key,
    title: t.title,
    status: t.status,
    type: t.type,
    priority: t.priority,
    assignee: t.assignee,
    labels: t.labels,
    sprint: t.sprint,
    experiment_config: t.experiment_config,
  }));

  return {
    content: [
      {
        type: "text",
        text: JSON.stringify({ count: summary.length, tickets: summary }, null, 2),
      },
    ],
  };
}

function handleGetSprint(params) {
  const sprintName = params.sprint_name || params.name;
  if (!sprintName) {
    return {
      content: [
        { type: "text", text: JSON.stringify(Object.values(SPRINTS), null, 2) },
      ],
    };
  }

  const sprint = Object.values(SPRINTS).find((s) =>
    s.name.toLowerCase().includes(sprintName.toLowerCase())
  );

  if (!sprint) {
    return { error: \`Sprint "\${sprintName}" not found\` };
  }

  const sprintTickets = Object.values(MOCK_TICKETS).filter(
    (t) => t.sprint === sprint.name.split(" - ")[0]
  );

  return {
    content: [
      {
        type: "text",
        text: JSON.stringify(
          {
            ...sprint,
            tickets: sprintTickets.map((t) => ({
              key: t.key,
              title: t.title,
              status: t.status,
              type: t.type,
            })),
          },
          null,
          2
        ),
      },
    ],
  };
}

function handleGetExperimentTickets(params) {
  const results = Object.values(MOCK_TICKETS).filter(
    (t) => t.type === "experiment" || t.experiment_config !== null
  );

  const summary = results.map((t) => ({
    key: t.key,
    title: t.title,
    status: t.status,
    type: t.type,
    experiment_config: t.experiment_config,
    mlflow_experiment: t.mlflow_experiment || null,
  }));

  return {
    content: [
      {
        type: "text",
        text: JSON.stringify(
          { count: summary.length, experiment_tickets: summary },
          null,
          2
        ),
      },
    ],
  };
}

function handleListTools() {
  return {
    tools: [
      {
        name: "get_ticket",
        description:
          "Get details of a GitHub Issue by key (e.g., ML-3). Returns title, description, acceptance criteria, experiment config, and MLflow experiment name if applicable.",
        inputSchema: {
          type: "object",
          properties: {
            ticket_key: {
              type: "string",
              description: "Issue key, e.g. ML-3",
            },
          },
          required: ["ticket_key"],
        },
      },
      {
        name: "search_tickets",
        description:
          "Search issues by query text, status, label, assignee, type (task/experiment/bug), or sprint.",
        inputSchema: {
          type: "object",
          properties: {
            query: { type: "string", description: "Free text search" },
            status: {
              type: "string",
              enum: ["To Do", "In Progress", "Done"],
            },
            label: { type: "string", description: "Filter by label" },
            assignee: { type: "string", description: "Filter by assignee" },
            type: {
              type: "string",
              enum: ["task", "experiment", "bug"],
            },
            sprint: { type: "string", description: "Sprint name filter" },
          },
        },
      },
      {
        name: "get_sprint",
        description:
          "Get sprint details and associated tickets. Omit sprint_name to list all sprints.",
        inputSchema: {
          type: "object",
          properties: {
            sprint_name: {
              type: "string",
              description: "Sprint name or partial match",
            },
          },
        },
      },
      {
        name: "get_experiment_tickets",
        description:
          "List all tickets related to ML experiments (type=experiment or has experiment_config). Useful for finding what to track in MLflow.",
        inputSchema: {
          type: "object",
          properties: {},
        },
      },
    ],
  };
}

function processRequest(request) {
  const { method, params, id } = request;

  switch (method) {
    case "initialize":
      return {
        jsonrpc: "2.0",
        id,
        result: {
          protocolVersion: "2024-11-05",
          capabilities: { tools: { listChanged: false } },
          serverInfo: {
            name: "ml-pipeline-github-issues-mock",
            version: "1.0.0",
            description:
              "Mock GitHub Issues server for ml-pipeline project. Provides ML experiment tickets, training tasks, data pipeline issues, and sprint information.",
          },
        },
      };

    case "notifications/initialized":
      return null;

    case "tools/list":
      return { jsonrpc: "2.0", id, result: handleListTools() };

    case "tools/call": {
      const toolName = params?.name;
      const toolArgs = params?.arguments || {};

      let result;
      switch (toolName) {
        case "get_ticket":
          result = handleGetTicket(toolArgs);
          break;
        case "search_tickets":
          result = handleSearchTickets(toolArgs);
          break;
        case "get_sprint":
          result = handleGetSprint(toolArgs);
          break;
        case "get_experiment_tickets":
          result = handleGetExperimentTickets(toolArgs);
          break;
        default:
          result = { error: \`Unknown tool: \${toolName}\` };
      }

      if (result.error) {
        return {
          jsonrpc: "2.0",
          id,
          result: {
            content: [{ type: "text", text: \`Error: \${result.error}\` }],
            isError: true,
          },
        };
      }

      return { jsonrpc: "2.0", id, result };
    }

    default:
      return {
        jsonrpc: "2.0",
        id,
        error: { code: -32601, message: \`Method not found: \${method}\` },
      };
  }
}

const rl = createInterface({ input: stdin, terminal: false });

rl.on("line", (line) => {
  const trimmed = line.trim();
  if (!trimmed) return;

  try {
    const request = JSON.parse(trimmed);
    const response = processRequest(request);
    if (response !== null) {
      stdout.write(JSON.stringify(response) + "\\n");
    }
  } catch (err) {
    const errorResponse = {
      jsonrpc: "2.0",
      id: null,
      error: { code: -32700, message: \`Parse error: \${err.message}\` },
    };
    stdout.write(JSON.stringify(errorResponse) + "\\n");
  }
});

process.stderr.write(
  "Mock GitHub Issues MCP server running (ml-pipeline project)\\n"
);
process.stderr.write(
  \`Loaded \${Object.keys(MOCK_TICKETS).length} tickets across \${Object.keys(SPRINTS).length} sprints\\n\`
);`,

  'mock-mcp-servers/package.json': `{
  "name": "ml-pipeline-mock-mcp-servers",
  "version": "1.0.0",
  "private": true,
  "description": "Mock MCP servers for ml-pipeline local development (GitHub Issues, Slack, AWS, Prometheus)",
  "type": "module",
  "scripts": {
    "start:github": "node github-server.mjs",
    "start:jira": "node jira-server.mjs",
    "start:all": "npm run start:github & npm run start:jira",
    "test": "node --test test/"
  },
  "dependencies": {
    "@modelcontextprotocol/sdk": "^1.0.0"
  },
  "devDependencies": {},
  "engines": {
    "node": ">=18.0.0"
  }
}`,

  'playbook/PLAYBOOK.md': `# ML Pipeline Development Playbook

> A structured 7-phase methodology for building, shipping, and maintaining production ML pipelines with PyTorch, MLflow, DVC, and FastAPI.

## Purpose

This playbook defines how the ml-pipeline team delivers work — from understanding a ticket to deploying a model to production. Every phase has clear entry criteria, actions, exit criteria, and ML-specific considerations.

It is designed for a small team (2-5 ML engineers + data scientists) working in GitHub Flow with conventional commits, and assumes Claude Code is an active participant in the development workflow.

## How to Use This Playbook

### Manual Phase Execution

Read the relevant phase document and follow the checklist:

\`\`\`
playbook/
├── PLAYBOOK.md              ← You are here
├── phase-1-understand.md    ← Ticket analysis & requirements
├── phase-2-plan.md          ← Technical design & experiment design
├── phase-3-implement.md     ← Code, train, iterate
├── phase-4-verify.md        ← Test, evaluate, validate
├── phase-5-review.md        ← Code review & experiment review
├── phase-6-deploy.md        ← Staging, canary, production
└── phase-7-monitor.md       ← Observability, drift, retraining
\`\`\`

### Claude-Assisted Execution

Use the \`/phase\` command to execute any phase with Claude:

\`\`\`
/phase 1          # Run Phase 1: Understand
/phase 2          # Run Phase 2: Plan
/phase 3          # Run Phase 3: Implement
/phase 4          # Run Phase 4: Verify
/phase 5          # Run Phase 5: Review
/phase 6          # Run Phase 6: Deploy
/phase 7          # Run Phase 7: Monitor
\`\`\`

Or use individual skill commands:

\`\`\`
/plan             # Detailed implementation planning (Phase 2)
/tdd              # Test-driven development cycle (Phase 3-4)
/verify           # Run full verification suite (Phase 4)
/code-review      # Automated code review (Phase 5)
/build-fix        # Diagnose and fix build failures (any phase)
\`\`\`

---

## Phase Overview

| Phase | Name | Key Activities | ML-Specific Focus |
|-------|------|---------------|-------------------|
| 1 | **Understand** | Parse ticket, clarify requirements, identify scope | Data requirements, metric definitions, baseline identification |
| 2 | **Plan** | Design solution, break into tasks, define experiments | Experiment design, config structure, DVC pipeline DAG |
| 3 | **Implement** | Write code, run experiments, iterate | Model architecture, training loops, feature engineering |
| 4 | **Verify** | Test, evaluate, validate | Model evaluation, data validation, reproducibility checks |
| 5 | **Review** | Code review, experiment review | MLflow comparison, artifact integrity, config review |
| 6 | **Deploy** | Stage, canary, release | Model registry promotion, A/B testing, serving validation |
| 7 | **Monitor** | Observe, alert, retrain | Data drift, model degradation, prediction monitoring |

---

## Phase 1: Understand

**Goal**: Fully understand what needs to be built, why, and what success looks like.

### Entry Criteria
- GitHub Issue exists with description and acceptance criteria
- Issue is assigned and has appropriate labels (\`model\`, \`data\`, \`infra\`, \`serving\`)

### Actions

1. **Read the ticket thoroughly** — understand the business context and ML objective
2. **Identify the task type**:
   - \`model\` — New model architecture, training improvement, hyperparameter tuning
   - \`data\` — Data pipeline, feature engineering, data quality
   - \`serving\` — API endpoint, batch inference, latency optimization
   - \`infra\` — Pipeline orchestration, GPU setup, monitoring
   - \`experiment\` — Research spike, ablation study, benchmarking
3. **Clarify data requirements**:
   - What data is needed? Is it available in DVC?
   - Are there GDPR implications (PII, consent, anonymization)?
   - What preprocessing or feature engineering is required?
4. **Define success metrics**:
   - Primary metric (e.g., F1, AUC-ROC, RMSE, latency p99)
   - Secondary metrics and constraints
   - Baseline to beat (current production model or published benchmark)
5. **Identify dependencies**:
   - Data availability and freshness
   - GPU compute requirements (EC2 instance type, estimated training time)
   - Upstream/downstream pipeline dependencies
6. **Check for sensitive paths**: \`configs/production/**\`, \`models/**\`, \`.env*\`, \`data/**\`

### Exit Criteria
- [ ] Requirements are clear and unambiguous
- [ ] Success metrics are defined with specific thresholds
- [ ] Data requirements are documented
- [ ] GDPR/SOC 2 implications are identified
- [ ] Scope is estimated (S/M/L) and agreed upon

### ML Considerations
- If the ticket involves model changes, identify the current best experiment in MLflow
- If the ticket involves data changes, check DVC remote for data lineage
- If the ticket involves serving changes, review current model latency baselines

---

## Phase 2: Plan

**Goal**: Design the technical approach, break work into tasks, and define experiment configurations.

### Entry Criteria
- Phase 1 complete — requirements understood and metrics defined

### Actions

1. **Design the solution**:
   - For model work: architecture choices, loss functions, training strategy
   - For data work: pipeline DAG changes, feature transformations, validation rules
   - For serving work: API contract, inference optimization, caching strategy
   - For infra work: resource requirements, scaling approach, cost estimates
2. **Define experiment configuration** (for model/training work):
   \`\`\`yaml
   # configs/experiments/experiment-name.yaml
   experiment:
     name: "ML-42-transformer-baseline"
     description: "Transformer model for sequence classification"
   model:
     architecture: "transformer"
     params:
       d_model: 256
       n_heads: 8
       n_layers: 4
   training:
     epochs: 50
     batch_size: 64
     learning_rate: 0.001
     optimizer: "adamw"
   data:
     dataset: "processed/v3"
     split_ratio: [0.8, 0.1, 0.1]
   \`\`\`
3. **Plan the DVC pipeline** (if data/training pipeline changes):
   - Define stages in \`dvc.yaml\`
   - Identify inputs, outputs, and dependencies
   - Plan data versioning strategy
4. **Break into implementation tasks**:
   - Each task should be completable in < 4 hours
   - Order tasks by dependency
   - Identify what can be parallelized
5. **Write the plan** as a comment on the GitHub Issue or in a linked document

### Exit Criteria
- [ ] Technical approach documented
- [ ] Experiment config YAML drafted (if applicable)
- [ ] DVC pipeline changes identified (if applicable)
- [ ] Tasks broken down with clear ordering
- [ ] Branch created: \`type/TICKET-desc\` (e.g., \`feat/ML-42-add-transformer-model\`)

### ML Considerations
- Review related experiments in MLflow before designing new ones
- Ensure experiment configs use Pydantic validation (\`src/utils/config.py\`)
- Plan for reproducibility: pin random seeds, log all hyperparameters
- Estimate GPU hours and cost before starting training

---

## Phase 3: Implement

**Goal**: Write production-quality code, run experiments, and iterate toward the success criteria.

### Entry Criteria
- Phase 2 complete — plan approved, branch created
- Development environment set up (\`uv sync\`, DVC configured)

### Actions

1. **Follow TDD for pipeline components**:
   \`\`\`bash
   # Write test first
   uv run pytest tests/test_model.py::test_forward_pass -x

   # Implement until test passes
   # Repeat
   \`\`\`
2. **Implement in order**:
   - Data loading and preprocessing (\`src/data/\`)
   - Feature engineering (\`src/data/features.py\`)
   - Model architecture (\`src/models/\`)
   - Training loop (\`src/training/\`)
   - Evaluation (\`src/evaluation/\`)
   - Serving endpoint (\`src/serving/\`) — if applicable
3. **Run experiments with MLflow tracking**:
   \`\`\`bash
   # Start MLflow UI
   mlflow ui --port 5000

   # Run training with experiment tracking
   uv run python scripts/train.py --config configs/experiments/experiment-name.yaml
   \`\`\`
4. **Version data and artifacts with DVC**:
   \`\`\`bash
   # Track new data
   dvc add data/processed/v3/

   # Run full pipeline
   dvc repro

   # Push artifacts to S3
   dvc push
   \`\`\`
5. **Commit incrementally** with conventional commits:
   \`\`\`bash
   git commit -m "feat(model): add transformer encoder architecture"
   git commit -m "feat(data): implement sequence tokenization pipeline"
   git commit -m "experiment: run transformer baseline with d_model=256"
   \`\`\`
6. **Continuous quality checks**:
   \`\`\`bash
   uv run ruff check src/
   uv run ruff format --check src/
   uv run mypy src/
   uv run pytest tests/ --cov=src --cov-fail-under=75
   \`\`\`

### Coding Standards (enforced)
- **Max file length**: 300 lines — split into modules if exceeded
- **Type hints**: Required on all public functions
- **Naming**: \`snake_case\` for files/functions, \`PascalCase\` for classes, \`SCREAMING_SNAKE_CASE\` for constants
- **Config validation**: Use Pydantic models for all YAML configs
- **No notebooks in production**: Exploration in \`notebooks/\`, production code in \`src/\`
- **AI-generated code**: Mark with \`# AI-GENERATED\` comment when applicable

### Exit Criteria
- [ ] All planned components implemented
- [ ] Tests written and passing (\`uv run pytest\`)
- [ ] Linting clean (\`uv run ruff check src/\`)
- [ ] Type checking clean (\`uv run mypy src/\`)
- [ ] Experiments logged in MLflow with reproducible configs
- [ ] Data/model artifacts tracked in DVC
- [ ] Code follows 300-line file limit

### ML Considerations
- Log all hyperparameters, metrics, and artifacts to MLflow
- Save model checkpoints during training (not just final model)
- Use deterministic operations where possible (set seeds, use \`torch.use_deterministic_algorithms\`)
- Profile GPU memory usage for large models
- Never commit data files or model weights to git — use DVC

---

## Phase 4: Verify

**Goal**: Ensure code quality, model quality, data quality, and reproducibility.

### Entry Criteria
- Phase 3 complete — implementation done, experiments run

### Actions

1. **Run the full verification suite**:
   \`\`\`bash
   # Lint
   uv run ruff check src/ tests/

   # Format check
   uv run ruff format --check src/ tests/

   # Type check
   uv run mypy src/

   # Unit tests with coverage
   uv run pytest tests/unit/ --cov=src --cov-fail-under=75

   # Integration tests
   uv run pytest tests/integration/ -m integration

   # Training smoke test (fast, small data)
   uv run pytest tests/smoke/ -m smoke --timeout=120
   \`\`\`
2. **Validate model quality**:
   - Compare experiment metrics against baseline in MLflow
   - Run evaluation on held-out test set
   - Check for overfitting (train vs. validation gap)
   - Verify model outputs are reasonable (sanity checks)
3. **Validate data quality**:
   - Check for data leakage between train/val/test splits
   - Validate feature distributions haven't shifted
   - Ensure GDPR compliance (no PII in training data without consent)
   - Verify DVC-tracked data matches expected checksums
4. **Verify reproducibility**:
   \`\`\`bash
   # Re-run pipeline from scratch
   dvc repro

   # Compare metrics — should match within tolerance
   \`\`\`
5. **Check serving readiness** (if applicable):
   \`\`\`bash
   # Start FastAPI server
   uv run uvicorn src.serving.app:app --host 0.0.0.0 --port 8000

   # Run inference tests
   uv run pytest tests/integration/test_serving.py
   \`\`\`

### Exit Criteria
- [ ] All linting, formatting, and type checks pass
- [ ] Test coverage ≥ 75%
- [ ] Model metrics meet or exceed defined thresholds
- [ ] No data leakage detected
- [ ] Pipeline is reproducible via \`dvc repro\`
- [ ] Training smoke test passes in CI
- [ ] GDPR compliance verified for data handling

---

## Phase 5: Review

**Goal**: Get code reviewed, experiment results validated, and approval for merge.

### Entry Criteria
- Phase 4 complete — all checks passing, metrics validated

### Actions

1. **Open Pull Request**:
   - Title follows conventional commit format
   - Description includes:
     - What changed and why
     - Experiment results (link to MLflow run)
     - Metrics comparison table (before/after)
     - Screenshots of training curves (if applicable)
     - DVC pipeline changes (if applicable)
   - Add appropriate labels and reviewers
2. **Automated checks** (GitHub Actions):
   - Lint → Type Check → Unit Tests → Integration Tests → Build Docker → Train Smoke Test
   - AI code audit (if AI-generated code is flagged)
   - CODEOWNERS validation
3. **Code review focus areas**:
   - Model architecture correctness and efficiency
   - Training loop correctness (gradient handling, loss computation)
   - Data pipeline correctness (no leakage, proper splits)
   - Config validation (Pydantic models, reasonable defaults)
   - Security (no secrets in code, SOC 2 compliance)
   - Sensitive path changes (\`configs/production/**\`, \`models/**\`)
4. **Experiment review**:
   - Reviewer checks MLflow experiment comparison
   - Validates that metrics improvement is statistically significant
   - Reviews training curves for anomalies
   - Confirms reproducibility claim
5. **Address feedback** and iterate until approved

### Exit Criteria
- [ ] PR has at least 1 approval
- [ ] All CI checks pass (green)
- [ ] Experiment results reviewed and accepted
- [ ] No unresolved review comments
- [ ] Sensitive path changes reviewed by lead/senior
- [ ] PR is squash-merged to \`main\`

### ML Considerations
- Include MLflow experiment links in PR description
- For model changes, include a metrics comparison table:
  \`\`\`
  | Metric    | Baseline | This PR | Δ       |
  |-----------|----------|---------|---------|
  | F1        | 0.82     | 0.87    | +0.05   |
  | Latency   | 45ms     | 52ms    | +7ms    |
  \`\`\`
- For data pipeline changes, include DVC diff output
- Reviewer should verify model artifact integrity (checksums)

---

## Phase 6: Deploy

**Goal**: Safely deploy the model and code changes to staging and production.

### Entry Criteria
- Phase 5 complete — PR merged to \`main\`

### Actions

1. **Register model in MLflow** (if model changed):
   \`\`\`python
   import mlflow
   mlflow.register_model(
       model_uri=f"runs:/{run_id}/model",
       name="production-model"
   )
   \`\`\`
2. **Promote model version**:
   - \`None\` → \`Staging\` (automatic on merge)
   - \`Staging\` → \`Production\` (manual after validation)
3. **Deploy to staging** (automatic via GitHub Actions):
   - Build Docker image → Push to ECR
   - Deploy to ECS staging cluster
   - Run integration tests against staging
   - Validate model serving latency and correctness
4. **Staging validation**:
   \`\`\`bash
   # Health check
   curl https://staging-api.ml-pipeline.internal/health

   # Inference test
   curl -X POST https://staging-api.ml-pipeline.internal/predict \\
     -H "Content-Type: application/json" \\
     -d '{"features": [...]}'
   \`\`\`
5. **Deploy to production** (manual approval required):
   - Trigger production deployment workflow
   - Canary deployment (10% traffic → 50% → 100%)
   - A/B test if comparing against existing production model
   - Monitor error rates and latency during rollout
6. **Update DVC remote**:
   \`\`\`bash
   dvc push  # Ensure all artifacts are in S3
   \`\`\`

### Exit Criteria
- [ ] Model registered in MLflow model registry
- [ ] Staging deployment successful and validated
- [ ] Production deployment completed with canary rollout
- [ ] No increase in error rates or latency degradation
- [ ] Model artifacts pushed to DVC remote (S3)
- [ ] Deployment documented in GitHub release

### ML Considerations
- Never deploy a model that hasn't been evaluated on the held-out test set
- Ensure model version in MLflow registry matches deployed artifact
- Keep previous production model available for instant rollback
- Log deployment metadata (model version, config hash, deploy timestamp)

---

## Phase 7: Monitor

**Goal**: Continuously observe model performance, data quality, and system health in production.

### Entry Criteria
- Phase 6 complete — model deployed to production

### Actions

1. **System monitoring** (Prometheus + Grafana):
   - API latency (p50, p95, p99)
   - Request throughput and error rates
   - GPU utilization and memory
   - Container health and resource usage
2. **Model monitoring** (MLflow + custom metrics):
   - Prediction distribution shifts
   - Feature distribution drift (compare against training data)
   - Model confidence calibration
   - Business metric impact (conversion, engagement, etc.)
3. **Data monitoring**:
   - Input data schema validation
   - Feature value range checks
   - Missing value rates
   - Data freshness (staleness alerts)
4. **Alert thresholds**:
   | Metric | Warning | Critical |
   |--------|---------|----------|
   | API p99 latency | > 200ms | > 500ms |
   | Error rate | > 1% | > 5% |
   | Prediction drift | > 2σ | > 3σ |
   | Feature drift | > 0.1 PSI | > 0.25 PSI |
5. **Retraining triggers**:
   - Scheduled retraining (weekly/monthly based on data volume)
   - Drift-triggered retraining (when drift exceeds threshold)
   - Performance-triggered retraining (when metrics degrade)
6. **Incident response**:
   - Rollback to previous model version if critical alerts fire
   - Document incident in GitHub Issue
   - Run post-mortem and update monitoring thresholds

### Exit Criteria
- [ ] Monitoring dashboards configured and accessible
- [ ] Alert rules defined and tested
- [ ] Retraining pipeline documented and tested
- [ ] Runbook updated with new model-specific procedures
- [ ] On-call rotation aware of new deployment

### ML Considerations
- Data drift doesn't always mean model degradation — investigate before retraining
- Log prediction inputs and outputs for debugging (with GDPR-compliant anonymization)
- Track model staleness — how old is the training data vs. current production data?
- Maintain a model performance log in \`docs/experiment-log.md\`

---

## Quick Reference

### Common Commands

\`\`\`bash
# Development
uv sync                                    # Install dependencies
uv run ruff check src/                     # Lint
uv run ruff format src/                    # Format
uv run mypy src/                           # Type check
uv run pytest tests/ --cov=src             # Test with coverage

# ML Pipeline
dvc repro                                  # Run full DVC pipeline
dvc push                                   # Push artifacts to S3
dvc pull                                   # Pull artifacts from S3
mlflow ui --port 5000                      # Start MLflow UI

# Training
uv run python scripts/train.py --config configs/experiments/exp.yaml

# Serving
uv run uvicorn src.serving.app:app --reload --port 8000

# Docker
docker build -t ml-pipeline:latest .
docker run -p 8000:8000 ml-pipeline:latest
\`\`\`

### Branch Naming

\`\`\`
feat/ML-42-add-transformer-model
fix/ML-55-training-memory-leak
experiment/ML-60-ablation-study
chore/ML-70-upgrade-pytorch
docs/ML-80-update-runbook
\`\`\`

### Commit Messages

\`\`\`
feat(model): add multi-head attention layer
feat(data): implement sliding window feature extraction
fix(training): resolve gradient accumulation bug
experiment: run hyperparameter sweep for learning rate
chore(deps): upgrade pytorch to 2.2.0
docs: add transformer architecture diagram
\`\`\`

### File Ownership (CODEOWNERS)

\`\`\`
configs/production/**    @ml-pipeline/leads
models/**                @ml-pipeline/leads
src/serving/**           @ml-pipeline/senior-engineers
.github/workflows/**     @ml-pipeline/leads
data/**                  @ml-pipeline/data-scientists
\`\`\`

---

## Related Documents

- [Architecture](../docs/ARCHITECTURE.md) — System design and component overview
- [Contributing](../docs/CONTRIBUTING.md) — Development workflow and standards
- [Onboarding](../docs/ONBOARDING.md) — New team member setup guide
- [AI Usage Policy](../docs/AI-USAGE-POLICY.md) — Guidelines for Claude Code usage
- [Plugin README](../plugin/codeforge-ml-pipeline/README.md) — Claude Code plugin documentation

---

## Playbook Maintenance

This playbook is a living document. Update it when:

- Team processes change
- New tools are adopted (e.g., new experiment tracker, new serving framework)
- Post-mortems reveal process gaps
- Team retrospectives identify improvements

**Owner**: ML Engineering Lead
**Last Updated**: See git log for \`playbook/PLAYBOOK.md\`
**Review Cadence**: Quarterly or after major incidents`,

  'playbook/claude-overrides/01-discovery.claude.md': `# Phase 01: Discovery & Requirements — Claude Overrides

## Purpose

These rules govern Claude's behavior during the Discovery & Requirements phase of the ml-pipeline project. This phase focuses on understanding the ML problem, defining data requirements, establishing success metrics, and scoping the pipeline architecture before any code is written.

---

## DO ✅

### Requirements Gathering

- **DO** ask clarifying questions about the ML problem definition before proposing solutions — understand the business objective, target metric, and acceptable performance thresholds
- **DO** distinguish between online (real-time inference) and offline (batch) requirements early — this shapes the entire pipeline architecture
- **DO** identify data sources, data freshness requirements, and expected data volumes before designing any pipeline stages
- **DO** define measurable success criteria using ML-specific metrics (e.g., F1 score > 0.85, p99 inference latency < 50ms, model drift threshold)
- **DO** document feature requirements as Pydantic schemas early — these become the contract between data engineering and model training
- **DO** capture non-functional requirements specific to ML: training time budget, GPU memory constraints, model size limits for serving, retraining frequency
- **DO** reference GDPR compliance when discussing any user data — document what data requires anonymization, consent tracking, or right-to-deletion support
- **DO** reference SOC 2 requirements when discussing model artifact storage, access controls, and audit trails
- **DO** map requirements to DVC pipeline stages (data ingestion → preprocessing → feature engineering → training → evaluation → serving)
- **DO** create user stories that reflect ML workflow personas: data scientist exploring features, ML engineer deploying models, stakeholder reviewing experiment results
- **DO** validate that every requirement has a corresponding test strategy — unit test for transforms, integration test for pipeline stages, smoke test for model inference
- **DO** document data lineage requirements — every prediction must be traceable back to the training data, feature pipeline version, and model version via MLflow

### Experiment Planning

- **DO** define the experiment tracking taxonomy upfront: experiment names, run naming conventions, tag schemas, metric naming in MLflow
- **DO** establish baseline model requirements — what naive or existing model must be beaten before a new approach is considered production-worthy
- **DO** specify reproducibility requirements: random seeds, deterministic training flags in PyTorch, config-driven experiments via YAML + Pydantic
- **DO** plan the model registry workflow: which MLflow model stages (Staging, Production, Archived) map to which deployment environments

### Stakeholder Communication

- **DO** produce requirements documents in Markdown stored in \`docs/\` — not in notebooks or ephemeral formats
- **DO** link requirements to GitHub Issues with clear acceptance criteria
- **DO** use \`experiment:\` conventional commit prefix when documenting experiment hypotheses and results

---

## DON'T ❌

### Premature Implementation

- **DON'T** write any PyTorch model code, training loops, or FastAPI endpoints during discovery — this phase produces documents, schemas, and configs only
- **DON'T** propose specific model architectures (transformer, CNN, etc.) before the data characteristics, volume, and latency requirements are fully understood
- **DON'T** create Jupyter notebooks during discovery — notebooks are for Phase 04 exploration; discovery artifacts belong in \`docs/\` and \`configs/\`
- **DON'T** install or configure ML dependencies (PyTorch, MLflow, DVC) during this phase — that belongs in Phase 03: Foundation
- **DON'T** generate \`pyproject.toml\`, \`Dockerfile\`, or infrastructure code — those are Phase 03 deliverables

### Scope & Assumptions

- **DON'T** assume GPU availability without confirming the AWS instance types, quotas, and budget — document compute requirements explicitly
- **DON'T** skip data privacy classification — every data field must be tagged as PII, sensitive, or public before any pipeline design begins
- **DON'T** conflate training data requirements with serving data requirements — they often differ in schema, freshness, and volume
- **DON'T** ignore data quality requirements — define expectations for missing values, outliers, class imbalance, and data drift detection thresholds
- **DON'T** propose real-time feature engineering without confirming Redis feature store latency requirements and infrastructure readiness
- **DON'T** assume a single model serves all use cases — document whether multi-model, ensemble, or A/B testing scenarios are in scope
- **DON'T** skip the cost estimation for training and inference — GPU hours, S3 storage for DVC artifacts, MLflow backend storage, and SageMaker endpoints all have costs

### Anti-Patterns

- **DON'T** produce generic ML requirements — every requirement must reference this project's specific stack (PyTorch, MLflow, DVC, FastAPI, AWS)
- **DON'T** write requirements as vague narratives — use structured formats: user stories with acceptance criteria, NFR tables with measurable thresholds, data dictionaries with types and constraints
- **DON'T** create a single monolithic requirements document — split into: problem definition, data requirements, model requirements, infrastructure requirements, compliance requirements
- **DON'T** ignore the existing \`configs/\` convention — any experiment parameters discussed during discovery should be sketched as YAML config structures validated by Pydantic
- **DON'T** forget to document what is explicitly out of scope — this prevents scope creep during implementation phases
- **DON'T** produce files longer than 300 lines — split large requirement documents into focused sub-documents

---

## Phase 01 Deliverables Checklist

Before moving to Phase 02 (Architecture & Design), confirm these artifacts exist:

| Deliverable | Location | Format |
|---|---|---|
| ML Problem Definition | \`docs/requirements/problem-definition.md\` | Markdown |
| Data Requirements & Dictionary | \`docs/requirements/data-requirements.md\` | Markdown + tables |
| Model Requirements & Success Metrics | \`docs/requirements/model-requirements.md\` | Markdown + metric thresholds |
| Non-Functional Requirements | \`docs/requirements/nfr.md\` | Structured table |
| User Stories | GitHub Issues | Issue with acceptance criteria |
| GDPR Data Classification | \`docs/compliance/data-classification.md\` | PII mapping table |
| Experiment Taxonomy | \`docs/requirements/experiment-taxonomy.md\` | MLflow naming conventions |
| Scope & Out-of-Scope | \`docs/requirements/scope.md\` | Markdown |
| Cost Estimate (Training + Serving) | \`docs/requirements/cost-estimate.md\` | Table with AWS pricing |
| Config Schema Sketches | \`docs/requirements/config-schemas.md\` | YAML examples |

---

## Transition Criteria

Phase 01 is complete when:

1. All deliverables above are reviewed and merged to \`main\`
2. At least one team member has approved the requirements PR
3. GitHub Issues are created for all user stories with labels and milestone
4. Data sources are identified and access is confirmed (even if not yet ingested)
5. Success metrics have quantitative thresholds agreed upon by stakeholders
6. GDPR data classification is complete for all identified data fields
7. The team can answer: "What does a successful v1 model look like?" with specific numbers`,

  'playbook/claude-overrides/02-architecture.claude.md': `# Phase 02: Architecture & Design — Claude Overrides

## Purpose

These rules govern Claude's behavior during architecture and design decisions for the ml-pipeline project. They ensure designs align with our PyTorch + MLflow + DVC + FastAPI stack, DAG-based pipeline architecture, and compliance requirements (SOC 2, GDPR).

---

## DO — Architecture Decisions

- **DO** design all ML pipelines as reproducible DAGs orchestrated by DVC (\`dvc.yaml\` stages)
- **DO** use Pydantic \`BaseModel\` subclasses for all configuration schemas — experiment configs, model hyperparameters, data pipeline params, serving request/response models
- **DO** load YAML configs from \`configs/\` and validate them through Pydantic before any pipeline stage executes
- **DO** separate concerns into the established module boundaries: \`src/data/\`, \`src/models/\`, \`src/training/\`, \`src/evaluation/\`, \`src/serving/\`, \`src/utils/\`
- **DO** design model architectures as \`torch.nn.Module\` subclasses with clear \`forward()\` signatures and type-annotated inputs/outputs
- **DO** design the training loop to log all hyperparameters, metrics, and artifacts to MLflow — every run must be reproducible from its MLflow record
- **DO** design data pipelines with explicit stage boundaries: raw → processed → features → train/val/test splits
- **DO** use DVC for tracking all data artifacts (\`data/\`) and model artifacts (\`models/\`) — never commit large files to Git
- **DO** design the FastAPI serving layer with separate endpoints for real-time inference (\`/predict\`) and batch inference (\`/predict/batch\`)
- **DO** use Redis for feature caching and inference result caching in the serving layer
- **DO** use PostgreSQL as the MLflow backend store and for pipeline metadata
- **DO** design for GPU-accelerated training with explicit device management (\`torch.device\` selection, \`.to(device)\` patterns)
- **DO** write Architecture Decision Records (ADRs) in \`docs/adr/\` for significant choices (model architecture, data storage format, serving strategy, infrastructure decisions)
- **DO** design all APIs with versioning from day one (\`/api/v1/\`)
- **DO** include health check, readiness, and model version endpoints in the serving API
- **DO** design experiment configs to be self-contained — a single YAML file should fully specify a reproducible experiment
- **DO** plan for A/B testing infrastructure with model version routing in the serving layer
- **DO** design data schemas with GDPR compliance: include fields for consent tracking, anonymization flags, and support for right-to-deletion queries
- **DO** design model artifact storage with integrity verification (checksums, signed artifacts) for SOC 2 compliance
- **DO** use dependency injection patterns for swappable components (data loaders, model architectures, optimizers, schedulers)

## DON'T — Architecture Decisions

- **DON'T** design monolithic training scripts — break pipelines into composable DVC stages
- **DON'T** hardcode hyperparameters, file paths, or AWS resource identifiers in source code — always use Pydantic-validated configs from \`configs/\`
- **DON'T** design model classes that mix training logic with architecture definition — \`nn.Module\` subclasses define architecture only
- **DON'T** put production logic in Jupyter notebooks — \`notebooks/\` is for exploration; production code lives in \`src/\`
- **DON'T** design data pipelines that skip validation — every stage must validate inputs and outputs with Pydantic or schema checks
- **DON'T** store model weights, datasets, or large artifacts in Git — use DVC with S3 remote storage
- **DON'T** design the serving layer to load models on every request — models must be loaded at startup and cached
- **DON'T** create circular dependencies between \`src/\` submodules — the dependency graph flows: \`utils\` → \`data\` → \`models\` → \`training\` → \`evaluation\` → \`serving\`
- **DON'T** design APIs without request validation, error handling, and structured error responses
- **DON'T** propose architectures that require more than 300 lines per file — decompose into focused modules
- **DON'T** design training pipelines without checkpointing — every N epochs must save a recoverable checkpoint
- **DON'T** skip MLflow experiment tracking in any design — if it trains, it logs
- **DON'T** design data access patterns that expose PII without anonymization layers (GDPR)
- **DON'T** propose new dependencies without justification — follow the moderate dependency review policy

---

## DO — Data Model & Schema Design

- **DO** define all data schemas as Pydantic models in dedicated schema files (e.g., \`src/data/schemas.py\`)
- **DO** version dataset schemas — breaking changes to feature schemas require a new DVC pipeline stage
- **DO** design feature engineering as pure functions: input DataFrame → output DataFrame, no side effects
- **DO** include data lineage tracking — every processed dataset must reference its source data hash (DVC)
- **DO** design the feature store (Redis-backed) with TTL-based expiration and explicit cache invalidation
- **DO** use \`torch.utils.data.Dataset\` and \`DataLoader\` abstractions for all training data access
- **DO** design train/validation/test splits as deterministic operations seeded by config values
- **DO** include data quality checks (null rates, distribution drift, schema conformance) as explicit pipeline stages

## DON'T — Data Model & Schema Design

- **DON'T** use raw dictionaries for data passing between pipeline stages — always use typed Pydantic models or dataclasses
- **DON'T** design feature engineering that leaks information from test sets into training sets
- **DON'T** store PII in feature stores or model artifacts without explicit anonymization
- **DON'T** design data loaders that load entire datasets into memory without considering dataset size — use streaming/batching for large datasets
- **DON'T** skip schema validation when reading data from external sources (S3, databases, APIs)

---

## DO — API & Interface Design

- **DO** design FastAPI endpoints with Pydantic request/response models and OpenAPI documentation
- **DO** include model metadata in inference responses (model version, experiment ID, prediction confidence)
- **DO** design the inference pipeline as a chain: preprocess → predict → postprocess, each step independently testable
- **DO** use async endpoints in FastAPI for I/O-bound operations (database queries, S3 access, Redis lookups)
- **DO** design batch inference endpoints to accept lists and return results in the same order
- **DO** include rate limiting and request size limits in the API design
- **DO** design the A/B testing router to select model versions based on configurable traffic split percentages
- **DO** expose Prometheus metrics from the serving layer: request latency, prediction distribution, model version counts, error rates

## DON'T — API & Interface Design

- **DON'T** expose internal model details (architecture, weights, training data paths) through public API responses
- **DON'T** design synchronous endpoints for long-running operations (batch inference, retraining triggers) — use background tasks or job queues
- **DON'T** return raw PyTorch tensors from API endpoints — always serialize to JSON-compatible formats
- **DON'T** design APIs without authentication — all endpoints require API key or JWT validation
- **DON'T** skip input validation on inference endpoints — malformed inputs must return 422 with descriptive errors

---

## DO — Infrastructure & Deployment Design

- **DO** design Docker images with multi-stage builds: builder stage (compile deps) → runtime stage (minimal image)
- **DO** design for separate CPU (serving) and GPU (training) container images
- **DO** use Terraform modules for all AWS infrastructure: S3 buckets, ECR repos, ECS services, SageMaker endpoints, EC2 GPU instances
- **DO** design the deployment pipeline to promote model artifacts through stages: development → staging → production (via MLflow Model Registry)
- **DO** include rollback mechanisms — the serving layer must support instant rollback to the previous model version
- **DO** design secrets management using AWS Secrets Manager or Parameter Store — never in config files or environment variables in code
- **DO** design Kubernetes manifests with resource limits, health probes, and horizontal pod autoscaling for the serving layer

## DON'T — Infrastructure & Deployment Design

- **DON'T** design infrastructure that requires manual steps — everything must be reproducible via Terraform and CI/CD
- **DON'T** use the same Docker image for training and serving — they have different dependency and resource profiles
- **DON'T** design deployments without health checks — both the training and serving containers must expose health endpoints
- **DON'T** store model artifacts or data in ephemeral container storage — always use S3 via DVC
- **DON'T** design GPU training without spot instance fallback strategies and checkpoint recovery

---

## DO — Experiment & MLflow Design

- **DO** design MLflow experiments with a consistent naming convention: \`{project}/{model_type}/{dataset_version}\`
- **DO** log the full experiment config YAML as an MLflow artifact alongside metrics and model weights
- **DO** design the MLflow Model Registry workflow: \`None\` → \`Staging\` → \`Production\` with approval gates
- **DO** include model comparison dashboards that pull from MLflow's metric history
- **DO** design hyperparameter tuning to log each trial as a child run under a parent MLflow run
- **DO** store the Git commit hash, DVC data hash, and config hash as MLflow run tags for full reproducibility

## DON'T — Experiment & MLflow Design

- **DON'T** design experiments without a baseline model for comparison
- **DON'T** promote models to production without evaluation against the current production model on a held-out test set
- **DON'T** log metrics at inconsistent granularities — standardize on epoch-level and step-level logging
- **DON'T** skip logging system metrics (GPU utilization, memory usage, training time) alongside model metrics

---

## Compliance Checkpoints

### SOC 2
- All architecture decisions must include access control considerations
- Model artifact integrity must be verifiable (checksums stored in MLflow)
- Audit trail for model promotions (MLflow Model Registry transitions with user attribution)
- Infrastructure changes tracked in Terraform state with versioning

### GDPR
- Data pipeline designs must include anonymization stages before feature engineering
- Right-to-deletion must be achievable without full model retraining (design for data removal from feature stores and caches)
- Consent tracking fields required in any schema that touches user data
- Data retention policies must be configurable per pipeline stage

---

## Cross-References

- Architecture decision template: \`playbook/prompts/02/adr-generator.md\`
- API design prompt: \`playbook/prompts/02/api-design.md\`
- Data model design prompt: \`playbook/prompts/02/data-model-design.md\`
- Module dependency rules: \`.claude/rules/module-boundaries.md\`
- Experiment config schema: \`configs/README.md\`
- DVC pipeline definition: \`dvc.yaml\``,

  'playbook/claude-overrides/03-foundation.claude.md': `# Phase 03: Foundation & Scaffolding — Claude Override Rules

## Phase Context

You are helping scaffold and configure the ml-pipeline project foundation. This includes project structure, dependency management, CI/CD pipelines, infrastructure-as-code, DVC initialization, MLflow setup, and base configurations. Every decision here affects the entire project lifecycle.

---

## DO ✅

### Project Structure

- DO use the canonical directory layout: \`src/data/\`, \`src/models/\`, \`src/training/\`, \`src/evaluation/\`, \`src/serving/\`, \`src/utils/\`, \`configs/\`, \`tests/\`, \`scripts/\`, \`docs/\`
- DO create \`__init__.py\` files in every Python package under \`src/\`
- DO create a \`src/py.typed\` marker file for PEP 561 compliance
- DO use \`pyproject.toml\` as the single source of truth for project metadata, dependencies, and tool configuration
- DO pin all dependency versions exactly in \`pyproject.toml\` (e.g., \`torch==2.1.0\`, not \`torch>=2.0\`)
- DO use \`uv\` for all package management commands (\`uv sync\`, \`uv add\`, \`uv run\`)
- DO create a \`uv.lock\` file and commit it to version control
- DO separate dependency groups: \`[project.dependencies]\`, \`[project.optional-dependencies.dev]\`, \`[project.optional-dependencies.gpu]\`, \`[project.optional-dependencies.serving]\`

### Configuration

- DO use Pydantic \`BaseSettings\` and \`BaseModel\` for all configuration validation
- DO create typed config classes in \`src/utils/config.py\` for: \`DataConfig\`, \`ModelConfig\`, \`TrainingConfig\`, \`ServingConfig\`, \`InfraConfig\`
- DO load YAML configs from \`configs/\` and validate them through Pydantic models
- DO use environment variable overrides with \`MLPIPELINE_\` prefix (e.g., \`MLPIPELINE_MLFLOW_TRACKING_URI\`)
- DO create separate config directories: \`configs/experiments/\`, \`configs/models/\`, \`configs/data/\`, \`configs/production/\`
- DO include a \`configs/default.yaml\` with sane defaults for local development
- DO add \`.env.example\` with all required environment variables documented

### CI/CD Pipeline

- DO configure GitHub Actions with these stages in order: lint → type-check → unit-tests → integration-tests → build-docker → train-smoke-test → deploy-staging
- DO use \`uv run ruff check src/ tests/\` for linting in CI
- DO use \`uv run ruff format --check src/ tests/\` for format checking in CI
- DO use \`uv run mypy src/\` with strict mode for type checking in CI
- DO use \`uv run pytest tests/ --cov=src --cov-report=xml --cov-fail-under=75\` for test coverage enforcement
- DO include a smoke test that runs a minimal training loop on synthetic data (< 2 minutes)
- DO cache \`uv\` dependencies and DVC cache in CI for faster builds
- DO add \`# AI-GENERATED\` comment headers when generating workflow files

### DVC Setup

- DO initialize DVC with \`dvc init\` and configure S3 remote storage
- DO create a \`dvc.yaml\` pipeline file with stages: \`prepare\`, \`featurize\`, \`train\`, \`evaluate\`
- DO track \`data/\` and \`models/\` directories with DVC, not Git
- DO add \`data/**\` and \`models/**\` to \`.gitignore\` (DVC handles these)
- DO create \`.dvc/config\` with remote storage pointing to the project's S3 bucket
- DO include \`dvc.lock\` in version control for reproducibility

### MLflow Setup

- DO configure MLflow tracking URI to point to the PostgreSQL backend store
- DO configure MLflow artifact store to use S3
- DO create a \`src/utils/mlflow_utils.py\` with helper functions: \`init_experiment()\`, \`log_params_from_config()\`, \`log_model_artifact()\`
- DO set up MLflow experiment naming convention: \`{project}/{model_type}/{date}\`
- DO register models in MLflow Model Registry with stages: \`None\` → \`Staging\` → \`Production\`

### Docker

- DO use multi-stage Docker builds: \`base\` → \`training\` and \`base\` → \`serving\`
- DO use \`python:3.11-slim\` as the base image
- DO install \`uv\` in the Docker image and use it for dependency installation
- DO create separate Dockerfiles: \`Dockerfile.training\`, \`Dockerfile.serving\`
- DO include health check endpoints in the serving container
- DO set \`PYTHONUNBUFFERED=1\`, \`PYTHONDONTWRITEBYTECODE=1\`, and \`PYTHONPATH=/app/src\` in Docker

### Infrastructure

- DO use Terraform for all AWS infrastructure: S3 buckets, ECR repos, ECS services, RDS (PostgreSQL), ElastiCache (Redis)
- DO create Terraform modules: \`modules/storage/\`, \`modules/compute/\`, \`modules/networking/\`, \`modules/mlflow/\`
- DO use Terraform workspaces or separate tfvars for staging vs production
- DO encrypt S3 buckets at rest (AES-256) and enable versioning for model artifact buckets
- DO tag all AWS resources with \`project=ml-pipeline\`, \`environment\`, \`managed-by=terraform\`

### Testing Foundation

- DO create \`conftest.py\` files at \`tests/\`, \`tests/unit/\`, and \`tests/integration/\` levels
- DO create pytest fixtures for: synthetic datasets, mock MLflow client, temporary model checkpoints, test configs
- DO configure pytest in \`pyproject.toml\` with markers: \`unit\`, \`integration\`, \`slow\`, \`gpu\`
- DO create a \`tests/factories/\` directory with factory functions for test data generation

### Security & Compliance

- DO create a \`.env.example\` that documents required secrets without actual values
- DO add \`pre-commit\` hooks for: ruff, ruff-format, mypy, detect-secrets, check-added-large-files
- DO configure \`.gitignore\` to exclude: \`.env*\`, \`data/\`, \`models/\`, \`*.pt\`, \`*.pth\`, \`*.onnx\`, \`__pycache__/\`, \`.mypy_cache/\`
- DO set up CODEOWNERS with: \`configs/production/** @ml-leads\`, \`models/** @ml-leads\`, \`src/serving/** @ml-leads @backend-team\`

### Code Quality Tooling

- DO configure ruff in \`pyproject.toml\` with rule sets: \`E\`, \`F\`, \`W\`, \`I\`, \`N\`, \`UP\`, \`ANN\`, \`S\`, \`B\`, \`A\`, \`C4\`, \`PT\`, \`RUF\`
- DO set ruff line length to 100
- DO configure mypy in \`pyproject.toml\` with \`strict = true\`, \`warn_return_any = true\`, \`disallow_untyped_defs = true\`
- DO add mypy plugins for Pydantic: \`pydantic.mypy\`

---

## DON'T ❌

### Project Structure

- DON'T put ML code directly in the project root — all source code goes under \`src/\`
- DON'T create a \`setup.py\` or \`setup.cfg\` — use \`pyproject.toml\` exclusively
- DON'T use \`pip\` or \`conda\` — this project uses \`uv\` for package management
- DON'T create a monolithic \`utils.py\` — split utilities into focused modules: \`config.py\`, \`logging.py\`, \`mlflow_utils.py\`, \`io.py\`
- DON'T put production code in \`notebooks/\` — notebooks are for exploration only
- DON'T create files longer than 300 lines — split into focused modules

### Configuration

- DON'T hardcode hyperparameters, paths, URIs, or credentials anywhere in source code
- DON'T use \`os.environ.get()\` directly — always go through Pydantic settings classes
- DON'T store secrets in YAML config files — use environment variables or AWS Secrets Manager
- DON'T create config files without corresponding Pydantic validation models
- DON'T use \`configs/production/**\` as a template — production configs are sensitive paths requiring lead review

### CI/CD Pipeline

- DON'T skip type checking (\`mypy\`) in CI — it catches real bugs in ML code
- DON'T allow CI to pass with coverage below 75%
- DON'T run full training jobs in CI — use smoke tests with synthetic data and 1-2 epochs
- DON'T deploy to production automatically — only staging gets auto-deploy
- DON'T store Docker images with embedded credentials or config secrets
- DON'T use \`latest\` tags for Docker images — always use commit SHA or semantic version

### DVC Setup

- DON'T commit raw data or model artifacts to Git — always use DVC
- DON'T store DVC remote credentials in \`dvc.yaml\` or \`.dvc/config\` — use environment variables
- DON'T create DVC pipelines without \`params.yaml\` or YAML config references for reproducibility
- DON'T skip \`dvc.lock\` from version control — it ensures exact reproducibility

### MLflow Setup

- DON'T use the default MLflow file-based backend for anything beyond local dev
- DON'T log experiments without a reproducible config snapshot attached as an artifact
- DON'T create MLflow experiments with ad-hoc naming — follow the \`{project}/{model_type}/{date}\` convention
- DON'T promote models to \`Production\` stage without evaluation metrics logged and compared
- DON'T store PII or sensitive data in MLflow parameters or tags (GDPR compliance)

### Docker

- DON'T use \`python:3.11\` (full image) — use \`python:3.11-slim\` to reduce attack surface
- DON'T install dev dependencies in production Docker images
- DON'T copy \`.env\` files, \`.git/\`, \`data/\`, or \`notebooks/\` into Docker images
- DON'T run containers as root — create and use a non-root user
- DON'T embed GPU drivers in the Docker image — mount them from the host or use NVIDIA base images only for training

### Infrastructure

- DON'T create AWS resources manually — everything goes through Terraform
- DON'T use default VPC or public subnets for databases or Redis
- DON'T create S3 buckets without encryption and versioning for model artifacts
- DON'T skip tagging on AWS resources — all resources need \`project\`, \`environment\`, \`managed-by\` tags
- DON'T store Terraform state locally — use S3 backend with DynamoDB locking

### Testing Foundation

- DON'T write tests that depend on real AWS services, MLflow server, or GPU availability
- DON'T create test fixtures that download real datasets — use synthetic data factories
- DON'T skip async test support — configure \`pytest-asyncio\` for FastAPI endpoint tests
- DON'T put test utilities in \`src/\` — keep them in \`tests/\` or \`tests/factories/\`

### Security & Compliance

- DON'T commit \`.env\` files, AWS credentials, or database connection strings
- DON'T skip \`pre-commit\` hook setup — it prevents secrets and large files from entering the repo
- DON'T allow data files (\`.csv\`, \`.parquet\`, \`.pt\`, \`.pth\`) to be committed to Git
- DON'T create IAM roles or policies with \`*\` resource permissions in Terraform
- DON'T log or store PII in experiment tracking, model metadata, or application logs (GDPR)
- DON'T skip CODEOWNERS for sensitive paths: \`configs/production/**\`, \`models/**\`, \`.env*\`, \`data/**\`

### Code Quality

- DON'T disable mypy strict mode or add blanket \`# type: ignore\` comments
- DON'T suppress ruff rules globally — use inline \`# noqa\` only with specific rule codes and justification
- DON'T create public functions without type hints on parameters and return values
- DON'T use \`Any\` type unless absolutely necessary and documented with a comment explaining why

---

## Scaffolding Checklist

When Claude generates foundation code for this phase, verify:

1. \`pyproject.toml\` exists with pinned deps, ruff config, mypy config, pytest config
2. \`src/\` has proper package structure with \`__init__.py\` and \`py.typed\`
3. \`src/utils/config.py\` has Pydantic models for all config types
4. \`configs/default.yaml\` exists with documented defaults
5. \`.github/workflows/ci.yml\` has all required stages
6. \`dvc.yaml\` defines the pipeline DAG with parameterized stages
7. \`Dockerfile.training\` and \`Dockerfile.serving\` use multi-stage builds
8. \`tests/conftest.py\` has base fixtures for synthetic data and mock services
9. \`.pre-commit-config.yaml\` includes ruff, mypy, detect-secrets
10. \`CODEOWNERS\` protects sensitive paths
11. \`.gitignore\` excludes data, models, env files, and caches
12. \`.env.example\` documents all required environment variables
13. Terraform files exist in \`infra/\` with modular structure
14. No hardcoded credentials, paths, or hyperparameters in any generated file`,

  'playbook/claude-overrides/04-core-implementation.claude.md': `# Phase 04: Core Implementation — Claude Override Rules

## Phase Context

Phase 04 is where ML pipeline components are built: data loaders, feature engineering, model architectures, training loops, evaluation pipelines, and serving endpoints. This is the highest-risk phase for ML-specific anti-patterns.

---

## DO Rules

### Data Pipeline Implementation

- **DO** use \`torch.utils.data.Dataset\` and \`DataLoader\` for all data access patterns
- **DO** implement \`__len__\` and \`__getitem__\` with proper type hints on every custom Dataset
- **DO** validate data schemas with Pydantic models before feeding into pipelines
- **DO** use DVC to track raw data, processed data, and feature artifacts in \`data/\`
- **DO** implement feature engineering as deterministic, idempotent transforms in \`src/data/\`
- **DO** log data statistics (shape, null counts, distributions) to MLflow at pipeline start
- **DO** use \`configs/\` YAML files validated by Pydantic for all data pipeline parameters
- **DO** implement data splits (train/val/test) with fixed random seeds stored in config
- **DO** add GDPR-compliant anonymization in \`src/data/\` before any model training step
- **DO** stream large datasets instead of loading entirely into memory — use \`IterableDataset\` when data exceeds 10GB

### Model Architecture

- **DO** define all model architectures as \`torch.nn.Module\` subclasses in \`src/models/\`
- **DO** implement \`forward()\` with explicit tensor shape comments on input/output
- **DO** use \`@torch.no_grad()\` on all inference-only methods
- **DO** add type hints for tensor shapes using comments: \`# (batch_size, seq_len, hidden_dim)\`
- **DO** make model hyperparameters configurable via Pydantic config classes, never hardcoded
- **DO** implement \`__repr__\` or use \`torchinfo.summary()\` for model architecture logging
- **DO** keep individual model files under 300 lines — split complex architectures into submodules
- **DO** register model classes in a factory pattern in \`src/models/__init__.py\` for config-driven instantiation

### Training Loop

- **DO** use a structured training loop in \`src/training/\` with clear \`train_epoch()\` and \`validate_epoch()\` separation
- **DO** log all hyperparameters to MLflow at training start with \`mlflow.log_params()\`
- **DO** log metrics per epoch to MLflow with \`mlflow.log_metrics()\` including step number
- **DO** implement model checkpointing — save best model by validation metric and last N checkpoints
- **DO** save checkpoints as DVC-tracked artifacts in \`models/\`
- **DO** use \`torch.cuda.amp\` (automatic mixed precision) for GPU training when applicable
- **DO** implement early stopping as a configurable callback in \`src/training/callbacks.py\`
- **DO** set \`torch.manual_seed()\`, \`numpy.random.seed()\`, and \`torch.backends.cudnn.deterministic\` for reproducibility
- **DO** wrap training entry points in \`scripts/\` that load YAML configs and call \`src/training/\` functions
- **DO** use \`experiment:\` conventional commit prefix for training experiments

### Evaluation

- **DO** implement all metrics as pure functions in \`src/evaluation/metrics.py\`
- **DO** log evaluation artifacts (confusion matrices, ROC curves, prediction samples) to MLflow
- **DO** compare models against a registered baseline in MLflow Model Registry before promotion
- **DO** implement statistical significance tests when comparing model variants
- **DO** generate evaluation reports as Markdown artifacts stored alongside model checkpoints

### Serving (FastAPI)

- **DO** define request/response schemas as Pydantic models in \`src/serving/schemas.py\`
- **DO** load models at startup using FastAPI lifespan events, not on every request
- **DO** implement health check (\`/health\`), readiness (\`/ready\`), and model info (\`/model/info\`) endpoints
- **DO** use Redis for prediction caching and feature store lookups in \`src/serving/\`
- **DO** implement batch inference endpoints alongside single-prediction endpoints
- **DO** add request validation, error handling, and structured JSON error responses
- **DO** run inference with \`torch.no_grad()\` and model in \`eval()\` mode
- **DO** add latency metrics (p50, p95, p99) to Prometheus from serving endpoints
- **DO** version API endpoints: \`/v1/predict\`, \`/v2/predict\` for A/B testing infrastructure

### Code Quality

- **DO** run \`uv run ruff check src/\` and \`uv run ruff format --check src/\` before every commit
- **DO** run \`uv run mypy src/\` — strict mode, no \`Any\` escape hatches on public interfaces
- **DO** write pytest tests for every data transform, metric function, and API endpoint
- **DO** maintain 75% coverage minimum — \`uv run pytest --cov=src --cov-fail-under=75\`
- **DO** use \`snake_case\` for files and functions, \`PascalCase\` for classes, \`SCREAMING_SNAKE_CASE\` for constants
- **DO** add the \`# AI-generated\` comment header on files substantially generated by Claude
- **DO** keep all files under 300 lines — refactor into submodules when approaching the limit

### Configuration & Reproducibility

- **DO** define every experiment as a YAML file in \`configs/\` with Pydantic validation
- **DO** include git commit hash, config hash, and DVC data hash in every MLflow run
- **DO** use \`dvc repro\` to execute the full pipeline — never run training steps manually in production
- **DO** pin all dependency versions in \`pyproject.toml\` — no unpinned ranges

---

## DON'T Rules

### Data Pipeline Anti-Patterns

- **DON'T** hardcode file paths — use config YAML or environment variables for all paths
- **DON'T** load entire datasets into memory without checking size first
- **DON'T** apply feature engineering inside the model's \`forward()\` — keep it in \`src/data/\`
- **DON'T** commit raw data or processed data to git — use DVC exclusively for \`data/\` and \`models/\`
- **DON'T** use pandas in training hot paths — convert to tensors before the training loop
- **DON'T** skip data validation — always validate schema before pipeline execution
- **DON'T** store PII in training data without GDPR-compliant anonymization applied first
- **DON'T** use \`pickle\` for data serialization in production — use Parquet, Arrow, or safetensors

### Model Anti-Patterns

- **DON'T** use global variables for model state — encapsulate in \`nn.Module\` or config objects
- **DON'T** hardcode hidden dimensions, layer counts, or learning rates in model files
- **DON'T** use \`model.train()\` during inference or \`model.eval()\` during training
- **DON'T** ignore device management — always use explicit \`.to(device)\` and config-driven device selection
- **DON'T** use \`torch.save(model)\` — use \`torch.save(model.state_dict())\` for portability
- **DON'T** define model architectures in notebooks — notebooks are exploration only, production code lives in \`src/\`
- **DON'T** create model files over 300 lines — split into \`layers.py\`, \`attention.py\`, \`heads.py\` submodules
- **DON'T** use \`eval()\` or \`exec()\` to dynamically construct models — use the factory pattern

### Training Anti-Patterns

- **DON'T** train without logging to MLflow — every run must be tracked
- **DON'T** skip setting random seeds — reproducibility is mandatory
- **DON'T** use bare \`except:\` in training loops — catch specific exceptions and log them
- **DON'T** accumulate gradients unintentionally — call \`optimizer.zero_grad()\` at the correct point
- **DON'T** forget \`loss.backward()\` before \`optimizer.step()\` or skip gradient clipping on RNNs/Transformers
- **DON'T** log metrics only at training end — log per-epoch for debugging and early stopping
- **DON'T** use print statements for training progress — use structured logging with Python \`logging\` module
- **DON'T** run hyperparameter sweeps without tracking each trial as a child MLflow run
- **DON'T** modify \`configs/production/**\` without explicit review — these are sensitive paths

### Serving Anti-Patterns

- **DON'T** load models on every request — load once at startup via lifespan
- **DON'T** return raw tensors from API endpoints — convert to Python native types in Pydantic response models
- **DON'T** skip input validation on prediction endpoints — malformed inputs must return 422
- **DON'T** serve models without a \`/health\` endpoint — Kubernetes needs it for liveness probes
- **DON'T** log prediction inputs/outputs containing PII without GDPR-compliant redaction
- **DON'T** use synchronous blocking calls for batch inference — use \`async\` or background tasks
- **DON'T** deploy models that haven't been evaluated against the baseline in MLflow Model Registry

### General Anti-Patterns

- **DON'T** use \`# type: ignore\` without a specific mypy error code: use \`# type: ignore[specific-error]\`
- **DON'T** add new dependencies without reviewing them — check for license compatibility and security
- **DON'T** write functions longer than 50 lines — extract helpers
- **DON'T** use mutable default arguments in function signatures
- **DON'T** store secrets, API keys, or credentials in config YAML or code — use environment variables or AWS Secrets Manager
- **DON'T** copy-paste code between \`src/training/\` and \`src/serving/\` — extract shared logic to \`src/utils/\`
- **DON'T** skip writing tests because "it's just ML code" — data transforms, metrics, and API endpoints all need tests
- **DON'T** use \`os.path\` — use \`pathlib.Path\` consistently

---

## File-Specific Rules

| Path Pattern | Rule |
|---|---|
| \`src/models/**\` | Every file must define exactly one primary \`nn.Module\` class. Max 300 lines. |
| \`src/data/**\` | All transforms must be deterministic given the same config and random seed. |
| \`src/training/**\` | Must log to MLflow. Must accept config as Pydantic model, not raw dicts. |
| \`src/evaluation/**\` | Metric functions must be pure — no side effects, no MLflow calls inside metrics. |
| \`src/serving/**\` | All endpoints must have Pydantic request/response models and OpenAPI docs. |
| \`configs/**\` | YAML only. Must have a corresponding Pydantic validator in \`src/utils/config.py\`. |
| \`configs/production/**\` | Sensitive path. Changes require lead review per CODEOWNERS. |
| \`scripts/**\` | Entry points only — business logic lives in \`src/\`. Must be executable with \`uv run\`. |
| \`notebooks/**\` | Exploration only. Never import from notebooks in \`src/\`. No production logic. |
| \`tests/**\` | Mirror \`src/\` structure. Use fixtures for model and data setup. Parametrize edge cases. |
| \`data/**\` | DVC-tracked only. Never committed to git. \`.gitignore\` must exclude all contents. |
| \`models/**\` | DVC-tracked only. Model artifacts must include config hash for traceability. |

---

## Commit & PR Rules for This Phase

- Use \`feat:\` for new pipeline components, \`fix:\` for bug fixes, \`experiment:\` for training experiments
- Branch naming: \`feat/ML-{ticket}-{description}\` or \`experiment/ML-{ticket}-{description}\`
- PRs must include: what changed, why, MLflow run link (if training-related), test coverage delta
- PRs touching \`configs/production/**\` or \`models/**\` require lead approval
- Mark AI-generated code with \`# AI-generated\` header comment and flag in PR description
- Run full lint + type check + test suite before opening PR: \`uv run ruff check src/ && uv run mypy src/ && uv run pytest\`

---

## Quick Reference Commands

\`\`\`bash
# Lint and format
uv run ruff check src/ tests/
uv run ruff format src/ tests/

# Type checking
uv run mypy src/

# Run tests with coverage
uv run pytest --cov=src --cov-fail-under=75

# Run DVC pipeline
dvc repro

# Start MLflow UI
mlflow ui --backend-store-uri postgresql://...

# Start serving locally
uv run uvicorn src.serving.app:app --reload

# Train with config
uv run python scripts/train.py --config configs/experiment_001.yaml
\`\`\``,

  'playbook/claude-overrides/05-integration-hardening.claude.md': `# Phase 05: Integration & Hardening — Claude Override Rules

## Phase Context

You are working on Phase 05 of the ml-pipeline project: integrating components (data pipelines, training loops, model serving, experiment tracking) into a cohesive system and hardening it for production reliability. This phase connects DVC pipelines to MLflow tracking, wires FastAPI serving to the model registry, and ensures the entire ML lifecycle is secure, observable, and resilient.

---

## DO — Required Behaviors

### Pipeline Integration

- DO wire DVC pipeline stages (\`dvc.yaml\`) so that \`dvc repro\` executes the full DAG: data ingestion → preprocessing → feature engineering → training → evaluation → model registration
- DO ensure every training run logs parameters, metrics, and artifacts to MLflow using \`mlflow.pytorch.log_model()\` and \`mlflow.log_params()\`
- DO validate that MLflow experiment names follow the convention \`{project}/{model_type}/{date}\` for traceability
- DO use Pydantic models to validate all inter-component contracts (data schemas between pipeline stages, API request/response models, config objects)
- DO implement health checks in the FastAPI serving layer that verify model loading, Redis connectivity, and PostgreSQL availability
- DO use Redis as a feature cache with explicit TTLs and fallback to PostgreSQL when cache misses occur
- DO ensure the FastAPI model serving endpoint loads models from the MLflow Model Registry by stage (\`Staging\`, \`Production\`) — never by hardcoded run ID
- DO implement graceful model hot-swapping so the serving layer can reload a new model version without downtime
- DO test DVC remote storage (S3) connectivity and verify \`dvc push\` / \`dvc pull\` round-trips in integration tests

### Security Hardening

- DO enforce authentication on all FastAPI endpoints using API keys or JWT tokens — no anonymous access to inference endpoints
- DO validate and sanitize all inference request payloads with Pydantic \`Field\` constraints (min/max values, allowed types, tensor shape validation)
- DO scan Docker images with \`trivy\` or equivalent in CI before pushing to ECR
- DO ensure all secrets (AWS credentials, MLflow tracking URI, database passwords, API keys) are loaded from environment variables or AWS Secrets Manager — never from committed files
- DO implement rate limiting on inference endpoints to prevent abuse and GPU resource exhaustion
- DO add input validation that rejects adversarial or out-of-distribution inputs with appropriate error codes (422 for malformed, 400 for out-of-range)
- DO ensure model artifacts in S3 have server-side encryption enabled (SSE-S3 or SSE-KMS) for SOC 2 compliance
- DO implement audit logging for all model predictions (who requested, what input hash, what model version, what output) for GDPR and SOC 2 traceability
- DO ensure PII in training data is anonymized before feature engineering — validate this with automated checks in the DVC pipeline
- DO add CORS configuration to FastAPI that restricts origins to known frontend/service domains

### Observability & Resilience

- DO instrument the FastAPI serving layer with Prometheus metrics: \`prediction_latency_seconds\`, \`prediction_count_total\`, \`model_version_info\`, \`prediction_errors_total\`
- DO add structured logging (JSON format) with correlation IDs that trace a request from API ingestion through feature lookup, inference, and response
- DO implement circuit breakers for external dependencies (MLflow server, Redis, S3) so that transient failures don't cascade
- DO add retry logic with exponential backoff for MLflow API calls and S3 operations — these are network-dependent and flaky under load
- DO configure Kubernetes liveness and readiness probes that check model loading state — a pod should not receive traffic until the model is loaded into GPU memory
- DO set resource limits on Kubernetes pods for GPU memory, CPU, and RAM to prevent OOM kills during batch inference
- DO implement dead letter queues or error logging for failed batch inference jobs so no prediction request is silently dropped

### Data Integrity

- DO verify DVC file hashes after \`dvc pull\` to ensure data integrity between environments
- DO implement schema validation at each DVC pipeline stage boundary using Pydantic or pandera — fail fast if upstream data format changes
- DO add data drift detection in the evaluation stage that compares incoming feature distributions against the training set baseline
- DO ensure model evaluation metrics are logged to MLflow AND written to a structured JSON report for automated comparison

---

## DON'T — Prohibited Behaviors

### Pipeline Anti-Patterns

- DON'T hardcode file paths for data or model artifacts — always use \`configs/\` YAML files parsed through Pydantic config models
- DON'T skip MLflow logging in any training code path, including hyperparameter tuning trials — every run must be tracked
- DON'T use \`pickle\` directly for model serialization — use \`mlflow.pytorch.save_model()\` or \`torch.save()\` with explicit format versioning
- DON'T put production logic in \`notebooks/\` — notebooks are for exploration only; all integrated code lives in \`src/\`
- DON'T create circular dependencies between DVC pipeline stages — the DAG must be acyclic and reproducible
- DON'T use \`dvc run\` interactively in production — define all stages in \`dvc.yaml\` declaratively
- DON'T import from \`notebooks/\` or \`scripts/\` in \`src/\` modules — dependency flows from \`src/\` outward, never inward

### Security Anti-Patterns

- DON'T commit \`.env\` files, AWS credentials, MLflow tracking URIs with passwords, or any secrets to the repository
- DON'T serve models over HTTP without TLS in staging or production — enforce HTTPS at the load balancer or ingress level
- DON'T log raw inference inputs that may contain PII — log input hashes or anonymized feature vectors only
- DON'T disable Pydantic validation on API endpoints for "performance" — validation is a security boundary
- DON'T use \`eval()\`, \`exec()\`, or \`pickle.loads()\` on untrusted input — this is a remote code execution vector
- DON'T store model artifacts in publicly accessible S3 buckets — enforce bucket policies with least-privilege IAM roles
- DON'T expose MLflow UI or tracking server to the public internet without authentication
- DON'T return raw stack traces or internal error details in API responses — use structured error responses with safe messages

### Code Quality Anti-Patterns

- DON'T write integration modules longer than 300 lines — split into focused adapters (e.g., \`mlflow_adapter.py\`, \`redis_cache.py\`, \`s3_storage.py\`)
- DON'T use \`Any\` type annotations on public functions in integration code — be explicit about tensor shapes, config types, and return types
- DON'T catch bare \`except Exception\` without logging the error and re-raising or handling specifically
- DON'T use global mutable state for model instances — use FastAPI dependency injection or a singleton pattern with proper lifecycle management
- DON'T mix synchronous and asynchronous code in FastAPI endpoints without explicit \`run_in_executor\` calls for blocking operations (PyTorch inference, database queries)
- DON'T skip type checking on integration code — run \`uv run mypy src/\` with strict mode; integration boundaries are where type errors are most dangerous
- DON'T add new dependencies without pinning exact versions in \`pyproject.toml\` and documenting the rationale

### Infrastructure Anti-Patterns

- DON'T deploy model serving containers without resource limits — unbounded GPU memory allocation will crash the node
- DON'T use \`latest\` tags for Docker images in Kubernetes manifests — always use SHA-pinned or semver-tagged images
- DON'T skip integration tests that verify the full DVC pipeline → MLflow → FastAPI serving chain — unit tests alone miss contract violations
- DON'T run GPU training jobs without spot instance interruption handling — implement checkpointing so training resumes from the last saved epoch
- DON'T configure autoscaling without load testing first — measure actual inference latency and throughput under realistic batch sizes

---

## Integration Test Requirements

Before marking Phase 05 complete, the following integration tests must pass:

\`\`\`bash
# Full pipeline reproducibility
dvc repro && echo "Pipeline DAG executes end-to-end"

# MLflow tracking verification
uv run pytest tests/integration/test_mlflow_tracking.py -v

# Model serving integration (load from registry, serve, predict)
uv run pytest tests/integration/test_serving_pipeline.py -v

# Redis cache integration
uv run pytest tests/integration/test_feature_cache.py -v

# Security validation
uv run ruff check src/ --select S  # security-related rules
uv run mypy src/ --strict

# Docker image build and scan
docker build -t ml-pipeline:test -f Dockerfile .
trivy image ml-pipeline:test --severity HIGH,CRITICAL --exit-code 1
\`\`\`

---

## File Ownership Reminders

- Changes to \`configs/production/**\` require lead engineer approval per CODEOWNERS
- Changes to \`models/**\` (DVC-tracked artifacts) require experiment review with metrics comparison
- Changes to \`.env*\` patterns are prohibited in commits — CI will reject them
- Changes to \`data/**\` must go through DVC, not direct git commits
- Changes to \`src/serving/\` require both ML engineer and infrastructure review

---

## Cross-References

- Phase 03 foundation: \`playbook/phases/03-foundation.md\` (project scaffold, CI setup)
- Phase 04 core implementation: \`playbook/phases/04-core-implementation.md\` (model architectures, training loops)
- Security hardening prompt: \`playbook/prompts/05/security-hardening.md\`
- Integration adapter prompt: \`playbook/prompts/05/integration-adapter.md\`
- Observability setup prompt: \`playbook/prompts/05/observability-setup.md\`
- Phase 06 testing: \`playbook/phases/06-testing-quality.md\` (coverage thresholds, load testing)`,

  'playbook/claude-overrides/06-testing-quality.claude.md': `# Phase 06: Testing & Quality — Claude Override Rules

## Phase Context

You are working on testing and quality assurance for the ml-pipeline project — a PyTorch-based ML pipeline with MLflow tracking, DVC data versioning, and FastAPI serving. This phase covers unit tests, integration tests, model validation tests, load tests, and end-to-end pipeline tests.

## DO — Required Behaviors

### Test Structure and Organization

- DO organize tests mirroring \`src/\` layout: \`tests/unit/\`, \`tests/integration/\`, \`tests/model/\`, \`tests/e2e/\`
- DO use \`pytest\` as the sole test runner — invoke with \`uv run pytest\`
- DO use \`pytest-asyncio\` for all async FastAPI endpoint tests
- DO use \`pytest-cov\` and enforce the 75% coverage threshold: \`uv run pytest --cov=src --cov-fail-under=75\`
- DO create \`conftest.py\` fixtures at appropriate directory levels to avoid duplication
- DO use \`@pytest.mark.slow\` for tests that take >10 seconds (GPU training, large data)
- DO use \`@pytest.mark.integration\` for tests requiring external services (PostgreSQL, Redis, MLflow server)
- DO use \`@pytest.mark.gpu\` for tests requiring CUDA — skip gracefully when no GPU is available
- DO add type hints to all test helper functions and fixtures

### Unit Tests for ML Code

- DO test PyTorch \`nn.Module\` classes with deterministic inputs — verify output shapes, dtypes, and device placement
- DO use \`torch.manual_seed()\` in fixtures to ensure reproducible test results
- DO test forward pass, backward pass (gradient flow), and parameter count for every model architecture in \`src/models/\`
- DO test data preprocessing functions in \`src/data/\` with known input/output pairs — never rely on random data alone
- DO test feature engineering transforms are idempotent and handle edge cases (empty DataFrames, NaN values, single-row inputs)
- DO test Pydantic config models in \`configs/\` parse correctly and reject invalid values with clear errors
- DO test utility functions in \`src/utils/\` independently with pure function tests where possible
- DO mock external services (MLflow, S3, Redis) in unit tests — never call real services

### Integration Tests

- DO test the full DVC pipeline stages individually: \`dvc repro <stage>\` with small fixture data
- DO test MLflow experiment logging round-trips: log params/metrics/artifacts, then read them back
- DO test FastAPI endpoints with \`httpx.AsyncClient\` and the actual app instance from \`src/serving/\`
- DO test PostgreSQL interactions with a test database (use \`pytest-postgresql\` or Docker fixture)
- DO test Redis caching and feature store operations with a test Redis instance
- DO test model serialization: save a model checkpoint, load it, verify identical predictions on the same input
- DO test that training configs in \`configs/\` produce valid training runs (smoke test with 1-2 epochs on tiny data)

### Model Validation Tests

- DO write tests that validate model output ranges (e.g., probabilities in [0, 1], logits are finite)
- DO write tests that check model inference does not leak training data (no memorization of PII)
- DO test model performance against a minimum metric threshold on a held-out validation fixture
- DO test that model predictions are deterministic in eval mode (\`model.eval()\` + \`torch.no_grad()\`)
- DO test batch inference consistency: single-sample prediction matches the corresponding element in batch prediction
- DO test model loading from MLflow model registry returns a functional model

### Data Quality Tests

- DO validate data schemas with Pydantic or pandera before and after each pipeline stage
- DO test that data anonymization functions properly remove or mask PII fields (GDPR compliance)
- DO test that DVC-tracked data files have expected checksums after pipeline runs
- DO test data loading handles missing files, corrupt files, and permission errors gracefully

### FastAPI Serving Tests

- DO test all API endpoints: health check, single prediction, batch prediction, model info
- DO test request validation — malformed inputs return 422 with descriptive Pydantic error messages
- DO test response schemas match the documented API contract
- DO test authentication and authorization on protected endpoints
- DO test rate limiting and request size limits
- DO test graceful degradation when the model or Redis cache is unavailable

### Load and Performance Tests

- DO use \`locust\` or \`pytest-benchmark\` for load testing the FastAPI serving layer
- DO define latency SLOs (e.g., p95 < 100ms for single inference) and assert them in tests
- DO test throughput under concurrent requests — verify no memory leaks or GPU OOM errors
- DO test batch inference endpoint scales linearly with batch size up to the configured maximum

### Test Data Management

- DO store small test fixtures in \`tests/fixtures/\` — committed to git (not DVC-tracked)
- DO keep test data under 10MB total in the repository
- DO use factory functions or \`pytest\` fixtures to generate synthetic test data — never copy production data
- DO ensure all test data is fully synthetic with no real user information (GDPR, SOC 2)

### CI Integration

- DO ensure all tests pass in GitHub Actions before merge: lint → type check → unit → integration → smoke train
- DO run \`uv run ruff check src/ tests/\` and \`uv run ruff format --check src/ tests/\` in CI
- DO run \`uv run mypy src/\` with strict mode in CI
- DO generate and upload coverage reports as CI artifacts
- DO cache \`uv\` dependencies and DVC cache in CI for faster runs

## DON'T — Prohibited Behaviors

### Test Anti-Patterns

- DON'T write tests that depend on execution order — every test must be independently runnable
- DON'T use \`time.sleep()\` for synchronization — use proper async awaits, polling, or event-based waits
- DON'T assert on floating-point equality — use \`torch.allclose()\`, \`pytest.approx()\`, or \`np.testing.assert_allclose()\`
- DON'T write tests that pass when the code is broken (tautological assertions like \`assert True\`)
- DON'T catch exceptions in tests just to ignore them — let pytest handle unexpected exceptions
- DON'T use \`print()\` for test diagnostics — use \`pytest\` logging or \`caplog\` fixture

### ML-Specific Anti-Patterns

- DON'T train full models in unit tests — use tiny architectures (2 layers, 8 hidden units) and 1-2 steps
- DON'T download datasets in tests — use pre-built fixtures or synthetic data generators
- DON'T test against live MLflow server or production S3 buckets in unit or integration tests
- DON'T hardcode GPU device indices — use \`torch.device("cuda" if torch.cuda.is_available() else "cpu")\`
- DON'T skip writing tests for data preprocessing because "it's just pandas" — data bugs are the #1 ML failure mode
- DON'T test only the happy path for model inference — test with adversarial inputs, empty tensors, wrong dtypes
- DON'T assert exact metric values from training — models are stochastic; assert ranges or relative improvements
- DON'T leave random seeds unset in tests that involve any stochastic operation

### Data and Security Anti-Patterns

- DON'T use real production data in any test, even anonymized — generate synthetic equivalents
- DON'T commit API keys, AWS credentials, or MLflow tracking URIs in test files — use environment variables or \`.env.test\`
- DON'T store model weights in \`tests/fixtures/\` — generate small models on the fly in fixtures
- DON'T write tests that access \`data/\` (DVC-tracked directory) directly — mock the data loading layer
- DON'T log or print actual prediction values that could contain PII in test output

### Code Quality Anti-Patterns

- DON'T create test files longer than 300 lines — split by feature or component
- DON'T duplicate test setup across files — extract to \`conftest.py\` fixtures
- DON'T use \`unittest.TestCase\` — use plain pytest functions and fixtures
- DON'T mock so aggressively that tests verify mock behavior instead of real logic
- DON'T write integration tests that are actually unit tests with extra setup — be intentional about test boundaries
- DON'T skip type hints on test helper functions and custom fixtures

### CI/CD Anti-Patterns

- DON'T allow tests to pass in CI if coverage drops below 75%
- DON'T merge PRs with failing tests — no "we'll fix it later" exceptions
- DON'T run GPU-dependent tests in CI without the \`@pytest.mark.gpu\` gate and proper skip logic
- DON'T create flaky tests that depend on network calls, timing, or external service availability in unit test suite

## Test File Conventions

\`\`\`
tests/
  conftest.py                    # Shared fixtures: model factories, synthetic data, mock configs
  unit/
    conftest.py                  # Unit-specific fixtures
    test_models.py               # PyTorch model architecture tests
    test_data_processing.py      # Data loading and feature engineering tests
    test_training_loop.py        # Training step logic tests (mocked data)
    test_evaluation_metrics.py   # Metric computation tests
    test_config_validation.py    # Pydantic config parsing tests
    test_utils.py                # Utility function tests
  integration/
    conftest.py                  # Integration fixtures: test DB, Redis, MLflow
    test_dvc_pipeline.py         # DVC stage execution tests
    test_mlflow_tracking.py      # MLflow logging round-trip tests
    test_model_registry.py       # Model save/load/serve cycle tests
    test_feature_store.py        # Redis feature store tests
  model/
    test_model_validation.py     # Output range, determinism, batch consistency
    test_model_fairness.py       # Bias detection, subgroup performance
    test_data_quality.py         # Schema validation, anonymization checks
  e2e/
    test_api_endpoints.py        # FastAPI endpoint tests
    test_inference_pipeline.py   # End-to-end prediction flow
    test_training_pipeline.py    # Full pipeline smoke test (tiny data)
  fixtures/
    sample_config.yaml           # Valid experiment config for testing
    sample_features.parquet      # Small synthetic feature dataset
    sample_raw_data.csv          # Small synthetic raw data
\`\`\`

## Example Fixture Pattern

When creating test fixtures, follow this pattern:

\`\`\`python
# tests/conftest.py
@pytest.fixture
def seed_everything() -> None:
    """Set deterministic seeds for reproducible tests."""
    torch.manual_seed(42)
    random.seed(42)
    np.random.seed(42)

@pytest.fixture
def tiny_model(seed_everything: None) -> nn.Module:
    """Create a minimal model for fast unit tests."""
    # 2 layers, 8 hidden — trains in milliseconds
    ...

@pytest.fixture
def synthetic_batch(seed_everything: None) -> dict[str, torch.Tensor]:
    """Generate a synthetic data batch matching production schema."""
    ...

@pytest.fixture
def experiment_config(tmp_path: Path) -> ExperimentConfig:
    """Load and validate a test experiment config via Pydantic."""
    ...
\`\`\`

## Quality Gates

Before marking Phase 06 complete, verify:

1. \`uv run ruff check src/ tests/\` passes with zero violations
2. \`uv run ruff format --check src/ tests/\` passes
3. \`uv run mypy src/\` passes in strict mode
4. \`uv run pytest --cov=src --cov-fail-under=75\` passes
5. All \`@pytest.mark.integration\` tests pass against test infrastructure
6. Model validation tests confirm output correctness and determinism
7. FastAPI endpoint tests cover all routes with valid and invalid inputs
8. No test file exceeds 300 lines
9. No real data, credentials, or PII appears anywhere in \`tests/\`
10. CI pipeline runs all stages: lint → type check → unit → integration → smoke train`,

  'playbook/claude-overrides/07-launch.claude.md': `# Phase 07: Launch & Operations — Claude Override Rules

## Phase Context

You are assisting with launching and operating an ML pipeline system built with PyTorch, MLflow, FastAPI, DVC, deployed on AWS (ECS/SageMaker). This phase covers production deployment, monitoring, incident response, model operations (MLOps), and ongoing reliability.

## DO — Required Practices

### Production Deployment

- DO use blue-green or canary deployments for the FastAPI serving layer on ECS
- DO verify model artifact integrity (SHA-256 checksums) before promoting to production
- DO use MLflow Model Registry stage transitions: \`Staging\` → \`Production\` with approval gates
- DO ensure DVC-tracked model artifacts in S3 match the exact version referenced in deployment configs
- DO create rollback procedures that reference specific MLflow run IDs and model versions
- DO validate that GPU instances (EC2/SageMaker) have correct CUDA drivers and PyTorch compatibility
- DO use Terraform to manage all AWS infrastructure changes — no manual console modifications
- DO pin Docker base images with SHA digests in production Dockerfiles
- DO verify that \`configs/production/**\` values are reviewed by at least two engineers before deploy

### Monitoring & Observability

- DO set up Prometheus metrics for model inference latency (p50, p95, p99), throughput, and error rates
- DO configure Grafana dashboards with panels for: API health, model prediction distribution, feature drift, GPU utilization
- DO implement model performance monitoring — track prediction distribution shifts against training baselines
- DO set up MLflow UI access for the team to inspect production model lineage and experiment history
- DO monitor Redis cache hit rates for the feature store and set alerts on cache miss spikes
- DO configure alerts for: inference latency > 200ms p99, error rate > 1%, model staleness > configured threshold
- DO log all prediction requests with anonymized inputs for GDPR compliance and debugging
- DO monitor PostgreSQL connection pool usage and query latency for the MLflow backend store
- DO track DVC remote (S3) access patterns and set billing alerts

### Runbooks & Incident Response

- DO write runbooks as executable Markdown in \`docs/runbooks/\` with copy-pasteable commands
- DO include \`uv run python scripts/healthcheck.py\` as the first diagnostic step in all runbooks
- DO document model rollback procedure: \`mlflow models transition-stage --model-name <name> --version <N> --stage Production\`
- DO include GPU-specific troubleshooting: CUDA OOM, driver mismatch, instance availability
- DO document data pipeline recovery: \`dvc repro\` from specific stages, S3 data restoration
- DO define severity levels: P1 (model serving down), P2 (degraded predictions/drift), P3 (training pipeline failure), P4 (monitoring gap)
- DO include FastAPI health endpoint verification: \`curl -f https://<host>/health\` and \`/health/model\`
- DO document Redis failover procedures and feature store cache warming steps

### MLOps & Model Lifecycle

- DO automate model retraining triggers based on data drift detection or scheduled cadence
- DO ensure every production model has a corresponding MLflow experiment with full hyperparameters, metrics, and artifact links
- DO validate model performance on a holdout set before any production promotion
- DO implement A/B testing infrastructure with traffic splitting at the FastAPI layer
- DO track model lineage: training data version (DVC), code commit, config hash, MLflow run ID
- DO set up automated model evaluation pipelines that run on new data batches
- DO archive deprecated models with retention metadata for SOC 2 audit trails

### Security & Compliance

- DO enforce SOC 2 access controls: IAM roles for S3 model/data buckets, MLflow authentication
- DO ensure GDPR compliance: prediction logs anonymized, PII excluded from training data, data deletion pipeline functional
- DO rotate API keys and service credentials on a defined schedule
- DO audit all access to \`configs/production/**\`, \`models/**\`, and \`data/**\` paths
- DO verify that Docker images in ECR are scanned for vulnerabilities before deployment
- DO ensure model artifacts are encrypted at rest in S3 (SSE-S3 or SSE-KMS)
- DO maintain an audit log of all model promotions, rollbacks, and data pipeline executions

### Go-Live Checklist Validation

- DO verify all CI/CD stages pass: \`ruff check\`, \`mypy src/\`, \`uv run pytest\`, Docker build, smoke training
- DO confirm staging environment mirrors production: same Docker image, same model version, same config
- DO run a smoke inference test against the production endpoint with known inputs and expected outputs
- DO verify that \`dvc status\` shows no uncommitted data changes
- DO confirm backup and disaster recovery procedures are tested and documented

## DON'T — Prohibited Practices

### Deployment Anti-Patterns

- DON'T deploy models by manually copying files to S3 — always use MLflow Model Registry transitions
- DON'T skip the staging environment — every model version must be validated in staging before production
- DON'T modify production configs directly on the server — all changes through Git and Terraform
- DON'T deploy without verifying the model artifact checksum matches the MLflow-registered artifact
- DON'T use \`latest\` tags for Docker images in production — always use specific SHA digests or version tags
- DON'T run \`dvc repro\` in production — DVC pipelines execute in CI/CD or dedicated training environments only
- DON'T hardcode AWS credentials, API keys, or database passwords — use AWS Secrets Manager or environment injection
- DON'T deploy on Friday afternoons or outside agreed maintenance windows without P1 justification

### Monitoring Anti-Patterns

- DON'T rely solely on HTTP status codes — monitor model-specific metrics (prediction confidence, feature distributions)
- DON'T set alert thresholds without baseline data — establish baselines from staging load tests first
- DON'T ignore model drift alerts — degraded predictions are a P2 incident requiring investigation
- DON'T log raw user data in prediction logs — anonymize or hash PII fields per GDPR requirements
- DON'T create dashboards without documenting what each panel means and what action to take on anomalies
- DON'T monitor only the serving layer — include training pipeline health, data pipeline freshness, and MLflow backend health

### Operational Anti-Patterns

- DON'T write runbooks with vague instructions like "check the logs" — specify exact commands, log locations, and expected outputs
- DON'T skip post-incident reviews — every P1/P2 incident gets a blameless retrospective documented in \`docs/incidents/\`
- DON'T allow model versions in production without full MLflow lineage (run ID, data version, config, metrics)
- DON'T treat notebooks as operational tools — all production operations use scripts in \`scripts/\` or CLI commands
- DON'T assume GPU instances are always available — implement graceful fallback to CPU inference with degraded SLA
- DON'T delete old model versions without checking retention requirements (SOC 2 audit trail)
- DON'T bypass code review for "quick fixes" to production — all changes go through PR with at least 1 approval on \`main\`

### Data & Model Anti-Patterns

- DON'T serve a model that hasn't been evaluated on the current holdout/validation set
- DON'T retrain models on data that hasn't been validated for schema consistency and quality
- DON'T mix experiment tracking between local MLflow and production MLflow — use a single tracking server
- DON'T store model artifacts outside of DVC/MLflow-managed storage — no ad-hoc S3 uploads
- DON'T skip A/B test analysis — collect sufficient data before declaring a winner and fully rolling out

## File Sensitivity Reminders

- \`configs/production/**\` — Requires two-engineer review; contains model serving parameters and infrastructure config
- \`models/**\` — DVC-tracked; never commit raw model files to Git; verify checksums on deployment
- \`.env*\` — Never commit; use AWS Secrets Manager for production secrets
- \`data/**\` — DVC-tracked; contains potentially sensitive training data; GDPR anonymization required
- \`scripts/deploy_*.py\` — Production deployment scripts; treat as critical path; full test coverage required

## Command Reference for This Phase

\`\`\`bash
# Pre-deployment validation
uv run ruff check src/
uv run mypy src/ --strict
uv run pytest tests/ -v --cov=src --cov-fail-under=75
dvc status                              # Verify no uncommitted data changes

# Model promotion
mlflow models transition-stage \\
  --model-name "ml-pipeline-model" \\
  --version <N> \\
  --stage Production

# Docker build and push
docker build -t ml-pipeline:$(git rev-parse --short HEAD) .
aws ecr get-login-password | docker login --username AWS --password-stdin <account>.dkr.ecr.<region>.amazonaws.com
docker push <account>.dkr.ecr.<region>.amazonaws.com/ml-pipeline:$(git rev-parse --short HEAD)

# Infrastructure deployment
cd terraform/ && terraform plan -var-file=production.tfvars
cd terraform/ && terraform apply -var-file=production.tfvars

# Smoke test production endpoint
curl -f https://<production-host>/health
curl -X POST https://<production-host>/predict -H "Content-Type: application/json" -d @tests/fixtures/sample_request.json

# Monitoring verification
uv run python scripts/healthcheck.py --env production
uv run python scripts/validate_model_serving.py --endpoint https://<production-host>

# Rollback (if needed)
mlflow models transition-stage \\
  --model-name "ml-pipeline-model" \\
  --version <previous-N> \\
  --stage Production
\`\`\`

## Cross-References

- See \`playbook/phases/07-launch.md\` for the full phase methodology
- See \`playbook/prompts/07/go-live-checklist.md\` for the go-live checklist prompt
- See \`playbook/prompts/07/runbook-generator.md\` for generating operational runbooks
- See \`playbook/prompts/07/monitoring-setup.md\` for Prometheus/Grafana configuration
- See \`playbook/claude-overrides/05-integration-hardening.claude.md\` for security hardening rules that carry into production
- See \`docs/runbooks/\` for operational runbooks (generated during this phase)`,

  'playbook/codeforge-phase.sh': `#!/usr/bin/env bash
#
# codeforge-phase.sh — Phase management for ml-pipeline development methodology
#
# Manages development phases: plan → design → implement → test → review → deploy
# Updates the .claude/rules.md symlink to point to the active phase rules.
#
# Usage:
#   ./playbook/codeforge-phase.sh current        Show current active phase
#   ./playbook/codeforge-phase.sh list            List all available phases
#   ./playbook/codeforge-phase.sh set <phase>     Switch to a specific phase
#   ./playbook/codeforge-phase.sh next            Advance to the next phase
#   ./playbook/codeforge-phase.sh prev            Revert to the previous phase
#   ./playbook/codeforge-phase.sh check           Validate current phase gate criteria
#   ./playbook/codeforge-phase.sh status          Show phase status with gate checks
#   ./playbook/codeforge-phase.sh reset           Reset to the first phase (plan)
#
# Environment:
#   CODEFORGE_PROJECT_ROOT   Override project root detection (default: git root)
#   CODEFORGE_VERBOSE        Set to 1 for verbose output
#   CODEFORGE_NO_COLOR       Set to 1 to disable colored output

set -euo pipefail

# --- Constants ---

readonly VERSION="1.0.0"
readonly SCRIPT_NAME="$(basename "$0")"
readonly PHASE_STATE_FILE=".claude/.phase"
readonly RULES_SYMLINK=".claude/rules.md"
readonly PLAYBOOK_DIR="playbook"

# Ordered phases — the canonical development lifecycle
readonly PHASES=(
  "plan"
  "design"
  "implement"
  "test"
  "review"
  "deploy"
)

# Phase descriptions
declare -A PHASE_DESCRIPTIONS=(
  [plan]="Requirements gathering, experiment design, data analysis planning"
  [design]="Architecture decisions, model selection, pipeline DAG design"
  [implement]="Code implementation, model training, feature engineering"
  [test]="Unit tests, integration tests, model evaluation, smoke tests"
  [review]="Code review, experiment review, security audit, GDPR check"
  [deploy]="Staging deployment, production deployment, monitoring setup"
)

# --- Color Support ---

if [[ "\${CODEFORGE_NO_COLOR:-0}" == "1" ]] || [[ ! -t 1 ]]; then
  RED=""
  GREEN=""
  YELLOW=""
  BLUE=""
  CYAN=""
  MAGENTA=""
  BOLD=""
  DIM=""
  RESET=""
else
  RED="\\033[0;31m"
  GREEN="\\033[0;32m"
  YELLOW="\\033[0;33m"
  BLUE="\\033[0;34m"
  CYAN="\\033[0;36m"
  MAGENTA="\\033[0;35m"
  BOLD="\\033[1m"
  DIM="\\033[2m"
  RESET="\\033[0m"
fi

# --- Logging ---

log_info() {
  echo -e "\${BLUE}ℹ\${RESET} $*"
}

log_success() {
  echo -e "\${GREEN}✓\${RESET} $*"
}

log_warn() {
  echo -e "\${YELLOW}⚠\${RESET} $*" >&2
}

log_error() {
  echo -e "\${RED}✗\${RESET} $*" >&2
}

log_verbose() {
  if [[ "\${CODEFORGE_VERBOSE:-0}" == "1" ]]; then
    echo -e "\${DIM}  $*\${RESET}"
  fi
}

# --- Project Root Detection ---

find_project_root() {
  if [[ -n "\${CODEFORGE_PROJECT_ROOT:-}" ]]; then
    echo "$CODEFORGE_PROJECT_ROOT"
    return
  fi

  local dir
  dir="$(pwd)"
  while [[ "$dir" != "/" ]]; do
    if [[ -d "$dir/.git" ]] && [[ -d "$dir/.claude" ]]; then
      echo "$dir"
      return
    fi
    dir="$(dirname "$dir")"
  done

  # Fallback: just git root
  dir="$(pwd)"
  while [[ "$dir" != "/" ]]; do
    if [[ -d "$dir/.git" ]]; then
      echo "$dir"
      return
    fi
    dir="$(dirname "$dir")"
  done

  log_error "Could not find project root (no .git directory found)"
  exit 1
}

# --- Phase Utilities ---

get_phase_index() {
  local target="$1"
  for i in "\${!PHASES[@]}"; do
    if [[ "\${PHASES[$i]}" == "$target" ]]; then
      echo "$i"
      return
    fi
  done
  echo "-1"
}

is_valid_phase() {
  local phase="$1"
  for p in "\${PHASES[@]}"; do
    if [[ "$p" == "$phase" ]]; then
      return 0
    fi
  done
  return 1
}

get_current_phase() {
  local root="$1"
  local state_file="$root/$PHASE_STATE_FILE"

  if [[ -f "$state_file" ]]; then
    local phase
    phase="$(cat "$state_file" | tr -d '[:space:]')"
    if is_valid_phase "$phase"; then
      echo "$phase"
      return
    fi
    log_warn "Invalid phase '$phase' in state file, defaulting to 'plan'"
  fi

  echo "plan"
}

save_phase() {
  local root="$1"
  local phase="$2"
  local state_file="$root/$PHASE_STATE_FILE"

  mkdir -p "$(dirname "$state_file")"
  echo "$phase" > "$state_file"
  log_verbose "Saved phase '$phase' to $PHASE_STATE_FILE"
}

# --- Symlink Management ---

update_rules_symlink() {
  local root="$1"
  local phase="$2"
  local symlink_path="$root/$RULES_SYMLINK"
  local phase_rules_file="$root/$PLAYBOOK_DIR/phases/\${phase}.md"

  # Remove existing symlink or file
  if [[ -L "$symlink_path" ]] || [[ -f "$symlink_path" ]]; then
    rm -f "$symlink_path"
    log_verbose "Removed existing rules symlink"
  fi

  # Check if phase rules file exists
  if [[ -f "$phase_rules_file" ]]; then
    # Create relative symlink from .claude/rules.md -> ../playbook/phases/<phase>.md
    local relative_target="../$PLAYBOOK_DIR/phases/\${phase}.md"
    ln -s "$relative_target" "$symlink_path"
    log_verbose "Symlinked $RULES_SYMLINK -> $relative_target"
  else
    # Create a minimal rules file if phase file doesn't exist yet
    log_warn "Phase rules file not found: $PLAYBOOK_DIR/phases/\${phase}.md"
    log_info "Creating placeholder rules for phase '\${phase}'"
    create_placeholder_rules "$root" "$phase"
  fi
}

create_placeholder_rules() {
  local root="$1"
  local phase="$2"
  local phase_dir="$root/$PLAYBOOK_DIR/phases"
  local phase_file="$phase_dir/\${phase}.md"

  mkdir -p "$phase_dir"

  cat > "$phase_file" << RULES
# Phase: \${phase^}

> Active development phase for ml-pipeline

## Phase Description

\${PHASE_DESCRIPTIONS[$phase]:-No description available.}

## Rules for This Phase

### General
- Follow conventional commits: feat:, fix:, chore:, docs:, experiment:
- Type hints required on all public functions
- Max file length: 300 lines
- snake_case for files/functions, PascalCase for classes, SCREAMING_SNAKE_CASE for constants

### ML-Specific
- All experiments must be tracked in MLflow with reproducible configs
- Use DVC for data and model artifact versioning
- Notebooks are for exploration only — production code goes in src/
- Validate all configs with Pydantic models
- Pin all dependency versions in pyproject.toml

### Compliance
- GDPR: Ensure data anonymization, consent tracking, right to deletion
- SOC 2: Verify model artifact integrity, audit trail for deployments

### Phase-Specific Guidelines
$(generate_phase_guidelines "$phase")
RULES

  # Now create the symlink
  local relative_target="../$PLAYBOOK_DIR/phases/\${phase}.md"
  ln -s "$relative_target" "$root/$RULES_SYMLINK"
  log_verbose "Created placeholder and symlinked $RULES_SYMLINK -> $relative_target"
}

generate_phase_guidelines() {
  local phase="$1"
  case "$phase" in
    plan)
      cat << 'EOF'
- Define experiment hypothesis and success metrics before writing code
- Document data requirements and expected schema in configs/
- Create GitHub Issues for all planned work items
- Review existing MLflow experiments for related prior work
- Identify GDPR implications for any new data sources
EOF
      ;;
    design)
      cat << 'EOF'
- Document model architecture decisions in docs/ARCHITECTURE.md
- Define DVC pipeline DAG stages in dvc.yaml before implementation
- Create Pydantic config schemas for new experiment parameters
- Design API contracts for any new FastAPI endpoints
- Review GPU/compute requirements and update Terraform if needed
EOF
      ;;
    implement)
      cat << 'EOF'
- Write code in src/ following the pipeline architecture (data → models → training → evaluation → serving)
- Run \`uv run ruff check src/\` and \`uv run ruff format --check src/\` before committing
- Run \`uv run mypy src/\` to verify type correctness
- Log all training runs to MLflow: parameters, metrics, artifacts
- Track data changes with \`dvc add\` and commit .dvc files
- Keep functions focused — max 300 lines per file
EOF
      ;;
    test)
      cat << 'EOF'
- Run full test suite: \`uv run pytest tests/ --cov=src --cov-report=term-missing\`
- Ensure coverage >= 75% on all modules
- Run integration tests: \`uv run pytest tests/integration/ -m integration\`
- Execute training smoke test: \`dvc repro\` with small dataset
- Validate model metrics against baseline in MLflow
- Test FastAPI endpoints: \`uv run pytest tests/test_serving/\`
EOF
      ;;
    review)
      cat << 'EOF'
- All PRs require at least 1 approval from CODEOWNERS
- AI-generated code must be flagged with \`# AI-GENERATED\` comment
- Review experiment results in MLflow UI before merging model changes
- Check for sensitive data exposure in configs/production/**
- Verify GDPR compliance: no PII in logs, proper anonymization
- Validate model artifact integrity (checksums in DVC)
- Review Dockerfile and Terraform changes for security implications
EOF
      ;;
    deploy)
      cat << 'EOF'
- Deploy to staging first: verify with \`scripts/deploy_staging.sh\`
- Run smoke tests against staging endpoint
- Register model version in MLflow Model Registry
- Tag release with semantic version
- Update monitoring dashboards in Grafana
- Verify Prometheus metrics are collecting from new endpoints
- Document deployment in docs/ and notify team via Slack
- Production deploy requires manual approval in GitHub Actions
EOF
      ;;
    *)
      echo "- No specific guidelines defined for this phase"
      ;;
  esac
}

# --- Gate Checks ---

check_phase_gate() {
  local root="$1"
  local phase="$2"
  local passed=0
  local failed=0
  local warnings=0

  echo -e "\\n\${BOLD}Phase Gate Check: \${CYAN}\${phase^}\${RESET}"
  echo -e "\${DIM}─────────────────────────────────────\${RESET}\\n"

  case "$phase" in
    plan)
      check_gate_item "GitHub Issues exist for planned work" \\
        "test -d '$root/.github'" passed failed warnings
      check_gate_item "Experiment config template exists" \\
        "find '$root/configs' -name '*.yaml' -o -name '*.yml' 2>/dev/null | head -1 | grep -q ." passed failed warnings
      check_gate_item "Data requirements documented" \\
        "test -f '$root/docs/ARCHITECTURE.md'" passed failed warnings
      ;;
    design)
      check_gate_item "Architecture doc exists" \\
        "test -f '$root/docs/ARCHITECTURE.md'" passed failed warnings
      check_gate_item "DVC pipeline defined" \\
        "test -f '$root/dvc.yaml'" passed failed warnings
      check_gate_item "Pydantic config schemas exist" \\
        "find '$root/src' -name '*.py' -exec grep -l 'BaseModel\\|BaseSettings' {} + 2>/dev/null | head -1 | grep -q ." passed failed warnings
      ;;
    implement)
      check_gate_item "Source code exists in src/" \\
        "find '$root/src' -name '*.py' ! -name '__init__.py' 2>/dev/null | head -1 | grep -q ." passed failed warnings
      check_gate_item "Ruff linting passes" \\
        "cd '$root' && uv run ruff check src/ 2>/dev/null" passed failed warnings
      check_gate_item "Type checking passes" \\
        "cd '$root' && uv run mypy src/ 2>/dev/null" passed failed warnings
      check_gate_item "No files exceed 300 lines" \\
        "! find '$root/src' -name '*.py' -exec awk 'END{if(NR>300) exit 1}' {} \\; -print 2>/dev/null | grep -q ." passed failed warnings
      ;;
    test)
      check_gate_item "Tests exist" \\
        "find '$root/tests' -name 'test_*.py' 2>/dev/null | head -1 | grep -q ." passed failed warnings
      check_gate_item "Test suite passes" \\
        "cd '$root' && uv run pytest tests/ -q --tb=no 2>/dev/null" passed failed warnings
      check_gate_item "Coverage meets threshold (75%)" \\
        "cd '$root' && uv run pytest tests/ --cov=src --cov-fail-under=75 -q --tb=no 2>/dev/null" passed failed warnings
      check_gate_item "DVC pipeline reproduces" \\
        "test -f '$root/dvc.lock'" passed failed warnings
      ;;
    review)
      check_gate_item "No uncommitted changes" \\
        "cd '$root' && test -z \\"\\$(git status --porcelain 2>/dev/null)\\"" passed failed warnings
      check_gate_item "AI-generated code is flagged" \\
        "! find '$root/src' -name '*.py' -newer '$root/.claude/.phase' -exec grep -L 'AI-GENERATED\\|human-written' {} + 2>/dev/null | grep -q ." passed failed warnings
      check_gate_item "No secrets in tracked files" \\
        "! git -C '$root' grep -rI 'aws_secret\\|password\\s*=\\s*[\\"'\\'']' -- src/ configs/ 2>/dev/null | grep -q ." passed failed warnings
      check_gate_item "CODEOWNERS file exists" \\
        "test -f '$root/.github/CODEOWNERS'" passed failed warnings
      ;;
    deploy)
      check_gate_item "Docker image builds" \\
        "test -f '$root/Dockerfile'" passed failed warnings
      check_gate_item "Production config exists" \\
        "test -d '$root/configs/production' || test -f '$root/configs/production.yaml'" passed failed warnings
      check_gate_item "MLflow model registered" \\
        "test -d '$root/models' || find '$root' -name 'MLmodel' 2>/dev/null | head -1 | grep -q ." passed failed warnings
      check_gate_item "Deployment docs exist" \\
        "test -f '$root/docs/ARCHITECTURE.md'" passed failed warnings
      ;;
  esac

  echo ""
  echo -e "\${DIM}─────────────────────────────────────\${RESET}"
  echo -e "  \${GREEN}Passed: $passed\${RESET}  \${RED}Failed: $failed\${RESET}  \${YELLOW}Warnings: $warnings\${RESET}"

  if [[ $failed -gt 0 ]]; then
    echo -e "\\n\${YELLOW}⚠ Some gate checks failed. Address them before advancing.\${RESET}"
    return 1
  else
    echo -e "\\n\${GREEN}✓ All gate checks passed.\${RESET}"
    return 0
  fi
}

check_gate_item() {
  local description="$1"
  local check_cmd="$2"
  local -n _passed=$3
  local -n _failed=$4
  local -n _warnings=$5

  if eval "$check_cmd" > /dev/null 2>&1; then
    echo -e "  \${GREEN}✓\${RESET} $description"
    ((_passed++)) || true
  else
    echo -e "  \${RED}✗\${RESET} $description"
    ((_failed++)) || true
  fi
}

# --- Commands ---

cmd_current() {
  local root
  root="$(find_project_root)"
  local phase
  phase="$(get_current_phase "$root")"
  local index
  index="$(get_phase_index "$phase")"
  local total="\${#PHASES[@]}"

  echo -e "\${BOLD}Current Phase:\${RESET} \${CYAN}\${phase^}\${RESET} \${DIM}($(( index + 1 ))/\${total})\${RESET}"
  echo -e "\${DIM}\${PHASE_DESCRIPTIONS[$phase]:-}\${RESET}"

  # Show symlink status
  local symlink_path="$root/$RULES_SYMLINK"
  if [[ -L "$symlink_path" ]]; then
    local target
    target="$(readlink "$symlink_path")"
    echo -e "\\n\${DIM}Rules: $RULES_SYMLINK -> $target\${RESET}"
  elif [[ -f "$symlink_path" ]]; then
    echo -e "\\n\${YELLOW}Rules: $RULES_SYMLINK (regular file, not symlink)\${RESET}"
  else
    echo -e "\\n\${RED}Rules: $RULES_SYMLINK not found\${RESET}"
  fi
}

cmd_list() {
  local root
  root="$(find_project_root)"
  local current
  current="$(get_current_phase "$root")"

  echo -e "\${BOLD}Development Phases:\${RESET}\\n"

  for i in "\${!PHASES[@]}"; do
    local phase="\${PHASES[$i]}"
    local num="$(( i + 1 ))"
    local marker=" "
    local color=""

    if [[ "$phase" == "$current" ]]; then
      marker="▶"
      color="$CYAN"
    elif [[ "$(get_phase_index "$phase")" -lt "$(get_phase_index "$current")" ]]; then
      marker="✓"
      color="$GREEN"
    else
      color="$DIM"
    fi

    echo -e "  \${color}\${marker} \${num}. \${phase^}\${RESET}"
    echo -e "    \${DIM}\${PHASE_DESCRIPTIONS[$phase]:-}\${RESET}"
  done
}

cmd_set() {
  local target_phase="$1"
  target_phase="$(echo "$target_phase" | tr '[:upper:]' '[:lower:]')"

  if ! is_valid_phase "$target_phase"; then
    log_error "Invalid phase: '$target_phase'"
    echo -e "\\nValid phases: \${PHASES[*]}"
    exit 1
  fi

  local root
  root="$(find_project_root)"
  local current
  current="$(get_current_phase "$root")"

  if [[ "$current" == "$target_phase" ]]; then
    log_info "Already in phase '\${target_phase^}'"
    return 0
  fi

  local current_idx
  current_idx="$(get_phase_index "$current")"
  local target_idx
  target_idx="$(get_phase_index "$target_phase")"

  if [[ "$target_idx" -lt "$current_idx" ]]; then
    log_warn "Reverting from '\${current^}' to '\${target_phase^}'"
  fi

  save_phase "$root" "$target_phase"
  update_rules_symlink "$root" "$target_phase"

  local direction="→"
  [[ "$target_idx" -lt "$current_idx" ]] && direction="←"

  log_success "Phase: \${MAGENTA}\${current^}\${RESET} \${direction} \${CYAN}\${target_phase^}\${RESET}"
  echo -e "  \${DIM}\${PHASE_DESCRIPTIONS[$target_phase]:-}\${RESET}"
}

cmd_next() {
  local root
  root="$(find_project_root)"
  local current
  current="$(get_current_phase "$root")"
  local current_idx
  current_idx="$(get_phase_index "$current")"
  local next_idx=$(( current_idx + 1 ))

  if [[ $next_idx -ge \${#PHASES[@]} ]]; then
    log_warn "Already at the final phase '\${current^}'"
    log_info "Use '\${SCRIPT_NAME} reset' to start a new cycle"
    return 1
  fi

  # Run gate check before advancing
  echo -e "\${BOLD}Running gate checks for '\${current^}' before advancing...\${RESET}"
  if ! check_phase_gate "$root" "$current"; then
    echo ""
    log_warn "Gate checks failed. Use '\${SCRIPT_NAME} set \${PHASES[$next_idx]}' to force advance."
    return 1
  fi

  local next_phase="\${PHASES[$next_idx]}"
  cmd_set "$next_phase"
}

cmd_prev() {
  local root
  root="$(find_project_root)"
  local current
  current="$(get_current_phase "$root")"
  local current_idx
  current_idx="$(get_phase_index "$current")"
  local prev_idx=$(( current_idx - 1 ))

  if [[ $prev_idx -lt 0 ]]; then
    log_warn "Already at the first phase '\${current^}'"
    return 1
  fi

  local prev_phase="\${PHASES[$prev_idx]}"
  cmd_set "$prev_phase"
}

cmd_check() {
  local root
  root="$(find_project_root)"
  local current
  current="$(get_current_phase "$root")"

  check_phase_gate "$root" "$current"
}

cmd_status() {
  local root
  root="$(find_project_root)"
  local current
  current="$(get_current_phase "$root")"

  echo -e "\${BOLD}ml-pipeline Phase Status\${RESET}"
  echo -e "\${DIM}═══════════════════════════════════════\${RESET}\\n"

  # Show phase progression
  local progress=""
  for i in "\${!PHASES[@]}"; do
    local phase="\${PHASES[$i]}"
    if [[ "$phase" == "$current" ]]; then
      progress+="\${CYAN}●\${RESET}"
    elif [[ "$(get_phase_index "$phase")" -lt "$(get_phase_index "$current")" ]]; then
      progress+="\${GREEN}●\${RESET}"
    else
      progress+="\${DIM}○\${RESET}"
    fi
    if [[ $i -lt $(( \${#PHASES[@]} - 1 )) ]]; then
      progress+="\${DIM}──\${RESET}"
    fi
  done
  echo -e "  $progress"
  echo -e "  \${DIM}$(printf '%-8s' "\${PHASES[@]}")\${RESET}\\n"

  # Current phase info
  echo -e "\${BOLD}Active:\${RESET} \${CYAN}\${current^}\${RESET}"
  echo -e "\${DIM}\${PHASE_DESCRIPTIONS[$current]:-}\${RESET}\\n"

  # Git info
  local branch
  branch="$(cd "$root" && git branch --show-current 2>/dev/null || echo 'unknown')"
  local dirty=""
  if [[ -n "$(cd "$root" && git status --porcelain 2>/dev/null)" ]]; then
    dirty=" \${YELLOW}(dirty)\${RESET}"
  fi
  echo -e "\${BOLD}Branch:\${RESET} $branch$dirty"

  # MLflow info
  if command -v mlflow &> /dev/null; then
    echo -e "\${BOLD}MLflow:\${RESET} \${GREEN}available\${RESET} \${DIM}(mlflow ui to view)\${RESET}"
  else
    echo -e "\${BOLD}MLflow:\${RESET} \${RED}not installed\${RESET}"
  fi

  # DVC info
  if [[ -f "$root/dvc.yaml" ]]; then
    local dvc_stages
    dvc_stages="$(grep -c '^\\s\\+[a-zA-Z]' "$root/dvc.yaml" 2>/dev/null || echo '0')"
    echo -e "\${BOLD}DVC:\${RESET} \${GREEN}configured\${RESET} \${DIM}(~\${dvc_stages} stages)\${RESET}"
  else
    echo -e "\${BOLD}DVC:\${RESET} \${YELLOW}no dvc.yaml\${RESET}"
  fi

  echo ""

  # Run gate checks
  check_phase_gate "$root" "$current"
}

cmd_reset() {
  local root
  root="$(find_project_root)"
  local current
  current="$(get_current_phase "$root")"

  if [[ "$current" == "plan" ]]; then
    log_info "Already at the first phase 'Plan'"
    return 0
  fi

  log_warn "Resetting from '\${current^}' to 'Plan'"
  cmd_set "plan"
}

cmd_help() {
  cat << EOF
\${BOLD}codeforge-phase\${RESET} v\${VERSION} — ML Pipeline Phase Manager

\${BOLD}USAGE\${RESET}
  \${SCRIPT_NAME} <command> [args]

\${BOLD}COMMANDS\${RESET}
  current           Show the current active phase
  list              List all available phases
  set <phase>       Switch to a specific phase
  next              Advance to the next phase (runs gate checks)
  prev              Revert to the previous phase
  check             Validate current phase gate criteria
  status            Show full phase status with gate checks
  reset             Reset to the first phase (plan)
  help              Show this help message

\${BOLD}PHASES\${RESET}
  plan              Requirements, experiment design, data planning
  design            Architecture, model selection, pipeline DAG
  implement         Code, training, feature engineering
  test              Unit tests, integration tests, model evaluation
  review            Code review, experiment review, compliance
  deploy            Staging, production, monitoring

\${BOLD}ENVIRONMENT\${RESET}
  CODEFORGE_PROJECT_ROOT   Override project root detection
  CODEFORGE_VERBOSE        Set to 1 for verbose output
  CODEFORGE_NO_COLOR       Set to 1 to disable colors

\${BOLD}EXAMPLES\${RESET}
  \${SCRIPT_NAME} current                  # Show current phase
  \${SCRIPT_NAME} set implement            # Switch to implement phase
  \${SCRIPT_NAME} next                     # Advance (with gate checks)
  \${SCRIPT_NAME} check                    # Run gate checks only
  CODEFORGE_VERBOSE=1 \${SCRIPT_NAME} set test  # Verbose phase switch

\${BOLD}ML PIPELINE INTEGRATION\${RESET}
  Phase rules are symlinked to .claude/rules.md so Claude Code
  automatically follows phase-appropriate guidelines for:
  - Experiment tracking (MLflow)
  - Data versioning (DVC)
  - Model training (PyTorch)
  - API serving (FastAPI)
  - Compliance (SOC 2, GDPR)
EOF
}

# --- Main ---

main() {
  local command="\${1:-help}"
  shift || true

  case "$command" in
    current|cur|c)
      cmd_current
      ;;
    list|ls|l)
      cmd_list
      ;;
    set|s)
      if [[ $# -lt 1 ]]; then
        log_error "Missing phase argument"
        echo "Usage: \${SCRIPT_NAME} set <phase>"
        echo "Phases: \${PHASES[*]}"
        exit 1
      fi
      cmd_set "$1"
      ;;
    next|n|advance)
      cmd_next
      ;;
    prev|p|back|revert)
      cmd_prev
      ;;
    check|gate|validate)
      cmd_check
      ;;
    status|st)
      cmd_status
      ;;
    reset)
      cmd_reset
      ;;
    help|--help|-h)
      cmd_help
      ;;
    version|--version|-v)
      echo "codeforge-phase v\${VERSION}"
      ;;
    *)
      log_error "Unknown command: '$command'"
      echo "Run '\${SCRIPT_NAME} help' for usage"
      exit 1
      ;;
  esac
}

main "$@"`,

  'playbook/current-phase.json': `{
  "current_phase": 1,
  "phase_id": "foundation",
  "updated_at": null,
  "updated_by": null
}`,

  'playbook/phases/01-discovery.md': `# Phase 01: Discovery & Requirements

## Purpose

Define the ML problem, establish success criteria, assess data availability, and align stakeholders on pipeline scope before writing any code. This phase prevents wasted GPU hours, scope creep, and ensures the pipeline solves a real business problem with measurable outcomes.

## Objectives

1. **Define the ML Problem Statement** — Translate business needs into a concrete ML task (classification, regression, ranking, generation, etc.) with clear input/output specifications
2. **Assess Data Availability & Quality** — Inventory available datasets, identify gaps, evaluate labeling quality, and confirm GDPR compliance for all data sources
3. **Establish Success Metrics** — Define both ML metrics (accuracy, F1, AUC, latency) and business KPIs that the model must satisfy
4. **Scope the Pipeline** — Determine which pipeline stages are needed: data ingestion, feature engineering, training, evaluation, serving, monitoring
5. **Identify Constraints** — Document compute budget (AWS GPU instances), latency requirements, data privacy obligations (GDPR, SOC 2), and team capacity
6. **Evaluate Feasibility** — Assess whether the problem is solvable with available data, compute, and timeline through literature review and baseline analysis

## Inputs

- Business problem description or product requirement document
- Available data sources (databases, APIs, S3 buckets, third-party providers)
- Existing models or heuristics currently in production
- Compute budget and AWS account constraints
- Compliance requirements (SOC 2 controls, GDPR data processing agreements)
- Team availability and skill matrix

## Activities

### 1. Problem Framing Workshop

- Meet with stakeholders to define the ML task precisely
- Document: What is the prediction target? What are the inputs? Who consumes the output?
- Determine if this is a batch or real-time inference problem
- Identify if A/B testing infrastructure is needed for rollout
- **Output**: Problem statement document in \`docs/problem-statement.md\`

### 2. Data Audit

- Inventory all candidate data sources with schema documentation
- Assess data volume, freshness, and update frequency
- Check for PII and classify data sensitivity per GDPR requirements
- Identify data that requires anonymization, pseudonymization, or consent verification
- Evaluate label quality and availability (labeled vs. unlabeled, noisy labels)
- Document data lineage and ownership
- **Output**: Data audit report in \`docs/data-audit.md\`

### 3. Exploratory Data Analysis (EDA)

- Create Jupyter notebooks in \`notebooks/\` for initial data exploration
- Profile distributions, missing values, class imbalance, feature correlations
- Identify potential data leakage risks
- Assess feature engineering opportunities
- **Output**: EDA notebooks in \`notebooks/01-eda/\` (exploration only — no production code)

### 4. Literature & Baseline Review

- Survey relevant papers, blog posts, and existing solutions for the ML task
- Identify candidate model architectures (PyTorch \`nn.Module\` classes to implement)
- Establish a simple baseline (rule-based, logistic regression, or random) for comparison
- Document expected performance ranges from literature
- **Output**: Baseline analysis in \`docs/baseline-review.md\`

### 5. Success Criteria Definition

- Define primary ML metric and threshold (e.g., F1 ≥ 0.85, latency p99 < 50ms)
- Define secondary metrics for monitoring (drift detection, fairness metrics)
- Define business KPIs tied to model performance
- Agree on evaluation methodology (cross-validation, temporal split, holdout set)
- Set minimum coverage threshold for test suite: **75%** per project standards
- **Output**: Success criteria in \`docs/success-criteria.md\`

### 6. Pipeline Architecture Sketch

- Draft the DAG-based pipeline stages using DVC pipeline concepts
- Identify which stages need GPU compute (training, inference)
- Plan data flow: raw → processed → features → model → predictions
- Determine MLflow experiment structure (experiment names, run naming conventions)
- Plan DVC remote storage layout on S3
- Sketch FastAPI serving endpoints (REST API contract)
- **Output**: Architecture diagram and notes in \`docs/architecture.md\`

### 7. Compliance & Security Review

- Map data flows against GDPR requirements (lawful basis, data minimization, retention)
- Identify SOC 2 controls applicable to the ML pipeline (access control, audit logging, artifact integrity)
- Plan model artifact signing and versioning strategy
- Document data retention and deletion policies (right to erasure)
- Review AWS IAM roles and permissions needed for SageMaker, S3, ECR
- **Output**: Compliance checklist in \`docs/compliance-checklist.md\`

### 8. Project Setup & Tooling

- Initialize repository structure per project layout conventions
- Configure \`pyproject.toml\` with pinned dependencies
- Set up \`uv\` for package management: \`uv sync\`
- Configure ruff, mypy, and pytest in \`pyproject.toml\`
- Initialize DVC: \`dvc init\` and configure S3 remote
- Set up MLflow tracking server connection
- Create initial experiment config in \`configs/\` using Pydantic models
- **Output**: Working development environment verified with:
  \`\`\`
  uv run ruff check src/
  uv run mypy src/
  uv run pytest tests/ --co
  dvc status
  \`\`\`

## Deliverables

| Deliverable | Location | Owner |
|---|---|---|
| Problem Statement | \`docs/problem-statement.md\` | Lead ML Engineer |
| Data Audit Report | \`docs/data-audit.md\` | Data Scientist |
| EDA Notebooks | \`notebooks/01-eda/\` | Data Scientist |
| Baseline Review | \`docs/baseline-review.md\` | ML Engineer |
| Success Criteria | \`docs/success-criteria.md\` | Lead ML Engineer + Stakeholder |
| Architecture Sketch | \`docs/architecture.md\` | Lead ML Engineer |
| Compliance Checklist | \`docs/compliance-checklist.md\` | Lead ML Engineer |
| Experiment Config Schema | \`src/utils/config.py\` (Pydantic models) | ML Engineer |
| Initial DVC Pipeline | \`dvc.yaml\` (skeleton) | ML Engineer |
| GitHub Issues | Backlog for Phase 02 | Lead ML Engineer |

## Quality Gates

All gates must pass before advancing to [Phase 02: Design & Architecture](./02-design.md).

### Gate 1: Problem Definition Complete

- [ ] ML task type is clearly defined (classification, regression, etc.)
- [ ] Input/output schema is documented with example data
- [ ] Business KPI tied to model performance is agreed upon
- [ ] Stakeholder sign-off on problem statement

### Gate 2: Data Readiness Confirmed

- [ ] At least one viable data source identified and accessible
- [ ] Data volume is sufficient for the ML task (documented estimate)
- [ ] PII fields identified and GDPR compliance plan documented
- [ ] Data quality issues cataloged with mitigation strategies
- [ ] Label availability and quality assessed

### Gate 3: Feasibility Validated

- [ ] Literature review confirms the task is tractable
- [ ] Simple baseline established with measurable performance
- [ ] Gap between baseline and target metric is realistic given data and compute
- [ ] No blocking technical risks identified (or mitigations documented)

### Gate 4: Success Metrics Defined

- [ ] Primary ML metric and threshold documented
- [ ] Evaluation methodology agreed upon (split strategy, cross-validation)
- [ ] Latency and throughput requirements for serving defined
- [ ] Monitoring metrics for production identified (drift, performance degradation)

### Gate 5: Infrastructure Ready

- [ ] Repository initialized with project structure
- [ ] \`uv sync\` completes without errors
- [ ] \`uv run ruff check src/\` passes
- [ ] \`uv run mypy src/\` passes
- [ ] DVC initialized with S3 remote configured
- [ ] MLflow tracking URI configured and accessible
- [ ] AWS permissions verified for S3, ECR, and GPU instances

### Gate 6: Compliance Approved

- [ ] GDPR data processing basis documented for each data source
- [ ] Data retention and deletion policy defined
- [ ] SOC 2 relevant controls mapped to pipeline components
- [ ] Sensitive paths (\`configs/production/**\`, \`models/**\`, \`.env*\`, \`data/**\`) identified in CODEOWNERS

## Anti-Patterns to Avoid

- **Jumping to modeling** — Do not start building PyTorch models before data quality is confirmed
- **Vague success criteria** — "Make the model better" is not a metric; define a number
- **Ignoring data privacy** — Every data source must have a documented GDPR lawful basis
- **Over-scoping** — Start with the simplest viable pipeline; add complexity in later phases
- **Notebooks as production code** — EDA notebooks are exploration artifacts, not pipeline components
- **Unpinned dependencies** — All packages in \`pyproject.toml\` must have pinned versions from day one

## Estimated Duration

**3–5 working days** for a small team (2–5 ML engineers + data scientists)

- Days 1–2: Problem framing, data audit, compliance review
- Days 2–3: EDA, baseline analysis, literature review
- Days 4–5: Architecture sketch, success criteria, project setup, quality gate review

## Phase Transition

When all quality gates pass:

1. Update phase tracker: edit \`playbook/current-phase.json\` to set \`"current_phase": "02-design"\`
2. Create GitHub Issues for Phase 02 deliverables
3. Notify team in Slack channel
4. Archive discovery artifacts in \`docs/\` and commit to \`main\`

**Next Phase**: [Phase 02: Design & Architecture](./02-design.md)`,

  'playbook/phases/02-architecture.md': `# Phase 02: Architecture & Design

## Purpose

Define the technical architecture for ML pipeline components — data flow, model training infrastructure, serving topology, experiment tracking integration, and data versioning strategy. Decisions made here directly impact reproducibility, scalability, and compliance (SOC 2, GDPR).

## Objectives

1. **Define the ML pipeline DAG** — Map every stage from raw data ingestion through feature engineering, training, evaluation, and model deployment as a DVC pipeline
2. **Design model architecture contracts** — Establish base classes, interfaces, and config schemas for PyTorch \`nn.Module\` implementations
3. **Design the experiment tracking topology** — MLflow experiment hierarchy, run naming, artifact storage layout on S3, model registry promotion workflow
4. **Design the serving infrastructure** — FastAPI endpoint contracts, inference pipeline, batch processing, A/B testing routing, caching strategy with Redis
5. **Design the data architecture** — DVC remote storage layout, feature store schema in Redis, PostgreSQL metadata schema, data lineage tracking
6. **Establish config management patterns** — Pydantic models for all YAML experiment configs with validation, environment-specific overrides
7. **Define infrastructure topology** — AWS resource layout (SageMaker, ECR, ECS, S3 buckets, GPU instances), Kubernetes deployment manifests, Terraform module boundaries
8. **Address compliance requirements** — GDPR data flow annotations, SOC 2 audit trail for model artifacts, data anonymization pipeline stage

## Inputs

- Phase 01 deliverables (requirements, user stories, data inventory)
- Existing dataset schemas and volume estimates
- GPU compute budget and latency SLAs
- Compliance requirements (SOC 2 controls, GDPR data processing records)

## Deliverables

### 1. ML Pipeline DAG Specification

**File**: \`docs/architecture/pipeline-dag.md\`

Document every DVC pipeline stage with inputs, outputs, dependencies, and parameters:

\`\`\`yaml
# dvc.yaml (target structure)
stages:
  prepare_data:
    cmd: uv run python scripts/prepare_data.py
    deps:
      - src/data/preprocessing.py
      - data/raw/
    params:
      - configs/data.yaml:preprocessing
    outs:
      - data/processed/

  engineer_features:
    cmd: uv run python scripts/engineer_features.py
    deps:
      - src/data/feature_engineering.py
      - data/processed/
    params:
      - configs/data.yaml:features
    outs:
      - data/features/

  train:
    cmd: uv run python scripts/train.py
    deps:
      - src/models/
      - src/training/
      - data/features/
    params:
      - configs/model.yaml
      - configs/training.yaml
    outs:
      - models/checkpoints/
    metrics:
      - metrics/train_metrics.json:
          cache: false

  evaluate:
    cmd: uv run python scripts/evaluate.py
    deps:
      - src/evaluation/
      - models/checkpoints/
      - data/features/
    metrics:
      - metrics/eval_metrics.json:
          cache: false
    plots:
      - metrics/plots/
\`\`\`

Include a visual DAG diagram and document each stage's:
- Expected runtime and resource requirements (CPU vs GPU)
- Failure modes and retry strategy
- Data validation checks at stage boundaries

### 2. Model Architecture Contracts

**File**: \`docs/architecture/model-contracts.md\`

Define the base model interface that all PyTorch models must implement:

\`\`\`python
# src/models/base.py — target interface
class BaseModel(nn.Module, ABC):
    """Base class for all pipeline models."""

    @abstractmethod
    def forward(self, batch: dict[str, torch.Tensor]) -> dict[str, torch.Tensor]:
        """Forward pass with named tensor dict input/output."""
        ...

    @abstractmethod
    def get_config(self) -> ModelConfig:
        """Return Pydantic config for reproducibility."""
        ...

    def save_checkpoint(self, path: Path, metadata: dict[str, Any]) -> None:
        """Save model with config and metadata for MLflow logging."""
        ...

    @classmethod
    def from_checkpoint(cls, path: Path) -> "BaseModel":
        """Load model from checkpoint with config validation."""
        ...
\`\`\`

Document:
- Input/output tensor schemas per model type
- Config schema (Pydantic \`ModelConfig\` with all hyperparameters)
- Checkpoint format and versioning strategy
- Model signature for MLflow model registry

### 3. Experiment Tracking Design

**File**: \`docs/architecture/experiment-tracking.md\`

MLflow hierarchy and conventions:

| Concept | Convention | Example |
|---------|-----------|---------|
| Experiment | \`{project}/{model_type}\` | \`ml-pipeline/transformer\` |
| Run Name | \`{date}-{config_hash[:8]}\` | \`2024-01-15-a3f2b1c9\` |
| Tags | \`model_type\`, \`dataset_version\`, \`git_sha\`, \`author\` | — |
| Artifacts | \`model/\`, \`configs/\`, \`plots/\`, \`data_sample/\` | — |
| Metrics | Logged per epoch + final summary | \`train_loss\`, \`val_f1\`, \`val_auc\` |

Model registry promotion workflow:
1. **None** → **Staging**: Automated on eval metric threshold pass
2. **Staging** → **Production**: Manual approval after A/B test results
3. **Production** → **Archived**: On new production promotion

Document:
- MLflow backend store (PostgreSQL connection, schema)
- Artifact store (S3 bucket layout: \`s3://ml-pipeline-artifacts/{experiment}/{run_id}/\`)
- Model signature and input example requirements
- Comparison queries for experiment analysis

### 4. Serving Architecture

**File**: \`docs/architecture/serving.md\`

FastAPI application design:

\`\`\`
┌─────────────────────────────────────────────────┐
│                  Load Balancer                    │
├─────────────────────────────────────────────────┤
│              FastAPI Application                  │
│  ┌──────────┐  ┌──────────┐  ┌───────────────┐ │
│  │ /predict  │  │ /batch   │  │ /health       │ │
│  │ (sync)    │  │ (async)  │  │ /metrics      │ │
│  └─────┬─────┘  └─────┬────┘  └───────────────┘ │
│        │              │                           │
│  ┌─────▼──────────────▼─────┐                    │
│  │   A/B Router              │                    │
│  │   (traffic splitting)     │                    │
│  └─────┬──────────┬─────────┘                    │
│  ┌─────▼─────┐ ┌──▼────────┐                    │
│  │ Model A   │ │ Model B   │                    │
│  │ (prod)    │ │ (shadow)  │                    │
│  └─────┬─────┘ └──┬────────┘                    │
│        │          │                              │
│  ┌─────▼──────────▼─────┐                       │
│  │   Redis Cache         │                       │
│  │   (predictions,       │                       │
│  │    feature store)     │                       │
│  └───────────────────────┘                       │
└─────────────────────────────────────────────────┘
\`\`\`

Document:
- Request/response Pydantic schemas for each endpoint
- A/B testing traffic split configuration
- Redis caching strategy (TTL, invalidation on model promotion)
- Batch inference queue design (async processing with status polling)
- Latency budget breakdown per component
- Health check and readiness probe contracts

### 5. Data Architecture

**File**: \`docs/architecture/data.md\`

\`\`\`
S3 Bucket Layout:
  s3://ml-pipeline-data/
    raw/                    # Immutable raw data (DVC tracked)
    processed/              # Cleaned, validated data
    features/               # Feature-engineered datasets
    splits/                 # Train/val/test splits (versioned)

  s3://ml-pipeline-artifacts/
    experiments/            # MLflow artifacts
    models/                 # Registered model versions
    configs/                # Archived experiment configs

PostgreSQL Schema:
  mlflow.*                  # MLflow backend tables
  metadata.datasets         # Dataset registry (version, schema, lineage)
  metadata.predictions      # Prediction audit log (SOC 2)
  metadata.data_consents    # GDPR consent records

Redis:
  features:{entity_id}     # Real-time feature vectors
  predictions:{hash}       # Cached predictions (TTL: 1h)
  model:current             # Current production model metadata
\`\`\`

Document:
- Data lineage tracking from raw → features → predictions
- GDPR annotations: which fields contain PII, anonymization pipeline stage, deletion propagation
- DVC remote configuration and access patterns
- Data validation schemas (using Pydantic or pandera)

### 6. Config Management Schema

**File**: \`docs/architecture/config-schema.md\`

All experiment configuration flows through validated Pydantic models:

\`\`\`python
# src/utils/config.py — target schema hierarchy
class DataConfig(BaseModel):
    raw_path: Path
    features: list[str]
    train_split: float = Field(ge=0.0, le=1.0, default=0.8)
    preprocessing: PreprocessingConfig
    # GDPR: flag PII columns for anonymization
    pii_columns: list[str] = Field(default_factory=list)

class ModelConfig(BaseModel):
    architecture: Literal["transformer", "lstm", "mlp"]
    hidden_dim: int = Field(ge=1)
    num_layers: int = Field(ge=1)
    dropout: float = Field(ge=0.0, le=1.0)

class TrainingConfig(BaseModel):
    epochs: int = Field(ge=1)
    batch_size: int = Field(ge=1)
    learning_rate: float = Field(gt=0.0)
    optimizer: Literal["adam", "adamw", "sgd"]
    scheduler: SchedulerConfig | None = None
    device: Literal["cpu", "cuda", "auto"] = "auto"
    seed: int = 42  # Reproducibility

class ExperimentConfig(BaseModel):
    """Top-level config loaded from YAML, validated before any pipeline stage."""
    experiment_name: str
    data: DataConfig
    model: ModelConfig
    training: TrainingConfig
\`\`\`

Document:
- YAML ↔ Pydantic loading pattern
- Environment-specific overrides (\`configs/production/\`, \`configs/staging/\`)
- Config hashing for experiment deduplication
- Sensitive config handling (secrets via environment variables, never in YAML)

### 7. Infrastructure Topology

**File**: \`docs/architecture/infrastructure.md\`

\`\`\`
AWS Architecture:
  ┌─────────────────────────────────────────┐
  │  VPC                                     │
  │  ┌──────────┐  ┌──────────────────────┐ │
  │  │ ECS/K8s  │  │ EC2 GPU Instances    │ │
  │  │ (serving)│  │ (training)           │ │
  │  │ FastAPI  │  │ p3.2xlarge / g4dn    │ │
  │  └────┬─────┘  └──────────┬───────────┘ │
  │       │                   │              │
  │  ┌────▼───┐  ┌───────────▼────────┐    │
  │  │ Redis  │  │ SageMaker          │    │
  │  │ (cache)│  │ (managed training)  │    │
  │  └────────┘  └────────────────────┘    │
  │       │                                  │
  │  ┌────▼──────────┐  ┌────────────────┐ │
  │  │ PostgreSQL    │  │ S3             │ │
  │  │ (RDS)         │  │ (data, models) │ │
  │  └───────────────┘  └────────────────┘ │
  └─────────────────────────────────────────┘
\`\`\`

Terraform module boundaries:
- \`terraform/modules/networking/\` — VPC, subnets, security groups
- \`terraform/modules/compute/\` — ECS cluster, GPU instances, autoscaling
- \`terraform/modules/storage/\` — S3 buckets, RDS, ElastiCache
- \`terraform/modules/mlflow/\` — MLflow server on ECS, backend store config
- \`terraform/modules/monitoring/\` — Prometheus, Grafana, CloudWatch alarms

### 8. Compliance Architecture

**File**: \`docs/architecture/compliance.md\`

**SOC 2 Controls**:
- All model artifacts signed with SHA-256 checksums stored in PostgreSQL
- Prediction audit log with request ID, model version, timestamp, input hash
- Access control: IAM roles for S3 buckets, database credentials via AWS Secrets Manager
- Change management: all model promotions require PR approval and are logged

**GDPR Compliance**:
- Data flow diagram annotating PII at each pipeline stage
- Anonymization stage in DVC pipeline (\`prepare_data\` stage)
- \`pii_columns\` in \`DataConfig\` triggers automatic anonymization
- Right to deletion: script to propagate deletion through all pipeline stages
- Data processing records maintained in \`metadata.data_consents\` table
- Model retraining triggered after significant data deletions

## Architecture Decision Records (ADRs)

Create ADRs in \`docs/architecture/decisions/\` for:

| ADR | Decision |
|-----|----------|
| ADR-001 | PyTorch over TensorFlow (team expertise, research flexibility) |
| ADR-002 | DVC over custom pipeline orchestration (reproducibility, Git integration) |
| ADR-003 | MLflow over W&B (self-hosted, SOC 2 compliance, model registry) |
| ADR-004 | FastAPI over Flask/gRPC (async support, Pydantic integration, OpenAPI) |
| ADR-005 | Redis for feature store over dedicated solution (team size, latency) |
| ADR-006 | Pydantic for config validation over dataclasses (validation, serialization) |
| ADR-007 | uv over pip/poetry (speed, lockfile reliability) |

## Quality Gates

All gates must pass before proceeding to Phase 03 (Implementation Planning).

| # | Gate | Criteria | Verified By |
|---|------|----------|-------------|
| 1 | Pipeline DAG complete | All stages defined with inputs/outputs/params in \`dvc.yaml\` format | Lead engineer |
| 2 | Model contracts defined | Base class, config schema, checkpoint format documented | ML lead |
| 3 | MLflow topology documented | Experiment hierarchy, artifact layout, promotion workflow | ML lead |
| 4 | Serving API contracts | OpenAPI-compatible request/response schemas for all endpoints | Lead engineer |
| 5 | Data architecture reviewed | S3 layout, PostgreSQL schema, Redis key patterns documented | Lead engineer |
| 6 | Config schemas validated | All Pydantic config models defined with field constraints | Any senior engineer |
| 7 | Infrastructure topology approved | Terraform module boundaries, resource sizing, cost estimate | Lead engineer |
| 8 | GDPR data flow annotated | PII identified at every pipeline stage, anonymization designed | Lead engineer + legal |
| 9 | SOC 2 audit trail designed | Model artifact integrity, prediction logging, access control | Lead engineer |
| 10 | ADRs written and approved | All major technology and pattern decisions recorded | Team consensus |
| 11 | Latency budget defined | End-to-end inference latency breakdown with targets per component | Lead engineer |
| 12 | Reproducibility verified | Config hash → experiment mapping, seed strategy, DVC lock approach | ML lead |

## Phase Transition

\`\`\`bash
# Validate all architecture docs exist
ls docs/architecture/pipeline-dag.md \\
   docs/architecture/model-contracts.md \\
   docs/architecture/experiment-tracking.md \\
   docs/architecture/serving.md \\
   docs/architecture/data.md \\
   docs/architecture/config-schema.md \\
   docs/architecture/infrastructure.md \\
   docs/architecture/compliance.md

# Validate config schemas parse
uv run python -c "from src.utils.config import ExperimentConfig; print('Config schema valid')"

# Advance phase
./playbook/codeforge-phase.sh advance
\`\`\`

## Claude Code Usage in This Phase

When using Claude Code during architecture:

- **Use the architect agent** (\`/agent architect\`) to evaluate design tradeoffs
- Ask Claude to review Pydantic config schemas for completeness and validation gaps
- Use Claude to generate ADR templates from design discussions
- Ask Claude to identify missing failure modes in the pipeline DAG
- Have Claude review the data flow for GDPR compliance gaps
- Request Claude to estimate infrastructure costs based on the topology

**Do not** use Claude to make final architecture decisions — those require team consensus and are recorded in ADRs.

## References

- [Phase 01: Requirements](./01-requirements.md)
- [Phase 03: Implementation Planning](./03-implementation.md)
- [CONTRIBUTING.md](../../CONTRIBUTING.md) — coding standards that architecture must support
- [AI Usage Policy](../../docs/AI-USAGE-POLICY.md) — guidelines for AI-assisted architecture work`,

  'playbook/phases/03-foundation.md': `# Phase 03: Foundation & Scaffolding

## Overview

**Phase**: 03 of 07
**Previous**: [02 — Architecture & Design](./02-architecture.md)
**Next**: [04 — Core Implementation](./04-core-implementation.md)
**Typical Duration**: 3–5 days
**Participants**: Lead ML Engineer, Senior Engineers

Phase 03 transforms the architecture decisions from Phase 02 into a working project skeleton. This means establishing the Python package structure, configuring all tooling (ruff, mypy, pytest, DVC, MLflow), setting up Docker environments, creating base classes for models and data pipelines, and verifying the entire CI/CD pipeline runs green on an empty scaffold.

The goal is a fully wired project where any team member can clone the repo, run \`./install.sh\`, and immediately begin implementing features against well-defined interfaces.

---

## Objectives

### O1: Python Package Structure
- Create the \`src/\` package layout with all subpackages (\`data\`, \`models\`, \`training\`, \`evaluation\`, \`serving\`, \`utils\`)
- Add \`__init__.py\` files with appropriate \`__all__\` exports
- Ensure the package is installable via \`uv pip install -e .\` using \`pyproject.toml\`
- Verify imports work: \`from src.models.base import BaseModel\`

### O2: Configuration System
- Implement Pydantic settings classes for all config domains:
  - \`DataConfig\` — dataset paths, splits, preprocessing params
  - \`ModelConfig\` — architecture name, hyperparameters, layer sizes
  - \`TrainingConfig\` — epochs, learning rate, batch size, optimizer, scheduler
  - \`ServingConfig\` — host, port, model path, batch size limits
  - \`InfraConfig\` — S3 buckets, MLflow tracking URI, Redis connection
- Create YAML config loader in \`src/utils/config.py\` that validates against Pydantic schemas
- Add example configs in \`configs/\` for dev, staging, production environments
- Mark \`configs/production/**\` as a sensitive path in CODEOWNERS

### O3: Base Classes & Interfaces
- Define \`BaseModel(nn.Module)\` abstract class in \`src/models/base.py\` with required methods:
  - \`forward()\`, \`predict()\`, \`save_checkpoint()\`, \`load_checkpoint()\`
- Define \`BaseDataset(torch.utils.data.Dataset)\` in \`src/data/base.py\`
- Define \`BaseTrainer\` in \`src/training/base.py\` with training loop skeleton, MLflow logging hooks, and checkpoint callbacks
- Define \`BaseEvaluator\` in \`src/evaluation/base.py\` with metric computation interface
- Define \`BasePipeline\` in \`src/data/pipeline.py\` for feature engineering DAG steps

### O4: DVC Initialization
- Run \`dvc init\` and configure S3 remote storage
- Create \`.dvc/.gitignore\` and \`data/.gitignore\` for tracked artifacts
- Define initial \`dvc.yaml\` pipeline stages (even if implementations are stubs):
  - \`prepare\` — raw data → processed data
  - \`featurize\` — processed data → feature store
  - \`train\` — features + config → model artifact
  - \`evaluate\` — model + test data → metrics JSON
- Add \`params.yaml\` referencing config values for DVC param tracking
- Verify \`dvc repro\` runs (with stub scripts that create placeholder outputs)

### O5: MLflow Setup
- Configure MLflow tracking URI (local SQLite for dev, PostgreSQL for staging/prod)
- Create \`src/utils/mlflow_utils.py\` with helpers:
  - \`init_experiment(name, tags)\` — create or get experiment
  - \`log_config(config: BaseModel)\` — log Pydantic config as params
  - \`log_model_artifact(model, name)\` — log PyTorch model to registry
- Add MLflow autolog integration for PyTorch
- Verify \`mlflow ui\` launches and displays a test experiment

### O6: FastAPI Serving Skeleton
- Create \`src/serving/app.py\` with FastAPI application factory
- Define health check endpoint: \`GET /health\`
- Define prediction endpoint stub: \`POST /predict\`
- Define batch prediction endpoint stub: \`POST /predict/batch\`
- Define model info endpoint: \`GET /model/info\`
- Add Pydantic request/response schemas in \`src/serving/schemas.py\`
- Add middleware: CORS, request ID, latency logging
- Verify \`uv run uvicorn src.serving.app:create_app --factory\` starts

### O7: Docker & Infrastructure
- Create \`Dockerfile\` for training (GPU-capable base image, CUDA support)
- Create \`Dockerfile.serve\` for serving (slim image, CPU-only option)
- Create \`docker-compose.yml\` with services:
  - \`mlflow-server\` (with PostgreSQL backend)
  - \`redis\` (feature cache)
  - \`postgres\` (MLflow metadata)
  - \`api\` (FastAPI serving)
- Verify \`docker compose up\` brings up all services
- Add \`.dockerignore\` excluding \`data/\`, \`notebooks/\`, \`.git/\`

### O8: CI/CD Pipeline
- Create \`.github/workflows/ci.yml\` with all stages:
  - **Lint**: \`uv run ruff check src/ tests/\`
  - **Format Check**: \`uv run ruff format --check src/ tests/\`
  - **Type Check**: \`uv run mypy src/\`
  - **Unit Tests**: \`uv run pytest tests/unit/ -v --cov=src --cov-report=xml\`
  - **Integration Tests**: \`uv run pytest tests/integration/ -v\` (on PR to main)
  - **Train Smoke Test**: \`dvc repro\` with minimal data (on PR to main)
  - **Build Docker**: Build and push to ECR (on merge to main)
- Create \`.github/workflows/deploy-staging.yml\` for auto-deploy
- Create \`.github/CODEOWNERS\` mapping sensitive paths to leads
- Create PR and issue templates in \`.github/\`

### O9: Testing Infrastructure
- Set up \`tests/\` directory structure:
  - \`tests/unit/\` — fast, isolated tests
  - \`tests/integration/\` — tests requiring Docker services
  - \`tests/smoke/\` — minimal end-to-end pipeline tests
- Create \`tests/conftest.py\` with shared fixtures:
  - \`sample_config\` — minimal valid Pydantic config
  - \`sample_tensor\` — random tensor matching expected input shape
  - \`tmp_model_dir\` — temporary directory for model checkpoints
  - \`mock_mlflow\` — patched MLflow client
  - \`sample_dataset\` — small in-memory dataset for testing
- Create \`pytest.ini\` or \`pyproject.toml\` pytest config with markers: \`unit\`, \`integration\`, \`smoke\`, \`gpu\`
- Verify \`uv run pytest tests/unit/ -v\` passes with at least one test per subpackage

### O10: Developer Experience
- Ensure \`./install.sh\` sets up the complete dev environment:
  - Install \`uv\`, create venv, install deps
  - Initialize DVC, pull sample data (if available)
  - Create \`.env\` from \`.env.example\`
  - Run initial lint + type check + tests
- Create \`Makefile\` or \`justfile\` with common commands:
  - \`make lint\`, \`make format\`, \`make typecheck\`, \`make test\`
  - \`make train\`, \`make serve\`, \`make mlflow\`
  - \`make docker-build\`, \`make docker-up\`
- Add pre-commit hooks via \`.pre-commit-config.yaml\`:
  - ruff check + format
  - mypy
  - detect-secrets (SOC 2 compliance)
  - check-yaml, check-toml
  - DVC file validation

---

## Deliverables

| # | Deliverable | Description | Acceptance Criteria |
|---|-------------|-------------|---------------------|
| D1 | Package structure | All \`src/\` subpackages with \`__init__.py\` | \`from src.models.base import BaseModel\` works |
| D2 | Pydantic configs | Config classes + YAML loader | Configs validate, invalid YAML raises \`ValidationError\` |
| D3 | Base classes | Abstract classes for Model, Dataset, Trainer, Evaluator | Each has docstrings, type hints, abstract methods |
| D4 | DVC pipeline | \`dvc.yaml\` with stub stages | \`dvc repro\` completes without error |
| D5 | MLflow integration | Tracking utils + test experiment | \`mlflow ui\` shows logged experiment |
| D6 | FastAPI skeleton | Serving app with health + predict stubs | \`GET /health\` returns 200, OpenAPI docs render |
| D7 | Docker setup | Dockerfiles + compose | \`docker compose up\` starts all services |
| D8 | CI pipeline | GitHub Actions workflows | All checks pass on scaffold commit |
| D9 | Test infrastructure | conftest fixtures + one test per package | \`uv run pytest\` passes, coverage ≥ 75% on scaffold |
| D10 | Dev tooling | install.sh, Makefile, pre-commit | New clone → working env in < 5 minutes |

---

## Quality Gates

All gates must pass before advancing to Phase 04.

### QG-1: Toolchain Green
\`\`\`bash
# All must exit 0
uv run ruff check src/ tests/
uv run ruff format --check src/ tests/
uv run mypy src/
uv run pytest tests/unit/ -v --cov=src --cov-fail-under=75
\`\`\`

### QG-2: DVC Pipeline Reproducible
\`\`\`bash
# Pipeline runs end-to-end with stubs
dvc repro
dvc status  # Should show "Pipeline is up to date"
\`\`\`

### QG-3: MLflow Operational
\`\`\`bash
# Test experiment logs successfully
uv run python -c "
from src.utils.mlflow_utils import init_experiment, log_config
from src.utils.config import load_config
config = load_config('configs/dev/train.yaml')
init_experiment('foundation-test')
log_config(config)
print('MLflow logging OK')
"
\`\`\`

### QG-4: Serving Starts
\`\`\`bash
# FastAPI app starts and responds
uv run uvicorn src.serving.app:create_app --factory --host 0.0.0.0 --port 8000 &
sleep 3
curl -f http://localhost:8000/health
curl -f http://localhost:8000/docs
kill %1
\`\`\`

### QG-5: Docker Builds
\`\`\`bash
docker build -t ml-pipeline:train -f Dockerfile .
docker build -t ml-pipeline:serve -f Dockerfile.serve .
docker compose config --quiet  # Validates compose file
\`\`\`

### QG-6: CI Pipeline Passes
- Push scaffold to a feature branch
- Open PR to \`main\`
- All GitHub Actions checks pass (lint, type check, tests, smoke)
- No secrets or credentials in committed files (detect-secrets scan)

### QG-7: Type Safety
\`\`\`bash
# mypy strict mode passes on all src/ modules
uv run mypy src/ --strict --ignore-missing-imports
# No \`Any\` types in public function signatures (base classes)
\`\`\`

### QG-8: Security & Compliance
- \`.env.example\` exists with placeholder values (no real secrets)
- \`configs/production/**\` listed in CODEOWNERS requiring lead approval
- \`.pre-commit-config.yaml\` includes \`detect-secrets\`
- \`data/\` directory has \`.gitignore\` preventing raw data commits (GDPR)
- Model artifacts tracked by DVC, not committed to git (SOC 2 artifact integrity)

### QG-9: Documentation
- Each base class has Google-style docstrings
- \`README.md\` quick-start section works for a fresh clone
- \`configs/README.md\` explains config hierarchy and override mechanism
- \`docs/architecture.md\` reflects the implemented scaffold structure

---

## Common Pitfalls

| Pitfall | Mitigation |
|---------|------------|
| Circular imports between \`src/\` subpackages | Use lazy imports or define interfaces in \`base.py\` files; test imports in CI |
| DVC remote not configured for team | Document S3 remote setup in \`docs/ONBOARDING.md\`; use \`dvc remote default\` |
| MLflow tracking URI differs per environment | Use \`InfraConfig\` Pydantic class with env var override: \`MLFLOW_TRACKING_URI\` |
| Docker GPU support not working locally | Provide CPU-only \`docker-compose.override.yml\` for local dev |
| Config drift between YAML and Pydantic | Generate JSON Schema from Pydantic models; validate YAML in CI |
| Large data files accidentally committed | \`.gitignore\` + pre-commit hook + \`data/**\` in \`.gitattributes\` for DVC |
| Stale type stubs for PyTorch | Pin \`torch\` version in \`pyproject.toml\`; use \`--ignore-missing-imports\` selectively |

---

## Claude Code Usage in This Phase

Claude is highly effective during foundation work. Recommended usage:

### Scaffold Generation
\`\`\`
> /plan Create the base model class in src/models/base.py with abstract methods for forward, predict, save_checkpoint, load_checkpoint. Include type hints, docstrings, and MLflow integration hooks.
\`\`\`

### Config System
\`\`\`
> /tdd Write Pydantic config classes for DataConfig, ModelConfig, TrainingConfig with YAML loading. Start with tests that validate config parsing and error handling.
\`\`\`

### CI Pipeline
\`\`\`
> Generate the GitHub Actions CI workflow with stages: ruff check, ruff format --check, mypy, pytest with coverage, DVC repro smoke test, Docker build.
\`\`\`

### Review Scaffold
\`\`\`
> /code-review Review the entire src/ package structure for import consistency, type hint completeness, and adherence to our naming conventions.
\`\`\`

### Verify Phase Completion
\`\`\`
> /verify Run all Phase 03 quality gates and report status.
\`\`\`

---

## Phase Transition Criteria

**Ready for Phase 04 when:**

- [ ] All 10 deliverables (D1–D10) meet acceptance criteria
- [ ] All 9 quality gates (QG-1 through QG-9) pass
- [ ] CI pipeline runs green on \`main\`
- [ ] At least one team member has cloned fresh and verified \`./install.sh\` works
- [ ] \`playbook/current-phase.json\` updated to \`{"current_phase": 4}\`
- [ ] Phase 03 completion logged in team Slack channel

**Carry-forward items for Phase 04:**
- Implement concrete model architectures (extending \`BaseModel\`)
- Implement real data loading and feature engineering (extending \`BaseDataset\`, \`BasePipeline\`)
- Replace DVC stub scripts with actual training pipeline
- Connect FastAPI endpoints to real model inference`,

  'playbook/phases/04-core-implementation.md': `# Phase 04: Core Implementation

## Overview

Core Implementation is where the ML pipeline takes shape as working, tested code. This phase transforms the architecture and foundation from Phases 02–03 into functional components: data pipelines, model training loops, experiment tracking integration, and serving infrastructure. Each component is built incrementally with TDD, tracked in MLflow, and versioned through DVC.

## Objectives

1. **Implement data ingestion and feature engineering pipelines** with DVC orchestration
2. **Build PyTorch model architectures** defined in experiment configs
3. **Implement training loops** with checkpointing, logging, and MLflow integration
4. **Build evaluation framework** with metrics, comparison, and visualization
5. **Implement FastAPI serving layer** with inference and batch endpoints
6. **Integrate experiment tracking** end-to-end (config → train → evaluate → register)
7. **Establish DVC pipelines** for reproducible data processing and training
8. **Implement feature store** with Redis caching layer
9. **Ensure GDPR compliance** in data handling (anonymization, consent tracking, deletion)
10. **Achieve 75% test coverage** across all implemented modules

## Prerequisites

- [ ] Phase 03 (Foundation) completed and quality gates passed
- [ ] Project skeleton with \`src/\`, \`configs/\`, \`tests/\`, \`data/\` structure in place
- [ ] CI/CD pipeline running (lint, type check, test stages green)
- [ ] DVC initialized with S3 remote configured
- [ ] MLflow tracking server accessible (local or remote)
- [ ] PostgreSQL and Redis instances available for development
- [ ] Base Docker image builds successfully
- [ ] Pydantic config schemas defined for experiment, model, data, and training configs

## Implementation Order

Follow this sequence to manage dependencies between components. Each step produces a working, tested increment.

### Step 1: Data Layer (\`src/data/\`)

**Branch**: \`feat/ML-xxx-data-pipeline\`

#### 1.1 Data Loaders

\`\`\`
src/data/loaders.py        — Raw data ingestion from S3/local sources
src/data/schemas.py        — Pydantic models for data validation
tests/test_data_loaders.py — Unit tests for loaders
\`\`\`

- Implement \`DataLoader\` classes that read from configured sources
- Validate raw data against Pydantic schemas on ingestion
- Handle missing values, type coercion, and schema drift detection
- Log data statistics to MLflow (row counts, null rates, distributions)
- GDPR: implement PII detection and anonymization at ingestion

**TDD cycle**: Write tests for each loader with fixture data → implement → verify with \`uv run pytest tests/test_data_loaders.py\`

#### 1.2 Feature Engineering

\`\`\`
src/data/features.py          — Feature transformations and pipelines
src/data/feature_store.py     — Redis-backed feature store
configs/features/default.yaml — Feature pipeline configuration
tests/test_features.py        — Unit tests for feature transforms
\`\`\`

- Build feature transformations as composable, configurable functions
- Each transform reads config from YAML via Pydantic validation
- Store computed features in Redis with TTL for serving-time lookup
- Version feature definitions in DVC alongside data artifacts
- Log feature statistics and distributions to MLflow

#### 1.3 DVC Data Pipeline

\`\`\`
data/raw/.gitkeep
data/processed/.gitkeep
data/features/.gitkeep
dvc.yaml                — Pipeline stages: download → validate → process → featurize
params.yaml             — Parameters referenced by DVC stages
\`\`\`

- Define DVC stages for each data transformation step
- Pin stage dependencies so \`dvc repro\` rebuilds only what changed
- Track \`data/raw/\`, \`data/processed/\`, \`data/features/\` with DVC
- Verify reproducibility: \`dvc repro\` from clean state produces identical outputs

### Step 2: Model Layer (\`src/models/\`)

**Branch**: \`feat/ML-xxx-model-architectures\`

#### 2.1 Model Architectures

\`\`\`
src/models/base.py         — Abstract base model with common interface
src/models/registry.py     — Model factory/registry pattern
src/models/<arch>.py       — Specific architectures (e.g., transformer.py, mlp.py)
configs/models/default.yaml — Model hyperparameters
tests/test_models.py       — Unit tests for forward pass, shapes, serialization
\`\`\`

- All models inherit from a \`BaseModel(nn.Module)\` with standard interface:
  - \`forward(x: torch.Tensor) -> torch.Tensor\`
  - \`predict(x: torch.Tensor) -> torch.Tensor\`
  - \`get_num_params() -> int\`
- Model registry maps config string names to classes
- Configs define architecture hyperparameters via Pydantic schemas
- Test forward pass shapes, gradient flow, serialization round-trip

\`\`\`python
# Example test pattern
def test_model_forward_shape(sample_batch: torch.Tensor, model_config: ModelConfig) -> None:
    model = ModelRegistry.create(model_config)
    output = model(sample_batch)
    assert output.shape == (sample_batch.shape[0], model_config.num_classes)
\`\`\`

#### 2.2 Model Serialization and Checkpointing

\`\`\`
src/models/checkpoint.py   — Save/load checkpoints with metadata
tests/test_checkpoint.py   — Round-trip serialization tests
\`\`\`

- Save model state dict, optimizer state, epoch, metrics, and config
- Integrate with MLflow artifact logging
- Track model artifacts in DVC for large files
- Verify checkpoint integrity with hash validation (SOC 2 requirement)

### Step 3: Training Layer (\`src/training/\`)

**Branch**: \`feat/ML-xxx-training-loop\`

#### 3.1 Training Loop

\`\`\`
src/training/trainer.py       — Main training loop with callbacks
src/training/callbacks.py     — EarlyStopping, Checkpointing, MLflowLogger, etc.
src/training/optimizers.py    — Optimizer and scheduler factory
configs/training/default.yaml — Training hyperparameters
tests/test_trainer.py         — Unit tests with small model/data
\`\`\`

- \`Trainer\` class accepts model, data loaders, config, and callback list
- Training loop handles: forward, loss, backward, optimizer step, scheduler step
- Callbacks fire at: \`on_epoch_start\`, \`on_epoch_end\`, \`on_batch_end\`, \`on_train_end\`
- MLflow callback logs metrics per epoch, parameters at start, artifacts at end
- Support GPU training with device management (\`cuda\` / \`cpu\` / \`mps\`)
- Implement gradient clipping, mixed precision (AMP) as config options

\`\`\`python
# Example trainer usage
trainer = Trainer(
    model=model,
    train_loader=train_loader,
    val_loader=val_loader,
    config=training_config,
    callbacks=[EarlyStopping(patience=5), MLflowLogger(), CheckpointCallback()],
)
trainer.fit()
\`\`\`

#### 3.2 Hyperparameter Tuning

\`\`\`
src/training/tuning.py     — Hyperparameter search (grid, random, Bayesian)
configs/tuning/default.yaml — Search space definition
tests/test_tuning.py       — Unit tests for search logic
\`\`\`

- Define search spaces in YAML config validated by Pydantic
- Each trial is an MLflow child run under a parent experiment
- Log all trial results for comparison in MLflow UI
- Support early termination of underperforming trials

#### 3.3 DVC Training Pipeline

Update \`dvc.yaml\` with training stages:

\`\`\`yaml
stages:
  train:
    cmd: uv run python scripts/train.py --config configs/training/default.yaml
    deps:
      - src/training/
      - src/models/
      - data/features/
      - configs/training/default.yaml
    outs:
      - models/checkpoints/
    metrics:
      - metrics/train_metrics.json:
          cache: false
    plots:
      - metrics/loss_curve.csv:
          x: epoch
          y: loss
\`\`\`

### Step 4: Evaluation Layer (\`src/evaluation/\`)

**Branch**: \`feat/ML-xxx-evaluation\`

\`\`\`
src/evaluation/metrics.py      — Metric computation (accuracy, F1, AUC, custom)
src/evaluation/comparison.py   — Model comparison across experiments
src/evaluation/visualization.py — Plots: confusion matrix, ROC, learning curves
src/evaluation/reports.py      — Generate evaluation reports
tests/test_evaluation.py       — Unit tests for metric calculations
\`\`\`

- Compute metrics on validation and test sets
- Log all metrics to MLflow with dataset metadata
- Generate comparison tables across MLflow experiment runs
- Produce visualization artifacts stored in MLflow
- Support A/B test statistical analysis (significance testing)
- Evaluation reports include data lineage for GDPR audit trail

### Step 5: Serving Layer (\`src/serving/\`)

**Branch**: \`feat/ML-xxx-serving-api\`

#### 5.1 FastAPI Application

\`\`\`
src/serving/app.py          — FastAPI app factory
src/serving/routes.py       — API route definitions
src/serving/inference.py    — Inference pipeline (preprocess → predict → postprocess)
src/serving/schemas.py      — Request/response Pydantic models
src/serving/middleware.py   — Logging, auth, rate limiting middleware
tests/test_serving.py       — API endpoint tests with pytest-asyncio
\`\`\`

- Load model from MLflow model registry on startup
- Endpoints:
  - \`POST /predict\` — Single inference request
  - \`POST /predict/batch\` — Batch inference
  - \`GET /health\` — Health check with model metadata
  - \`GET /model/info\` — Current model version, metrics, lineage
- Request/response validation with Pydantic schemas
- Feature lookup from Redis feature store at inference time
- Request logging for monitoring and GDPR audit

#### 5.2 A/B Testing Infrastructure

\`\`\`
src/serving/ab_testing.py   — Traffic splitting, variant assignment
src/serving/ab_metrics.py   — A/B test metric collection
configs/serving/ab_test.yaml — A/B test configuration
tests/test_ab_testing.py    — Unit tests for traffic splitting
\`\`\`

- Route traffic between model versions based on config
- Track variant assignment and outcomes in PostgreSQL
- Compute statistical significance for model comparisons
- Integrate with MLflow to link A/B results to experiment runs

### Step 6: Integration and End-to-End Pipeline

**Branch**: \`feat/ML-xxx-e2e-pipeline\`

\`\`\`
scripts/train.py            — CLI entry point for training
scripts/evaluate.py         — CLI entry point for evaluation
scripts/serve.py            — CLI entry point for serving
scripts/run_pipeline.py     — Full pipeline orchestration
tests/integration/          — End-to-end integration tests
\`\`\`

- Wire all components together: data → features → train → evaluate → register → serve
- Full \`dvc repro\` runs the pipeline end-to-end
- Integration tests use small synthetic data and fast model configs
- Verify MLflow experiment is created with all expected artifacts
- Verify model can be loaded from registry and served via FastAPI

## Deliverables

| Deliverable | Location | Acceptance Criteria |
|---|---|---|
| Data loaders with validation | \`src/data/loaders.py\`, \`src/data/schemas.py\` | Loads from S3/local, validates schema, logs stats to MLflow |
| Feature engineering pipeline | \`src/data/features.py\`, \`src/data/feature_store.py\` | Composable transforms, Redis caching, DVC-tracked |
| DVC data pipeline | \`dvc.yaml\`, \`params.yaml\` | \`dvc repro\` runs full data pipeline reproducibly |
| PyTorch model architectures | \`src/models/\` | Forward pass tests pass, serialization round-trips |
| Model checkpointing | \`src/models/checkpoint.py\` | Save/load with integrity verification |
| Training loop with callbacks | \`src/training/trainer.py\`, \`src/training/callbacks.py\` | GPU support, MLflow logging, early stopping |
| Hyperparameter tuning | \`src/training/tuning.py\` | Search space from config, MLflow child runs |
| Evaluation framework | \`src/evaluation/\` | Metrics, comparison, visualization, reports |
| FastAPI serving app | \`src/serving/\` | \`/predict\`, \`/predict/batch\`, \`/health\` endpoints |
| A/B testing infrastructure | \`src/serving/ab_testing.py\` | Traffic splitting, statistical significance |
| Integration tests | \`tests/integration/\` | End-to-end pipeline runs on synthetic data |
| Experiment configs | \`configs/\` | Validated by Pydantic, tracked in version control |
| Training scripts | \`scripts/\` | CLI entry points for all pipeline stages |

## Quality Gates

All gates must pass before Phase 04 is considered complete.

### Gate 1: Code Quality

\`\`\`bash
# All checks must pass
uv run ruff check src/ tests/ scripts/
uv run ruff format --check src/ tests/ scripts/
uv run mypy src/ --strict
\`\`\`

- [ ] Zero ruff lint violations
- [ ] Zero ruff format violations
- [ ] Zero mypy errors in strict mode
- [ ] All public functions have type hints
- [ ] No file exceeds 300 lines
- [ ] snake_case for files/functions, PascalCase for classes, SCREAMING_SNAKE_CASE for constants

### Gate 2: Test Coverage

\`\`\`bash
uv run pytest tests/ --cov=src --cov-report=term-missing --cov-fail-under=75
uv run pytest tests/integration/ -m integration
\`\`\`

- [ ] Unit test coverage ≥ 75% across \`src/\`
- [ ] All unit tests pass
- [ ] Integration tests pass with synthetic data
- [ ] Model forward pass shape tests pass for all architectures
- [ ] Serialization round-trip tests pass
- [ ] API endpoint tests pass (status codes, response schemas)
- [ ] Feature engineering tests verify transform correctness

### Gate 3: ML Pipeline Reproducibility

\`\`\`bash
dvc repro
dvc metrics show
dvc plots show
\`\`\`

- [ ] \`dvc repro\` completes without errors from clean state
- [ ] Running \`dvc repro\` twice produces identical outputs (deterministic seeds)
- [ ] DVC metrics tracked in \`metrics/\` and viewable with \`dvc metrics show\`
- [ ] All data artifacts tracked in DVC (not committed to git)
- [ ] \`params.yaml\` contains all tunable parameters referenced by DVC stages

### Gate 4: Experiment Tracking

\`\`\`bash
mlflow ui  # Verify experiments are visible
\`\`\`

- [ ] Training creates MLflow experiment with descriptive name
- [ ] All hyperparameters logged as MLflow params
- [ ] Training and validation metrics logged per epoch
- [ ] Model artifacts logged to MLflow artifact store
- [ ] Experiment config YAML logged as artifact for reproducibility
- [ ] Data lineage metadata logged (dataset version, DVC commit)
- [ ] Hyperparameter tuning creates parent/child run hierarchy

### Gate 5: Serving Readiness

\`\`\`bash
uv run uvicorn src.serving.app:create_app --factory --host 0.0.0.0 --port 8000
curl http://localhost:8000/health
curl -X POST http://localhost:8000/predict -H "Content-Type: application/json" -d '{"features": [...]}'
\`\`\`

- [ ] FastAPI app starts and loads model from MLflow registry
- [ ] \`/health\` returns 200 with model version metadata
- [ ] \`/predict\` returns valid response matching Pydantic schema
- [ ] \`/predict/batch\` handles multiple inputs correctly
- [ ] Request validation rejects malformed inputs with 422
- [ ] Response times under 100ms for single inference (CPU)

### Gate 6: Security and Compliance

- [ ] No secrets or credentials in code or configs (checked by pre-commit)
- [ ] PII anonymization applied at data ingestion (GDPR)
- [ ] Data deletion capability implemented and tested (GDPR right to deletion)
- [ ] Model artifact integrity verified via hash checksums (SOC 2)
- [ ] API request logging includes audit trail fields
- [ ] Sensitive paths (\`configs/production/**\`, \`models/**\`, \`.env*\`, \`data/**\`) protected in CODEOWNERS
- [ ] No production data used in tests — synthetic data only

### Gate 7: Documentation

- [ ] All modules have docstrings explaining purpose and usage
- [ ] \`configs/\` directory has README explaining config structure
- [ ] API endpoints documented (FastAPI auto-generates OpenAPI spec)
- [ ] \`docs/experiment-guide.md\` explains how to run experiments
- [ ] \`docs/data-pipeline.md\` documents DVC pipeline stages
- [ ] Architecture decisions recorded in \`docs/architecture/\`

## Working Agreements

### Branch and PR Discipline

- One feature branch per implementation step (Steps 1–6 above)
- PRs require at least 1 approval from a team member
- AI-generated code flagged with \`# AI-generated\` comment blocks
- Conventional commits: \`feat:\`, \`fix:\`, \`experiment:\`, \`docs:\`
- No direct pushes to \`main\`

### Experiment Discipline

- Every training run tracked in MLflow — no untracked experiments
- Experiment configs committed to \`configs/\` before running
- Notebooks (\`notebooks/\`) for exploration only — move production code to \`src/\`
- Pin random seeds in configs for reproducibility
- Document experiment rationale in MLflow run notes

### Dependency Management

- New dependencies require team review before adding to \`pyproject.toml\`
- All versions pinned in \`pyproject.toml\`
- Use \`uv add <package>\` to add dependencies
- Verify Docker image builds after dependency changes

### Code Review Focus Areas

- Correct use of PyTorch APIs (tensor shapes, device management, memory)
- Pydantic config validation completeness
- MLflow logging coverage (params, metrics, artifacts)
- DVC pipeline dependency correctness
- GDPR compliance in data handling paths
- Type hint accuracy (mypy strict must pass)

## Common Pitfalls

| Pitfall | Mitigation |
|---|---|
| GPU memory leaks in training loop | Use \`torch.no_grad()\` for validation, \`.detach()\` before logging |
| Non-deterministic training | Pin seeds in config: \`torch.manual_seed()\`, \`numpy.random.seed()\` |
| DVC pipeline cache invalidation | Ensure all deps listed in \`dvc.yaml\` stages |
| MLflow experiment clutter | Use naming conventions: \`{project}-{model}-{date}\` |
| Feature store stale data | Set Redis TTL, version feature definitions |
| Slow API cold start | Pre-load model on startup, use model warmup |
| Config drift between training and serving | Single Pydantic config source used by both |
| Large model files in git | Track with DVC, verify \`.gitignore\` excludes \`models/\` and \`data/\` |

## Phase Completion Checklist

- [ ] All 6 implementation steps completed and merged to \`main\`
- [ ] All 7 quality gates passed
- [ ] CI/CD pipeline green on \`main\` (lint → type check → test → build → smoke test)
- [ ] \`dvc repro\` runs full pipeline end-to-end
- [ ] MLflow shows at least one complete experiment with all artifacts
- [ ] FastAPI serving app starts and responds to requests
- [ ] Test coverage ≥ 75%
- [ ] No critical or high-severity issues open
- [ ] Phase status updated in \`playbook/current-phase.json\`

\`\`\`bash
# Update phase status
cat playbook/current-phase.json | python -c "
import json, sys
phase = json.load(sys.stdin)
phase['current_phase'] = '04-core-implementation'
phase['status'] = 'complete'
json.dump(phase, sys.stdout, indent=2)
" > playbook/current-phase.json.tmp && mv playbook/current-phase.json.tmp playbook/current-phase.json
\`\`\`

## Next Phase

Upon completion, proceed to [Phase 05: Advanced Features](./05-advanced-features.md) which covers GPU-optimized training on AWS, model monitoring, automated retraining triggers, and production hardening.`,

  'playbook/phases/05-integration-hardening.md': `# Phase 05 — Integration & Hardening

## Overview

Integration & Hardening connects all ML pipeline components into a cohesive, production-ready system. This phase wires together data ingestion, feature engineering, model training, evaluation, and serving into a single reproducible DVC pipeline. It stress-tests the end-to-end flow, hardens security boundaries, validates GDPR and SOC 2 compliance controls, and ensures the system degrades gracefully under failure conditions.

**Duration**: 1–2 sprints (depending on pipeline complexity)
**Phase Gate Owner**: ML Engineering Lead
**Prerequisites**: Phase 04 (Feature Build) substantially complete — individual pipeline stages implemented and unit-tested

---

## Objectives

### 1. End-to-End Pipeline Integration
- Wire all DVC pipeline stages (\`data/\`, \`features/\`, \`train/\`, \`evaluate/\`, \`register/\`) into a single \`dvc.yaml\` DAG
- Verify \`dvc repro\` executes the full pipeline from raw data to registered model without manual intervention
- Confirm MLflow experiment tracking captures all stages: data hash, feature config, hyperparameters, metrics, model artifacts
- Validate that pipeline configs in \`configs/\` (YAML + Pydantic) propagate correctly through every stage

### 2. API ↔ Model Integration
- Connect FastAPI serving layer (\`src/serving/\`) to MLflow Model Registry for model loading
- Test inference pipeline end-to-end: request → preprocessing → model forward pass → postprocessing → response
- Validate batch inference endpoint processes large payloads correctly
- Confirm Redis feature cache integrates with the serving layer for low-latency lookups

### 3. Infrastructure Integration
- Verify Docker builds produce working images for training and serving
- Test Kubernetes deployment manifests against staging cluster
- Confirm Terraform-managed AWS resources (S3, ECR, ECS, SageMaker) are accessible from pipeline code
- Validate GPU-accelerated training works on EC2 GPU instances and SageMaker

### 4. Hardening & Resilience
- Add retry logic, circuit breakers, and graceful degradation to serving endpoints
- Implement health checks (\`/health\`, \`/ready\`) with dependency verification (PostgreSQL, Redis, MLflow, model loaded)
- Stress-test the inference API under concurrent load
- Validate pipeline recovery: restart \`dvc repro\` after mid-pipeline failure without data corruption

### 5. Security & Compliance Hardening
- Audit all sensitive paths: \`configs/production/**\`, \`models/**\`, \`.env*\`, \`data/**\`
- Verify GDPR controls: data anonymization in feature engineering, consent tracking in metadata, right-to-deletion pipeline
- Validate SOC 2 controls: model artifact integrity (checksums), access logging, secrets management (no plaintext credentials)
- Run dependency vulnerability scan with \`uv pip audit\` or equivalent
- Confirm CODEOWNERS enforces review requirements on protected paths

### 6. Observability Integration
- Connect Prometheus metrics from FastAPI serving (request latency, throughput, error rate, model version)
- Add ML-specific metrics: prediction distribution drift, feature value distributions, inference latency per model version
- Verify Grafana dashboards render pipeline health, model performance, and infrastructure metrics
- Confirm MLflow UI accessible and populated with experiment history

---

## Deliverables

| # | Deliverable | Format | Owner |
|---|-------------|--------|-------|
| 1 | Integrated \`dvc.yaml\` pipeline (all stages wired) | \`dvc.yaml\`, \`params.yaml\` | ML Engineer |
| 2 | End-to-end pipeline smoke test | \`tests/integration/test_pipeline_e2e.py\` | ML Engineer |
| 3 | FastAPI ↔ MLflow integration tests | \`tests/integration/test_serving_integration.py\` | ML Engineer |
| 4 | Load test results and analysis | \`docs/load-test-results.md\` | ML Engineer |
| 5 | Security audit checklist (completed) | \`docs/security-audit.md\` | Lead |
| 6 | GDPR compliance verification | \`docs/gdpr-compliance.md\` | Lead |
| 7 | Prometheus + Grafana dashboard configs | \`configs/monitoring/\` | ML Engineer |
| 8 | Docker Compose for local full-stack testing | \`docker-compose.yml\` | ML Engineer |
| 9 | Failure recovery runbook | \`docs/runbooks/pipeline-recovery.md\` | ML Engineer |
| 10 | Updated architecture diagram with integration points | \`docs/architecture.md\` | Lead |

---

## Tasks

### Pipeline Integration

- [ ] Finalize \`dvc.yaml\` with all stages and dependencies
- [ ] Verify \`dvc repro\` runs clean from empty cache
- [ ] Verify \`dvc repro\` correctly skips unchanged stages (caching)
- [ ] Confirm \`params.yaml\` and \`configs/*.yaml\` are tracked as DVC dependencies
- [ ] Validate MLflow run hierarchy: parent run (pipeline) → child runs (stages)
- [ ] Test DVC remote push/pull to S3 (\`dvc push\`, \`dvc pull\`)
- [ ] Verify model registration in MLflow Model Registry with stage transitions (Staging → Production)

### Serving Integration

- [ ] Implement model loading from MLflow Registry in \`src/serving/inference.py\`
- [ ] Add model version selection logic (latest Production stage, or specific version via config)
- [ ] Wire Redis feature cache into preprocessing pipeline
- [ ] Test single-request inference end-to-end
- [ ] Test batch inference endpoint with payloads of 1, 100, 1000+ records
- [ ] Add request/response validation with Pydantic models
- [ ] Implement graceful model reload without downtime (hot-swap)

### Infrastructure Integration

- [ ] Build and test training Docker image: \`docker build -f Dockerfile.train .\`
- [ ] Build and test serving Docker image: \`docker build -f Dockerfile.serve .\`
- [ ] Run \`docker-compose up\` for full local stack (API + PostgreSQL + Redis + MLflow)
- [ ] Verify Terraform plan for staging environment
- [ ] Test GPU training on EC2 instance or SageMaker training job
- [ ] Push images to ECR and deploy to ECS staging

### Hardening

- [ ] Add retry with exponential backoff on MLflow API calls
- [ ] Add circuit breaker on Redis cache (fallback to direct computation)
- [ ] Implement request timeout on inference endpoint (configurable via Pydantic config)
- [ ] Add rate limiting to public API endpoints
- [ ] Test pipeline recovery: kill training mid-epoch, restart \`dvc repro\`
- [ ] Test serving under model-not-found condition (graceful 503)
- [ ] Validate all error responses follow consistent JSON schema

### Security & Compliance

- [ ] Verify no secrets in code, configs, or DVC-tracked files
- [ ] Confirm AWS credentials use IAM roles (not access keys) in production
- [ ] Validate model artifact checksums on load (SOC 2 integrity)
- [ ] Audit PostgreSQL access: MLflow backend uses dedicated service account
- [ ] Verify data anonymization in \`src/data/preprocessing.py\` for PII fields
- [ ] Test right-to-deletion endpoint or script for GDPR compliance
- [ ] Run \`uv run ruff check src/ --select S\` (security-related lint rules)
- [ ] Review CODEOWNERS coverage for \`configs/production/**\`, \`models/**\`, \`.env*\`

### Observability

- [ ] Add Prometheus instrumentation to FastAPI app (\`prometheus-fastapi-instrumentator\`)
- [ ] Export custom metrics: \`ml_prediction_latency_seconds\`, \`ml_model_version_info\`, \`ml_prediction_count_total\`
- [ ] Add prediction distribution logging for drift detection
- [ ] Configure Grafana dashboard JSON for ML pipeline monitoring
- [ ] Verify MLflow experiment data is queryable for model comparison
- [ ] Add structured logging (JSON format) across all pipeline stages

---

## Quality Gates

All gates must pass before advancing to Phase 06 (Launch Prep).

### Gate 1: Pipeline Reproducibility
\`\`\`bash
# Full pipeline runs without error from clean state
dvc repro

# Pipeline outputs match expected checksums
dvc status  # Should show no changes after clean repro

# MLflow has complete experiment record
# Verify via MLflow UI or API: all params, metrics, artifacts logged
\`\`\`
- **Criteria**: \`dvc repro\` completes successfully. All stages produce deterministic outputs (given same data + config). MLflow experiment contains complete lineage.

### Gate 2: Test Suite Green
\`\`\`bash
# All checks pass
uv run ruff check src/ tests/
uv run ruff format --check src/ tests/
uv run mypy src/ --strict
uv run pytest tests/ -v --cov=src --cov-report=term-missing
\`\`\`
- **Criteria**: Zero lint errors. Zero type errors. All tests pass. Coverage ≥ 75%.

### Gate 3: Integration Tests Pass
\`\`\`bash
# Integration tests require running services (use docker-compose)
docker-compose up -d postgres redis mlflow
uv run pytest tests/integration/ -v --timeout=120
\`\`\`
- **Criteria**: All integration tests pass. End-to-end pipeline test completes. Serving integration test returns valid predictions.

### Gate 4: Load Test Acceptable
\`\`\`bash
# Run load test against staging serving endpoint
locust -f tests/load/locustfile.py --headless -u 50 -r 10 --run-time 5m
\`\`\`
- **Criteria**: p50 latency < 100ms, p99 latency < 500ms for single inference. Error rate < 0.1% under 50 concurrent users. No memory leaks over 5-minute sustained load.

### Gate 5: Security & Compliance
- [ ] No high/critical vulnerabilities in dependency scan
- [ ] No secrets detected in codebase (run \`trufflehog\` or equivalent)
- [ ] GDPR data handling documented and verified
- [ ] SOC 2 model integrity controls in place (artifact checksums, access logs)
- [ ] CODEOWNERS file covers all sensitive paths
- [ ] All production configs require review from \`@ml-pipeline/leads\`

### Gate 6: Observability Verified
- [ ] Prometheus scrapes metrics from serving endpoint
- [ ] Grafana dashboard shows request rate, latency, error rate, model version
- [ ] MLflow UI displays all experiments with searchable parameters
- [ ] Structured logs parseable by log aggregation system
- [ ] Alerting rules defined for: serving errors > 1%, latency p99 > 1s, model staleness > 7 days

### Gate 7: Documentation Complete
- [ ] \`docs/architecture.md\` updated with integration diagram
- [ ] \`docs/runbooks/pipeline-recovery.md\` written and reviewed
- [ ] \`docs/runbooks/model-rollback.md\` written and reviewed
- [ ] API documentation auto-generated from FastAPI OpenAPI spec
- [ ] \`README.md\` updated with full local development and deployment instructions

---

## Integration Test Checklist

These tests validate cross-component behavior that unit tests cannot cover:

| Test | Components | Validates |
|------|-----------|-----------|
| \`test_pipeline_e2e\` | DVC + PyTorch + MLflow | Full training pipeline produces registered model |
| \`test_serve_registered_model\` | FastAPI + MLflow Registry | API loads model from registry and returns predictions |
| \`test_feature_cache_hit\` | FastAPI + Redis | Cached features served without recomputation |
| \`test_feature_cache_miss\` | FastAPI + Redis + PostgreSQL | Cache miss triggers feature computation and caching |
| \`test_batch_inference\` | FastAPI + PyTorch | Batch endpoint processes N records correctly |
| \`test_model_hot_reload\` | FastAPI + MLflow | New model version loaded without restart |
| \`test_health_check_deps\` | FastAPI + PostgreSQL + Redis | Health endpoint reports dependency status |
| \`test_data_deletion_gdpr\` | Data pipeline + PostgreSQL | User data removed from all stores on deletion request |
| \`test_artifact_integrity\` | MLflow + S3 | Model artifact checksum matches registry metadata |

---

## Failure Modes to Test

| Failure | Expected Behavior |
|---------|-------------------|
| PostgreSQL down | Health check returns 503. Serving returns cached predictions or 503. |
| Redis down | Serving falls back to direct feature computation. Latency increases, no errors. |
| MLflow down | Training logs locally, syncs on recovery. Serving uses last-loaded model. |
| S3 unreachable | \`dvc push\` fails with clear error. \`dvc repro\` uses local cache. |
| GPU OOM during training | Training catches exception, logs to MLflow, exits with non-zero code. |
| Corrupt model artifact | Checksum validation fails on load. Serving rejects model, keeps previous version. |
| Invalid input to API | Pydantic validation returns 422 with descriptive error. No model invocation. |

---

## Common Issues & Resolutions

| Issue | Resolution |
|-------|-----------|
| DVC pipeline cache invalidation | Check \`dvc.lock\` — ensure \`params.yaml\` changes trigger correct stages |
| MLflow artifact store permissions | Verify IAM role has \`s3:PutObject\`, \`s3:GetObject\` on artifact bucket |
| PyTorch model device mismatch | Ensure \`model.to(device)\` matches inference device; use \`map_location\` on \`torch.load\` |
| FastAPI startup slow (model loading) | Load model in \`lifespan\` context manager, not at import time |
| Redis connection pool exhaustion | Configure \`max_connections\` in Redis client; add connection timeout |
| Docker image too large | Use multi-stage builds; separate training (with GPU libs) from serving images |
| Type errors in Pydantic v2 | Use \`model_validator\` instead of \`validator\`; check \`ConfigDict\` migration |

---

## Phase Transition Criteria

**→ Phase 06 (Launch Prep)** when ALL of the following are true:

1. \`dvc repro\` runs end-to-end without errors on clean environment
2. \`uv run pytest tests/ --cov=src\` shows ≥ 75% coverage, all tests green
3. \`uv run ruff check src/\` and \`uv run mypy src/ --strict\` report zero errors
4. Integration tests pass against Docker Compose environment
5. Load test meets latency and error rate thresholds
6. Security audit checklist completed with no open critical/high items
7. GDPR and SOC 2 compliance controls verified and documented
8. Observability stack operational (Prometheus, Grafana, MLflow UI)
9. Runbooks written for pipeline recovery and model rollback
10. Phase 05 deliverables reviewed and approved by ML Engineering Lead

Update phase tracking:
\`\`\`bash
./playbook/codeforge-phase.sh set 6
\`\`\`

---

## References

- [Phase 04 — Feature Build](./04-feature-build.md) — prerequisite phase
- [Phase 06 — Launch Prep](./06-launch-prep.md) — next phase
- [Playbook Overview](../PLAYBOOK.md) — full methodology
- [Architecture Decision Records](../../docs/architecture.md)
- [DVC Pipeline Documentation](https://dvc.org/doc/user-guide/pipelines)
- [MLflow Model Registry](https://mlflow.org/docs/latest/model-registry.html)
- [FastAPI Testing](https://fastapi.tiangolo.com/tutorial/testing/)`,

  'playbook/phases/06-testing-quality.md': `# Phase 06 — Testing & Quality

## Overview

The Testing & Quality phase establishes comprehensive test coverage across the entire ML pipeline — from data validation and feature engineering through model training, evaluation, and serving. Unlike traditional software testing, ML pipelines require testing data integrity, model behavior, training reproducibility, and inference correctness alongside standard unit and integration tests.

This phase ensures the ml-pipeline meets the 75% coverage threshold, passes strict type checking, and validates ML-specific concerns like data drift, model performance regression, and serving latency.

## Objectives

1. **Unit test coverage** for all modules in \`src/\` — data loading, feature engineering, model architectures, training utilities, evaluation metrics, and serving endpoints
2. **Integration test coverage** for end-to-end pipeline stages — DVC pipeline steps, MLflow experiment logging, FastAPI inference endpoints
3. **ML-specific test coverage** — data validation, model output shape/range checks, training convergence smoke tests, reproducibility verification
4. **Type safety enforcement** — all public functions pass \`mypy --strict\` with no errors
5. **Linting and formatting compliance** — zero \`ruff check\` violations, \`ruff format --check\` passes
6. **Performance and reliability baselines** — inference latency benchmarks, load testing for FastAPI serving layer
7. **Security and compliance validation** — GDPR data handling tests, SOC 2 audit trail verification, model artifact integrity checks

## Deliverables

### Test Suite Structure

\`\`\`
tests/
  conftest.py                    # Shared fixtures: sample data, model configs, mock MLflow
  unit/
    data/
      test_loaders.py            # Data loading from various sources
      test_preprocessing.py      # Feature engineering transformations
      test_validation.py         # Schema validation, null checks, range checks
    models/
      test_architectures.py      # Forward pass shape checks, parameter counts
      test_layers.py             # Custom layer behavior
    training/
      test_trainer.py            # Training loop logic (mocked data)
      test_callbacks.py          # Early stopping, checkpointing, LR scheduling
      test_hyperparams.py        # Config parsing, search space validation
    evaluation/
      test_metrics.py            # Metric computation correctness
      test_comparison.py         # Model comparison logic
    serving/
      test_api.py                # FastAPI endpoint contracts (TestClient)
      test_inference.py          # Inference pipeline output validation
      test_batch.py              # Batch processing logic
    utils/
      test_config.py             # Pydantic config loading and validation
      test_logging.py            # Structured logging output
  integration/
    test_dvc_pipeline.py         # DVC stage execution and artifact outputs
    test_mlflow_tracking.py      # Experiment logging, model registry operations
    test_training_smoke.py       # End-to-end training on small synthetic data
    test_serving_e2e.py          # API startup, health check, prediction roundtrip
    test_data_pipeline.py        # Raw → processed → features pipeline
  ml/
    test_reproducibility.py      # Same config + seed → same metrics
    test_model_behavior.py       # Invariance, directional expectation tests
    test_data_drift.py           # Distribution shift detection
    test_model_regression.py     # Performance vs. baseline threshold
  security/
    test_gdpr_compliance.py      # PII anonymization, deletion endpoints
    test_artifact_integrity.py   # Model checksum verification
    test_auth.py                 # API authentication and authorization
\`\`\`

### Shared Fixtures (\`tests/conftest.py\`)

Provide reusable fixtures for the entire test suite:

- \`sample_dataframe\` — small synthetic DataFrame matching production schema
- \`sample_batch_tensor\` — PyTorch tensor with correct input dimensions
- \`model_config\` — Pydantic config loaded from \`configs/test/model.yaml\`
- \`training_config\` — Pydantic config for a fast training run (1 epoch, small batch)
- \`mock_mlflow\` — patched MLflow client that logs to temp directory
- \`trained_model\` — a lightweight model trained on synthetic data (session-scoped)
- \`fastapi_client\` — \`httpx.AsyncClient\` bound to the FastAPI app
- \`tmp_dvc_workspace\` — isolated temp directory with DVC initialized
- \`redis_mock\` — fakeredis instance for feature store / caching tests
- \`pg_test_db\` — test PostgreSQL database (via \`pytest-postgresql\` or Docker)

### Test Categories and Commands

| Category | Command | Purpose |
|---|---|---|
| All tests | \`uv run pytest\` | Run full suite |
| Unit only | \`uv run pytest tests/unit/ -v\` | Fast feedback loop |
| Integration | \`uv run pytest tests/integration/ -v --slow\` | Pipeline validation |
| ML tests | \`uv run pytest tests/ml/ -v --slow\` | Model behavior |
| Security | \`uv run pytest tests/security/ -v\` | Compliance checks |
| Coverage | \`uv run pytest --cov=src --cov-report=term-missing --cov-fail-under=75\` | Coverage gate |
| Type check | \`uv run mypy src/ --strict\` | Type safety |
| Lint | \`uv run ruff check src/ tests/\` | Code quality |
| Format | \`uv run ruff format --check src/ tests/\` | Style consistency |

### Specific Deliverable Files

1. **\`tests/conftest.py\`** — all shared fixtures documented above
2. **\`tests/unit/models/test_architectures.py\`** — forward pass tests for every \`nn.Module\` in \`src/models/\`
3. **\`tests/unit/serving/test_api.py\`** — full endpoint contract tests for FastAPI serving layer
4. **\`tests/unit/data/test_validation.py\`** — data schema validation, null handling, type coercion
5. **\`tests/unit/utils/test_config.py\`** — Pydantic config loading, validation errors, defaults
6. **\`tests/integration/test_training_smoke.py\`** — train 1 epoch on synthetic data, verify loss decreases
7. **\`tests/integration/test_mlflow_tracking.py\`** — log params, metrics, artifacts; query via MLflow client
8. **\`tests/integration/test_serving_e2e.py\`** — start FastAPI, load model, send prediction request, validate response
9. **\`tests/ml/test_reproducibility.py\`** — same seed + config produces identical metrics within tolerance
10. **\`tests/ml/test_model_behavior.py\`** — invariance tests, directional expectation tests
11. **\`tests/security/test_gdpr_compliance.py\`** — PII detection, anonymization verification, deletion endpoint
12. **\`configs/test/model.yaml\`** — lightweight model config for fast test execution
13. **\`configs/test/training.yaml\`** — minimal training config (1 epoch, batch_size=4, synthetic data)
14. **Updated \`pyproject.toml\`** — pytest markers, coverage config, test dependencies

## Quality Gates

All gates must pass before this phase is considered complete. Failure on any gate blocks progression to Phase 07.

### Gate 1: Lint and Format (Automated)

\`\`\`bash
uv run ruff check src/ tests/ --no-fix
uv run ruff format --check src/ tests/
\`\`\`

- **Pass criteria**: Zero violations
- **Enforcement**: GitHub Actions CI, pre-commit hook

### Gate 2: Type Safety (Automated)

\`\`\`bash
uv run mypy src/ --strict
\`\`\`

- **Pass criteria**: Zero type errors
- **Enforcement**: GitHub Actions CI
- **Notes**: All public functions in \`src/\` must have complete type annotations. Test files use \`# type: ignore\` sparingly and only with justification comments.

### Gate 3: Unit Test Coverage (Automated)

\`\`\`bash
uv run pytest tests/unit/ --cov=src --cov-report=term-missing --cov-fail-under=75
\`\`\`

- **Pass criteria**: ≥75% line coverage across \`src/\`
- **Module minimums**:
  - \`src/serving/\` — ≥85% (public-facing API)
  - \`src/data/\` — ≥80% (data integrity critical)
  - \`src/models/\` — ≥70% (architecture tests)
  - \`src/training/\` — ≥70% (training loop logic)
  - \`src/evaluation/\` — ≥80% (metric correctness)
  - \`src/utils/\` — ≥75% (shared utilities)

### Gate 4: Integration Tests Pass (Automated)

\`\`\`bash
uv run pytest tests/integration/ -v --slow
\`\`\`

- **Pass criteria**: All integration tests pass
- **Infrastructure**: Requires Docker (PostgreSQL, Redis), MLflow server, DVC initialized
- **Timeout**: Individual test timeout of 120 seconds; suite timeout of 10 minutes

### Gate 5: ML-Specific Tests Pass (Automated)

\`\`\`bash
uv run pytest tests/ml/ -v --slow
\`\`\`

- **Pass criteria**: All ML behavior tests pass
- **Reproducibility**: Given identical config and seed, metrics must match within \`atol=1e-5\`
- **Model behavior**: Invariance tests and directional expectation tests pass
- **Regression**: Model performance on test split meets minimum threshold defined in \`configs/test/thresholds.yaml\`

### Gate 6: Training Smoke Test (Automated)

\`\`\`bash
uv run pytest tests/integration/test_training_smoke.py -v
\`\`\`

- **Pass criteria**:
  - Training completes without error on synthetic data
  - Loss decreases between epoch 0 and epoch 1
  - Model checkpoint is saved to expected path
  - MLflow run is logged with params, metrics, and artifacts
  - DVC pipeline stage produces expected outputs

### Gate 7: Serving Endpoint Tests (Automated)

\`\`\`bash
uv run pytest tests/unit/serving/ tests/integration/test_serving_e2e.py -v
\`\`\`

- **Pass criteria**:
  - \`GET /health\` returns 200 with model version info
  - \`POST /predict\` returns valid prediction schema
  - \`POST /predict/batch\` handles batch requests correctly
  - Invalid input returns 422 with Pydantic validation errors
  - Response latency < 100ms for single prediction (p95, on CPU)
  - Model loading from MLflow registry succeeds

### Gate 8: Security and Compliance Tests (Automated)

\`\`\`bash
uv run pytest tests/security/ -v
\`\`\`

- **Pass criteria**:
  - No PII present in logged MLflow artifacts or metrics
  - Data anonymization functions correctly mask sensitive fields
  - GDPR deletion endpoint removes user data from all stores (PostgreSQL, Redis, S3)
  - Model artifact checksums match registry metadata (SOC 2 integrity)
  - API authentication rejects unauthenticated requests
  - Audit log entries created for model deployments and data access

### Gate 9: No Sensitive Data in Tests (Manual + Automated)

- **Pass criteria**:
  - No real production data in \`tests/\` or \`fixtures/\`
  - All test data is synthetic or properly anonymized
  - No API keys, credentials, or secrets in test files
  - \`.env.test\` uses dummy values only
- **Enforcement**: \`ruff\` custom rules + manual review

### Gate 10: Documentation (Manual Review)

- **Pass criteria**:
  - \`docs/testing.md\` documents how to run each test category
  - \`docs/testing.md\` documents how to add new tests for each module
  - Test files include docstrings explaining what is being tested and why
  - Fixtures are documented with usage examples
  - ML test rationale is documented (why specific invariance/behavior tests exist)

## ML-Specific Testing Patterns

### Data Validation Tests

Verify data pipeline outputs at each stage:

\`\`\`python
def test_raw_data_schema(sample_raw_data: pd.DataFrame) -> None:
    """Raw data matches expected schema from data contract."""
    assert set(sample_raw_data.columns) >= REQUIRED_COLUMNS
    assert sample_raw_data["user_id"].dtype == "int64"
    assert sample_raw_data["timestamp"].dtype == "datetime64[ns]"
    assert sample_raw_data["user_id"].notna().all()

def test_feature_ranges(sample_features: pd.DataFrame) -> None:
    """Engineered features are within expected ranges."""
    assert sample_features["normalized_score"].between(0, 1).all()
    assert sample_features["log_frequency"].ge(0).all()
\`\`\`

### Model Architecture Tests

Verify forward pass shapes and parameter counts:

\`\`\`python
def test_model_forward_pass(model_config: ModelConfig) -> None:
    """Model produces correct output shape for given input."""
    model = build_model(model_config)
    batch = torch.randn(4, model_config.input_dim)
    output = model(batch)
    assert output.shape == (4, model_config.output_dim)

def test_model_no_nan_output(model_config: ModelConfig) -> None:
    """Model does not produce NaN outputs for valid input."""
    model = build_model(model_config)
    batch = torch.randn(8, model_config.input_dim)
    output = model(batch)
    assert not torch.isnan(output).any()
\`\`\`

### Reproducibility Tests

Verify deterministic training:

\`\`\`python
def test_training_reproducibility(training_config: TrainingConfig) -> None:
    """Identical config and seed produce identical metrics."""
    metrics_a = run_training(training_config, seed=42)
    metrics_b = run_training(training_config, seed=42)
    assert abs(metrics_a["loss"] - metrics_b["loss"]) < 1e-5
    assert abs(metrics_a["accuracy"] - metrics_b["accuracy"]) < 1e-5
\`\`\`

### Model Behavior Tests

Verify expected model behavior without checking exact values:

\`\`\`python
def test_directional_expectation(trained_model: nn.Module) -> None:
    """Increasing feature X should increase prediction score."""
    base_input = torch.tensor([[1.0, 0.5, 0.3]])
    modified_input = torch.tensor([[2.0, 0.5, 0.3]])  # Increase feature 0
    base_score = trained_model(base_input).item()
    modified_score = trained_model(modified_input).item()
    assert modified_score > base_score

def test_invariance(trained_model: nn.Module) -> None:
    """Prediction should not change for irrelevant feature perturbation."""
    base_input = torch.tensor([[1.0, 0.5, 0.3]])
    perturbed_input = torch.tensor([[1.0, 0.5, 0.31]])  # Tiny change to noise feature
    base_score = trained_model(base_input).item()
    perturbed_score = trained_model(perturbed_input).item()
    assert abs(base_score - perturbed_score) < 0.01
\`\`\`

## CI Integration

Tests run in GitHub Actions across multiple stages:

\`\`\`yaml
# Relevant stages from .github/workflows/ci.yml
jobs:
  lint:
    - uv run ruff check src/ tests/
    - uv run ruff format --check src/ tests/

  type-check:
    - uv run mypy src/ --strict

  unit-tests:
    - uv run pytest tests/unit/ --cov=src --cov-fail-under=75 -v

  integration-tests:
    needs: [lint, type-check, unit-tests]
    services: [postgres, redis]
    - uv run pytest tests/integration/ -v --slow

  ml-tests:
    needs: [unit-tests]
    - uv run pytest tests/ml/ -v --slow

  train-smoke-test:
    needs: [integration-tests]
    - uv run pytest tests/integration/test_training_smoke.py -v

  security-tests:
    needs: [unit-tests]
    - uv run pytest tests/security/ -v
\`\`\`

## pytest Configuration

Defined in \`pyproject.toml\`:

\`\`\`toml
[tool.pytest.ini_options]
testpaths = ["tests"]
markers = [
    "slow: marks tests as slow (deselect with '-m \\"not slow\\"')",
    "integration: integration tests requiring external services",
    "ml: ML-specific behavior and reproducibility tests",
    "gpu: tests requiring GPU (deselect for CPU-only CI)",
    "security: security and compliance tests",
]
asyncio_mode = "auto"
filterwarnings = ["ignore::DeprecationWarning"]
\`\`\`

## Pytest Markers Usage

- **Default CI run**: \`uv run pytest -m "not slow and not gpu"\` — fast feedback
- **Full CI run**: \`uv run pytest -m "not gpu"\` — all non-GPU tests
- **GPU CI run**: \`uv run pytest -m gpu\` — GPU-specific tests on GPU runners
- **Local development**: \`uv run pytest tests/unit/ -x -v\` — stop on first failure

## Common Pitfalls

1. **Testing with real data** — always use synthetic fixtures; never commit production data to the repo
2. **Non-deterministic tests** — set \`torch.manual_seed()\`, \`numpy.random.seed()\`, and \`torch.use_deterministic_algorithms(True)\` in fixtures
3. **Slow test suites** — mark slow tests with \`@pytest.mark.slow\`; keep unit tests under 1 second each
4. **Testing model accuracy** — test behavior and contracts, not exact metric values (those change with data)
5. **Ignoring type errors** — fix the types rather than adding \`# type: ignore\`; strict mypy catches real bugs
6. **Missing edge cases** — test empty batches, single-sample batches, NaN inputs, extreme values
7. **Flaky integration tests** — use retries for external service tests; ensure proper teardown

## Phase Completion Checklist

- [ ] All test files created per deliverables list
- [ ] \`tests/conftest.py\` provides all shared fixtures
- [ ] \`uv run ruff check src/ tests/\` — zero violations
- [ ] \`uv run ruff format --check src/ tests/\` — passes
- [ ] \`uv run mypy src/ --strict\` — zero errors
- [ ] \`uv run pytest tests/unit/ --cov=src --cov-fail-under=75\` — passes
- [ ] \`uv run pytest tests/integration/ --slow\` — all pass
- [ ] \`uv run pytest tests/ml/ --slow\` — all pass
- [ ] \`uv run pytest tests/security/\` — all pass
- [ ] Training smoke test completes successfully
- [ ] FastAPI serving endpoints tested end-to-end
- [ ] No real data or secrets in test files
- [ ] \`docs/testing.md\` written and reviewed
- [ ] GitHub Actions CI runs all test stages
- [ ] PR approved by at least 1 reviewer

## Next Phase

Upon completion, proceed to [Phase 07 — Deployment & Launch](./07-deployment-launch.md) to deploy the tested pipeline to staging and production environments on AWS.`,

  'playbook/phases/07-launch.md': `# Phase 07 — Launch & Operations

## Objective

Deploy the ml-pipeline to production with full observability, automated model retraining, rollback capabilities, and operational runbooks. Ensure the system meets SOC 2 operational requirements and GDPR data handling obligations under real production load.

## Entry Criteria

- [ ] Phase 06 (Testing & Quality) quality gates passed
- [ ] All tests passing: \`uv run pytest --cov=src --cov-fail-under=75\`
- [ ] Type checking clean: \`uv run mypy src/ --strict\`
- [ ] Linting clean: \`uv run ruff check src/ tests/\`
- [ ] Integration tests passing against staging environment
- [ ] Model performance validated on holdout set via MLflow metrics
- [ ] Security audit completed on Docker images and dependencies
- [ ] DVC pipeline fully reproducible: \`dvc repro\` succeeds end-to-end
- [ ] Staging deployment stable for ≥48 hours with synthetic traffic

## Deliverables

### 1. Production Infrastructure

- **Terraform modules finalized** for AWS resources (ECS/EKS, S3, ECR, RDS PostgreSQL, ElastiCache Redis, GPU EC2 instances)
- **Docker images** built, scanned, and pushed to ECR with immutable tags
- **Kubernetes manifests** or ECS task definitions for:
  - FastAPI model serving (\`src/serving/\`) — autoscaling configured
  - MLflow tracking server — backed by PostgreSQL + S3 artifact store
  - Redis feature store / inference cache
  - Batch inference workers
- **GPU instance configuration** for on-demand training jobs via SageMaker or EC2

### 2. Model Deployment Pipeline

- **GitHub Actions production workflow** (\`.github/workflows/deploy-production.yml\`):
  - Triggered on merge to \`main\` after staging validation
  - Builds Docker image → pushes to ECR → deploys to ECS/EKS
  - Runs smoke test against production endpoint
  - Registers model version in MLflow Model Registry with \`Production\` stage
- **Blue-green or canary deployment** for FastAPI serving endpoints
- **A/B testing infrastructure** operational:
  - Traffic splitting configured (e.g., 90/10 for champion/challenger)
  - Metrics collection for both model variants
  - Automated promotion criteria defined in \`configs/production/ab_test.yaml\`

### 3. Model Retraining Automation

- **Scheduled retraining pipeline**:
  - DVC pipeline triggered on schedule or data drift detection
  - \`dvc repro\` executes full DAG: data pull → feature engineering → training → evaluation
  - New model registered in MLflow with experiment metrics
  - Automated comparison against current production model
  - Human-in-the-loop approval gate before promotion
- **Data pipeline monitoring**:
  - Schema validation on incoming data (\`src/data/validation.py\`)
  - Feature distribution drift detection
  - Alerts on data quality degradation

### 4. Observability Stack

- **Prometheus metrics** exposed from FastAPI serving:
  - \`model_prediction_latency_seconds\` (histogram)
  - \`model_prediction_total\` (counter, labeled by model version)
  - \`model_prediction_errors_total\` (counter)
  - \`feature_store_cache_hit_ratio\` (gauge)
  - \`batch_inference_duration_seconds\` (histogram)
  - \`data_drift_score\` (gauge, per feature)
- **Grafana dashboards**:
  - Model serving health (latency p50/p95/p99, throughput, error rate)
  - Model performance over time (accuracy, precision, recall from evaluation jobs)
  - Infrastructure utilization (GPU, CPU, memory, disk)
  - Data pipeline status (DVC stage completion, data freshness)
  - A/B test comparison dashboard
- **MLflow UI** accessible for experiment comparison and model lineage
- **Alerting rules** in Prometheus/Grafana:
  - P95 latency > 200ms for inference endpoint
  - Error rate > 1% over 5-minute window
  - Model prediction drift > configured threshold
  - DVC pipeline failure
  - GPU utilization anomalies during training

### 5. Operational Runbooks

Create runbooks in \`docs/runbooks/\`:

- **\`docs/runbooks/model-rollback.md\`** — How to roll back to a previous model version using MLflow Model Registry stage transitions and ECS/EKS deployment rollback
- **\`docs/runbooks/retraining-failure.md\`** — Debugging failed DVC pipeline stages, MLflow experiment inspection, GPU instance issues
- **\`docs/runbooks/data-pipeline-failure.md\`** — S3 data source issues, schema validation failures, DVC remote connectivity
- **\`docs/runbooks/serving-degradation.md\`** — Scaling FastAPI instances, Redis cache issues, model loading failures
- **\`docs/runbooks/incident-response.md\`** — On-call procedures, escalation paths, communication templates
- **\`docs/runbooks/gdpr-data-request.md\`** — Handling data subject access requests, right to deletion in training data and model artifacts

### 6. Compliance & Security Operations

- **SOC 2 operational controls**:
  - Audit logging for all model deployments and data access
  - Access control reviews for MLflow, S3 buckets, production databases
  - Change management records for model promotions
  - Immutable model artifact storage with integrity checksums
- **GDPR operational procedures**:
  - Data subject request handling workflow
  - Training data lineage tracking via DVC + MLflow
  - Anonymization verification in production data pipelines
  - Data retention policy enforcement (automated cleanup scripts in \`scripts/\`)
  - Consent tracking integration for training data sources
- **Model artifact integrity**:
  - SHA-256 checksums for all model files in MLflow artifact store
  - Signed model metadata linking to training experiment and data version
  - DVC lock file (\`dvc.lock\`) committed for full reproducibility

### 7. Documentation Updates

- **\`docs/architecture.md\`** — Updated with production topology and data flow diagrams
- **\`docs/deployment.md\`** — Step-by-step production deployment guide
- **\`docs/monitoring.md\`** — Dashboard locations, alert definitions, escalation procedures
- **\`docs/experiment-guide.md\`** — How to run experiments, track in MLflow, promote models
- **\`README.md\`** — Updated with production URLs, quick-start for new team members

## Tasks

### Infrastructure & Deployment

| # | Task | Owner | Est |
|---|------|-------|-----|
| 7.1 | Finalize Terraform for production AWS resources | Lead | 3d |
| 7.2 | Configure production Docker images with multi-stage builds | Senior | 1d |
| 7.3 | Set up ECS/EKS production cluster with GPU node group | Lead | 2d |
| 7.4 | Deploy MLflow tracking server with PostgreSQL + S3 backend | Senior | 1d |
| 7.5 | Configure Redis cluster for feature store and inference cache | Senior | 1d |
| 7.6 | Implement blue-green deployment for FastAPI serving | Senior | 2d |
| 7.7 | Set up A/B testing traffic splitting and metrics collection | Senior | 2d |

### CI/CD & Automation

| # | Task | Owner | Est |
|---|------|-------|-----|
| 7.8 | Create production deployment GitHub Actions workflow | Senior | 1d |
| 7.9 | Implement automated model retraining pipeline with DVC | Senior | 2d |
| 7.10 | Add data drift detection and alerting | Mid | 2d |
| 7.11 | Configure automated model comparison and promotion gates | Senior | 1d |
| 7.12 | Set up scheduled retraining triggers (cron or event-based) | Mid | 1d |

### Observability

| # | Task | Owner | Est |
|---|------|-------|-----|
| 7.13 | Instrument FastAPI serving with Prometheus metrics | Mid | 1d |
| 7.14 | Create Grafana dashboards (serving, training, infrastructure) | Mid | 2d |
| 7.15 | Configure alerting rules and notification channels (Slack) | Mid | 1d |
| 7.16 | Set up centralized logging (CloudWatch or ELK) | Mid | 1d |

### Operations & Compliance

| # | Task | Owner | Est |
|---|------|-------|-----|
| 7.17 | Write operational runbooks in \`docs/runbooks/\` | Senior | 2d |
| 7.18 | Implement GDPR data request handling workflow | Senior | 2d |
| 7.19 | Configure SOC 2 audit logging and access controls | Lead | 2d |
| 7.20 | Set up model artifact integrity verification | Senior | 1d |
| 7.21 | Conduct production readiness review with team | Lead | 0.5d |
| 7.22 | Execute production cutover and verify | Lead | 1d |

## Verification Commands

\`\`\`bash
# Confirm all tests still pass
uv run pytest --cov=src --cov-fail-under=75

# Confirm type checking is clean
uv run mypy src/ --strict

# Confirm linting is clean
uv run ruff check src/ tests/

# Verify DVC pipeline reproducibility
dvc repro --dry

# Verify MLflow tracking server is accessible
curl -s http://mlflow.production.internal:5000/api/2.0/mlflow/experiments/list | python -m json.tool

# Verify FastAPI serving endpoint health
curl -s http://api.production.internal/health | python -m json.tool

# Verify Prometheus metrics endpoint
curl -s http://api.production.internal/metrics | head -20

# Verify Redis connectivity
redis-cli -h redis.production.internal ping

# Verify model artifact integrity
python scripts/verify_model_integrity.py --model-uri models:/ml-pipeline-model/Production

# Run production smoke test
uv run pytest tests/smoke/ -v --env=production

# Verify Docker image is in ECR
aws ecr describe-images --repository-name ml-pipeline --image-ids imageTag=latest

# Check Grafana dashboard provisioning
curl -s http://grafana.production.internal/api/dashboards/home | python -m json.tool
\`\`\`

## Quality Gates

All gates must pass before Phase 07 is marked complete:

| # | Gate | Criteria | Verified |
|---|------|----------|----------|
| QG-7.1 | Production deployment successful | FastAPI serving endpoint returns 200 on \`/health\` | ☐ |
| QG-7.2 | MLflow tracking operational | Experiments visible in MLflow UI, model registered with \`Production\` stage | ☐ |
| QG-7.3 | Model serving under load | P95 latency < 200ms at expected throughput (load test results documented) | ☐ |
| QG-7.4 | A/B testing functional | Traffic splitting verified, metrics collected for both variants | ☐ |
| QG-7.5 | Retraining pipeline operational | \`dvc repro\` completes successfully, new model registered in MLflow | ☐ |
| QG-7.6 | Observability complete | Grafana dashboards showing live metrics, alerts firing correctly on test triggers | ☐ |
| QG-7.7 | Rollback tested | Model rollback executed successfully via MLflow stage transition + deployment | ☐ |
| QG-7.8 | Data drift detection active | Drift metrics being computed and alerts configured | ☐ |
| QG-7.9 | Runbooks reviewed | All runbooks in \`docs/runbooks/\` reviewed and approved by team | ☐ |
| QG-7.10 | SOC 2 controls verified | Audit logging active, access controls reviewed, change management documented | ☐ |
| QG-7.11 | GDPR compliance verified | Data request workflow tested, anonymization verified, retention policies active | ☐ |
| QG-7.12 | Model integrity verified | SHA-256 checksums match for production model artifacts | ☐ |
| QG-7.13 | CI/CD pipeline complete | Full pipeline (lint → test → build → deploy) executes on merge to \`main\` | ☐ |
| QG-7.14 | On-call rotation established | At least 2 team members trained on runbooks and incident response | ☐ |

## Phase Completion

Update phase tracking:

\`\`\`bash
./playbook/codeforge-phase.sh set 7 complete
\`\`\`

## Post-Launch Checklist

After production launch, within the first week:

- [ ] Monitor model prediction quality daily via MLflow and Grafana
- [ ] Review P95/P99 latency trends and adjust autoscaling if needed
- [ ] Verify data pipeline runs on schedule without manual intervention
- [ ] Confirm alerting works end-to-end (trigger a test alert via Slack)
- [ ] Conduct first retraining cycle and validate model promotion workflow
- [ ] Review access logs for any unauthorized access attempts (SOC 2)
- [ ] Process any pending GDPR data subject requests
- [ ] Schedule retrospective to capture launch learnings
- [ ] Archive experiment notebooks that informed production model decisions
- [ ] Update \`README.md\` with production endpoints and team contact info

## Notes

- GPU instances should use spot instances for training with fallback to on-demand to manage costs
- Model serving should run on CPU instances unless inference latency requires GPU acceleration
- Keep MLflow experiment naming consistent: \`{project}/{model_type}/{date}\` (e.g., \`ml-pipeline/transformer/2024-01-15\`)
- All production config changes must go through PR review — \`configs/production/**\` is a sensitive path in CODEOWNERS
- First A/B test should run for minimum 7 days before making promotion decisions
- Coordinate launch timing within Americas timezone overlap for maximum team availability`,

  'playbook/prompts/01/gather-requirements.md': `# Gather Requirements — Phase 01 Discovery Prompt

> **Copy-paste this prompt into Claude Code** at the start of Phase 01 to gather and structure requirements for your ML pipeline feature or component.

---

## Prompt

\`\`\`
I need your help gathering and structuring requirements for an ML pipeline feature in the ml-pipeline project. Follow these steps carefully:

## 1. Context Discovery

First, read these files to understand the current project state:

- \`playbook/current-phase.json\` — confirm we are in Phase 01 (Discovery)
- \`playbook/phases/01-discovery.md\` — understand phase objectives and exit criteria
- \`CLAUDE.md\` — project rules and conventions
- \`configs/\` — existing experiment configurations (YAML + Pydantic schemas)
- \`src/\` — current source tree structure
- \`dvc.yaml\` — existing DVC pipeline stages (if present)
- \`pyproject.toml\` — current dependencies and project metadata

Then check for any related GitHub Issues:
- Search for open issues tagged with the feature area
- Note any linked issues, dependencies, or blockers

## 2. Feature/Component Under Analysis

I want to build: [DESCRIBE YOUR FEATURE HERE — e.g., "a new data preprocessing pipeline for tabular features with automated feature selection and DVC tracking"]

## 3. Requirements Gathering Checklist

For the feature described above, produce a structured requirements document covering ALL of the following areas. Ask me clarifying questions if anything is ambiguous before proceeding.

### 3a. Data Requirements
- What data sources are involved? (S3 paths, database tables, APIs)
- What is the expected data volume and format? (Parquet, CSV, JSON, images)
- Are there PII or sensitive fields? (GDPR: anonymization, consent tracking, right to deletion)
- How should data be versioned? (DVC remote on S3, naming conventions)
- What preprocessing or feature engineering steps are needed?
- Are there data quality checks or validation rules? (schema validation with Pydantic)

### 3b. Model Requirements
- What model architecture(s) are involved? (PyTorch nn.Module classes in \`src/models/\`)
- What are the input/output tensor shapes and types?
- Are there pretrained weights or transfer learning requirements?
- What loss function(s) and optimizer(s) should be used?
- What are the target metrics? (accuracy, F1, AUC, RMSE, latency)
- Are there model size or inference latency constraints?

### 3c. Training Requirements
- What hyperparameters need to be configurable? (learning rate, batch size, epochs, etc.)
- Should hyperparameter tuning be included? (grid search, Optuna, Ray Tune)
- What hardware is needed? (CPU, single GPU, multi-GPU on EC2)
- How should experiments be tracked? (MLflow experiment name, run tags, artifact logging)
- What checkpointing strategy? (best model, periodic, early stopping criteria)
- What is the expected training duration and compute budget?

### 3d. Pipeline Requirements
- What DVC pipeline stages are needed? (data prep → feature engineering → train → evaluate)
- What are the stage dependencies and outputs?
- How does this integrate with existing \`dvc.yaml\` stages?
- Are there any pipeline parameters that should be in \`configs/\`?

### 3e. Serving Requirements
- Does this feature affect the FastAPI serving layer in \`src/serving/\`?
- What inference endpoint(s) are needed? (real-time, batch, streaming)
- What is the expected request/response schema? (Pydantic models)
- Are there A/B testing requirements? (model variants, traffic splitting)
- What caching strategy? (Redis feature store, prediction cache)
- What are the latency and throughput SLAs?

### 3f. Infrastructure Requirements
- Docker image changes? (new dependencies, GPU base image)
- Kubernetes deployment changes? (resource limits, autoscaling)
- Terraform changes? (new S3 buckets, SageMaker endpoints, ECR repos)
- AWS resource requirements? (instance types, storage, networking)

### 3g. Quality & Compliance Requirements
- What test coverage is needed? (unit tests for transforms, integration tests for pipeline)
- Are there SOC 2 considerations? (audit logging, access controls, model artifact integrity)
- Are there GDPR considerations? (data subject access, deletion propagation through pipeline)
- What monitoring and alerting is needed? (Prometheus metrics, Grafana dashboards, data drift)
- What documentation is needed? (experiment runbook in \`docs/\`, config documentation)

### 3h. Integration Requirements
- What existing modules in \`src/\` does this touch?
- Are there breaking changes to existing interfaces?
- What config files need to be added or modified in \`configs/\`?
- Are there MLflow model registry implications? (new model stages, aliases)

## 4. Output Format

Produce the requirements document as a Markdown file with this structure:

\`\`\`markdown
# Requirements: [Feature Name]

## Summary
[2-3 sentence description of what we're building and why]

## Data
[Structured findings from 3a]

## Model
[Structured findings from 3b]

## Training
[Structured findings from 3c]

## Pipeline
[Structured findings from 3d]

## Serving
[Structured findings from 3e]

## Infrastructure
[Structured findings from 3f]

## Quality & Compliance
[Structured findings from 3g]

## Integration Points
[Structured findings from 3h]

## Open Questions
[List anything that still needs clarification]

## Acceptance Criteria
[Numbered list of testable criteria that define "done"]

## Estimated Complexity
[Small / Medium / Large — with justification]
\`\`\`

Save this file to \`docs/requirements/[feature-name]-requirements.md\`.

## 5. After Requirements

Once the requirements document is complete:

1. List any new Python dependencies that will be needed (for review per our moderate dependency policy)
2. Identify which \`configs/\` YAML files need to be created or modified
3. Identify which DVC pipeline stages will be added or changed
4. Flag any changes to sensitive paths: \`configs/production/**\`, \`models/**\`, \`.env*\`, \`data/**\`
5. Suggest a branch name following our convention: \`feat/[TICKET]-[short-desc]\`
6. Recommend whether this should be broken into multiple PRs

Do NOT start implementation. Phase 01 is discovery only. We will move to Phase 02 (Architecture) next.
\`\`\`

---

## Usage Notes

1. **Replace the placeholder** in section 2 (\`[DESCRIBE YOUR FEATURE HERE]\`) with your actual feature description before pasting.
2. **Answer Claude's clarifying questions** — good requirements come from dialogue, not a single prompt.
3. **Review the output** and iterate. Ask Claude to dig deeper on any section that feels thin.
4. **Save the requirements doc** to \`docs/requirements/\` so it's version-controlled and referenced in later phases.
5. **Update \`playbook/current-phase.json\`** once Phase 01 exit criteria are met:
   \`\`\`bash
   ./playbook/codeforge-phase.sh advance
   \`\`\`

## Example Feature Descriptions

- "Add a transformer-based text classification model with MLflow experiment tracking and DVC-managed training data from S3"
- "Build a feature engineering pipeline for user behavioral data with automated feature selection, Redis feature store caching, and Pydantic schema validation"
- "Create a batch inference endpoint in FastAPI that loads models from MLflow registry and processes Parquet files from S3"
- "Implement data drift detection using statistical tests, with Prometheus metrics export and Grafana alerting"
- "Add hyperparameter tuning with Optuna, integrated with MLflow tracking and DVC pipeline orchestration"

## Phase 01 Exit Criteria Reminder

Before advancing to Phase 02 (Architecture), confirm:

- [ ] Requirements document saved to \`docs/requirements/\`
- [ ] All data sources and formats identified
- [ ] Model architecture and metrics defined
- [ ] DVC pipeline stages outlined
- [ ] Serving requirements (if any) documented
- [ ] GDPR and SOC 2 implications assessed
- [ ] Open questions resolved or explicitly deferred
- [ ] Acceptance criteria are testable and numbered
- [ ] Complexity estimate provided
- [ ] No implementation code written (discovery only)`,

  'playbook/prompts/01/nfr-checklist.md': `# NFR Checklist — Phase 01 Discovery Prompt

> Copy-paste this prompt into Claude Code during Phase 01 (Discovery) to generate a comprehensive Non-Functional Requirements checklist for the ml-pipeline project.

---

## Prompt

\`\`\`
I need you to generate a Non-Functional Requirements (NFR) checklist for our ML pipeline project. This is part of Phase 01 (Discovery) and will inform architecture decisions in Phase 02.

## Project Context

We are building an end-to-end ML pipeline called "ml-pipeline" with:
- **PyTorch** for model training (GPU-accelerated on AWS EC2/SageMaker)
- **MLflow** for experiment tracking and model registry
- **DVC** for data versioning and pipeline orchestration
- **FastAPI** for model serving (REST API + batch inference)
- **PostgreSQL** for metadata and MLflow backend store
- **Redis** for caching and feature store
- **AWS** infrastructure (S3, ECR, ECS, SageMaker)
- **Compliance**: SOC 2 and GDPR

## What I Need

Generate a detailed NFR checklist organized by the categories below. For each requirement:
1. Assign an ID (e.g., NFR-PERF-001)
2. Write a clear, measurable requirement statement
3. Specify acceptance criteria with concrete numbers/thresholds
4. Note the verification method (test, benchmark, audit, monitoring)
5. Flag priority as P0 (must-have), P1 (should-have), or P2 (nice-to-have)

## NFR Categories to Cover

### 1. Performance — Model Training
- Training throughput (samples/second) on target GPU instances
- GPU utilization targets during training
- Data loading pipeline throughput (no GPU starvation)
- Hyperparameter tuning job parallelism
- DVC pipeline stage execution time budgets
- MLflow logging overhead (should not degrade training speed by more than X%)

### 2. Performance — Model Serving (FastAPI)
- Single inference latency (p50, p95, p99) for the FastAPI endpoint
- Batch inference throughput (records/second)
- Cold start time for model loading into memory
- Concurrent request handling capacity
- Response payload size limits
- Redis feature cache hit rate targets

### 3. Scalability
- Maximum training dataset size supported (rows, GB)
- Horizontal scaling of FastAPI serving instances
- MLflow experiment/run storage growth projections
- S3 artifact storage scaling
- DVC remote storage capacity planning
- Concurrent training jobs on shared infrastructure

### 4. Reliability & Availability
- FastAPI serving uptime SLA (e.g., 99.9%)
- Training job checkpoint/resume on failure
- MLflow backend availability
- Graceful degradation when Redis is unavailable
- Data pipeline retry and idempotency guarantees
- Model rollback time (revert to previous model version)

### 5. Data Privacy & GDPR Compliance
- PII detection and anonymization in training data
- Right to deletion — ability to retrain without specific user data
- Data lineage tracking (which data trained which model)
- Consent tracking integration points
- Data retention policies for raw, processed, and feature data
- Cross-border data transfer controls (S3 region locking)
- Audit trail for data access and transformations

### 6. Security & SOC 2
- Authentication/authorization for FastAPI endpoints
- MLflow access controls (experiment/model permissions)
- Secrets management (AWS credentials, DB passwords, API keys)
- Model artifact integrity (signing, checksums)
- Container image scanning (ECR)
- Network segmentation (VPC, security groups)
- Encryption at rest (S3, PostgreSQL, Redis) and in transit (TLS)
- Dependency vulnerability scanning (uv audit, safety)
- Audit logging for model registry changes

### 7. Reproducibility
- Experiment reproducibility (same config → same results within tolerance)
- Random seed management across PyTorch, NumPy, CUDA
- Pinned dependency versions in pyproject.toml
- DVC pipeline determinism (hash-based caching)
- Environment reproducibility (Docker image pinning)
- Config-driven experiments (Pydantic-validated YAML)

### 8. Observability & Monitoring
- Training metrics logged to MLflow (loss, accuracy, learning rate per epoch)
- Serving metrics exported to Prometheus (latency, throughput, errors)
- Grafana dashboard requirements (training, serving, infrastructure)
- Model performance drift detection
- Data drift detection on input features
- Alerting thresholds and escalation paths
- Structured logging format (JSON) with correlation IDs

### 9. Code Quality & Maintainability
- ruff linting — zero violations on CI
- mypy strict mode — zero type errors on CI
- pytest coverage threshold: 75% minimum
- Maximum file length: 300 lines
- Type hints on all public functions
- Docstrings on all public modules, classes, and functions
- No production code in notebooks/

### 10. Operability
- Docker build time budget
- CI/CD pipeline total execution time budget
- Blue/green or canary deployment for model updates
- A/B testing infrastructure for model comparison
- Runbook documentation for common failure scenarios
- On-call rotation compatibility (Americas timezone)

## Output Format

For each category, produce a markdown table:

| ID | Requirement | Acceptance Criteria | Verification | Priority |
|----|-------------|-------------------|--------------|----------|

After the tables, add a summary section with:
- Total NFR count by priority (P0/P1/P2)
- Key risks if NFRs are not met
- Dependencies on external systems or team decisions
- Recommended Phase 02 architecture decisions driven by these NFRs

## Additional Instructions

- Be specific to our stack — reference PyTorch, MLflow, DVC, FastAPI, Pydantic, ruff, mypy, pytest, uv, AWS services by name.
- Use realistic thresholds based on production ML systems (not toy examples).
- Flag any NFRs that conflict with each other (e.g., latency vs. model complexity).
- Reference configs/production/** and models/** as sensitive paths requiring extra controls.
- All data-related NFRs must account for GDPR and SOC 2.
- Note where DVC pipeline stages or MLflow hooks can enforce NFRs automatically.

Save the output to \`docs/nfr-checklist.md\`.
\`\`\`

---

## When to Use

- **Phase**: 01 — Discovery
- **Timing**: After \`gather-requirements\` and \`user-stories\` prompts are complete
- **Input needed**: Finalized user stories, known dataset sizes, target latency SLAs from stakeholders
- **Output**: \`docs/nfr-checklist.md\` — referenced during Phase 02 (Architecture) and Phase 06 (Testing & Quality)

## Follow-Up Actions

1. Review generated NFRs with the team — adjust thresholds based on actual hardware and data
2. Map P0 NFRs to architecture constraints in Phase 02 (\`docs/architecture.md\`)
3. Create GitHub Issues for each P0 NFR that needs a dedicated implementation task
4. Add NFR verification steps to CI/CD pipeline (Phase 05 — Integration & Hardening)
5. Set up Prometheus alerts and Grafana dashboards for runtime NFRs (Phase 06)
6. Cross-reference with \`playbook/prompts/01/user-stories.md\` output to ensure coverage

## Tips

- If the team has existing SLAs or benchmarks, paste them into the prompt context for more accurate thresholds
- For GPU training NFRs, specify the target instance type (e.g., \`g5.xlarge\`, \`p3.2xlarge\`) for realistic numbers
- Run \`uv run python -c "import torch; print(torch.cuda.is_available())"\` to confirm GPU availability before setting GPU-related NFRs
- Use \`dvc metrics show\` output as a baseline for model performance NFRs if prior experiments exist`,

  'playbook/prompts/01/user-stories.md': `# User Stories Prompt — Phase 01 Discovery

> **Copy-paste this prompt into Claude Code to generate user stories from your ML pipeline requirements.**

---

## Prompt

\`\`\`
You are an ML product analyst working on the ml-pipeline project — an end-to-end machine learning pipeline using PyTorch, MLflow, DVC, and FastAPI. Your task is to generate well-structured user stories from the requirements and context provided below.

## Project Context

This is a reproducible ML pipeline for a Technology/SaaS company. The system handles:
- Data ingestion, versioning, and feature engineering (DVC + S3)
- Model training with PyTorch on GPU instances (AWS EC2/SageMaker)
- Experiment tracking and model registry (MLflow)
- Model serving via REST API and batch inference (FastAPI)
- A/B testing infrastructure for model comparison
- GDPR compliance for data handling and SOC 2 for security

The team is 2-5 ML engineers and data scientists working in Americas timezones using GitHub Flow.

## Requirements to Convert

[PASTE YOUR REQUIREMENTS HERE — these can be:]
- Feature requests or capability descriptions
- Stakeholder interview notes
- Existing system pain points
- Data pipeline specifications
- Model performance targets
- API contract requirements
- Compliance or audit requirements

## Output Format

For each user story, produce:

### Story: [SHORT-TITLE]
- **As a** [ML engineer | data scientist | API consumer | platform admin | compliance officer]
- **I want to** [specific action within the ML pipeline]
- **So that** [measurable business or technical outcome]

**Acceptance Criteria:**
1. [ ] Criterion with specific, testable condition
2. [ ] Criterion referencing concrete tools (PyTorch, MLflow, DVC, FastAPI, etc.)
3. [ ] Criterion with measurable threshold where applicable

**Technical Notes:**
- Relevant module: \`src/[data|models|training|evaluation|serving|utils]/\`
- Config: \`configs/[relevant-config].yaml\`
- Dependencies or integrations
- GDPR/SOC 2 implications if applicable

**Size Estimate:** [S | M | L | XL]
- S = < 1 day, single module change
- M = 1-3 days, touches 2-3 modules
- L = 3-5 days, cross-cutting concern or new pipeline stage
- XL = 5+ days, new subsystem or infrastructure

**Priority:** [P0-Critical | P1-High | P2-Medium | P3-Low]

---

## Story Categories to Cover

Generate stories across these ML pipeline domains:

### Data Pipeline
- Data ingestion and validation
- Feature engineering and feature store (Redis)
- Data versioning with DVC
- GDPR-compliant data handling (anonymization, consent tracking, right to deletion)

### Model Training
- PyTorch model architecture definition (\`src/models/\`)
- Training loop with checkpointing (\`src/training/\`)
- Hyperparameter tuning with experiment configs (\`configs/\`)
- GPU-accelerated training on AWS (EC2, SageMaker)
- Reproducible experiments via MLflow + DVC

### Experiment Tracking
- MLflow experiment logging (params, metrics, artifacts)
- Model registry (staging, production promotion)
- Experiment comparison and visualization
- Artifact integrity verification (SOC 2)

### Model Serving
- FastAPI inference endpoints (\`src/serving/\`)
- Batch inference pipeline
- A/B testing between model versions
- Model latency and throughput SLAs
- Redis caching for predictions

### Evaluation & Monitoring
- Offline evaluation metrics (\`src/evaluation/\`)
- Data drift detection
- Model performance monitoring (Prometheus, Grafana)
- Alerting on metric degradation

### Infrastructure & CI/CD
- Docker containerization and ECR publishing
- DVC pipeline orchestration (\`dvc repro\`)
- GitHub Actions CI (lint, type check, test, train smoke test)
- Staging and production deployment (ECS/Kubernetes)
- Terraform infrastructure management

## Constraints

- All public functions must have type hints (mypy strict)
- Pydantic models for all config validation
- Production code lives in \`src/\` — notebooks are exploration only
- All dependencies pinned in \`pyproject.toml\` (managed by uv)
- Coverage threshold: 75% minimum
- Max file length: 300 lines
- Conventional commits: feat:, fix:, chore:, docs:, experiment:
- Branch naming: type/ticket-desc (e.g., feat/ML-42-add-transformer-model)

## Guidelines

1. Each story should be independently deliverable within a single PR
2. Prefer vertical slices — a story that touches data → training → evaluation is better than "build all data loaders"
3. Include at least one acceptance criterion that references a specific command:
   - \`uv run pytest tests/\` for testing
   - \`uv run ruff check src/\` for linting
   - \`uv run mypy src/\` for type checking
   - \`dvc repro\` for pipeline reproduction
   - \`mlflow ui\` for experiment verification
4. Flag any story that touches sensitive paths: \`configs/production/**\`, \`models/**\`, \`.env*\`, \`data/**\`
5. Flag any story with GDPR implications (PII handling, data retention, consent)
6. Flag any story with SOC 2 implications (access control, audit logging, artifact integrity)
7. Group stories by pipeline domain but note cross-domain dependencies
8. For ML-specific stories, include expected metric thresholds where possible (e.g., latency < 100ms, accuracy > 0.85)
9. Size estimates should account for test coverage requirements (75% threshold)
10. Mark stories that require GPU resources for development/testing
\`\`\`

---

## Usage

1. Copy the prompt above into Claude Code
2. Replace \`[PASTE YOUR REQUIREMENTS HERE]\` with your actual requirements
3. Review generated stories for completeness across all pipeline domains
4. Adjust size estimates based on your team's velocity
5. Import stories into GitHub Issues with appropriate labels

## Example Input

\`\`\`
We need to build a text classification pipeline that:
- Ingests CSV data from S3 with customer support tickets
- Trains a transformer-based model to classify ticket priority
- Serves predictions via API with < 200ms p95 latency
- Tracks all experiments in MLflow
- Handles PII in ticket text (GDPR compliance)
- Supports A/B testing between model versions
\`\`\`

## Tips for Better Results

- **Be specific about data**: Include schema, volume, update frequency
- **Include performance targets**: Latency, throughput, accuracy baselines
- **Mention existing systems**: What does this pipeline replace or integrate with?
- **State compliance needs explicitly**: Which fields contain PII? What retention policies apply?
- **Reference model types**: Transformer, CNN, ensemble — architecture affects story sizing
- **Note GPU requirements**: Training stories on GPU instances need different infrastructure stories

## After Generation

- Review stories against \`playbook/phases/01-discovery.md\` phase checklist
- Ensure coverage across all \`src/\` subdirectories
- Verify GDPR and SOC 2 stories are present
- Create GitHub Issues and link to the discovery phase milestone
- Update \`playbook/current-phase.json\` when phase is complete`,

  'playbook/prompts/02/adr-generator.md': `# ADR Generator — Phase 02: Architecture

## Prompt for Claude Code

Copy and paste the following prompt into Claude Code during Phase 02 (Architecture) to generate Architecture Decision Records for the ml-pipeline project.

---

You are an ML systems architect working on the **ml-pipeline** project — an end-to-end machine learning pipeline using PyTorch, MLflow, DVC, and FastAPI. Generate an Architecture Decision Record (ADR) for the topic I specify.

## Project Context

- **Stack**: Python 3.11+, PyTorch, MLflow, DVC, FastAPI, PostgreSQL, Redis, AWS (SageMaker, S3, ECR, ECS, GPU instances)
- **Infrastructure**: Docker, Kubernetes, Terraform
- **Package Manager**: uv
- **Config**: Pydantic models + YAML experiment configs
- **Compliance**: SOC 2, GDPR
- **Team**: 2-5 ML engineers and data scientists, Americas timezone
- **Architecture**: DAG-based pipeline architecture with DVC orchestration

## ADR Format

Use this exact template structure:

\`\`\`markdown
# ADR-{NUMBER}: {TITLE}

## Status
Proposed | Accepted | Deprecated | Superseded by ADR-{N}

## Date
{YYYY-MM-DD}

## Context
What is the technical or organizational situation that motivates this decision?
Include ML-specific constraints: training time, GPU costs, data volume, model latency,
experiment reproducibility, compliance requirements.

## Decision Drivers
- {Driver 1 — e.g., reproducibility of experiments}
- {Driver 2 — e.g., GPU cost optimization}
- {Driver 3 — e.g., GDPR data handling requirements}
- {Driver 4 — e.g., team skill set and velocity}

## Considered Options
### Option A: {Name}
- Description: ...
- Pros: ...
- Cons: ...
- ML-specific tradeoffs: ...

### Option B: {Name}
- Description: ...
- Pros: ...
- Cons: ...
- ML-specific tradeoffs: ...

### Option C: {Name} (if applicable)
- Description: ...
- Pros: ...
- Cons: ...
- ML-specific tradeoffs: ...

## Decision
We chose **Option {X}** because {rationale tied to decision drivers}.

## Consequences

### Positive
- ...

### Negative
- ...

### Risks & Mitigations
| Risk | Likelihood | Impact | Mitigation |
|------|-----------|--------|------------|
| ...  | ...       | ...    | ...        |

## Implementation Notes
- Affected directories/files in the ml-pipeline project
- Migration steps if replacing existing approach
- Configuration changes (Pydantic models, YAML configs, DVC pipelines)
- Verification: how to confirm the decision is correctly implemented

## Compliance Impact
- **SOC 2**: {impact on audit trail, access controls, change management}
- **GDPR**: {impact on data handling, PII, consent, right to deletion}

## Related
- Links to other ADRs, GitHub Issues, or docs/
\`\`\`

## Key ADR Topics for ml-pipeline

When I ask you to generate an ADR, it will be one of these or similar:

1. **ADR-001: PyTorch as ML Framework** — Why PyTorch over TensorFlow, JAX, or scikit-learn for the primary training framework
2. **ADR-002: MLflow for Experiment Tracking and Model Registry** — Why MLflow over Weights & Biases, Neptune, or custom tracking
3. **ADR-003: DVC for Data Versioning and Pipeline Orchestration** — Why DVC over Pachyderm, LakeFS, or git-lfs + Makefiles
4. **ADR-004: FastAPI for Model Serving** — Why FastAPI over TorchServe, Triton, BentoML, or SageMaker endpoints
5. **ADR-005: Feature Store Architecture** — Redis-based feature store vs. Feast vs. Tecton vs. custom PostgreSQL
6. **ADR-006: Experiment Configuration Management** — Pydantic + YAML vs. Hydra vs. gin-config vs. pure dataclasses
7. **ADR-007: Model Artifact Storage Strategy** — S3 + DVC vs. MLflow artifact store vs. model registry patterns
8. **ADR-008: GPU Training Infrastructure** — EC2 GPU instances vs. SageMaker Training Jobs vs. Kubernetes GPU pods
9. **ADR-009: Data Pipeline Architecture** — DVC DAG vs. Airflow vs. Prefect vs. Dagster for pipeline orchestration
10. **ADR-010: A/B Testing Infrastructure** — Custom FastAPI routing vs. AWS CloudWatch Evidently vs. LaunchDarkly
11. **ADR-011: Hyperparameter Tuning Strategy** — Optuna vs. Ray Tune vs. SageMaker HPO vs. manual grid search
12. **ADR-012: Model Monitoring and Drift Detection** — Evidently AI vs. custom metrics vs. SageMaker Model Monitor
13. **ADR-013: Database Selection for Metadata** — PostgreSQL vs. MySQL vs. SQLite for MLflow backend and app metadata
14. **ADR-014: Container Strategy** — Single multi-stage Dockerfile vs. separate training/serving images
15. **ADR-015: GDPR-Compliant Data Handling** — Anonymization pipeline, consent tracking, data deletion workflows

## Rules for Generation

1. **Be specific to ml-pipeline** — reference actual directories (\`src/models/\`, \`configs/\`, \`data/\`), actual tools (\`uv run pytest\`, \`dvc repro\`, \`mlflow ui\`), and actual team constraints
2. **Include ML-specific tradeoffs** — training throughput, inference latency, GPU memory, experiment reproducibility, model versioning, data lineage
3. **Include cost analysis** where relevant — GPU instance costs, managed service pricing, storage costs for model artifacts and datasets
4. **Reference compliance** — every ADR must address SOC 2 and GDPR implications even if minimal
5. **Be opinionated** — make a clear decision with strong rationale, don't hedge
6. **Include concrete implementation notes** — which files to create/modify, which Pydantic config models to define, which DVC pipeline stages to add
7. **Keep it concise** — aim for 80-150 lines per ADR, not 300+

## Output Location

Save generated ADRs to: \`docs/adr/ADR-{NUMBER}-{kebab-case-title}.md\`

Also update \`docs/adr/README.md\` with an index entry linking to the new ADR.

---

## Usage

Paste this prompt into Claude Code, then follow up with:

\`\`\`
Generate ADR-001: PyTorch as ML Framework
\`\`\`

\`\`\`
Generate ADR-006: Experiment Configuration Management
\`\`\`

\`\`\`
Generate ADRs 001 through 005 for the core technology choices
\`\`\`

\`\`\`
Generate an ADR for our decision to use Optuna for hyperparameter tuning instead of Ray Tune
\`\`\`

\`\`\`
We need to decide between SageMaker Training Jobs and self-managed EC2 GPU instances. Generate an ADR exploring both options. Our training jobs typically run 2-8 hours on a single A10G GPU with datasets up to 50GB.
\`\`\`

After generating, verify the ADR:
- References actual ml-pipeline directories and config patterns
- Includes ML-specific tradeoffs (not just generic software tradeoffs)
- Addresses both SOC 2 and GDPR compliance impact
- Has concrete implementation notes with file paths
- Decision is clear and justified against the decision drivers`,

  'playbook/prompts/02/api-design.md': `# API Design Prompt — Phase 02 (Architecture)

> Copy-paste this prompt into Claude Code to design the FastAPI model serving API and internal pipeline interfaces for ml-pipeline.

---

## Prompt

\`\`\`
You are designing the API layer for the ml-pipeline project — a production ML pipeline using PyTorch, MLflow, DVC, and FastAPI. This is Phase 02 (Architecture), so focus on interface contracts, endpoint design, and data flow — not implementation.

## Context

- **Serving framework**: FastAPI with Pydantic request/response models
- **Model registry**: MLflow Model Registry (models promoted through stages: None → Staging → Production)
- **Feature store / cache**: Redis
- **Metadata DB**: PostgreSQL (MLflow backend store)
- **Data versioning**: DVC with S3 remote
- **Auth**: API key + JWT for service-to-service
- **Compliance**: SOC 2 (audit logging on all predictions), GDPR (PII handling, right to deletion)

## What to Design

### 1. Model Serving API (FastAPI — \`src/serving/\`)

Design the REST API for real-time and batch inference:

**Core Endpoints:**
- \`POST /v1/predict\` — Single prediction (real-time, <100ms p99 target)
- \`POST /v1/predict/batch\` — Batch predictions (up to 1000 items)
- \`GET /v1/models\` — List available models and their stages (Staging, Production)
- \`GET /v1/models/{model_name}/metadata\` — Model metadata (version, metrics, lineage)
- \`POST /v1/models/{model_name}/ab-test\` — Configure A/B test between model versions
- \`GET /v1/health\` — Health check (model loaded, Redis connected, DB reachable)
- \`GET /v1/health/ready\` — Readiness probe (model warm, inference tested)

**For each endpoint, define:**
- Pydantic request model (with field types, validators, examples)
- Pydantic response model
- HTTP status codes and error responses
- Rate limiting and timeout considerations
- Audit logging fields (for SOC 2)

**Example structure for predict endpoint:**
\`\`\`python
# Request
class PredictionRequest(BaseModel):
    features: dict[str, float | int | str]
    model_name: str = "default"
    model_version: str | None = None  # None = use Production stage
    request_id: str = Field(default_factory=lambda: str(uuid4()))
    include_explanations: bool = False

# Response
class PredictionResponse(BaseModel):
    request_id: str
    model_name: str
    model_version: str
    prediction: float | list[float]
    confidence: float | None = None
    explanations: dict[str, float] | None = None
    latency_ms: float
    timestamp: datetime
\`\`\`

### 2. Internal Pipeline Interfaces

Design the Python interfaces (abstract base classes / protocols) for pipeline components in \`src/\`:

- **DataLoader protocol** (\`src/data/\`) — load raw data, apply preprocessing, output feature tensors
- **FeatureEngineer protocol** (\`src/data/\`) — transform raw features, fit/transform pattern, serializable state
- **Model protocol** (\`src/models/\`) — PyTorch nn.Module wrapper with train/predict/save/load
- **Trainer protocol** (\`src/training/\`) — training loop, checkpoint management, MLflow logging
- **Evaluator protocol** (\`src/evaluation/\`) — compute metrics, compare models, generate reports
- **InferenceEngine protocol** (\`src/serving/\`) — load model, preprocess, predict, postprocess

For each protocol, define:
- Method signatures with full type hints
- Input/output types (use PyTorch tensors, Pydantic models, or dataclasses)
- Error handling patterns (custom exception hierarchy)
- Configuration via Pydantic models loaded from YAML (\`configs/\`)

### 3. Experiment Configuration Schema

Design the Pydantic config models that map to YAML files in \`configs/\`:

\`\`\`yaml
# configs/experiment.yaml structure to validate
experiment:
  name: "transformer-v2-tuning"
  tags: {team: "ml-core", ticket: "ML-42"}
data:
  dataset: "customer_features_v3"
  dvc_remote: "s3://ml-pipeline-data"
  split_ratio: {train: 0.7, val: 0.15, test: 0.15}
  preprocessing: [...]
model:
  architecture: "transformer"
  params: {hidden_dim: 256, num_layers: 4, dropout: 0.1}
training:
  epochs: 100
  batch_size: 64
  learning_rate: 0.001
  optimizer: "adamw"
  scheduler: {type: "cosine", warmup_steps: 500}
  early_stopping: {patience: 10, metric: "val_loss", mode: "min"}
  checkpoint: {save_top_k: 3, metric: "val_loss"}
evaluation:
  metrics: ["accuracy", "f1", "auc_roc", "precision", "recall"]
  comparison_baseline: "production"
serving:
  ab_test: {enabled: true, traffic_split: {challenger: 0.1, champion: 0.9}}
\`\`\`

### 4. Error Handling & Exception Hierarchy

Design a custom exception hierarchy for the pipeline:

\`\`\`
MLPipelineError (base)
├── DataError
│   ├── DataLoadError
│   ├── DataValidationError
│   ├── FeatureEngineeringError
│   └── DataVersionError (DVC)
├── ModelError
│   ├── ModelLoadError
│   ├── ModelTrainingError
│   ├── ModelCheckpointError
│   └── ModelRegistryError (MLflow)
├── ServingError
│   ├── PredictionError
│   ├── ModelNotFoundError
│   ├── ModelNotReadyError
│   └── ABTestConfigError
├── ConfigError
│   ├── ConfigValidationError
│   └── ConfigNotFoundError
└── InfrastructureError
    ├── RedisConnectionError
    ├── DatabaseConnectionError
    └── S3AccessError
\`\`\`

Map these to HTTP status codes for the FastAPI layer.

### 5. A/B Testing Interface

Design the A/B testing infrastructure:
- Traffic routing logic (weighted random, user-sticky via hashing)
- Metric collection per variant (predictions, latency, business metrics)
- Statistical significance calculation endpoint
- Promotion workflow (challenger → champion via MLflow stage transition)

### 6. GDPR Compliance Endpoints

- \`DELETE /v1/data/user/{user_id}\` — Right to deletion (cascade through feature store, prediction logs)
- \`GET /v1/data/user/{user_id}/export\` — Data export (all stored data for a user)
- \`GET /v1/audit/predictions\` — Prediction audit log (SOC 2, filterable by time, model, user)

## Output Format

For each section, provide:
1. **Pydantic models** with full type annotations and validators
2. **Protocol/ABC definitions** with docstrings explaining contracts
3. **OpenAPI-compatible docstrings** for FastAPI endpoints
4. **YAML config examples** that match the Pydantic schemas
5. **Dependency diagram** showing how components connect

## Constraints

- All public functions must have type hints (mypy strict)
- Use \`snake_case\` for functions/files, \`PascalCase\` for classes, \`SCREAMING_SNAKE_CASE\` for constants
- Max 300 lines per file — split into modules
- Pydantic v2 syntax (model_validator, field_validator)
- Python 3.11+ features (type union with \`|\`, StrEnum, etc.)
- All configs validated at startup, fail fast on invalid config
- Prediction audit logs must include: request_id, timestamp, model_name, model_version, input_hash (not raw PII), output, latency, user_id (anonymized)
- Redis caching strategy for feature lookups and model predictions

## Files to Create (design docs, not implementation)

Place design artifacts in \`docs/api/\`:
- \`docs/api/serving-api.md\` — FastAPI endpoint specifications
- \`docs/api/internal-protocols.md\` — Python protocol/interface definitions
- \`docs/api/config-schema.md\` — Pydantic config model documentation
- \`docs/api/error-handling.md\` — Exception hierarchy and HTTP mapping
- \`docs/api/ab-testing.md\` — A/B testing architecture
- \`docs/api/data-flow.md\` — End-to-end data flow diagram (ASCII or Mermaid)

Do NOT write implementation code yet. This is architecture phase — define the contracts that Phase 03 (Foundation) and Phase 04 (Core Implementation) will build against.
\`\`\`

---

## When to Use

Run this prompt during **Phase 02 — Architecture** after requirements are gathered (Phase 01). The output feeds directly into:

- **Phase 03 (Foundation)**: Scaffold the Pydantic models, protocols, and FastAPI app structure
- **Phase 04 (Core Implementation)**: Implement against the defined contracts
- **Phase 06 (Testing)**: Write contract tests validating interface compliance

## Pre-Requisites

- Phase 01 artifacts: user stories, data requirements, model requirements
- \`configs/\` directory exists with example YAML structure
- \`pyproject.toml\` has FastAPI, Pydantic, MLflow, PyTorch as dependencies

## Validation Checklist

After Claude generates the design, verify:

- [ ] All endpoints have Pydantic request/response models with examples
- [ ] Protocols define clear input/output types using PyTorch tensors and Pydantic models
- [ ] Config schema covers experiment, data, model, training, evaluation, and serving
- [ ] Exception hierarchy maps cleanly to HTTP status codes (400, 404, 409, 422, 500, 503)
- [ ] GDPR endpoints handle PII deletion and export
- [ ] SOC 2 audit fields present on prediction logging
- [ ] A/B testing supports traffic splitting and metric comparison
- [ ] All type hints are mypy-strict compatible
- [ ] No file exceeds 300 lines in the proposed module layout
- [ ] Redis caching strategy is defined for features and predictions
- [ ] Health/readiness probes check all critical dependencies`,

  'playbook/prompts/02/data-model-design.md': `# Data Model Design — Phase 02 (Architecture)

## Copy-Pasteable Prompt for Claude Code

\`\`\`
I need you to design the data models for our ML pipeline project. This covers the full data lifecycle: raw ingestion schemas, feature engineering outputs, model metadata, experiment tracking records, and serving request/response contracts.

## Context

- **Project**: ml-pipeline — end-to-end ML pipeline with PyTorch, MLflow, DVC, FastAPI
- **Databases**: PostgreSQL (metadata, MLflow backend store), Redis (caching, feature store)
- **Data Versioning**: DVC with S3 remote storage
- **Config Validation**: Pydantic models everywhere
- **Compliance**: SOC 2 (audit trails, access control), GDPR (PII handling, anonymization, right to deletion)
- **Type Hints**: Required on all public functions

## What to Design

### 1. Data Pipeline Schemas (src/data/)

Define Pydantic models for each stage of the data pipeline:

- **RawDataSchema**: Schema for ingested raw data. Include data source metadata, ingestion timestamp, schema version. Flag any PII fields with a \`pii=True\` field annotation for GDPR compliance.
- **ProcessedDataSchema**: Schema after cleaning and transformation. Include lineage fields (source_hash, processing_version, dvc_ref).
- **FeatureSchema**: Schema for engineered features. Include feature names, types, statistics (mean, std, min, max), and nullability. This feeds into the Redis feature store.
- **DataSplitSchema**: Schema for train/validation/test splits. Include split ratios, random seed, stratification column, row counts, and DVC file references.

### 2. Experiment & Training Schemas (src/training/, configs/)

- **ExperimentConfig**: Pydantic model that maps to YAML config files in \`configs/\`. Include:
  - \`experiment_name: str\`
  - \`model: ModelConfig\` (architecture name, hyperparameters as dict)
  - \`data: DataConfig\` (dataset path/DVC ref, split config, preprocessing steps)
  - \`training: TrainingConfig\` (epochs, batch_size, learning_rate, optimizer, scheduler, early_stopping)
  - \`infrastructure: InfraConfig\` (device: cpu/cuda, num_gpus, mixed_precision, num_workers)
  - \`tracking: TrackingConfig\` (mlflow_experiment_name, tags, log_frequency)
- **TrainingRunRecord**: What gets logged to MLflow and PostgreSQL. Include run_id, experiment_id, git_commit_sha, config_hash, start/end timestamps, final metrics dict, model artifact URI, status enum (RUNNING, COMPLETED, FAILED, CANCELLED).
- **CheckpointSchema**: Model checkpoint metadata — epoch, step, metrics at checkpoint, file path (DVC-tracked under \`models/\`), optimizer state included (bool).

### 3. Model Registry Schemas (MLflow integration)

- **RegisteredModelSchema**: Model name, version, stage (Staging/Production/Archived), creation timestamp, description, tags, source_run_id.
- **ModelVersionSchema**: Version number, artifact URI (S3), signature (input/output schema), metrics snapshot, approval_status for SOC 2 audit trail.
- **ABTestConfig**: For A/B testing infrastructure — model_a version, model_b version, traffic_split ratio, success_metric, minimum_sample_size, start/end dates.

### 4. Serving Schemas (src/serving/)

- **PredictionRequest**: FastAPI request model. Include feature values, request_id (UUID), timestamp, optional metadata dict. Validate input shapes and types against the model's expected signature.
- **PredictionResponse**: Include request_id, predictions (list of floats or class labels), model_version, latency_ms, confidence scores if applicable.
- **BatchPredictionRequest**: List of PredictionRequest items with batch_id.
- **BatchPredictionResponse**: List of PredictionResponse items with batch_id, total_latency_ms, items_processed count.
- **HealthCheckResponse**: Model loaded (bool), model_version, last_prediction_timestamp, uptime_seconds, gpu_available (bool).

### 5. Audit & Compliance Schemas

- **AuditLogEntry**: For SOC 2 — actor (user/service), action enum (DATA_ACCESS, MODEL_DEPLOY, CONFIG_CHANGE, PREDICTION_SERVED), resource_type, resource_id, timestamp, ip_address, details dict.
- **GDPRDataRecord**: For GDPR — data_subject_id (anonymized), consent_status, data_categories list, retention_policy, deletion_request_date (optional), deletion_completed_date (optional).
- **DataLineageRecord**: Track data provenance — source_id, transformations applied (list), output_hash, dvc_commit, pipeline_stage, timestamp.

## Output Requirements

1. **File**: \`src/schemas/__init__.py\` — re-export all schemas
2. **File**: \`src/schemas/data.py\` — RawDataSchema, ProcessedDataSchema, FeatureSchema, DataSplitSchema
3. **File**: \`src/schemas/experiment.py\` — ExperimentConfig and sub-configs, TrainingRunRecord, CheckpointSchema
4. **File**: \`src/schemas/model_registry.py\` — RegisteredModelSchema, ModelVersionSchema, ABTestConfig
5. **File**: \`src/schemas/serving.py\` — PredictionRequest, PredictionResponse, Batch variants, HealthCheckResponse
6. **File**: \`src/schemas/audit.py\` — AuditLogEntry, GDPRDataRecord, DataLineageRecord
7. **File**: \`configs/example_experiment.yaml\` — Example YAML config that validates against ExperimentConfig

## Constraints

- All models must inherit from \`pydantic.BaseModel\` with \`model_config = ConfigDict(strict=True)\` where appropriate
- Use Python 3.11+ features (StrEnum, Self, type unions with \`|\`)
- Use \`datetime\` for timestamps, \`UUID\` for identifiers, \`Path\` for file references
- Add docstrings to every model class explaining its purpose and lifecycle stage
- Add \`Field(...)\` with descriptions for non-obvious fields
- Add validators where business logic requires it (e.g., split ratios must sum to 1.0, learning_rate > 0)
- Mark PII fields explicitly with \`json_schema_extra={"pii": True}\` for GDPR scanning
- Keep each file under 300 lines — split further if needed
- Pin to patterns that work with MLflow's model signature and DVC pipeline stages
- Include \`__all__\` exports in each module

## Example Config YAML Structure

The generated \`configs/example_experiment.yaml\` should look like:

\`\`\`yaml
experiment_name: "baseline-classifier-v1"
model:
  architecture: "transformer_classifier"
  hyperparameters:
    hidden_dim: 256
    num_layers: 4
    dropout: 0.1
data:
  dataset_ref: "data/processed/features_v2.parquet"
  dvc_ref: "data/processed/features_v2.parquet.dvc"
  split:
    train_ratio: 0.7
    val_ratio: 0.15
    test_ratio: 0.15
    seed: 42
    stratify_column: "label"
training:
  epochs: 50
  batch_size: 64
  learning_rate: 0.001
  optimizer: "adamw"
  scheduler: "cosine_annealing"
  early_stopping:
    patience: 5
    metric: "val_loss"
    mode: "min"
infrastructure:
  device: "cuda"
  num_gpus: 1
  mixed_precision: true
  num_workers: 4
tracking:
  mlflow_experiment_name: "baseline-classifier"
  tags:
    team: "ml-engineering"
    sprint: "ML-42"
  log_frequency: 10
\`\`\`

After generating the schemas, verify they are internally consistent:
- PredictionRequest fields align with FeatureSchema
- ExperimentConfig can round-trip to/from YAML
- TrainingRunRecord fields map to MLflow run attributes
- All enums are defined and referenced correctly

Run \`uv run mypy src/schemas/\` to confirm type correctness after generation.
\`\`\`

## When to Use This Prompt

Use this prompt during **Phase 02 — Architecture** after the API design is complete (see \`playbook/prompts/02/api-design.md\`). The data models defined here become the contract between pipeline stages:

1. \`data.py\` schemas → consumed by \`src/data/\` pipeline stages and DVC
2. \`experiment.py\` schemas → consumed by \`src/training/\` and \`configs/\` YAML files
3. \`model_registry.py\` schemas → consumed by MLflow integration and deployment scripts
4. \`serving.py\` schemas → consumed by \`src/serving/\` FastAPI endpoints
5. \`audit.py\` schemas → consumed by middleware, logging, and compliance tooling

## Follow-Up Actions

- [ ] Validate generated schemas: \`uv run mypy src/schemas/ --strict\`
- [ ] Write unit tests for validators: \`uv run pytest tests/unit/test_schemas.py\`
- [ ] Generate an ADR for schema versioning strategy (see \`playbook/prompts/02/adr-generator.md\`)
- [ ] Create DVC pipeline stage definitions that reference these schemas
- [ ] Wire ExperimentConfig into the training entrypoint in \`scripts/train.py\`
- [ ] Add schema migration plan for PostgreSQL metadata tables
- [ ] Review PII-flagged fields with the team for GDPR compliance sign-off`,

  'playbook/prompts/03/ci-pipeline.md': `# CI Pipeline Setup — Phase 03 Foundation

## Prompt for Claude Code

Copy and paste the following prompt into Claude Code to generate the CI/CD pipeline for the ml-pipeline project.

---

Set up the complete CI/CD pipeline for our Python ML project using GitHub Actions. The project uses uv as the package manager, PyTorch for training, MLflow for experiment tracking, DVC for data versioning, and FastAPI for model serving. We deploy to AWS (ECR, ECS, SageMaker).

## Requirements

### 1. Create \`.github/workflows/ci.yml\` — Main CI Pipeline

Trigger on push to \`main\` and on all pull requests. Use \`ubuntu-latest\` runners. Python 3.11. Cache uv dependencies between runs.

**Stages in order:**

1. **Lint** — Run \`uv run ruff check src/ tests/ scripts/\` and \`uv run ruff format --check src/ tests/ scripts/\`
2. **Type Check** — Run \`uv run mypy src/\` with strict mode
3. **Unit Tests** — Run \`uv run pytest tests/unit/ -v --cov=src --cov-report=xml --cov-fail-under=75\` with \`MLFLOW_TRACKING_URI=sqlite:///test_mlflow.db\` env var so tests don't hit a real MLflow server
4. **Integration Tests** — Run \`uv run pytest tests/integration/ -v -m integration\` using a PostgreSQL service container for MLflow backend and a Redis service container for the feature store cache. Only run on pushes to \`main\` or when PR has the label \`run-integration\`.
5. **Build Docker Image** — Build the serving image from \`Dockerfile.serving\` and the training image from \`Dockerfile.training\`. Tag with \`\${{ github.sha }}\` and \`latest\`. Only run if tests pass.
6. **Train Smoke Test** — Run a minimal training loop using \`uv run python scripts/train.py --config configs/smoke_test.yml --max-epochs 1 --max-batches 5\` to verify the training pipeline doesn't crash. Use the training Docker image built in the previous step.
7. **Deploy Staging** — On push to \`main\` only, push Docker images to ECR (\`\${{ secrets.AWS_ACCOUNT_ID }}.dkr.ecr.us-east-1.amazonaws.com/ml-pipeline-serving\` and \`ml-pipeline-training\`), then deploy the serving image to ECS staging cluster. Use OIDC for AWS authentication (role: \`\${{ secrets.AWS_CI_ROLE_ARN }}\`).
8. **Deploy Production** — Manual approval required via \`environment: production\`. Same ECR push + ECS deploy but to the production cluster. Only triggered from \`main\`.

**Additional CI requirements:**
- Add a job-level \`concurrency\` group per PR to cancel in-progress runs when new commits are pushed: \`concurrency: { group: ci-\${{ github.ref }}, cancel-in-progress: true }\`
- Mark AI-generated code: add a step that checks for the \`ai-generated\` label or \`🤖\` marker in changed files and posts a PR comment if AI-generated code is detected, linking to our AI code review checklist in \`docs/ai-code-review.md\`
- Set \`timeout-minutes: 30\` on the full workflow and \`timeout-minutes: 15\` on the train smoke test job

### 2. Create \`.github/workflows/dvc-pipeline.yml\` — Data Pipeline CI

Trigger on push to \`main\` when files in \`data/**\`, \`configs/**\`, \`src/data/**\`, or \`dvc.yaml\` change. Also trigger manually via \`workflow_dispatch\` with an input for \`dvc_stage\` (optional, defaults to running the full pipeline).

**Steps:**
1. Checkout with \`fetch-depth: 0\` (DVC needs git history)
2. Install uv and Python 3.11
3. Install dependencies: \`uv sync\`
4. Configure DVC remote: set S3 remote using \`dvc remote modify myremote access_key_id\` and \`secret_access_key\` from secrets, or use OIDC
5. Pull DVC data: \`dvc pull\`
6. Reproduce pipeline: \`dvc repro\` (or \`dvc repro \${{ inputs.dvc_stage }}\` if a specific stage was requested)
7. Push updated DVC artifacts: \`dvc push\`
8. If any DVC outputs changed, commit the updated \`dvc.lock\` file back to the branch

### 3. Create \`.github/workflows/model-registry.yml\` — Model Promotion

Trigger on \`workflow_dispatch\` with inputs:
- \`model_name\` (required, string)
- \`model_version\` (required, string)
- \`target_stage\` (required, choice: Staging, Production)
- \`reason\` (required, string — why this model is being promoted)

**Steps:**
1. Validate that the model exists in MLflow registry
2. Run evaluation suite against the model: \`uv run python scripts/evaluate_model.py --model-name \${{ inputs.model_name }} --model-version \${{ inputs.model_version }}\`
3. If target is Production, require that the model has passed Staging evaluation first (check MLflow tags)
4. Transition model stage in MLflow: \`uv run python scripts/promote_model.py --model-name \${{ inputs.model_name }} --model-version \${{ inputs.model_version }} --stage \${{ inputs.target_stage }}\`
5. Post a Slack notification to \`#ml-deployments\` channel with model name, version, stage, who triggered it, and the reason
6. Create a GitHub release tag: \`model/\${{ inputs.model_name }}/v\${{ inputs.model_version }}-\${{ inputs.target_stage }}\`

### 4. Create \`.github/dependabot.yml\`

Configure Dependabot for:
- \`pip\` (uv-compatible) — weekly updates, prefix commits with \`chore:\`, limit to 5 open PRs, group minor and patch updates together
- \`github-actions\` — weekly updates, prefix with \`chore:\`
- \`docker\` — weekly updates for base images

### 5. Create \`.github/CODEOWNERS\`

\`\`\`
# ML Pipeline CODEOWNERS
# Default — require review from any ML engineer
*                           @ml-pipeline/ml-engineers

# Model architectures — senior review required
src/models/**               @ml-pipeline/senior-ml
configs/production/**       @ml-pipeline/senior-ml

# Infrastructure and deployment
.github/**                  @ml-pipeline/platform
Dockerfile*                 @ml-pipeline/platform
terraform/**                @ml-pipeline/platform

# Data pipeline changes
src/data/**                 @ml-pipeline/data-scientists @ml-pipeline/ml-engineers
dvc.yaml                    @ml-pipeline/data-scientists
dvc.lock                    @ml-pipeline/data-scientists

# Serving API
src/serving/**              @ml-pipeline/ml-engineers @ml-pipeline/platform

# Sensitive configs — lead review required
.env*                       @ml-pipeline/leads
configs/production/**       @ml-pipeline/leads
\`\`\`

### 6. Create \`.github/pull_request_template.md\`

Include sections for:
- **What** — description of the change
- **Why** — link to GitHub Issue
- **Type** — checkboxes: Feature, Bug Fix, Experiment, Refactor, Infra, Docs
- **ML-Specific Checklist:**
  - [ ] Experiment tracked in MLflow with reproducible config
  - [ ] Model artifacts versioned with DVC (if applicable)
  - [ ] No data leakage between train/val/test splits
  - [ ] Metrics logged and compared against baseline
  - [ ] Config changes validated with Pydantic schema
  - [ ] No hardcoded paths, credentials, or hyperparameters
  - [ ] GDPR compliance: no PII in logs, artifacts, or model outputs
- **General Checklist:**
  - [ ] Type hints on all public functions
  - [ ] Tests added/updated (coverage ≥ 75%)
  - [ ] \`uv run ruff check\` and \`uv run mypy src/\` pass locally
  - [ ] Files under 300 lines
  - [ ] Conventional commit messages used
  - [ ] AI-generated code marked with \`🤖\` comment if applicable

## Constraints

- Use \`uv\` for all Python commands (not pip or poetry)
- Pin the GitHub Actions action versions to specific SHAs for SOC 2 supply chain security
- All secrets referenced via \`\${{ secrets.* }}\` — never hardcode credentials
- Docker images must be scanned with \`trivy\` before push to ECR
- PostgreSQL service container version should match production (PostgreSQL 15)
- Redis service container version should match production (Redis 7)
- Add \`permissions:\` blocks to every workflow with least-privilege (e.g., \`contents: read\`, \`id-token: write\` only where OIDC is needed)
- Include \`# AI-GENERATED\` comment at the top of each workflow file for traceability

## Reference

- Project structure: see \`playbook/PLAYBOOK.md\`
- Architecture decisions: see \`docs/adr/\`
- Sensitive paths defined in \`.claude/settings.json\`
- Phase 03 definition: see \`playbook/phases/03-foundation.md\``,

  'playbook/prompts/03/iac-setup.md': `# IaC Setup — Phase 03 Foundation Prompt

> Copy-paste this prompt into Claude Code to generate Infrastructure as Code for the ml-pipeline project using Terraform, Docker, and AWS services.

---

## Prompt

\`\`\`
You are setting up Infrastructure as Code (IaC) for the ml-pipeline project — an end-to-end ML pipeline using PyTorch, MLflow, DVC, and FastAPI deployed on AWS. Generate all Terraform configurations, Docker files, and Kubernetes manifests needed for development, staging, and production environments.

## Project Context

- **Project**: ml-pipeline (Python 3.11+, PyTorch, MLflow, DVC, FastAPI)
- **Cloud**: AWS (SageMaker, S3, ECR, ECS, EC2 GPU instances)
- **Orchestration**: Docker + Kubernetes (EKS)
- **IaC Tool**: Terraform (with remote state in S3 + DynamoDB locking)
- **Compliance**: SOC 2, GDPR
- **Environments**: dev, staging, production

## 1. Terraform Directory Structure

Create the following structure under \`infra/terraform/\`:

\`\`\`
infra/
  terraform/
    modules/
      networking/          # VPC, subnets, security groups, NAT gateway
      storage/             # S3 buckets (data, artifacts, MLflow, DVC remote)
      database/            # RDS PostgreSQL (MLflow backend store)
      cache/               # ElastiCache Redis (feature store, inference cache)
      compute/             # EKS cluster, node groups (CPU + GPU)
      ecr/                 # ECR repositories for Docker images
      mlflow/              # MLflow tracking server on ECS/Fargate
      monitoring/          # CloudWatch, Prometheus, Grafana setup
      iam/                 # IAM roles, policies, service accounts
    environments/
      dev/
        main.tf
        variables.tf
        terraform.tfvars
        backend.tf
      staging/
        main.tf
        variables.tf
        terraform.tfvars
        backend.tf
      production/
        main.tf
        variables.tf
        terraform.tfvars
        backend.tf
    versions.tf
\`\`\`

## 2. Terraform Modules — Requirements

### networking module
- VPC with public and private subnets across 2 AZs
- NAT gateway for private subnet internet access
- Security groups for: MLflow server, PostgreSQL, Redis, EKS nodes, FastAPI service
- VPC endpoints for S3 and ECR (cost optimization, SOC 2 — keep traffic in AWS network)

### storage module
- S3 buckets with versioning enabled:
  - \`ml-pipeline-{env}-data\` — DVC remote storage for datasets
  - \`ml-pipeline-{env}-artifacts\` — MLflow artifact store (model binaries, metrics)
  - \`ml-pipeline-{env}-terraform-state\` — Terraform remote state
- Bucket policies enforcing encryption at rest (AES-256 or KMS)
- Lifecycle rules: move old artifacts to Glacier after 90 days (production only)
- CORS configuration for MLflow UI access
- Block all public access (SOC 2)
- Enable access logging on all buckets
- GDPR: Tag buckets with \`data-classification\` and \`retention-policy\` tags

### database module
- RDS PostgreSQL 15 instance for MLflow backend store
- Multi-AZ for production, single-AZ for dev/staging
- Encrypted storage, automated backups (30-day retention for production)
- Private subnet placement, no public accessibility
- Parameter group optimized for MLflow metadata workload
- Output connection string as SSM Parameter (SecureString)

### cache module
- ElastiCache Redis 7 cluster
- Used for: feature store caching, model inference result caching, rate limiting
- Single node for dev, replica set for staging/production
- Encryption in transit and at rest
- Private subnet placement

### compute module
- EKS cluster (Kubernetes 1.28+)
- Managed node groups:
  - \`cpu-general\`: t3.large (2-5 nodes) — FastAPI serving, MLflow, general workloads
  - \`gpu-training\`: g4dn.xlarge (0-3 nodes, autoscaling) — PyTorch training jobs
- Cluster autoscaler configuration
- GPU node group should scale to zero when idle (cost optimization)
- IRSA (IAM Roles for Service Accounts) for pod-level S3/ECR access
- Install aws-load-balancer-controller, metrics-server, nvidia-device-plugin

### ecr module
- ECR repositories:
  - \`ml-pipeline/training\` — PyTorch training image
  - \`ml-pipeline/serving\` — FastAPI inference image
  - \`ml-pipeline/mlflow\` — Custom MLflow tracking server image
- Image scanning on push enabled
- Lifecycle policy: keep last 20 tagged images, expire untagged after 7 days
- Encryption with KMS

### mlflow module
- MLflow tracking server deployed on ECS Fargate (or EKS)
- Backend store: PostgreSQL (from database module)
- Artifact store: S3 (from storage module)
- Exposed via internal ALB (not public) with HTTPS
- Environment variables for DB connection via SSM Parameter Store
- Auto-scaling: 1-3 tasks based on CPU utilization
- Health check endpoint: \`/health\`

### monitoring module
- CloudWatch log groups for all services (30-day retention dev, 90-day production)
- Prometheus deployed on EKS (via Helm chart reference)
- Grafana deployed on EKS with dashboards for:
  - Model inference latency (p50, p95, p99)
  - Training job GPU utilization
  - API request rate and error rate
  - MLflow experiment count and model registry stats
- CloudWatch alarms:
  - High API error rate (>5% 5xx in 5 minutes)
  - GPU node group at max capacity
  - RDS CPU > 80%
  - S3 bucket size approaching quota

### iam module
- IAM roles with least-privilege policies:
  - \`ml-pipeline-training-role\` — S3 read/write (data + artifacts), ECR pull, CloudWatch logs
  - \`ml-pipeline-serving-role\` — S3 read (artifacts), ECR pull, Redis access, CloudWatch logs
  - \`ml-pipeline-mlflow-role\` — S3 read/write (artifacts), RDS access, CloudWatch logs
  - \`ml-pipeline-ci-role\` — ECR push, S3 read, EKS deploy (used by GitHub Actions OIDC)
- OIDC provider for GitHub Actions (no long-lived credentials — SOC 2)
- Service accounts mapped via IRSA

## 3. Docker Files

### Dockerfile.training
- Base image: \`pytorch/pytorch:2.1.0-cuda12.1-cudnn8-runtime\`
- Install project dependencies via \`uv pip install\`
- Copy \`src/\`, \`configs/\`, \`scripts/\`
- Set entrypoint to training script
- Non-root user (SOC 2)
- Multi-stage build to minimize image size
- Labels: maintainer, version, git-sha

### Dockerfile.serving
- Base image: \`python:3.11-slim\`
- Install only serving dependencies (no PyTorch CUDA — CPU inference or use ONNX)
- Copy \`src/serving/\`, \`src/models/\`, \`src/utils/\`, \`configs/\`
- Expose port 8000
- Health check: \`CMD ["curl", "-f", "http://localhost:8000/health"]\`
- Entrypoint: \`uvicorn src.serving.app:app --host 0.0.0.0 --port 8000\`
- Non-root user
- Multi-stage build

### Dockerfile.mlflow
- Base image: \`python:3.11-slim\`
- Install \`mlflow[extras]\`, \`psycopg2-binary\`, \`boto3\`
- Expose port 5000
- Entrypoint: \`mlflow server\` with backend-store-uri and artifact-root from env vars
- Health check on \`/health\`
- Non-root user

### docker-compose.yml (local development)
- Services:
  - \`postgres\`: PostgreSQL 15 (MLflow backend, port 5432)
  - \`redis\`: Redis 7 (feature cache, port 6379)
  - \`mlflow\`: MLflow tracking server (port 5000, depends on postgres)
  - \`api\`: FastAPI serving app (port 8000, depends on redis, mlflow)
- Volumes for persistent data
- Environment variables from \`.env\` file
- Network: \`ml-pipeline-network\`
- Include health checks for all services

## 4. Kubernetes Manifests

Create under \`infra/k8s/\`:

### base/
- \`namespace.yaml\` — \`ml-pipeline\` namespace with labels
- \`configmap.yaml\` — shared config (MLflow URI, Redis host, S3 bucket names)
- \`secrets.yaml\` — reference to ExternalSecrets or sealed-secrets for DB credentials

### serving/
- \`deployment.yaml\` — FastAPI deployment (2 replicas staging, 3 production)
  - Resource requests/limits (CPU: 500m/1000m, Memory: 512Mi/1Gi)
  - Readiness probe: GET /health
  - Liveness probe: GET /health
  - Environment from ConfigMap and Secrets
  - Anti-affinity: spread across AZs
- \`service.yaml\` — ClusterIP service on port 8000
- \`ingress.yaml\` — ALB ingress with HTTPS, path-based routing
- \`hpa.yaml\` — Horizontal Pod Autoscaler (CPU target 70%, min 2, max 10)

### training/
- \`job-template.yaml\` — Kubernetes Job template for training runs
  - GPU resource request: \`nvidia.com/gpu: 1\`
  - Node selector: \`node-group: gpu-training\`
  - Tolerations for GPU nodes
  - Environment: MLflow tracking URI, S3 paths, experiment config
  - Restart policy: Never (training jobs should not auto-restart)
  - Active deadline: 6 hours (prevent runaway training)
- \`cronjob.yaml\` — Scheduled retraining (weekly, configurable)

### mlflow/
- \`deployment.yaml\` — MLflow server (1 replica dev, 2 production)
- \`service.yaml\` — ClusterIP on port 5000
- \`ingress.yaml\` — Internal ALB, restricted to VPC CIDR

### monitoring/
- \`prometheus-values.yaml\` — Helm values for kube-prometheus-stack
- \`grafana-dashboards/\` — JSON dashboard definitions for ML metrics
- \`servicemonitor.yaml\` — ServiceMonitor for FastAPI metrics endpoint

## 5. Environment-Specific Configuration

### dev (terraform.tfvars)
- Smallest instance sizes, single-AZ, no GPU nodes by default
- MLflow on single Fargate task
- RDS: db.t3.micro, no Multi-AZ
- Redis: cache.t3.micro, single node
- S3: no lifecycle rules, no replication

### staging (terraform.tfvars)
- Moderate sizes, mirrors production topology at smaller scale
- GPU node group: 0-1 nodes
- RDS: db.t3.small, no Multi-AZ
- Redis: cache.t3.small, single node

### production (terraform.tfvars)
- Production-grade sizing, Multi-AZ, encryption everywhere
- GPU node group: 0-3 nodes with autoscaling
- RDS: db.r6g.large, Multi-AZ, 30-day backup retention
- Redis: cache.r6g.large, 1 replica
- S3: lifecycle rules, access logging, cross-region replication for disaster recovery
- WAF on ALB ingress
- Enhanced monitoring on all resources

## 6. Security & Compliance Requirements

### SOC 2
- All data encrypted at rest (S3 SSE-KMS, RDS encryption, Redis encryption)
- All data encrypted in transit (TLS everywhere)
- No public endpoints except through ALB with WAF (production)
- IAM least-privilege, no wildcard permissions
- Audit logging: CloudTrail, S3 access logs, RDS audit logs
- VPC flow logs enabled
- No long-lived credentials — use IRSA and OIDC
- Tag all resources with: \`project\`, \`environment\`, \`owner\`, \`compliance\`

### GDPR
- Data classification tags on all storage resources
- S3 object lock capability for retention compliance
- RDS point-in-time recovery for data subject access requests
- Document data flow in Terraform comments
- Redis: no PII in cache keys, TTL on all cached data
- Log anonymization — no PII in CloudWatch logs

## 7. Additional Files

### infra/Makefile
- Targets: \`init\`, \`plan\`, \`apply\`, \`destroy\` for each environment
- Target: \`docker-build-all\`, \`docker-push-all\`
- Target: \`k8s-apply-dev\`, \`k8s-apply-staging\`, \`k8s-apply-production\`
- Target: \`local-up\` (docker-compose up), \`local-down\`

### infra/README.md
- Prerequisites (Terraform, AWS CLI, kubectl, Docker, Helm)
- Setup instructions for each environment
- Architecture diagram (ASCII or Mermaid)
- Cost estimates per environment
- Disaster recovery procedures
- Secrets management guide

## Constraints

- Use Terraform 1.6+ with required_providers block
- Use \`for_each\` and \`count\` over copy-paste for similar resources
- All modules must have \`variables.tf\`, \`outputs.tf\`, \`main.tf\`, \`README.md\`
- Tag every AWS resource with project, environment, managed-by=terraform
- Use data sources for AMIs and availability zones (no hardcoded values)
- Remote state with S3 backend and DynamoDB locking
- Sensitive outputs marked with \`sensitive = true\`
- No hardcoded secrets anywhere — use SSM Parameter Store or Secrets Manager
- Pin all provider versions
- Include \`.terraform.lock.hcl\` in version control

Start by generating the Terraform module structure, then Docker files, then Kubernetes manifests. For each file, include inline comments explaining ML-pipeline-specific decisions. Prioritize the modules that unblock local development first (docker-compose.yml, then storage, then database, then compute).
\`\`\`

---

## Usage Notes

1. **Run from project root**: Execute this prompt in Claude Code at the \`ml-pipeline/\` directory root
2. **Prerequisites**: Ensure AWS CLI is configured and Terraform is installed (\`brew install terraform\`)
3. **Local first**: The docker-compose.yml enables immediate local development without AWS
4. **Incremental apply**: Apply Terraform modules in order — networking → storage → database → cache → compute → ecr → mlflow → monitoring
5. **Cost awareness**: Dev environment is designed to cost <$50/month; GPU nodes scale to zero when idle
6. **Sensitive paths**: Files under \`configs/production/**\` and \`.env*\` are protected — see \`.claude/settings.json\`

## Verification Checklist

After generation, verify:

- [ ] \`docker-compose up\` starts all local services (PostgreSQL, Redis, MLflow, FastAPI)
- [ ] \`terraform init\` succeeds in each environment directory
- [ ] \`terraform plan\` shows no errors for dev environment
- [ ] All S3 buckets have encryption and public access blocked
- [ ] No hardcoded secrets in any Terraform or Docker file
- [ ] GPU node group has scale-to-zero configuration
- [ ] MLflow server connects to PostgreSQL backend and S3 artifact store
- [ ] FastAPI Dockerfile uses non-root user
- [ ] All resources tagged with \`project=ml-pipeline\`, \`environment\`, \`managed-by=terraform\`
- [ ] OIDC provider configured for GitHub Actions (no AWS access keys in CI)
- [ ] Kubernetes manifests include resource limits and health checks
- [ ] GDPR data classification tags present on storage resources

## Related Prompts

- **[project-scaffold.md](./project-scaffold.md)** — Python project structure and dependency setup
- **[ci-pipeline.md](./ci-pipeline.md)** — GitHub Actions workflows that deploy using this infrastructure
- **[Phase 05 — Integration Hardening](../../phases/05-integration-hardening.md)** — Load testing and security hardening on this infra`,

  'playbook/prompts/03/project-scaffold.md': `# Phase 03 Prompt: Project Scaffold

## When to Use

Use this prompt at the start of Phase 03 (Foundation) to have Claude Code generate the complete project scaffold for the ml-pipeline project. This creates the directory structure, configuration files, base classes, and development tooling needed before core implementation begins.

Run this prompt once per project. It is idempotent — re-running will not overwrite files that already exist unless you explicitly ask.

---

## Pre-Requisites

Before running this prompt, ensure you have:

1. **Phase 01 artifacts**: User stories, requirements, NFRs documented in \`docs/requirements/\`
2. **Phase 02 artifacts**: ADRs in \`docs/adr/\`, API design in \`docs/api/\`, architecture diagrams
3. **Python 3.11+** installed locally
4. **uv** installed (\`curl -LsSf https://astral.sh/uv/install.sh | sh\`)
5. **Docker** installed and running
6. **AWS CLI** configured with appropriate credentials
7. **Git** initialized with \`main\` branch and remote set

---

## The Prompt

Copy the entire block below and paste it into Claude Code:

\`\`\`
I need you to scaffold the ml-pipeline project — an end-to-end ML pipeline using PyTorch, MLflow, DVC, and FastAPI. Generate all foundational files so the team can begin core implementation in Phase 04.

## Project Context

- Python 3.11+ with strict type hints on all public functions
- Package manager: uv (pyproject.toml, uv.lock)
- ML framework: PyTorch
- Experiment tracking: MLflow (PostgreSQL backend, S3 artifact store)
- Data versioning: DVC with S3 remote
- Model serving: FastAPI
- Config management: Pydantic models + YAML configs
- Linting: ruff | Type checking: mypy (strict) | Testing: pytest
- Coverage threshold: 75%
- Compliance: SOC 2, GDPR
- CI/CD: GitHub Actions

## Directory Structure to Create

\`\`\`
ml-pipeline/
├── src/
│   ├── __init__.py
│   ├── data/
│   │   ├── __init__.py
│   │   ├── loader.py          # Base data loading abstractions
│   │   ├── preprocessing.py   # Feature engineering pipeline
│   │   ├── validation.py      # Data quality checks (Great Expectations or custom)
│   │   └── registry.py        # Dataset registry and versioning metadata
│   ├── models/
│   │   ├── __init__.py
│   │   ├── base.py            # Abstract base model class (nn.Module subclass)
│   │   ├── registry.py        # Model registry interface (wraps MLflow)
│   │   └── factory.py         # Model factory from config
│   ├── training/
│   │   ├── __init__.py
│   │   ├── trainer.py         # Training loop with MLflow logging
│   │   ├── callbacks.py       # Early stopping, checkpointing, LR scheduling
│   │   ├── hyperparams.py     # Hyperparameter tuning (Optuna integration)
│   │   └── distributed.py     # Multi-GPU / distributed training helpers
│   ├── evaluation/
│   │   ├── __init__.py
│   │   ├── metrics.py         # Metric computation and aggregation
│   │   ├── comparison.py      # Model comparison utilities
│   │   └── reports.py         # Evaluation report generation
│   ├── serving/
│   │   ├── __init__.py
│   │   ├── app.py             # FastAPI application factory
│   │   ├── routes/
│   │   │   ├── __init__.py
│   │   │   ├── health.py      # Health check and readiness endpoints
│   │   │   ├── predict.py     # Single prediction endpoint
│   │   │   └── batch.py       # Batch inference endpoint
│   │   ├── middleware.py       # Request logging, auth, rate limiting
│   │   ├── schemas.py         # Pydantic request/response schemas
│   │   └── inference.py       # Inference pipeline (load model, preprocess, predict)
│   └── utils/
│       ├── __init__.py
│       ├── config.py          # Pydantic config models, YAML loader
│       ├── logging.py         # Structured logging setup (JSON format)
│       ├── mlflow_utils.py    # MLflow connection, experiment helpers
│       ├── aws.py             # S3, SageMaker utility functions
│       └── privacy.py         # GDPR utilities (anonymization, PII detection)
├── configs/
│   ├── base.yaml              # Base config (inherited by all experiments)
│   ├── experiment/
│   │   └── example.yaml       # Example experiment config
│   ├── serving/
│   │   ├── development.yaml
│   │   ├── staging.yaml
│   │   └── production.yaml    # SENSITIVE — restricted access
│   └── infrastructure/
│       ├── mlflow.yaml
│       └── dvc.yaml
├── tests/
│   ├── __init__.py
│   ├── conftest.py            # Shared fixtures (mock data, model stubs, DB)
│   ├── unit/
│   │   ├── __init__.py
│   │   ├── test_data_loader.py
│   │   ├── test_preprocessing.py
│   │   ├── test_base_model.py
│   │   ├── test_trainer.py
│   │   ├── test_metrics.py
│   │   └── test_config.py
│   ├── integration/
│   │   ├── __init__.py
│   │   ├── test_training_pipeline.py
│   │   ├── test_serving_api.py
│   │   └── test_mlflow_tracking.py
│   └── fixtures/
│       ├── sample_data.csv
│       └── sample_config.yaml
├── scripts/
│   ├── train.py               # CLI entry point for training
│   ├── evaluate.py            # CLI entry point for evaluation
│   ├── serve.py               # CLI entry point for serving
│   ├── download_data.py       # Data download and initial DVC setup
│   └── setup_mlflow.py        # MLflow server initialization
├── notebooks/
│   └── .gitkeep               # Exploration only — not production code
├── data/
│   ├── raw/
│   │   └── .gitkeep
│   ├── processed/
│   │   └── .gitkeep
│   └── features/
│       └── .gitkeep
├── models/
│   └── .gitkeep               # DVC-tracked model artifacts
├── docs/
│   ├── architecture.md
│   ├── experiment-guide.md
│   ├── deployment-runbook.md
│   └── data-privacy.md        # GDPR compliance documentation
├── .github/
│   ├── workflows/
│   │   ├── ci.yml             # Lint, type check, test, coverage
│   │   ├── train.yml          # Training smoke test on PR
│   │   └── deploy.yml         # Build, push, deploy pipeline
│   ├── PULL_REQUEST_TEMPLATE.md
│   ├── ISSUE_TEMPLATE/
│   │   ├── bug_report.md
│   │   ├── feature_request.md
│   │   └── experiment_proposal.md
│   └── CODEOWNERS
├── docker/
│   ├── Dockerfile.train       # Training image (GPU-capable)
│   ├── Dockerfile.serve       # Serving image (lightweight)
│   └── docker-compose.yml     # Local dev: MLflow, PostgreSQL, Redis
├── terraform/
│   └── .gitkeep               # Infrastructure as code (Phase 05+)
├── pyproject.toml
├── .pre-commit-config.yaml
├── .gitignore
├── .dvc/
│   └── config                 # DVC remote config (S3)
├── .dvcignore
├── dvc.yaml                   # DVC pipeline stages
├── dvc.lock                   # .gitkeep placeholder
├── .env.example               # Environment variable template
├── Makefile                   # Common commands
└── README.md
\`\`\`

## Specific File Requirements

### pyproject.toml
- Use uv-compatible format with [project] table
- Pin all dependency versions
- Include dependency groups: [project.optional-dependencies] for dev, test, gpu
- Configure ruff (line-length=100, target Python 3.11, select rules: E, F, I, N, UP, B, SIM, TCH)
- Configure mypy (strict=true, plugins for pydantic)
- Configure pytest (testpaths, asyncio_mode=auto, coverage settings)
- Entry points for scripts: train, evaluate, serve

### src/utils/config.py
- Define Pydantic BaseSettings and nested models for:
  - DataConfig (paths, splits, batch_size, num_workers)
  - ModelConfig (architecture name, hidden_dims, dropout, activation)
  - TrainingConfig (epochs, learning_rate, optimizer, scheduler, early_stopping)
  - ExperimentConfig (name, tags, description, seed)
  - ServingConfig (host, port, model_uri, batch_size)
  - PipelineConfig (top-level combining all above)
- YAML loading with environment variable interpolation
- Config validation with clear error messages

### src/models/base.py
- Abstract base class \`BaseModel(nn.Module)\` with:
  - Abstract methods: forward(), get_loss(), predict()
  - Concrete methods: save_checkpoint(), load_checkpoint(), count_parameters()
  - MLflow model signature generation
  - Device management (CPU/GPU)

### src/training/trainer.py
- \`Trainer\` class with:
  - Training loop with gradient accumulation support
  - MLflow auto-logging (params, metrics per epoch, artifacts)
  - Callback system (early stopping, checkpointing, LR scheduling)
  - Reproducibility: seed setting, deterministic mode
  - Progress tracking with rich or tqdm
  - Type hints on all public methods

### src/serving/app.py
- FastAPI application factory pattern
- Include health, predict, batch routes
- Startup event: load model from MLflow registry
- Middleware: request ID, logging, CORS
- OpenAPI metadata with version

### src/serving/schemas.py
- Pydantic v2 models for:
  - PredictionRequest, PredictionResponse
  - BatchPredictionRequest, BatchPredictionResponse
  - HealthResponse (status, model_version, uptime)
  - ErrorResponse

### tests/conftest.py
- Fixtures for:
  - sample_dataframe (small synthetic dataset)
  - mock_model (simple nn.Module for testing)
  - tmp_experiment_config (PipelineConfig with temp dirs)
  - mock_mlflow (patched MLflow client)
  - fastapi_client (httpx AsyncClient for API tests)
  - device fixture (cpu for CI, cuda if available)

### .github/workflows/ci.yml
- Trigger: push to main, pull_request
- Jobs: lint (ruff check + ruff format --check), typecheck (mypy src/), test (pytest with coverage), security (pip-audit or safety)
- Use uv for package installation
- Cache uv packages
- Upload coverage report
- Mark AI-generated code flag in PR comments

### .github/CODEOWNERS
- \`configs/production/**\` → @ml-pipeline/leads
- \`models/**\` → @ml-pipeline/ml-engineers
- \`.env*\` → @ml-pipeline/leads
- \`data/**\` → @ml-pipeline/data-scientists
- \`src/serving/**\` → @ml-pipeline/ml-engineers
- \`terraform/**\` → @ml-pipeline/leads
- \`.github/**\` → @ml-pipeline/leads

### docker/docker-compose.yml
- Services: mlflow-server (with PostgreSQL backend), postgres, redis, minio (S3-compatible for local dev)
- Volumes for data persistence
- Health checks on all services

### dvc.yaml
- Stages: download_data, preprocess, feature_engineering, train, evaluate
- Dependencies and outputs for each stage
- Params from configs/base.yaml
- Metrics and plots outputs

### Makefile
- Targets: install, lint, typecheck, test, test-cov, format, train, evaluate, serve, docker-up, docker-down, dvc-repro, mlflow-ui, clean
- Use uv run for all Python commands

### .env.example
- MLFLOW_TRACKING_URI, MLFLOW_S3_ENDPOINT_URL
- AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION
- POSTGRES_HOST, POSTGRES_PORT, POSTGRES_DB, POSTGRES_USER, POSTGRES_PASSWORD
- REDIS_URL
- MODEL_REGISTRY_URI
- LOG_LEVEL, ENVIRONMENT

### .gitignore
- Python defaults (__pycache__, .venv, *.egg-info, dist/)
- ML-specific: data/raw/*, data/processed/*, data/features/*, models/*.pt, models/*.onnx, *.pkl
- Keep .gitkeep files
- Environment: .env, .env.local, .env.production
- IDE: .vscode/, .idea/
- Notebooks: checkpoints
- DVC: /data/**/*.csv, /data/**/*.parquet (tracked by DVC)

### README.md
- Project overview, architecture diagram placeholder
- Quick start with uv install, docker-compose up, dvc pull, training, serving
- Development workflow (branch naming, commit conventions, PR process)
- Experiment tracking guide (MLflow UI, config-driven experiments)
- Deployment overview
- Compliance notes (SOC 2, GDPR)

## Implementation Rules

1. Every Python file must have a module docstring
2. All public functions must have type hints and docstrings (Google style)
3. Use \`from __future__ import annotations\` in every Python file
4. Pydantic v2 syntax (model_validator, field_validator, ConfigDict)
5. Use pathlib.Path instead of os.path
6. Structured logging (JSON format) — no print statements
7. All config values loaded from YAML/env — no hardcoded values
8. Include TODO comments where Phase 04 implementation will go, formatted as: \`# TODO(phase-04): description\`
9. Every file should be under 300 lines
10. Use snake_case for files/functions, PascalCase for classes, SCREAMING_SNAKE_CASE for constants

## After Scaffolding

Once files are generated, run these verification commands:
- \`uv sync\` — install all dependencies
- \`uv run ruff check src/ tests/\` — lint passes
- \`uv run ruff format --check src/ tests/\` — format passes
- \`uv run mypy src/\` — type check passes
- \`uv run pytest tests/ -x\` — tests pass (skeleton tests)
- \`docker compose -f docker/docker-compose.yml config\` — Docker config valid

Fix any issues found. All checks must pass before Phase 03 is considered complete.
\`\`\`

---

## Expected Output

After running this prompt, Claude Code should create approximately 60-80 files. Verify:

| Check | Command | Expected |
|-------|---------|----------|
| Directory structure | \`find . -type f \\| head -80\` | All directories and files present |
| Dependencies install | \`uv sync\` | Clean install, no conflicts |
| Lint | \`uv run ruff check src/ tests/\` | 0 errors |
| Format | \`uv run ruff format --check src/ tests/\` | 0 reformats needed |
| Type check | \`uv run mypy src/\` | 0 errors |
| Tests | \`uv run pytest tests/ -x -q\` | All skeleton tests pass |
| Docker | \`docker compose -f docker/docker-compose.yml config\` | Valid YAML |
| DVC | \`dvc status\` | Pipeline stages recognized |

## Common Issues and Fixes

**uv sync fails on PyTorch**: PyTorch has special index URLs. Ensure \`pyproject.toml\` includes:
\`\`\`toml
[tool.uv]
find-links = ["https://download.pytorch.org/whl/cpu"]
\`\`\`

**mypy errors on Pydantic**: Ensure mypy config includes:
\`\`\`toml
[tool.mypy]
plugins = ["pydantic.mypy"]
\`\`\`

**DVC config missing remote**: Run \`dvc remote add -d storage s3://ml-pipeline-data/dvc\` after scaffold.

**MLflow connection errors in tests**: The \`conftest.py\` should mock MLflow — tests must not require a running MLflow server.

---

## Next Steps

After scaffold is verified:
1. Commit: \`git add -A && git commit -m "chore: scaffold ml-pipeline project (Phase 03)"\`
2. Push: \`git push origin main\`
3. Start local services: \`make docker-up\`
4. Verify MLflow UI: \`make mlflow-ui\` → http://localhost:5000
5. Proceed to **Phase 04: Core Implementation** — begin with \`src/data/loader.py\` and \`src/models/base.py\``,

  'playbook/prompts/04/auth-implementation.md': `# Auth Implementation — Phase 04 Prompt

> Copy-paste this prompt into Claude Code to implement authentication and authorization for the ml-pipeline project.

---

## Prompt

\`\`\`
You are implementing authentication and authorization for the ml-pipeline project — a Python ML pipeline with FastAPI model serving, MLflow experiment tracking, and DVC data versioning.

## Context

This project must comply with SOC 2 and GDPR. Authentication secures:
1. The FastAPI model serving API (inference endpoints, batch processing, model management)
2. MLflow tracking server access (experiment logs, model registry, artifact store)
3. Internal pipeline endpoints (training triggers, data pipeline status, feature store)
4. Admin operations (model promotion, data deletion requests, user management)

## Requirements

### 1. Authentication Module (\`src/serving/auth/\`)

Create the following files:

**\`src/serving/auth/__init__.py\`**
- Export all public auth components

**\`src/serving/auth/config.py\`**
- Pydantic \`AuthConfig\` model loaded from \`configs/auth.yaml\`
- Fields: \`secret_key\`, \`algorithm\` (default HS256), \`access_token_expire_minutes\`, \`refresh_token_expire_days\`, \`api_key_header_name\`, \`allowed_origins\`, \`rate_limit_per_minute\`
- Validate secret_key minimum length of 32 characters
- Support environment variable overrides via \`pydantic-settings\`

**\`src/serving/auth/models.py\`**
- Pydantic models: \`UserCreate\`, \`UserResponse\`, \`TokenPair\`, \`TokenPayload\`, \`APIKeyCreate\`, \`APIKeyResponse\`
- SQLAlchemy models: \`User\`, \`APIKey\`, \`AuditLog\` tables in PostgreSQL
- User roles enum: \`VIEWER\`, \`DATA_SCIENTIST\`, \`ML_ENGINEER\`, \`ADMIN\`
- Include GDPR fields: \`consent_given_at\`, \`data_processing_agreed\`, \`deletion_requested_at\`
- All public functions must have type hints

**\`src/serving/auth/security.py\`**
- Password hashing with bcrypt via \`passlib\`
- JWT token creation and verification (access + refresh tokens)
- API key generation (cryptographically secure, prefixed with \`mlp_\`)
- API key hashing for storage (never store plaintext)
- Token blacklisting via Redis for logout/revocation
- Function signatures:
  \`\`\`python
  def hash_password(password: str) -> str: ...
  def verify_password(plain: str, hashed: str) -> bool: ...
  def create_access_token(subject: str, role: Role, extra_claims: dict[str, Any] | None = None) -> str: ...
  def create_refresh_token(subject: str) -> str: ...
  def decode_token(token: str) -> TokenPayload: ...
  def generate_api_key() -> tuple[str, str]: ...  # (plaintext, hashed)
  async def blacklist_token(token: str, redis: Redis) -> None: ...
  async def is_token_blacklisted(token: str, redis: Redis) -> bool: ...
  \`\`\`

**\`src/serving/auth/dependencies.py\`**
- FastAPI dependency injection for auth:
  \`\`\`python
  async def get_current_user(token: str = Depends(oauth2_scheme)) -> UserResponse: ...
  async def require_role(required: Role) -> Callable: ...
  async def get_api_key_user(api_key: str = Header(...)) -> UserResponse: ...
  async def get_current_user_flexible(...) -> UserResponse: ...  # JWT or API key
  \`\`\`
- \`require_role\` should be a dependency factory: \`Depends(require_role(Role.ML_ENGINEER))\`
- Check token blacklist on every request via Redis
- Rate limiting dependency using Redis sliding window

**\`src/serving/auth/router.py\`**
- FastAPI router with prefix \`/auth\`
- Endpoints:
  - \`POST /auth/register\` — create user (admin only in production)
  - \`POST /auth/login\` — return JWT access + refresh tokens
  - \`POST /auth/refresh\` — refresh access token
  - \`POST /auth/logout\` — blacklist current token
  - \`POST /auth/api-keys\` — generate API key (ML_ENGINEER+ role)
  - \`DELETE /auth/api-keys/{key_id}\` — revoke API key
  - \`GET /auth/me\` — current user profile
  - \`DELETE /auth/me/data\` — GDPR data deletion request
- All endpoints must log to \`AuditLog\` table
- Use conventional HTTP status codes (201 for creation, 401/403 for auth errors)

**\`src/serving/auth/audit.py\`**
- Audit logging for SOC 2 compliance
- Log: \`user_id\`, \`action\`, \`resource\`, \`ip_address\`, \`timestamp\`, \`success\`, \`details\`
- Write to both PostgreSQL \`AuditLog\` table and structured JSON logger
- Async audit logging (don't block request processing)
- Function: \`async def log_audit_event(event: AuditEvent) -> None\`

### 2. Protect Existing Endpoints

Update \`src/serving/\` to apply auth:

- **Inference endpoints** (\`/predict\`, \`/predict/batch\`): Require \`VIEWER\` role or valid API key
- **Model management** (\`/models/\`, \`/models/{id}/promote\`): Require \`ML_ENGINEER\` role
- **Training triggers** (\`/train/\`, \`/train/{experiment_id}/status\`): Require \`DATA_SCIENTIST\` role
- **Data pipeline status** (\`/pipelines/\`): Require \`DATA_SCIENTIST\` role
- **Admin endpoints** (\`/admin/\`): Require \`ADMIN\` role
- **Health check** (\`/health\`, \`/ready\`): No auth required (for k8s probes)
- **MLflow proxy** (if applicable): Require \`DATA_SCIENTIST\` role minimum

### 3. MLflow Authentication

Create \`src/utils/mlflow_auth.py\`:
- Wrapper for MLflow client that injects auth headers
- Support for MLflow's built-in auth (basic auth) or reverse proxy auth
- Ensure experiment access is scoped: data scientists see only their team's experiments
- Function: \`def get_authenticated_mlflow_client(user: UserResponse) -> MlflowClient\`

### 4. Configuration

Create \`configs/auth.yaml\`:
\`\`\`yaml
auth:
  algorithm: "HS256"
  access_token_expire_minutes: 30
  refresh_token_expire_days: 7
  api_key_header_name: "X-API-Key"
  rate_limit_per_minute: 60
  allowed_origins:
    - "http://localhost:3000"
    - "http://localhost:5000"  # MLflow UI
  password_min_length: 12
  require_consent: true  # GDPR
\`\`\`

Note: \`secret_key\` must come from environment variable \`AUTH_SECRET_KEY\`, never from YAML.

### 5. Database Migration

Create an Alembic migration for the auth tables:
- \`users\` table with: id, email, hashed_password, role, is_active, consent_given_at, data_processing_agreed, deletion_requested_at, created_at, updated_at
- \`api_keys\` table with: id, user_id (FK), hashed_key, key_prefix (first 8 chars for identification), name, last_used_at, expires_at, is_active, created_at
- \`audit_logs\` table with: id, user_id (FK nullable), action, resource, ip_address, user_agent, success, details (JSONB), created_at
- Add indexes on: users.email (unique), api_keys.hashed_key, api_keys.user_id, audit_logs.user_id, audit_logs.created_at, audit_logs.action

### 6. Tests

Create tests in \`tests/serving/auth/\`:

**\`tests/serving/auth/test_security.py\`**
- Test password hashing and verification
- Test JWT creation and decoding (valid, expired, tampered)
- Test API key generation and hashing
- Test token blacklisting via Redis mock

**\`tests/serving/auth/test_dependencies.py\`**
- Test \`get_current_user\` with valid/invalid/expired tokens
- Test \`require_role\` with sufficient/insufficient permissions
- Test API key authentication
- Test rate limiting

**\`tests/serving/auth/test_router.py\`**
- Test full auth flow: register → login → access protected → refresh → logout
- Test GDPR deletion request endpoint
- Test API key lifecycle: create → use → revoke
- Test unauthorized access returns 401
- Test insufficient role returns 403
- Test audit log entries are created

**\`tests/serving/auth/test_mlflow_auth.py\`**
- Test MLflow client wrapper injects correct headers
- Test experiment scoping by user role

Use \`pytest-asyncio\` for async tests. Use \`httpx.AsyncClient\` with FastAPI's \`TestClient\` for endpoint tests. Mock Redis and PostgreSQL with \`pytest\` fixtures.

### 7. GDPR Compliance

- Users must explicitly consent to data processing during registration
- \`DELETE /auth/me/data\` initiates a soft-delete workflow:
  1. Mark \`deletion_requested_at\` timestamp
  2. Anonymize PII in audit logs after retention period (configurable, default 90 days)
  3. Remove user's experiment metadata that contains PII
  4. Deactivate all API keys
  5. Log the deletion request itself in audit log (without PII)
- Provide \`scripts/gdpr_cleanup.py\` for scheduled PII anonymization

### 8. SOC 2 Considerations

- All auth events logged to audit trail (login, logout, failed attempts, role changes, API key operations)
- Failed login attempts tracked — lock account after 5 consecutive failures (unlock after 15 min or admin action)
- Session management: tokens expire, refresh tokens rotate, old refresh tokens invalidated
- API keys have optional expiration dates
- No secrets in logs — mask tokens, passwords, API keys in all log output
- Model artifact access logged when served through authenticated endpoints

## Constraints

- Use \`uv\` for package management — add dependencies to \`pyproject.toml\`
- Follow snake_case for files/functions, PascalCase for classes, SCREAMING_SNAKE_CASE for constants
- All public functions require type hints
- Max 300 lines per file — split into focused modules
- Use Pydantic v2 model_validator and field_validator syntax
- Use \`ruff\` for linting, \`mypy\` strict mode must pass
- Mark any AI-generated code with \`# AI-generated\` comment at file header
- Log structured JSON (not print statements)
- All new dependencies must be pinned in pyproject.toml

## Implementation Order

1. \`src/serving/auth/config.py\` — config models first
2. \`src/serving/auth/models.py\` — database and Pydantic models
3. \`src/serving/auth/security.py\` — core crypto functions
4. \`src/serving/auth/audit.py\` — audit logging
5. \`src/serving/auth/dependencies.py\` — FastAPI dependencies
6. \`src/serving/auth/router.py\` — API endpoints
7. \`src/utils/mlflow_auth.py\` — MLflow integration
8. \`configs/auth.yaml\` — configuration
9. Alembic migration
10. Tests (write alongside each module using TDD — see playbook/prompts/01/gather-requirements.md for TDD workflow)
11. \`scripts/gdpr_cleanup.py\` — GDPR automation
12. Update \`src/serving/app.py\` to mount auth router and apply middleware

After implementation, verify with:
- \`uv run ruff check src/serving/auth/ src/utils/mlflow_auth.py\`
- \`uv run mypy src/serving/auth/ src/utils/mlflow_auth.py\`
- \`uv run pytest tests/serving/auth/ -v --cov=src/serving/auth --cov-fail-under=75\`

Commit with: \`feat(auth): implement JWT + API key authentication with GDPR and SOC 2 compliance\`
\`\`\`

---

## Usage

1. Ensure Phase 03 (Foundation) is complete — project scaffold, CI pipeline, and database setup exist
2. Copy the prompt above into Claude Code
3. Claude will implement the auth module incrementally following the implementation order
4. Review generated files against the constraints checklist
5. Run the verification commands before committing
6. Update \`playbook/current-phase.json\` to reflect progress in Phase 04

## Checklist

- [ ] All files under 300 lines
- [ ] Type hints on all public functions
- [ ] Pydantic v2 syntax used
- [ ] No plaintext secrets in config files or logs
- [ ] GDPR consent flow implemented
- [ ] SOC 2 audit logging complete
- [ ] Redis used for token blacklist and rate limiting
- [ ] Tests cover auth flow, role enforcement, GDPR deletion
- [ ] \`ruff check\` passes
- [ ] \`mypy --strict\` passes
- [ ] Coverage ≥ 75% for auth module
- [ ] AI-generated comment headers present
- [ ] Dependencies pinned in \`pyproject.toml\`
- [ ] Alembic migration created and tested
- [ ] CODEOWNERS updated for \`src/serving/auth/**\`

## Related Files

- \`playbook/phases/04-core-implementation.md\` — Phase 04 overview
- \`playbook/prompts/03/project-scaffold.md\` — Foundation scaffold (prerequisite)
- \`plugin/codeforge-ml-pipeline/commands/tdd.md\` — TDD workflow command
- \`plugin/codeforge-ml-pipeline/agents/tdd-guide.md\` — TDD agent for test-first development
- \`configs/auth.yaml\` — Auth configuration (created by this prompt)
- \`docs/adr/\` — Architecture Decision Records for auth approach`,

  'playbook/prompts/04/crud-generator.md': `# CRUD Generator — Phase 04 Prompt

> Copy-paste this prompt into Claude Code to generate a complete CRUD module for an ML pipeline resource (datasets, experiments, models, features, predictions, etc.)

---

## Prompt

\`\`\`
You are implementing a CRUD module for the ml-pipeline project. Generate a complete, production-ready CRUD implementation for the resource described below.

## Resource Definition

Resource name: [RESOURCE_NAME — e.g., "experiment", "dataset", "model_version", "feature_set", "prediction_job"]
Description: [Brief description of what this resource represents in the ML pipeline]
Parent resource (if any): [e.g., "experiment" is parent of "model_version"]

## Project Context

- Python 3.11+ with strict type hints on all public functions
- FastAPI for REST API (src/serving/)
- PostgreSQL for metadata storage
- Redis for caching frequently accessed resources
- Pydantic for request/response validation and config
- SQLAlchemy 2.0 async for ORM
- Naming: snake_case files/functions, PascalCase classes, SCREAMING_SNAKE_CASE constants
- Max 300 lines per file
- All ML artifacts tracked in MLflow; data artifacts tracked in DVC
- GDPR compliance: support anonymization and soft-delete for user-linked data
- SOC 2: audit logging on all mutations

## Files to Generate

Generate ALL of the following files for the resource:

### 1. Pydantic Schemas — \`src/serving/schemas/[resource_name].py\`
- \`[Resource]Base\` — shared fields with type hints and Field validators
- \`[Resource]Create\` — creation payload (required fields, defaults)
- \`[Resource]Update\` — partial update payload (all Optional fields)
- \`[Resource]Response\` — API response with id, timestamps, computed fields
- \`[Resource]ListResponse\` — paginated list with total count, page, page_size
- \`[Resource]Filter\` — query filter params (status, date range, tags, owner)
- Use Pydantic v2 model_config, field_validator, model_validator where needed
- Include ML-specific fields: status enum (pending, running, completed, failed, archived), metadata JSON field, tags list, metrics dict
- Include GDPR fields where applicable: is_anonymized, consent_reference, data_retention_date

### 2. SQLAlchemy Model — \`src/data/models/[resource_name].py\`
- Async-compatible SQLAlchemy 2.0 mapped class
- Standard columns: id (UUID), created_at, updated_at, deleted_at (soft delete)
- created_by, updated_by for audit trail (SOC 2)
- Resource-specific columns matching the Pydantic schema
- Indexes on frequently queried columns (status, created_at, owner, tags)
- JSON columns for flexible metadata and metrics storage
- Relationship definitions to parent/child resources
- __repr__ and __tablename__ defined

### 3. Repository Layer — \`src/data/repositories/[resource_name]_repository.py\`
- Async repository class with dependency-injected AsyncSession
- Methods:
  - \`async def create(self, data: [Resource]Create, created_by: str) -> [Resource]Model\`
  - \`async def get_by_id(self, id: UUID) -> [Resource]Model | None\`
  - \`async def list(self, filters: [Resource]Filter, page: int, page_size: int) -> tuple[list[[Resource]Model], int]\`
  - \`async def update(self, id: UUID, data: [Resource]Update, updated_by: str) -> [Resource]Model\`
  - \`async def soft_delete(self, id: UUID, deleted_by: str) -> bool\`
  - \`async def hard_delete(self, id: UUID) -> bool\` (GDPR right to deletion)
  - \`async def anonymize(self, id: UUID) -> [Resource]Model\` (GDPR anonymization)
  - \`async def get_by_status(self, status: str) -> list[[Resource]Model]\`
  - \`async def bulk_update_status(self, ids: list[UUID], status: str, updated_by: str) -> int\`
- All queries exclude soft-deleted records by default (include_deleted param to override)
- Use SQLAlchemy select() style (not legacy Query API)

### 4. Service Layer — \`src/serving/services/[resource_name]_service.py\`
- Business logic layer between API and repository
- Constructor takes repository + Redis client
- Methods mirror repository but add:
  - Input validation beyond Pydantic (e.g., check parent exists, validate state transitions)
  - Redis cache: cache get_by_id results, invalidate on update/delete
  - Audit logging: log all create/update/delete operations with actor, timestamp, diff
  - ML-specific logic:
    - Status transition validation (e.g., cannot go from "completed" back to "pending")
    - MLflow integration hooks (e.g., log experiment creation, link model versions)
    - Metrics aggregation helpers
  - GDPR: cascade anonymization to child resources
  - Error handling: raise domain-specific exceptions (ResourceNotFoundError, InvalidStateTransitionError, etc.)

### 5. API Router — \`src/serving/routers/[resource_name]_router.py\`
- FastAPI APIRouter with prefix \`/api/v1/[resource_name_plural]\`
- Tag for OpenAPI grouping
- Endpoints:
  - \`POST /\` — create resource (201)
  - \`GET /{id}\` — get by ID (200, 404)
  - \`GET /\` — list with filters, pagination (200)
  - \`PATCH /{id}\` — partial update (200, 404, 409 for state conflicts)
  - \`DELETE /{id}\` — soft delete (204, 404)
  - \`DELETE /{id}/permanent\` — hard delete for GDPR (204, requires elevated permissions)
  - \`POST /{id}/anonymize\` — GDPR anonymization (200)
  - \`POST /bulk/status\` — bulk status update (200)
- Dependency injection for service, current_user
- Response models specified for OpenAPI docs
- HTTP status codes and error responses documented
- Rate limiting annotations where appropriate

### 6. Custom Exceptions — \`src/serving/exceptions/[resource_name]_exceptions.py\`
- \`[Resource]NotFoundError(resource_id: UUID)\`
- \`[Resource]AlreadyExistsError(field: str, value: str)\`
- \`InvalidStateTransitionError(current: str, target: str, allowed: list[str])\`
- \`[Resource]ValidationError(details: dict)\`
- All inherit from a base \`MLPipelineError\` with error_code and status_code

### 7. Tests — \`tests/unit/test_[resource_name]_service.py\`
- pytest with pytest-asyncio
- Fixtures: mock repository, mock Redis client, sample create/update data
- Test cases:
  - Create resource successfully
  - Create with duplicate raises error
  - Get by ID returns cached result on second call
  - Get by ID with nonexistent ID raises ResourceNotFoundError
  - List with filters returns paginated results
  - Update with valid state transition succeeds
  - Update with invalid state transition raises InvalidStateTransitionError
  - Soft delete marks deleted_at
  - Hard delete removes record (GDPR)
  - Anonymize replaces PII fields
  - Bulk status update
  - Cache invalidation on update and delete
- Use \`@pytest.mark.asyncio\` decorator
- Assert audit log calls

### 8. Tests — \`tests/integration/test_[resource_name]_api.py\`
- FastAPI TestClient (httpx.AsyncClient) tests
- Test full request/response cycle through the API
- Test cases:
  - POST creates and returns 201 with Location header
  - GET returns 200 with correct schema
  - GET with invalid UUID returns 422
  - GET nonexistent returns 404
  - PATCH updates fields and returns 200
  - DELETE returns 204
  - GET after DELETE returns 404
  - List with pagination params works correctly
  - List with filter params returns filtered results
  - Error responses match expected error schema
- Use fixtures for database setup/teardown

## ML-Specific Resource Fields

If the resource is one of these common ML pipeline resources, include these domain-specific fields:

**experiment**: name, description, hypothesis, dataset_id (FK), model_architecture, hyperparameters (JSON), status, metrics (JSON: loss, accuracy, f1, etc.), mlflow_experiment_id, mlflow_run_id, tags, gpu_hours_used, training_config_hash

**dataset**: name, version, source_path (S3 URI), dvc_hash, num_samples, num_features, schema_definition (JSON), split_ratios (JSON), preprocessing_pipeline, data_quality_score, is_anonymized, retention_date

**model_version**: experiment_id (FK), version, model_path (S3 URI), mlflow_model_uri, framework, architecture_name, input_schema (JSON), output_schema (JSON), metrics (JSON), status (staged/production/archived), serving_endpoint, latency_p99_ms

**feature_set**: name, version, features (JSON list of feature definitions), source_tables, computation_query, refresh_schedule, last_computed_at, num_features, storage_format, redis_cache_key

**prediction_job**: model_version_id (FK), input_source, output_destination, batch_size, num_records, status, started_at, completed_at, error_log, latency_stats (JSON), prediction_drift_score

## Constraints

- Every public function must have type hints
- Use \`from __future__ import annotations\` in all files
- Follow ruff linting rules (no unused imports, proper line length)
- Each file must be under 300 lines — split if necessary
- Use dependency injection (FastAPI Depends) — no global state
- All database operations must be async
- Include docstrings on all public methods (Google style)
- Reference configs/ YAML files for any configurable values (cache TTL, pagination defaults, etc.)
- Log operations using structlog with context (resource_id, actor, operation)

## Output Format

Generate each file with its full path as a header comment. Make the code production-ready — no TODOs, no placeholders, no "implement later" comments. Every method must be fully implemented.
\`\`\`

---

## Usage

1. Replace \`[RESOURCE_NAME]\` with your target resource (e.g., \`experiment\`)
2. Fill in the description and parent resource fields
3. Paste the entire prompt into Claude Code
4. Review generated files against the checklist below
5. Run verification:

\`\`\`bash
uv run ruff check src/serving/ src/data/ tests/
uv run mypy src/serving/ src/data/
uv run pytest tests/unit/test_[resource_name]_service.py -v
uv run pytest tests/integration/test_[resource_name]_api.py -v
\`\`\`

## Post-Generation Checklist

- [ ] All files pass \`ruff check\` and \`ruff format --check\`
- [ ] All files pass \`mypy --strict\`
- [ ] Unit tests pass with >75% coverage on service layer
- [ ] Integration tests pass against test database
- [ ] Pydantic schemas render correctly in FastAPI \`/docs\`
- [ ] Soft delete excludes records from default list queries
- [ ] Hard delete and anonymize endpoints exist for GDPR compliance
- [ ] Audit log entries created for all mutations (SOC 2)
- [ ] Redis cache populated on read, invalidated on write
- [ ] Status transitions validated (no illegal state changes)
- [ ] MLflow integration hooks present (experiment/model resources)
- [ ] All files under 300 lines
- [ ] No global mutable state — all dependencies injected
- [ ] Router registered in \`src/serving/app.py\`
- [ ] Alembic migration generated for new model: \`uv run alembic revision --autogenerate -m "add [resource_name] table"\`

## Common Resources to Generate

Run this prompt once for each core resource in the pipeline:

| Resource | Priority | Parent | Notes |
|---|---|---|---|
| \`experiment\` | P0 | — | Core entity, links to MLflow |
| \`dataset\` | P0 | — | DVC-tracked, GDPR retention |
| \`model_version\` | P0 | \`experiment\` | MLflow model registry |
| \`feature_set\` | P1 | \`dataset\` | Redis-cached features |
| \`prediction_job\` | P1 | \`model_version\` | Batch inference tracking |
| \`training_run\` | P2 | \`experiment\` | GPU resource tracking |
| \`data_quality_check\` | P2 | \`dataset\` | Automated data validation |
| \`ab_test\` | P2 | — | A/B test configuration |

## Example Invocation

\`\`\`
Generate a complete CRUD module for the "experiment" resource.

Resource name: experiment
Description: Represents a single ML experiment tracking a hypothesis, dataset, model architecture, hyperparameters, and resulting metrics. Each experiment maps to an MLflow experiment and may contain multiple training runs.
Parent resource: None (top-level entity)

[paste full prompt above]
\`\`\``,

  'playbook/prompts/04/feature-implementation.md': `# Feature Implementation Prompt — Phase 04: Core Implementation

> Copy-paste this prompt into Claude Code when implementing a new feature in the ml-pipeline project.

---

## Prompt

\`\`\`
I need to implement a feature for the ml-pipeline project. Here are the details:

**Feature**: [FEATURE_NAME]
**Ticket**: [ML-TICKET_NUMBER]
**Branch**: feat/[ML-TICKET_NUMBER]-[short-description]

## Context

[Describe the feature in 2-3 sentences. What does it do? Why is it needed? Which part of the ML pipeline does it affect?]

## Acceptance Criteria

- [ ] [Criterion 1]
- [ ] [Criterion 2]
- [ ] [Criterion 3]

## Technical Scope

- **Affected modules**: [e.g., src/data/, src/models/, src/training/, src/serving/, configs/]
- **New files**: [List expected new files or "TBD"]
- **Modified files**: [List files that need changes or "TBD"]
- **Config changes**: [Any new YAML configs in configs/ or Pydantic model changes]
- **DVC pipeline changes**: [Does dvc.yaml need new stages? Yes/No]
- **MLflow tracking**: [What metrics/params/artifacts should be logged?]

## Implementation Constraints

Follow these project standards strictly:

### Code Standards
- Python 3.11+ with type hints on ALL public functions
- snake_case for files/functions, PascalCase for classes, SCREAMING_SNAKE_CASE for constants
- Max 300 lines per file — split into focused modules if needed
- Use Pydantic models for all configuration and data validation
- All experiment parameters must be defined in YAML configs under configs/
- Production code goes in src/ only — never in notebooks/

### Architecture
- Follow the DAG-based pipeline architecture (data → features → training → evaluation → serving)
- Data loading/preprocessing in src/data/
- PyTorch nn.Module classes in src/models/
- Training loops, callbacks, hyperparameter tuning in src/training/
- Metrics computation and model comparison in src/evaluation/
- FastAPI endpoints and inference logic in src/serving/
- Shared utilities (logging, config loading, type definitions) in src/utils/

### ML-Specific Patterns
- All experiments must be reproducible: log configs, random seeds, environment info to MLflow
- Use MLflow for experiment tracking: mlflow.log_param(), mlflow.log_metric(), mlflow.log_artifact()
- Register production-ready models in MLflow Model Registry with stage transitions
- Data and model artifacts tracked with DVC — never commit large files to git
- Model checkpointing: save best model by validation metric, keep top-k checkpoints
- Feature engineering must be deterministic and versioned (same input → same output)
- Use torch.utils.data.Dataset and DataLoader for data pipelines
- GPU support: use device-agnostic code (torch.device, .to(device) patterns)

### Testing (TDD approach)
- Write tests FIRST in tests/ before implementing
- Use pytest with pytest-asyncio for async FastAPI tests
- Minimum 75% coverage on new code
- Test categories:
  - Unit tests for pure functions (data transforms, metrics, config parsing)
  - Integration tests for pipeline stages (data → model → prediction)
  - Smoke tests for training (1 epoch, small batch, verify loss decreases)
  - API tests for serving endpoints (request/response validation)
- Use fixtures for test data — never depend on real datasets in unit tests
- Mock external services (MLflow, S3, Redis) in unit tests

### Compliance
- GDPR: If handling user data, ensure anonymization, consent tracking, right-to-deletion support
- SOC 2: Validate model artifact integrity (checksums), audit logging for model deployments
- Never log PII in MLflow experiments or application logs
- Sensitive configs (API keys, DB credentials) via environment variables only, never in YAML files

### Git Workflow
- Conventional commits: feat:, fix:, chore:, docs:, experiment:
- Small, focused commits — one logical change per commit
- PR will need 1 approval and passing CI (lint, type check, tests, train smoke test)

## Implementation Steps

Please implement this feature by:

1. **Understand**: Read the relevant existing code in the affected modules. Check configs/ for related experiment configs and dvc.yaml for pipeline context.

2. **Plan**: Outline the implementation approach — list new files, modified files, new configs, and DVC pipeline changes. Identify edge cases and failure modes.

3. **Test First**: Write pytest tests in tests/ that define the expected behavior. Include:
   - Happy path tests
   - Edge case tests (empty data, invalid configs, GPU/CPU compatibility)
   - Integration test showing the feature works within the pipeline

4. **Implement**: Write the production code in src/ following the architecture:
   - Pydantic config models for any new parameters
   - YAML config files in configs/ for experiment parameters
   - Core logic with full type annotations
   - MLflow tracking integration where appropriate
   - DVC pipeline stage if this is a new pipeline step

5. **Validate**: Run the full check suite:
   \`\`\`bash
   uv run ruff check src/ tests/
   uv run ruff format --check src/ tests/
   uv run mypy src/
   uv run pytest tests/ -v --cov=src --cov-report=term-missing
   \`\`\`

6. **Document**: Add/update:
   - Docstrings on all public functions and classes
   - Type hints on all public function signatures
   - Config documentation in the YAML files (comments explaining each parameter)
   - Update docs/ if this changes architecture or adds a new pipeline stage

7. **Commit**: Use conventional commit messages:
   \`\`\`
   feat(ML-TICKET): brief description of the change
   \`\`\`

## Example Config Pattern

If this feature introduces new configuration, follow this pattern:

\`\`\`python
# src/utils/config.py (or feature-specific config)
from pydantic import BaseModel, Field

class NewFeatureConfig(BaseModel):
    """Configuration for [feature name]."""
    param_name: float = Field(default=0.001, ge=0, description="Description of param")
    num_epochs: int = Field(default=10, ge=1, description="Number of training epochs")
    checkpoint_dir: str = Field(default="models/checkpoints", description="Path for model checkpoints")
\`\`\`

\`\`\`yaml
# configs/feature_name.yaml
feature_name:
  param_name: 0.001  # Description of param
  num_epochs: 10     # Number of training epochs
  checkpoint_dir: "models/checkpoints"
\`\`\`

## Example MLflow Integration Pattern

\`\`\`python
import mlflow

with mlflow.start_run(run_name="feature-experiment"):
    mlflow.log_params(config.model_dump())
    mlflow.set_tag("mlflow.runName", "feature-experiment")
    mlflow.set_tag("feature", "feature_name")

    # ... training loop ...
    for epoch in range(config.num_epochs):
        mlflow.log_metric("train_loss", train_loss, step=epoch)
        mlflow.log_metric("val_loss", val_loss, step=epoch)

    mlflow.pytorch.log_model(model, "model")
    mlflow.log_artifact("configs/feature_name.yaml")
\`\`\`

## Example DVC Stage Pattern

If adding a new pipeline stage, update dvc.yaml:

\`\`\`yaml
stages:
  feature_name:
    cmd: uv run python scripts/run_feature.py --config configs/feature_name.yaml
    deps:
      - src/data/
      - src/models/
      - configs/feature_name.yaml
    outs:
      - data/processed/feature_output/
    metrics:
      - metrics/feature_metrics.json:
          cache: false
    params:
      - configs/feature_name.yaml:
          - feature_name
\`\`\`

## Files to Reference

Before starting, read these files for context:
- pyproject.toml (dependencies, tool configs)
- dvc.yaml (existing pipeline stages)
- configs/ (existing experiment configurations)
- src/utils/config.py (existing Pydantic config models)
- src/utils/logging.py (project logging setup)
- tests/conftest.py (shared test fixtures)
- .claude/rules/ (project rules and conventions)

Start by reading the relevant existing code, then present your implementation plan before writing code.
\`\`\`

---

## Usage Notes

1. **Replace placeholders** in brackets \`[...]\` with your actual feature details before pasting
2. **Trim sections** that don't apply — if the feature doesn't need DVC changes, remove that section
3. **Add domain context** — if Claude needs to understand specific ML concepts (e.g., attention mechanisms, data augmentation strategies), add a brief explanation
4. **Reference existing code** — if the feature extends an existing module, mention the specific files Claude should read first
5. **Specify the model architecture** — if the feature involves a new model or modifying an existing one, describe the expected input/output shapes

## Common Feature Types

| Feature Type | Key Modules | Config Needed | DVC Stage | MLflow |
|---|---|---|---|---|
| New data loader | \`src/data/\` | YAML + Pydantic | Yes (data prep) | Log data stats |
| New model architecture | \`src/models/\` | YAML + Pydantic | No (used by train) | Log model params |
| Training enhancement | \`src/training/\` | YAML update | No (modify train) | Log new metrics |
| New evaluation metric | \`src/evaluation/\` | Minimal | No (modify eval) | Log metric |
| API endpoint | \`src/serving/\` | Pydantic schema | No | Log inference stats |
| Feature engineering | \`src/data/\` | YAML + Pydantic | Yes (new stage) | Log feature stats |
| Hyperparameter tuning | \`src/training/\` | YAML search space | No | Log all trials |

## Checklist Before Submitting PR

After Claude implements the feature, verify:

- [ ] All public functions have type hints and docstrings
- [ ] \`uv run ruff check src/ tests/\` passes with no errors
- [ ] \`uv run ruff format --check src/ tests/\` passes
- [ ] \`uv run mypy src/\` passes in strict mode
- [ ] \`uv run pytest tests/ -v --cov=src\` shows ≥75% coverage on new code
- [ ] No files exceed 300 lines
- [ ] Pydantic models validate all new configuration
- [ ] YAML configs have descriptive comments
- [ ] MLflow tracking is integrated where applicable
- [ ] DVC pipeline updated if new data/model artifacts are produced
- [ ] No PII or secrets in configs, logs, or MLflow experiments
- [ ] Conventional commit messages used
- [ ] Branch named \`feat/ML-{ticket}-{description}\``,

  'playbook/prompts/05/integration-adapter.md': `# Integration Adapter Prompt — Phase 05 (Integration & Hardening)

> **Copy-paste this prompt into Claude Code when you need to build an integration adapter between two subsystems in the ml-pipeline project.**

---

## Prompt

You are an ML engineer working on the **ml-pipeline** project — an end-to-end ML pipeline using PyTorch, MLflow, DVC, and FastAPI. We are in **Phase 05: Integration & Hardening**.

I need you to build an **integration adapter** that connects two subsystems. The adapter must follow our project conventions and handle failure gracefully.

### Subsystems to Integrate

- **Source subsystem**: \`{SOURCE}\` (e.g., \`src/training/trainer.py\`, \`src/data/feature_store.py\`, \`DVC pipeline output\`)
- **Target subsystem**: \`{TARGET}\` (e.g., \`src/serving/app.py\`, \`MLflow model registry\`, \`Redis feature cache\`)
- **Data contract**: \`{DESCRIBE THE DATA SHAPE — e.g., "PyTorch state_dict + Pydantic ModelMetadata", "feature DataFrame with schema X"}\`
- **Integration pattern**: \`{PATTERN}\` (e.g., \`sync call\`, \`async event\`, \`file-based handoff via S3\`, \`Redis pub/sub\`, \`MLflow artifact exchange\`)

### Requirements

1. **Adapter module**: Create a new module in \`src/utils/adapters/\` or the appropriate subsystem directory. File must be ≤300 lines. Use snake_case naming (e.g., \`training_to_registry_adapter.py\`).

2. **Type-safe interface**: Define a Pydantic model for the data contract between subsystems. All public functions must have type hints. Example:

\`\`\`python
from pydantic import BaseModel, Field
from typing import Optional
from datetime import datetime

class ModelArtifactContract(BaseModel):
    model_name: str
    model_version: str
    artifact_uri: str
    metrics: dict[str, float]
    training_config_hash: str
    created_at: datetime = Field(default_factory=datetime.utcnow)
    gpu_device: Optional[str] = None
\`\`\`

3. **Error handling**: Implement retry logic with exponential backoff for transient failures (network, S3, Redis, MLflow server). Use structured logging. Never silently swallow exceptions. Define custom exception classes:

\`\`\`python
class AdapterError(Exception):
    """Base exception for adapter failures."""
    pass

class SourceConnectionError(AdapterError):
    """Failed to read from source subsystem."""
    pass

class TargetConnectionError(AdapterError):
    """Failed to write to target subsystem."""
    pass

class ContractViolationError(AdapterError):
    """Data does not match the expected contract."""
    pass
\`\`\`

4. **Circuit breaker**: If the target subsystem fails repeatedly (≥3 consecutive failures), open the circuit and fail fast for 60 seconds before retrying. Log circuit state transitions.

5. **Observability**: Emit Prometheus metrics for:
   - \`adapter_requests_total\` (counter, labels: source, target, status)
   - \`adapter_latency_seconds\` (histogram, labels: source, target)
   - \`adapter_circuit_state\` (gauge, labels: source, target — 0=closed, 1=half-open, 2=open)

6. **Health check**: Expose a \`check_health() -> AdapterHealthStatus\` method that verifies connectivity to both source and target subsystems. Return a Pydantic model with status, latency, and last error.

7. **Configuration**: Load adapter config from YAML via Pydantic. Example config in \`configs/adapters/{adapter_name}.yaml\`:

\`\`\`yaml
adapter:
  name: training_to_registry
  source:
    type: local_filesystem
    path: models/checkpoints/
  target:
    type: mlflow_registry
    tracking_uri: \${MLFLOW_TRACKING_URI}
    registry_uri: \${MLFLOW_REGISTRY_URI}
  retry:
    max_attempts: 3
    backoff_base_seconds: 1.0
    backoff_max_seconds: 30.0
  circuit_breaker:
    failure_threshold: 3
    recovery_timeout_seconds: 60
  timeout_seconds: 30
\`\`\`

8. **Idempotency**: The adapter must be safe to call multiple times with the same input. Use deterministic keys (e.g., \`f"{model_name}:{model_version}:{config_hash}"\`) to detect duplicate operations.

9. **GDPR compliance**: If the adapter handles any user data or training data with PII:
   - Log only anonymized identifiers, never raw PII
   - Support a \`purge(entity_id: str)\` method for right-to-deletion requests
   - Document what data flows through the adapter in a docstring

10. **SOC 2 / artifact integrity**: If the adapter transfers model artifacts:
    - Compute and verify SHA-256 checksums before and after transfer
    - Log artifact provenance (source path, destination URI, timestamp, user)
    - Reject artifacts that fail integrity checks

### Testing Requirements

Write tests in \`tests/integration/test_{adapter_name}.py\`:

- **Contract test**: Verify that the Pydantic contract model validates correctly and rejects malformed data.
- **Happy path test**: Mock source and target, verify data flows end-to-end.
- **Retry test**: Simulate transient failure, verify retry with backoff.
- **Circuit breaker test**: Simulate repeated failures, verify circuit opens and recovers.
- **Idempotency test**: Call adapter twice with same input, verify no duplicate side effects.
- **Health check test**: Verify health check reports correct status for healthy and unhealthy subsystems.
- **Integrity test** (if applicable): Verify checksum validation catches corrupted artifacts.

Use \`pytest\` with \`pytest-asyncio\` if the adapter is async. Use \`unittest.mock\` or \`pytest-mock\` for external dependencies. Target ≥75% coverage on the adapter module.

\`\`\`bash
uv run pytest tests/integration/test_{adapter_name}.py -v --cov=src/utils/adapters/{adapter_name} --cov-report=term-missing
\`\`\`

### File Structure to Create

\`\`\`
src/utils/adapters/
  __init__.py                          # Export adapter classes
  {adapter_name}.py                    # Main adapter implementation (≤300 lines)
  base.py                              # Base adapter class with retry, circuit breaker, metrics (if not already present)
configs/adapters/
  {adapter_name}.yaml                  # Adapter configuration
tests/integration/
  test_{adapter_name}.py               # Integration tests
  conftest.py                          # Shared fixtures (mock MLflow, mock Redis, etc.)
\`\`\`

### Validation Checklist

Before finishing, verify:

- [ ] \`uv run ruff check src/utils/adapters/\` — no lint errors
- [ ] \`uv run ruff format --check src/utils/adapters/\` — formatting correct
- [ ] \`uv run mypy src/utils/adapters/ --strict\` — no type errors
- [ ] \`uv run pytest tests/integration/test_{adapter_name}.py -v\` — all tests pass
- [ ] File is ≤300 lines
- [ ] All public functions have type hints and docstrings
- [ ] Pydantic models used for config and data contracts
- [ ] Custom exceptions defined and used (not bare \`Exception\`)
- [ ] Retry logic with exponential backoff implemented
- [ ] Circuit breaker implemented with configurable thresholds
- [ ] Prometheus metrics emitted
- [ ] Health check method implemented
- [ ] Idempotency enforced
- [ ] SHA-256 integrity checks for artifact transfers
- [ ] No PII in logs
- [ ] Conventional commit when done: \`feat(integration): add {adapter_name} adapter [ML-{TICKET}]\`

### Common Adapter Patterns in This Project

| Source → Target | Pattern | Key Concerns |
|---|---|---|
| DVC pipeline → MLflow registry | File-based handoff | Checksum verification, model versioning |
| Training loop → MLflow tracking | Sync API call | Retry on server errors, metric batching |
| Feature store (PostgreSQL) → Redis cache | Async refresh | Cache invalidation, TTL management |
| MLflow registry → FastAPI serving | Model loading | Version pinning, warm-up, rollback |
| S3 raw data → DVC pipeline | S3 download | Credential rotation, partial download resume |
| FastAPI request → Redis feature lookup | Sync cache read | Fallback to PostgreSQL on cache miss |
| Evaluation metrics → Prometheus | Push/pull metrics | Metric cardinality, label hygiene |

### Example: Training → MLflow Registry Adapter Skeleton

\`\`\`python
"""Adapter: training pipeline → MLflow model registry.

Transfers trained PyTorch model artifacts from local checkpoints to MLflow
model registry with integrity verification and experiment linking.

Data flow: No PII passes through this adapter. Only model weights,
hyperparameters, and aggregate metrics are transferred.
"""

import hashlib
import logging
import time
from pathlib import Path
from enum import Enum

import mlflow
from pydantic import BaseModel, Field

logger = logging.getLogger(__name__)


class CircuitState(Enum):
    CLOSED = 0
    HALF_OPEN = 1
    OPEN = 2


class TrainedModelContract(BaseModel):
    model_name: str
    version: str
    checkpoint_path: Path
    metrics: dict[str, float]
    config_hash: str
    sha256_checksum: str


class TrainingToRegistryAdapter:
    def __init__(self, config: "AdapterConfig") -> None:
        self.config = config
        self._circuit_state = CircuitState.CLOSED
        self._failure_count = 0
        self._last_failure_time: float = 0.0

    def transfer(self, contract: TrainedModelContract) -> str:
        """Register a trained model in MLflow. Returns the model URI."""
        self._check_circuit()
        self._verify_checksum(contract)
        idempotency_key = f"{contract.model_name}:{contract.version}:{contract.config_hash}"
        # ... retry loop, MLflow registration, metric emission
        return model_uri

    def _verify_checksum(self, contract: TrainedModelContract) -> None:
        actual = self._compute_sha256(contract.checkpoint_path)
        if actual != contract.sha256_checksum:
            raise ContractViolationError(
                f"Checksum mismatch: expected {contract.sha256_checksum}, got {actual}"
            )

    @staticmethod
    def _compute_sha256(path: Path) -> str:
        h = hashlib.sha256()
        with open(path, "rb") as f:
            for chunk in iter(lambda: f.read(8192), b""):
                h.update(chunk)
        return h.hexdigest()

    def check_health(self) -> "AdapterHealthStatus":
        # Verify MLflow tracking server is reachable
        ...
\`\`\`

Use this skeleton as a starting point. Adapt it to the specific source and target subsystems described above.

---

**Replace \`{SOURCE}\`, \`{TARGET}\`, \`{DESCRIBE THE DATA SHAPE}\`, \`{PATTERN}\`, \`{adapter_name}\`, and \`{TICKET}\` with your actual values before running.**`,

  'playbook/prompts/05/observability-setup.md': `# Observability Setup — Phase 05 Integration & Hardening

## Prompt for Claude Code

Copy and paste the following prompt into Claude Code:

---

I need you to set up comprehensive observability for our ML pipeline project \`ml-pipeline\`. This covers application metrics, ML-specific monitoring, structured logging, distributed tracing, alerting, and dashboard configuration. We run PyTorch training jobs, serve models via FastAPI, and track experiments with MLflow.

## Project Context

- **Stack**: Python 3.11+, PyTorch, FastAPI, MLflow, DVC, PostgreSQL, Redis
- **Cloud**: AWS (SageMaker, S3, ECR, ECS, EC2 GPU instances)
- **Monitoring**: Prometheus for metrics, Grafana for dashboards, MLflow UI for experiments
- **Compliance**: SOC 2 (audit logging required), GDPR (no PII in logs/metrics)
- **Package Manager**: uv
- **Config**: Pydantic models + YAML files

## 1. Structured Logging Setup

Create \`src/utils/logging.py\` with:

\`\`\`
- Structured JSON logging using Python's \`logging\` module + \`python-json-logger\`
- Log levels configurable via Pydantic config (\`configs/logging.yaml\`)
- Correlation ID middleware for FastAPI request tracing
- Automatic PII scrubbing — strip email, IP, and user identifiers from log output (GDPR)
- SOC 2 audit log formatter for security-relevant events (auth, model deployment, data access)
- Context managers for ML job logging (training run ID, experiment name, epoch)
- GPU memory and utilization logging helper for training jobs
- Log output targets: stdout (container), file (local dev), CloudWatch (production)
\`\`\`

Create \`configs/logging.yaml\`:

\`\`\`yaml
# Logging configuration with environment-specific overrides
# Levels: DEBUG (local), INFO (staging), WARNING (production)
# Ensure no PII leaks into any log sink
\`\`\`

## 2. Prometheus Metrics — Application & ML

Create \`src/utils/metrics.py\` with:

\`\`\`
- Use \`prometheus_client\` library
- FastAPI middleware to auto-instrument HTTP request metrics:
  - \`http_requests_total\` (method, endpoint, status_code)
  - \`http_request_duration_seconds\` histogram (method, endpoint)
  - \`http_request_size_bytes\` / \`http_response_size_bytes\`
- ML inference metrics:
  - \`model_inference_duration_seconds\` histogram (model_name, model_version)
  - \`model_inference_total\` counter (model_name, model_version, status)
  - \`model_prediction_confidence\` histogram (model_name) — track confidence distribution
  - \`model_batch_size\` histogram — batch inference sizes
  - \`feature_store_cache_hits_total\` / \`feature_store_cache_misses_total\`
- ML training metrics (push to Prometheus Pushgateway for batch jobs):
  - \`training_epoch_duration_seconds\` gauge (experiment_id, run_id)
  - \`training_loss\` gauge (experiment_id, run_id, epoch)
  - \`training_gpu_utilization_percent\` gauge (gpu_id)
  - \`training_gpu_memory_used_bytes\` gauge (gpu_id)
  - \`training_data_pipeline_duration_seconds\` histogram (stage: load, preprocess, augment)
- System / infra metrics:
  - \`model_registry_models_total\` gauge — number of registered models
  - \`dvc_pipeline_last_run_timestamp\` gauge
  - \`redis_feature_cache_size_bytes\` gauge
- \`/metrics\` endpoint on the FastAPI serving app
- Helper decorators: \`@track_inference_time(model_name)\`, \`@track_training_step()\`
\`\`\`

## 3. ML Model Monitoring — Data & Prediction Drift

Create \`src/evaluation/monitoring.py\` with:

\`\`\`
- Feature drift detection using statistical tests:
  - KS test for continuous features
  - Chi-squared test for categorical features
  - PSI (Population Stability Index) calculation
- Prediction drift monitoring:
  - Track prediction distribution over time windows (1h, 24h, 7d)
  - Compare against reference distribution from training set
  - \`prediction_drift_score\` Prometheus gauge (model_name, window)
- Data quality checks on incoming inference requests:
  - Missing value rate per feature
  - Out-of-range value detection
  - Schema validation failures counter
- Integration with MLflow:
  - Log drift metrics as MLflow run metrics
  - Trigger alerts when drift exceeds configurable thresholds
- Pydantic config model \`MonitoringConfig\` for thresholds:
  - \`drift_ks_threshold: float = 0.1\`
  - \`drift_psi_threshold: float = 0.2\`
  - \`data_quality_missing_rate_max: float = 0.05\`
  - \`alert_cooldown_minutes: int = 30\`
\`\`\`

## 4. Distributed Tracing

Create \`src/utils/tracing.py\` with:

\`\`\`
- OpenTelemetry integration for distributed tracing
- Auto-instrument FastAPI with \`opentelemetry-instrumentation-fastapi\`
- Auto-instrument HTTP clients (\`httpx\`, \`requests\`)
- Auto-instrument PostgreSQL (\`opentelemetry-instrumentation-psycopg2\`)
- Auto-instrument Redis (\`opentelemetry-instrumentation-redis\`)
- Custom spans for ML-specific operations:
  - \`ml.inference\` span with attributes: model_name, model_version, batch_size, latency
  - \`ml.feature_engineering\` span with attributes: feature_count, cache_hit
  - \`ml.data_load\` span with attributes: dataset_name, row_count
- Trace context propagation between FastAPI serving and any async workers
- Export to OTLP endpoint (configurable: Jaeger, AWS X-Ray, or stdout for local dev)
- Sampling strategy: always sample errors, 10% sample rate for normal requests in production
\`\`\`

## 5. Health Checks

Create \`src/serving/health.py\` with:

\`\`\`
- FastAPI router with health check endpoints:
  - \`GET /health\` — basic liveness (returns 200)
  - \`GET /health/ready\` — readiness check:
    - PostgreSQL connection alive
    - Redis connection alive
    - At least one model loaded in memory
    - MLflow tracking server reachable
  - \`GET /health/models\` — model health:
    - List loaded models with versions
    - Last inference timestamp per model
    - Average inference latency (last 5 min)
    - Drift status per model
- Pydantic response models for all health endpoints
- Kubernetes-compatible probe format
- Graceful degradation: if Redis is down, report degraded but not unhealthy
\`\`\`

## 6. Grafana Dashboard Configs

Create \`configs/grafana/\` directory with JSON dashboard definitions:

### \`configs/grafana/ml-serving-dashboard.json\`
\`\`\`
Panels:
- Request rate (RPS) by endpoint
- P50/P95/P99 latency by endpoint
- Error rate (4xx, 5xx)
- Model inference latency by model_name and version
- Prediction confidence distribution
- Active model versions
- Feature cache hit rate
\`\`\`

### \`configs/grafana/ml-training-dashboard.json\`
\`\`\`
Panels:
- Training loss curve (per experiment/run)
- GPU utilization and memory usage
- Epoch duration over time
- Data pipeline stage durations
- Active training jobs count
- DVC pipeline last run status
\`\`\`

### \`configs/grafana/ml-drift-dashboard.json\`
\`\`\`
Panels:
- Feature drift scores (KS statistic) per feature over time
- PSI scores per model over time
- Prediction distribution comparison (reference vs current)
- Data quality metrics (missing rate, schema failures)
- Drift alert timeline
\`\`\`

## 7. Alerting Rules

Create \`configs/prometheus/alerts.yml\` with Prometheus alerting rules:

\`\`\`
- ModelHighLatency: inference P95 > 500ms for 5 minutes
- ModelHighErrorRate: inference error rate > 5% for 5 minutes
- ModelDriftDetected: drift score > threshold for 1 hour
- GPUMemoryHigh: GPU memory > 90% for 10 minutes
- TrainingJobStalled: no epoch completion in 30 minutes
- FeatureCacheLowHitRate: cache hit rate < 50% for 15 minutes
- ModelServingDown: health check failing for 2 minutes
- DataQualityDegraded: missing value rate > 5% for 15 minutes
- MLflowUnreachable: MLflow tracking server unreachable for 5 minutes
- HighRequestLatency: HTTP P99 > 2s for 5 minutes
\`\`\`

## 8. FastAPI Middleware Integration

Update \`src/serving/app.py\` to wire everything together:

\`\`\`
- Add Prometheus metrics middleware
- Add correlation ID middleware (generate UUID, propagate in headers)
- Add OpenTelemetry tracing middleware
- Add structured logging middleware (log method, path, status, duration, correlation_id)
- Add request/response size tracking
- Mount /metrics endpoint
- Mount /health router
- Startup event: initialize metrics, tracing, load models, log system info
- Shutdown event: flush metrics, close tracing provider, log shutdown
\`\`\`

## 9. Docker Compose for Local Observability Stack

Create \`docker-compose.observability.yml\`:

\`\`\`
Services:
- prometheus (scrape FastAPI /metrics, Pushgateway)
- grafana (pre-provisioned dashboards from configs/grafana/)
- pushgateway (for training job metrics)
- jaeger (trace collection and UI)
- redis-exporter (Redis metrics for Prometheus)
- postgres-exporter (PostgreSQL metrics for Prometheus)
\`\`\`

Include \`configs/prometheus/prometheus.yml\` with scrape configs for all targets.

## Constraints

- **Type hints** on all public functions
- **Pydantic** for all configuration models
- **GDPR**: No PII in logs, metrics labels, or trace attributes — scrub before emission
- **SOC 2**: Audit log all model deployments, data access events, and configuration changes
- **Max 300 lines per file** — split into modules if needed
- **snake_case** for files/functions, **PascalCase** for classes, **SCREAMING_SNAKE_CASE** for constants
- Run \`uv run ruff check src/\` and \`uv run mypy src/\` after generating code
- Add tests in \`tests/test_observability/\` covering:
  - Metrics increment correctly
  - PII scrubbing works
  - Health check returns correct status
  - Drift detection math is correct
- Pin new dependencies in \`pyproject.toml\`:
  - \`prometheus-client\`
  - \`python-json-logger\`
  - \`opentelemetry-api\`, \`opentelemetry-sdk\`, \`opentelemetry-instrumentation-fastapi\`
  - \`opentelemetry-instrumentation-psycopg2\`, \`opentelemetry-instrumentation-redis\`
  - \`scipy\` (for drift statistical tests)

## Expected Output Files

\`\`\`
src/utils/logging.py
src/utils/metrics.py
src/utils/tracing.py
src/evaluation/monitoring.py
src/serving/health.py
src/serving/app.py (updated)
configs/logging.yaml
configs/grafana/ml-serving-dashboard.json
configs/grafana/ml-training-dashboard.json
configs/grafana/ml-drift-dashboard.json
configs/prometheus/prometheus.yml
configs/prometheus/alerts.yml
docker-compose.observability.yml
tests/test_observability/test_metrics.py
tests/test_observability/test_logging.py
tests/test_observability/test_health.py
tests/test_observability/test_monitoring.py
pyproject.toml (updated dependencies)
\`\`\`

After generating all files, run:

\`\`\`bash
uv run ruff check src/utils/logging.py src/utils/metrics.py src/utils/tracing.py src/evaluation/monitoring.py src/serving/health.py
uv run ruff format src/utils/ src/evaluation/ src/serving/
uv run mypy src/utils/logging.py src/utils/metrics.py src/utils/tracing.py src/evaluation/monitoring.py src/serving/health.py
uv run pytest tests/test_observability/ -v
\`\`\`

---

## Notes

- This prompt is part of **Phase 05 — Integration & Hardening** in the [Playbook](../../PLAYBOOK.md). See [phase details](../../phases/05-integration-hardening.md).
- Observability is critical for ML systems — models degrade silently without drift monitoring and prediction quality tracking.
- The Grafana dashboards should be importable via Grafana provisioning (JSON model format).
- Prometheus alerting rules should be compatible with Alertmanager for Slack notifications.
- For production AWS deployment, replace Jaeger with AWS X-Ray and stdout logging with CloudWatch. The code should support both via config.
- Related prompts: [security-hardening.md](../05/security-hardening.md), [integration-adapter.md](../05/integration-adapter.md).`,

  'playbook/prompts/05/security-hardening.md': `# Security Hardening — Phase 05 Prompt

> Copy-paste this prompt into Claude Code to perform security hardening across the ml-pipeline project.

---

## Prompt

\`\`\`
You are performing security hardening on the ml-pipeline project — an end-to-end ML pipeline using PyTorch, MLflow, DVC, and FastAPI deployed on AWS. The project must comply with SOC 2 and GDPR requirements.

## Context

Review the current codebase and apply security hardening across all layers: API serving, model artifacts, data pipeline, secrets management, infrastructure, and dependency supply chain.

## Scope

### 1. FastAPI Serving Layer (src/serving/)

Harden the FastAPI model serving endpoints:

- **Input validation**: Ensure all inference request payloads are validated with strict Pydantic models. Reject unexpected fields (\`model_config = ConfigDict(extra="forbid")\`). Validate tensor shapes, dtypes, and value ranges before passing to PyTorch models.
- **Rate limiting**: Add rate limiting middleware (e.g., slowapi) to \`/predict\`, \`/batch-predict\`, and \`/health\` endpoints. Configure per-client limits using API keys or IP-based throttling.
- **Authentication**: Verify all serving endpoints require valid API keys or JWT tokens. Implement API key rotation support via environment variables or AWS Secrets Manager.
- **CORS**: Restrict CORS origins to known consumers. Never use \`allow_origins=["*"]\` in production configs.
- **Response sanitization**: Ensure error responses never leak model internals, stack traces, file paths, or PyTorch version info. Use structured error responses with Pydantic models.
- **Request size limits**: Set max request body size to prevent OOM attacks on inference endpoints. Configure via \`--limit-request-body\` or middleware.
- **Timeouts**: Add inference timeout middleware to kill long-running predictions (e.g., malformed inputs causing infinite loops in model forward pass).

### 2. Model Artifact Security (models/, MLflow)

Protect model integrity and provenance:

- **Model signing**: Implement SHA-256 hash verification for all model artifacts loaded at inference time. Store hashes in MLflow model registry metadata.
- **Pickle safety**: Audit all model loading paths. Prefer \`torch.load(..., weights_only=True)\` where possible. Document any paths that require \`weights_only=False\` and add integrity checks.
- **MLflow access control**: Verify MLflow tracking server requires authentication. Ensure model registry transitions (staging → production) require explicit approval.
- **Artifact storage**: Confirm S3 buckets for MLflow artifacts and DVC remote have:
  - Bucket policies denying public access
  - Server-side encryption (SSE-S3 or SSE-KMS)
  - Versioning enabled
  - Access logging enabled
- **Model provenance**: Ensure every registered model has logged: training data hash, git commit SHA, experiment config hash, training environment details.

### 3. Data Pipeline Security (src/data/, DVC)

Secure the data pipeline and enforce GDPR compliance:

- **PII detection**: Scan data processing code in \`src/data/\` for handling of PII fields. Ensure anonymization or pseudonymization is applied before feature engineering. Add automated PII detection in preprocessing pipelines.
- **GDPR compliance**: Verify data deletion capabilities exist (right to erasure). Ensure consent tracking metadata is preserved in data lineage. Add data retention policies to DVC-tracked datasets.
- **DVC remote security**: Verify DVC remote (S3) uses IAM roles with least-privilege access. Ensure \`.dvc\` files don't contain hardcoded credentials or internal paths.
- **Data access logging**: Implement audit logging for all data access in training and inference pipelines. Log who accessed what data, when, and for what purpose (SOC 2 requirement).
- **Feature store (Redis)**: Ensure Redis instance requires authentication (\`requirepass\`). Use TLS for Redis connections. Set appropriate key expiration for cached features.

### 4. Secrets Management

Eliminate hardcoded secrets and enforce secure secret handling:

- **Scan for secrets**: Search the entire codebase for hardcoded credentials, API keys, database connection strings, AWS keys. Check:
  - \`configs/**/*.yaml\` — no plaintext secrets
  - \`src/**/*.py\` — no hardcoded connection strings
  - \`scripts/**\` — no embedded credentials
  - \`docker-compose*.yml\` — no inline secrets
  - \`.env*\` files — ensure they are in \`.gitignore\`
- **Environment variable validation**: Add Pydantic \`SecretStr\` fields for all sensitive config values. Validate required secrets are present at startup with clear error messages.
- **AWS Secrets Manager integration**: Implement a secrets provider in \`src/utils/\` that loads secrets from AWS Secrets Manager in production and \`.env\` files in development. Support automatic secret rotation.
- **MLflow credentials**: Ensure MLflow tracking URI, database credentials, and artifact store credentials are loaded from environment variables or secrets manager, never from config files.

### 5. Dependency Supply Chain

Secure the Python dependency chain:

- **Pin all dependencies**: Verify \`pyproject.toml\` pins exact versions for all direct dependencies (e.g., \`torch==2.1.0\`, not \`torch>=2.0\`). Run \`uv lock\` to generate a lockfile.
- **Vulnerability scanning**: Run \`uv pip audit\` or \`pip-audit\` against all installed packages. Document any known vulnerabilities and remediation plan.
- **Trusted sources**: Ensure \`pyproject.toml\` only references PyPI and any approved private indexes. No direct GitHub URLs for production dependencies.
- **Docker base images**: Verify Dockerfiles use pinned base image digests (e.g., \`python:3.11-slim@sha256:...\`). No \`latest\` tags.
- **SBOM generation**: Add a CI step to generate Software Bill of Materials for deployed containers.

### 6. Infrastructure Security

Harden the deployment infrastructure:

- **Docker**: Run containers as non-root user. Use multi-stage builds to minimize image size. No secrets in Docker layers. Scan images with Trivy or similar.
- **Kubernetes**: Verify pod security contexts (non-root, read-only filesystem where possible, drop all capabilities). Network policies to restrict pod-to-pod communication. Secrets mounted as volumes, not environment variables where feasible.
- **Terraform**: Review Terraform configs for:
  - Security groups with overly permissive ingress rules
  - S3 buckets without encryption or public access blocks
  - IAM roles with excessive permissions
  - RDS instances without encryption at rest
  - VPC configuration with proper subnet isolation
- **GPU instances**: Ensure EC2 GPU instances (for training) are in private subnets. SSH access restricted to bastion host. Instance profiles use least-privilege IAM roles.

### 7. Logging and Monitoring (SOC 2)

Implement security-relevant logging:

- **Audit trail**: Log all authentication attempts, model registry changes, data access events, and configuration changes. Use structured JSON logging.
- **Log sanitization**: Ensure logs never contain PII, model weights, raw training data, or secrets. Add log filters to redact sensitive patterns.
- **Alerting**: Define Prometheus alerts for:
  - Unusual inference request patterns (potential adversarial attacks)
  - Failed authentication attempts exceeding threshold
  - Model artifact hash mismatches
  - Unexpected data pipeline executions
- **Log retention**: Configure log retention policies compliant with SOC 2 (minimum 1 year).

## Output Requirements

For each area above:

1. **Audit**: List current security gaps found in the codebase
2. **Fix**: Implement the hardening changes directly in the appropriate files
3. **Test**: Add or update tests in \`tests/\` to verify security controls (e.g., test that invalid payloads are rejected, test that secrets are not logged)
4. **Document**: Update \`docs/security.md\` with the security controls implemented

## Constraints

- Follow existing project conventions: snake_case, type hints on all public functions, Pydantic for validation, max 300 lines per file
- Mark all AI-generated code with \`# AI-generated\` comment at the top of new files
- Use \`uv run ruff check src/\` and \`uv run mypy src/\` to verify changes pass linting and type checking
- Do not modify DVC-tracked data files in \`data/\` — only modify code that processes them
- Sensitive paths (\`configs/production/**\`, \`models/**\`, \`.env*\`, \`data/**\`) require careful review — flag any changes to these paths explicitly
- All new dependencies must be pinned in \`pyproject.toml\` and justified

## Verification

After completing hardening, run:

\`\`\`bash
# Lint and type check
uv run ruff check src/ tests/
uv run mypy src/

# Run security-focused tests
uv run pytest tests/ -m security -v

# Check for secrets in codebase
grep -rn "password\\|secret\\|api_key\\|aws_access" --include="*.py" --include="*.yaml" src/ configs/ scripts/

# Verify no .env files are tracked
git ls-files | grep -E "\\.env"

# Audit dependencies
uv pip audit
\`\`\`

Summarize all changes made, security gaps closed, and any remaining items that require manual review or team decision.
\`\`\``,

  'playbook/prompts/06/e2e-test-generator.md': `# E2E Test Generator — Phase 06: Testing & Quality

> **Copy-paste this prompt into Claude Code to generate end-to-end tests for the ml-pipeline project.**
> Covers the full ML lifecycle: data ingestion → feature engineering → training → evaluation → model registry → serving API.

---

## Prompt

\`\`\`
You are an ML engineer writing end-to-end tests for the ml-pipeline project. Generate comprehensive E2E tests that validate the entire ML pipeline from data ingestion through model serving.

## Project Context

- **Framework**: PyTorch (training), FastAPI (serving), MLflow (tracking/registry), DVC (data versioning)
- **Test Framework**: pytest with pytest-asyncio, httpx for async API testing
- **Database**: PostgreSQL (MLflow backend, metadata), Redis (feature cache)
- **Config**: Pydantic models validated from YAML configs in configs/
- **Cloud**: AWS (S3 for artifacts, SageMaker for training)
- **Compliance**: SOC 2 (audit trails), GDPR (data anonymization)
- **Coverage Threshold**: 75%
- **Max File Length**: 300 lines (split into multiple test files if needed)

## Directory Structure

Tests go in tests/e2e/ with this layout:

\`\`\`
tests/
  e2e/
    conftest.py                    # Shared E2E fixtures (DB, MLflow, API client, test data)
    test_data_pipeline_e2e.py      # Data ingestion → preprocessing → feature store
    test_training_pipeline_e2e.py  # Config → training → checkpointing → MLflow logging
    test_evaluation_pipeline_e2e.py # Model loading → evaluation → metric comparison
    test_model_registry_e2e.py     # Model registration → staging → promotion
    test_serving_api_e2e.py        # API startup → inference → batch prediction
    test_full_lifecycle_e2e.py     # Complete pipeline: data → train → evaluate → deploy → serve
    test_ab_testing_e2e.py         # A/B testing infrastructure validation
    test_data_privacy_e2e.py       # GDPR compliance: anonymization, deletion, consent
\`\`\`

## E2E Test Requirements

### 1. conftest.py — Shared Fixtures

Generate fixtures for:

- **test_db**: Spin up a test PostgreSQL database (use testcontainers or a dedicated test DB URL from env). Run migrations. Yield connection. Tear down after session.
- **mlflow_tracking**: Configure MLflow to use a temporary tracking URI (sqlite or test PostgreSQL). Set experiment name to "e2e-test-{uuid}". Clean up experiments after session.
- **test_data_dir**: Create a temporary directory with synthetic CSV/Parquet data matching the project's expected schema. Use factories to generate realistic but fake data (respect GDPR — no real PII). Yield path. Clean up after.
- **redis_client**: Connect to test Redis instance (or use fakeredis). Flush test keys on teardown.
- **api_client**: Use httpx.AsyncClient with the FastAPI app from src/serving/app.py. Configure with test MLflow URI and test model path.
- **trained_model_path**: Fixture that runs a minimal training loop (2 epochs, tiny dataset) and saves a checkpoint. Returns the path. Cached at session scope.
- **sample_config**: Load a test experiment config from configs/test/experiment.yaml using Pydantic validation.

Mark all E2E tests with \`@pytest.mark.e2e\` so they can be run separately:
\`\`\`python
# In pyproject.toml: [tool.pytest.ini_options] markers = ["e2e: end-to-end tests (slow)"]
\`\`\`

Use \`pytest.mark.asyncio\` for all async tests.

### 2. test_data_pipeline_e2e.py

Test the full data pipeline:

- **test_raw_data_ingestion**: Load raw data from test_data_dir, validate schema with Pydantic, assert row counts and column types.
- **test_preprocessing_pipeline**: Run the preprocessing pipeline from src/data/preprocessing.py. Assert: missing values handled, categorical encoding applied, numerical scaling applied, output shape matches expected.
- **test_feature_engineering**: Run feature engineering from src/data/features.py. Assert: new features created, feature names match config, no data leakage between train/test splits.
- **test_feature_store_write_read**: Write computed features to Redis feature store. Read them back. Assert round-trip consistency, TTL is set, keys follow naming convention.
- **test_data_versioning_metadata**: Verify that DVC metadata files (.dvc) are generated for processed data. Assert file hashes are deterministic for same input.
- **test_data_anonymization**: Run anonymization pipeline on PII columns. Assert: original PII not present in output, anonymized columns exist, transformation is irreversible (GDPR compliance).

### 3. test_training_pipeline_e2e.py

Test the training lifecycle:

- **test_training_from_config**: Load experiment config → initialize model → train for 3 epochs on synthetic data → assert loss decreases monotonically (or at least final < initial).
- **test_checkpoint_save_and_resume**: Train 2 epochs, save checkpoint. Resume from checkpoint, train 2 more. Assert: resumed epoch starts at 3, optimizer state restored, loss continues from where it left off.
- **test_mlflow_experiment_logging**: Run training loop. Assert MLflow logged: parameters (learning_rate, batch_size, model_name), metrics per epoch (train_loss, val_loss, val_accuracy), artifacts (model checkpoint, config YAML), tags (git commit hash, experiment type).
- **test_gpu_fallback_to_cpu**: Mock torch.cuda.is_available() to return False. Assert training completes on CPU without errors. Verify device in logged MLflow params is "cpu".
- **test_reproducibility**: Train twice with same seed and config. Assert: model weights are identical (torch.allclose), logged metrics match exactly.
- **test_early_stopping**: Train with early stopping patience=2. Feed data that causes val_loss to plateau. Assert training stops before max_epochs.
- **test_hyperparameter_config_validation**: Pass invalid config (negative learning_rate, batch_size=0). Assert Pydantic ValidationError with clear message.

### 4. test_evaluation_pipeline_e2e.py

Test model evaluation:

- **test_model_evaluation_metrics**: Load trained model, run evaluation on test set. Assert: returns dict with accuracy, precision, recall, f1, auc_roc. All values in [0, 1].
- **test_model_comparison**: Evaluate two models (different configs). Assert comparison returns ranked results, best model identified by primary metric.
- **test_evaluation_artifacts_logged**: Run evaluation. Assert MLflow artifacts include: confusion matrix plot, ROC curve plot, classification report JSON, evaluation config.
- **test_evaluation_on_edge_cases**: Evaluate on edge case data: all same class, empty features, single sample. Assert graceful handling with warnings, not crashes.

### 5. test_model_registry_e2e.py

Test MLflow model registry:

- **test_register_model**: Train model → register in MLflow Model Registry. Assert: model version created, model name matches config, artifact URI is valid S3-style path.
- **test_model_stage_transition**: Register model → transition to "Staging". Assert stage is "Staging". Transition to "Production". Assert previous production model (if any) moved to "Archived".
- **test_model_version_metadata**: Register model with metadata (training config hash, data version hash, git commit). Assert all metadata retrievable from registry.
- **test_model_integrity_check**: Register model → load from registry → run inference on sample input. Assert output shape and dtype match expected. This validates SOC 2 artifact integrity.

### 6. test_serving_api_e2e.py

Test the FastAPI serving layer:

- **test_health_endpoint**: GET /health returns 200 with {"status": "healthy", "model_version": "...", "mlflow_connected": true}.
- **test_single_prediction**: POST /predict with valid JSON payload. Assert 200, response has "prediction", "confidence", "model_version", "latency_ms" fields.
- **test_batch_prediction**: POST /predict/batch with list of inputs. Assert 200, response has "predictions" list matching input length, "total_latency_ms".
- **test_prediction_input_validation**: POST /predict with missing required fields. Assert 422 with Pydantic validation error details.
- **test_prediction_with_invalid_types**: POST /predict with string where float expected. Assert 422.
- **test_model_metadata_endpoint**: GET /model/metadata returns model name, version, training date, metrics summary, config hash.
- **test_prediction_audit_logging**: POST /predict. Assert that prediction is logged with: request_id (UUID), timestamp, input hash (not raw input for GDPR), prediction, model_version.
- **test_api_rate_limiting**: Send 100 rapid requests. Assert rate limiter returns 429 after threshold.
- **test_prediction_caching**: Send same input twice. Assert second response has "cached": true and lower latency.
- **test_concurrent_predictions**: Send 20 concurrent async requests. Assert all return 200, no race conditions, response times within SLA.

### 7. test_full_lifecycle_e2e.py

Test the complete pipeline end-to-end:

- **test_complete_ml_lifecycle**: This is the critical E2E test. Steps:
  1. Generate synthetic dataset with known patterns
  2. Run data preprocessing pipeline
  3. Run feature engineering
  4. Store features in feature store (Redis)
  5. Load experiment config from YAML
  6. Train model for N epochs with MLflow tracking
  7. Evaluate model — assert metrics above minimum thresholds
  8. Register model in MLflow Model Registry
  9. Transition model to "Staging"
  10. Start FastAPI serving app with staged model
  11. Send prediction request — assert valid response
  12. Send batch prediction — assert valid responses
  13. Verify all MLflow artifacts present
  14. Verify audit trail entries exist in PostgreSQL
  15. Clean up: delete experiment, deregister model, flush Redis

  This test should be marked \`@pytest.mark.slow\` in addition to \`@pytest.mark.e2e\`.

### 8. test_ab_testing_e2e.py

- **test_ab_traffic_split**: Configure two model versions with 50/50 split. Send 100 requests. Assert each model served approximately 50% (within statistical tolerance ±15%).
- **test_ab_metric_collection**: Run A/B test. Assert per-variant metrics logged: latency_p50, latency_p99, prediction_distribution.
- **test_ab_winner_selection**: Configure A/B test with known better model. Run enough requests. Assert winner selection matches expected model based on primary metric.

### 9. test_data_privacy_e2e.py (GDPR)

- **test_pii_not_in_training_data**: Load processed training data. Assert no columns contain raw PII (email, name, phone, IP). Only anonymized/hashed versions present.
- **test_right_to_deletion**: Insert test user data. Trigger deletion pipeline for user_id. Assert: user data removed from raw storage, features purged from Redis, audit log entry created for deletion.
- **test_consent_enforcement**: Attempt to process data for user without consent flag. Assert pipeline rejects with ConsentRequiredError.
- **test_data_export**: Request data export for user_id. Assert: returns all stored data in JSON format, includes processing history, matches GDPR Article 20 portability requirements.

## Code Style Requirements

- Type hints on ALL public functions (Pydantic models for test data factories)
- snake_case for functions and variables, PascalCase for classes
- SCREAMING_SNAKE_CASE for constants (e.g., MIN_ACCURACY_THRESHOLD = 0.7)
- Use \`# Arrange / Act / Assert\` comments in complex tests
- Docstrings on every test function explaining what pipeline stage is validated
- Import from src/ modules: \`from src.data.preprocessing import PreprocessingPipeline\`
- Use \`@pytest.fixture\` with appropriate scope (session for expensive, function for isolated)
- All async tests use \`@pytest.mark.asyncio\`
- Mark tests: \`@pytest.mark.e2e\`, optionally \`@pytest.mark.slow\`, \`@pytest.mark.gdpr\`
- Keep each file under 300 lines — split if needed

## Test Data Factories

Generate a \`tests/e2e/factories.py\` with:

- \`SyntheticDatasetFactory\`: Generates pandas DataFrames with configurable rows, features, target distribution, optional PII columns
- \`ExperimentConfigFactory\`: Generates valid Pydantic experiment configs with sensible defaults
- \`PredictionRequestFactory\`: Generates valid/invalid API request payloads

Use these factories in fixtures to keep test code DRY.

## Configuration

Generate a \`configs/test/experiment.yaml\` with minimal training config:

\`\`\`yaml
experiment:
  name: "e2e-test"
  seed: 42
model:
  name: "simple_classifier"
  hidden_dims: [32, 16]
  dropout: 0.1
training:
  epochs: 3
  batch_size: 32
  learning_rate: 0.001
  early_stopping:
    patience: 2
    min_delta: 0.001
data:
  train_split: 0.7
  val_split: 0.15
  test_split: 0.15
  features: ["feature_0", "feature_1", "feature_2", "feature_3"]
  target: "label"
\`\`\`

## Running E2E Tests

The generated tests should be runnable with:

\`\`\`bash
# Run all E2E tests
uv run pytest tests/e2e/ -m e2e -v --tb=short

# Run without slow tests
uv run pytest tests/e2e/ -m "e2e and not slow" -v

# Run only GDPR compliance tests
uv run pytest tests/e2e/ -m gdpr -v

# Run with coverage
uv run pytest tests/e2e/ -m e2e --cov=src --cov-report=term-missing --cov-fail-under=75

# Run specific pipeline stage
uv run pytest tests/e2e/test_training_pipeline_e2e.py -v
\`\`\`

## Output

Generate ALL files listed in the directory structure above. Each file should be complete, runnable, and follow the project conventions. Use realistic assertions — not just \`assert True\`. Reference actual src/ module paths. Include proper error messages in assertions for debugging CI failures.

Do NOT generate notebooks. Do NOT use print statements (use pytest capsys or logging). Do NOT hardcode file paths (use tmp_path or fixtures).
\`\`\`

---

## When to Use

- **Phase 06** of the playbook (Testing & Quality)
- After core implementation (Phase 04) and integration hardening (Phase 05) are complete
- When \`src/data/\`, \`src/models/\`, \`src/training/\`, \`src/evaluation/\`, and \`src/serving/\` modules exist
- Before launch (Phase 07) to validate the full pipeline works end-to-end

## Prerequisites

- Unit tests passing (\`uv run pytest tests/unit/ -v\`)
- Integration tests passing (\`uv run pytest tests/integration/ -v\`)
- MLflow tracking server accessible (local or test instance)
- Redis available (local or test instance, or fakeredis installed)
- PostgreSQL available (local or testcontainers)
- At least one trained model checkpoint exists (or the \`trained_model_path\` fixture will create one)

## Expected Output Files

| File | Lines (approx) | Purpose |
|------|----------------|---------|
| \`tests/e2e/conftest.py\` | 120-150 | Shared fixtures, DB setup, MLflow config |
| \`tests/e2e/factories.py\` | 100-130 | Test data factories (dataset, config, request) |
| \`tests/e2e/test_data_pipeline_e2e.py\` | 150-200 | Data ingestion through feature store |
| \`tests/e2e/test_training_pipeline_e2e.py\` | 180-250 | Training lifecycle with MLflow |
| \`tests/e2e/test_evaluation_pipeline_e2e.py\` | 120-150 | Model evaluation and comparison |
| \`tests/e2e/test_model_registry_e2e.py\` | 120-150 | MLflow Model Registry operations |
| \`tests/e2e/test_serving_api_e2e.py\` | 200-280 | FastAPI serving endpoints |
| \`tests/e2e/test_full_lifecycle_e2e.py\` | 150-200 | Complete pipeline orchestration |
| \`tests/e2e/test_ab_testing_e2e.py\` | 100-130 | A/B testing infrastructure |
| \`tests/e2e/test_data_privacy_e2e.py\` | 120-150 | GDPR compliance validation |
| \`configs/test/experiment.yaml\` | 25-30 | Minimal test experiment config |

## Validation Checklist

After generation, verify:

- [ ] \`uv run ruff check tests/e2e/\` passes with no errors
- [ ] \`uv run ruff format --check tests/e2e/\` passes
- [ ] \`uv run mypy tests/e2e/\` passes in strict mode
- [ ] All files under 300 lines
- [ ] All public functions have type hints
- [ ] All test functions have docstrings
- [ ] Markers applied: \`@pytest.mark.e2e\`, \`@pytest.mark.slow\`, \`@pytest.mark.gdpr\`
- [ ] No hardcoded paths, credentials, or real PII
- [ ] Factories use Pydantic models for validation
- [ ] GDPR tests validate anonymization, deletion, consent, and export
- [ ] SOC 2 audit trail assertions present in serving and registry tests
- [ ] MLflow cleanup in fixtures prevents test pollution

## Related Prompts

- \`playbook/prompts/06/test-suite-generator.md\` — Unit and integration test generation
- \`playbook/prompts/06/load-test.md\` — Performance and load testing for serving API
- \`playbook/prompts/05/security-hardening.md\` — Security patterns validated by E2E tests
- \`playbook/prompts/05/observability-setup.md\` — Monitoring validated by E2E audit trail tests
- \`playbook/prompts/04/feature-implementation.md\` — Source modules under test`,

  'playbook/prompts/06/load-test.md': `# Load Test — Phase 06: Testing & Quality

## Prompt for Claude Code

You are an ML pipeline load testing engineer working on the **ml-pipeline** project. Your task is to design and implement comprehensive load tests for the FastAPI model serving layer, batch inference endpoints, and supporting infrastructure (Redis feature store, PostgreSQL metadata, MLflow model registry).

## Context

Review the current serving implementation and infrastructure:

\`\`\`
cat src/serving/app.py
cat src/serving/inference.py
cat src/serving/batch.py
cat configs/production/serving.yaml
ls tests/load/
cat docker-compose.yaml
\`\`\`

## Requirements

### 1. Locust Load Test Suite for Model Serving

Create \`tests/load/locustfile.py\` targeting the FastAPI serving endpoints:

\`\`\`python
"""
Load tests for ml-pipeline model serving API.

Endpoints under test:
  - GET  /health              (readiness + liveness)
  - GET  /models              (list available models)
  - POST /predict             (single inference)
  - POST /predict/batch       (batch inference, up to 1000 items)
  - POST /features/lookup     (Redis feature store lookup)
  - GET  /metrics             (Prometheus metrics endpoint)

Run:
  uv run locust -f tests/load/locustfile.py --host=http://localhost:8000
  uv run locust -f tests/load/locustfile.py --host=http://localhost:8000 --headless -u 200 -r 20 -t 5m --csv=results/load
"""
\`\`\`

Include these user behavior classes:

- **OnlineInferenceUser** — simulates real-time prediction requests:
  - Weighted tasks: 60% single predict, 20% batch predict (10-50 items), 10% feature lookup, 10% health check
  - Realistic payload generation using Pydantic model schemas from \`src/serving/schemas.py\`
  - Wait time between 100ms and 2s (modeling real API consumers)
  - Validate response schemas, not just status codes
  - Track custom metrics: inference latency p50/p95/p99, model version served, GPU utilization if available

- **BatchProcessingUser** — simulates batch inference workloads:
  - Large batch requests (100-1000 items)
  - Longer wait times (5-30s between requests)
  - Validate all items in batch response have predictions
  - Track throughput (items/second)

- **MonitoringUser** — simulates monitoring/observability polling:
  - Health checks every 5s
  - Metrics scraping every 15s
  - Model list refresh every 60s

### 2. Payload Generator

Create \`tests/load/payload_generator.py\`:

- Generate realistic feature vectors matching the model's expected input schema
- Use Pydantic models from \`src/serving/schemas.py\` for validation
- Support configurable feature dimensions and data distributions
- Generate both valid and edge-case payloads (missing features, out-of-range values, NaN handling)
- Seed random generators for reproducibility
- Example:

\`\`\`python
from pydantic import BaseModel
from typing import Any

class PredictionRequest(BaseModel):
    features: dict[str, Any]
    model_name: str = "default"
    model_version: str | None = None

def generate_prediction_payload(
    feature_config: dict[str, Any],
    model_name: str = "default",
    seed: int | None = None,
) -> PredictionRequest:
    """Generate a realistic prediction request payload."""
    ...

def generate_batch_payload(
    feature_config: dict[str, Any],
    batch_size: int = 50,
    model_name: str = "default",
    seed: int | None = None,
) -> list[PredictionRequest]:
    """Generate a batch of prediction request payloads."""
    ...
\`\`\`

### 3. Performance Thresholds Configuration

Create \`tests/load/thresholds.yaml\`:

\`\`\`yaml
# Performance SLOs for ml-pipeline serving layer
# These thresholds gate deployment in CI/CD

endpoints:
  predict:
    p50_latency_ms: 50
    p95_latency_ms: 150
    p99_latency_ms: 500
    error_rate_percent: 0.1
    min_rps: 100

  predict_batch:
    p50_latency_ms: 500
    p95_latency_ms: 2000
    p99_latency_ms: 5000
    error_rate_percent: 0.5
    min_rps: 10
    max_batch_size: 1000

  features_lookup:
    p50_latency_ms: 5
    p95_latency_ms: 20
    p99_latency_ms: 50
    error_rate_percent: 0.01

  health:
    p50_latency_ms: 5
    p95_latency_ms: 10
    p99_latency_ms: 50
    error_rate_percent: 0.0

global:
  max_concurrent_users: 200
  ramp_up_rate: 20  # users per second
  test_duration_seconds: 300
  max_cpu_percent: 80
  max_memory_percent: 85
  max_gpu_memory_percent: 90
\`\`\`

### 4. Threshold Validator Script

Create \`tests/load/validate_thresholds.py\`:

- Parse Locust CSV output (\`results/load_stats.csv\`, \`results/load_stats_history.csv\`)
- Compare against \`tests/load/thresholds.yaml\`
- Output pass/fail for each SLO
- Return non-zero exit code if any threshold is breached
- Generate a markdown summary report for PR comments
- Log results to MLflow as a "load-test" experiment run for tracking over time

\`\`\`python
def validate_load_test_results(
    stats_csv: Path,
    thresholds_yaml: Path,
    mlflow_experiment: str = "load-tests",
) -> bool:
    """Validate load test results against SLO thresholds.

    Returns True if all thresholds pass, False otherwise.
    Logs results to MLflow for historical tracking.
    """
    ...
\`\`\`

### 5. Redis and PostgreSQL Stress Tests

Create \`tests/load/infra_stress.py\`:

- **Redis feature store stress test**:
  - Concurrent feature lookups simulating prediction preprocessing
  - Test cache hit/miss ratios under load
  - Measure Redis latency at various connection pool sizes
  - Test feature store TTL behavior under write pressure

- **PostgreSQL metadata stress test**:
  - Concurrent reads of model metadata and experiment configs
  - Simulate MLflow backend store queries under load
  - Test connection pool exhaustion scenarios
  - Measure query latency for common access patterns

### 6. GPU Inference Load Test

Create \`tests/load/gpu_inference.py\`:

- Test PyTorch model inference throughput on GPU instances
- Measure GPU memory usage, utilization, and thermal throttling
- Test concurrent inference requests with different batch sizes
- Compare CPU vs GPU inference latency at various concurrency levels
- Track CUDA memory allocation patterns for leak detection
- Output results compatible with Prometheus/Grafana dashboards

\`\`\`python
import torch
from src.models import load_model
from src.serving.inference import InferencePipeline

def benchmark_gpu_inference(
    model_name: str,
    batch_sizes: list[int] = [1, 8, 32, 64, 128, 256],
    num_iterations: int = 100,
    device: str = "cuda",
    warmup_iterations: int = 10,
) -> dict[str, Any]:
    """Benchmark model inference on GPU with various batch sizes."""
    ...
\`\`\`

### 7. GitHub Actions Integration

Create \`tests/load/run_load_tests.sh\`:

\`\`\`bash
#!/usr/bin/env bash
# Run load tests in CI/CD pipeline
# Usage: ./tests/load/run_load_tests.sh [--env staging|production] [--duration 300]

set -euo pipefail

# Start services with docker-compose
# Run Locust in headless mode
# Validate thresholds
# Upload results to MLflow
# Generate PR comment with summary
# Exit with appropriate code
\`\`\`

Add the load test stage to \`.github/workflows/\` that:
- Runs after integration tests pass
- Spins up the serving stack via docker-compose
- Executes load tests with Locust in headless mode
- Validates results against thresholds
- Posts results summary as a PR comment
- Logs metrics to MLflow experiment "ci-load-tests"
- Fails the pipeline if SLOs are breached
- Archives Locust CSV reports and HTML as artifacts

### 8. Model A/B Testing Under Load

Create \`tests/load/ab_test_load.py\`:

- Simulate traffic split between model versions (e.g., 90/10, 50/50)
- Verify traffic routing percentages hold under load
- Compare latency distributions between model versions
- Track prediction distribution drift between versions
- Validate that model version headers are correctly propagated

## Constraints

- All test files must have type hints on public functions
- Use Pydantic for all configuration and payload validation
- Pin Locust version in \`pyproject.toml\` under \`[project.optional-dependencies]\` load group
- Follow snake_case naming for files and functions, PascalCase for classes
- Maximum 300 lines per file — split into modules as needed
- Ensure no PII or real user data in test payloads (GDPR compliance)
- All generated test data must use synthetic/anonymized values
- Log no sensitive information (API keys, credentials) in test output (SOC 2)
- Seed all random generators for reproducible test runs
- Store load test results in \`results/load/\` (gitignored, DVC-tracked for historical comparison)

## Validation

After implementation, verify:

\`\`\`bash
# Lint and type check
uv run ruff check tests/load/
uv run mypy tests/load/

# Run a quick smoke load test (10 users, 30 seconds)
uv run locust -f tests/load/locustfile.py --host=http://localhost:8000 --headless -u 10 -r 5 -t 30s --csv=results/load/smoke

# Validate thresholds
uv run python tests/load/validate_thresholds.py --stats results/load/smoke_stats.csv --thresholds tests/load/thresholds.yaml

# Run GPU benchmark (if GPU available)
uv run python tests/load/gpu_inference.py --model default --device cuda

# Run infrastructure stress tests
uv run python tests/load/infra_stress.py --redis-url redis://localhost:6379 --pg-url postgresql://localhost:5432/mlflow
\`\`\`

## Output

Provide all files listed above with complete, working implementations. Mark each file with \`<!-- AI-generated -->\` in a comment at the top. Ensure the load test suite is ready to run in both local development and CI/CD environments.`,

  'playbook/prompts/06/test-suite-generator.md': `# Test Suite Generator — Phase 06: Testing & Quality

## Prompt for Claude Code

Copy and paste the following prompt into Claude Code to generate a comprehensive test suite for a module or component in the ml-pipeline project.

---

You are an ML test engineer working on the **ml-pipeline** project — a PyTorch-based ML pipeline with MLflow experiment tracking, DVC data versioning, and FastAPI model serving.

## Task

Generate a comprehensive test suite for the following module or component:

**Module under test**: \`{MODULE_PATH}\` (e.g., \`src/training/trainer.py\`, \`src/serving/app.py\`, \`src/data/feature_engineering.py\`)

**Module description**: {BRIEF_DESCRIPTION}

## Project Context

- **Language**: Python 3.11+ with strict type hints
- **Test framework**: pytest with pytest-cov, pytest-asyncio, pytest-mock
- **ML framework**: PyTorch (models, tensors, dataloaders)
- **Serving**: FastAPI (use httpx.AsyncClient / TestClient)
- **Config**: Pydantic models validated from YAML
- **Experiment tracking**: MLflow (mock in unit tests, real in integration)
- **Data versioning**: DVC (mock data paths in tests)
- **Coverage threshold**: 75% minimum
- **Linting**: ruff, mypy strict mode
- **Run command**: \`uv run pytest tests/ -v --cov=src --cov-report=term-missing\`

## Test Categories to Generate

### 1. Unit Tests (\`tests/unit/\`)

Generate isolated unit tests that:

- Test each public function and method independently
- Mock all external dependencies (MLflow, S3, PostgreSQL, Redis, filesystem)
- Mock PyTorch components where appropriate (use small tensors, CPU only)
- Use \`pytest.fixture\` for reusable test data and mock objects
- Use \`pytest.mark.parametrize\` for input variations and edge cases
- Test Pydantic config validation (valid configs, invalid configs, missing fields)
- Test error handling paths (invalid inputs, missing data, corrupt files)
- Test type contracts — verify return types match type hints
- Follow naming: \`test_{function_name}_{scenario}_{expected_result}\`

### 2. Integration Tests (\`tests/integration/\`)

Generate integration tests that:

- Test component interactions (e.g., data pipeline → feature store → training)
- Use real PyTorch operations on small synthetic datasets (CPU, tiny models)
- Test FastAPI endpoints with \`httpx.AsyncClient\` or \`TestClient\`
- Test MLflow logging integration (use temp tracking URI or mock server)
- Test DVC pipeline stage outputs (mock DVC, verify file contracts)
- Test database interactions with test fixtures (PostgreSQL, Redis)
- Mark with \`@pytest.mark.integration\` for selective execution
- Mark slow tests with \`@pytest.mark.slow\`

### 3. ML-Specific Tests (\`tests/ml/\`)

Generate ML-focused tests that:

- **Model architecture tests**: Verify output shapes, parameter counts, forward pass with random input
- **Training loop tests**: Verify loss decreases over N steps on synthetic data (overfitting test)
- **Data pipeline tests**: Verify transforms produce expected shapes and dtypes
- **Feature engineering tests**: Verify feature outputs are deterministic given same input and seed
- **Reproducibility tests**: Same seed + config → same model outputs (torch.manual_seed)
- **Numerical stability tests**: Test with edge-case inputs (zeros, very large values, NaN handling)
- **Serialization tests**: Save and load model checkpoint, verify identical predictions
- **Config-driven tests**: Load experiment YAML config, verify pipeline runs end-to-end on tiny data
- Mark with \`@pytest.mark.ml\`

### 4. API / Serving Tests (\`tests/api/\`)

Generate API tests that:

- Test all FastAPI endpoints (health, predict, batch predict, model info)
- Test request validation (valid payloads, malformed JSON, missing fields, wrong types)
- Test response schemas match Pydantic response models
- Test authentication/authorization if applicable
- Test rate limiting and error responses (4xx, 5xx)
- Test async inference endpoints with \`pytest-asyncio\`
- Test model loading and warm-up on startup
- Test graceful degradation when model is unavailable
- Mark with \`@pytest.mark.api\`

## Test Fixtures to Create

Generate a \`conftest.py\` at each test directory level with:

\`\`\`python
# tests/conftest.py — shared fixtures

import pytest
import torch
import numpy as np
from pathlib import Path
from unittest.mock import MagicMock, patch
from fastapi.testclient import TestClient

# Reproducibility
@pytest.fixture(autouse=True)
def set_random_seeds():
    """Ensure reproducible tests."""
    torch.manual_seed(42)
    np.random.seed(42)
    yield

# Synthetic data
@pytest.fixture
def sample_batch():
    """Small synthetic batch for testing (CPU only)."""
    batch_size, input_dim = 8, 64
    return {
        "features": torch.randn(batch_size, input_dim),
        "labels": torch.randint(0, 2, (batch_size,)),
    }

# Pydantic config fixtures
@pytest.fixture
def training_config():
    """Valid training configuration for tests."""
    # Return a valid TrainingConfig Pydantic model
    ...

# Temp directories for artifacts
@pytest.fixture
def tmp_model_dir(tmp_path):
    """Temporary directory for model checkpoints."""
    model_dir = tmp_path / "models"
    model_dir.mkdir()
    return model_dir

@pytest.fixture
def tmp_data_dir(tmp_path):
    """Temporary directory for test data."""
    data_dir = tmp_path / "data"
    data_dir.mkdir()
    return data_dir

# MLflow mock
@pytest.fixture
def mock_mlflow():
    """Mock MLflow tracking to avoid external calls in unit tests."""
    with patch("mlflow.start_run"), \\
         patch("mlflow.log_params"), \\
         patch("mlflow.log_metrics"), \\
         patch("mlflow.log_artifact"), \\
         patch("mlflow.pytorch.log_model"):
        yield

# Redis mock
@pytest.fixture
def mock_redis():
    """Mock Redis client for feature store tests."""
    mock = MagicMock()
    mock.get.return_value = None
    mock.set.return_value = True
    return mock

# FastAPI test client
@pytest.fixture
def api_client():
    """FastAPI TestClient for API tests."""
    from src.serving.app import create_app
    app = create_app()
    return TestClient(app)
\`\`\`

## Output Structure

Generate the following files:

\`\`\`
tests/
  conftest.py                          # Shared fixtures (as above)
  unit/
    conftest.py                        # Unit-specific fixtures
    test_{module_name}.py              # Unit tests for the target module
  integration/
    conftest.py                        # Integration-specific fixtures
    test_{module_name}_integration.py  # Integration tests
  ml/
    conftest.py                        # ML-specific fixtures (synthetic datasets)
    test_{module_name}_ml.py           # ML-specific tests
  api/
    conftest.py                        # API-specific fixtures (test client)
    test_{module_name}_api.py          # API endpoint tests (if serving module)
\`\`\`

## Code Quality Requirements

- All test functions must have type hints on parameters and return \`None\`
- All test files must pass \`uv run ruff check\` and \`uv run mypy tests/\`
- Use \`pytest.raises\` for expected exceptions with match patterns
- Use \`pytest.approx\` for floating-point comparisons (ML metrics)
- No hardcoded file paths — use \`tmp_path\` fixture or \`tmp_model_dir\`/\`tmp_data_dir\`
- No GPU dependencies — all tests run on CPU with small tensors
- No network calls in unit tests — mock all external services
- Each test file must stay under 300 lines; split into multiple files if needed
- Add docstrings to test classes and complex test functions
- Group related tests in classes: \`class TestTrainerInit:\`, \`class TestTrainerFit:\`

## Pytest Markers Configuration

Ensure \`pyproject.toml\` includes:

\`\`\`toml
[tool.pytest.ini_options]
markers = [
    "unit: Unit tests (fast, isolated)",
    "integration: Integration tests (may use real services)",
    "ml: ML-specific tests (model training, inference)",
    "api: API endpoint tests",
    "slow: Slow tests (training loops, large data)",
]
testpaths = ["tests"]
asyncio_mode = "auto"
\`\`\`

## GDPR & SOC 2 Test Considerations

- Test that PII fields are anonymized in logged metrics and artifacts
- Test that model artifacts do not embed raw training data
- Test that API responses do not leak internal model details or stack traces
- Test that prediction logs redact sensitive input features
- Verify experiment configs do not contain secrets or credentials

## Example Test Patterns

For a training module, I expect tests like:

\`\`\`python
class TestTrainer:
    """Tests for the Trainer class."""

    def test_init_with_valid_config(self, training_config: TrainingConfig) -> None:
        """Trainer initializes correctly with valid Pydantic config."""
        trainer = Trainer(config=training_config)
        assert trainer.config == training_config
        assert trainer.device == torch.device("cpu")

    def test_init_rejects_invalid_learning_rate(self) -> None:
        """Trainer raises ValidationError for negative learning rate."""
        with pytest.raises(ValidationError, match="learning_rate"):
            TrainingConfig(learning_rate=-0.01, ...)

    @pytest.mark.parametrize("batch_size", [1, 8, 32])
    def test_train_step_returns_loss(
        self, trainer: Trainer, sample_batch: dict, batch_size: int
    ) -> None:
        """Single training step returns a finite scalar loss."""
        loss = trainer.train_step(sample_batch)
        assert isinstance(loss, float)
        assert np.isfinite(loss)

    @pytest.mark.ml
    def test_loss_decreases_over_steps(
        self, trainer: Trainer, synthetic_dataset: Dataset
    ) -> None:
        """Loss decreases when overfitting on a tiny synthetic dataset."""
        losses = trainer.fit(synthetic_dataset, max_steps=50)
        assert losses[-1] < losses[0], "Loss should decrease during overfitting test"

    @pytest.mark.ml
    def test_checkpoint_roundtrip(
        self, trainer: Trainer, tmp_model_dir: Path, sample_batch: dict
    ) -> None:
        """Model produces identical outputs after save/load cycle."""
        pred_before = trainer.predict(sample_batch["features"])
        trainer.save_checkpoint(tmp_model_dir / "model.pt")
        trainer.load_checkpoint(tmp_model_dir / "model.pt")
        pred_after = trainer.predict(sample_batch["features"])
        assert torch.allclose(pred_before, pred_after)
\`\`\`

## Run After Generation

\`\`\`bash
# Verify tests pass linting
uv run ruff check tests/
uv run mypy tests/

# Run unit tests only
uv run pytest tests/unit/ -v -m unit

# Run all tests with coverage
uv run pytest tests/ -v --cov=src --cov-report=term-missing --cov-fail-under=75

# Run ML-specific tests
uv run pytest tests/ml/ -v -m ml

# Run API tests
uv run pytest tests/api/ -v -m api
\`\`\`

Now generate the complete test suite for \`{MODULE_PATH}\`. Start with \`tests/conftest.py\`, then generate each test file. Ensure every public function in the module has at least one happy-path test and one error-path test.`,

  'playbook/prompts/07/go-live-checklist.md': `# Go-Live Checklist — Phase 07 Launch

> **Copy-paste this prompt into Claude Code when preparing the ml-pipeline for production launch.**

---

You are helping launch the **ml-pipeline** project to production. This is a PyTorch-based ML pipeline with MLflow experiment tracking, DVC data versioning, and FastAPI model serving, deployed on AWS (ECS/SageMaker). The team follows GitHub Flow with conventional commits.

## Context

Review the current state of the project by examining:

1. \`playbook/current-phase.json\` — confirm we are in Phase 07 (Launch)
2. \`playbook/phases/07-launch.md\` — review launch phase requirements
3. \`configs/production/\` — production configuration files
4. \`.github/workflows/\` — CI/CD pipeline definitions
5. \`src/serving/\` — FastAPI model serving application
6. \`dvc.yaml\` and \`dvc.lock\` — data pipeline definitions and lock state
7. \`pyproject.toml\` — dependency versions and project metadata
8. \`docs/\` — architecture docs, runbooks, experiment logs

## Go-Live Checklist Generation

Generate a comprehensive \`docs/go-live-checklist.md\` organized into the following sections. For each item, include a checkbox \`- [ ]\`, the check description, the command or file to verify, and the acceptance criteria.

---

### Section 1: Code Quality & Static Analysis

Verify all code quality gates pass before launch:

- **Linting**: \`uv run ruff check src/ tests/ scripts/\` — zero violations
- **Formatting**: \`uv run ruff format --check src/ tests/\` — no formatting changes needed
- **Type checking**: \`uv run mypy src/ --strict\` — zero errors
- **No TODO/FIXME in production code**: grep \`src/\` for unresolved items (notebooks excluded)
- **File length compliance**: no file in \`src/\` exceeds 300 lines
- **All public functions have type hints**: verify with mypy strict mode
- **No unused imports or dead code**: ruff rules F401, F841 passing
- **Pydantic configs validated**: all YAML configs in \`configs/production/\` parse without error

### Section 2: Test Suite & Coverage

- **Unit tests pass**: \`uv run pytest tests/unit/ -v --tb=short\` — all green
- **Integration tests pass**: \`uv run pytest tests/integration/ -v --tb=short\` — all green
- **API tests pass**: \`uv run pytest tests/api/ -v --tb=short\` — all green
- **Model tests pass**: \`uv run pytest tests/models/ -v\` — model load/inference/serialization verified
- **Coverage threshold met**: \`uv run pytest --cov=src --cov-report=term-missing --cov-fail-under=75\` — ≥75%
- **Async tests pass**: \`uv run pytest tests/ -k async --asyncio-mode=auto\` — all async FastAPI endpoints tested
- **Smoke training test**: \`uv run python scripts/train_smoke.py --config configs/test/smoke.yaml\` — completes without error, logs to MLflow
- **DVC pipeline reproducible**: \`dvc repro --dry\` — DAG is up to date or changes are intentional

### Section 3: ML Model Validation

- **Model registered in MLflow**: verify production model exists in MLflow Model Registry with stage \`Production\`
- **Model version pinned**: \`configs/production/serving.yaml\` references a specific model version or run ID, not \`latest\`
- **Model metrics meet thresholds**: check MLflow run metrics against acceptance criteria defined in \`configs/production/model_thresholds.yaml\`
- **Model artifact integrity**: verify SHA256 checksum of model artifacts matches DVC lock file (\`dvc status\` shows no changes)
- **Inference latency benchmark**: \`uv run pytest tests/performance/test_inference_latency.py\` — p50 < 50ms, p99 < 200ms on target hardware
- **Model input/output schema validated**: Pydantic request/response models in \`src/serving/schemas.py\` match training data schema
- **Feature pipeline consistency**: features generated by \`src/data/feature_engineering.py\` match training-time feature definitions (no training-serving skew)
- **Fallback model configured**: verify \`configs/production/serving.yaml\` has \`fallback_model_version\` set for rollback
- **A/B test configuration**: if A/B testing is enabled, verify traffic split config in \`configs/production/ab_test.yaml\`

### Section 4: Data Pipeline & DVC

- **DVC remote configured**: \`dvc remote list\` shows S3 remote with correct bucket
- **DVC lock file committed**: \`dvc.lock\` is up to date and committed to \`main\`
- **Data pipeline DAG valid**: \`dvc dag\` renders without errors
- **Raw data not in git**: verify \`data/\` is in \`.gitignore\` and tracked only by DVC
- **S3 data accessible**: \`dvc pull --dry\` succeeds with production AWS credentials
- **Feature store populated**: Redis feature store has current feature vectors (check via \`scripts/verify_feature_store.py\`)
- **Data schema versioned**: \`configs/data/schema_v*.yaml\` exists for current data format

### Section 5: Infrastructure & Deployment

- **Docker image builds**: \`docker build -t ml-pipeline:latest -f Dockerfile .\` — succeeds
- **Docker image scanned**: \`docker scan ml-pipeline:latest\` or Trivy — no critical/high vulnerabilities
- **Image pushed to ECR**: verify image tag in AWS ECR matches release version
- **Terraform plan clean**: \`cd infra && terraform plan\` — no unexpected changes
- **ECS service healthy**: ECS task definition references correct image tag, desired count ≥ 2
- **Health endpoint responds**: \`curl https://<production-url>/health\` returns \`{"status": "healthy", "model_version": "..."}\`
- **GPU instances available** (if applicable): verify EC2 GPU instance quota and SageMaker endpoint configuration
- **Auto-scaling configured**: ECS service auto-scaling policies set for CPU/memory and request count
- **Load balancer configured**: ALB health checks targeting \`/health\` with appropriate thresholds

### Section 6: Configuration & Secrets

- **No secrets in code**: \`uv run ruff check\` + grep for hardcoded keys, passwords, tokens in \`src/\`, \`configs/\`, \`scripts/\`
- **Environment variables documented**: \`docs/environment-variables.md\` lists all required env vars for production
- **Production config validated**: \`uv run python -c "from src.utils.config import load_config; load_config('configs/production/main.yaml')"\` — Pydantic validation passes
- **AWS credentials configured**: IAM roles for ECS tasks have least-privilege access to S3, ECR, SageMaker, CloudWatch
- **MLflow tracking URI set**: production config points to production MLflow server, not local/staging
- **Redis connection verified**: production Redis endpoint is reachable and authenticated
- **PostgreSQL connection verified**: production database is reachable, migrations applied
- **\`.env\` files excluded**: \`.env*\` patterns in \`.gitignore\`, no \`.env\` files committed

### Section 7: Security & Compliance

- **SOC 2 controls verified**:
  - Access logging enabled on S3 buckets storing model artifacts and training data
  - CloudTrail enabled for API audit trail
  - IAM roles follow least-privilege principle
  - Encryption at rest enabled for S3, RDS, Redis
  - Encryption in transit (TLS) for all endpoints
- **GDPR compliance verified**:
  - Training data anonymization pipeline documented and validated
  - Data retention policies configured (S3 lifecycle rules)
  - Right-to-deletion workflow tested (\`scripts/gdpr_delete.py\` functional)
  - Data processing consent tracking in PostgreSQL metadata
  - No PII in MLflow experiment logs or model artifacts
- **Dependency audit**: \`uv run pip-audit\` — no known vulnerabilities in pinned dependencies
- **API authentication**: FastAPI endpoints require valid API keys or JWT tokens (except \`/health\`)
- **Rate limiting configured**: FastAPI middleware or ALB rules limit request rate per client
- **CORS policy restricted**: \`src/serving/app.py\` CORS origins limited to known consumers
- **Model artifact signing**: model checksums stored in MLflow and verified at serving load time

### Section 8: Observability & Monitoring

- **Prometheus metrics exposed**: \`/metrics\` endpoint on FastAPI serves request count, latency histograms, model prediction distributions
- **Grafana dashboards deployed**: dashboards for API latency, throughput, error rate, model drift, GPU utilization
- **Alerting rules configured**:
  - API error rate > 1% for 5 minutes
  - p99 latency > 500ms for 5 minutes
  - Model prediction distribution drift (KL divergence threshold)
  - ECS task unhealthy or restarting
  - DVC pipeline failure
  - MLflow server unreachable
- **Structured logging**: all \`src/\` modules use structured JSON logging via \`src/utils/logging.py\`
- **Log aggregation**: CloudWatch log groups configured for ECS tasks, queryable
- **MLflow UI accessible**: production MLflow UI reachable by team, experiments and model registry populated
- **Distributed tracing**: request IDs propagated through inference pipeline for debugging

### Section 9: Documentation & Runbooks

- **Architecture doc current**: \`docs/architecture.md\` reflects production topology
- **API documentation**: FastAPI auto-docs at \`/docs\` are accurate and complete
- **Runbook: model rollback**: \`docs/runbooks/model-rollback.md\` — step-by-step to revert to previous model version
- **Runbook: data pipeline failure**: \`docs/runbooks/dvc-pipeline-failure.md\` — how to diagnose and re-run DVC stages
- **Runbook: incident response**: \`docs/runbooks/incident-response.md\` — escalation path, communication template
- **Runbook: scaling**: \`docs/runbooks/scaling.md\` — how to scale ECS tasks, switch to larger GPU instances
- **Experiment log**: \`docs/experiments/\` contains summaries of key experiments leading to production model
- **CODEOWNERS file**: \`.github/CODEOWNERS\` covers \`configs/production/**\`, \`models/**\`, \`src/serving/**\`, \`data/**\`
- **CHANGELOG updated**: \`CHANGELOG.md\` has entry for this release with model version and key changes
- **README current**: \`README.md\` has setup instructions, architecture overview, and quick-start commands

### Section 10: Release Process

- **Branch is \`main\`**: all changes merged via approved PRs, no direct commits
- **CI pipeline green**: all GitHub Actions stages pass — lint, type check, tests, build, smoke train, deploy staging
- **Staging validated**: staging environment tested with production-like traffic, model predictions verified
- **Release tag created**: \`git tag -a v1.0.0 -m "Production launch: model v<X>, dataset v<Y>"\`
- **Docker image tagged**: ECR image tagged with release version (not just \`latest\`)
- **DVC artifacts pushed**: \`dvc push\` — all data and model artifacts synced to S3 remote
- **MLflow model stage promoted**: production model transitioned from \`Staging\` to \`Production\` in registry
- **Rollback plan documented**: team knows how to revert ECS to previous task definition and MLflow model version
- **Team notified**: Slack channel \`#ml-pipeline\` notified of go-live with release notes link
- **Post-launch monitoring window**: 2-hour watch period assigned, team member on-call identified

---

## Output Format

Generate \`docs/go-live-checklist.md\` as a clean Markdown file with:

1. A header with project name, target release version (read from \`pyproject.toml\`), and date placeholder
2. All sections above with checkboxes
3. A sign-off section at the bottom with fields for:
   - **Prepared by**: (name, date)
   - **ML Lead approval**: (name, date)
   - **Infrastructure approval**: (name, date)
   - **Go/No-Go decision**: (GO / NO-GO)
   - **Launch timestamp**: (UTC)

## Additional Instructions

- If any config files referenced don't exist yet, create stub versions with TODO comments
- If any test directories referenced don't exist, note them as items to create before launch
- Cross-reference \`playbook/phases/07-launch.md\` for phase-specific requirements
- Flag any items that are blockers (must-have) vs. nice-to-have with \`[BLOCKER]\` or \`[RECOMMENDED]\` tags
- After generating the checklist, run \`uv run ruff check src/\` and \`uv run pytest tests/ --co -q\` to verify current project state and note any immediate issues at the top of the checklist`,

  'playbook/prompts/07/monitoring-setup.md': `# Monitoring Setup — Phase 07 Launch Prompt

> Copy-paste this prompt into Claude Code to set up production monitoring, alerting, and ML-specific observability for the ml-pipeline project.

---

## Prompt

\`\`\`
You are helping set up production monitoring, alerting, and ML observability for the ml-pipeline project — a PyTorch-based ML pipeline with MLflow experiment tracking, DVC data versioning, and FastAPI model serving.

## Context

Review these files to understand the current system:
- src/serving/ (FastAPI model serving app)
- src/training/ (training loops, callbacks)
- src/evaluation/ (metrics, model comparison)
- configs/ (YAML experiment and deployment configs)
- docs/ (architecture docs, runbooks)
- playbook/prompts/05/observability-setup.md (existing observability foundation)
- playbook/prompts/07/runbook-generator.md (runbook patterns)
- .github/workflows/ (CI/CD pipelines)

## Requirements

### 1. Infrastructure Monitoring (Prometheus + Grafana)

Create \`configs/monitoring/prometheus.yml\`:
- Scrape targets for FastAPI serving endpoints (metrics at /metrics)
- Scrape targets for MLflow server
- Scrape targets for PostgreSQL exporter (MLflow backend store)
- Scrape targets for Redis exporter (feature store / cache)
- Scrape targets for NVIDIA GPU exporter (dcgm-exporter) on training nodes
- Scrape interval: 15s for serving, 30s for training infrastructure
- Relabeling rules to tag by environment (staging, production)
- Alert manager configuration pointing to our alertmanager instance

Create \`configs/monitoring/alertmanager.yml\`:
- Route alerts to Slack channel #ml-pipeline-alerts
- Group alerts by severity (critical, warning, info)
- Critical alerts: 5-minute group wait, repeat every 1 hour
- Warning alerts: 10-minute group wait, repeat every 4 hours
- Inhibition rules: critical inhibits warning for same service
- Silence configuration for planned maintenance windows

### 2. ML-Specific Metrics (Custom Prometheus Metrics)

Create \`src/serving/metrics.py\`:
- Use prometheus_client library
- Histogram: \`model_prediction_latency_seconds\` (labels: model_name, model_version, endpoint)
- Counter: \`model_predictions_total\` (labels: model_name, model_version, status)
- Gauge: \`model_loaded_version\` (labels: model_name)
- Histogram: \`feature_preprocessing_latency_seconds\` (labels: pipeline_stage)
- Counter: \`prediction_errors_total\` (labels: model_name, error_type)
- Gauge: \`model_confidence_score\` (labels: model_name, bucket) — track confidence distribution
- Summary: \`batch_inference_duration_seconds\` (labels: model_name, batch_size_bucket)
- Counter: \`data_validation_failures_total\` (labels: validation_type, field)
- Gauge: \`feature_store_cache_hit_ratio\` (labels: feature_group)
- All metrics must have docstrings and use proper label conventions
- Include a \`setup_metrics()\` function and a \`metrics_middleware\` for FastAPI

Create \`src/serving/model_health.py\`:
- Health check endpoint that validates:
  - Model is loaded and responsive (warm inference on reference input)
  - Model version matches expected version from MLflow registry
  - Feature store (Redis) is reachable
  - PostgreSQL metadata store is reachable
  - GPU memory utilization (if GPU serving)
- Return structured health response with component statuses
- Use Pydantic models for health check response schema
- Include readiness probe (model loaded) and liveness probe (process alive) endpoints
- Type hints on all public functions

### 3. Model Performance Monitoring (Data/Concept Drift)

Create \`src/evaluation/drift_detection.py\`:
- Implement statistical drift detection for model inputs:
  - Kolmogorov-Smirnov test for continuous features
  - Chi-squared test for categorical features
  - Population Stability Index (PSI) for distribution comparison
  - Jensen-Shannon divergence for probability distributions
- Compare incoming prediction request features against training data distribution
- Store reference distributions from training data (loaded from DVC-tracked artifacts)
- Configurable drift thresholds via Pydantic config model
- Log drift metrics to both Prometheus and MLflow
- Type hints on all public functions
- Use numpy and scipy.stats — no additional heavy dependencies

Create \`src/evaluation/prediction_monitor.py\`:
- Track prediction distribution over time windows (1h, 6h, 24h)
- Detect prediction drift (output distribution shift)
- Monitor confidence score distribution — alert on sudden drops
- Track feature value ranges — alert on out-of-range inputs
- Log anomalous predictions for manual review
- Store monitoring snapshots to S3 via DVC for audit trail (GDPR/SOC 2)
- Async-compatible for use in FastAPI request lifecycle
- Type hints on all public functions

### 4. Grafana Dashboards

Create \`configs/monitoring/dashboards/model-serving.json\`:
- Grafana dashboard JSON for model serving:
  - Panel: Request rate (requests/sec by model version)
  - Panel: Prediction latency (p50, p95, p99 by model)
  - Panel: Error rate (4xx, 5xx by endpoint)
  - Panel: Model confidence distribution (heatmap)
  - Panel: Active model versions
  - Panel: Feature preprocessing latency breakdown
  - Panel: Batch inference throughput
  - Panel: Cache hit ratio for feature store
  - Variables: environment, model_name, time_range
  - Annotations: model deployments, config changes

Create \`configs/monitoring/dashboards/model-health.json\`:
- Grafana dashboard JSON for ML health:
  - Panel: Data drift score over time (per feature group)
  - Panel: Prediction distribution shift (PSI over time)
  - Panel: Feature value range violations
  - Panel: Training vs serving data distribution comparison
  - Panel: Model staleness (time since last retrain)
  - Panel: Data validation failure rate
  - Panel: GPU utilization and memory (if applicable)
  - Panel: MLflow experiment completion rate
  - Variables: model_name, feature_group, drift_threshold

### 5. Alert Rules

Create \`configs/monitoring/alerts/serving-alerts.yml\`:
- Prometheus alerting rules:
  - \`HighPredictionLatency\`: p99 latency > 500ms for 5 minutes (critical)
  - \`HighErrorRate\`: error rate > 5% for 5 minutes (critical)
  - \`ModelNotLoaded\`: model_loaded_version == 0 for 2 minutes (critical)
  - \`LowThroughput\`: request rate drops > 50% vs previous hour (warning)
  - \`HighGPUMemory\`: GPU memory > 90% for 10 minutes (warning)
  - \`FeatureStoreDown\`: Redis unreachable for 1 minute (critical)
  - \`CacheHitRatioLow\`: cache hit ratio < 50% for 15 minutes (warning)
  - All alerts include runbook_url annotation pointing to docs/runbooks/

Create \`configs/monitoring/alerts/ml-alerts.yml\`:
- ML-specific alerting rules:
  - \`DataDriftDetected\`: PSI > 0.2 for any feature group sustained 1 hour (warning)
  - \`SevereDriftDetected\`: PSI > 0.5 for any feature group (critical)
  - \`PredictionDistributionShift\`: output distribution KS test p-value < 0.01 for 2 hours (warning)
  - \`ConfidenceScoreDrop\`: mean confidence drops > 20% vs baseline (warning)
  - \`ModelStale\`: model not retrained in > 7 days (info)
  - \`TrainingPipelineFailure\`: DVC pipeline failed (critical)
  - \`DataValidationSpikeFailures\`: validation failure rate > 10% for 30 minutes (warning)
  - \`ExperimentTrackingDown\`: MLflow server unreachable for 5 minutes (critical)
  - All alerts include runbook_url and relevant MLflow experiment links

### 6. Monitoring Integration in FastAPI

Update guidance for \`src/serving/app.py\`:
- Integrate prometheus_client metrics middleware
- Add /metrics endpoint (prometheus_client exposition)
- Add /health/ready endpoint (readiness probe)
- Add /health/live endpoint (liveness probe)
- Add /health/detailed endpoint (full component health check, auth-protected)
- Add background task for periodic drift detection (configurable interval)
- Add request logging middleware that captures prediction metadata for monitoring
- Ensure GDPR compliance: do NOT log raw input features containing PII — log only statistical summaries and anonymized feature hashes

### 7. Docker & Kubernetes Monitoring Config

Create \`configs/monitoring/docker-compose.monitoring.yml\`:
- Services: prometheus, grafana, alertmanager, redis-exporter, postgres-exporter, dcgm-exporter
- Mount config files from configs/monitoring/
- Grafana provisioning for dashboards and datasources
- Network configuration to reach ml-pipeline services
- Volume persistence for Prometheus TSDB and Grafana state

Create \`configs/monitoring/k8s/service-monitor.yml\`:
- Kubernetes ServiceMonitor CRD for Prometheus Operator
- Target the FastAPI serving pods
- Target the MLflow server pods
- Proper label selectors matching our deployment labels
- Metric relabeling for environment tagging

### 8. Monitoring Tests

Create \`tests/test_metrics.py\`:
- Test that all custom Prometheus metrics are properly registered
- Test metrics middleware records latency and counts
- Test health check endpoints return correct structure
- Test drift detection functions with known distributions (normal, shifted, identical)
- Test PSI calculation with reference and comparison distributions
- Test prediction monitor window aggregation
- Use pytest fixtures for sample data and model mocks
- Minimum 75% coverage for monitoring code

## Constraints

- All Python files must have type hints on public functions
- Use Pydantic for all config/response models
- Follow snake_case for files/functions, PascalCase for classes, SCREAMING_SNAKE_CASE for constants
- Max 300 lines per file — split if needed
- Pin dependency versions in pyproject.toml for any new packages
- GDPR: Never log raw PII in metrics or monitoring data — use anonymized identifiers
- SOC 2: Ensure model artifact integrity checks in health monitoring
- All monitoring configs should work in both staging and production environments
- Reference MLflow for experiment/model metadata in alerts and dashboards
- Use DVC-tracked reference data for drift baselines

## Output

Generate all files listed above. For each file:
1. Create the file with proper content
2. Add appropriate comments explaining ML-specific monitoring decisions
3. Ensure cross-references between alerts and runbooks in docs/runbooks/
4. After generating, run: \`uv run ruff check src/serving/metrics.py src/serving/model_health.py src/evaluation/drift_detection.py src/evaluation/prediction_monitor.py\`
5. After generating, run: \`uv run mypy src/serving/metrics.py src/serving/model_health.py src/evaluation/drift_detection.py src/evaluation/prediction_monitor.py\`
6. After generating, run: \`uv run pytest tests/test_metrics.py -v\`

Summarize what was created and any manual steps needed (e.g., Slack webhook URL, Grafana API key, AWS CloudWatch integration).
\`\`\`

---

## What This Prompt Produces

| File | Purpose |
|------|---------|
| \`configs/monitoring/prometheus.yml\` | Prometheus scrape config for all ML services |
| \`configs/monitoring/alertmanager.yml\` | Alert routing to Slack with severity grouping |
| \`src/serving/metrics.py\` | Custom Prometheus metrics for ML serving |
| \`src/serving/model_health.py\` | Health check endpoints (readiness, liveness, detailed) |
| \`src/evaluation/drift_detection.py\` | Statistical drift detection (KS, chi-squared, PSI, JSD) |
| \`src/evaluation/prediction_monitor.py\` | Prediction distribution monitoring over time windows |
| \`configs/monitoring/dashboards/model-serving.json\` | Grafana dashboard for serving metrics |
| \`configs/monitoring/dashboards/model-health.json\` | Grafana dashboard for ML health/drift |
| \`configs/monitoring/alerts/serving-alerts.yml\` | Prometheus alert rules for serving infrastructure |
| \`configs/monitoring/alerts/ml-alerts.yml\` | Prometheus alert rules for ML-specific issues |
| \`configs/monitoring/docker-compose.monitoring.yml\` | Docker Compose for monitoring stack |
| \`configs/monitoring/k8s/service-monitor.yml\` | Kubernetes ServiceMonitor for Prometheus Operator |
| \`tests/test_metrics.py\` | pytest tests for all monitoring components |

## Prerequisites

- Phase 05 observability foundation in place (see \`playbook/prompts/05/observability-setup.md\`)
- FastAPI serving app exists in \`src/serving/\`
- MLflow server deployed and accessible
- Redis and PostgreSQL running
- Runbooks generated (see \`playbook/prompts/07/runbook-generator.md\`)

## Manual Steps After Generation

1. **Slack Webhook**: Replace placeholder webhook URL in \`alertmanager.yml\` with actual Slack incoming webhook
2. **Grafana**: Import dashboards via Grafana UI or provisioning API
3. **DVC Reference Data**: Run \`dvc pull data/reference/\` to ensure drift baselines are available
4. **GPU Monitoring**: Install \`dcgm-exporter\` on GPU nodes if using GPU serving
5. **Kubernetes**: Apply ServiceMonitor CRD if using Prometheus Operator: \`kubectl apply -f configs/monitoring/k8s/service-monitor.yml\`
6. **Verify**: Run \`docker compose -f configs/monitoring/docker-compose.monitoring.yml up -d\` and check Prometheus targets at \`http://localhost:9090/targets\`

## Validation Checklist

- [ ] \`uv run ruff check\` passes on all new Python files
- [ ] \`uv run mypy\` passes in strict mode on all new Python files
- [ ] \`uv run pytest tests/test_metrics.py -v\` — all tests pass with ≥75% coverage
- [ ] Prometheus scrapes all targets successfully
- [ ] Grafana dashboards render with sample data
- [ ] Alert rules evaluate without errors in Prometheus
- [ ] Health check endpoints respond correctly: \`/health/ready\`, \`/health/live\`, \`/health/detailed\`
- [ ] Drift detection produces valid PSI scores against reference data
- [ ] No PII leaks in any metric labels or log output (GDPR)
- [ ] Model artifact checksums validated in health checks (SOC 2)

## Related Prompts

- \`playbook/prompts/05/observability-setup.md\` — Foundation logging and tracing
- \`playbook/prompts/07/runbook-generator.md\` — Runbooks referenced by alert annotations
- \`playbook/prompts/07/go-live-checklist.md\` — Launch checklist including monitoring verification
- \`playbook/prompts/06/load-test.md\` — Load testing to validate monitoring under stress`,

  'playbook/prompts/07/runbook-generator.md': `# Runbook Generator — Phase 07 (Launch)

> **Copy-paste this prompt into Claude Code to generate operational runbooks for the ml-pipeline project.**

---

You are an ML operations engineer creating production runbooks for the **ml-pipeline** project. This is a PyTorch-based ML pipeline with MLflow experiment tracking, DVC data versioning, FastAPI model serving, deployed on AWS (ECS/SageMaker with GPU instances), backed by PostgreSQL and Redis.

## Context

- **Stack**: Python 3.11+, PyTorch, MLflow, DVC, FastAPI, PostgreSQL, Redis, AWS (S3, ECR, ECS, SageMaker, EC2 GPU)
- **Infrastructure**: Docker, Kubernetes, Terraform
- **Monitoring**: Prometheus, Grafana, MLflow UI
- **Compliance**: SOC 2, GDPR
- **CI/CD**: GitHub Actions (lint → type check → test → build → smoke train → deploy staging → deploy production)
- **Data pipeline**: DVC-orchestrated DAG (data ingestion → preprocessing → feature engineering → training → evaluation)
- **Model serving**: FastAPI REST API with batch inference endpoints, Redis feature cache

## Runbooks to Generate

Create the following runbook files in \`docs/runbooks/\`. Each runbook must follow the standard template below.

### Standard Runbook Template

Every runbook must include:

1. **Title and Severity** — Name, severity level (SEV1–SEV4), estimated resolution time
2. **Symptoms** — What alerts fire, what users/systems observe
3. **Impact** — Which services, users, or pipelines are affected
4. **Prerequisites** — Tools, access, credentials needed to respond
5. **Diagnosis Steps** — Numbered commands to identify root cause
6. **Resolution Steps** — Numbered commands to fix the issue
7. **Verification** — How to confirm the fix worked
8. **Escalation** — When and to whom to escalate
9. **Post-Incident** — Checklist for after resolution
10. **Appendix** — Related dashboards, logs, configs

### Runbook 1: \`docs/runbooks/model-serving-degraded.md\`

**Scenario**: FastAPI model serving latency exceeds SLO (p99 > 500ms) or error rate spikes above 1%.

Include diagnosis for:
- FastAPI endpoint health checks: \`curl -s http://localhost:8000/health | jq .\`
- Prometheus query for latency: \`histogram_quantile(0.99, rate(http_request_duration_seconds_bucket{service="model-serving"}[5m]))\`
- Redis feature cache hit rate drop: \`redis-cli INFO stats | grep keyspace\`
- PyTorch model inference bottleneck (GPU memory, batch size)
- Check if model artifact loaded correctly from MLflow model registry
- ECS task health and container resource limits
- Resolution: restart ECS tasks, clear Redis cache, rollback model version in MLflow registry, scale horizontally

### Runbook 2: \`docs/runbooks/training-pipeline-failure.md\`

**Scenario**: DVC pipeline (\`dvc repro\`) fails during scheduled or manual training run.

Include diagnosis for:
- DVC pipeline status: \`dvc status\`, \`dvc dag\`
- Check which stage failed: \`dvc repro --dry\` to identify the broken stage
- S3 remote storage connectivity: \`dvc push --dry\`, \`aws s3 ls s3://ml-pipeline-data/\`
- MLflow tracking server availability: \`curl -s $MLFLOW_TRACKING_URI/api/2.0/mlflow/experiments/list\`
- GPU availability on training instance: \`nvidia-smi\`, check CUDA errors
- PyTorch training errors: OOM (reduce batch size), NaN loss (check learning rate, data quality)
- Data integrity: \`dvc diff\`, check DVC lock file, verify data checksums
- PostgreSQL MLflow backend connectivity
- Resolution: retry failed stage, fix data issues, adjust training config in \`configs/\`, re-run \`dvc repro\`

### Runbook 3: \`docs/runbooks/data-pipeline-drift.md\`

**Scenario**: Data drift detected — model performance degrades on incoming data, feature distributions shift.

Include diagnosis for:
- Check MLflow metrics dashboard for accuracy/F1 degradation over time
- Compare feature distributions: current vs. training data baseline
- DVC data lineage: \`dvc plots diff\` to visualize distribution changes
- Redis feature store staleness: check TTLs and last-updated timestamps
- Validate incoming data schema with Pydantic validators in \`src/data/\`
- Check data source upstream changes
- Resolution: trigger retraining with updated data, update feature engineering pipeline, adjust drift detection thresholds, update DVC-tracked reference distributions

### Runbook 4: \`docs/runbooks/model-rollback.md\`

**Scenario**: Newly deployed model performs worse than previous version in production (A/B test failure or metric regression).

Include diagnosis for:
- Compare model versions in MLflow UI: metrics, parameters, artifacts
- Check A/B test results: traffic split, statistical significance
- Verify model artifact integrity (SHA256 checksums in MLflow)
- Review experiment config diff: \`diff configs/production/model_v{N-1}.yaml configs/production/model_vN.yaml\`
- Resolution steps:
  - Transition model stage in MLflow: \`mlflow.tracking.MlflowClient().transition_model_version_stage()\`
  - Update ECS task definition to pull previous model version
  - Rollback FastAPI serving container: \`aws ecs update-service --force-new-deployment\`
  - Verify rollback with health check and metric comparison
  - SOC 2: log the rollback event with justification

### Runbook 5: \`docs/runbooks/gpu-instance-issues.md\`

**Scenario**: GPU training instances become unavailable, unhealthy, or exhibit performance degradation.

Include diagnosis for:
- \`nvidia-smi\` output: GPU utilization, memory, temperature, ECC errors
- Check EC2 instance status: \`aws ec2 describe-instance-status\`
- CUDA driver compatibility: \`nvcc --version\` vs PyTorch CUDA version
- Docker GPU runtime: \`docker run --gpus all nvidia/cuda:12.0-base nvidia-smi\`
- Spot instance interruption notices (if using spot)
- Resolution: terminate and replace instance via Terraform, fall back to CPU training with reduced batch size, request capacity from different AZ

### Runbook 6: \`docs/runbooks/gdpr-data-deletion.md\`

**Scenario**: GDPR right-to-deletion request received — must purge user data from all pipeline stages.

Include steps for:
- Identify all data locations: raw data (S3/DVC), processed features (S3/DVC), Redis feature cache, PostgreSQL metadata, MLflow artifacts, model training data snapshots
- Data lineage trace: which DVC-tracked datasets contain the user's data
- Deletion procedure:
  - Remove from PostgreSQL: \`DELETE FROM user_features WHERE user_id = %s\`
  - Invalidate Redis cache: \`redis-cli DEL user:{user_id}:*\`
  - Remove from S3 raw/processed: \`aws s3 rm s3://ml-pipeline-data/raw/ --recursive --include "*{user_id}*"\`
  - Regenerate DVC-tracked processed datasets without the user's data
  - Document that models trained on data including this user cannot be "untrained" — document this in the deletion log
- Verification: audit query across all stores confirming zero records
- SOC 2 compliance: log deletion request, actions taken, timestamp, operator
- Respond to data subject within GDPR timeline (30 days)

### Runbook 7: \`docs/runbooks/incident-response-checklist.md\`

**Scenario**: General incident response template for any production issue.

Include:
- Severity classification (SEV1: full outage, SEV2: degraded, SEV3: minor, SEV4: cosmetic)
- Communication template for Slack #ml-pipeline-incidents channel
- On-call rotation and escalation paths
- Links to all Grafana dashboards, MLflow UI, AWS Console, ECS logs
- Post-incident review template with sections: timeline, root cause, impact, action items
- SOC 2 incident documentation requirements

## Requirements

1. **Use actual commands** — every diagnosis and resolution step must include copy-pasteable shell commands, API calls, or SQL queries specific to this stack.
2. **Reference real paths** — use \`src/\`, \`configs/\`, \`data/\`, \`models/\`, \`scripts/\` as defined in the project layout.
3. **Reference real tools** — \`uv run pytest\`, \`uv run ruff check\`, \`dvc repro\`, \`dvc status\`, \`mlflow\`, \`aws\`, \`docker\`, \`kubectl\`, \`redis-cli\`, \`psql\`.
4. **Include Prometheus/Grafana queries** where relevant for monitoring-based diagnosis.
5. **Include AWS CLI commands** for ECS, S3, EC2, SageMaker operations.
6. **Mark sensitive operations** — any command that modifies production data or models must have a ⚠️ warning and require confirmation.
7. **GDPR and SOC 2** — reference compliance requirements where data access, deletion, or audit logging is involved.
8. **Cross-reference** — link between runbooks where scenarios overlap (e.g., model rollback references serving degraded).
9. **Keep each runbook under 300 lines** — focused and actionable, not encyclopedic.
10. **Add frontmatter** to each runbook with: title, severity, last_reviewed date, owner, and tags.

## Output

Generate all 7 runbook files. For each file, output the full path and complete content. Use Markdown with clear headers, numbered steps, and code blocks for all commands.

Start with \`docs/runbooks/model-serving-degraded.md\` and proceed in order.`,

  'plugin/codeforge-ml-pipeline/.claude-plugin/plugin.json': `{
  "name": "codeforge-ml-pipeline",
  "version": "1.0.0",
  "description": "CodeForge plugin for ML pipeline development with PyTorch, MLflow experiment tracking, DVC data versioning, and FastAPI model serving. Provides agents, commands, and skills tailored for end-to-end ML workflows.",
  "author": "ml-pipeline-team",
  "license": "MIT",
  "min_claude_version": "1.0.0",
  "capabilities": [
    "agents",
    "commands",
    "skills",
    "rules"
  ],
  "agents": {
    "directory": "../agents",
    "entries": [
      {
        "slug": "ml-engineer",
        "name": "ML Engineer Agent",
        "description": "Handles model development, training pipeline construction, hyperparameter tuning, and experiment tracking with MLflow. Works within src/models/, src/training/, and configs/.",
        "entry_point": "ml-engineer.md"
      },
      {
        "slug": "data-engineer",
        "name": "Data Engineer Agent",
        "description": "Manages data pipelines, feature engineering, DVC pipeline stages, and data quality validation. Works within src/data/, data/, and dvc.yaml.",
        "entry_point": "data-engineer.md"
      },
      {
        "slug": "serving-engineer",
        "name": "Serving Engineer Agent",
        "description": "Builds and maintains FastAPI model serving endpoints, batch inference pipelines, A/B testing infrastructure, and inference optimization. Works within src/serving/.",
        "entry_point": "serving-engineer.md"
      },
      {
        "slug": "evaluator",
        "name": "Model Evaluator Agent",
        "description": "Runs model evaluation, generates comparison reports, computes metrics, and produces visualizations. Works within src/evaluation/ and notebooks/.",
        "entry_point": "evaluator.md"
      }
    ]
  },
  "commands": {
    "directory": "../commands",
    "entries": [
      {
        "slug": "train",
        "name": "Train Model",
        "description": "Run a training pipeline with a specified experiment config. Executes DVC pipeline stages and logs results to MLflow.",
        "entry_point": "train.md",
        "aliases": ["t"]
      },
      {
        "slug": "evaluate",
        "name": "Evaluate Model",
        "description": "Evaluate a trained model against test data, compute metrics, and log results to MLflow.",
        "entry_point": "evaluate.md",
        "aliases": ["eval"]
      },
      {
        "slug": "serve",
        "name": "Serve Model",
        "description": "Start the FastAPI model serving application locally for testing inference endpoints.",
        "entry_point": "serve.md"
      },
      {
        "slug": "experiment",
        "name": "New Experiment",
        "description": "Scaffold a new experiment config YAML, create an MLflow experiment, and set up the training branch.",
        "entry_point": "experiment.md",
        "aliases": ["exp"]
      },
      {
        "slug": "data-pipeline",
        "name": "Run Data Pipeline",
        "description": "Execute DVC data pipeline stages: download, preprocess, feature engineering, and validation.",
        "entry_point": "data-pipeline.md",
        "aliases": ["dp"]
      },
      {
        "slug": "lint-check",
        "name": "Lint and Type Check",
        "description": "Run ruff check, ruff format --check, and mypy strict mode across the codebase.",
        "entry_point": "lint-check.md",
        "aliases": ["lc"]
      },
      {
        "slug": "test",
        "name": "Run Tests",
        "description": "Execute pytest with coverage reporting. Supports unit, integration, and smoke test targets.",
        "entry_point": "test.md"
      },
      {
        "slug": "deploy",
        "name": "Deploy Model",
        "description": "Deploy a registered MLflow model to staging or production via Docker/ECS.",
        "entry_point": "deploy.md"
      }
    ]
  },
  "skills": {
    "directory": "../skills",
    "entries": [
      {
        "slug": "pytorch-model",
        "name": "PyTorch Model Development",
        "description": "Best practices for defining PyTorch nn.Module classes, custom layers, loss functions, and forward pass patterns.",
        "entry_point": "pytorch-model.md"
      },
      {
        "slug": "mlflow-tracking",
        "name": "MLflow Experiment Tracking",
        "description": "Patterns for logging parameters, metrics, artifacts, and registering models in the MLflow model registry.",
        "entry_point": "mlflow-tracking.md"
      },
      {
        "slug": "dvc-pipelines",
        "name": "DVC Data Pipelines",
        "description": "Defining reproducible DVC pipeline stages, managing remote storage on S3, and tracking data lineage.",
        "entry_point": "dvc-pipelines.md"
      },
      {
        "slug": "fastapi-serving",
        "name": "FastAPI Model Serving",
        "description": "Building inference endpoints with FastAPI, request/response validation with Pydantic, async inference, and health checks.",
        "entry_point": "fastapi-serving.md"
      },
      {
        "slug": "feature-engineering",
        "name": "Feature Engineering",
        "description": "Patterns for building reproducible feature pipelines, feature stores with Redis, and feature validation.",
        "entry_point": "feature-engineering.md"
      },
      {
        "slug": "hyperparameter-tuning",
        "name": "Hyperparameter Tuning",
        "description": "Configuring and running hyperparameter searches with Optuna, logging trials to MLflow, and selecting best configs.",
        "entry_point": "hyperparameter-tuning.md"
      },
      {
        "slug": "experiment-config",
        "name": "Experiment Configuration",
        "description": "Defining YAML experiment configs validated with Pydantic, ensuring reproducibility across training runs.",
        "entry_point": "experiment-config.md"
      },
      {
        "slug": "gpu-training",
        "name": "GPU Training on AWS",
        "description": "Setting up GPU-accelerated training on EC2/SageMaker, mixed precision, distributed training, and checkpointing.",
        "entry_point": "gpu-training.md"
      },
      {
        "slug": "data-privacy",
        "name": "Data Privacy and GDPR",
        "description": "GDPR-compliant data handling: anonymization, consent tracking, right to deletion, and audit logging for SOC 2.",
        "entry_point": "data-privacy.md"
      },
      {
        "slug": "ab-testing",
        "name": "A/B Testing Infrastructure",
        "description": "Implementing model A/B tests in the serving layer, traffic splitting, metric collection, and statistical significance.",
        "entry_point": "ab-testing.md"
      }
    ]
  },
  "rules": {
    "directory": "../../../.claude/rules",
    "description": "Project-wide Claude rules for Python ML development, testing, security, and code quality."
  },
  "settings": {
    "project_root": "../../..",
    "source_directory": "src",
    "test_directory": "tests",
    "config_directory": "configs",
    "data_directory": "data",
    "models_directory": "models",
    "sensitive_paths": [
      "configs/production/**",
      "models/**",
      ".env*",
      "data/**"
    ],
    "tools": {
      "package_manager": "uv",
      "linter": "ruff",
      "formatter": "ruff format",
      "type_checker": "mypy",
      "test_runner": "pytest",
      "ml_framework": "pytorch",
      "experiment_tracker": "mlflow",
      "data_versioning": "dvc",
      "serving_framework": "fastapi"
    },
    "commands": {
      "lint": "uv run ruff check src/ tests/",
      "format": "uv run ruff format src/ tests/",
      "type_check": "uv run mypy src/",
      "test": "uv run pytest tests/ -v --cov=src --cov-report=term-missing",
      "test_unit": "uv run pytest tests/unit/ -v",
      "test_integration": "uv run pytest tests/integration/ -v",
      "train": "uv run python -m scripts.train --config configs/default.yaml",
      "evaluate": "uv run python -m scripts.evaluate --config configs/default.yaml",
      "serve": "uv run uvicorn src.serving.app:app --reload --port 8000",
      "mlflow_ui": "uv run mlflow ui --port 5000",
      "dvc_repro": "dvc repro",
      "dvc_push": "dvc push",
      "dvc_pull": "dvc pull"
    },
    "conventions": {
      "max_file_length": 300,
      "coverage_threshold": 75,
      "naming": {
        "files": "snake_case",
        "functions": "snake_case",
        "classes": "PascalCase",
        "constants": "SCREAMING_SNAKE_CASE"
      },
      "commit_format": "conventional",
      "branch_format": "type/ticket-desc",
      "ai_code_flag": true
    },
    "compliance": ["SOC 2", "GDPR"]
  }
}`,

  'plugin/codeforge-ml-pipeline/README.md': `# CodeForge ML Pipeline Plugin

A Claude Code plugin tailored for the **ml-pipeline** project — an end-to-end machine learning pipeline built with PyTorch, MLflow, DVC, and FastAPI. This plugin provides specialized agents, skills, and commands that accelerate ML engineering workflows while enforcing project standards.

## Overview

The \`codeforge-ml-pipeline\` plugin extends Claude Code with ML-aware capabilities:

- **Agents** that understand PyTorch model architectures, MLflow experiment tracking, and DVC data pipelines
- **Skills** that encode team conventions for planning, TDD, code review, build fixing, and verification
- **Commands** that provide quick access to common ML engineering workflows
- **Hooks** that enforce quality gates before commits and after file generation

## Installation

### Prerequisites

- [Claude Code](https://docs.anthropic.com/claude-code) installed and authenticated
- Python 3.11+ with [uv](https://github.com/astral-sh/uv) package manager
- Project dependencies installed (\`./install.sh\` or \`uv sync\`)

### Setup

The plugin is included in the repository under \`plugin/codeforge-ml-pipeline/\`. Claude Code discovers it automatically via the plugin manifest.

1. **Clone the repository** (if you haven't already):

   \`\`\`bash
   git clone <repo-url> ml-pipeline
   cd ml-pipeline
   \`\`\`

2. **Run the install script** to set up the full environment:

   \`\`\`bash
   ./install.sh
   \`\`\`

3. **Verify plugin detection** by asking Claude Code:

   \`\`\`
   What plugins are available?
   \`\`\`

   You should see \`codeforge-ml-pipeline\` listed with its agents, skills, and commands.

### Manual Registration

If the plugin isn't auto-detected, add it to your \`.claude/settings.json\`:

\`\`\`json
{
  "plugins": [
    {
      "path": "plugin/codeforge-ml-pipeline/.claude-plugin/plugin.json"
    }
  ]
}
\`\`\`

## Available Agents

Agents are specialized personas that Claude Code can adopt for different ML engineering tasks.

| Agent | File | Purpose |
|-------|------|---------|
| **Planner** | \`agents/planner.md\` | Breaks down ML features into phased implementation plans with experiment design, data pipeline steps, and training milestones |
| **Architect** | \`agents/architect.md\` | Designs PyTorch model architectures, DVC pipeline DAGs, FastAPI serving endpoints, and infrastructure layouts |
| **TDD Guide** | \`agents/tdd-guide.md\` | Drives test-driven development for ML code — test fixtures for tensors, model forward passes, API endpoints, and data transforms |
| **Code Reviewer** | \`agents/code-reviewer.md\` | Reviews PRs against project standards: type hints, Pydantic configs, MLflow logging, GDPR compliance, SOC 2 security |
| **Build Error Resolver** | \`agents/build-error-resolver.md\` | Diagnoses and fixes CI failures — ruff lint errors, mypy type errors, pytest failures, Docker build issues, DVC pipeline breaks |

### Using an Agent

Invoke an agent by referencing it in your prompt:

\`\`\`
@planner Create an implementation plan for adding a transformer-based model for user churn prediction. We need feature engineering from the events table, hyperparameter tuning, and A/B test setup.
\`\`\`

\`\`\`
@architect Design the DVC pipeline stages for our new text classification feature, including data preprocessing, tokenization, training, and evaluation.
\`\`\`

## Available Skills

Skills are structured methodologies that guide Claude Code through multi-step workflows.

| Skill | File | Purpose |
|-------|------|---------|
| **Plan** | \`skills/plan/SKILL.md\` | Structured planning methodology — ticket analysis, experiment design, phased implementation with DVC stages and MLflow experiments |
| **TDD** | \`skills/tdd/SKILL.md\` | Test-driven development cycle for ML code — write failing test, implement, refactor, verify with \`uv run pytest\` |
| **Code Review** | \`skills/code-review/SKILL.md\` | Systematic review checklist covering type safety, ML best practices, data privacy (GDPR), security (SOC 2), and experiment reproducibility |
| **Build Fix** | \`skills/build-fix/SKILL.md\` | Diagnose CI/CD failures across lint (\`ruff\`), types (\`mypy\`), tests (\`pytest\`), Docker builds, and DVC pipeline stages |
| **Verify** | \`skills/verify/SKILL.md\` | End-to-end verification — run the full quality stack and confirm everything passes before PR submission |
| **Phase** | \`skills/phase/SKILL.md\` | Phase-gated development — ensures work progresses through planning, implementation, testing, and review phases in order |

### Using a Skill

Skills are typically invoked through their corresponding commands (see below) or referenced directly:

\`\`\`
Use the TDD skill to implement a new data augmentation transform for image preprocessing.
\`\`\`

## Available Commands

Commands are shorthand invocations for common workflows.

| Command | File | Invocation | Description |
|---------|------|------------|-------------|
| **plan** | \`commands/plan.md\` | \`/plan <description>\` | Generate a phased implementation plan for an ML feature or pipeline change |
| **tdd** | \`commands/tdd.md\` | \`/tdd <component>\` | Start a TDD cycle for a specific component (model, transform, endpoint, pipeline stage) |
| **code-review** | \`commands/code-review.md\` | \`/code-review [files]\` | Run a structured code review on staged changes or specified files |
| **build-fix** | \`commands/build-fix.md\` | \`/build-fix [error]\` | Diagnose and fix a CI failure — paste the error or let it read CI logs |
| **verify** | \`commands/verify.md\` | \`/verify\` | Run the full verification suite before submitting a PR |

### Command Examples

\`\`\`
/plan Add ONNX export support for serving models with lower latency

/tdd src/models/transformer.py

/code-review src/training/trainer.py src/models/attention.py

/build-fix mypy error: src/serving/app.py:42 - Incompatible return type

/verify
\`\`\`

## Hooks

Hooks run automatically at specific points in the workflow to enforce quality gates.

| Hook | Trigger | Action |
|------|---------|--------|
| **Pre-commit lint** | Before commit | Runs \`uv run ruff check src/ tests/\` and \`uv run ruff format --check src/ tests/\` |
| **Pre-commit type check** | Before commit | Runs \`uv run mypy src/\` in strict mode |
| **Post-generate validate** | After file generation | Validates generated files follow naming conventions, have type hints on public functions, and respect the 300-line limit |
| **Sensitive path guard** | On file modification | Warns when modifying \`configs/production/**\`, \`models/**\`, \`.env*\`, or \`data/**\` — requires explicit confirmation |

Hook configuration is defined in \`hooks/hooks.json\`.

## Project Integration

### MLflow Experiment Tracking

The plugin understands MLflow conventions used in this project:

- Experiments are organized by model type and dataset
- All hyperparameters logged via Pydantic config objects
- Model artifacts registered in the MLflow Model Registry
- Agents will suggest proper \`mlflow.log_param()\`, \`mlflow.log_metric()\`, and \`mlflow.pytorch.log_model()\` calls

### DVC Pipeline Awareness

Agents and skills understand the DVC pipeline DAG defined in \`dvc.yaml\`:

- Data stages: download → preprocess → feature engineering
- Training stages: train → evaluate → register
- Commands reference \`dvc repro\`, \`dvc push\`, \`dvc pull\` appropriately
- The planner agent designs new stages that integrate with the existing DAG

### FastAPI Serving

The plugin generates FastAPI endpoint code that follows project patterns:

- Pydantic request/response models with type hints
- Health check and readiness probe endpoints
- Batch inference endpoints with Redis caching
- Model version selection for A/B testing

### Compliance Awareness

All generated code and reviews account for:

- **GDPR**: Data anonymization, consent tracking, right-to-deletion support in data pipelines
- **SOC 2**: Model artifact integrity, access controls, audit logging, secrets management

## Directory Structure

\`\`\`
plugin/codeforge-ml-pipeline/
├── .claude-plugin/
│   └── plugin.json          # Plugin manifest — metadata, registration
├── agents/
│   ├── planner.md           # ML feature planning agent
│   ├── architect.md         # System and model architecture agent
│   ├── tdd-guide.md         # Test-driven development agent
│   ├── code-reviewer.md     # Code review agent
│   └── build-error-resolver.md  # CI/CD failure resolution agent
├── skills/
│   ├── plan/SKILL.md        # Planning methodology
│   ├── tdd/SKILL.md         # TDD methodology for ML code
│   ├── code-review/SKILL.md # Review checklist and process
│   ├── build-fix/SKILL.md   # Build failure diagnosis
│   ├── verify/SKILL.md      # Pre-PR verification suite
│   └── phase/SKILL.md       # Phase-gated development
├── commands/
│   ├── plan.md              # /plan command definition
│   ├── tdd.md               # /tdd command definition
│   ├── code-review.md       # /code-review command definition
│   ├── build-fix.md         # /build-fix command definition
│   └── verify.md            # /verify command definition
├── hooks/
│   └── hooks.json           # Automated hook definitions
└── README.md                # This file
\`\`\`

## Typical Workflow

A typical ML feature development workflow using this plugin:

1. **Plan** — \`/plan Add gradient accumulation support for large batch training\`
2. **Phase: Design** — Architect agent designs the implementation approach
3. **Phase: Implement** — \`/tdd src/training/gradient_accumulation.py\` drives test-first development
4. **Phase: Verify** — \`/verify\` runs lint, types, tests, and coverage checks
5. **Phase: Review** — \`/code-review\` performs a structured self-review before opening a PR
6. **Fix issues** — \`/build-fix\` resolves any CI failures after pushing

## Customization

### Adding a New Skill

Create a new directory under \`skills/\` with a \`SKILL.md\` file:

\`\`\`
plugin/codeforge-ml-pipeline/skills/my-skill/SKILL.md
\`\`\`

Follow the structure of existing skills — define the goal, steps, tools used, and success criteria.

### Adding a New Agent

Create a new markdown file under \`agents/\`:

\`\`\`
plugin/codeforge-ml-pipeline/agents/my-agent.md
\`\`\`

Define the agent's persona, expertise areas, tools it uses, and behavioral guidelines.

### Adding a New Command

Create a new markdown file under \`commands/\`:

\`\`\`
plugin/codeforge-ml-pipeline/commands/my-command.md
\`\`\`

Define the invocation syntax, parameters, and which skill/agent it delegates to.

After adding new components, update \`plugin.json\` to register them.

## Troubleshooting

| Issue | Solution |
|-------|----------|
| Plugin not detected | Verify \`plugin.json\` path in \`.claude/settings.json\` |
| Commands not recognized | Restart Claude Code session after plugin changes |
| Hooks not firing | Check \`hooks/hooks.json\` syntax and trigger definitions |
| Agent gives generic advice | Ensure you're in the \`ml-pipeline\` project root so context files are visible |
| Type check failures in generated code | Run \`/build-fix\` — the resolver understands mypy strict mode requirements |

## Related Documentation

- [Project README](../../README.md) — Overall project setup and architecture
- [Architecture](../../docs/ARCHITECTURE.md) — System design, pipeline DAG, infrastructure
- [Contributing](../../docs/CONTRIBUTING.md) — Git workflow, PR process, coding standards
- [AI Usage Policy](../../docs/AI-USAGE-POLICY.md) — Guidelines for AI-assisted development
- [Onboarding](../../docs/ONBOARDING.md) — New team member setup guide`,

  'plugin/codeforge-ml-pipeline/agents/architect.md': `# Architect Agent — ML Pipeline

## Identity

You are the **Architect Agent** for the ml-pipeline project. You specialize in designing and evolving the architecture of end-to-end machine learning systems built with PyTorch, MLflow, DVC, and FastAPI on AWS infrastructure. You make structural decisions that balance ML experimentation velocity with production reliability, data integrity, and SOC 2 / GDPR compliance.

## Activation

This agent activates when:
- Designing new pipeline stages or modifying the DAG structure
- Introducing new model architectures or serving patterns
- Evaluating infrastructure changes (GPU instances, Kubernetes scaling, S3 storage)
- Reviewing data flow from ingestion through feature engineering to model training
- Making decisions about experiment tracking, model registry, or artifact management
- Assessing cross-cutting concerns: latency, throughput, cost, reproducibility
- Planning migrations or major refactors across \`src/\` modules

## Context

### Project Architecture

This is a DAG-based ML pipeline with the following flow:

\`\`\`
Data Ingestion → Feature Engineering → Training → Evaluation → Registry → Serving
     (DVC)           (src/data/)       (PyTorch)   (MLflow)    (MLflow)  (FastAPI)
\`\`\`

**Key architectural boundaries:**
- \`src/data/\` — Data loading, preprocessing, feature engineering. DVC-tracked inputs/outputs.
- \`src/models/\` — PyTorch \`nn.Module\` classes. Pure model architecture, no training logic.
- \`src/training/\` — Training loops, hyperparameter tuning, callbacks, checkpointing.
- \`src/evaluation/\` — Metrics computation, model comparison, visualization generation.
- \`src/serving/\` — FastAPI application, inference pipeline, batch processing, A/B routing.
- \`src/utils/\` — Shared utilities, logging, config loading via Pydantic.
- \`configs/\` — YAML experiment configurations validated by Pydantic models.

**Infrastructure:**
- PostgreSQL: MLflow backend store, pipeline metadata
- Redis: Feature caching, inference result caching, rate limiting
- S3: DVC remote storage, MLflow artifact store, model checkpoints
- ECR/ECS/Kubernetes: Container orchestration for serving
- SageMaker: Optional managed training on GPU instances
- Terraform: All infrastructure as code

### Key Invariants

1. **Reproducibility**: Every training run must be fully reproducible from a config YAML + DVC-tracked data + git commit SHA.
2. **Separation of concerns**: Model architecture (\`src/models/\`) never imports from training, serving, or data modules.
3. **Config-driven**: All hyperparameters, data paths, and feature definitions live in \`configs/\` as Pydantic-validated YAML — never hardcoded.
4. **Artifact lineage**: Every model artifact in MLflow must trace back to: dataset version (DVC hash), config snapshot, code commit, training metrics.
5. **Data privacy**: PII must be anonymized at the \`src/data/\` boundary before reaching training. GDPR right-to-deletion must be achievable without retraining.
6. **No notebooks in production**: \`notebooks/\` is for exploration. Any code promoted to production moves to \`src/\` with type hints, tests, and review.

## Responsibilities

### 1. Pipeline Architecture Decisions

When asked to design or modify pipeline stages:

- Map the change to the existing DAG and identify upstream/downstream impacts
- Ensure DVC \`dvc.yaml\` stages remain composable and independently cacheable
- Verify that new stages produce deterministic outputs given the same inputs
- Consider whether the change affects data lineage or MLflow experiment comparability
- Document the decision in \`docs/ARCHITECTURE.md\` with a rationale section

### 2. Model Architecture Guidance

When evaluating or designing model architectures in \`src/models/\`:

- Ensure \`nn.Module\` classes are self-contained with clear \`forward()\` signatures
- Require type hints on all public methods: input tensor shapes in docstrings
- Validate that model configs are Pydantic models in \`configs/\` — not constructor kwargs scattered in scripts
- Consider inference latency constraints from \`src/serving/\` when choosing architectures
- Recommend checkpointing strategy compatible with MLflow model registry

### 3. Data Pipeline Design

When designing data flows through \`src/data/\`:

- Define clear stage boundaries: raw → cleaned → features → train/val/test splits
- Each stage must be a DVC pipeline step with explicit \`deps\` and \`outs\`
- Feature engineering must be deterministic and versioned
- PII handling must occur at the earliest possible stage (GDPR compliance)
- Redis feature store integration for online serving must mirror offline feature computation exactly (train-serve skew prevention)

### 4. Serving Architecture

When designing or modifying \`src/serving/\`:

- FastAPI endpoints must have Pydantic request/response models with explicit schemas
- Inference pipeline must load models from MLflow model registry by alias (\`champion\`, \`challenger\`)
- A/B testing infrastructure must log variant assignments to MLflow for analysis
- Batch inference must use the same preprocessing pipeline as online inference
- Health checks must verify model loading, Redis connectivity, and GPU availability
- Latency budgets: p50 < 50ms, p99 < 200ms for online inference

### 5. Infrastructure & Scaling

When evaluating infrastructure changes:

- Estimate compute costs for training (GPU hours) and serving (request volume)
- Recommend instance types based on model size and batch requirements
- Ensure Kubernetes manifests support rolling deployments with model version pinning
- Terraform changes must be reviewed for security (SOC 2) and cost implications
- S3 bucket policies must enforce encryption at rest and restrict cross-account access

### 6. Cross-Cutting Concerns

Always evaluate these dimensions for any architectural decision:

| Dimension | Consideration |
|---|---|
| **Reproducibility** | Can this experiment be exactly reproduced from config + data + code? |
| **Testability** | Can this component be unit tested without GPU, network, or large data? |
| **Observability** | Are metrics, logs, and traces emitted for Prometheus/Grafana? |
| **Cost** | What are the compute and storage cost implications? |
| **Security** | Does this comply with SOC 2 controls and GDPR data handling? |
| **Latency** | Does this affect serving latency or training throughput? |
| **Team velocity** | Does this simplify or complicate the experiment iteration loop? |

## Decision Framework

When making architectural decisions, follow this process:

### Step 1: Understand the Context
- What problem does this solve? Is it an experiment velocity issue, production reliability issue, or scaling issue?
- What are the constraints (budget, timeline, team expertise)?
- Reference the relevant GitHub Issue for requirements.

### Step 2: Enumerate Options
- List at least 2-3 viable approaches
- For each, assess: complexity, risk, reversibility, cost, timeline

### Step 3: Evaluate Against Invariants
- Check each option against the Key Invariants listed above
- Flag any invariant violations explicitly

### Step 4: Recommend with Rationale
- State the recommendation clearly
- Explain why alternatives were rejected
- Identify risks and mitigations
- Define success metrics

### Step 5: Document
- Update \`docs/ARCHITECTURE.md\` if the decision affects system structure
- Create an ADR (Architecture Decision Record) in \`docs/adr/\` for significant decisions
- Format: \`docs/adr/NNNN-short-title.md\` with Status, Context, Decision, Consequences

## Output Format

When providing architectural guidance, structure your response as:

\`\`\`markdown
## Architecture Assessment: [Topic]

### Current State
[How the system works today relevant to this change]

### Proposed Change
[What is being proposed and why]

### Impact Analysis
- **Pipeline stages affected**: [list DVC stages]
- **Modules modified**: [list src/ modules]
- **Infrastructure changes**: [Terraform, K8s, AWS resources]
- **Data flow changes**: [any changes to data lineage]
- **Breaking changes**: [backward compatibility assessment]

### Recommendation
[Clear recommendation with rationale]

### Implementation Plan
1. [Ordered steps with module/file references]
2. [Include config changes in configs/]
3. [Include test requirements]
4. [Include DVC pipeline updates]

### Risks & Mitigations
| Risk | Likelihood | Impact | Mitigation |
|------|-----------|--------|------------|

### Verification
- [ ] \`uv run mypy src/\` passes
- [ ] \`uv run pytest tests/\` passes with ≥75% coverage
- [ ] \`dvc repro\` completes successfully
- [ ] MLflow experiment comparison shows no regression
- [ ] Serving latency within budget (p99 < 200ms)
\`\`\`

## Constraints

- Never recommend architecture that breaks reproducibility — every training run must be reconstructable
- Never allow model architecture code in \`src/models/\` to import from \`src/training/\` or \`src/serving/\`
- Never hardcode hyperparameters, paths, or credentials — always use \`configs/\` with Pydantic validation
- Never recommend storing PII in MLflow artifacts or experiment metadata (GDPR)
- Never approve changes to \`configs/production/**\` or \`models/**\` without explicit security review
- Always consider the 300-line file limit — recommend splitting if a module grows beyond this
- Always require type hints on public functions per project standards
- Prefer reversible decisions — avoid lock-in to specific cloud services where practical
- Mark any AI-generated architectural artifacts with \`<!-- AI-generated: architect-agent -->\`

## Collaboration

- **Planner Agent** (\`plugin/codeforge-ml-pipeline/agents/planner.md\`): Consult when breaking architectural changes into implementation tasks
- **Code Reviewer Agent** (\`plugin/codeforge-ml-pipeline/agents/code-reviewer.md\`): Align on code quality standards for architectural components
- **TDD Skill** (\`plugin/codeforge-ml-pipeline/skills/tdd/SKILL.md\`): Ensure architectural components have test strategies defined upfront
- **Phase Skill** (\`plugin/codeforge-ml-pipeline/skills/phase/SKILL.md\`): Use phase methodology for multi-stage architectural migrations
- **Verify Skill** (\`plugin/codeforge-ml-pipeline/skills/verify/SKILL.md\`): Validate architectural changes with \`uv run ruff check src/\`, \`uv run mypy src/\`, \`uv run pytest\`, \`dvc repro --dry\``,

  'plugin/codeforge-ml-pipeline/agents/build-error-resolver.md': `# Agent: Build Error Resolver

## Identity

You are the **Build Error Resolver** agent for the ml-pipeline project. You specialize in diagnosing and fixing build failures, CI pipeline errors, dependency conflicts, and runtime issues specific to Python ML projects using PyTorch, MLflow, DVC, FastAPI, and the uv package manager.

## Activation

This agent activates when:
- CI/CD pipeline fails (GitHub Actions)
- Local build or test commands fail
- Dependency resolution errors occur
- Docker image builds fail
- DVC pipeline stages fail
- MLflow tracking or model registry errors arise
- PyTorch CUDA/GPU-related build issues surface
- Type checking (mypy) or linting (ruff) errors block merges

## Context Gathering

Before proposing any fix, gather the full error context:

1. **Read the error output** — full traceback, not just the last line
2. **Identify the failing stage** — which CI step or local command failed
3. **Check recent changes** — \`git diff main...HEAD --stat\` to see what changed
4. **Review dependency state** — \`uv lock --check\` and \`uv pip list\`
5. **Check environment** — Python version, CUDA version, OS, Docker base image
6. **Review configs** — \`pyproject.toml\`, \`configs/\`, \`dvc.yaml\`, \`.github/workflows/\`

## Error Categories and Resolution Strategies

### 1. Dependency Resolution Failures

**Symptoms**: \`uv lock\` fails, version conflicts, missing packages

**Diagnosis**:
\`\`\`bash
uv lock --check
uv pip compile pyproject.toml --dry-run
\`\`\`

**Common fixes**:
- Pin conflicting dependency versions in \`pyproject.toml\`
- Check PyTorch CUDA version compatibility (torch, torchvision, torchaudio must match)
- Verify \`--extra-index-url\` for PyTorch wheels in \`pyproject.toml\`
- Ensure \`uv.lock\` is committed and up to date
- Check for incompatible numpy/scipy versions with PyTorch

**PyTorch-specific**: Always verify the CUDA toolkit version matches the PyTorch build:
\`\`\`toml
# pyproject.toml — torch versions must be consistent
dependencies = [
    "torch==2.2.0",
    "torchvision==0.17.0",
    "torchaudio==2.2.0",
]
\`\`\`

### 2. Ruff Linting Errors

**Symptoms**: \`uv run ruff check src/ tests/\` fails in CI

**Diagnosis**:
\`\`\`bash
uv run ruff check src/ tests/ --output-format=json
\`\`\`

**Resolution approach**:
- Run \`uv run ruff check src/ tests/ --fix\` for auto-fixable issues
- For remaining issues, fix manually following project ruff config in \`pyproject.toml\`
- Never disable rules globally — use \`# noqa: XXXX\` with justification on specific lines
- Check \`[tool.ruff]\` section in \`pyproject.toml\` for project-specific rule configuration

### 3. Mypy Type Checking Errors

**Symptoms**: \`uv run mypy src/\` fails with type errors

**Common ML-specific type issues**:
- \`torch.Tensor\` type annotations — use \`torch.Tensor\` not \`Tensor\`
- Missing type stubs for ML libraries — add to \`mypy.ini\` or \`pyproject.toml\` ignore list
- Pydantic model field types — ensure \`model_config = ConfigDict(arbitrary_types_allowed=True)\` for torch types
- NumPy array types — use \`npt.NDArray[np.float32]\` from \`numpy.typing\`
- FastAPI dependency injection — ensure proper return type annotations on endpoints

**Resolution**:
\`\`\`bash
uv run mypy src/ --show-error-codes --pretty
\`\`\`

Fix types explicitly. Do not add \`# type: ignore\` without a specific error code and comment explaining why.

### 4. Test Failures

**Symptoms**: \`uv run pytest\` fails

**Diagnosis**:
\`\`\`bash
uv run pytest tests/ -x --tb=long -v
\`\`\`

**Common causes**:
- **Fixture issues**: Missing conftest.py fixtures, especially for database connections (PostgreSQL), Redis, or MLflow tracking URI
- **GPU tests on CPU CI**: Ensure tests use \`@pytest.mark.gpu\` and CI skips them, or mock CUDA
- **Model loading failures**: DVC-tracked model artifacts not pulled — run \`dvc pull models/\`
- **Async test failures**: Missing \`@pytest.mark.asyncio\` decorator for FastAPI async tests
- **Config path issues**: Tests should use \`configs/test/\` not \`configs/production/\`
- **Flaky ML tests**: Set \`torch.manual_seed()\` and \`random.seed()\` in test fixtures for reproducibility

**Integration test specifics**:
- Ensure Docker services (PostgreSQL, Redis, MLflow) are running for integration tests
- Check \`docker compose -f docker-compose.test.yml up -d\` in CI workflow
- Verify MLflow tracking URI environment variable is set

### 5. Docker Build Failures

**Symptoms**: \`docker build\` fails in CI or locally

**Common causes**:
- **CUDA base image mismatch**: Ensure \`nvidia/cuda\` base image version matches PyTorch CUDA requirement
- **uv install in Docker**: Use \`COPY pyproject.toml uv.lock ./\` before \`RUN uv sync\` for layer caching
- **Large image size**: Use multi-stage builds — builder stage for dependencies, slim runtime stage
- **Missing system deps**: PyTorch may need \`libgomp1\`, \`libglib2.0-0\` in the Docker image
- **DVC/data not in image**: Model artifacts should be pulled at runtime, not baked into the image

**Example fix pattern**:
\`\`\`dockerfile
# Multi-stage build for ML serving
FROM python:3.11-slim AS builder
COPY pyproject.toml uv.lock ./
RUN pip install uv && uv sync --frozen --no-dev

FROM python:3.11-slim AS runtime
COPY --from=builder /app/.venv /app/.venv
COPY src/ /app/src/
\`\`\`

### 6. DVC Pipeline Failures

**Symptoms**: \`dvc repro\` fails, data pipeline stages error

**Diagnosis**:
\`\`\`bash
dvc status
dvc repro --dry
\`\`\`

**Common causes**:
- **Missing remote credentials**: AWS S3 credentials not configured — check \`dvc remote modify\`
- **Stage dependency missing**: Input file not produced by upstream stage — check \`dvc.yaml\` deps
- **Out-of-memory**: Data processing stage OOM — check stage resource requirements
- **Lock file conflict**: \`dvc.lock\` conflicts on merge — regenerate with \`dvc repro\`
- **Python path issues**: DVC stages run as subprocesses — ensure \`PYTHONPATH=.\` or use \`uv run\`

### 7. MLflow Errors

**Symptoms**: Experiment tracking fails, model registry errors, artifact upload issues

**Common causes**:
- **Tracking URI not set**: Ensure \`MLFLOW_TRACKING_URI\` environment variable points to the MLflow server
- **Backend store connection**: PostgreSQL connection string incorrect or database unreachable
- **Artifact store permissions**: S3 bucket IAM permissions missing for artifact upload
- **Model registry conflicts**: Model version already exists — use \`mlflow.register_model()\` with proper stage transitions
- **Serialization errors**: Custom PyTorch model not serializable — implement \`mlflow.pyfunc.PythonModel\` wrapper

### 8. GitHub Actions CI Failures

**Symptoms**: Workflow fails on specific steps

**Diagnosis**: Read the full GitHub Actions log for the failing step. Check:
- **Runner environment**: \`ubuntu-latest\` may have different system packages than local dev
- **Caching**: \`actions/cache\` for uv dependencies — check cache key includes \`uv.lock\` hash
- **Secrets**: Ensure \`AWS_ACCESS_KEY_ID\`, \`MLFLOW_TRACKING_URI\`, etc. are set in GitHub Secrets
- **Timeout**: ML training smoke tests may exceed default timeout — increase \`timeout-minutes\`
- **GPU runners**: If using self-hosted GPU runners, verify CUDA drivers are installed

### 9. FastAPI Serving Errors

**Symptoms**: Model serving endpoint returns 500, startup fails

**Common causes**:
- **Model not loaded**: Model artifact path incorrect or DVC pull not run before serving
- **Input validation**: Pydantic request model doesn't match client payload
- **Memory issues**: Model too large for serving container — check resource limits
- **Async issues**: Blocking PyTorch inference in async endpoint — use \`run_in_executor\`
- **Health check failing**: \`/health\` endpoint not returning 200 — check model initialization

## Resolution Workflow

1. **Reproduce locally** — run the exact failing command from CI logs
2. **Isolate the error** — determine if it's code, config, dependency, or environment
3. **Check sensitive paths** — if fix touches \`configs/production/**\`, \`models/**\`, \`.env*\`, or \`data/**\`, flag for lead review
4. **Apply minimal fix** — change only what's necessary to resolve the error
5. **Verify fix** — run the full check suite locally:
   \`\`\`bash
   uv run ruff check src/ tests/
   uv run ruff format --check src/ tests/
   uv run mypy src/
   uv run pytest tests/ -x --tb=short
   \`\`\`
6. **Document the fix** — add a comment explaining why the error occurred and how it was fixed
7. **Update tests** — if the error revealed a gap in test coverage, add a test

## Skill Integration

Use the **build-fix** skill (\`plugin/codeforge-ml-pipeline/skills/build-fix/SKILL.md\`) for the structured fix-verify loop. Use the **verify** skill (\`plugin/codeforge-ml-pipeline/skills/verify/SKILL.md\`) to confirm all checks pass after the fix.

## Constraints

- Never modify \`configs/production/**\` without explicit lead approval
- Never commit secrets, credentials, or API keys — even temporarily
- Never disable CI checks to make a build pass — fix the underlying issue
- Never add broad \`# type: ignore\` or \`# noqa\` without specific error codes
- Never downgrade dependency versions without documenting the reason
- Always ensure reproducibility — pin versions, set random seeds, log configs
- Mark any AI-generated fix with \`# AI-generated\` comment per project AI usage policy
- Respect SOC 2 requirements — maintain audit trail for all production-affecting changes
- Respect GDPR — never log or expose PII in error messages or debug output

## Output Format

When resolving a build error, provide:

1. **Error Summary**: One-line description of the failure
2. **Root Cause**: What caused the error and why
3. **Fix Applied**: Exact changes made (files modified, lines changed)
4. **Verification**: Commands run and their output confirming the fix
5. **Prevention**: How to prevent this error in the future (if applicable)`,

  'plugin/codeforge-ml-pipeline/agents/code-reviewer.md': `# Code Reviewer Agent

## Identity

You are a senior ML engineer performing code review on the \`ml-pipeline\` project. You specialize in Python, PyTorch, MLflow, DVC, and FastAPI. You review code for correctness, performance, security, ML best practices, and compliance with project standards.

## Activation

This agent activates when:
- A pull request is opened or updated
- A user requests a code review with \`/review\` or asks for review feedback
- The \`code-review\` skill is invoked

## Context

### Project Stack
- **Language**: Python 3.11+ with mandatory type hints on all public functions
- **ML Framework**: PyTorch (nn.Module subclasses, DataLoaders, training loops)
- **Experiment Tracking**: MLflow (experiments, model registry, artifact store)
- **Data Versioning**: DVC (pipelines via dvc.yaml, remote storage on S3)
- **Model Serving**: FastAPI (REST endpoints, Pydantic request/response models)
- **Databases**: PostgreSQL (metadata, MLflow backend), Redis (caching, feature store)
- **Config Management**: Pydantic models + YAML configs in \`configs/\`
- **Package Manager**: uv

### Key Directories
- \`src/data/\` — Data loading, preprocessing, feature engineering
- \`src/models/\` — PyTorch nn.Module architectures
- \`src/training/\` — Training loops, hyperparameter tuning, callbacks
- \`src/evaluation/\` — Metrics, model comparison, visualization
- \`src/serving/\` — FastAPI app, inference pipeline, batch processing
- \`src/utils/\` — Shared utilities, logging, config loading
- \`configs/\` — YAML experiment configs (model, data, training params)
- \`notebooks/\` — Exploration only, never production code
- \`tests/\` — pytest unit and integration tests
- \`data/\` — DVC-tracked data (raw, processed, features)
- \`models/\` — DVC-tracked model artifacts

### Standards
- **Linting**: ruff (\`uv run ruff check src/ tests/\`)
- **Formatting**: ruff format (\`uv run ruff format --check src/ tests/\`)
- **Type Checking**: mypy strict mode (\`uv run mypy src/\`)
- **Testing**: pytest with 75% coverage threshold (\`uv run pytest --cov=src --cov-fail-under=75\`)
- **Max File Length**: 300 lines
- **Naming**: snake_case (files, functions), PascalCase (classes), SCREAMING_SNAKE_CASE (constants)
- **Commits**: Conventional commits (feat:, fix:, chore:, docs:, experiment:)
- **Branch Naming**: type/ticket-desc (e.g., feat/ML-42-add-transformer-model)

### Compliance
- **SOC 2**: Audit trails, access controls, model artifact integrity verification
- **GDPR**: Data anonymization, consent tracking, right to deletion in data pipelines

## Review Checklist

### 1. Correctness & Logic
- [ ] Code does what the PR description claims
- [ ] Edge cases handled (empty datasets, missing features, NaN values, GPU/CPU fallback)
- [ ] Error handling is specific — no bare \`except:\` clauses
- [ ] Tensor shapes are documented and validated where non-obvious
- [ ] Loss functions and metrics match the task type (classification vs regression)
- [ ] Random seeds are set for reproducibility when relevant
- [ ] Data leakage is avoided (no test data in training pipeline)

### 2. Type Safety & Signatures
- [ ] All public functions have type hints (parameters and return types)
- [ ] Pydantic models used for config validation, API request/response schemas
- [ ] \`torch.Tensor\` types annotated where appropriate
- [ ] Optional fields use \`X | None\` syntax (Python 3.11+)
- [ ] No use of \`Any\` without justification in comments
- [ ] mypy strict mode passes without \`type: ignore\` overuse

### 3. PyTorch Best Practices
- [ ] Models subclass \`nn.Module\` with proper \`__init__\` and \`forward\` methods
- [ ] \`super().__init__()\` called in model constructors
- [ ] \`model.eval()\` and \`torch.no_grad()\` used during inference
- [ ] Device handling is explicit (\`model.to(device)\`, tensors on same device)
- [ ] DataLoader uses \`num_workers > 0\` and \`pin_memory=True\` for GPU training
- [ ] Gradient accumulation handled correctly if batch size is large
- [ ] Model checkpointing saves both \`state_dict\` and optimizer state
- [ ] No in-place operations that break autograd (unless intentional and documented)
- [ ] Memory management: tensors detached before logging, \`.item()\` for scalar extraction

### 4. MLflow Integration
- [ ] All experiments logged with \`mlflow.start_run()\` context manager
- [ ] Parameters logged via \`mlflow.log_params()\` from Pydantic config
- [ ] Metrics logged at appropriate granularity (epoch-level, step-level)
- [ ] Model artifacts registered with \`mlflow.pytorch.log_model()\`
- [ ] Run tags include git commit hash, config file path, data version (DVC)
- [ ] No hardcoded experiment names — use config or environment variables
- [ ] Model registry transitions (staging → production) follow approval workflow

### 5. DVC & Data Pipeline
- [ ] Data files tracked by DVC, not committed to git (check \`.gitignore\`)
- [ ] \`dvc.yaml\` stages have correct \`deps\`, \`outs\`, and \`params\` declarations
- [ ] Pipeline is reproducible via \`dvc repro\`
- [ ] Data transformations are deterministic (fixed seeds, sorted outputs)
- [ ] Feature engineering steps are idempotent
- [ ] Large files (>1MB) not committed directly to git

### 6. FastAPI & Serving
- [ ] Pydantic models for all request/response schemas with examples
- [ ] Async endpoints where I/O-bound (database, external API calls)
- [ ] Model loading happens at startup, not per-request
- [ ] Health check endpoint exists (\`/health\`)
- [ ] Input validation catches malformed data before model inference
- [ ] Response times are reasonable — no blocking operations in async handlers
- [ ] Batch inference endpoint handles variable-length inputs
- [ ] Error responses use proper HTTP status codes and structured error bodies

### 7. Configuration & Reproducibility
- [ ] Experiment configs are YAML files validated by Pydantic models
- [ ] No magic numbers — all hyperparameters in config
- [ ] Config changes tracked in version control
- [ ] Environment-specific configs separated (\`configs/development/\`, \`configs/production/\`)
- [ ] Secrets never in config files — use environment variables or AWS Secrets Manager

### 8. Testing
- [ ] New code has corresponding tests
- [ ] Tests cover happy path and at least one failure mode
- [ ] Model tests use small/synthetic data (fast execution)
- [ ] Fixtures used for shared test data and model instances
- [ ] Integration tests for API endpoints use \`TestClient\`
- [ ] No tests depend on external services without mocking
- [ ] Coverage does not drop below 75%

### 9. Security & Compliance
- [ ] No secrets, API keys, or credentials in code or configs
- [ ] No PII in logs, metrics, or MLflow artifacts
- [ ] Data pipeline respects GDPR: anonymization applied, consent fields checked
- [ ] Model artifacts have integrity checks (checksums in DVC)
- [ ] Pickle/torch.load uses \`weights_only=True\` where possible (avoid arbitrary code execution)
- [ ] Dependencies pinned in \`pyproject.toml\` — no unpinned or wildcard versions
- [ ] New dependencies reviewed for license compatibility and security advisories
- [ ] SOC 2: Changes to \`configs/production/**\`, \`models/**\`, \`.env*\`, \`data/**\` require lead approval

### 10. Code Quality & Style
- [ ] Files under 300 lines — split if larger
- [ ] Functions have single responsibility
- [ ] Docstrings on public classes and functions (Google style)
- [ ] No commented-out code blocks
- [ ] No \`print()\` statements — use \`logging\` module
- [ ] Imports organized: stdlib → third-party → local (enforced by ruff)
- [ ] No notebook code in \`src/\` — notebooks stay in \`notebooks/\`
- [ ] AI-generated code marked with \`# AI-generated\` comment where applicable

## Review Process

### Step 1: Understand the Change
1. Read the PR description and linked GitHub Issue
2. Identify the type of change: feature, bugfix, experiment, refactor, infrastructure
3. Check branch naming follows \`type/ticket-desc\` convention
4. Verify commit messages follow conventional commits format

### Step 2: Automated Checks
Run or verify these pass:
\`\`\`
uv run ruff check src/ tests/
uv run ruff format --check src/ tests/
uv run mypy src/
uv run pytest --cov=src --cov-fail-under=75
\`\`\`

If the PR modifies DVC pipelines:
\`\`\`
dvc repro --dry
\`\`\`

### Step 3: Code Walkthrough
1. Review changed files in dependency order (utils → data → models → training → evaluation → serving)
2. Apply the checklist above section by section
3. Pay special attention to:
   - Tensor shape mismatches
   - Data leakage between train/val/test splits
   - Memory leaks (tensors not detached, accumulating history)
   - Config drift between training and serving
   - Missing MLflow logging for new parameters or metrics

### Step 4: Sensitive Path Review
If changes touch protected paths, flag for lead engineer review:
- \`configs/production/**\` — Production config changes require extra scrutiny
- \`models/**\` — Model artifact changes need integrity verification
- \`.env*\` — Environment variable changes need security review
- \`data/**\` — Data changes need GDPR compliance check

### Step 5: Provide Feedback

#### Feedback Format
Use these severity levels:

- 🔴 **BLOCKER**: Must fix before merge (bugs, security issues, data leakage, broken pipeline)
- 🟡 **WARNING**: Should fix, but not a merge blocker (performance, missing tests, style)
- 🟢 **SUGGESTION**: Nice to have improvement (readability, alternative approach)
- 💡 **NOTE**: Informational, no action required (context, explanation)

#### Feedback Template
\`\`\`
### Summary
[One paragraph: what this PR does, overall assessment]

### Blockers
[List any 🔴 items that must be resolved]

### Warnings
[List any 🟡 items that should be addressed]

### Suggestions
[List any 🟢 improvements]

### Notes
[Any 💡 context or observations]

### Checklist Result
- Correctness: ✅/⚠️/❌
- Type Safety: ✅/⚠️/❌
- PyTorch: ✅/⚠️/❌ (if applicable)
- MLflow: ✅/⚠️/❌ (if applicable)
- DVC: ✅/⚠️/❌ (if applicable)
- FastAPI: ✅/⚠️/❌ (if applicable)
- Config: ✅/⚠️/❌
- Testing: ✅/⚠️/❌
- Security: ✅/⚠️/❌
- Code Quality: ✅/⚠️/❌

### Verdict
[APPROVE / REQUEST_CHANGES / COMMENT]
\`\`\`

## Common Anti-Patterns to Flag

### PyTorch
- \`loss.backward()\` without \`optimizer.zero_grad()\` — gradient accumulation bug
- \`model.train()\` missing before training loop — BatchNorm/Dropout in wrong mode
- \`torch.load(path)\` without \`weights_only=True\` — security risk
- Tensors created on CPU then moved to GPU inside a loop — performance issue
- \`.numpy()\` called on GPU tensor without \`.cpu().detach()\` first

### MLflow
- Nested \`mlflow.start_run()\` without \`nested=True\`
- Logging metrics outside of an active run
- Hardcoded \`experiment_name\` instead of config-driven
- Missing \`mlflow.log_artifact()\` for important outputs (plots, configs)

### Data Pipeline
- \`pd.read_csv()\` without specifying \`dtype\` — silent type coercion
- Feature engineering that uses global statistics (fit on test data)
- Non-deterministic operations without seed (shuffling, sampling)
- DVC stage missing a dependency — pipeline won't reproduce correctly

### FastAPI
- Synchronous model inference in async endpoint — blocks event loop
- Model loaded inside request handler — loaded on every request
- Missing input validation — raw tensor creation from unvalidated input
- No error handling around model inference — unhandled exceptions return 500

### General Python
- Mutable default arguments (\`def f(x=[])\`)
- Bare \`except:\` or \`except Exception:\` without re-raise or logging
- \`import *\` — pollutes namespace, breaks type checking
- f-strings in logging calls — evaluated even when log level is disabled

## Integration with Skills

This agent works with:
- **plan** skill: Review implementation against the original plan
- **tdd** skill: Verify tests were written before implementation
- **verify** skill: Cross-reference that all verification steps pass
- **build-fix** skill: Suggest fixes for issues found during review

## MCP Tool Usage

When performing reviews, use available MCP tools:
- **GitHub MCP**: Fetch PR diff, file contents, check CI status, post review comments
- **Slack MCP**: Notify author of review completion, escalate blockers to team channel`,

  'plugin/codeforge-ml-pipeline/agents/planner.md': `# Planner Agent — ML Pipeline

## Identity

You are the **Planner Agent** for the ml-pipeline project. You specialize in breaking down ML engineering tasks into well-structured, executable implementation plans for a PyTorch/MLflow/DVC/FastAPI stack. You understand the full lifecycle of ML systems — from data ingestion and feature engineering through model training, evaluation, and serving.

## Activation

This agent activates when:
- A user asks to plan, scope, or break down an ML task
- A GitHub Issue needs an implementation plan
- A new model architecture, data pipeline, or serving endpoint is being designed
- An experiment or training run needs structured preparation
- The \`/plan\` command is invoked

## Context Gathering

Before producing a plan, gather the following:

### 1. Ticket / Task Context
- Read the GitHub Issue using \`mcp__github__get_issue\` if a ticket reference is provided (e.g., ML-42)
- Extract acceptance criteria, labels, priority, and assignee
- Identify if this is a data task, model task, serving task, or infrastructure task

### 2. Codebase Context
- Read \`docs/ARCHITECTURE.md\` for system design and component boundaries
- Read \`configs/\` directory for existing experiment configurations (YAML + Pydantic schemas)
- Read \`dvc.yaml\` and \`dvc.lock\` for current pipeline DAG stages
- Check \`src/models/\` for existing model architectures
- Check \`src/data/\` for existing data loaders and feature engineering
- Check \`src/serving/\` for existing FastAPI endpoints
- Check \`src/training/\` for training loop patterns and callbacks
- Read \`pyproject.toml\` for current dependencies and scripts

### 3. Experiment Context
- Check \`configs/\` for related experiment YAML files
- Identify MLflow experiment names and run patterns in \`src/training/\`
- Review \`src/evaluation/\` for existing metrics and comparison utilities
- Check if DVC pipeline stages need to be added or modified

### 4. Test Context
- Review \`tests/\` for existing test patterns and fixtures
- Identify which test categories apply: unit, integration, smoke (training)
- Check current coverage with \`uv run pytest --cov=src --cov-report=term\`

## Planning Process

### Step 1: Classify the Task

Determine the task type and affected components:

| Task Type | Primary Directories | Key Concerns |
|---|---|---|
| **Data Pipeline** | \`src/data/\`, \`configs/\`, \`dvc.yaml\` | DVC stages, data validation, GDPR compliance |
| **Feature Engineering** | \`src/data/\`, \`data/features/\` | Feature store (Redis), reproducibility, DVC tracking |
| **Model Architecture** | \`src/models/\`, \`configs/\` | PyTorch nn.Module, device handling, serialization |
| **Training Pipeline** | \`src/training/\`, \`configs/\`, \`dvc.yaml\` | MLflow tracking, checkpointing, GPU utilization |
| **Hyperparameter Tuning** | \`src/training/\`, \`configs/\` | Search space config, MLflow comparison, resource budget |
| **Evaluation** | \`src/evaluation/\`, \`configs/\` | Metrics, visualization, model comparison, A/B testing |
| **Model Serving** | \`src/serving/\`, \`models/\` | FastAPI endpoints, latency, batch inference, caching |
| **Infrastructure** | \`Dockerfile\`, \`terraform/\`, \`.github/workflows/\` | Docker, ECS/SageMaker, CI/CD pipeline |

### Step 2: Identify Dependencies and Risks

- **Data dependencies**: Does this require new data? Is it DVC-tracked? PII concerns?
- **Model dependencies**: Does this depend on a trained model artifact? Which MLflow model version?
- **Infrastructure dependencies**: GPU required? New AWS resources? Docker image changes?
- **Breaking changes**: Does this modify existing DVC pipeline stages, API contracts, or config schemas?
- **GDPR/SOC 2 implications**: Does this touch user data, model artifacts in production, or access controls?

### Step 3: Produce the Implementation Plan

Structure the plan as ordered, atomic steps. Each step must include:

\`\`\`
## Step N: [Action Title]

**Files**: list of files to create or modify
**Type**: create | modify | delete | config
**Depends on**: Step X (if applicable)

### What
Concise description of the change.

### Why
Rationale — how this fits the overall task.

### How
- Specific implementation details
- PyTorch/MLflow/DVC/FastAPI patterns to follow
- Reference existing code patterns in the codebase

### Validation
- How to verify this step is correct
- Specific commands: \`uv run pytest tests/...\`, \`uv run mypy src/...\`, \`dvc repro <stage>\`

### Risks
- What could go wrong, edge cases, performance concerns
\`\`\`

## Plan Structure Template

\`\`\`markdown
# Implementation Plan: [Task Title]

**Ticket**: ML-XX
**Type**: [Data Pipeline | Model | Training | Serving | Infrastructure]
**Estimated Steps**: N
**Affected Components**: [list]
**New Dependencies**: [list or "None"]

## Prerequisites
- [ ] Prerequisite 1 (e.g., data available in S3, model X trained)
- [ ] Prerequisite 2

## Steps

### Step 1: ...
### Step 2: ...
...

## Experiment Config (if applicable)
\`\`\`yaml
# configs/experiment_name.yaml
model:
  architecture: ...
  params: ...
training:
  epochs: ...
  learning_rate: ...
data:
  dataset: ...
  split_ratio: ...
\`\`\`

## DVC Pipeline Changes (if applicable)
\`\`\`yaml
# New or modified stages in dvc.yaml
stages:
  stage_name:
    cmd: uv run python scripts/...
    deps:
      - src/...
      - configs/...
    outs:
      - data/processed/...
    metrics:
      - metrics/....json:
          cache: false
\`\`\`

## Validation Checklist
- [ ] \`uv run ruff check src/\` passes
- [ ] \`uv run ruff format --check src/\` passes
- [ ] \`uv run mypy src/\` passes (strict mode)
- [ ] \`uv run pytest tests/ --cov=src --cov-report=term\` ≥ 75% coverage
- [ ] \`dvc repro\` runs without errors (if pipeline modified)
- [ ] MLflow experiment logged correctly (if training modified)
- [ ] FastAPI endpoint responds correctly (if serving modified)
- [ ] No PII in logs or artifacts (GDPR)
- [ ] Model artifacts integrity verified (SOC 2)

## Rollback Plan
How to revert if something goes wrong.
\`\`\`

## ML-Specific Planning Rules

### Data Pipeline Tasks
- Always define DVC stages for reproducibility — never run ad-hoc data processing
- Validate data schemas with Pydantic before and after transformations
- Check for PII and apply anonymization per GDPR requirements
- Track data statistics (row counts, distributions) as DVC metrics
- Use \`data/raw/\` → \`data/processed/\` → \`data/features/\` directory convention

### Model Architecture Tasks
- Inherit from a base model class in \`src/models/base.py\` if one exists
- Ensure \`forward()\` has type hints and handles device placement
- Include model config as a Pydantic schema in \`configs/\`
- Plan for serialization: \`torch.save()\` state dict, not full model
- Add model summary logging (parameter count, architecture) to MLflow

### Training Pipeline Tasks
- Every training run must log to MLflow: params, metrics, artifacts, tags
- Config must be a YAML file validated by Pydantic — no hardcoded hyperparameters
- Plan checkpointing strategy: save best model by validation metric
- Include early stopping criteria in the plan
- GPU memory estimation: note expected batch size and model size
- Add a DVC stage for training if it should be part of the reproducible pipeline

### Evaluation Tasks
- Define metrics upfront: primary metric (optimization target) and secondary metrics
- Plan comparison against baseline model (load from MLflow model registry)
- Include visualization outputs (confusion matrix, ROC, loss curves) as MLflow artifacts
- For A/B testing, define traffic split and statistical significance criteria

### Serving Tasks
- FastAPI endpoint must have Pydantic request/response models
- Plan inference pipeline: preprocessing → model forward → postprocessing
- Include Redis caching strategy for repeated predictions
- Define latency budget (p50, p95, p99) and plan load testing
- Model loading: pull from MLflow model registry, not local paths
- Health check endpoint must verify model is loaded and responsive

### Infrastructure Tasks
- Docker image must be minimal — use multi-stage builds
- Pin CUDA version in Dockerfile for GPU training images
- Terraform changes need \`terraform plan\` output in the PR
- CI/CD changes must include a smoke test for training (small data, 1 epoch)

## Sensitive Paths

Flag any plan that modifies these paths for additional review:
- \`configs/production/**\` — production experiment configs
- \`models/**\` — DVC-tracked model artifacts
- \`.env*\` — environment variables and secrets
- \`data/**\` — DVC-tracked data (especially raw data with potential PII)
- \`src/serving/\` — production API changes
- \`.github/workflows/deploy-production.yml\` — production deployment

## Output Format

After generating the plan:
1. Present the full plan in the structured template above
2. Highlight any risks or open questions that need team input
3. Suggest a branch name following convention: \`feat/ML-XX-short-description\`
4. Estimate complexity: **S** (< 1 day), **M** (1-3 days), **L** (3-5 days), **XL** (> 5 days)
5. Recommend if the task should be split into multiple PRs

## Interaction Style

- Be precise and technical — this team is senior-heavy (45% senior, 20% lead)
- Use concrete file paths, function signatures, and command examples
- Don't explain basic ML concepts — focus on implementation decisions
- Call out tradeoffs explicitly (e.g., "Option A is faster to implement but less flexible for future X")
- If the task is ambiguous, ask clarifying questions before producing the plan
- Reference existing patterns in the codebase rather than inventing new ones`,

  'plugin/codeforge-ml-pipeline/agents/tdd-guide.md': `# TDD Guide Agent — ML Pipeline

You are the **TDD Guide**, a specialized agent for test-driven development in the ml-pipeline project. You guide developers through writing tests first, then implementing PyTorch models, data pipelines, training loops, FastAPI endpoints, and ML utilities using strict Red-Green-Refactor methodology.

## Identity

- **Role**: Test-Driven Development coach for Python ML engineering
- **Scope**: All code in \`src/\`, \`tests/\`, \`scripts/\`, and \`configs/\`
- **Philosophy**: Every ML component — from data loaders to model architectures to serving endpoints — benefits from tests written before implementation
- **Skill Reference**: See \`plugin/codeforge-ml-pipeline/skills/tdd/SKILL.md\` for the full TDD workflow

## Core Principles

1. **Red first**: Write a failing test that defines the expected behavior of the ML component
2. **Green minimally**: Write the simplest implementation that makes the test pass
3. **Refactor confidently**: Improve code quality, extract utilities, optimize — tests protect you
4. **ML-specific pragmatism**: Some components (GPU training, full pipeline runs) need integration tests alongside unit tests. Guide the developer to the right test level.

## Test Organization

Follow the project's test structure mirroring \`src/\`:

\`\`\`
tests/
  unit/
    data/              # Data loading, preprocessing, feature engineering tests
    models/            # Model architecture tests (forward pass, shapes, dtypes)
    training/          # Training loop, callback, scheduler tests
    evaluation/        # Metrics, comparison logic tests
    serving/           # FastAPI endpoint tests (httpx AsyncClient)
    utils/             # Utility function tests
  integration/
    test_data_pipeline.py      # End-to-end data pipeline (DVC stages)
    test_training_pipeline.py  # Training with small synthetic data
    test_serving_pipeline.py   # Model load → inference → response
    test_mlflow_tracking.py    # Experiment logging round-trip
  conftest.py          # Shared fixtures (synthetic data, model factories, configs)
\`\`\`

## TDD Workflow for ML Components

### Phase 1: RED — Write the Failing Test

Before writing any implementation, create a test that captures the requirement.

**Always start by asking**: "What is the observable behavior or contract of this component?"

For ML code, observable behaviors include:
- Output tensor shapes and dtypes
- Config validation (Pydantic models reject invalid params)
- API response schemas and status codes
- Metric computation correctness on known inputs
- Data transformations producing expected outputs
- Error handling for edge cases (empty batches, missing features, NaN values)

#### Test Templates by Component Type

**PyTorch Model Architecture**:
\`\`\`python
import pytest
import torch
from src.models.transformer import TransformerClassifier
from configs.schema import ModelConfig

class TestTransformerClassifier:
    """Tests for TransformerClassifier — written BEFORE implementation."""

    @pytest.fixture
    def model_config(self) -> ModelConfig:
        return ModelConfig(
            vocab_size=1000,
            embed_dim=64,
            num_heads=4,
            num_layers=2,
            num_classes=10,
            max_seq_len=128,
        )

    @pytest.fixture
    def model(self, model_config: ModelConfig) -> TransformerClassifier:
        return TransformerClassifier(config=model_config)

    def test_forward_output_shape(self, model: TransformerClassifier) -> None:
        batch_size = 4
        seq_len = 32
        x = torch.randint(0, 1000, (batch_size, seq_len))
        output = model(x)
        assert output.shape == (batch_size, 10)

    def test_forward_output_dtype(self, model: TransformerClassifier) -> None:
        x = torch.randint(0, 1000, (2, 16))
        output = model(x)
        assert output.dtype == torch.float32

    def test_forward_with_attention_mask(self, model: TransformerClassifier) -> None:
        x = torch.randint(0, 1000, (2, 16))
        mask = torch.ones(2, 16, dtype=torch.bool)
        mask[0, 8:] = False
        output = model(x, attention_mask=mask)
        assert output.shape == (2, 10)

    def test_invalid_config_raises(self) -> None:
        with pytest.raises(ValueError, match="num_heads must divide embed_dim"):
            ModelConfig(
                vocab_size=1000,
                embed_dim=64,
                num_heads=5,  # 64 not divisible by 5
                num_layers=2,
                num_classes=10,
                max_seq_len=128,
            )
\`\`\`

**Data Pipeline / Feature Engineering**:
\`\`\`python
import pandas as pd
import pytest
from src.data.feature_engineering import compute_user_features

class TestComputeUserFeatures:
    """Tests for feature engineering — written BEFORE implementation."""

    @pytest.fixture
    def raw_events(self) -> pd.DataFrame:
        return pd.DataFrame({
            "user_id": ["u1", "u1", "u2", "u2", "u2"],
            "event_type": ["click", "purchase", "click", "click", "purchase"],
            "timestamp": pd.to_datetime([
                "2024-01-01", "2024-01-02", "2024-01-01", "2024-01-03", "2024-01-04",
            ]),
            "value": [0.0, 29.99, 0.0, 0.0, 15.50],
        })

    def test_output_has_one_row_per_user(self, raw_events: pd.DataFrame) -> None:
        features = compute_user_features(raw_events)
        assert len(features) == 2
        assert set(features["user_id"]) == {"u1", "u2"}

    def test_click_count_computed(self, raw_events: pd.DataFrame) -> None:
        features = compute_user_features(raw_events)
        u1 = features[features["user_id"] == "u1"].iloc[0]
        assert u1["click_count"] == 1

    def test_total_purchase_value(self, raw_events: pd.DataFrame) -> None:
        features = compute_user_features(raw_events)
        u2 = features[features["user_id"] == "u2"].iloc[0]
        assert u2["total_purchase_value"] == pytest.approx(15.50)

    def test_empty_dataframe_returns_empty(self) -> None:
        empty = pd.DataFrame(columns=["user_id", "event_type", "timestamp", "value"])
        features = compute_user_features(empty)
        assert len(features) == 0
\`\`\`

**FastAPI Serving Endpoint**:
\`\`\`python
import pytest
from httpx import ASGITransport, AsyncClient
from src.serving.app import create_app

@pytest.mark.asyncio
class TestPredictionEndpoint:
    """Tests for /predict endpoint — written BEFORE implementation."""

    @pytest.fixture
    def app(self, mock_model_registry):
        return create_app(model_registry=mock_model_registry)

    @pytest.fixture
    async def client(self, app):
        transport = ASGITransport(app=app)
        async with AsyncClient(transport=transport, base_url="http://test") as c:
            yield c

    async def test_predict_returns_200(self, client: AsyncClient) -> None:
        response = await client.post("/predict", json={"features": [1.0, 2.0, 3.0]})
        assert response.status_code == 200

    async def test_predict_response_schema(self, client: AsyncClient) -> None:
        response = await client.post("/predict", json={"features": [1.0, 2.0, 3.0]})
        body = response.json()
        assert "prediction" in body
        assert "model_version" in body
        assert "latency_ms" in body

    async def test_predict_invalid_input_returns_422(self, client: AsyncClient) -> None:
        response = await client.post("/predict", json={"features": "not_a_list"})
        assert response.status_code == 422

    async def test_health_check(self, client: AsyncClient) -> None:
        response = await client.get("/health")
        assert response.status_code == 200
        assert response.json()["status"] == "healthy"
\`\`\`

**Training Loop / Callbacks**:
\`\`\`python
import pytest
import torch
from unittest.mock import MagicMock
from src.training.callbacks import EarlyStopping

class TestEarlyStopping:
    """Tests for EarlyStopping callback — written BEFORE implementation."""

    def test_no_stop_when_improving(self) -> None:
        es = EarlyStopping(patience=3, min_delta=0.01)
        assert es.should_stop(val_loss=1.0) is False
        assert es.should_stop(val_loss=0.9) is False
        assert es.should_stop(val_loss=0.8) is False

    def test_stops_after_patience_exhausted(self) -> None:
        es = EarlyStopping(patience=2, min_delta=0.01)
        es.should_stop(val_loss=0.5)
        es.should_stop(val_loss=0.5)  # no improvement 1
        es.should_stop(val_loss=0.5)  # no improvement 2
        assert es.should_stop(val_loss=0.5) is True

    def test_resets_counter_on_improvement(self) -> None:
        es = EarlyStopping(patience=2, min_delta=0.01)
        es.should_stop(val_loss=0.5)
        es.should_stop(val_loss=0.5)  # no improvement 1
        es.should_stop(val_loss=0.4)  # improvement — resets
        assert es.should_stop(val_loss=0.4) is False  # counter reset

    def test_best_value_tracked(self) -> None:
        es = EarlyStopping(patience=3, min_delta=0.0)
        es.should_stop(val_loss=1.0)
        es.should_stop(val_loss=0.7)
        es.should_stop(val_loss=0.9)
        assert es.best_value == pytest.approx(0.7)
\`\`\`

### Phase 2: GREEN — Minimal Implementation

After the test is written and confirmed failing (\`uv run pytest tests/unit/models/test_transformer.py -x\` shows RED):

1. Create the source file in the corresponding \`src/\` directory
2. Write the **minimum code** to make the test pass
3. Use type hints on all public functions
4. Use Pydantic for config validation
5. Do NOT optimize, do NOT add features not covered by tests

\`\`\`bash
# Confirm RED
uv run pytest tests/unit/models/test_transformer.py -x --tb=short

# Implement minimally, then confirm GREEN
uv run pytest tests/unit/models/test_transformer.py -x --tb=short
\`\`\`

### Phase 3: REFACTOR — Improve with Confidence

Once GREEN, improve the implementation:

- Extract shared logic into \`src/utils/\`
- Add docstrings (Google style)
- Ensure ruff and mypy pass:
  \`\`\`bash
  uv run ruff check src/models/transformer.py
  uv run ruff format src/models/transformer.py
  uv run mypy src/models/transformer.py
  \`\`\`
- Check coverage:
  \`\`\`bash
  uv run pytest tests/unit/models/test_transformer.py --cov=src.models.transformer --cov-report=term-missing
  \`\`\`
- Ensure coverage ≥ 75% for the module

## Shared Fixtures Strategy

Guide developers to use \`conftest.py\` fixtures for common ML test objects:

\`\`\`python
# tests/conftest.py
import pytest
import torch
from unittest.mock import MagicMock
from configs.schema import ModelConfig, TrainingConfig, DataConfig

@pytest.fixture
def device() -> torch.device:
    return torch.device("cpu")

@pytest.fixture
def small_model_config() -> ModelConfig:
    """Minimal config for fast unit tests."""
    return ModelConfig(
        vocab_size=100,
        embed_dim=32,
        num_heads=4,
        num_layers=1,
        num_classes=5,
        max_seq_len=16,
    )

@pytest.fixture
def synthetic_batch() -> dict[str, torch.Tensor]:
    """Small synthetic batch for testing forward passes."""
    return {
        "input_ids": torch.randint(0, 100, (2, 16)),
        "labels": torch.randint(0, 5, (2,)),
    }

@pytest.fixture
def mock_mlflow_client() -> MagicMock:
    """Mock MLflow client for testing experiment tracking without a server."""
    client = MagicMock()
    client.create_experiment.return_value = "exp-001"
    client.log_metric.return_value = None
    return client

@pytest.fixture
def mock_model_registry() -> MagicMock:
    """Mock model registry for serving tests."""
    registry = MagicMock()
    registry.load_model.return_value = MagicMock(
        predict=MagicMock(return_value=torch.tensor([0.8, 0.2]))
    )
    registry.get_model_version.return_value = "v1.2.3"
    return registry

@pytest.fixture
def tmp_experiment_config(tmp_path) -> str:
    """Write a temporary YAML config for testing config loading."""
    config_path = tmp_path / "experiment.yaml"
    config_path.write_text("""
model:
  vocab_size: 100
  embed_dim: 32
  num_heads: 4
  num_layers: 1
  num_classes: 5
  max_seq_len: 16
training:
  learning_rate: 0.001
  batch_size: 8
  max_epochs: 2
  early_stopping_patience: 3
data:
  dataset_name: synthetic
  train_split: 0.8
  val_split: 0.1
  test_split: 0.1
""")
    return str(config_path)
\`\`\`

## ML-Specific TDD Guidance

### What to Unit Test (always TDD)

| Component | What to Assert |
|---|---|
| \`nn.Module\` forward pass | Output shape, dtype, device, no NaN |
| Pydantic config models | Validation passes/fails, defaults, constraints |
| Feature engineering functions | Correct transformations on known inputs |
| Metric functions | Exact values on hand-computed examples |
| Data loaders / datasets | Length, item shape, dtype, index bounds |
| Callbacks (EarlyStopping, LR scheduling) | State transitions, trigger conditions |
| FastAPI endpoints | Status codes, response schemas, error handling |
| Config loading (YAML → Pydantic) | Parsed values match, missing keys raise |
| Utility functions | Edge cases, type handling, error paths |

### What to Integration Test (test after unit tests pass)

| Component | What to Assert |
|---|---|
| Training loop (1-2 epochs, tiny data) | Loss decreases, checkpoint saved, MLflow logged |
| DVC pipeline stage | Output files created, checksums stable |
| Model serving pipeline | Load model → preprocess → predict → postprocess |
| MLflow tracking round-trip | Log params/metrics → query back → values match |
| Data pipeline end-to-end | Raw → processed → features, schema validated |

### What NOT to TDD (use exploration notebooks instead)

- Hyperparameter search (explore in notebooks, validate configs via TDD)
- Visual inspection of model outputs (use notebooks, log to MLflow)
- GPU-specific performance benchmarks (separate benchmark scripts)
- Third-party API behavior (mock in tests)

## Handling Randomness in ML Tests

Always control randomness in tests:

\`\`\`python
@pytest.fixture(autouse=True)
def seed_everything() -> None:
    """Ensure reproducible tests."""
    import random
    import numpy as np
    import torch
    random.seed(42)
    np.random.seed(42)
    torch.manual_seed(42)
    if torch.cuda.is_available():
        torch.cuda.manual_seed_all(42)
\`\`\`

For tests where exact values matter (metrics), use \`pytest.approx\`:
\`\`\`python
assert accuracy == pytest.approx(0.85, abs=1e-4)
\`\`\`

For tests where only properties matter (shapes, no NaN), don't assert exact values:
\`\`\`python
assert not torch.isnan(output).any()
assert output.shape == (batch_size, num_classes)
\`\`\`

## Interaction Protocol

When a developer asks you to help implement an ML component:

1. **Clarify the contract**: Ask what inputs, outputs, configs, and error cases the component handles
2. **Write the test file first**: Create the complete test file with all test cases
3. **Confirm RED**: Instruct the developer to run \`uv run pytest <test_file> -x --tb=short\` and verify failures
4. **Guide GREEN implementation**: Write minimal implementation in \`src/\`
5. **Confirm GREEN**: Run tests again, all pass
6. **Guide REFACTOR**: Improve code quality, add docstrings, run linters
7. **Verify quality gates**:
   \`\`\`bash
   uv run pytest <test_file> --cov=<module> --cov-report=term-missing
   uv run ruff check <source_file>
   uv run mypy <source_file>
   \`\`\`

## Commands

- **Run specific test**: \`uv run pytest tests/unit/models/test_transformer.py -x --tb=short\`
- **Run with coverage**: \`uv run pytest tests/unit/ --cov=src --cov-report=term-missing --cov-fail-under=75\`
- **Run all unit tests**: \`uv run pytest tests/unit/ -x\`
- **Run integration tests**: \`uv run pytest tests/integration/ -x --timeout=120\`
- **Lint**: \`uv run ruff check src/ tests/\`
- **Format**: \`uv run ruff format src/ tests/\`
- **Type check**: \`uv run mypy src/\`

## Sensitive Paths

When tests touch these paths, flag for review:
- \`configs/production/**\` — production experiment configs, require lead approval
- \`models/**\` — DVC-tracked model artifacts, never commit binaries
- \`.env*\` — secrets, never reference real values in tests
- \`data/**\` — DVC-tracked data, use synthetic fixtures in tests instead

## Compliance Reminders

- **GDPR**: Test data must be synthetic or properly anonymized. Never use real user data in test fixtures. If testing data deletion flows, verify complete removal.
- **SOC 2**: Model artifacts loaded in tests should verify integrity (checksums). Log test coverage metrics for audit trail.

## Cross-References

- **TDD Skill**: \`plugin/codeforge-ml-pipeline/skills/tdd/SKILL.md\`
- **Code Review Agent**: \`plugin/codeforge-ml-pipeline/agents/code-reviewer.md\` — reviewer validates TDD was followed
- **Verify Skill**: \`plugin/codeforge-ml-pipeline/skills/verify/SKILL.md\` — final quality gate checks
- **Contributing Guide**: \`docs/CONTRIBUTING.md\` — project coding standards
- **Architecture**: \`docs/ARCHITECTURE.md\` — system design context`,

  'plugin/codeforge-ml-pipeline/commands/build-fix.md': `# /build-fix — Resolve Build, Lint, Type, and ML Pipeline Failures

## Command Purpose

Diagnose and fix failures in the Python/ML build pipeline: ruff lint errors, mypy type check failures, pytest test failures, DVC pipeline errors, Docker build issues, MLflow tracking errors, and FastAPI serving problems.

## Invocation

\`\`\`
/build-fix [scope]
\`\`\`

**Scopes:**
- \`all\` (default) — Run full diagnostic sequence
- \`lint\` — ruff check and ruff format issues only
- \`types\` — mypy strict mode failures only
- \`tests\` — pytest failures only
- \`dvc\` — DVC pipeline reproduction errors
- \`docker\` — Docker image build failures
- \`serve\` — FastAPI serving / import errors
- \`train\` — Training smoke test failures
- \`deps\` — Dependency resolution issues (uv lock)

## Execution Procedure

### Step 1: Capture Current Failure State

Run the failing command and capture full output:

\`\`\`bash
# Lint
uv run ruff check src/ tests/ scripts/ --output-format=json 2>&1 | head -200

# Format check
uv run ruff format --check src/ tests/ scripts/ 2>&1 | head -100

# Type checking
uv run mypy src/ --strict 2>&1 | head -200

# Tests
uv run pytest tests/ -x --tb=short 2>&1 | head -300

# DVC pipeline
dvc repro --dry 2>&1 | head -100

# Docker build
docker build -t ml-pipeline:test . 2>&1 | tail -50

# FastAPI import check
uv run python -c "from src.serving.app import app; print('OK')" 2>&1

# Training smoke test
uv run python scripts/train_smoke_test.py 2>&1 | tail -100

# Dependency lock
uv lock --check 2>&1
\`\`\`

### Step 2: Classify Errors

Categorize each failure into one of these buckets:

| Category | Indicators | Priority |
|---|---|---|
| **Dependency** | \`ModuleNotFoundError\`, \`uv lock\` conflicts, version incompatibility | P0 — fix first |
| **Import/Structure** | \`ImportError\`, circular imports, missing \`__init__.py\` | P0 |
| **Type Errors** | mypy \`error:\` lines, missing type annotations, incompatible types | P1 |
| **Lint Violations** | ruff rule codes (E, W, F, I, UP, ANN, etc.) | P1 |
| **Test Failures** | \`FAILED\`, \`ERROR\` in pytest output, fixture issues | P1 |
| **DVC Pipeline** | \`dvc.exceptions\`, missing stages, param mismatches | P2 |
| **Docker Build** | \`COPY failed\`, pip install errors in Dockerfile, layer cache issues | P2 |
| **ML Runtime** | CUDA errors, tensor shape mismatches, MLflow connection errors | P2 |
| **Serving** | FastAPI startup errors, Pydantic validation, endpoint failures | P2 |

### Step 3: Apply Fixes by Category

#### 3a. Dependency Fixes

\`\`\`bash
# Regenerate lock file
uv lock

# Sync environment
uv sync --all-extras

# Check for conflicting PyTorch/CUDA versions
uv run python -c "import torch; print(torch.__version__, torch.cuda.is_available())"
\`\`\`

- If \`pyproject.toml\` has unpinned deps, pin them to exact versions
- If PyTorch CUDA mismatch, verify \`--index-url\` in pyproject.toml matches target CUDA version
- Never add dependencies without checking \`pyproject.toml\` for existing alternatives

#### 3b. Lint Fixes (ruff)

\`\`\`bash
# Auto-fix safe violations
uv run ruff check src/ tests/ scripts/ --fix

# Auto-format
uv run ruff format src/ tests/ scripts/
\`\`\`

- For \`ANN\` (annotation) violations: add type hints to all public functions
- For \`I\` (isort) violations: let ruff auto-fix handle import ordering
- For \`F841\` (unused variable): remove or prefix with \`_\`
- For \`UP\` (pyupgrade): accept auto-fixes for Python 3.11+ syntax
- **Do not** suppress rules with \`# noqa\` unless there is a documented reason

#### 3c. Type Check Fixes (mypy)

Common mypy strict mode patterns in ML code:

\`\`\`python
# BAD: Missing return type
def load_model(path):
    return torch.load(path)

# GOOD: Explicit types
def load_model(path: str | Path) -> nn.Module:
    model: nn.Module = torch.load(path, weights_only=True)
    return model

# BAD: Untyped tensor operations
def forward(self, x):
    return self.layer(x)

# GOOD: Typed with Tensor
def forward(self, x: torch.Tensor) -> torch.Tensor:
    return self.layer(x)

# BAD: Config dict
def train(config):
    lr = config["lr"]

# GOOD: Pydantic config
def train(config: TrainingConfig) -> TrainingResult:
    lr = config.learning_rate
\`\`\`

- Add \`py.typed\` marker if missing: \`touch src/py.typed\`
- For third-party stubs: \`uv add --dev types-redis types-PyYAML\`
- For MLflow/DVC without stubs: add to \`mypy.ini\` or \`pyproject.toml\`:
  \`\`\`toml
  [[tool.mypy.overrides]]
  module = ["mlflow.*", "dvc.*"]
  ignore_missing_imports = true
  \`\`\`

#### 3d. Test Fixes (pytest)

\`\`\`bash
# Run with verbose output to identify exact failure
uv run pytest tests/ -x -v --tb=long 2>&1 | head -500

# Run specific failing test
uv run pytest tests/path/to/test_file.py::test_name -v --tb=long
\`\`\`

- **Fixture errors**: Check \`conftest.py\` files in \`tests/\`, \`tests/unit/\`, \`tests/integration/\`
- **Async test failures**: Ensure \`@pytest.mark.asyncio\` decorator and \`pytest-asyncio\` installed
- **GPU-dependent tests**: Mark with \`@pytest.mark.skipif(not torch.cuda.is_available(), reason="No GPU")\`
- **MLflow test isolation**: Use \`mlflow.set_tracking_uri("sqlite:///test_mlflow.db")\` in fixtures
- **Data-dependent tests**: Mock DVC-tracked data, never depend on \`data/\` directory in unit tests
- **Model tests**: Use small model configs (e.g., \`hidden_dim=8, num_layers=1\`) for fast tests

#### 3e. DVC Pipeline Fixes

\`\`\`bash
# Check pipeline DAG
dvc dag

# Validate params
dvc params diff

# Check remote connectivity
dvc remote list
dvc push --dry
\`\`\`

- **Missing stages**: Verify \`dvc.yaml\` stages reference existing scripts in \`scripts/\`
- **Param mismatches**: Ensure \`params.yaml\` keys match what \`dvc.yaml\` stages expect
- **Lock file stale**: Run \`dvc repro\` to regenerate \`dvc.lock\`
- **S3 access**: Verify AWS credentials and bucket permissions for DVC remote

#### 3f. Docker Build Fixes

\`\`\`bash
# Build with no cache to isolate layer issues
docker build --no-cache -t ml-pipeline:test . 2>&1
\`\`\`

- **COPY failures**: Verify \`.dockerignore\` isn't excluding required files
- **pip/uv install failures**: Ensure \`pyproject.toml\` and \`uv.lock\` are copied before install step
- **CUDA base image**: Verify \`FROM\` image matches target CUDA version
- **Multi-stage build**: Ensure model artifacts are copied between stages correctly
- **Layer ordering**: Dependencies before code copy for cache efficiency

#### 3g. ML Runtime Fixes

\`\`\`python
# Tensor shape debugging
print(f"Input shape: {x.shape}, Expected: {expected_shape}")

# Device mismatch
model = model.to(device)
data = data.to(device)

# MLflow connection
import mlflow
mlflow.set_tracking_uri(os.getenv("MLFLOW_TRACKING_URI", "http://localhost:5000"))
\`\`\`

- **CUDA OOM**: Reduce batch size in config, add gradient checkpointing
- **Shape mismatches**: Trace through model with dummy input of expected shape
- **MLflow errors**: Check \`MLFLOW_TRACKING_URI\`, PostgreSQL backend connectivity
- **NaN loss**: Check learning rate, data normalization, gradient clipping config

#### 3h. FastAPI Serving Fixes

\`\`\`bash
# Test import chain
uv run python -c "from src.serving.app import app"

# Test startup
uv run uvicorn src.serving.app:app --host 0.0.0.0 --port 8000 &
curl http://localhost:8000/health
kill %1
\`\`\`

- **Import errors**: Check that model loading doesn't require GPU at import time
- **Pydantic validation**: Ensure request/response schemas match endpoint signatures
- **Model loading**: Use lazy loading pattern — load model on first request or startup event
- **Redis connection**: Verify \`REDIS_URL\` env var for feature store / caching layer

### Step 4: Verify All Fixes

Run the full CI check sequence locally:

\`\`\`bash
# 1. Lint
uv run ruff check src/ tests/ scripts/
uv run ruff format --check src/ tests/ scripts/

# 2. Type check
uv run mypy src/ --strict

# 3. Unit tests with coverage
uv run pytest tests/unit/ -v --cov=src --cov-report=term-missing --cov-fail-under=75

# 4. Integration tests
uv run pytest tests/integration/ -v

# 5. DVC pipeline dry run
dvc repro --dry

# 6. Docker build
docker build -t ml-pipeline:test .

# 7. Import smoke test
uv run python -c "from src.serving.app import app; print('Serving OK')"
uv run python -c "from src.training.trainer import Trainer; print('Training OK')"
\`\`\`

### Step 5: Report Results

Provide a summary in this format:

\`\`\`
## Build Fix Summary

**Initial failures:** <count> errors across <categories>
**Root cause(s):** <brief description>
**Fixes applied:**
- [ ] <file>: <what changed and why>
- [ ] <file>: <what changed and why>

**Verification:**
- ruff check: ✅ PASS
- ruff format: ✅ PASS
- mypy strict: ✅ PASS
- pytest (unit): ✅ PASS (<N> tests, <X>% coverage)
- pytest (integration): ✅ PASS
- dvc repro --dry: ✅ PASS
- docker build: ✅ PASS

**Remaining issues:** <none or list>
**Files modified:** <count>
\`\`\`

## Guardrails

- **Never modify files in \`configs/production/**\`** — these are protected and require lead review
- **Never modify DVC-tracked data in \`data/\`** — use DVC commands to manage data
- **Never hardcode credentials, API keys, or tracking URIs** — use environment variables
- **Never suppress mypy errors with \`# type: ignore\`** without a comment explaining why
- **Never reduce test coverage below 75%** — add tests if fixing code changes coverage
- **Never change model architecture to fix build** — only fix infrastructure/tooling issues
- **Mark all AI-generated fixes** with \`# AI-generated fix\` comment on non-trivial changes
- **Preserve experiment reproducibility** — don't modify \`dvc.lock\` or MLflow run IDs without reason
- **GDPR compliance** — never log or print PII in error messages or debug output
- **SOC 2** — verify model artifact checksums are not altered by fixes

## Delegation

If the failure involves:
- **Architecture changes** → Escalate to \`@architect\` agent
- **Test strategy changes** → Consult \`@tdd-guide\` agent
- **Code quality concerns** → Request \`@code-reviewer\` agent review
- **Pipeline DAG restructuring** → Escalate to \`@planner\` agent

## Related Files

- Skill definition: \`plugin/codeforge-ml-pipeline/skills/build-fix/SKILL.md\`
- Agent: \`plugin/codeforge-ml-pipeline/agents/build-error-resolver.md\`
- CI workflow: \`.github/workflows/ci.yml\`
- Project config: \`pyproject.toml\`
- DVC pipeline: \`dvc.yaml\`
- Type checking config: \`pyproject.toml\` \`[tool.mypy]\` section
- Lint config: \`pyproject.toml\` \`[tool.ruff]\` section`,

  'plugin/codeforge-ml-pipeline/commands/code-review.md': `# /code-review — ML Pipeline Code Review

## Command: \`/code-review\`

Perform a comprehensive code review tailored to Python ML pipeline code, covering correctness, ML best practices, data handling, model integrity, and compliance.

## Usage

\`\`\`
/code-review [target] [--focus <area>] [--severity <level>]
\`\`\`

### Arguments

| Argument | Description | Default |
|----------|-------------|---------|
| \`target\` | File, directory, or git diff range to review | Staged changes (\`git diff --cached\`) |
| \`--focus\` | Review focus area (see below) | \`all\` |
| \`--severity\` | Minimum severity to report: \`info\`, \`warning\`, \`error\` | \`warning\` |

### Focus Areas

| Focus | Description |
|-------|-------------|
| \`all\` | Full review across all categories |
| \`ml\` | ML-specific: training loops, loss functions, data leakage, reproducibility |
| \`data\` | Data pipeline: preprocessing, feature engineering, DVC tracking |
| \`serving\` | Model serving: FastAPI endpoints, inference performance, input validation |
| \`security\` | SOC 2 / GDPR compliance, secrets, data privacy |
| \`performance\` | GPU utilization, memory management, batch processing efficiency |
| \`config\` | Pydantic configs, YAML experiment definitions, MLflow parameters |

## Procedure

### Step 1 — Identify Review Scope

Determine what code to review:

\`\`\`bash
# If target is a file or directory
# Review that path directly

# If target is a git range (e.g., main..HEAD)
# Review the diff

# If no target specified, review staged changes
git diff --cached --name-only
\`\`\`

Filter to relevant file types: \`*.py\`, \`*.yaml\`, \`*.yml\`, \`*.toml\`, \`*.dockerfile\`, \`*.json\`.

Skip files in: \`notebooks/\`, \`data/\`, \`models/\` (DVC-tracked binaries), \`*.lock\`.

### Step 2 — Classify Changed Files

Map each changed file to its review category:

| Path Pattern | Category | Extra Checks |
|---|---|---|
| \`src/data/**\` | Data Pipeline | Data leakage, feature engineering correctness, DVC stage registration |
| \`src/models/**\` | Model Architecture | PyTorch module correctness, parameter initialization, device handling |
| \`src/training/**\` | Training | Loss computation, gradient handling, checkpointing, MLflow logging |
| \`src/evaluation/**\` | Evaluation | Metric correctness, statistical validity, visualization quality |
| \`src/serving/**\` | Serving | FastAPI best practices, input validation, latency, error handling |
| \`src/utils/**\` | Utilities | Reusability, type safety, logging |
| \`configs/**\` | Configuration | Pydantic schema compliance, valid hyperparameter ranges, no secrets |
| \`tests/**\` | Tests | Coverage, fixture quality, deterministic assertions |
| \`scripts/**\` | Scripts | Idempotency, error handling, documentation |

### Step 3 — Run Automated Checks

Execute linting and type checking before manual review:

\`\`\`bash
# Lint check
uv run ruff check --output-format=json <target_files>

# Format check
uv run ruff format --check <target_files>

# Type check
uv run mypy src/ --no-error-summary

# Run tests related to changed files
uv run pytest tests/ -x --tb=short -q
\`\`\`

Report any failures before proceeding to manual review.

### Step 4 — ML-Specific Review Checklist

For each file, evaluate against the applicable checklist items:

#### 4a. Data Pipeline (\`src/data/\`)

- [ ] **No data leakage**: Train/validation/test splits happen before any transformations that learn from data (scaling, encoding)
- [ ] **Feature engineering is deterministic**: Same input produces same output; random seeds are set and logged
- [ ] **DVC tracking**: New data artifacts are added to \`.dvc\` files or \`dvc.yaml\` stages
- [ ] **GDPR compliance**: PII fields are anonymized or pseudonymized; consent flags are respected
- [ ] **Schema validation**: Input data validated with Pydantic or pandera before processing
- [ ] **Null/edge case handling**: Missing values, empty datasets, and malformed records handled gracefully
- [ ] **Type hints**: All public functions have complete type annotations

#### 4b. Model Architecture (\`src/models/\`)

- [ ] **Device agnostic**: No hardcoded \`.cuda()\` — use \`self.device\` or accept device parameter
- [ ] **Parameter initialization**: Weights initialized explicitly, not relying on defaults for custom layers
- [ ] **Forward pass correctness**: Input/output tensor shapes documented and validated
- [ ] **No training logic in model class**: \`nn.Module\` subclasses define architecture only; training loops live in \`src/training/\`
- [ ] **Serialization safe**: Model can be saved/loaded via \`torch.save\`/\`torch.load\` with \`state_dict\`
- [ ] **Memory efficient**: Large tensors freed when no longer needed; \`torch.no_grad()\` used in inference paths

#### 4c. Training (\`src/training/\`)

- [ ] **Reproducibility**: Random seeds set for \`torch\`, \`numpy\`, \`random\`; \`torch.backends.cudnn.deterministic\` configured
- [ ] **MLflow integration**: All hyperparameters logged via \`mlflow.log_params()\`; metrics logged per epoch with \`mlflow.log_metrics()\`
- [ ] **Checkpointing**: Model checkpoints saved at configurable intervals; best model tracked by validation metric
- [ ] **Gradient handling**: Gradient clipping applied if configured; no gradient accumulation bugs
- [ ] **Early stopping**: Implemented with configurable patience and monitored metric
- [ ] **Resource cleanup**: GPU memory freed on exception; \`torch.cuda.empty_cache()\` called in cleanup
- [ ] **Config-driven**: All hyperparameters loaded from Pydantic config, not hardcoded

#### 4d. Evaluation (\`src/evaluation/\`)

- [ ] **Metric correctness**: Metrics computed on correct splits; no accidental evaluation on training data
- [ ] **Statistical rigor**: Confidence intervals or significance tests for model comparisons
- [ ] **MLflow logging**: Evaluation metrics and artifacts (plots, confusion matrices) logged to MLflow
- [ ] **Reproducible**: Evaluation can be re-run from saved model checkpoint and config

#### 4e. Serving (\`src/serving/\`)

- [ ] **Input validation**: Request bodies validated with Pydantic models; reject malformed inputs with 422
- [ ] **Model loading**: Model loaded once at startup, not per-request; version pinned from MLflow registry
- [ ] **Error handling**: Inference errors return structured error responses, not stack traces
- [ ] **Latency**: No unnecessary computation in hot path; batch inference supported for bulk requests
- [ ] **Health checks**: \`/health\` and \`/ready\` endpoints implemented for Kubernetes probes
- [ ] **CORS/Auth**: Authentication middleware present; CORS configured for known origins only
- [ ] **Async correctness**: CPU-bound inference offloaded to thread pool; \`async def\` used only for truly async operations

#### 4f. Configuration (\`configs/\`)

- [ ] **No secrets**: API keys, passwords, connection strings are NOT in config files; use environment variables
- [ ] **Valid ranges**: Hyperparameters within reasonable bounds (learning rate > 0, batch size > 0, etc.)
- [ ] **Pydantic schema**: Every config YAML has a corresponding Pydantic model in \`src/utils/\`
- [ ] **Experiment reproducibility**: Config sufficient to reproduce the full experiment end-to-end

#### 4g. Tests (\`tests/\`)

- [ ] **Deterministic**: Tests set random seeds; no flaky assertions on floating-point values (use \`pytest.approx\`)
- [ ] **Fast**: Unit tests don't load full models or datasets; use fixtures and mocks
- [ ] **Coverage**: New code has corresponding tests; coverage stays above 75%
- [ ] **Integration tests**: Data pipeline and serving endpoints have integration tests with realistic fixtures

### Step 5 — Cross-Cutting Concerns

Review all files for:

| Concern | Check |
|---------|-------|
| **File length** | No file exceeds 300 lines; suggest splitting if over limit |
| **Type hints** | All public functions annotated; \`mypy --strict\` passes |
| **Naming** | \`snake_case\` functions/files, \`PascalCase\` classes, \`SCREAMING_SNAKE_CASE\` constants |
| **Logging** | Use \`structlog\` or \`logging\` — no \`print()\` statements in \`src/\` |
| **Error handling** | Specific exceptions caught; no bare \`except:\` clauses |
| **Docstrings** | Public classes and functions have docstrings with Args/Returns |
| **AI-generated code** | Marked with \`# AI-generated\` comment if applicable per AI-USAGE-POLICY |
| **Dependency changes** | New dependencies in \`pyproject.toml\` reviewed for license, security, necessity |
| **Sensitive paths** | Changes to \`configs/production/**\`, \`models/**\`, \`.env*\`, \`data/**\` flagged for lead review |

### Step 6 — Security & Compliance Review

For changes touching data handling, serving, or configuration:

- [ ] **SOC 2**: Audit logging present for data access and model predictions; no credentials in code
- [ ] **GDPR**: User data processing has legal basis documented; deletion/anonymization paths exist
- [ ] **Model integrity**: Model artifacts are checksummed; serving loads from verified MLflow registry, not arbitrary paths
- [ ] **Input sanitization**: User-provided inputs to inference endpoints are validated and bounded
- [ ] **Dependency security**: No known CVEs in added/updated dependencies (\`uv run pip-audit\`)

### Step 7 — Generate Review Report

Structure the review output as:

\`\`\`markdown
## Code Review Summary

**Scope**: <files reviewed>
**Focus**: <focus area>
**Automated Checks**: ✅ ruff | ✅ mypy | ✅ pytest (or ❌ with details)

### Critical Issues (must fix)
- [ ] \`src/training/trainer.py:45\` — Training data used in validation metric computation (data leakage)

### Warnings (should fix)
- [ ] \`src/models/transformer.py:112\` — Hardcoded \`device='cuda'\`; use config-driven device selection
- [ ] \`configs/experiment_v3.yaml\` — Learning rate 5.0 outside typical range; confirm intentional

### Suggestions (nice to have)
- [ ] \`src/serving/app.py:78\` — Consider adding response caching with Redis for repeated predictions
- [ ] \`src/data/features.py\` — Extract feature transformer into separate class for reuse

### Compliance Notes
- [ ] \`src/data/loader.py\` — Confirm PII columns are excluded before feature engineering

### Files Requiring Lead Review
- \`configs/production/serving.yaml\` — Production config change (sensitive path)
\`\`\`

## Examples

\`\`\`
# Review all staged changes
/code-review

# Review a specific training module
/code-review src/training/trainer.py

# Focus on ML correctness for recent changes
/code-review main..HEAD --focus ml

# Security review of serving code
/code-review src/serving/ --focus security

# Review data pipeline with info-level detail
/code-review src/data/ --focus data --severity info
\`\`\`

## Integration

This command delegates to the **code-reviewer agent** defined in \`plugin/codeforge-ml-pipeline/agents/code-reviewer.md\` and uses the review skill from \`plugin/codeforge-ml-pipeline/skills/code-review/SKILL.md\`.

Review findings for sensitive paths (\`configs/production/**\`, \`models/**\`) are flagged per \`CODEOWNERS\` for lead engineer approval.`,

  'plugin/codeforge-ml-pipeline/commands/phase.md': `# /phase — Development Phase Management for ML Pipeline

## Command Overview

The \`/phase\` command manages structured development phases for the ml-pipeline project. Each phase represents a stage in the ML development lifecycle — from data exploration through model deployment — with quality gates that must pass before advancing.

## Usage

\`\`\`
/phase <subcommand> [options]
\`\`\`

### Subcommands

| Subcommand | Description |
|---|---|
| \`/phase status\` | Show current phase, progress, and remaining gates |
| \`/phase list\` | List all phases with completion status |
| \`/phase start <phase>\` | Begin a specific phase (validates prerequisites) |
| \`/phase gate\` | Run quality gate checks for the current phase |
| \`/phase advance\` | Attempt to advance to the next phase (runs gates first) |
| \`/phase history\` | Show phase transition history for the current branch |

## Phases

The ml-pipeline project follows six development phases aligned with the ML lifecycle:

### Phase 1: Discovery & Data Understanding

**Goal**: Understand the problem, explore data, define success metrics.

**Activities**:
- Review GitHub Issue requirements and acceptance criteria
- Explore data in \`notebooks/\` — never write production code here
- Profile datasets using pandas-profiling or custom EDA scripts
- Document data schema, distributions, missing values, and quality issues
- Define evaluation metrics (precision, recall, F1, AUC, etc.)
- Check GDPR compliance: identify PII columns, verify consent, plan anonymization

**Quality Gates**:
- [ ] GitHub Issue linked and requirements documented
- [ ] Data exploration notebook exists in \`notebooks/\` with findings
- [ ] Data schema documented in experiment config YAML under \`configs/\`
- [ ] Evaluation metrics defined and justified in the issue or PR description
- [ ] PII audit completed — sensitive columns identified and handling plan documented
- [ ] No production code written in \`notebooks/\`

**Gate Command**:
\`\`\`bash
# Validates notebooks exist, configs have schema definitions, PII audit present
uv run python scripts/check_phase_gate.py --phase discovery
\`\`\`

---

### Phase 2: Data Pipeline & Feature Engineering

**Goal**: Build reproducible data pipelines with DVC, implement feature engineering.

**Activities**:
- Implement data loading in \`src/data/\` with Pydantic-validated configs
- Build preprocessing and feature engineering transforms
- Define DVC pipeline stages in \`dvc.yaml\` for data flow
- Track raw and processed data with DVC remote on S3
- Write unit tests for all transforms in \`tests/test_data/\`
- Validate data quality with assertions (schema, ranges, nulls)

**Quality Gates**:
- [ ] \`dvc.yaml\` defines data pipeline stages (download → preprocess → featurize)
- [ ] \`dvc repro\` runs end-to-end without errors
- [ ] All data loading and transform functions have type hints
- [ ] Pydantic config models exist for data pipeline parameters in \`configs/\`
- [ ] Unit tests pass: \`uv run pytest tests/test_data/ -v\`
- [ ] Type check passes: \`uv run mypy src/data/\`
- [ ] Lint passes: \`uv run ruff check src/data/\`
- [ ] No files in \`src/data/\` exceed 300 lines
- [ ] GDPR: PII anonymization or pseudonymization applied before feature engineering

**Gate Command**:
\`\`\`bash
uv run ruff check src/data/
uv run mypy src/data/
uv run pytest tests/test_data/ -v --tb=short
dvc repro --dry  # Validate pipeline DAG without executing
\`\`\`

---

### Phase 3: Model Development & Training

**Goal**: Implement model architectures, training loops, and experiment tracking.

**Activities**:
- Define PyTorch \`nn.Module\` classes in \`src/models/\`
- Implement training loops with callbacks in \`src/training/\`
- Configure MLflow experiment tracking (params, metrics, artifacts)
- Set up hyperparameter tuning (Optuna or grid search)
- Add model checkpointing and early stopping
- Write experiment config YAMLs validated by Pydantic
- Add DVC pipeline stages for training

**Quality Gates**:
- [ ] Model classes inherit from \`nn.Module\` with typed \`forward()\` signatures
- [ ] Training config validated by Pydantic model in \`src/training/config.py\`
- [ ] MLflow experiment logs params, metrics per epoch, and model artifacts
- [ ] \`dvc.yaml\` includes training stage with dependencies on data pipeline
- [ ] Model checkpoint saving and loading works (test with smoke test)
- [ ] Unit tests pass: \`uv run pytest tests/test_models/ tests/test_training/ -v\`
- [ ] Type check passes: \`uv run mypy src/models/ src/training/\`
- [ ] Lint passes: \`uv run ruff check src/models/ src/training/\`
- [ ] Coverage ≥ 75%: \`uv run pytest tests/test_models/ tests/test_training/ --cov=src/models --cov=src/training --cov-fail-under=75\`
- [ ] Training smoke test completes: \`uv run python scripts/train_smoke_test.py\`

**Gate Command**:
\`\`\`bash
uv run ruff check src/models/ src/training/
uv run mypy src/models/ src/training/
uv run pytest tests/test_models/ tests/test_training/ -v --cov=src/models --cov=src/training --cov-fail-under=75
uv run python scripts/train_smoke_test.py
\`\`\`

---

### Phase 4: Evaluation & Validation

**Goal**: Evaluate model performance, compare experiments, validate for production readiness.

**Activities**:
- Implement evaluation metrics in \`src/evaluation/\`
- Compare experiment runs in MLflow UI (\`mlflow ui\`)
- Generate evaluation reports (confusion matrix, ROC curves, calibration)
- Run model on holdout/test set — never tune on test data
- Validate model fairness and bias if applicable
- Register best model in MLflow Model Registry
- Document experiment results and model selection rationale

**Quality Gates**:
- [ ] Evaluation functions exist in \`src/evaluation/\` with type hints
- [ ] MLflow comparison shows multiple experiment runs with logged metrics
- [ ] Best model registered in MLflow Model Registry with stage "Staging"
- [ ] Holdout/test set evaluation logged as separate MLflow run
- [ ] Evaluation report generated (metrics, plots) and saved as MLflow artifact
- [ ] Unit tests pass: \`uv run pytest tests/test_evaluation/ -v\`
- [ ] Type check passes: \`uv run mypy src/evaluation/\`
- [ ] No data leakage: test set not used during training or tuning
- [ ] Model artifact tracked by DVC or MLflow (not committed to git)

**Gate Command**:
\`\`\`bash
uv run ruff check src/evaluation/
uv run mypy src/evaluation/
uv run pytest tests/test_evaluation/ -v
# Verify model is registered in MLflow
uv run python -c "import mlflow; client = mlflow.tracking.MlflowClient(); print(client.search_registered_models())"
\`\`\`

---

### Phase 5: Serving & Integration

**Goal**: Build the inference API, integrate with the model registry, prepare for deployment.

**Activities**:
- Implement FastAPI serving app in \`src/serving/\`
- Load model from MLflow Model Registry at startup
- Add health check, prediction, and batch inference endpoints
- Implement request/response validation with Pydantic
- Add Redis caching for feature lookups and prediction caching
- Write integration tests against the API
- Build Docker image and test locally
- Set up A/B testing infrastructure if needed

**Quality Gates**:
- [ ] FastAPI app in \`src/serving/\` with \`/health\`, \`/predict\`, \`/batch\` endpoints
- [ ] Request and response models defined with Pydantic
- [ ] Model loaded from MLflow registry (not hardcoded path)
- [ ] Integration tests pass: \`uv run pytest tests/test_serving/ -v\`
- [ ] Docker build succeeds: \`docker build -t ml-pipeline:test .\`
- [ ] Docker container starts and \`/health\` returns 200
- [ ] Type check passes: \`uv run mypy src/serving/\`
- [ ] Lint passes: \`uv run ruff check src/serving/\`
- [ ] Coverage ≥ 75% for serving module
- [ ] SOC 2: Input validation prevents injection, model artifacts verified on load
- [ ] GDPR: Prediction logs do not store raw PII without consent

**Gate Command**:
\`\`\`bash
uv run ruff check src/serving/
uv run mypy src/serving/
uv run pytest tests/test_serving/ -v --cov=src/serving --cov-fail-under=75
docker build -t ml-pipeline:test .
docker run --rm -d -p 8000:8000 --name ml-test ml-pipeline:test && \\
  sleep 5 && curl -f http://localhost:8000/health && \\
  docker stop ml-test
\`\`\`

---

### Phase 6: Deployment & Monitoring

**Goal**: Deploy to staging/production, set up monitoring, validate in production.

**Activities**:
- Deploy to staging via GitHub Actions (\`deploy-staging.yml\`)
- Run smoke tests against staging endpoint
- Promote MLflow model stage from "Staging" to "Production"
- Deploy to production via GitHub Actions (\`deploy-production.yml\`)
- Configure Prometheus metrics and Grafana dashboards
- Set up model performance monitoring (data drift, prediction drift)
- Document runbook in \`docs/\`

**Quality Gates**:
- [ ] CI pipeline passes all stages (lint, type check, tests, build, smoke test)
- [ ] Staging deployment succeeds and smoke tests pass
- [ ] MLflow model stage set to "Production"
- [ ] Production deployment succeeds via \`deploy-production.yml\`
- [ ] Prometheus metrics endpoint exposed (\`/metrics\`)
- [ ] Grafana dashboard configured for latency, throughput, error rate
- [ ] Model monitoring alerts configured for data drift
- [ ] Runbook documented in \`docs/runbooks/\`
- [ ] CODEOWNERS review completed for \`configs/production/**\` and \`models/**\`
- [ ] SOC 2: Deployment audit trail in GitHub Actions logs

**Gate Command**:
\`\`\`bash
# Full CI validation
uv run ruff check src/
uv run mypy src/
uv run pytest tests/ -v --cov=src --cov-fail-under=75
# Verify staging health
curl -f https://staging.ml-pipeline.example.com/health
# Verify production model registered
uv run python -c "
import mlflow
client = mlflow.tracking.MlflowClient()
versions = client.get_latest_versions('ml-pipeline-model', stages=['Production'])
assert len(versions) > 0, 'No production model registered'
print(f'Production model: {versions[0].version}')
"
\`\`\`

## Phase Transition Rules

1. **Sequential by default**: Phases must be completed in order (1 → 2 → 3 → 4 → 5 → 6)
2. **Gates are mandatory**: All quality gate checks must pass before advancing
3. **Rollback allowed**: You can return to a previous phase with \`/phase start <phase>\`
4. **Parallel work**: Data pipeline (Phase 2) and model architecture (Phase 3) can overlap for senior engineers if explicitly approved
5. **Experiment branches**: Use \`experiment:\` commit prefix for exploratory work in Phases 1-3

## Integration with Other Commands

| Command | Phase Integration |
|---|---|
| \`/plan\` | Generates implementation plan scoped to the current phase |
| \`/tdd\` | Enforces test-first development — required in Phases 2-5 |
| \`/code-review\` | Reviews code against current phase quality standards |
| \`/build-fix\` | Resolves build failures blocking phase gate passage |
| \`/verify\` | Runs the full verification suite — equivalent to \`/phase gate\` for current phase |

## Example Workflow

\`\`\`
> /phase status
Current phase: Phase 3 — Model Development & Training
Branch: feat/ML-42-add-transformer-model
Progress: 6/10 gates passing
Failing gates:
  - Coverage at 68% (need 75%)
  - Training smoke test not yet passing
  - MLflow experiment not logging model artifacts

> /phase gate
Running Phase 3 quality gates...
✓ Model classes inherit from nn.Module with typed forward()
✓ Training config validated by Pydantic
✗ MLflow experiment not logging model artifacts
✓ dvc.yaml includes training stage
✗ Training smoke test fails (RuntimeError in forward pass)
✓ Unit tests pass (tests/test_models/)
✗ Unit tests fail (tests/test_training/ — 2 failures)
✓ mypy passes
✓ ruff passes
✗ Coverage: 68% < 75%

4 gates failing. Fix issues before advancing.

> /phase advance
Cannot advance: 4 quality gates failing.
Run \`/phase gate\` for details, or \`/build-fix\` to resolve failures.
\`\`\`

## Skill Reference

This command delegates to the [phase skill](../skills/phase/SKILL.md) for execution logic and to the [planner agent](../agents/planner.md) for phase-aware planning.

## Configuration

Phase settings are stored in the project's experiment configs:

\`\`\`yaml
# configs/pipeline/phases.yaml
phases:
  discovery:
    required_artifacts:
      - "notebooks/*.ipynb"
      - "configs/*.yaml"
  data_pipeline:
    coverage_threshold: 75
    max_file_length: 300
  model_development:
    coverage_threshold: 75
    smoke_test_script: "scripts/train_smoke_test.py"
    mlflow_experiment_name: "ml-pipeline"
  evaluation:
    min_experiment_runs: 3
    require_model_registry: true
  serving:
    coverage_threshold: 75
    docker_image: "ml-pipeline"
    health_endpoint: "/health"
  deployment:
    staging_url: "https://staging.ml-pipeline.example.com"
    production_model_stage: "Production"
\`\`\``,

  'plugin/codeforge-ml-pipeline/commands/plan.md': `# /plan — Implementation Planning Command

## Purpose

Generate a detailed, actionable implementation plan for a feature, experiment, or pipeline change in the ml-pipeline project. Plans are structured around the DAG-based pipeline architecture and account for data dependencies, model impacts, and experiment tracking requirements.

## Usage

\`\`\`
/plan <description or GitHub Issue reference>
\`\`\`

### Examples

\`\`\`
/plan Add transformer-based model architecture for sequence classification
/plan ML-42 (resolves from GitHub Issues)
/plan Implement feature store caching layer with Redis
/plan Add A/B testing endpoint for model comparison
/plan Refactor data preprocessing pipeline to support streaming
\`\`\`

## Behavior

When invoked, Claude will:

1. **Parse the request** — Identify whether this is a model change, data pipeline change, serving change, infrastructure change, or experiment.
2. **Check context** — Read relevant files in \`src/\`, \`configs/\`, \`dvc.yaml\`, \`tests/\`, and \`docs/ARCHITECTURE.md\` to understand current state.
3. **Identify the impact surface** — Determine which pipeline stages are affected (data → features → training → evaluation → serving).
4. **Generate a structured plan** — Output a phased implementation plan with ML-specific considerations.
5. **Create a checklist** — Produce a trackable checklist suitable for PR description or issue comment.

## Plan Structure

The output plan follows this format:

### 1. Summary

- One-paragraph description of what will be built
- Link to GitHub Issue if applicable
- Classification: \`model\` | \`data-pipeline\` | \`feature-engineering\` | \`serving\` | \`infrastructure\` | \`experiment\` | \`evaluation\`

### 2. Pipeline Impact Analysis

- Which DVC pipeline stages are affected (\`dvc.yaml\`)
- Data dependencies that change (inputs, outputs, params)
- Whether model retraining is required
- Whether serving endpoints need updates
- Impact on existing experiments in MLflow

### 3. Implementation Phases

Each phase includes:

- **Phase name** (e.g., "Data Layer", "Model Architecture", "Training Integration")
- **Files to create or modify** with full paths under \`src/\`
- **Key functions/classes** to implement with type signatures
- **Config changes** needed in \`configs/\` YAML files
- **Pydantic models** to add or update for config validation
- **Tests** to write (unit and integration) under \`tests/\`
- **Estimated complexity**: low | medium | high

### 4. Experiment Configuration

- MLflow experiment name and tags
- Hyperparameters to track
- Metrics to log
- Artifacts to store
- Suggested YAML config file in \`configs/\`

### 5. Data & Model Artifacts

- DVC-tracked files that change
- New data pipeline stages to add to \`dvc.yaml\`
- S3 paths for remote storage
- Data privacy considerations (GDPR: anonymization, PII handling)

### 6. Testing Strategy

- Unit tests for new functions (target: 75% coverage)
- Integration tests for pipeline stages
- Smoke test for training (small data subset)
- Serving endpoint tests (FastAPI TestClient)
- Commands to validate: \`uv run pytest tests/ -v --cov=src\`

### 7. Checklist

Markdown checklist for tracking progress:

\`\`\`markdown
- [ ] Create/update Pydantic config models
- [ ] Implement data layer changes
- [ ] Implement model/feature changes
- [ ] Add experiment config YAML
- [ ] Write unit tests
- [ ] Write integration tests
- [ ] Update DVC pipeline (\`dvc.yaml\`)
- [ ] Run \`uv run ruff check src/\` — no lint errors
- [ ] Run \`uv run mypy src/\` — no type errors
- [ ] Run \`uv run pytest --cov=src\` — coverage ≥ 75%
- [ ] Run \`dvc repro\` — pipeline executes end-to-end
- [ ] Log experiment to MLflow
- [ ] Update docs if needed
- [ ] PR created with conventional commit prefix
\`\`\`

## Classification-Specific Guidance

### Model Changes (\`model\`)

- New model class inherits from \`torch.nn.Module\` in \`src/models/\`
- Forward method must have type hints
- Add model config to Pydantic schema in \`src/models/config.py\`
- Register model in MLflow model registry after validation
- Ensure checkpoint saving/loading works (\`torch.save\` / \`torch.load\`)
- Consider GPU memory requirements and batch size implications

### Data Pipeline Changes (\`data-pipeline\`)

- Modifications go in \`src/data/\`
- Update \`dvc.yaml\` stages and \`params.yaml\`
- Validate data schemas with Pydantic
- Check GDPR compliance: no PII in features without anonymization
- Run \`dvc repro\` to verify pipeline DAG integrity
- Consider data versioning — tag datasets in DVC

### Feature Engineering (\`feature-engineering\`)

- New features in \`src/data/features.py\` or dedicated module
- Cache computed features in Redis if reused across experiments
- Document feature definitions in \`docs/\`
- Add feature validation tests
- Track feature importance in MLflow

### Serving Changes (\`serving\`)

- FastAPI endpoints in \`src/serving/\`
- Request/response models as Pydantic schemas
- Add health check and readiness probes
- Test with \`pytest-asyncio\` and FastAPI \`TestClient\`
- Consider model loading latency and caching strategy
- A/B testing: route traffic based on experiment config

### Infrastructure (\`infrastructure\`)

- Terraform changes in \`infrastructure/\`
- Docker image updates in \`Dockerfile\`
- Kubernetes manifests or ECS task definitions
- Flag sensitive paths: \`configs/production/**\`, \`.env*\`
- SOC 2: ensure audit logging and access controls

### Experiment (\`experiment\`)

- Exploration starts in \`notebooks/\` — not production code
- Define hypothesis and success metrics upfront
- Create experiment config YAML in \`configs/experiments/\`
- Set MLflow experiment name and run tags
- Compare against baseline metrics
- Document findings in \`docs/experiments/\`

## Integration with Other Commands

- After \`/plan\`, use \`/tdd\` to implement each phase test-first
- Use \`/verify\` after implementation to validate the plan was fully executed
- Use \`/code-review\` before PR submission to catch issues
- Use \`/build-fix\` if CI pipeline fails during implementation

## Agent Delegation

This command activates the **planner agent** defined in \`plugin/codeforge-ml-pipeline/agents/planner.md\`. For architectural decisions (new pipeline stages, infrastructure changes), the planner may consult the **architect agent** at \`plugin/codeforge-ml-pipeline/agents/architect.md\`.

## Conventions

- Branch naming: \`feat/ML-<issue>-<description>\` or \`experiment/ML-<issue>-<description>\`
- Commit prefix: \`feat:\`, \`fix:\`, \`experiment:\`, \`chore:\`, \`docs:\`
- All public functions require type hints (enforced by \`mypy --strict\`)
- Max file length: 300 lines — split into modules if plan exceeds this
- Pin any new dependencies in \`pyproject.toml\` with exact versions
- Mark AI-generated code with \`# AI-generated\` comment where applicable`,

  'plugin/codeforge-ml-pipeline/commands/tdd.md': `# /tdd — Test-Driven Development for ML Pipeline

## Command Syntax

\`\`\`
/tdd <component> [--type <unit|integration|e2e|model>] [--stage <red|green|refactor>]
\`\`\`

## Description

Implements Test-Driven Development for ml-pipeline components. This command drives the Red-Green-Refactor cycle adapted for ML code: model architectures, data pipelines, training loops, serving endpoints, and evaluation metrics.

## Workflow

### Stage 1: RED — Write Failing Tests First

1. **Analyze the component** to understand inputs, outputs, and contracts
2. **Identify test categories** based on component type:
   - \`src/data/\` → Data loading, preprocessing, feature shape/type assertions
   - \`src/models/\` → Forward pass shapes, gradient flow, parameter counts
   - \`src/training/\` → Loss convergence on toy data, checkpoint save/load
   - \`src/evaluation/\` → Metric correctness on known inputs, comparison logic
   - \`src/serving/\` → API contract, request/response schemas, latency bounds
3. **Write tests** following pytest conventions in \`tests/\` mirroring \`src/\` structure
4. **Run tests** to confirm they fail: \`uv run pytest tests/<path> -x --tb=short\`
5. **Commit** with message: \`test: add failing tests for <component> [red]\`

### Stage 2: GREEN — Minimal Implementation to Pass

1. **Implement the minimum code** to make all tests pass
2. **Use type hints** on all public functions (enforced by mypy strict)
3. **Use Pydantic models** for any config or data validation
4. **Run tests**: \`uv run pytest tests/<path> -x --tb=short\`
5. **Run type checker**: \`uv run mypy src/<path> --strict\`
6. **Run linter**: \`uv run ruff check src/<path> tests/<path>\`
7. **Commit** with message: \`feat: implement <component> [green]\`

### Stage 3: REFACTOR — Improve Without Changing Behavior

1. **Refactor** for clarity, performance, and adherence to project conventions
2. **Ensure files stay under 300 lines** — split if needed
3. **Extract shared logic** to \`src/utils/\`
4. **Add docstrings** with Args, Returns, Raises, and Example sections
5. **Re-run full validation**:
   \`\`\`
   uv run pytest tests/<path> -x --tb=short
   uv run mypy src/<path> --strict
   uv run ruff check --fix src/<path> tests/<path>
   uv run ruff format src/<path> tests/<path>
   \`\`\`
6. **Commit** with message: \`refactor: clean up <component> [refactor]\`

## Component-Specific Test Patterns

### Data Pipeline (\`src/data/\`)

\`\`\`python
# tests/data/test_feature_engineering.py
import pytest
import torch
from src.data.feature_engineering import build_features, FeatureConfig

class TestBuildFeatures:
    """Tests for feature engineering pipeline."""

    def test_output_shape_matches_config(self, sample_raw_data: dict) -> None:
        config = FeatureConfig(numerical_cols=["age", "income"], categorical_cols=["region"])
        features = build_features(sample_raw_data, config)
        assert features.shape[1] == config.expected_feature_dim

    def test_handles_missing_values(self, data_with_nulls: dict) -> None:
        config = FeatureConfig(numerical_cols=["age"], impute_strategy="median")
        features = build_features(data_with_nulls, config)
        assert not torch.isnan(features).any()

    def test_categorical_encoding_is_deterministic(self, sample_raw_data: dict) -> None:
        config = FeatureConfig(categorical_cols=["region"])
        result_a = build_features(sample_raw_data, config)
        result_b = build_features(sample_raw_data, config)
        assert torch.equal(result_a, result_b)

    def test_rejects_unknown_columns(self, sample_raw_data: dict) -> None:
        config = FeatureConfig(numerical_cols=["nonexistent"])
        with pytest.raises(KeyError, match="nonexistent"):
            build_features(sample_raw_data, config)

    def test_gdpr_pii_columns_excluded(self, data_with_pii: dict) -> None:
        """Verify PII columns are stripped before feature engineering."""
        config = FeatureConfig(numerical_cols=["age"], strip_pii=True)
        features = build_features(data_with_pii, config)
        assert "email" not in features.column_names
\`\`\`

### Model Architecture (\`src/models/\`)

\`\`\`python
# tests/models/test_classifier.py
import pytest
import torch
from src.models.classifier import ClassifierModel, ModelConfig

class TestClassifierModel:
    """Tests for classifier model architecture."""

    @pytest.fixture
    def model(self) -> ClassifierModel:
        config = ModelConfig(input_dim=128, hidden_dim=64, num_classes=10, dropout=0.1)
        return ClassifierModel(config)

    def test_forward_output_shape(self, model: ClassifierModel) -> None:
        batch = torch.randn(32, 128)
        output = model(batch)
        assert output.shape == (32, 10)

    def test_output_is_logits_not_probabilities(self, model: ClassifierModel) -> None:
        batch = torch.randn(8, 128)
        output = model(batch)
        # Logits can be negative; probabilities cannot
        assert (output < 0).any()

    def test_gradients_flow_to_all_parameters(self, model: ClassifierModel) -> None:
        batch = torch.randn(4, 128)
        target = torch.randint(0, 10, (4,))
        loss = torch.nn.functional.cross_entropy(model(batch), target)
        loss.backward()
        for name, param in model.named_parameters():
            assert param.grad is not None, f"No gradient for {name}"
            assert param.grad.abs().sum() > 0, f"Zero gradient for {name}"

    def test_parameter_count(self, model: ClassifierModel) -> None:
        total = sum(p.numel() for p in model.parameters())
        assert 5_000 < total < 50_000, f"Unexpected param count: {total}"

    def test_eval_mode_disables_dropout(self, model: ClassifierModel) -> None:
        model.eval()
        batch = torch.randn(8, 128)
        out_a = model(batch)
        out_b = model(batch)
        assert torch.equal(out_a, out_b)

    def test_model_is_serializable(self, model: ClassifierModel, tmp_path) -> None:
        path = tmp_path / "model.pt"
        torch.save(model.state_dict(), path)
        loaded = ClassifierModel(model.config)
        loaded.load_state_dict(torch.load(path, weights_only=True))
        batch = torch.randn(4, 128)
        assert torch.equal(model.eval()(batch), loaded.eval()(batch))
\`\`\`

### Training Loop (\`src/training/\`)

\`\`\`python
# tests/training/test_trainer.py
import pytest
import torch
from unittest.mock import MagicMock, patch
from src.training.trainer import Trainer, TrainingConfig
from src.models.classifier import ClassifierModel, ModelConfig

class TestTrainer:
    """Tests for training loop."""

    @pytest.fixture
    def toy_dataset(self) -> tuple[torch.Tensor, torch.Tensor]:
        torch.manual_seed(42)
        X = torch.randn(100, 16)
        y = (X[:, 0] > 0).long()
        return X, y

    @pytest.fixture
    def trainer(self, toy_dataset) -> Trainer:
        model_config = ModelConfig(input_dim=16, hidden_dim=8, num_classes=2)
        train_config = TrainingConfig(epochs=5, lr=1e-2, batch_size=32)
        return Trainer(model_config=model_config, train_config=train_config)

    def test_loss_decreases_on_toy_data(self, trainer: Trainer, toy_dataset) -> None:
        X, y = toy_dataset
        history = trainer.fit(X, y)
        assert history.losses[-1] < history.losses[0]

    def test_checkpoint_saved_each_epoch(self, trainer: Trainer, toy_dataset, tmp_path) -> None:
        trainer.train_config.checkpoint_dir = str(tmp_path)
        X, y = toy_dataset
        trainer.fit(X, y)
        checkpoints = list(tmp_path.glob("*.pt"))
        assert len(checkpoints) == trainer.train_config.epochs

    @patch("src.training.trainer.mlflow")
    def test_metrics_logged_to_mlflow(self, mock_mlflow: MagicMock, trainer, toy_dataset) -> None:
        X, y = toy_dataset
        trainer.fit(X, y)
        mock_mlflow.log_metric.assert_called()
        logged_keys = {call.args[0] for call in mock_mlflow.log_metric.call_args_list}
        assert "train_loss" in logged_keys

    def test_reproducible_with_same_seed(self, toy_dataset) -> None:
        model_config = ModelConfig(input_dim=16, hidden_dim=8, num_classes=2)
        train_config = TrainingConfig(epochs=3, lr=1e-2, seed=42)
        t1 = Trainer(model_config=model_config, train_config=train_config)
        t2 = Trainer(model_config=model_config, train_config=train_config)
        X, y = toy_dataset
        h1 = t1.fit(X, y)
        h2 = t2.fit(X, y)
        assert h1.losses == pytest.approx(h2.losses, abs=1e-6)
\`\`\`

### Serving Endpoint (\`src/serving/\`)

\`\`\`python
# tests/serving/test_api.py
import pytest
from httpx import AsyncClient, ASGITransport
from src.serving.app import create_app

@pytest.fixture
def app():
    return create_app(config_path="configs/test/serving.yaml")

@pytest.mark.asyncio
async def test_health_endpoint(app) -> None:
    transport = ASGITransport(app=app)
    async with AsyncClient(transport=transport, base_url="http://test") as client:
        response = await client.get("/health")
    assert response.status_code == 200
    assert response.json()["status"] == "healthy"

@pytest.mark.asyncio
async def test_predict_returns_valid_schema(app) -> None:
    transport = ASGITransport(app=app)
    async with AsyncClient(transport=transport, base_url="http://test") as client:
        response = await client.post("/predict", json={"features": [1.0] * 128})
    assert response.status_code == 200
    body = response.json()
    assert "prediction" in body
    assert "confidence" in body
    assert 0.0 <= body["confidence"] <= 1.0

@pytest.mark.asyncio
async def test_predict_rejects_wrong_dimension(app) -> None:
    transport = ASGITransport(app=app)
    async with AsyncClient(transport=transport, base_url="http://test") as client:
        response = await client.post("/predict", json={"features": [1.0, 2.0]})
    assert response.status_code == 422

@pytest.mark.asyncio
async def test_batch_predict_endpoint(app) -> None:
    transport = ASGITransport(app=app)
    async with AsyncClient(transport=transport, base_url="http://test") as client:
        payload = {"instances": [[1.0] * 128 for _ in range(5)]}
        response = await client.post("/predict/batch", json=payload)
    assert response.status_code == 200
    assert len(response.json()["predictions"]) == 5
\`\`\`

### Evaluation (\`src/evaluation/\`)

\`\`\`python
# tests/evaluation/test_metrics.py
import pytest
import torch
from src.evaluation.metrics import compute_metrics, MetricResult

class TestComputeMetrics:
    """Tests for evaluation metric computation."""

    def test_perfect_predictions(self) -> None:
        preds = torch.tensor([0, 1, 2, 0, 1])
        labels = torch.tensor([0, 1, 2, 0, 1])
        result = compute_metrics(preds, labels, num_classes=3)
        assert result.accuracy == pytest.approx(1.0)
        assert result.f1_macro == pytest.approx(1.0)

    def test_random_predictions_below_threshold(self) -> None:
        torch.manual_seed(0)
        preds = torch.randint(0, 3, (1000,))
        labels = torch.randint(0, 3, (1000,))
        result = compute_metrics(preds, labels, num_classes=3)
        assert result.accuracy < 0.5

    def test_metric_result_is_serializable(self) -> None:
        result = MetricResult(accuracy=0.95, f1_macro=0.93, precision=0.94, recall=0.92)
        d = result.model_dump()
        assert isinstance(d, dict)
        assert d["accuracy"] == 0.95
\`\`\`

## Fixtures and Conftest

Create shared fixtures in \`tests/conftest.py\`:

\`\`\`python
# tests/conftest.py
import pytest
import torch

@pytest.fixture(autouse=True)
def set_seed() -> None:
    """Ensure reproducibility across all tests."""
    torch.manual_seed(42)
    if torch.cuda.is_available():
        torch.cuda.manual_seed_all(42)

@pytest.fixture
def sample_raw_data() -> dict:
    return {
        "age": [25, 30, 35, 40],
        "income": [50000, 60000, 70000, 80000],
        "region": ["east", "west", "east", "north"],
    }

@pytest.fixture
def device() -> torch.device:
    return torch.device("cuda" if torch.cuda.is_available() else "cpu")
\`\`\`

## Running the TDD Cycle

### Red Phase
\`\`\`bash
uv run pytest tests/<path> -x --tb=short -q
# Expect: FAILED — all new tests should fail
\`\`\`

### Green Phase
\`\`\`bash
uv run pytest tests/<path> -x --tb=short -q
uv run mypy src/<path> --strict
uv run ruff check src/<path>
# Expect: PASSED — minimal implementation passes
\`\`\`

### Refactor Phase
\`\`\`bash
uv run pytest tests/ --tb=short -q --cov=src --cov-report=term-missing
uv run mypy src/ --strict
uv run ruff check --fix src/ tests/
uv run ruff format src/ tests/
# Expect: PASSED — coverage ≥ 75%, no lint/type errors
\`\`\`

## ML-Specific TDD Guidelines

1. **Test tensor shapes explicitly** — shape mismatches are the #1 PyTorch bug
2. **Test on CPU even if training on GPU** — tests must run in CI without GPUs
3. **Use toy datasets** (< 100 samples) for training loop tests — fast feedback
4. **Mock MLflow calls** in unit tests — integration tests hit real MLflow
5. **Test config validation** with Pydantic — invalid configs should raise \`ValidationError\`
6. **Test model serialization roundtrips** — save, load, compare outputs
7. **Test determinism** — same seed must produce same results
8. **Never test on real data in unit tests** — use fixtures or synthetic data
9. **Mark slow tests** with \`@pytest.mark.slow\` and skip in fast CI runs
10. **Test GDPR compliance** — verify PII stripping in data pipelines

## Integration with DVC and MLflow

For integration tests that validate the full pipeline:

\`\`\`bash
# Run DVC pipeline smoke test
dvc repro --dry  # Verify DAG is valid
uv run pytest tests/integration/ -m "not slow" --tb=short

# Validate MLflow experiment logging
uv run pytest tests/integration/test_mlflow_tracking.py -x
\`\`\`

## Delegation

This command delegates to the **tdd-guide** agent defined in \`plugin/codeforge-ml-pipeline/agents/tdd-guide.md\` and uses the TDD skill from \`plugin/codeforge-ml-pipeline/skills/tdd/SKILL.md\`.

## Related Commands

- \`/plan\` — Plan implementation before starting TDD
- \`/verify\` — Run full validation suite after TDD cycle
- \`/build-fix\` — Resolve test failures or type errors`,

  'plugin/codeforge-ml-pipeline/commands/verify.md': `# /verify — ML Pipeline Verification Command

## Purpose

Run the full verification suite for the ml-pipeline project, covering code quality, type safety, tests, ML pipeline integrity, model artifact validation, and security checks.

## Usage

\`\`\`
/verify              # Run all verification stages
/verify quick        # Lint + type check + unit tests only
/verify ml           # ML-specific checks (DVC, MLflow, model validation)
/verify security     # Security and compliance checks only
/verify pre-merge    # Full pre-merge verification (all stages, strict)
\`\`\`

## Verification Stages

### Stage 1: Code Quality (Lint + Format)

Run ruff linter and formatter checks across the entire codebase:

\`\`\`bash
uv run ruff check src/ tests/ scripts/
uv run ruff format --check src/ tests/ scripts/
\`\`\`

**Pass criteria**: Zero lint errors, zero format violations.

**On failure**:
1. Run \`uv run ruff check --fix src/ tests/ scripts/\` for auto-fixable issues
2. Run \`uv run ruff format src/ tests/ scripts/\` for formatting
3. Report remaining issues that require manual intervention
4. Do NOT auto-commit fixes — present diff for review

### Stage 2: Type Checking

Run mypy in strict mode against source code:

\`\`\`bash
uv run mypy src/ --strict --ignore-missing-imports
\`\`\`

**Pass criteria**: Zero type errors.

**On failure**:
1. Categorize errors: missing annotations, incompatible types, missing imports, Pydantic model issues
2. For missing type annotations on public functions, suggest specific fixes
3. For PyTorch tensor type issues, suggest appropriate \`torch.Tensor\` annotations
4. For Pydantic config models, verify \`model_config\` and field types
5. List files with errors sorted by error count (highest first)

### Stage 3: Unit Tests

Run pytest unit tests with coverage measurement:

\`\`\`bash
uv run pytest tests/unit/ -v --tb=short --cov=src --cov-report=term-missing --cov-fail-under=75
\`\`\`

**Pass criteria**: All tests pass, coverage ≥ 75%.

**On failure**:
1. Separate test failures from coverage failures
2. For test failures: show the failing test, the assertion, and the relevant source code
3. For coverage gaps: identify uncovered files and functions, prioritize by importance
4. Check if failures are flaky (timing, random seeds, GPU availability)
5. Suggest specific tests to add for uncovered critical paths (training loops, data transforms, API endpoints)

### Stage 4: Integration Tests

Run integration tests (database, API, pipeline stages):

\`\`\`bash
uv run pytest tests/integration/ -v --tb=short -m "not gpu"
\`\`\`

**Pass criteria**: All integration tests pass.

**On failure**:
1. Check if failures are infrastructure-related (PostgreSQL, Redis, S3 connectivity)
2. Verify test fixtures and database migrations are current
3. For FastAPI endpoint tests, check request/response schema changes
4. For pipeline integration tests, verify DVC stage dependencies

### Stage 5: ML Pipeline Validation

Validate DVC pipeline integrity and experiment configuration:

\`\`\`bash
# Verify DVC pipeline DAG is valid
dvc dag --dot

# Check DVC file integrity (tracked files match .dvc metadata)
dvc status

# Validate all experiment config YAML files against Pydantic schemas
uv run python -m scripts.validate_configs

# Smoke test: run pipeline on sample data
dvc repro --dry
\`\`\`

**Checks performed**:
- All \`dvc.yaml\` stages have valid dependencies and outputs
- No orphaned \`.dvc\` files referencing missing data
- All YAML configs in \`configs/\` parse without errors and pass Pydantic validation
- Model architecture configs specify valid PyTorch module paths
- Training configs have valid hyperparameter ranges
- Data pipeline configs reference existing feature transformations
- \`dvc repro --dry\` completes without dependency errors

**On failure**:
1. For DVC status mismatches: identify which data files changed and whether \`.dvc\` files need updating
2. For config validation errors: show the specific field, expected type, and actual value
3. For pipeline DAG issues: visualize the broken dependency chain
4. Suggest \`dvc push\` if local artifacts are ahead of remote

### Stage 6: Model Artifact Validation

Verify model artifacts and MLflow registry consistency:

\`\`\`bash
# Check model files are loadable
uv run python -m scripts.validate_model_artifacts

# Verify MLflow model registry entries match tracked artifacts
uv run python -m scripts.check_mlflow_registry
\`\`\`

**Checks performed**:
- All \`.pt\` / \`.pth\` files in \`models/\` can be loaded with \`torch.load()\`
- Model state dicts match their architecture definitions in \`src/models/\`
- MLflow registered models have valid artifact URIs
- Model versions in staging/production have passing evaluation metrics
- No model artifacts contain embedded secrets or PII (SOC 2 / GDPR)

**On failure**:
1. For corrupt model files: identify the file and last known good DVC commit
2. For architecture mismatches: diff the model config vs saved state dict keys
3. For MLflow registry issues: check backend store connectivity and artifact permissions

### Stage 7: Security & Compliance

Run security and compliance checks:

\`\`\`bash
# Dependency vulnerability scan
uv run pip-audit

# Check for secrets in codebase
uv run detect-secrets scan --baseline .secrets.baseline

# Verify no PII in tracked data files
uv run python -m scripts.pii_scan --paths data/ configs/

# Check sensitive file permissions
\`\`\`

**Checks performed**:
- No known vulnerabilities in pinned dependencies (pip-audit)
- No hardcoded secrets, API keys, or credentials in source files
- No AWS access keys, MLflow tracking URIs with credentials, or database connection strings in code
- \`.env*\` files are in \`.gitignore\` and not tracked
- \`configs/production/**\` changes are flagged for lead review (CODEOWNERS)
- Data files comply with GDPR requirements (anonymization verified)
- Model artifacts have integrity checksums (SOC 2)

**On failure**:
1. For vulnerabilities: show CVE, severity, affected package, and upgrade path
2. For secrets: identify file and line, but do NOT display the secret value
3. For PII detection: flag the file and data field, recommend anonymization approach
4. For CODEOWNERS violations: list files that need additional reviewers

## Execution Behavior

### Run Order

Stages execute sequentially. By default, **fail-fast** is enabled — verification stops at the first failing stage. Use \`/verify --no-fail-fast\` to run all stages regardless.

### Output Format

For each stage, report:

\`\`\`
## Stage N: [Name]
**Status**: ✅ PASS | ❌ FAIL | ⚠️ WARN
**Duration**: Xs
**Details**: [summary]
\`\`\`

### Final Summary

After all stages complete, produce a summary table:

\`\`\`
| Stage                    | Status | Duration | Issues |
|--------------------------|--------|----------|--------|
| Code Quality             | ✅     | 3s       | 0      |
| Type Checking            | ✅     | 8s       | 0      |
| Unit Tests               | ✅     | 12s      | 0      |
| Integration Tests        | ❌     | 25s      | 2      |
| ML Pipeline Validation   | ✅     | 5s       | 0      |
| Model Artifact Validation| ⚠️     | 10s      | 1      |
| Security & Compliance    | ✅     | 7s       | 0      |

**Overall: FAIL** — 2 errors, 1 warning
\`\`\`

### Variant Behavior

| Variant       | Stages Included                          | Fail Behavior |
|---------------|------------------------------------------|---------------|
| \`quick\`       | 1 (Lint), 2 (Types), 3 (Unit Tests)     | Fail-fast     |
| \`ml\`          | 5 (Pipeline), 6 (Artifacts)             | Run all       |
| \`security\`    | 7 (Security & Compliance)               | Run all       |
| \`pre-merge\`   | All stages (1–7)                         | Run all       |
| _(default)_   | All stages (1–7)                         | Fail-fast     |

## AI-Generated Code Handling

When verification runs on files containing the \`# AI-GENERATED\` marker:

1. Apply **stricter** type checking — no \`Any\` types allowed in AI-generated code
2. Require **≥ 85% coverage** for AI-generated modules (vs 75% baseline)
3. Flag AI-generated model architectures for mandatory human review
4. Verify AI-generated training configs have been validated against known-good baselines
5. Log AI-generated file list in verification output for audit trail (per docs/AI-USAGE-POLICY.md)

## Integration with Other Commands

- After \`/plan\` — run \`/verify quick\` to validate the codebase before starting work
- After \`/tdd\` — run \`/verify\` to confirm full pipeline integrity after new code
- Before PR — run \`/verify pre-merge\` to catch all issues before review
- After experiment — run \`/verify ml\` to validate pipeline and artifact consistency

## Environment Requirements

- Python 3.11+ with \`uv\` installed
- DVC configured with S3 remote (\`dvc remote list\` should show \`s3-storage\`)
- MLflow tracking server accessible (or \`MLFLOW_TRACKING_URI\` set)
- PostgreSQL and Redis running for integration tests
- GPU not required (GPU tests excluded by default; use \`-m gpu\` to include)`,

  'plugin/codeforge-ml-pipeline/hooks/hooks.json': `{
  "version": "1.0",
  "description": "Git hooks for ml-pipeline — enforces commit conventions, code quality, ML artifact integrity, and data privacy compliance",
  "hooks": {
    "pre-commit": {
      "description": "Runs before each commit to enforce code quality, type safety, and ML pipeline integrity",
      "enabled": true,
      "fail_on_error": true,
      "steps": [
        {
          "id": "check-file-length",
          "name": "Enforce max file length (300 lines)",
          "command": "python -c \\"\\nimport sys, pathlib\\nfailed = []\\nfor f in pathlib.Path('src').rglob('*.py'):\\n    lines = len(f.read_text().splitlines())\\n    if lines > 300:\\n        failed.append(f'{f}: {lines} lines')\\nif failed:\\n    print('Files exceeding 300 line limit:'); [print(f'  {f}') for f in failed]; sys.exit(1)\\n\\"",
          "description": "Ensures no Python source file in src/ exceeds 300 lines",
          "run_on": ["src/**/*.py"]
        },
        {
          "id": "ruff-lint",
          "name": "Ruff linter",
          "command": "uv run ruff check --fix src/ tests/ scripts/",
          "description": "Runs ruff linter with auto-fix on staged Python files",
          "run_on": ["*.py"]
        },
        {
          "id": "ruff-format",
          "name": "Ruff formatter",
          "command": "uv run ruff format --check src/ tests/ scripts/",
          "description": "Verifies all Python files conform to ruff format standards",
          "run_on": ["*.py"]
        },
        {
          "id": "mypy-typecheck",
          "name": "Mypy strict type checking",
          "command": "uv run mypy src/ --strict --ignore-missing-imports",
          "description": "Enforces strict type hints on all public functions in src/",
          "run_on": ["src/**/*.py"]
        },
        {
          "id": "check-type-hints",
          "name": "Verify public function type hints",
          "command": "python -c \\"\\nimport ast, sys, pathlib\\nmissing = []\\nfor f in pathlib.Path('src').rglob('*.py'):\\n    tree = ast.parse(f.read_text())\\n    for node in ast.walk(tree):\\n        if isinstance(node, (ast.FunctionDef, ast.AsyncFunctionDef)):\\n            if not node.name.startswith('_') and node.returns is None:\\n                missing.append(f'{f}:{node.lineno} {node.name}()')\\nif missing:\\n    print('Public functions missing return type hints:'); [print(f'  {m}') for m in missing]; sys.exit(1)\\n\\"",
          "description": "Ensures all public functions have return type annotations",
          "run_on": ["src/**/*.py"]
        },
        {
          "id": "check-pydantic-configs",
          "name": "Validate Pydantic config schemas",
          "command": "uv run python -c \\"from src.utils.config import load_and_validate_configs; load_and_validate_configs('configs/')\\"",
          "description": "Validates all YAML experiment configs against Pydantic schemas",
          "run_on": ["configs/**/*.yaml", "configs/**/*.yml"],
          "allow_failure": true
        },
        {
          "id": "prevent-notebook-outputs",
          "name": "Strip notebook outputs",
          "command": "python -c \\"\\nimport json, sys, pathlib\\nfor nb in pathlib.Path('notebooks').rglob('*.ipynb'):\\n    data = json.loads(nb.read_text())\\n    for cell in data.get('cells', []):\\n        if cell.get('outputs'):\\n            print(f'Notebook has outputs: {nb}'); print('Run: jupyter nbconvert --clear-output --inplace {nb}'); sys.exit(1)\\n\\"",
          "description": "Prevents committing Jupyter notebooks with cell outputs (data leak prevention, GDPR)",
          "run_on": ["notebooks/**/*.ipynb"]
        },
        {
          "id": "check-sensitive-paths",
          "name": "Guard sensitive paths",
          "command": "python -c \\"\\nimport subprocess, sys\\nstaged = subprocess.check_output(['git', 'diff', '--cached', '--name-only']).decode().splitlines()\\nsensitive_patterns = ['.env', 'configs/production/', 'data/', 'models/']\\nflagged = [f for f in staged for p in sensitive_patterns if f.startswith(p) or p in f]\\nif flagged:\\n    print('⚠️  Sensitive files staged for commit (review carefully):'); [print(f'  {f}') for f in flagged]\\n    print('Ensure no PII, credentials, or unversioned model artifacts are included.')\\n    print('GDPR: Verify no personal data in data/ files. SOC 2: Verify model artifact integrity.')\\n\\"",
          "description": "Warns when committing to sensitive paths (configs/production/**, models/**, .env*, data/**)",
          "run_on": ["configs/production/**", "models/**", ".env*", "data/**"],
          "fail_on_error": false
        },
        {
          "id": "check-secrets",
          "name": "Detect hardcoded secrets",
          "command": "python -c \\"\\nimport re, subprocess, sys\\nstaged = subprocess.check_output(['git', 'diff', '--cached', '-U0']).decode()\\npatterns = [\\n    (r'(?:aws_secret_access_key|aws_access_key_id)\\\\s*=\\\\s*[\\\\w/+=]{20,}', 'AWS credential'),\\n    (r'(?:password|passwd|secret|token)\\\\s*=\\\\s*[\\\\\\"\\\\'][^\\\\\\"\\\\']+([\\\\\\"\\\\']+)', 'Hardcoded secret'),\\n    (r'AKIA[0-9A-Z]{16}', 'AWS Access Key ID'),\\n    (r'mlflow\\\\.set_tracking_uri\\\\([\\\\\\"\\\\']https?://[^\\\\\\"\\\\']', 'Hardcoded MLflow URI'),\\n    (r'postgresql://[^\\\\s]+:[^\\\\s]+@', 'Database connection string with credentials'),\\n]\\nfound = []\\nfor pattern, label in patterns:\\n    if re.search(pattern, staged, re.IGNORECASE):\\n        found.append(label)\\nif found:\\n    print('🔒 Potential secrets detected (SOC 2 violation):'); [print(f'  - {f}') for f in found]; sys.exit(1)\\n\\"",
          "description": "Scans staged diffs for AWS keys, database credentials, API tokens, and MLflow URIs",
          "run_on": ["*.py", "*.yaml", "*.yml", "*.toml", "*.cfg", "*.ini", "*.env*"]
        },
        {
          "id": "check-dvc-tracked",
          "name": "Verify large files are DVC-tracked",
          "command": "python -c \\"\\nimport subprocess, sys, os\\nstaged = subprocess.check_output(['git', 'diff', '--cached', '--name-only']).decode().splitlines()\\nlarge_extensions = {'.pt', '.pth', '.onnx', '.pkl', '.pickle', '.h5', '.parquet', '.csv', '.feather', '.arrow'}\\nviolations = []\\nfor f in staged:\\n    ext = os.path.splitext(f)[1].lower()\\n    if ext in large_extensions and not f.endswith('.dvc'):\\n        size = os.path.getsize(f) if os.path.exists(f) else 0\\n        if size > 10_000_000:\\n            violations.append(f'{f} ({size // 1_000_000}MB)')\\nif violations:\\n    print('Large files should be tracked with DVC, not git:'); [print(f'  {v}') for v in violations]\\n    print('Run: dvc add <file>'); sys.exit(1)\\n\\"",
          "description": "Prevents committing large model/data files that should be DVC-tracked",
          "run_on": ["**/*.pt", "**/*.pth", "**/*.onnx", "**/*.pkl", "**/*.parquet", "**/*.csv", "data/**", "models/**"]
        },
        {
          "id": "pytest-fast",
          "name": "Run fast unit tests",
          "command": "uv run pytest tests/unit/ -x -q --timeout=60 -m 'not slow and not gpu'",
          "description": "Runs fast unit tests (excludes slow and GPU-dependent tests)",
          "run_on": ["src/**/*.py", "tests/**/*.py"],
          "allow_failure": false
        }
      ]
    },
    "post-commit": {
      "description": "Runs after each commit for tracking, notifications, and experiment metadata",
      "enabled": true,
      "fail_on_error": false,
      "steps": [
        {
          "id": "log-ai-generated",
          "name": "Flag AI-generated code",
          "command": "python -c \\"\\nimport subprocess\\nmsg = subprocess.check_output(['git', 'log', '-1', '--pretty=%B']).decode()\\nif any(tag in msg.lower() for tag in ['[ai]', '[claude]', '[copilot]', 'ai-generated']):\\n    sha = subprocess.check_output(['git', 'rev-parse', 'HEAD']).decode().strip()[:8]\\n    print(f'📌 AI-generated commit {sha} flagged for review audit trail (SOC 2 compliance)')\\n\\"",
          "description": "Detects and logs AI-generated commits for SOC 2 audit trail"
        },
        {
          "id": "track-experiment-config-changes",
          "name": "Track experiment config changes",
          "command": "python -c \\"\\nimport subprocess\\nchanged = subprocess.check_output(['git', 'diff', '--name-only', 'HEAD~1', 'HEAD']).decode().splitlines()\\nconfig_changes = [f for f in changed if f.startswith('configs/') and f.endswith(('.yaml', '.yml'))]\\nif config_changes:\\n    sha = subprocess.check_output(['git', 'rev-parse', 'HEAD']).decode().strip()[:8]\\n    print(f'🧪 Experiment configs changed in {sha}:')\\n    for c in config_changes:\\n        print(f'  {c}')\\n    print('Remember to run: dvc repro && mlflow ui to verify experiment tracking')\\n\\"",
          "description": "Alerts when experiment YAML configs change, reminding to run DVC pipeline"
        },
        {
          "id": "track-model-changes",
          "name": "Track model architecture changes",
          "command": "python -c \\"\\nimport subprocess\\nchanged = subprocess.check_output(['git', 'diff', '--name-only', 'HEAD~1', 'HEAD']).decode().splitlines()\\nmodel_changes = [f for f in changed if f.startswith('src/models/') and f.endswith('.py')]\\nif model_changes:\\n    sha = subprocess.check_output(['git', 'rev-parse', 'HEAD']).decode().strip()[:8]\\n    print(f'🏗️  Model architecture changed in {sha}:')\\n    for m in model_changes:\\n        print(f'  {m}')\\n    print('Action required: Update model version in MLflow registry and re-run evaluation suite')\\n\\"",
          "description": "Alerts when PyTorch model architectures change, prompting MLflow registry update"
        },
        {
          "id": "track-dvc-pipeline-changes",
          "name": "Track DVC pipeline changes",
          "command": "python -c \\"\\nimport subprocess\\nchanged = subprocess.check_output(['git', 'diff', '--name-only', 'HEAD~1', 'HEAD']).decode().splitlines()\\ndvc_changes = [f for f in changed if f in ('dvc.yaml', 'dvc.lock', 'params.yaml') or f.endswith('.dvc')]\\nif dvc_changes:\\n    print('📊 DVC pipeline files changed:')\\n    for d in dvc_changes:\\n        print(f'  {d}')\\n    print('Run: dvc status && dvc repro to update pipeline outputs')\\n\\"",
          "description": "Detects DVC pipeline definition changes and prompts reproduction"
        },
        {
          "id": "check-coverage-delta",
          "name": "Report coverage impact",
          "command": "python -c \\"\\nimport subprocess\\nchanged = subprocess.check_output(['git', 'diff', '--name-only', 'HEAD~1', 'HEAD']).decode().splitlines()\\nsrc_changes = [f for f in changed if f.startswith('src/') and f.endswith('.py')]\\ntest_changes = [f for f in changed if f.startswith('tests/') and f.endswith('.py')]\\nif src_changes and not test_changes:\\n    print(f'⚠️  {len(src_changes)} source file(s) changed with no test updates.')\\n    print(f'Coverage threshold: 75%. Consider adding tests for:')\\n    for s in src_changes[:5]:\\n        print(f'  {s}')\\n\\"",
          "description": "Warns when source files change without corresponding test updates"
        },
        {
          "id": "gdpr-data-change-alert",
          "name": "GDPR data change alert",
          "command": "python -c \\"\\nimport subprocess\\nchanged = subprocess.check_output(['git', 'diff', '--name-only', 'HEAD~1', 'HEAD']).decode().splitlines()\\ndata_changes = [f for f in changed if f.startswith('src/data/') or f.startswith('data/')]\\nif data_changes:\\n    print('🔐 GDPR Notice: Data pipeline files changed:')\\n    for d in data_changes:\\n        print(f'  {d}')\\n    print('Verify: No PII in training data. Anonymization applied. Consent documented.')\\n    print('See: docs/AI-USAGE-POLICY.md for data handling requirements.')\\n\\"",
          "description": "Alerts on data pipeline changes for GDPR compliance review"
        }
      ]
    },
    "pre-push": {
      "description": "Runs before pushing to remote — comprehensive validation gate",
      "enabled": true,
      "fail_on_error": true,
      "steps": [
        {
          "id": "full-lint-suite",
          "name": "Full lint and type check",
          "command": "uv run ruff check src/ tests/ && uv run mypy src/ --strict --ignore-missing-imports",
          "description": "Runs complete linting and type checking before push",
          "run_on": ["*.py"]
        },
        {
          "id": "full-test-suite",
          "name": "Full test suite with coverage",
          "command": "uv run pytest tests/ --cov=src --cov-report=term-missing --cov-fail-under=75 -m 'not gpu' --timeout=300",
          "description": "Runs all non-GPU tests with 75% coverage enforcement",
          "run_on": ["src/**/*.py", "tests/**/*.py"]
        },
        {
          "id": "validate-dvc-lock",
          "name": "Validate DVC lock file",
          "command": "python -c \\"\\nimport subprocess, sys\\nresult = subprocess.run(['dvc', 'status'], capture_output=True, text=True)\\nif 'changed' in result.stdout.lower() or 'modified' in result.stdout.lower():\\n    print('⚠️  DVC pipeline is out of date. Run: dvc repro')\\n    print(result.stdout)\\n    sys.exit(1)\\nelse:\\n    print('✅ DVC pipeline is up to date')\\n\\"",
          "description": "Ensures DVC pipeline lock file is current before pushing",
          "allow_failure": true
        },
        {
          "id": "validate-configs",
          "name": "Validate all experiment configs",
          "command": "uv run python -m src.utils.validate_configs configs/",
          "description": "Validates all YAML configs against Pydantic schemas before push",
          "run_on": ["configs/**/*.yaml"]
        },
        {
          "id": "check-branch-naming",
          "name": "Enforce branch naming convention",
          "command": "python -c \\"\\nimport subprocess, sys, re\\nbranch = subprocess.check_output(['git', 'rev-parse', '--abbrev-ref', 'HEAD']).decode().strip()\\nif branch == 'main':\\n    sys.exit(0)\\npattern = r'^(feat|fix|chore|docs|experiment|refactor|test)/[A-Z]+-\\\\d+-[a-z0-9-]+$'\\nif not re.match(pattern, branch):\\n    print(f'Branch name \\\\\\"{branch}\\\\\\" does not match pattern: type/TICKET-123-description')\\n    print('Valid types: feat, fix, chore, docs, experiment, refactor, test')\\n    print('Example: feat/ML-42-add-transformer-model')\\n    sys.exit(1)\\n\\"",
          "description": "Enforces branch naming: type/TICKET-123-description (includes experiment type for ML)"
        },
        {
          "id": "protect-main",
          "name": "Prevent direct push to main",
          "command": "python -c \\"\\nimport subprocess, sys\\nbranch = subprocess.check_output(['git', 'rev-parse', '--abbrev-ref', 'HEAD']).decode().strip()\\nif branch == 'main':\\n    print('❌ Direct push to main is not allowed. Create a PR instead.')\\n    sys.exit(1)\\n\\"",
          "description": "Blocks direct pushes to the protected main branch"
        }
      ]
    }
  },
  "installation": {
    "description": "Hook installation instructions for ml-pipeline",
    "commands": [
      "git config core.hooksPath git-hooks",
      "chmod +x git-hooks/*"
    ],
    "notes": [
      "Hooks are installed automatically by running: ./install.sh",
      "Requires uv, dvc, and mypy to be available in PATH",
      "GPU tests are excluded from pre-commit and pre-push hooks",
      "See docs/CONTRIBUTING.md for full development setup"
    ]
  }
}`,

  'plugin/codeforge-ml-pipeline/skills/build-fix/SKILL.md': `---
skill: build-fix
version: 1.0.0
description: Diagnose and fix build, lint, type-check, test, and pipeline failures in the ML pipeline project
triggers:
  - build failure
  - lint error
  - type check error
  - test failure
  - CI failure
  - DVC pipeline error
  - Docker build failure
  - import error
  - dependency conflict
  - training smoke test failure
tools:
  - shell
  - file_editor
  - file_reader
  - github_issues
  - github_actions
inputs:
  - name: error_source
    description: "Where the failure originated: lint, typecheck, test, build, ci, dvc, docker, training"
    required: true
  - name: error_output
    description: "Raw error output or CI log snippet"
    required: true
  - name: branch
    description: "Branch where the failure occurred"
    required: false
---

# Skill: build-fix

Diagnose and resolve build, lint, type-check, test, DVC pipeline, and Docker failures in the ml-pipeline project. This skill follows a systematic approach: reproduce → diagnose → fix → verify → document.

## Activation

This skill activates when:
- CI pipeline fails (lint, type-check, test, build, deploy stages)
- Local \`uv run ruff check\`, \`uv run mypy src/\`, or \`uv run pytest\` commands fail
- \`dvc repro\` fails during pipeline execution
- Docker image build fails
- Training smoke tests fail
- Dependency resolution errors occur with \`uv\`

## Workflow

### Phase 1: Triage and Reproduce

1. **Identify the failure category**:
   - **Lint** → \`ruff check\` or \`ruff format --check\` errors
   - **Type check** → \`mypy\` errors in \`src/\`
   - **Unit test** → \`pytest tests/unit/\` failures
   - **Integration test** → \`pytest tests/integration/\` failures
   - **DVC pipeline** → \`dvc repro\` or \`dvc push/pull\` errors
   - **Docker build** → Dockerfile or dependency installation errors
   - **Training smoke** → Model training sanity check failures
   - **Dependency** → \`uv lock\` or \`uv sync\` resolution conflicts

2. **Reproduce locally** before making any changes:

\`\`\`bash
# Lint errors
uv run ruff check src/ tests/ --output-format=full

# Format errors
uv run ruff format --check src/ tests/

# Type check errors
uv run mypy src/ --show-error-codes

# Test failures (run the specific failing test first)
uv run pytest <failing_test_path> -xvs

# DVC pipeline errors
dvc status
dvc repro --dry

# Docker build errors
docker build -t ml-pipeline:debug .

# Training smoke test
uv run python scripts/train_smoke_test.py --config configs/smoke_test.yaml
\`\`\`

3. **Capture the exact error** — copy the full traceback or error message. Do not guess at the problem.

### Phase 2: Diagnose Root Cause

Follow this diagnostic decision tree:

#### Lint Errors (ruff)
- **Import sorting**: ruff auto-fixes most import issues → \`uv run ruff check --fix src/ tests/\`
- **Unused imports/variables**: Verify they are truly unused before removing. Check if they are re-exported or used in \`__all__\`.
- **Line length**: Refactor long lines. For ML code, break long tensor operations or config dicts across lines.
- **Naming violations**: Ensure snake_case for functions/variables, PascalCase for classes, SCREAMING_SNAKE_CASE for constants.

#### Type Check Errors (mypy)
- **Missing type hints**: Add type annotations to all public functions. Use \`torch.Tensor\` for tensor types, \`nn.Module\` for model parameters.
- **Incompatible types**: Check PyTorch tensor dtype mismatches, Pydantic model field types, and FastAPI endpoint signatures.
- **Missing stubs**: Add type stubs or \`# type: ignore[import-untyped]\` with a comment explaining why.
- **Generic types**: Use \`dict[str, Any]\` not \`Dict\`, \`list[float]\` not \`List[float]\` (Python 3.11+).
- **Common ML type patterns**:
  \`\`\`python
  from torch import Tensor
  from torch.utils.data import DataLoader, Dataset
  from pathlib import Path
  from typing import Any
  import numpy as np
  import numpy.typing as npt

  NDArrayFloat = npt.NDArray[np.floating[Any]]
  \`\`\`

#### Test Failures (pytest)
- **Fixture issues**: Check \`conftest.py\` files at the correct directory level. Ensure ML fixtures (sample tensors, mock models) are properly scoped.
- **Async test failures**: Ensure \`@pytest.mark.asyncio\` decorator is present for async tests (FastAPI endpoints).
- **GPU/device issues**: Tests must run on CPU. Check for hardcoded \`cuda\` device references — use \`torch.device("cpu")\` in test fixtures.
- **Flaky tests**: Look for random seed issues in ML tests. Ensure \`torch.manual_seed()\` and \`np.random.seed()\` are set in fixtures.
- **Import errors in tests**: Verify \`src/\` is on the Python path (check \`pyproject.toml\` \`[tool.pytest.ini_options]\` for \`pythonpath\`).
- **Missing test data**: Check if DVC-tracked test fixtures need \`dvc pull\` first.

#### DVC Pipeline Errors
- **Lock file mismatch**: Run \`dvc repro --force\` to regenerate \`dvc.lock\`.
- **Missing remote data**: Run \`dvc pull\` to fetch data from S3 remote.
- **Stage dependency changes**: Check \`dvc.yaml\` for changed deps/outs that invalidate the pipeline.
- **S3 credential issues**: Verify AWS credentials are configured (\`aws sts get-caller-identity\`).
- **Params file errors**: Validate YAML configs referenced in \`dvc.yaml\` params.

#### Docker Build Errors
- **Dependency installation**: Check \`pyproject.toml\` for incompatible packages. Ensure \`uv\` is installed in the Docker image.
- **CUDA version mismatch**: Verify the base image CUDA version matches PyTorch requirements.
- **Missing system dependencies**: Some Python packages need system libs (e.g., \`libpq-dev\` for psycopg2).
- **Layer caching issues**: Ensure \`pyproject.toml\` and \`uv.lock\` are copied before source code for cache efficiency.

#### Training Smoke Test Failures
- **Config validation**: Run \`uv run python -c "from src.utils.config import load_config; load_config('configs/smoke_test.yaml')"\` to validate Pydantic config.
- **Model initialization**: Check model architecture params match the config (input dims, hidden sizes, output classes).
- **Data pipeline**: Verify the smoke test dataset exists and the DataLoader can iterate.
- **NaN/Inf in loss**: Check learning rate, weight initialization, and input normalization.
- **MLflow connection**: Ensure MLflow tracking URI is set correctly for local runs.

#### Dependency Conflicts
- **Resolution failures**: Run \`uv lock --verbose\` to see conflict details.
- **PyTorch + CUDA**: PyTorch versions must match CUDA toolkit. Use \`--index-url\` for PyTorch wheels.
- **Version pins**: Check \`pyproject.toml\` for overly strict pins that conflict.
- **Lock file drift**: Delete \`uv.lock\` and regenerate with \`uv lock\`.

### Phase 3: Apply Fix

**Rules for applying fixes:**

1. **Minimal changes only** — fix the build error, do not refactor unrelated code.
2. **One logical fix per commit** — if multiple errors exist, fix them in order of dependency.
3. **Never modify test expectations to make tests pass** unless the test is genuinely wrong. Verify the intended behavior first.
4. **Never weaken type checking** (e.g., adding \`# type: ignore\` without justification or switching to \`Any\`).
5. **Never reduce test coverage** — if removing code, remove corresponding tests only if the feature is intentionally deleted.
6. **Preserve ML reproducibility** — do not change random seeds, model configs, or data pipeline stages without explicit approval.
7. **Sensitive paths require extra caution**:
   - \`configs/production/**\` — production experiment configs, never modify without lead review
   - \`models/**\` — DVC-tracked model artifacts, changes affect model registry
   - \`.env*\` — credentials and secrets, never commit values
   - \`data/**\` — DVC-tracked data, changes affect pipeline reproducibility

**Auto-fixable issues** (apply directly):
\`\`\`bash
# Lint auto-fix
uv run ruff check --fix src/ tests/

# Format auto-fix
uv run ruff format src/ tests/

# Sort imports
uv run ruff check --select I --fix src/ tests/
\`\`\`

**Manual fixes** — apply with file_editor, explaining each change.

### Phase 4: Verify Fix

Run the full verification chain in order. **All must pass before considering the fix complete.**

\`\`\`bash
# 1. Lint
uv run ruff check src/ tests/

# 2. Format
uv run ruff format --check src/ tests/

# 3. Type check
uv run mypy src/

# 4. Unit tests with coverage
uv run pytest tests/unit/ --cov=src --cov-report=term-missing --cov-fail-under=75

# 5. Integration tests (if the fix touches API or pipeline code)
uv run pytest tests/integration/ -xvs

# 6. DVC pipeline dry run (if the fix touches data or training code)
dvc repro --dry

# 7. Training smoke test (if the fix touches model or training code)
uv run python scripts/train_smoke_test.py --config configs/smoke_test.yaml
\`\`\`

If any step fails, return to Phase 2 and diagnose the new failure. Do not loop more than 3 times — if the fix is not converging, escalate.

### Phase 5: Document

1. **Commit with conventional commit message**:
   \`\`\`
   fix(build): resolve mypy error in feature engineering pipeline

   - Added type annotations to \`src/data/feature_store.py\` public functions
   - Fixed Tensor vs ndarray type mismatch in \`compute_embeddings()\`
   - Verified: ruff ✓ mypy ✓ pytest ✓
   \`\`\`

2. **If the fix reveals a systemic issue**, create a follow-up GitHub Issue:
   - Missing type stubs for a commonly used library
   - Flaky test that needs deterministic seeding
   - Docker base image needs updating
   - DVC pipeline stage that is fragile

3. **If the fix touches ML code**, verify experiment reproducibility:
   - Confirm the same config produces the same metrics (within tolerance)
   - Check that MLflow experiment tracking still logs correctly
   - Ensure DVC pipeline hash hasn't changed unexpectedly

## Common Fix Patterns

### Pattern: PyTorch Type Annotations
\`\`\`python
# Before (mypy error)
def forward(self, x):
    return self.model(x)

# After
def forward(self, x: Tensor) -> Tensor:
    return self.model(x)
\`\`\`

### Pattern: Pydantic Config Validation
\`\`\`python
# Before (runtime error from invalid config)
config = yaml.safe_load(open("config.yaml"))

# After
from src.utils.config import ExperimentConfig
config = ExperimentConfig.from_yaml(Path("config.yaml"))
\`\`\`

### Pattern: FastAPI Async Test Fix
\`\`\`python
# Before (test hangs or fails)
def test_predict_endpoint(client):
    response = client.post("/predict", json=payload)

# After
import pytest
from httpx import AsyncClient

@pytest.mark.asyncio
async def test_predict_endpoint(async_client: AsyncClient) -> None:
    response = await async_client.post("/predict", json=payload)
    assert response.status_code == 200
\`\`\`

### Pattern: DVC Pipeline Stage Fix
\`\`\`yaml
# Before (stage fails due to missing param)
stages:
  train:
    cmd: python scripts/train.py
    deps:
      - src/training/trainer.py

# After
stages:
  train:
    cmd: uv run python scripts/train.py --config \${item.config_path}
    deps:
      - src/training/trainer.py
      - configs/experiment.yaml
    params:
      - configs/experiment.yaml:
          - model
          - training
    outs:
      - models/checkpoints/
    metrics:
      - metrics/train_metrics.json:
          cache: false
\`\`\`

### Pattern: Docker Build Dependency Fix
\`\`\`dockerfile
# Before (build fails on psycopg2)
RUN uv sync

# After
RUN apt-get update && apt-get install -y --no-install-recommends \\
    libpq-dev gcc && \\
    rm -rf /var/lib/apt/lists/*
RUN uv sync --frozen
\`\`\`

## Escalation Criteria

Stop and request human intervention if:
- The fix requires changing production configs (\`configs/production/**\`)
- The fix involves modifying model architecture or training hyperparameters
- The fix requires updating DVC-tracked data or model artifacts
- More than 3 fix-verify cycles have not resolved the issue
- The error involves AWS credentials, secrets, or SOC 2-sensitive infrastructure
- The error suggests data leakage or GDPR-relevant data handling issues
- The root cause is unclear after diagnosis

## Anti-Patterns

- ❌ Adding \`# type: ignore\` without a specific error code and justification
- ❌ Disabling a ruff rule project-wide to fix one file
- ❌ Marking a failing test as \`@pytest.mark.skip\` instead of fixing it
- ❌ Pinning a dependency to an older version without documenting why
- ❌ Modifying \`dvc.lock\` manually instead of running \`dvc repro\`
- ❌ Changing random seeds or model configs to make tests pass
- ❌ Committing \`.env\` files or AWS credentials to fix CI auth issues
- ❌ Reducing coverage threshold to make CI pass`,

  'plugin/codeforge-ml-pipeline/skills/code-review/SKILL.md': `---
skill: code-review
version: 1.0.0
description: Structured code review for ML pipeline PRs — covers code quality, ML best practices, data handling, model correctness, and compliance
triggers:
  - review this PR
  - code review
  - review my changes
  - check this code
  - review before merge
inputs:
  - name: pr_ref
    description: PR number or branch name to review
    required: false
  - name: focus_area
    description: Specific focus — model, data, serving, training, config, security, all
    required: false
    default: all
  - name: severity_threshold
    description: Minimum severity to report — info, warning, error, critical
    required: false
    default: warning
tags:
  - code-review
  - ml-pipeline
  - quality
  - compliance
---

# Skill: code-review

You are performing a structured code review on an ML pipeline codebase (PyTorch, MLflow, DVC, FastAPI). Reviews must go beyond surface-level style checks and evaluate ML-specific correctness, reproducibility, data handling, and compliance.

## Review Process

### Phase 1: Gather Context

1. Identify the changed files using git diff or the PR reference:
   \`\`\`
   git diff main --name-only
   git diff main --stat
   \`\`\`
2. Read the PR description and linked GitHub Issue for intent and acceptance criteria
3. Classify the change type:
   - **model**: Changes to \`src/models/\` — architecture, layers, forward pass
   - **training**: Changes to \`src/training/\` — training loop, optimizers, schedulers, callbacks
   - **data**: Changes to \`src/data/\` — data loading, preprocessing, feature engineering
   - **serving**: Changes to \`src/serving/\` — FastAPI endpoints, inference pipeline, batch processing
   - **config**: Changes to \`configs/\` — experiment YAML configs, Pydantic schemas
   - **infra**: Changes to Dockerfiles, Terraform, CI/CD workflows, DVC pipelines
   - **tests**: Changes to \`tests/\`
   - **mixed**: Multiple categories

### Phase 2: Automated Checks Verification

Confirm that CI checks pass or identify failures:

- **Linting**: \`uv run ruff check src/ tests/\` — no violations
- **Formatting**: \`uv run ruff format --check src/ tests/\` — properly formatted
- **Type checking**: \`uv run mypy src/\` — no type errors in strict mode
- **Tests**: \`uv run pytest tests/ --tb=short\` — all passing
- **Coverage**: \`uv run pytest --cov=src --cov-fail-under=75\` — meets 75% threshold

If any automated check fails, flag it as a **blocking** issue before proceeding.

### Phase 3: Code Quality Review

Evaluate each changed file against these criteria:

#### 3a. General Python Quality
- [ ] Type hints present on all public functions and methods
- [ ] Functions under 50 lines, files under 300 lines
- [ ] snake_case for functions/variables, PascalCase for classes, SCREAMING_SNAKE_CASE for constants
- [ ] No hardcoded values — use Pydantic config models or YAML configs
- [ ] Proper error handling with specific exception types (not bare \`except:\`)
- [ ] Logging via \`structlog\` or \`logging\` — no \`print()\` statements in \`src/\`
- [ ] Docstrings on public classes and functions (Google style)
- [ ] No unused imports, variables, or dead code

#### 3b. Dependency Review
- [ ] New dependencies justified and version-pinned in \`pyproject.toml\`
- [ ] No unnecessary heavy dependencies (check if stdlib or existing deps suffice)
- [ ] License compatibility verified for new packages
- [ ] No known CVEs in added dependencies

### Phase 4: ML-Specific Review

Apply the appropriate checklist based on the change type:

#### 4a. Model Architecture (\`src/models/\`)
- [ ] \`nn.Module\` subclass with proper \`__init__\` and \`forward\` method signatures
- [ ] All layers initialized in \`__init__\`, not created dynamically in \`forward\`
- [ ] Input/output tensor shapes documented in docstrings
- [ ] No in-place operations that break autograd (e.g., avoid \`tensor.data = ...\`)
- [ ] Proper use of \`self.register_buffer()\` for non-parameter tensors
- [ ] Device-agnostic code — no hardcoded \`.cuda()\`, use config-driven device placement
- [ ] Dropout and batch norm behave correctly in train vs eval mode
- [ ] Model is serializable via \`torch.save(model.state_dict(), ...)\`
- [ ] Parameter count is reasonable for the task and documented

#### 4b. Training Code (\`src/training/\`)
- [ ] Random seeds set for reproducibility (torch, numpy, python random, CUDA)
- [ ] Learning rate, batch size, epochs externalized to config — not hardcoded
- [ ] Gradient clipping applied if using RNNs or transformers
- [ ] Loss function appropriate for the task (classification vs regression vs ranking)
- [ ] Proper train/val/test split — no data leakage between splits
- [ ] Validation performed every N steps/epochs, not just at end
- [ ] Early stopping or checkpoint saving based on validation metric
- [ ] MLflow experiment tracking:
  - \`mlflow.log_params()\` for all hyperparameters
  - \`mlflow.log_metrics()\` for train/val loss and task metrics each epoch
  - \`mlflow.log_artifact()\` for model checkpoints and configs
  - Experiment name and run name set meaningfully
- [ ] GPU memory management — \`torch.cuda.empty_cache()\` where appropriate
- [ ] DataLoader uses \`num_workers > 0\` and \`pin_memory=True\` for GPU training
- [ ] No silent NaN/Inf — check for gradient explosion or loss divergence

#### 4c. Data Pipeline (\`src/data/\`)
- [ ] Data loading is deterministic given the same DVC-tracked version
- [ ] Feature engineering is idempotent — same input always produces same output
- [ ] No data leakage: fit transformers on train set only, apply to val/test
- [ ] Null/missing value handling is explicit, not silently dropped
- [ ] Data validation with schema checks (Pydantic or pandera)
- [ ] Large datasets use streaming/chunked processing, not full memory load
- [ ] PII handling compliant with GDPR:
  - Personal data anonymized or pseudonymized before feature engineering
  - Consent tracking metadata preserved
  - Right to deletion supported in pipeline design
- [ ] DVC pipeline stages defined in \`dvc.yaml\` with proper deps/outs

#### 4d. Model Serving (\`src/serving/\`)
- [ ] FastAPI endpoint has Pydantic request/response models with validation
- [ ] Model loaded once at startup, not per-request
- [ ] Inference runs in \`torch.no_grad()\` context
- [ ] Input preprocessing matches training preprocessing exactly
- [ ] Proper error handling for malformed inputs (422 with details)
- [ ] Health check endpoint (\`/health\`) returns model version and status
- [ ] Response latency acceptable — no unnecessary computation in hot path
- [ ] Batch inference endpoint handles variable-size batches
- [ ] Model version tracked in response headers or body
- [ ] Rate limiting and authentication in place for production endpoints

#### 4e. Experiment Configs (\`configs/\`)
- [ ] Pydantic model validates all config fields with types and constraints
- [ ] Config YAML is complete — no missing required fields
- [ ] Hyperparameters have sensible defaults and documented ranges
- [ ] Config includes metadata: experiment name, description, author, date
- [ ] Sensitive values (API keys, credentials) NOT in config files — use env vars
- [ ] Config is version-controlled and referenced in MLflow run

### Phase 5: Security & Compliance Review

#### SOC 2 Compliance
- [ ] No secrets, API keys, or credentials in code or configs
- [ ] Model artifacts have integrity checks (checksums in DVC)
- [ ] Access controls documented for sensitive resources
- [ ] Audit trail maintained via MLflow tracking and git history
- [ ] No arbitrary code execution from user input (pickle deserialization, eval())

#### GDPR Compliance
- [ ] Training data does not contain unprocessed PII
- [ ] Data retention policies respected in pipeline design
- [ ] Model does not memorize or leak training data (check for overfitting on PII)
- [ ] Data processing purposes documented in config or metadata

#### Sensitive Path Changes
Flag for additional review if changes touch:
- \`configs/production/**\` — production experiment configs
- \`models/**\` — DVC-tracked model artifacts
- \`.env*\` — environment variable files
- \`data/**\` — DVC-tracked data directories
- \`.github/workflows/**\` — CI/CD pipeline definitions
- \`Dockerfile*\`, \`terraform/**\` — infrastructure

### Phase 6: Test Coverage Review

- [ ] New public functions have corresponding unit tests in \`tests/\`
- [ ] Model tests verify forward pass shape, gradient flow, and device compatibility
- [ ] Data pipeline tests use fixtures with small synthetic data, not real data
- [ ] Serving tests use FastAPI \`TestClient\` with mocked model inference
- [ ] Training tests verify one step of training completes without error
- [ ] Edge cases tested: empty input, single sample batch, missing features
- [ ] Integration tests cover end-to-end pipeline stages where applicable
- [ ] No tests depend on external services without mocking (S3, MLflow server, DB)

## Output Format

Structure your review as follows:

\`\`\`markdown
## Code Review: [PR Title or Branch Name]

**Change Type**: model | training | data | serving | config | infra | mixed
**Risk Level**: low | medium | high | critical
**Files Reviewed**: N files changed

### Summary
[1-3 sentence summary of what the PR does and overall assessment]

### Blocking Issues 🚫
[Issues that MUST be fixed before merge — correctness, security, data leakage, compliance]

### Warnings ⚠️
[Issues that SHOULD be fixed — ML best practices, performance, maintainability]

### Suggestions 💡
[Optional improvements — style, alternative approaches, optimization ideas]

### ML-Specific Notes 🧪
[Observations about model correctness, reproducibility, experiment tracking]

### Compliance Notes 🔒
[SOC 2 or GDPR relevant observations, if any]

### Verdict
- [ ] **Approve** — Ready to merge
- [ ] **Request Changes** — Blocking issues found
- [ ] **Comment** — Non-blocking feedback only
\`\`\`

## Review Principles

1. **Reproducibility first**: Every experiment must be reproducible from config + code + data version
2. **No silent failures**: Training that silently produces bad results is worse than a crash
3. **Data integrity**: Data leakage is the most critical ML bug — always verify split boundaries
4. **Production parity**: Serving code must match training preprocessing exactly
5. **Incremental improvement**: Don't block PRs for style nits if correctness is sound
6. **Teach, don't gatekeep**: Explain the "why" behind every review comment, especially for ML-specific feedback
7. **Flag AI-generated code**: If code appears AI-generated, verify it has the \`# AI-generated\` marker per team policy

## Integration Notes

- Use GitHub MCP server to fetch PR details, diff, and existing review comments
- Cross-reference linked GitHub Issues for acceptance criteria
- Check MLflow for related experiment runs if the PR includes training changes
- Verify DVC pipeline integrity if data or model stages are modified: \`dvc status\`
- If the PR modifies \`configs/production/\`, tag the review as requiring lead engineer approval per CODEOWNERS`,

  'plugin/codeforge-ml-pipeline/skills/phase/SKILL.md': `---
skill: phase
version: 1.0.0
description: Navigate ML pipeline development through structured workflow phases — from experiment design through production deployment
triggers:
  - "phase"
  - "workflow"
  - "pipeline phase"
  - "next phase"
  - "experiment phase"
inputs:
  - name: phase_name
    description: "Target phase: design | data-prep | experiment | training | evaluation | serving | deploy | monitor"
    required: true
  - name: ticket_id
    description: "GitHub Issue ID (e.g., ML-42)"
    required: false
  - name: experiment_name
    description: "MLflow experiment name for tracking"
    required: false
  - name: config_path
    description: "Path to YAML experiment config"
    required: false
tags:
  - ml-pipeline
  - workflow
  - experiment-tracking
  - pytorch
  - mlflow
  - dvc
---

# Skill: phase — ML Pipeline Workflow Navigation

You are an ML pipeline workflow orchestrator for the **ml-pipeline** project. Guide development through structured phases that ensure reproducibility, traceability, and production readiness.

## Project Context

- **Stack**: Python 3.11+, PyTorch, MLflow, DVC, FastAPI, PostgreSQL, Redis, AWS
- **Architecture**: DAG-based pipeline (DVC stages → MLflow tracking → FastAPI serving)
- **Compliance**: SOC 2 (audit trails, access controls), GDPR (data anonymization, consent)
- **Config**: Pydantic models validated from YAML in \`configs/\`
- **Data**: DVC-tracked in \`data/\` (raw → processed → features)
- **Models**: DVC-tracked artifacts in \`models/\`, registered in MLflow Model Registry

## Phase Definitions

### Phase 1: \`design\`
**Purpose**: Define the experiment hypothesis, success metrics, and pipeline changes needed.

Steps:
1. Fetch the GitHub Issue via \`gh issue view <ticket_id>\` or MCP GitHub server
2. Review the current pipeline DAG: \`dvc dag\`
3. Review existing MLflow experiments: check \`mlflow ui\` or query the tracking server
4. Create or update the experiment config YAML in \`configs/\`:
   \`\`\`yaml
   experiment:
     name: "<experiment_name>"
     hypothesis: "<what we expect to observe>"
     success_criteria:
       primary_metric: "f1_score"
       threshold: 0.85
     owner: "<engineer>"
     ticket: "<ticket_id>"
   \`\`\`
5. Define data requirements — what raw/processed data is needed, any new features
6. Validate config with Pydantic: ensure \`src/utils/config.py\` schema covers new fields
7. Document the design in the issue or in \`docs/experiments/<experiment_name>.md\`

Output checklist:
- [ ] Experiment config YAML created/updated in \`configs/\`
- [ ] Pydantic config schema validated
- [ ] Data requirements documented
- [ ] Success metrics defined with thresholds
- [ ] Pipeline DAG changes identified
- [ ] GitHub Issue updated with design summary

### Phase 2: \`data-prep\`
**Purpose**: Prepare, version, and validate data for the experiment.

Steps:
1. Review data requirements from the design phase config
2. Implement or update data loading in \`src/data/\`:
   - \`src/data/loaders.py\` — raw data ingestion
   - \`src/data/preprocessing.py\` — cleaning, normalization
   - \`src/data/features.py\` — feature engineering
3. Add DVC pipeline stages in \`dvc.yaml\`:
   \`\`\`yaml
   stages:
     prepare_data:
       cmd: uv run python scripts/prepare_data.py --config \${config_path}
       deps:
         - src/data/
         - configs/\${config_path}
       outs:
         - data/processed/
       params:
         - configs/\${config_path}:
             - data
     engineer_features:
       cmd: uv run python scripts/engineer_features.py --config \${config_path}
       deps:
         - src/data/features.py
         - data/processed/
       outs:
         - data/features/
   \`\`\`
4. Run the data pipeline: \`dvc repro prepare_data engineer_features\`
5. Validate data quality — check for nulls, distributions, class balance
6. Push data to DVC remote: \`dvc push\`
7. **GDPR compliance**: Ensure PII is anonymized or pseudonymized. Document data lineage. Verify consent records exist for training data. Implement right-to-deletion hooks if user data is involved.
8. Write tests in \`tests/test_data/\`:
   - Test data loading with fixtures
   - Test preprocessing transformations
   - Test feature engineering output shapes and types

Output checklist:
- [ ] Data loading/preprocessing code in \`src/data/\`
- [ ] DVC stages defined in \`dvc.yaml\`
- [ ] \`dvc repro\` runs successfully
- [ ] Data pushed to S3 via \`dvc push\`
- [ ] GDPR compliance verified (anonymization, lineage)
- [ ] Unit tests passing: \`uv run pytest tests/test_data/ -v\`
- [ ] Type hints on all public functions, validated with \`uv run mypy src/data/\`

### Phase 3: \`experiment\`
**Purpose**: Define model architecture and experiment configuration for rapid iteration.

Steps:
1. Implement or modify model architecture in \`src/models/\`:
   - Subclass \`torch.nn.Module\`
   - Type hints on \`__init__\` and \`forward\` methods
   - Document input/output tensor shapes in docstrings
2. Update experiment config in \`configs/\`:
   \`\`\`yaml
   model:
     architecture: "transformer_classifier"
     params:
       hidden_dim: 256
       num_layers: 4
       dropout: 0.1
   training:
     optimizer: "adamw"
     learning_rate: 0.001
     batch_size: 64
     max_epochs: 50
     early_stopping_patience: 5
     scheduler: "cosine_annealing"
   data:
     train_split: 0.8
     val_split: 0.1
     test_split: 0.1
     seed: 42
   \`\`\`
3. Validate config loads correctly via Pydantic:
   \`\`\`python
   from src.utils.config import ExperimentConfig
   config = ExperimentConfig.from_yaml("configs/<config_path>")
   \`\`\`
4. Write model unit tests in \`tests/test_models/\`:
   - Test forward pass with dummy tensors
   - Test output shapes match expectations
   - Test model serialization (save/load state_dict)
5. Ensure all code passes linting and type checks:
   - \`uv run ruff check src/models/\`
   - \`uv run mypy src/models/\`

Output checklist:
- [ ] Model architecture in \`src/models/\` with type hints and docstrings
- [ ] Experiment config YAML validated with Pydantic
- [ ] Model unit tests passing
- [ ] Lint clean: \`uv run ruff check src/models/\`
- [ ] Type check clean: \`uv run mypy src/models/\`
- [ ] No file exceeds 300 lines

### Phase 4: \`training\`
**Purpose**: Execute training with full MLflow tracking and reproducibility.

Steps:
1. Implement or update training loop in \`src/training/\`:
   - \`src/training/trainer.py\` — main training loop with MLflow integration
   - \`src/training/callbacks.py\` — early stopping, checkpointing, LR scheduling
   - \`src/training/tuning.py\` — hyperparameter search (Optuna or grid search)
2. Integrate MLflow tracking in the trainer:
   \`\`\`python
   import mlflow
   
   with mlflow.start_run(experiment_id=experiment_id, run_name=run_name):
       mlflow.log_params(config.training.model_dump())
       mlflow.log_params(config.model.model_dump())
       mlflow.set_tag("ticket", ticket_id)
       mlflow.set_tag("config_path", config_path)
       # Training loop...
       for epoch in range(config.training.max_epochs):
           train_loss = train_one_epoch(model, train_loader, optimizer)
           val_metrics = evaluate(model, val_loader)
           mlflow.log_metrics({"train_loss": train_loss, **val_metrics}, step=epoch)
       # Log model artifact
       mlflow.pytorch.log_model(model, "model")
   \`\`\`
3. Add DVC training stage:
   \`\`\`yaml
   stages:
     train:
       cmd: uv run python scripts/train.py --config \${config_path}
       deps:
         - src/training/
         - src/models/
         - data/features/
       outs:
         - models/\${experiment_name}/
       params:
         - configs/\${config_path}:
             - model
             - training
   \`\`\`
4. Run training: \`dvc repro train\` or \`uv run python scripts/train.py --config <config_path>\`
5. Verify MLflow run logged correctly — check parameters, metrics, artifacts
6. For GPU training on AWS: ensure Docker image builds with CUDA support, test on EC2 GPU instance
7. **SOC 2**: Log all training runs with timestamps, configs, and data versions. Ensure model artifacts have integrity checksums.

Output checklist:
- [ ] Training code in \`src/training/\` with MLflow integration
- [ ] DVC training stage in \`dvc.yaml\`
- [ ] MLflow run logged with params, metrics, artifacts, and tags
- [ ] Model checkpoint saved and DVC-tracked
- [ ] Training tests in \`tests/test_training/\` (smoke test with small data)
- [ ] Reproducible: same config + data version → same results (seeded)

### Phase 5: \`evaluation\`
**Purpose**: Evaluate model performance, compare with baselines, and decide on promotion.

Steps:
1. Implement evaluation in \`src/evaluation/\`:
   - \`src/evaluation/metrics.py\` — compute metrics (accuracy, F1, AUC, etc.)
   - \`src/evaluation/comparison.py\` — compare runs in MLflow
   - \`src/evaluation/visualization.py\` — confusion matrices, ROC curves, learning curves
2. Run evaluation on held-out test set:
   \`\`\`python
   from src.evaluation.metrics import compute_metrics
   metrics = compute_metrics(model, test_loader)
   mlflow.log_metrics({f"test_{k}": v for k, v in metrics.items()})
   \`\`\`
3. Compare against baseline and previous best:
   - Query MLflow for the current production model metrics
   - Log comparison as MLflow artifact (JSON or markdown table)
4. Add DVC evaluation stage:
   \`\`\`yaml
   stages:
     evaluate:
       cmd: uv run python scripts/evaluate.py --config \${config_path}
       deps:
         - src/evaluation/
         - models/\${experiment_name}/
         - data/features/
       metrics:
         - reports/metrics.json:
             cache: false
       plots:
         - reports/plots/
   \`\`\`
5. Generate evaluation report: \`dvc metrics show\`, \`dvc plots show\`
6. Check against success criteria defined in design phase config
7. If metrics meet threshold → proceed to serving phase
8. If metrics do not meet threshold → document findings, return to experiment phase

Output checklist:
- [ ] Evaluation code in \`src/evaluation/\`
- [ ] Test metrics logged to MLflow
- [ ] Comparison with baseline documented
- [ ] DVC metrics and plots generated
- [ ] Success criteria check: pass/fail with evidence
- [ ] Evaluation tests in \`tests/test_evaluation/\`

### Phase 6: \`serving\`
**Purpose**: Package the model for inference via FastAPI and prepare for deployment.

Steps:
1. Register model in MLflow Model Registry:
   \`\`\`python
   mlflow.register_model(f"runs:/{run_id}/model", "my_model")
   # Transition to staging
   client.transition_model_version_stage("my_model", version, "Staging")
   \`\`\`
2. Implement or update serving code in \`src/serving/\`:
   - \`src/serving/app.py\` — FastAPI application with health, predict, batch endpoints
   - \`src/serving/inference.py\` — model loading, preprocessing, postprocessing
   - \`src/serving/schemas.py\` — Pydantic request/response models
3. Implement caching with Redis for repeated predictions:
   \`\`\`python
   from src.serving.cache import get_cached_prediction, cache_prediction
   \`\`\`
4. Add A/B testing infrastructure:
   - Route traffic between model versions based on config
   - Log predictions with model version for analysis
5. Write serving tests:
   - \`tests/test_serving/test_app.py\` — FastAPI TestClient tests
   - \`tests/test_serving/test_inference.py\` — inference pipeline tests
   - Test latency requirements (p95 < threshold)
6. Build Docker image:
   \`\`\`bash
   docker build -t ml-pipeline-serving:latest -f Dockerfile.serving .
   \`\`\`
7. **GDPR**: Ensure prediction inputs are not logged with PII. Implement data retention policies for prediction logs.
8. **SOC 2**: Verify model artifact integrity (checksum matches MLflow registry).

Output checklist:
- [ ] Model registered in MLflow Model Registry (Staging)
- [ ] FastAPI app in \`src/serving/\` with predict and health endpoints
- [ ] Pydantic schemas for request/response validation
- [ ] Redis caching for predictions
- [ ] A/B testing routing implemented
- [ ] Docker image builds successfully
- [ ] Serving tests passing: \`uv run pytest tests/test_serving/ -v\`
- [ ] API docs accessible at \`/docs\`

### Phase 7: \`deploy\`
**Purpose**: Deploy to staging/production with proper CI/CD and rollback capability.

Steps:
1. Ensure all CI checks pass:
   - \`uv run ruff check src/\`
   - \`uv run ruff format --check src/\`
   - \`uv run mypy src/\`
   - \`uv run pytest --cov=src --cov-fail-under=75\`
2. Create PR following GitHub Flow:
   - Branch: \`feat/<ticket_id>-<description>\`
   - PR title: \`feat(<scope>): <description>\`
   - Fill out PR template with experiment results, metrics, MLflow run links
   - Tag with \`ai-assisted\` if Claude was used
3. Push Docker image to ECR:
   \`\`\`bash
   aws ecr get-login-password | docker login --username AWS --password-stdin <ecr-url>
   docker tag ml-pipeline-serving:latest <ecr-url>/ml-pipeline-serving:latest
   docker push <ecr-url>/ml-pipeline-serving:latest
   \`\`\`
4. Deploy to staging (auto-deploy on merge to main):
   - ECS service update or Kubernetes rolling deployment
   - Run smoke tests against staging endpoint
   - Verify MLflow model version matches deployed version
5. Production deployment (manual approval required):
   - Transition model to "Production" in MLflow Registry
   - Blue/green or canary deployment via ECS/K8s
   - Verify health endpoint and run integration tests
6. Update DVC pipeline lock: \`dvc push\`
7. Tag release: \`git tag v<version>\` with model version and metrics summary

Output checklist:
- [ ] All CI checks passing (lint, type check, tests, coverage ≥ 75%)
- [ ] PR created with experiment results and MLflow links
- [ ] Docker image pushed to ECR
- [ ] Staging deployment successful with smoke tests
- [ ] Production deployment with manual approval
- [ ] MLflow model transitioned to Production stage
- [ ] Release tagged in git
- [ ] CODEOWNERS review for \`configs/production/**\`, \`models/**\`

### Phase 8: \`monitor\`
**Purpose**: Monitor model performance in production, detect drift, and trigger retraining.

Steps:
1. Verify monitoring infrastructure:
   - Prometheus metrics exported from FastAPI (request latency, error rate, prediction distribution)
   - Grafana dashboards for model performance
   - MLflow UI for experiment comparison
2. Implement drift detection in \`src/evaluation/drift.py\`:
   - Feature drift (KS test, PSI)
   - Prediction drift (distribution shift)
   - Performance drift (metric degradation vs. offline evaluation)
3. Set up alerting:
   - Slack notifications for metric degradation
   - Automated GitHub Issue creation for retraining triggers
4. Log production predictions (anonymized) for future retraining:
   - Store in S3 with DVC tracking
   - Maintain data lineage for GDPR compliance
5. Document findings in \`docs/experiments/<experiment_name>.md\`:
   - Production metrics vs. offline metrics
   - Drift observations
   - Retraining recommendations

Output checklist:
- [ ] Prometheus metrics exported from serving endpoints
- [ ] Grafana dashboard configured
- [ ] Drift detection implemented and scheduled
- [ ] Alerting configured (Slack, GitHub Issues)
- [ ] Production prediction logging (GDPR-compliant)
- [ ] Experiment documentation updated

## Phase Transition Rules

\`\`\`
design → data-prep → experiment → training → evaluation
                                                  ↓
                         experiment ← (fail) ← evaluation
                                                  ↓
                                              (pass) → serving → deploy → monitor
                                                                            ↓
                                                              design ← (drift detected)
\`\`\`

- **Never skip phases** — each phase produces artifacts the next phase depends on
- **Evaluation gates**: Only proceed to serving if success criteria are met
- **Monitor loops back**: Drift detection triggers a new design phase
- **All phases log to MLflow**: Every phase should have traceable artifacts

## Execution Instructions

When the user invokes \`phase <phase_name>\`:

1. **Identify current state**: Check for existing artifacts (configs, DVC stages, MLflow runs, code)
2. **Validate prerequisites**: Ensure prior phase outputs exist
3. **Execute the phase steps**: Follow the checklist for the requested phase
4. **Verify outputs**: Run relevant checks (lint, type check, tests)
5. **Report status**: Summarize what was done, what artifacts were created, and what the next phase is

When the user invokes \`phase\` without a phase name:
1. Analyze the current repo state to determine which phase the project is in
2. Suggest the next phase with rationale
3. List any blockers or missing prerequisites

## Quality Gates (Applied at Every Phase)

- **Lint**: \`uv run ruff check src/\` — zero violations
- **Format**: \`uv run ruff format --check src/\` — zero violations
- **Type check**: \`uv run mypy src/\` — zero errors
- **Tests**: \`uv run pytest --cov=src --cov-fail-under=75\` — all passing, coverage ≥ 75%
- **File length**: No file exceeds 300 lines
- **Type hints**: All public functions have type annotations
- **Naming**: snake_case files/functions, PascalCase classes, SCREAMING_SNAKE_CASE constants
- **Sensitive paths**: Changes to \`configs/production/**\`, \`models/**\`, \`.env*\`, \`data/**\` require CODEOWNERS review
- **AI attribution**: Mark AI-generated code with \`# AI-GENERATED\` comment and \`ai-assisted\` PR label`,

  'plugin/codeforge-ml-pipeline/skills/plan/SKILL.md': `---
skill: plan
version: 1.0.0
description: Create a detailed implementation plan for ML pipeline tasks before writing code
triggers:
  - plan
  - create plan
  - implementation plan
  - design
  - architect
inputs:
  - name: task_description
    description: The task, feature, or experiment to plan
    required: true
  - name: ticket_id
    description: GitHub Issue ID (e.g., ML-42)
    required: false
  - name: scope
    description: "Scope of the plan: feature, experiment, bugfix, refactor, infrastructure"
    required: false
    default: feature
tags:
  - planning
  - architecture
  - ml-pipeline
  - workflow
---

# Skill: Plan

Create a structured implementation plan for ML pipeline work before writing any code. Plans ensure alignment with the DAG-based pipeline architecture, experiment reproducibility, and team review standards.

## When to Use

- Before starting any feature, experiment, or refactor that touches more than one file
- When a GitHub Issue needs breakdown into concrete implementation steps
- Before adding a new model architecture, data pipeline stage, or serving endpoint
- When designing hyperparameter tuning experiments or A/B test infrastructure
- Before modifying DVC pipelines or MLflow tracking schemas

## Planning Process

### Step 1: Gather Context

1. **Read the task description** and any linked GitHub Issue via MCP:
   \`\`\`
   Use github MCP to fetch issue details for the ticket_id
   \`\`\`

2. **Review relevant existing code** in the affected areas:
   - \`src/data/\` — data loading, preprocessing, feature engineering
   - \`src/models/\` — PyTorch model architectures (nn.Module classes)
   - \`src/training/\` — training loops, callbacks, hyperparameter tuning
   - \`src/evaluation/\` — metrics, model comparison, visualization
   - \`src/serving/\` — FastAPI endpoints, inference pipeline, batch processing
   - \`src/utils/\` — shared utilities, config loading, logging
   - \`configs/\` — YAML experiment configs (model, data, training params)

3. **Check the DVC pipeline** for upstream/downstream dependencies:
   - Review \`dvc.yaml\` and \`dvc.lock\` for pipeline stage ordering
   - Identify which stages will be affected by the change
   - Note data dependencies and output artifacts

4. **Review MLflow experiment history** if this relates to model changes:
   - Check existing experiment names and run naming conventions
   - Review tracked parameters, metrics, and artifacts for consistency

### Step 2: Classify the Work

Determine the scope and type:

| Scope | Description | Typical Artifacts |
|-------|-------------|-------------------|
| \`experiment\` | New model, hyperparams, or training approach | Config YAML, model code, training script, MLflow runs |
| \`feature\` | New pipeline stage, API endpoint, or capability | Source code, tests, DVC stage, config updates |
| \`bugfix\` | Fix incorrect behavior in pipeline or serving | Source fix, regression test, config patch if needed |
| \`refactor\` | Restructure without behavior change | Source changes, updated tests, same DVC outputs |
| \`infrastructure\` | Docker, CI/CD, Terraform, deployment changes | Infra configs, deployment scripts, monitoring |

### Step 3: Produce the Plan

Generate a structured plan document with these sections:

#### 3a. Summary
- One-paragraph description of what will be built and why
- Link to GitHub Issue if available
- Expected impact on pipeline DAG, model performance, or serving latency

#### 3b. Architecture Decisions
- Which components of the pipeline are affected
- New modules or classes to create (with proposed file paths)
- Interfaces between components (function signatures with type hints)
- Config schema changes (Pydantic models)
- Data flow through the pipeline DAG

#### 3c. Experiment Design (if scope is \`experiment\`)
- Hypothesis being tested
- Independent variables (hyperparameters, architecture choices)
- Dependent variables (metrics to track in MLflow)
- Baseline comparison (existing model run ID or metric values)
- YAML config structure for the experiment:
  \`\`\`yaml
  experiment:
    name: "experiment-name"
    model:
      architecture: "..."
      params: {}
    training:
      epochs: ...
      learning_rate: ...
      batch_size: ...
    data:
      dataset: "..."
      preprocessing: []
  \`\`\`

#### 3d. Implementation Steps
Ordered list of concrete steps, each with:
- **What**: Description of the change
- **Where**: File path(s) to create or modify
- **Why**: Rationale for this step
- **Dependencies**: Which prior steps must complete first
- **Estimated complexity**: Low / Medium / High

Example structure:
\`\`\`
1. Define Pydantic config schema
   - Where: src/utils/config.py, configs/experiment_name.yaml
   - Why: Validate experiment parameters before training starts
   - Dependencies: None
   - Complexity: Low

2. Implement data preprocessing stage
   - Where: src/data/preprocessing.py
   - Why: New feature engineering required for experiment
   - Dependencies: Step 1 (config schema)
   - Complexity: Medium

3. Add DVC pipeline stage
   - Where: dvc.yaml
   - Why: Integrate preprocessing into reproducible pipeline
   - Dependencies: Step 2
   - Complexity: Low
\`\`\`

#### 3e. Testing Strategy
- **Unit tests**: Which functions/classes need tests, expected in \`tests/unit/\`
- **Integration tests**: Pipeline stage integration, API endpoint tests in \`tests/integration/\`
- **Smoke tests**: Quick training run with small data subset to verify end-to-end
- **Coverage target**: Must maintain ≥75% coverage threshold
- **Test data**: Fixtures or synthetic data needed (never use production PII — GDPR)

#### 3f. DVC Pipeline Changes
- New or modified stages in \`dvc.yaml\`
- Data dependencies (\`deps\`) and outputs (\`outs\`)
- Metrics files tracked by DVC (\`metrics\`)
- Plots or visualization outputs

#### 3g. MLflow Tracking Plan
- Experiment name and run naming convention
- Parameters to log (\`mlflow.log_param\`)
- Metrics to log (\`mlflow.log_metric\`) — training loss, validation metrics, inference latency
- Artifacts to log — model checkpoints, confusion matrices, feature importance plots
- Model registry — whether to register a new model version

#### 3h. Security and Compliance Checklist
- [ ] No PII in training data without anonymization (GDPR)
- [ ] No secrets or credentials in config files or code
- [ ] Model artifacts integrity verified (SOC 2 — checksums, signed artifacts)
- [ ] Sensitive paths (\`configs/production/**\`, \`models/**\`, \`.env*\`, \`data/**\`) handled appropriately
- [ ] Data access follows least-privilege principle
- [ ] Audit trail maintained via MLflow and git history

#### 3i. Rollback Plan
- How to revert if the change causes issues
- DVC commands to restore previous data/model versions
- MLflow model registry stage transitions (Staging → Archived)
- Feature flags or A/B test kill switches if applicable

#### 3j. Review Checklist
- [ ] Plan reviewed by at least one team member before implementation
- [ ] Branch created following convention: \`type/TICKET-desc\` (e.g., \`feat/ML-42-add-transformer-model\`)
- [ ] Conventional commit prefixes identified (\`feat:\`, \`fix:\`, \`experiment:\`, \`chore:\`, \`docs:\`)
- [ ] CODEOWNERS notified for affected paths
- [ ] No file exceeds 300-line limit — split if needed

### Step 4: Validate the Plan

Before finalizing, verify:

1. **Reproducibility**: Can another engineer reproduce this work from the plan + configs alone?
2. **Pipeline integrity**: Does the DVC DAG remain valid? Run \`dvc dag\` mentally to check.
3. **Type safety**: Are all public function signatures specified with type hints?
4. **Config-driven**: Are all tunable parameters in YAML configs validated by Pydantic — not hardcoded?
5. **Notebook boundary**: Is all production logic in \`src/\`, with notebooks only for exploration?

## Output Format

The plan should be written as a Markdown document suitable for:
- Posting as a comment on the GitHub Issue
- Storing in \`docs/plans/\` for team reference
- Using as a checklist during implementation

## Example Invocation

\`\`\`
Plan the implementation for ML-42: Add a Transformer-based model for sequence classification.
The model should support variable-length inputs, use the existing feature pipeline,
and be comparable against the current LSTM baseline tracked in MLflow experiment "seq-classification-v2".
\`\`\`

## Related Skills

- **code** — Implement the plan by writing source code, tests, and configs
- **review** — Review implementation against the plan and coding standards
- **experiment** — Run and track ML experiments defined in the plan
- **debug** — Troubleshoot issues found during implementation`,

  'plugin/codeforge-ml-pipeline/skills/tdd/SKILL.md': `---
name: tdd
description: Test-Driven Development skill for ML pipeline components — write failing tests first, implement minimal code, refactor with full type safety and experiment reproducibility
version: 1.0.0
author: codeforge-ml-pipeline
tags:
  - testing
  - tdd
  - ml-pipeline
  - pytorch
  - fastapi
inputs:
  - name: component
    description: The ML pipeline component to build (e.g., data loader, model, training loop, API endpoint, feature transformer)
    required: true
  - name: ticket
    description: GitHub Issue ID (e.g., ML-42)
    required: false
  - name: description
    description: Natural language description of the desired behavior
    required: true
  - name: layer
    description: Pipeline layer — one of data, models, training, evaluation, serving, utils
    required: true
    enum:
      - data
      - models
      - training
      - evaluation
      - serving
      - utils
---

# TDD Skill — ML Pipeline

Apply strict Test-Driven Development to every ML pipeline component. The cycle is **Red → Green → Refactor** with ML-specific considerations for reproducibility, numerical correctness, and experiment tracking.

## Workflow

### Phase 1: Red — Write Failing Tests First

Before writing any implementation code, create a comprehensive test file.

1. **Determine the test file location** based on the \`layer\` input:
   - \`src/data/\` → \`tests/unit/test_data_<component>.py\`
   - \`src/models/\` → \`tests/unit/test_models_<component>.py\`
   - \`src/training/\` → \`tests/unit/test_training_<component>.py\`
   - \`src/evaluation/\` → \`tests/unit/test_evaluation_<component>.py\`
   - \`src/serving/\` → \`tests/integration/test_serving_<component>.py\`
   - \`src/utils/\` → \`tests/unit/test_utils_<component>.py\`

2. **Write tests that cover**:
   - Happy path with expected inputs and outputs
   - Edge cases (empty datasets, single-sample batches, NaN/Inf values, GPU/CPU device handling)
   - Input validation (Pydantic config validation, tensor shape mismatches, dtype errors)
   - Error handling (missing files, corrupt data, OOM simulation)
   - Reproducibility (seeded random state produces identical outputs)
   - Type annotations on all test helper functions

3. **ML-specific test patterns**:

   For **data components** (\`layer: data\`):
   \`\`\`python
   import pytest
   import torch
   from pydantic import ValidationError

   from src.data.<component> import <ComponentClass>, <ComponentConfig>


   class TestComponentConfig:
       """Test Pydantic config validation."""

       def test_valid_config(self) -> None:
           config = <ComponentConfig>(param="value")
           assert config.param == "value"

       def test_invalid_config_raises(self) -> None:
           with pytest.raises(ValidationError):
               <ComponentConfig>(param=None)


   class TestComponent:
       """Test data component behavior."""

       @pytest.fixture
       def sample_data(self, tmp_path: Path) -> Path:
           """Create reproducible test data."""
           ...

       def test_output_shape(self, sample_data: Path) -> None:
           result = <ComponentClass>(config).process(sample_data)
           assert result.shape == expected_shape

       def test_handles_empty_input(self) -> None:
           ...

       def test_deterministic_with_seed(self) -> None:
           """Verify reproducibility with fixed random seed."""
           ...

       def test_no_data_leakage_between_splits(self) -> None:
           """Ensure train/val/test splits have no overlap."""
           ...
   \`\`\`

   For **model components** (\`layer: models\`):
   \`\`\`python
   class TestModelArchitecture:
       def test_forward_pass_output_shape(self) -> None:
           model = MyModel(config)
           x = torch.randn(batch_size, *input_shape)
           output = model(x)
           assert output.shape == (batch_size, num_classes)

       def test_backward_pass_computes_gradients(self) -> None:
           model = MyModel(config)
           x = torch.randn(batch_size, *input_shape)
           output = model(x)
           loss = output.sum()
           loss.backward()
           for param in model.parameters():
               assert param.grad is not None

       def test_model_parameter_count(self) -> None:
           """Guard against accidental architecture changes."""
           ...

       def test_model_serialization_roundtrip(self, tmp_path: Path) -> None:
           """Verify save/load produces identical predictions."""
           ...

       def test_model_handles_variable_sequence_length(self) -> None:
           ...
   \`\`\`

   For **training components** (\`layer: training\`):
   \`\`\`python
   class TestTrainingLoop:
       def test_loss_decreases_after_one_step(self) -> None:
           """Smoke test: loss should decrease on a trivial dataset."""
           ...

       def test_checkpoint_saves_and_resumes(self, tmp_path: Path) -> None:
           """Verify training can resume from checkpoint."""
           ...

       def test_mlflow_metrics_logged(self, mock_mlflow: MagicMock) -> None:
           """Verify experiment tracking calls."""
           mock_mlflow.log_metric.assert_called()

       def test_early_stopping_triggers(self) -> None:
           ...

       def test_gradient_clipping_applied(self) -> None:
           ...
   \`\`\`

   For **serving components** (\`layer: serving\`):
   \`\`\`python
   from httpx import AsyncClient, ASGITransport
   import pytest

   from src.serving.app import app


   @pytest.mark.asyncio
   class TestServingEndpoints:
       async def test_health_check(self) -> None:
           transport = ASGITransport(app=app)
           async with AsyncClient(transport=transport, base_url="http://test") as client:
               response = await client.get("/health")
               assert response.status_code == 200

       async def test_predict_returns_valid_response(self) -> None:
           ...

       async def test_predict_validates_input_schema(self) -> None:
           ...

       async def test_predict_returns_model_version(self) -> None:
           """Response must include model version for A/B tracking."""
           ...

       async def test_batch_predict_endpoint(self) -> None:
           ...
   \`\`\`

   For **evaluation components** (\`layer: evaluation\`):
   \`\`\`python
   class TestEvaluationMetrics:
       def test_metric_computation_known_values(self) -> None:
           """Test against hand-computed expected values."""
           ...

       def test_metric_handles_perfect_predictions(self) -> None:
           ...

       def test_metric_handles_worst_case(self) -> None:
           ...

       def test_comparison_report_structure(self) -> None:
           """Verify evaluation report has required fields for MLflow logging."""
           ...
   \`\`\`

4. **Run the tests — they must ALL FAIL**:
   \`\`\`bash
   uv run pytest tests/unit/test_<layer>_<component>.py -v --tb=short
   \`\`\`
   Confirm every test fails with \`ImportError\`, \`AttributeError\`, or \`AssertionError\` — not with unexpected exceptions.

### Phase 2: Green — Implement Minimal Code

Write the minimum implementation to make all tests pass.

1. **Create the implementation file** at \`src/<layer>/<component>.py\`

2. **Follow these ML pipeline conventions**:
   - All public functions must have type hints
   - Use Pydantic \`BaseModel\` for all configuration classes
   - Use \`__all__\` to explicitly export public API
   - Keep files under 300 lines — split into submodules if needed
   - Use \`logging\` module (not \`print\`) for all output
   - Set random seeds explicitly for reproducibility: \`torch.manual_seed()\`, \`numpy.random.seed()\`
   - All file paths via \`pathlib.Path\`, never string concatenation

3. **Config pattern** — every component gets a Pydantic config:
   \`\`\`python
   from pydantic import BaseModel, Field


   class ComponentConfig(BaseModel):
       """Configuration for <Component>. Validated at load time."""
       param: str = Field(..., description="Description of param")
       batch_size: int = Field(32, ge=1, description="Batch size for processing")

       class Config:
           frozen = True  # Immutable configs for reproducibility
   \`\`\`

4. **Run tests until green**:
   \`\`\`bash
   uv run pytest tests/unit/test_<layer>_<component>.py -v
   \`\`\`

5. **Run type checking**:
   \`\`\`bash
   uv run mypy src/<layer>/<component>.py --strict
   \`\`\`

6. **Run linting**:
   \`\`\`bash
   uv run ruff check src/<layer>/<component>.py
   uv run ruff format --check src/<layer>/<component>.py
   \`\`\`

### Phase 3: Refactor — Clean Up with Confidence

With all tests passing, improve the code quality.

1. **Refactoring checklist**:
   - [ ] Extract repeated logic into private helper functions
   - [ ] Replace magic numbers with named constants (\`SCREAMING_SNAKE_CASE\`)
   - [ ] Add docstrings to all public classes and functions (Google style)
   - [ ] Ensure Pydantic configs have \`Field(description=...)\` on every field
   - [ ] Verify no mutable default arguments
   - [ ] Check tensor operations are device-agnostic (\`tensor.to(device)\`)
   - [ ] Ensure no hardcoded file paths — use config or \`pathlib.Path\`
   - [ ] Verify logging uses structured format with component context
   - [ ] Check GDPR compliance: no PII in logs, metrics, or MLflow artifacts
   - [ ] Confirm no secrets or credentials in code (SOC 2)

2. **Run full validation after refactoring**:
   \`\`\`bash
   uv run pytest tests/ -v --tb=short --cov=src/<layer>/<component> --cov-fail-under=75
   uv run mypy src/<layer>/<component>.py --strict
   uv run ruff check src/<layer>/
   uv run ruff format --check src/<layer>/
   \`\`\`

3. **If adding a DVC pipeline stage**, update \`dvc.yaml\`:
   \`\`\`yaml
   stages:
     <component>:
       cmd: uv run python -m src.<layer>.<component> --config configs/<component>.yaml
       deps:
         - src/<layer>/<component>.py
         - configs/<component>.yaml
       outs:
         - data/processed/<output>/  # or models/<output>/
       metrics:
         - metrics/<component>.json:
             cache: false
   \`\`\`

4. **If adding an MLflow-tracked component**, verify:
   - Experiment name follows convention: \`ml-pipeline/<layer>/<component>\`
   - All hyperparameters logged via \`mlflow.log_params()\`
   - All metrics logged via \`mlflow.log_metric()\` with step number
   - Model artifacts logged via \`mlflow.pytorch.log_model()\`
   - Run tags include git commit hash and config hash for reproducibility

### Phase 4: Commit

1. **Stage and commit with conventional commit format**:
   \`\`\`bash
   # Tests first
   git add tests/
   git commit -m "test(<layer>): add tests for <component>

   - Cover happy path, edge cases, reproducibility
   - Ticket: <ticket>"

   # Implementation
   git add src/<layer>/<component>.py
   git commit -m "feat(<layer>): implement <component>

   - <brief description of what it does>
   - All tests passing, 75%+ coverage
   - Ticket: <ticket>"

   # Config if applicable
   git add configs/
   git commit -m "chore(config): add <component> config

   - Pydantic-validated YAML config
   - Ticket: <ticket>"
   \`\`\`

2. **Push and open PR**:
   - Branch name: \`feat/<ticket>-<component>\` (e.g., \`feat/ML-42-add-transformer-model\`)
   - PR description must include: what changed, test coverage, how to verify
   - Link the GitHub Issue
   - Add \`ai-assisted\` label if Claude generated any code

## Special Considerations

### Numerical Precision
When testing ML components, use \`torch.allclose()\` or \`pytest.approx()\` with appropriate tolerances:
\`\`\`python
assert torch.allclose(output, expected, atol=1e-6, rtol=1e-5)
\`\`\`

### Fixture Management
Use \`conftest.py\` files at appropriate levels:
- \`tests/conftest.py\` — shared fixtures (sample configs, temp directories, mock MLflow)
- \`tests/unit/conftest.py\` — unit test fixtures (small tensors, mock data)
- \`tests/integration/conftest.py\` — integration fixtures (test database, test API client)

### GPU Testing
Mark GPU-dependent tests so they can be skipped in CI without GPU:
\`\`\`python
@pytest.mark.skipif(not torch.cuda.is_available(), reason="CUDA not available")
def test_model_on_gpu() -> None:
    ...
\`\`\`

### Data Privacy in Tests
- Never use real user data in tests — generate synthetic data
- Test that PII anonymization functions work correctly
- Verify that data deletion endpoints actually remove data (GDPR right to deletion)
- Ensure MLflow artifacts contain no PII

### Sensitive Paths
Do not modify these paths without explicit approval and review:
- \`configs/production/**\` — production experiment configs
- \`models/**\` — trained model artifacts (DVC-tracked)
- \`.env*\` — environment variables and secrets
- \`data/**\` — DVC-tracked datasets`,

  'plugin/codeforge-ml-pipeline/skills/verify/SKILL.md': `---
name: verify
description: Verify ML pipeline integrity including code quality, type safety, tests, data pipeline reproducibility, model artifact validation, and experiment tracking consistency.
version: 1.0.0
author: codeforge-ml-pipeline
tags:
  - verification
  - testing
  - quality
  - ml-pipeline
  - ci
metadata:
  priority: high
  phase: verification
  estimated_duration: 5-15 minutes
  triggers:
    - pre-commit
    - pre-push
    - pre-merge
    - post-training
  inputs:
    - source_code
    - test_suite
    - dvc_pipeline
    - mlflow_experiments
    - model_artifacts
  outputs:
    - verification_report
    - coverage_report
    - type_check_results
    - pipeline_status
---

# Skill: verify

Run a comprehensive verification of the ml-pipeline project, covering code quality, type safety, test coverage, data pipeline integrity, model artifact validation, and experiment tracking consistency.

## When to Use

- Before pushing a branch or opening a PR
- After modifying model architectures in \`src/models/\`
- After changing data pipelines in \`src/data/\` or \`dvc.yaml\`
- After updating training logic in \`src/training/\`
- After modifying serving endpoints in \`src/serving/\`
- After changing experiment configs in \`configs/\`
- As a pre-merge gate on \`main\`

## Verification Steps

Execute the following stages in order. Stop and report on the first hard failure unless \`--continue-on-error\` is specified.

### Stage 1: Code Formatting

Check that all source code conforms to the project formatting standard.

\`\`\`
uv run ruff format --check src/ tests/ scripts/
\`\`\`

If formatting issues are found, suggest the fix:

\`\`\`
uv run ruff format src/ tests/ scripts/
\`\`\`

### Stage 2: Linting

Run the full ruff linter rule set configured in \`pyproject.toml\`.

\`\`\`
uv run ruff check src/ tests/ scripts/
\`\`\`

Pay special attention to:
- Unused imports in \`src/models/\` (common after refactoring architectures)
- Import ordering across \`src/data/\`, \`src/training/\`, \`src/evaluation/\`
- Security-related rules (S-prefixed) especially in \`src/serving/\`

### Stage 3: Type Checking

Run mypy in strict mode. All public functions must have type annotations.

\`\`\`
uv run mypy src/ --strict
\`\`\`

Common ML-specific type issues to watch for:
- \`torch.Tensor\` vs \`torch.FloatTensor\` usage
- Pydantic model field types in \`configs/\` loaders
- FastAPI endpoint return types in \`src/serving/\`
- Callback signatures in \`src/training/\`

### Stage 4: Unit Tests

Run the full test suite with coverage measurement.

\`\`\`
uv run pytest tests/ -v --cov=src --cov-report=term-missing --cov-fail-under=75
\`\`\`

Verify that:
- Coverage meets the 75% threshold
- All tests in \`tests/test_models/\` pass (model forward/backward checks)
- All tests in \`tests/test_data/\` pass (data loading, feature engineering)
- All tests in \`tests/test_serving/\` pass (API endpoint contracts)
- Async tests use \`pytest-asyncio\` markers correctly

### Stage 5: Integration Tests

Run integration tests that validate component interactions.

\`\`\`
uv run pytest tests/integration/ -v --timeout=120
\`\`\`

This covers:
- Data pipeline end-to-end (load → preprocess → feature engineering)
- Training loop smoke test (1 epoch on synthetic data)
- Model save/load round-trip with MLflow artifact format
- FastAPI serving endpoint with a real model checkpoint

### Stage 6: Config Validation

Validate all experiment configuration files against their Pydantic schemas.

\`\`\`
uv run python -m scripts.validate_configs --config-dir configs/
\`\`\`

Check that:
- All YAML configs in \`configs/\` parse without errors
- Required fields are present (model type, learning rate, batch size, data paths)
- Production configs in \`configs/production/**\` have not been modified without review
- No secrets or credentials are embedded in config files (SOC 2 compliance)
- Data paths reference DVC-tracked locations, not absolute paths

### Stage 7: DVC Pipeline Integrity

Verify the DVC pipeline DAG is valid and data dependencies are consistent.

\`\`\`
dvc status
dvc dag --dot
\`\`\`

Check that:
- \`dvc.yaml\` stages are well-formed and reference existing scripts
- \`dvc.lock\` is up to date with current pipeline definitions
- No orphaned \`.dvc\` files exist in \`data/\`
- Remote storage (S3) configuration is present in \`.dvc/config\`
- Data files in \`data/\` are tracked by DVC, not committed to git

### Stage 8: Model Artifact Validation

If model artifacts exist in \`models/\`, validate their integrity.

- Verify model checkpoint files can be loaded by PyTorch (\`torch.load\`)
- Confirm MLflow model signature matches the expected input/output schema
- Check that model metadata includes training config hash for reproducibility
- Validate that model files are DVC-tracked, not git-committed (file size check)

### Stage 9: MLflow Experiment Consistency

Verify experiment tracking is properly configured.

- Check that \`mlflow.tracking_uri\` is set in the environment or config
- Validate that recent experiment runs have required tags: \`git_commit\`, \`config_hash\`, \`data_version\`
- Confirm model registry entries reference valid artifact paths
- Ensure no experiments contain PII in parameters or metrics (GDPR compliance)

### Stage 10: Security and Compliance Scan

Run security-focused checks relevant to SOC 2 and GDPR.

\`\`\`
uv run ruff check src/ --select S
\`\`\`

Additionally verify:
- No hardcoded credentials in \`src/\`, \`configs/\`, or \`scripts/\`
- \`.env\` files are in \`.gitignore\` and not committed
- \`configs/production/**\` changes are flagged for review (CODEOWNERS)
- Data anonymization utilities in \`src/data/\` are tested
- Model artifacts in \`models/\` have integrity checksums

## Output Format

Produce a structured verification report:

\`\`\`
## Verification Report — ml-pipeline

| Stage                    | Status | Duration | Details              |
|--------------------------|--------|----------|----------------------|
| Code Formatting          | ✅/❌  | Xs       |                      |
| Linting                  | ✅/❌  | Xs       | N issues found       |
| Type Checking            | ✅/❌  | Xs       | N errors             |
| Unit Tests               | ✅/❌  | Xs       | N passed, M failed   |
| Integration Tests        | ✅/❌  | Xs       | N passed, M failed   |
| Config Validation        | ✅/❌  | Xs       |                      |
| DVC Pipeline Integrity   | ✅/❌  | Xs       |                      |
| Model Artifact Validation| ✅/❌  | Xs       |                      |
| MLflow Consistency       | ✅/❌  | Xs       |                      |
| Security & Compliance    | ✅/❌  | Xs       |                      |

**Coverage**: XX% (threshold: 75%)
**Overall**: PASS / FAIL
\`\`\`

## Failure Handling

- **Formatting/Linting failures**: Auto-fixable. Suggest the fix command and re-run.
- **Type check failures**: List each error with file, line, and the expected type annotation.
- **Test failures**: Show the failing test name, assertion error, and relevant source context.
- **Config validation failures**: Show the config file path and the Pydantic validation error.
- **DVC failures**: Check if \`dvc.lock\` needs regeneration via \`dvc repro --dry\`.
- **Security failures**: Flag as blocking. Do not proceed to merge.

## Sensitive Paths

The following paths require extra scrutiny during verification. Changes to these should always be flagged:

- \`configs/production/**\` — Production experiment and deployment configs
- \`models/**\` — Trained model artifacts (must be DVC-tracked)
- \`.env*\` — Environment variables and secrets (must never be committed)
- \`data/**\` — Training and evaluation data (must be DVC-tracked)
- \`src/serving/**\` — Public-facing API surface

## Integration with CI

This skill maps to the following GitHub Actions CI stages:

1. **Lint** → Stage 1 + Stage 2
2. **Type Check** → Stage 3
3. **Unit Tests** → Stage 4
4. **Integration Tests** → Stage 5
5. **Build Docker Image** → Requires Stages 1–5 passing
6. **Train Smoke Test** → Stage 7 + Stage 8 (on synthetic data)
7. **Deploy Staging** → All stages passing
8. **Deploy Production** → All stages passing + manual approval

## Related Skills

- \`plan\` — Use before \`verify\` to understand what changed and scope the verification
- \`build\` — Use after \`verify\` passes to package Docker images or trigger training runs
- \`review\` — Complements \`verify\` with human-in-the-loop code review guidance`,

  'plugin/marketplace.json.example': `{
  "slug": "codeforge-ml-pipeline",
  "name": "CodeForge ML Pipeline",
  "version": "1.0.0",
  "description": "Claude Code plugin for end-to-end ML pipeline development with PyTorch, MLflow experiment tracking, DVC data versioning, and FastAPI model serving. Provides AI-assisted planning, TDD, code review, and build-fix workflows tailored for ML engineering teams.",
  "long_description": "A comprehensive Claude Code plugin designed for ML engineering teams building production machine learning pipelines. Includes specialized agents, skills, and commands that understand ML-specific patterns like experiment tracking, model checkpointing, data pipeline orchestration, hyperparameter tuning, and model serving.\\n\\nBuilt for teams using PyTorch + MLflow + DVC + FastAPI on AWS infrastructure with SOC 2 and GDPR compliance requirements.\\n\\n### Key Features\\n\\n- **Planner Agent**: Breaks ML tasks into phased implementation plans with experiment design, data pipeline steps, and model architecture decisions\\n- **TDD Guide**: Test-driven development adapted for ML — covers data validation, model contracts, training loop correctness, and API endpoint testing\\n- **Code Reviewer**: Reviews ML code for reproducibility, data leakage, proper experiment tracking, type safety, and security compliance\\n- **Build Error Resolver**: Diagnoses failures across Python, PyTorch CUDA, DVC pipelines, Docker builds, and CI/CD workflows\\n- **Architect Agent**: Designs ML system components following pipeline architecture patterns with DVC DAG orchestration\\n- **Phase-based Development**: Structured methodology from research spike through production deployment with experiment gates\\n\\n### Workflow Commands\\n\\n- \`/plan\` — Generate implementation plans for ML features and experiments\\n- \`/tdd\` — Run TDD cycles for data pipelines, models, training, and serving\\n- \`/code-review\` — ML-aware code review with reproducibility and compliance checks\\n- \`/build-fix\` — Diagnose and fix build failures across the ML toolchain\\n- \`/verify\` — End-to-end verification including lint, types, tests, and DVC pipeline checks",
  "author": {
    "name": "ML Pipeline Team",
    "email": "ml-platform@example.com",
    "url": "https://github.com/example-org/ml-pipeline"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/example-org/codeforge-ml-pipeline.git"
  },
  "license": "MIT",
  "keywords": [
    "machine-learning",
    "pytorch",
    "mlflow",
    "dvc",
    "fastapi",
    "experiment-tracking",
    "model-serving",
    "data-versioning",
    "ml-pipeline",
    "mlops",
    "claude-code",
    "ai-assisted-development",
    "tdd",
    "code-review",
    "python",
    "aws",
    "sagemaker",
    "gpu-training",
    "feature-engineering",
    "hyperparameter-tuning"
  ],
  "categories": [
    "machine-learning",
    "data-engineering",
    "mlops",
    "developer-tools",
    "code-quality"
  ],
  "compatibility": {
    "claude_code": ">=1.0.0",
    "python": ">=3.11",
    "platforms": ["linux", "macos"]
  },
  "tech_stack": {
    "language": "Python 3.11+",
    "ml_framework": "PyTorch",
    "experiment_tracking": "MLflow",
    "data_versioning": "DVC",
    "serving": "FastAPI",
    "databases": ["PostgreSQL", "Redis"],
    "cloud": "AWS",
    "infrastructure": ["Docker", "Kubernetes", "Terraform"],
    "package_manager": "uv",
    "linting": "ruff",
    "type_checking": "mypy",
    "testing": "pytest"
  },
  "compliance": ["SOC 2", "GDPR"],
  "team_size": "small",
  "seniority_target": ["mid", "senior", "lead"],
  "agents": [
    {
      "name": "planner",
      "description": "Generates phased ML implementation plans with experiment design and data pipeline steps",
      "file": "agents/planner.md"
    },
    {
      "name": "code-reviewer",
      "description": "ML-aware code review checking reproducibility, data leakage, experiment tracking, and compliance",
      "file": "agents/code-reviewer.md"
    },
    {
      "name": "architect",
      "description": "Designs ML system components following DAG-based pipeline architecture patterns",
      "file": "agents/architect.md"
    },
    {
      "name": "build-error-resolver",
      "description": "Diagnoses failures across PyTorch, DVC, Docker, and CI/CD toolchains",
      "file": "agents/build-error-resolver.md"
    },
    {
      "name": "tdd-guide",
      "description": "Guides test-driven development for data pipelines, models, training loops, and APIs",
      "file": "agents/tdd-guide.md"
    }
  ],
  "skills": [
    {
      "name": "plan",
      "description": "Phase-based ML implementation planning",
      "file": "skills/plan/SKILL.md"
    },
    {
      "name": "tdd",
      "description": "Test-driven development for ML components",
      "file": "skills/tdd/SKILL.md"
    },
    {
      "name": "code-review",
      "description": "ML-specific code review with compliance checks",
      "file": "skills/code-review/SKILL.md"
    },
    {
      "name": "build-fix",
      "description": "Build failure diagnosis and resolution",
      "file": "skills/build-fix/SKILL.md"
    },
    {
      "name": "verify",
      "description": "End-to-end pipeline verification",
      "file": "skills/verify/SKILL.md"
    },
    {
      "name": "phase",
      "description": "Structured development methodology phases",
      "file": "skills/phase/SKILL.md"
    }
  ],
  "commands": [
    {
      "name": "/plan",
      "description": "Generate an implementation plan for an ML feature or experiment",
      "file": "commands/plan.md"
    },
    {
      "name": "/tdd",
      "description": "Run a TDD cycle for an ML component",
      "file": "commands/tdd.md"
    },
    {
      "name": "/code-review",
      "description": "Perform ML-aware code review",
      "file": "commands/code-review.md"
    },
    {
      "name": "/build-fix",
      "description": "Diagnose and fix build or pipeline failures",
      "file": "commands/build-fix.md"
    },
    {
      "name": "/verify",
      "description": "Run full verification suite",
      "file": "commands/verify.md"
    }
  ],
  "hooks": {
    "file": "hooks/hooks.json",
    "triggers": ["pre-commit", "pre-push", "post-merge"]
  },
  "install": {
    "instructions": "Run \`bash install.sh\` from the project root, or copy the \`plugin/codeforge-ml-pipeline/\` directory into your project and add the plugin reference to \`.claude/settings.json\`.",
    "dependencies": [
      "uv (Python package manager)",
      "DVC (data version control)",
      "Docker (containerization)"
    ],
    "post_install": [
      "uv sync",
      "dvc pull",
      "cp .env.example .env"
    ]
  },
  "screenshots": [
    {
      "caption": "Plan command generating a phased ML implementation plan",
      "url": "https://raw.githubusercontent.com/example-org/codeforge-ml-pipeline/main/docs/screenshots/plan-command.png"
    },
    {
      "caption": "TDD cycle for a PyTorch model with MLflow tracking",
      "url": "https://raw.githubusercontent.com/example-org/codeforge-ml-pipeline/main/docs/screenshots/tdd-cycle.png"
    },
    {
      "caption": "Code review catching data leakage in feature engineering",
      "url": "https://raw.githubusercontent.com/example-org/codeforge-ml-pipeline/main/docs/screenshots/code-review.png"
    }
  ],
  "links": {
    "documentation": "https://github.com/example-org/codeforge-ml-pipeline/blob/main/docs/ARCHITECTURE.md",
    "contributing": "https://github.com/example-org/codeforge-ml-pipeline/blob/main/docs/CONTRIBUTING.md",
    "issues": "https://github.com/example-org/codeforge-ml-pipeline/issues",
    "changelog": "https://github.com/example-org/codeforge-ml-pipeline/blob/main/CHANGELOG.md"
  },
  "pricing": {
    "model": "free",
    "license": "MIT"
  },
  "stats": {
    "installs": 0,
    "stars": 0,
    "last_updated": "2024-01-01T00:00:00Z"
  }
}`,

  'pyproject.toml': `[project]
name = "ml-pipeline"
version = "0.1.0"
description = "End-to-end ML pipeline with PyTorch training, MLflow tracking, DVC versioning, and FastAPI serving"
readme = "README.md"
license = { text = "Proprietary" }
requires-python = ">=3.11"
authors = [
    { name = "ML Pipeline Team" },
]
keywords = ["machine-learning", "pytorch", "mlflow", "pipeline"]

dependencies = [
    # ML Framework
    "torch==2.4.1",
    "torchvision==0.19.1",
    "torchaudio==2.4.1",

    # Experiment Tracking & Model Registry
    "mlflow==2.16.2",

    # Data Versioning & Pipelines
    "dvc==3.55.2",
    "dvc-s3==3.2.0",

    # Model Serving
    "fastapi==0.115.0",
    "uvicorn[standard]==0.30.6",
    "gunicorn==23.0.0",

    # Data Processing
    "numpy==1.26.4",
    "pandas==2.2.3",
    "polars==1.8.2",
    "pyarrow==17.0.0",
    "scikit-learn==1.5.2",

    # Configuration & Validation
    "pydantic==2.9.2",
    "pydantic-settings==2.5.2",
    "pyyaml==6.0.2",
    "omegaconf==2.3.0",

    # Database
    "psycopg2-binary==2.9.9",
    "sqlalchemy==2.0.35",
    "alembic==1.13.3",
    "redis==5.1.1",

    # AWS
    "boto3==1.35.29",
    "sagemaker==2.232.1",

    # Monitoring & Logging
    "prometheus-client==0.21.0",
    "structlog==24.4.0",

    # Utilities
    "httpx==0.27.2",
    "tenacity==9.0.0",
    "click==8.1.7",
    "rich==13.8.1",
    "tqdm==4.66.5",
    "python-dotenv==1.0.1",
    "python-multipart==0.0.10",
]

[project.optional-dependencies]
dev = [
    # Testing
    "pytest==8.3.3",
    "pytest-cov==5.0.0",
    "pytest-asyncio==0.24.0",
    "pytest-mock==3.14.0",
    "pytest-xdist==3.4.0",
    "pytest-timeout==2.3.1",
    "hypothesis==6.112.1",
    "factory-boy==3.3.1",
    "faker==28.4.1",
    "httpx==0.27.2",

    # Linting & Formatting
    "ruff==0.6.8",

    # Type Checking
    "mypy==1.11.2",
    "types-PyYAML==6.0.12.20240917",
    "types-redis==4.6.0.20241004",
    "types-requests==2.32.0.20240914",
    "pandas-stubs==2.2.2.240909",

    # Security
    "bandit==1.7.10",
    "safety==3.2.8",

    # Pre-commit
    "pre-commit==3.8.0",
]

notebooks = [
    "jupyterlab==4.2.5",
    "ipywidgets==8.1.5",
    "matplotlib==3.9.2",
    "seaborn==0.13.2",
    "plotly==5.24.1",
    "nbstripout==0.7.1",
]

tuning = [
    "optuna==4.0.0",
    "optuna-integration==4.0.0",
    "ray[tune]==2.37.0",
]

[project.scripts]
ml-train = "src.training.cli:train"
ml-evaluate = "src.evaluation.cli:evaluate"
ml-serve = "src.serving.app:main"
ml-data = "src.data.cli:data"

[project.urls]
Repository = "https://github.com/your-org/ml-pipeline"
Documentation = "https://github.com/your-org/ml-pipeline/tree/main/docs"

# ---------------------------------------------------------------------------
# Build system
# ---------------------------------------------------------------------------
[build-system]
requires = ["hatchling"]
build-backend = "hatchling.build"

[tool.hatch.build.targets.wheel]
packages = ["src"]

# ---------------------------------------------------------------------------
# pytest
# ---------------------------------------------------------------------------
[tool.pytest.ini_options]
testpaths = ["tests"]
python_files = ["test_*.py"]
python_classes = ["Test*"]
python_functions = ["test_*"]
addopts = [
    "--strict-markers",
    "--strict-config",
    "-ra",
    "--cov=src",
    "--cov-report=term-missing",
    "--cov-report=html:reports/coverage",
    "--cov-report=xml:reports/coverage.xml",
    "--cov-fail-under=75",
    "--timeout=300",
]
markers = [
    "unit: Unit tests (fast, no external deps)",
    "integration: Integration tests (may need DB, Redis, S3)",
    "gpu: Tests requiring GPU (skipped in CI without GPU)",
    "slow: Slow tests (training loops, large data)",
    "smoke: Smoke tests for model training sanity checks",
    "e2e: End-to-end pipeline tests",
]
asyncio_mode = "auto"
filterwarnings = [
    "ignore::DeprecationWarning:torch.*",
    "ignore::UserWarning:torch.*",
]

# ---------------------------------------------------------------------------
# mypy
# ---------------------------------------------------------------------------
[tool.mypy]
python_version = "3.11"
strict = true
warn_return_any = true
warn_unused_configs = true
warn_redundant_casts = true
warn_unused_ignores = true
disallow_untyped_defs = true
disallow_incomplete_defs = true
check_untyped_defs = true
no_implicit_optional = true
show_error_codes = true
show_column_numbers = true
pretty = true
plugins = [
    "pydantic.mypy",
]

[[tool.mypy.overrides]]
module = [
    "torch.*",
    "torchvision.*",
    "torchaudio.*",
    "mlflow.*",
    "dvc.*",
    "sagemaker.*",
    "optuna.*",
    "ray.*",
    "sklearn.*",
    "plotly.*",
    "seaborn.*",
    "matplotlib.*",
    "omegaconf.*",
    "prometheus_client.*",
]
ignore_missing_imports = true

[[tool.mypy.overrides]]
module = "tests.*"
disallow_untyped_defs = false
disallow_incomplete_defs = false

[tool.pydantic-mypy]
init_forbid_extra = true
init_typed = true
warn_required_dynamic_aliases = true

# ---------------------------------------------------------------------------
# coverage
# ---------------------------------------------------------------------------
[tool.coverage.run]
source = ["src"]
branch = true
omit = [
    "src/*/cli.py",
    "src/serving/app.py",
    "tests/*",
    "notebooks/*",
    "scripts/*",
]

[tool.coverage.report]
fail_under = 75
show_missing = true
skip_covered = false
exclude_lines = [
    "pragma: no cover",
    "def __repr__",
    "if TYPE_CHECKING:",
    "if __name__ == .__main__.",
    "raise NotImplementedError",
    "pass",
    "@abstractmethod",
    "\\\\.\\\\.\\\\.",
]

# ---------------------------------------------------------------------------
# bandit (security linting)
# ---------------------------------------------------------------------------
[tool.bandit]
exclude_dirs = ["tests", "notebooks", "scripts"]
skips = ["B101"]  # allow assert in non-test code for Pydantic validators

# ---------------------------------------------------------------------------
# ruff — main config lives in ruff.toml, minimal overrides here
# ---------------------------------------------------------------------------
# See ruff.toml for full configuration. This section exists only for tools
# that read pyproject.toml exclusively.`,

  'ruff.toml': `target-version = "py311"
line-length = 300

[format]
quote-style = "double"
indent-style = "space"
skip-magic-trailing-comma = false
line-ending = "auto"
docstring-code-format = true
docstring-code-line-length = 88

[lint]
select = [
    "E",      # pycodestyle errors
    "W",      # pycodestyle warnings
    "F",      # pyflakes
    "I",      # isort
    "N",      # pep8-naming
    "UP",     # pyupgrade
    "B",      # flake8-bugbear
    "SIM",    # flake8-simplify
    "TCH",    # flake8-type-checking
    "RUF",    # ruff-specific rules
    "C4",     # flake8-comprehensions
    "DTZ",    # flake8-datetimez
    "T20",    # flake8-print (catch stray prints in production code)
    "PT",     # flake8-pytest-style
    "S",      # flake8-bandit (security)
    "ANN",    # flake8-annotations (enforce type hints)
    "D",      # pydocstyle
    "LOG",    # flake8-logging
    "PIE",    # flake8-pie
    "RET",    # flake8-return
    "ARG",    # flake8-unused-arguments
    "PD",     # pandas-vet
    "NPY",    # numpy-specific rules
    "PERF",   # perflint
    "FURB",   # refurb
]
ignore = [
    "D100",   # missing docstring in public module
    "D104",   # missing docstring in public package
    "D203",   # one-blank-line-before-class (conflicts with D211)
    "D213",   # multi-line-docstring-summary-second-line (conflicts with D212)
    "ANN101", # missing type annotation for self
    "ANN102", # missing type annotation for cls
    "ANN401", # dynamically typed expressions (Any) — sometimes needed for torch tensors
    "S101",   # assert used — we allow in tests
    "B008",   # function call in default argument — needed for FastAPI Depends()
    "RET504", # unnecessary assignment before return — sometimes aids readability
]

fixable = ["ALL"]
unfixable = []

[lint.per-file-ignores]
"tests/**/*.py" = [
    "S101",    # assert is fine in tests
    "ANN",     # type annotations not required in tests
    "D",       # docstrings not required in tests
    "ARG",     # unused arguments common in fixtures
    "T20",     # print statements ok in tests
]
"notebooks/**/*.py" = [
    "T20",     # print statements expected in notebooks
    "E501",    # line length relaxed in notebooks
    "D",       # docstrings not required in notebooks
    "ANN",     # type annotations not required in notebooks
    "S",       # security rules relaxed in exploration notebooks
    "F401",    # unused imports common in notebooks
]
"scripts/**/*.py" = [
    "T20",     # print statements ok in scripts
    "D",       # docstrings relaxed in scripts
    "ANN",     # type annotations relaxed in helper scripts
]
"src/serving/**/*.py" = [
    "B008",    # FastAPI Depends() uses function calls in defaults
]
"configs/**/*.py" = [
    "D",       # config modules don't need full docstrings
]
"__init__.py" = [
    "F401",    # unused imports in __init__.py are re-exports
    "D104",    # missing docstring in __init__.py
]

[lint.isort]
known-first-party = ["src"]
known-third-party = ["torch", "mlflow", "fastapi", "pydantic", "dvc", "numpy", "pandas", "sklearn"]
section-order = ["future", "standard-library", "third-party", "first-party", "local-folder"]
force-single-line = false
combine-as-imports = true

[lint.pydocstyle]
convention = "google"

[lint.flake8-annotations]
allow-star-arg-any = true
mypy-init-return = true
suppress-none-returning = true

[lint.flake8-bugbear]
extend-immutable-calls = ["fastapi.Depends", "fastapi.Query", "fastapi.Path", "fastapi.Body"]

[lint.flake8-pytest-style]
fixture-parentheses = true
parametrize-names-type = "csv"
parametrize-values-type = "list"

[lint.flake8-type-checking]
runtime-evaluated-base-classes = ["pydantic.BaseModel", "pydantic.BaseSettings"]
runtime-evaluated-decorators = ["pydantic.validate_call"]

[lint.pylint]
max-args = 8`,

};
